(function(){
	'use strict';

    angular
        .module('app.partners', 
            [
                'datatables',
                // Partners
                'app.partners.partners',                
                'app.partners.prospects'
                
                // 'signature',
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.partners', {
                abstract: true,
                url     : '/partners'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : '',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.partners', {
            title : 'Socios',
            icon  : 'icon-account-multiple',
            weight: 3
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerRentableShowDialogController', PartnersPartnerRentableShowDialogController);

    /** @ngInject */
    function PartnersPartnerRentableShowDialogController($mdDialog, Rentable)
    {
        var vm = this;
        _init();

        /// Methods
        vm.cancel = cancel;
        ////

        function _init(){
            if (!Rentable){
                vm.rentable = {
                    id: 0,
                    dateFrom: new Date()
                };
            }else{
                vm.rentable = Rentable;
            }
            vm.zoneId = Rentable.rentable.rentableZone.id;
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerRentableDialogController', PartnersPartnerRentableDialogController);

    /** @ngInject */
    function PartnersPartnerRentableDialogController(api, $mdDialog, msg,Rentable, FamilyId, RefreshTable, $scope)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.cancel = cancel;
        ////

        function _init(){
            api.partners.partners.getByFamily({ id: 0, familyId: FamilyId }, function(response){
                vm.family = response;
            });

            vm.periodicities = api.catalogs.periodicities.query();
            vm.applyDiscount = false;

            api.catalogs.calculationModes.query(function(response){
                vm.calculationModes = response.filter(function(m){ return m.id !=  2 });
            });


            if (!Rentable){
                vm.rentable = {
                    id: 0,
                    dateFrom: new Date()
                };
            }else{
                vm.rentable = Rentable;
            }
        }

        function save(){
            if (!vm.rentable.rentableId || vm.rentable.rentableId == 0){
                msg.error("Seleccione rentable");
                return;
            }
                
            api.partners.rentables.save(vm.rentable, function(response){
                msg.success("Rentable seleccionado correctamente");
                RefreshTable();
                cancel();
            });
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerLevelDialogController', PartnersPartnerLevelDialogController);

    /** @ngInject */
    function PartnersPartnerLevelDialogController(api, $mdDialog, msg, Level, FamilyId, RefreshTable)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.cancel = cancel;
        ////

        function _init(){
            api.partners.partners.getByFamily({ id: 0, familyId: FamilyId }, function(response){
                vm.partners = response;
            });

            api.catalogs.employees.query(function(response){
                vm.employees = response.filter(function(e){ return e.employeeTypeId == 2 });
            });

            vm.levels = api.catalogs.levels.query(); 
            vm.levelScores = api.catalogs.levelScores.query(); 
            vm.activities = api.catalogs.activities.query(); 

            // Evaluation Years
            var today = new moment();
            vm.years = [];
            vm.years.push({ year: today.year() - 1 });
            vm.years.push({ year: today.year() });

            for(var i= 1; i <= 3; i++){
                vm.years.push({ year: today.year() + i });                
            }

            // Evaluation numbers
            vm.evaluations = api.catalogs.evaluations.query();

            if (Level){
                vm.title = "EDITAR NIVEL DE AVANCE ";
                vm.level = angular.copy(Level);
            }else{
                vm.title = "AGREGAR NIVEL DE AVANCE";
                vm.level = {
                    id          : 0, 
                };
            }
        }

        function save(){
            api.partners.levels.save(vm.level, function(response){
                msg.success("Nivel de avance guardado correctamente.");
                RefreshTable();
                cancel();
            });
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerTagsDialogController', PartnersPartnerTagsDialogController);

    /** @ngInject */
    function PartnersPartnerTagsDialogController(api, $mdDialog, msg, familyId, Tag, RefreshTable)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.cancel = cancel;
        ////

        function _init(){            
            if (Tag){
                vm.title = "EDITAR TAG";
                vm.tag = angular.copy(Tag);
            }else{
                vm.title = "AGREGAR TAG";
                vm.tag = {
                    id      : 0,                    
                    familyId: familyId,                    
                    tag     : ''
                };
            }
        }

        function save(){
            api.partners.tags.save(vm.tag, function(_){
                msg.success("Tag guardado correctamente.");
                RefreshTable();
                cancel();
            });
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerActivityDialogController', PartnersPartnerActivityDialogController);

    /** @ngInject */
    function PartnersPartnerActivityDialogController(api, $mdDialog, msg, PartnerActivity, FamilyId, Callback)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.cancel = cancel;
        vm.activityChange = activityChange;
        vm.scheduleChange = scheduleChange;
        vm.zoneChange = zoneChange;
        ////

        function _init(){
            api.partners.partners.getByFamily({ id: 0, familyId: FamilyId }, function(response){
                vm.partners = response;
            });

            api.catalogs.activities.query(function(response){
                vm.activities = response;
                
                if (PartnerActivity){
                    vm.title = "EDITAR ACTIVIDAD";
                    vm.partnerActivity = angular.copy(PartnerActivity);
                    vm.activity = vm.activities.filter(function(a){ return a.id == vm.partnerActivity.activityScheduleZone.activitySchedule.activityId })[0];
                    activityChange(function(){
                        vm.schedule = vm.schedules.filter(function(s){ return s.id == vm.partnerActivity.activityScheduleZone.activitySchedule.id })[0];
                        scheduleChange(function(){
                            zoneChange();                            
                        });
                    });
                    
                }else{  
                    vm.title = "AGREGAR ACTIVIDAD";
                    vm.partnerActivity = {
                        id : 0,
                        activityScheduleId: null 
                    };
                }
            });
        }

        function save(){
            api.partners.activities.save(vm.partnerActivity, function(response){
                msg.success("Actividad guardada correctamente.");
                Callback();
                cancel();
            });
        }

        function cancel(){
            $mdDialog.hide();
        }

        function activityChange(success){
            api.catalogs.activitiesSchedules.query({ activityId: vm.activity.id }, function(response){
                vm.schedules = response;
                if (success)
                    success();
            });
        }

        function scheduleChange(success){
            // Get activity zones from schedule (vm.schedule)
            api.catalogs.activitiesSchedulesZones.get({ scheduleId: vm.schedule.id }, function(response){
                vm.activityZones = response;
                if (success)
                    success();
            });
        }

        function zoneChange(){
            vm.validatingQuota = true;
            // Verify disponibility quota in zone
            api.partners.activities.verify({ 
                id: vm.partnerActivity.id,
                activityScheduleZoneId: vm.partnerActivity.activityScheduleZoneId 
            }, function(response){
                vm.validatingQuota = false;
                vm.quotaOk = true;
            }, function(errorResponse){
                vm.validatingQuota = false;
                vm.quotaOk = false;
            });
        }
    }
})();
(function ()
{
    'use strict';

    var treeViewAccessData = [];

    angular
        .module('app.partners')
        .controller('PartnersPartnerFamilyDialogController', PartnersPartnerFamilyDialogController);

    /** @ngInject */
    function PartnersPartnerFamilyDialogController(api, $mdDialog, msg, Familiar, RefreshTable, Partner, utils, Catalogs, isLocked, $document, $state)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.cancel = cancel;
        vm.birthdateChange = birthdateChange;
        vm.dueChange = dueChange;
        vm.showAutomaticPayment = showAutomaticPayment;
        ////

        function _init(){
            vm.catalogs = Catalogs;
            vm.partner = Partner;
            vm.minBirthdate = moment(vm.today).subtract(100, 'years').toDate();
            vm.maxBirthdate = moment(vm.today).toDate();
            vm.duePrices = [];
            vm.isLocked = isLocked;
                
            if (Familiar){
                vm.title = "EDITAR FAMILIAR";
                api.partners.family.get({
                    partnerId  : Familiar.parentPartnerId,
                    id         : Familiar.id
                }, function(response){
                    vm.familiar = response;
                    
                    // Set agreements
                    var agreements = angular.copy(vm.familiar.agreements);
                    vm.familiar.agreements = [];
                    angular.forEach(agreements, function(x) {
                        vm.familiar.agreements.push(vm.catalogs.agreements.filter(function(a){ return a.id == x.id })[0]); 
                    });
                    
                    // Set branches 
                    var branches = angular.copy(vm.familiar.branches);
                    vm.familiar.branches = [];
                    angular.forEach(branches, function(ca) {
                        vm.familiar.branches.push(vm.catalogs.branches.filter(function(branch){ return branch.id == ca.id })[0]); 
                    });

                    vm.birthdate = vm.familiar.birthdate;
                    birthdateChange();
                    dueChange();
                    vm.inscriptionDate = moment(vm.familiar.inscriptionDate).toDate();
                    vm.initPayDate = moment(vm.familiar.initPayDate).toDate();            
                });
            }else{
                vm.title = "AGREGAR FAMILIAR";
                vm.familiar = {
                    id             : 0,
                    parentPartnerId: Partner.id,
                    familyId       : Partner.familyId,
                    isFamily       : true,
                    active         : true,
                    birthdate      : new Date(),
                    dues           : [],
                    agreements     : [],
                    initPayDate    : new Date(),
                    inscriptionDate: new Date()
                };
                vm.birthdate = vm.familiar.birthdate;
                birthdateChange();
                vm.inscriptionDate = moment(vm.familiar.inscriptionDate).toDate();
            
            }

        }

        function save(){
            api.partners.family.save(vm.familiar, function(response){
                msg.success("Familiar guardada correctamente.");
                if ($state.current.name == "app.partners.partners.detail")
                    $state.reload();
                else
                    $state.go("app.partners.partners.detail", { id: vm.partner.id });
                cancel();
            });
        }

        function cancel(){
            $mdDialog.hide();
        }

        function birthdateChange(){
            if (moment(vm.birthdate) > moment()){
                msg.error("Fecha invalida!");
                return;
            }

            vm.familiar.birthdate = vm.birthdate;

            var birthdate = moment(vm.birthdate);     
            vm.familiar.age = utils.calculateAge(birthdate.date(), birthdate.month(),  birthdate.year())               
            vm.birthdate = moment(vm.familiar.birthdate).toDate();
        }

        function dueChange(){
            api.catalogs.duePrices.get({ 
                dueId         : vm.familiar.dueId,
                searchType    : 3,
                searchId      : vm.partner.duePeriodicityId
            }, function(response){
                if (response.length == 0){
                    msg.error("No hay precios vigentes configurados para esa cuota");
                    vm.duePrices = [];
                }else{
                    vm.familiar.duePeriodicityId = response[0].periodicity.id;
                    vm.duePeriodicityText = response[0].periodicity.name + " ($ " + response[0].price.toFixed(2) + " )" ;
                }
            });
        }

        function showAutomaticPayment(ev){
            $mdDialog.show({
                controller         : 'PartnersPartnerAutomaticPaymentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/dialogs/dialog-automaticPayment/dialog-automaticPayment.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Partner     : vm.familiar
                }
            });
        }        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerBecasDialogController', PartnersPartnerBecasDialogController);

    /** @ngInject */
    function PartnersPartnerBecasDialogController(api, $mdDialog, msg, Beca, FamilyId, RefreshTable)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.cancel = cancel;
        ////

        function _init(){
            api.partners.partners.getByFamily({ id: 0, familyId: FamilyId }, function(response){
                vm.partners = response;
            });

            vm.becas = api.catalogs.becas.query();

            if (Beca){
                vm.title = "EDITAR BECA";
                vm.beca = angular.copy(Beca);
            }else{
                vm.title = "AGREGAR BECA";
                vm.beca = {
                    id                  : 0,
                    dateFrom            : new Date(),
                    dateTo              : new Date(),
                    discountPercentage  : 0
                };
            }
        }

        function save(){
            api.partners.becas.save(vm.beca, function(response){
                msg.success("Beca guardada correctamente.");
                RefreshTable();
                cancel();
            });
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.partners")
    .controller(
      "PartnersPartnerAddressDialogController",
      PartnersPartnerAddressDialogController
    );

  /** @ngInject */
  function PartnersPartnerAddressDialogController(
    api,
    $mdDialog,
    msg,
    Address,
    RefreshTable,
    PartnerID
  ) {
    var vm = this;
    _init();

    /// Methods
    vm.save = save;
    vm.cancel = cancel;
    ////

    function _init() {
      vm.addressTypes = api.catalogs.addressTypes.query();
      vm.satRegimenFiscales = api.sat.regimenFiscales.query();

      vm.title = "EDITAR DIRECCIÓN";
      vm.address = angular.copy(Address);

      if (!vm.address) {
        vm.title = "AGREGAR DIRECCIÓN";
        vm.address = {
          id: 0,
          partnerId: PartnerID,
          addressTypeId: 0,
          isDefault: true,
          active: true,
        };
      }
    }

    function save() {
      api.partners.addresses.save(vm.address, function (response) {
        msg.success("Dirección guardada correctamente.");
        RefreshTable();
        cancel();
      });
    }

    function cancel() {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerAbsencesDialogController', PartnersPartnerFamilyDialogController);

    /** @ngInject */
    function PartnersPartnerFamilyDialogController(api, $mdDialog, msg, Absence, FamilyId, RefreshTable)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.cancel = cancel;
        ////

        function _init(){
            api.partners.partners.getByFamily({ id: 0, familyId: FamilyId }, function(response){
                vm.partners = response;
            });

            if (Absence){
                vm.title = "EDITAR AUSENCIA";
                vm.absence = angular.copy(Absence);
            }else{
                vm.title = "AGREGAR AUSENCIA";
                vm.absence = {
                    id                  : 0,
                    dateFrom            : new Date(),
                    dateTo              : new Date(),
                    discountPercentage  : 0
                };
            }
        }

        function save(){
            vm.absence.dateFrom = new Date(moment(vm.absence.dateFrom).format("MM/DD/YYYY"));;
            vm.absence.dateTo = new Date(moment(vm.absence.dateTo).format("MM/DD/YYYY"));;
            api.partners.absences.save(vm.absence, function(response){
                msg.success("Ausencia guardada correctamente.");
                RefreshTable();
                cancel();
            });
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.partners.partners', [ 
        ])
        .config(config);


    function getContractState(name){
        var result = {
            url      : '/' + name,
            views    : {
                'content@app': {
                    templateUrl: 'app/main/partners/views/partners/partner/contract/contract-' + name + '.html',
                    controller : 'PartnersPartnerContractController as vm'
                }
            },
            bodyClass: 'invoice printable'
        };        
        return result;
    }

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {        

        // State
        $stateProvider
            .state('app.partners.info', {
                url      : '/partners/info',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/info/info.html',
                        controller : 'PartnersPartnersInfoController as vm'
                    }
                }
            })
            .state('app.partners.info.pass-print', {
                url      : '/pass-print/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/info/printable-pass/printable-pass.html',
                        controller : 'PartnersPartnersInfoPassPrintController as vm'
                    }
                },
                resolve  : {
                    Item: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('partners.passes@getById', { id : $stateParams.id });
                    }
                },
                bodyClass: 'pass printable'
            })
            .state('app.partners.info.credential', {
                url      : '/credential/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/info/credential/credential.html',
                        controller : 'PartnersPartnerCredentialController as vm'
                    }
                },
                resolve  : {
                    Partner: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('partners.partners@get', { id: $stateParams.id });
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.partners.partners', {
                url      : '/partners',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/partners/partners.html',
                        controller : 'PartnersPartnersController as vm'
                    }
                }
            })
            .state('app.partners.partners.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/partner/partner.html',
                        controller : 'PartnersPartnerController as vm'
                    }
                },
                resolve  : {
                    Partner: function ()
                    {
                        return { 
                            id                  : 0,
                            name                : '', 
                            active              : true, 
                            isRecurrent         : true, 
                            calculationModeId   : 1 /*Proporcional por día*/,
                            initPayDate         : new Date(),
                            payedDate           : new Date(),                            
                            inscriptionDate     : new Date(), 
                        };
                    },
                    PartnerTypes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.partnerTypes@query');
                    },
                    Dues: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.dues@query');
                    },
                    Media: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.media@query');
                    },
                    Countries: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.countries@query');
                    },
                    Agreements: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.agreements@query');
                    },
                    Professions: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.professions@query');
                    },
                    Genders: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.genders@query');
                    },
                    ClubAccess: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.clubAccess@query');
                    },
                    Employees: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.employees@query');
                    },
                    CalculationModes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.calculationModes@query');
                    },
                    AccessTimeZones: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.accessTimeZones@query');
                    },
                    Branches: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.branches@query');
                    },
                    Acciones: function(apiResolver)
                    {
                        return apiResolver.resolve('accionistas.acciones@query');
                    },
                },
            })
            .state('app.partners.partners.add.prospect', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/partner/partner.html',
                        controller : 'PartnersPartnerController as vm'
                    }
                },
                resolve  : {
                    Partner: function ($stateParams, apiResolver)
                    {
                        return { 
                            id: 0,
                            prospectId : $stateParams.id,
                            active: true, 
                            inscriptionDate : new Date(), 
                            isRecurrent: true, 
                            calculationModeId: 1 /*Proporcional por día*/,
                            initPayDate: new Date(),
                            payedDate: new Date(),
                            partnerTypeId: 1
                        };
                    },
                    PartnerTypes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.partnerTypes@query');
                    },
                    Dues: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.dues@query');
                    },
                    Media: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.media@query');
                    },
                    Countries: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.countries@query');
                    },
                    Agreements: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.agreements@query');
                    },
                    Professions: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.professions@query');
                    },
                    Genders: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.genders@query');
                    },
                    ClubAccess: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.clubAccess@query');
                    },
                    Employees: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.employees@query');
                    },
                    CalculationModes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.calculationModes@query');
                    },
                    AccessTimeZones: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.accessTimeZones@query');
                    },
                    Branches: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.branches@query');
                    },
                    Acciones: function(apiResolver)
                    {
                        return apiResolver.resolve('accionistas.acciones@query');
                    },
                },
            })
            .state('app.partners.partners.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/partner/partner.html',
                        controller : 'PartnersPartnerController as vm'
                    }
                },
                resolve  : {
                    Partner: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('partners.partners@get', { id: $stateParams.id });
                    },
                    // PartnerKardex: function ($stateParams, apiResolver)
                    // {
                    //     return apiResolver.resolve('partners.partners@getByKardex', { id: $stateParams.id, dummy1: 0, dummy2: 0, dummy3: 0 });
                    // },
                    PartnerTypes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.partnerTypes@query');
                    },
                    Dues: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.dues@query');
                    },
                    Media: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.media@query');
                    },
                    Countries: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.countries@query');
                    },
                    Agreements: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.agreements@query');
                    },
                    Professions: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.professions@query');
                    },
                    Genders: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.genders@query');
                    },
                    ClubAccess: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.clubAccess@query');
                    },
                    Employees: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.employees@query');
                    },
                    CalculationModes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.calculationModes@query');
                    },
                    AccessTimeZones: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.accessTimeZones@query');
                    },
                    Branches: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.branches@query');
                    },
                    Acciones: function(apiResolver)
                    {
                        return apiResolver.resolve('accionistas.acciones@query');
                    },
                },
            })
            .state('app.partners.partners.kardex', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/partner/kardex/kardex.html',
                        controller : 'PartnersPartnerKardexController as vm'
                    }
                },
                resolve  : {
                    Partner: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('partners.partners@get', { id: $stateParams.id });
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.partners.partners.contract', {
                url      : '/contract/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/partners/partner/contract/contract-default.html',
                        controller : 'PartnersPartnerContractController as vm'
                    }
                },
                resolve  : {
                    Contract: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('partners.contracts@getContract', { id: $stateParams.id, isLastData: false });
                    }
                },
                bodyClass: 'invoice printable'
            })            
            .state('app.partners.partners.contract.altea', getContractState('altea'))
            .state('app.partners.partners.contract.operactive', getContractState('operactive'))
            .state('app.partners.partners.contract.urban', getContractState('urban'))
            .state('app.partners.partners.contract.omada', getContractState('omada'))
            .state('app.partners.partners.contract.bylifefit', getContractState('bylifefit'))
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.partners.info', {
            title: 'Info Socios',
            shortcuticon  : 'icon-account-alert',            
            state: 'app.partners.info'
        });

        msNavigationServiceProvider.saveItem('apps.partners.partners', {
            title: 'Socios Datos',
            shortcuticon  : 'icon-account-multiple',            
            state: 'app.partners.partners'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersChangePayedDatesController', PartnersChangePayedDatesController);

    /** @ngInject */
    function PartnersChangePayedDatesController(api, $mdDialog, msg, Titular, Callback)
    {
        var vm = this;
        _init();

        /// Methods
        vm.close = close;
        vm.selectPartner = selectPartner;
        vm.saveDues = saveDues;
        vm.selectRentable = selectRentable;
        vm.saveRentables = saveRentables
        ////

        function _init(){
            vm.callback = Callback;
            vm.titular = Titular;

            api.partners.partners.getByFamily({ id: 0, familyId: vm.titular.familyId }, function(response){
                vm.partners = response;
            });

            api.partners.rentables.query({ familyId: vm.titular.familyId }, function(response){
                vm.rentables = response;
            });
        }

        function close(){
            $mdDialog.hide();
        }

        
        function selectPartner(item){
            vm.partner = item;
            vm.newPayedDate = moment(vm.partner.payedDate).toDate()
        }
        
        function saveDues(){
            if (confirm("Una vez cambiadas las fechas no se pueden cancelar los cambios")){
                if (vm.applyAllPartners == true){
                    if (confirm("Esta seguro que quiere aplicar los cambios a toda la familia?")){
                        _save(1);
                    }
                }else{
                    _save(1);
                }
            }
        }

        function selectRentable(item){
            vm.rentable = item;
            vm.newPayedDateRentable = moment(vm.rentable.payedDate).toDate();
        }
        
        function saveRentables(){
            if (confirm("Una vez cambiadas las fechas no se pueden cancelar los cambios")){
                if (vm.applyAllPartners == true){
                    if (confirm("Esta seguro que quiere aplicar los cambios a todos los rentables?")){
                        _save(2);
                    }
                }else{
                    _save(2);
                }
            }
        }

        function _save(type){
            var changeObject = {
                type : type                
            }

            if (type == 1){  
                /* Partner */
                changeObject.newDate = vm.newPayedDate;
                changeObject.applyAll = vm.applyAllPartners;
                if (vm.applyAllPartners)                    
                    changeObject.id = vm.titular.familyId;
                else
                    changeObject.id = vm.partner.id;
            }else{ 
                /* Rentable */
                changeObject.newDate = vm.newPayedDateRentable;
                changeObject.applyAll = vm.applyAllRentables;
                if (vm.applyAllRentables)
                    changeObject.id = vm.titular.familyId;                    
                else
                    changeObject.id = vm.rentable.id;
            }

            api.partners.changeDates.save(changeObject, function(){
                msg.success("Cambio(s) de fecha(s) realizados correctamente.");
                _init();
                vm.callback();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerRentablesController', PartnersPartnerRentablesController);

    /** @ngInject */
    function PartnersPartnerRentablesController($state, api, $scope, CONST_DATATABLES, $mdDialog, $document, msg)
    {
        var vm = this;

        /// Methods
        vm.detail = detail;
        vm.remove = remove;
        vm.show = show;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(vm.parentScope.item);
            _refresh();            
        }

        function _refresh(){
            api.partners.rentables.query({ familyId: vm.partner.familyId }, function(response){
                vm.rentables = response;
            });
        }

        function detail(ev, item){
            $mdDialog.show({
                controller         : 'PartnersPartnerRentableDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-rentables/dialogs/dialog-rentable/dialog-rentable.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Rentable          : item,
                    RefreshTable   : _refresh,
                    FamilyId       : vm.partner.familyId
                }
            });
        }

        function show(ev, item){
            $mdDialog.show({
                controller         : 'PartnersPartnerRentableShowDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-rentables/dialogs/dialog-showRentable/dialog-showRentable.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Rentable          : item,
                }
            });
        }

        function remove(item){
            msg.confirm("Esta seguro que desea borrar este rentable?", function(){
                api.partners.rentables.delete({ id: item.id }, function(response){
                    msg.success("Rentable borrado correctamente.");
                    _refresh();
                });
            });
        }

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerTagsController', PartnersPartnerTagsController);

    /** @ngInject */
    function PartnersPartnerTagsController($state, api, $scope, CONST_DATATABLES, $mdDialog, $document, msg)
    {
        var vm = this;

        // Methods
        vm.detail = detail;
        vm.remove = remove;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(vm.parentScope.item);            
            _refresh();            
        }

        function _refresh(){            
            api.partners.tags.query({ familyId: vm.partner.familyId }, function(response){
                vm.tags = response;
            });
        }

        function detail(ev, item){
            $mdDialog.show({
                controller         : 'PartnersPartnerTagsDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-tags/dialogs/dialog-tag.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                escapeToClose      : true,
                clickOutsideToClose: true,
                locals             : {
                    Tag         : item,
                    familyId    : vm.partner.familyId,
                    RefreshTable: _refresh
                }
            });
        }

        function remove(item){
            msg.confirm("Esta seguro que desea borrar este tag?", function(){
                api.partners.tags.delete({ id: item.id }, function(_){
                    msg.success("Tag borrada correctamente.");
                    _refresh();
                });
            });
        }

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerPicturesController', partnersPartnerPictureController);

    /** @ngInject */
    function partnersPartnerPictureController($state, api, $scope, CONST_DATATABLES, $mdDialog, $document, msg, localStorageService)
    {
        var vm = this;

        /// Methods
        vm.save = save;
        ///

        _init();

        function _init(){
            vm.picturesUrl = api.baseUrl.replace("api/","");            
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(vm.parentScope.item);     

            vm.family = api.partners.partners.getByFamily({ id: 0, familyId: vm.partner.familyId });

            vm.partner = null;
            vm.saving = false;
        }

        function save(){
            var files = $("#inputFile").get(0).files;

            // Validate data
            if (files.length == 0) {
                msg.error("Seleccione  archivo a subir!.");
                return;
            }

            var file = files[0];
            var data = new FormData();
            data.append("file", file);
            data.append("partnerId", vm.partner.id);

            var authData = localStorageService.get('authorizationData');
            $.ajax({
                type: "POST",
                url: api.baseUrl + "PartnerPictures",
                contentType: false,
                processData: false,
                data: data,
                headers: { 
                    "Authorization": 'Bearer ' + authData.token
                },
                success: function (response) {
                    msg.success("Fotografia cambiada correctamente.");
                    if ($state.current.name == "app.partners.partners.detail")
                        $state.reload();
                    else
                        $state.go("app.partners.partners.detail", { id: vm.partner.id });
                },
                error: function (errorResponse) {
                    if (errorResponse.status == 500){
                        msg.error(errorResponse.responseJSON.exceptionMessage);
                    }else                    
                        msg.error("Error al subir archivo, comunicate con el administrador!!!!"); 
                }
            });
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.partners")
    .controller(
      "PartnersPartnerPaymentsController",
      partnersPartnerPaymentsController
    );

  /** @ngInject */
  function partnersPartnerPaymentsController(
    $state,
    api,
    $scope,
    CONST_DATATABLES,
    $mdDialog,
    $document,
    msg,
    localStorageService
  ) {
    var vm = this;

    _init();

    function _init() {
      vm.picturesUrl = api.baseUrl.replace("api/", "");
      vm.parentScope = $scope.$parent.$parent.vm;
      vm.partner = angular.copy(vm.parentScope.item);

      var data = new FormData();
      // vm.family = api.invoices.invoicesOrders.get({ });
      var authData = localStorageService.get("authorizationData");
      $.ajax({
        type: "GET",
        url: api.baseUrl + "InvoicesOrders/" + vm.partner.id,
        contentType: false,
        processData: false,
        data: data,
        headers: {
          Authorization: "Bearer " + authData.token,
          BranchId: vm.partner.branchId,
        },
        success: function (response) {
          // vm.group = response;
          
          vm.summary = [];
          vm.group = response.groupBy("partnerName");
          angular.forEach(vm.group, function (g) {
            g.totalFolios = 0;
            g.orderTypeGroups = g.items.groupBy("orderType");
            angular.forEach(g.orderTypeGroups, function (orderTypeIn) {     
              console.log(orderTypeIn);         
              
              var total = 0;
              var totalFolios = 0;
              orderTypeIn.InvoiceGroup = orderTypeIn.items.groupBy("folio");
              angular.forEach(orderTypeIn.InvoiceGroup, function (folio) {
                var isCanceled = false;
                angular.forEach(folio.items, function (item) {
                  isCanceled = item.isCanceled;
                  if (!isCanceled) {
                    total = total + item.total;
                  }
                });
                if (!isCanceled) {
                  totalFolios++;
                }
              });
              orderTypeIn.InvoiceGroup.totalFolios = totalFolios;
              vm.summary.push({
                orderType: orderTypeIn.key,
                count: totalFolios,
                total: total,
              });
              g.totalFolios += totalFolios;
            });
          });

          // Summary
          // vm.summary = [];
          // angular.forEach(vm.group, function (group) {
          //     angular.forEach(group.orderTypeGroups, function (g) {
          //         vm.summary.push({
          //             orderType: g.key,
          //             count: g.items.length,
          //             total: (g && g.items && g.items.length) ? g.InvoiceGroup.map(function (x) { return x.isCanceled ? 0 : x.total; }).reduce(function (x, y) { return x + y }) : 0
          //         });
          //     });
          // });

          // Totals Summary
          vm.summary.push({
            orderType: "Totales",
            count:
              vm.summary.length > 0
                ? vm.summary
                    .map(function (s) {
                      return s.count;
                    })
                    .reduce(function (a, b) {
                      return a + b;
                    })
                : 0,
            total:
              vm.summary.length > 0
                ? vm.summary
                    .map(function (s) {
                      return s.total;
                    })
                    .reduce(function (a, b) {
                      return a + b;
                    })
                : 0,
          });
        },
        error: function (errorResponse) {
          if (errorResponse.status == 500) {
            msg.error(errorResponse.responseJSON.exceptionMessage);
          } else
            msg.error(
              "Error al subir archivo, comunicate con el administrador!!!!"
            );
        },
      });

      vm.partner = null;
      vm.saving = false;
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerOtherChargesController', partnersPartnerOtherChargesController);

    /** @ngInject */
    function partnersPartnerOtherChargesController($state, api, $scope, CONST_DATATABLES, $mdDialog, msg)
        {
        var vm = this;

        /// Methods
        vm.partnerChange = partnerChange;
        
        vm.addPlanned = addPlanned;
        vm.plannedAccept = plannedAccept;
        vm.plannedRemove = plannedRemove;
        
        vm.addPeriodicity = addPeriodicity;
        vm.periodicalDueChange = periodicalDueChange;
        vm.periodicalAccept = periodicalAccept;
        vm.periodicalRemove = periodicalRemove;
        vm.periodicalEdit = periodicalEdit;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(vm.parentScope.item);          
            
            api.partners.partners.getByFamily({ id: 0, familyId: vm.partner.familyId }, function(response){
                vm.family = response;
                vm.partner = response.filter(function(p){ return p.id == vm.partner.id })[0];

                partnerChange();
            });

            // Get periodicities
            vm.periodicities = api.catalogs.periodicities.query();

            // Get dues
            _getDues();

            // Get inventory
            api.inventory.products.query(function(response){
                vm.inventory = response.filter(function(i){ return i.quantity > 0 || !i.product.isStockRequired });
            });

            vm.duePrices = [];
        }

        function partnerChange(){
            if (vm.plannedNew)
                vm.plannedNew.partnerId = vm.partner.id;

            if (vm.periodicalProductNew)
                vm.periodicalProductNew.partnerId = vm.partner.id;
            
                _getPeriodicalProducts();
            _getPlannedProducts();
            _getDues();
        }

        function _getDues(){
            api.catalogs.dues.query(function(response){
                vm.dues = response.filter(function(d){ 
                    return d.isFamiliar == vm.partner.isFamily || d.isTitular == !vm.partner.isFamily
                    // // Age range validation
                    // && (d.minAge != 0 && d.minAge <= vm.partner.age)
                    // && (d.maxAge != 0 && vm.partner.age <= d.minAge)
                    // // Partner Type validation
                    // && (d.partnerType == vm.partner.partnerType)
                    ; 
                }) 
            });
        }

        function _getPlannedProducts(){
            api.invoices.plannedProducts.get({ id: vm.partner.id }, function(response){
                vm.plannedProducts = response;
            });
        }

        function _getPeriodicalProducts(){
            api.partners.periodicalProducts.get({ id: vm.partner.id }, function(response){
                vm.periodicalProducts = response;
            });
        }

        function addPlanned(){
            vm.plannedNew = {
                id              : 0,
                expirationDate  : new Date(),
                partnerId       : vm.partner.id,
                product         : null,
                addType         : 1,
            };
        }
        
        function addPeriodicity(){
            vm.periodicalProductNew = {
                id          : 0,
                isDue       : true,
                initPayDate : new Date(),    
                partnerId   : vm.partner.id,
                dueId       : null,
                productId   : null
            };
        } 
        
        function periodicalDueChange(fromEdit){
            api.catalogs.duePrices.get({ 
                dueId         : vm.periodicalProductNew.dueId,
                searchType    : 2,
                searchId      : vm.periodicalProductNew.dueId
            }, function(response){
                if (response.length == 0){
                    msg.error("No hay precios vigentes configurados para esa cuota");
                    vm.duePrices = [];
                }else{
                    vm.duePrices = response;
                }

                if (fromEdit)
                    return;
                
                vm.periodicalProductNew.periodicityId = null;
            });
        }

        function plannedAccept(){
            api.invoices.plannedProducts.save(vm.plannedNew, function(response){
                msg.success("Cargo planificado agregado correctamente.");
                vm.plannedNew = null;
                _getPlannedProducts();
            });
        }

        function plannedRemove(item){
            msg.confirm("Esta seguro que desea borrar este cargo?", function(){
                if (item.groupId && item.groupId != 0){
                    msg.confirm("Este registro pertenece a un lote, se borrara el lote completo, desea continuar?", function(){
                        _plannedRemove(item);
                    });
                }else{
                    _plannedRemove(item);
                }
            });
        }

        function _plannedRemove(item){
            api.invoices.plannedProducts.delete({ id: item.id }, function(response){
                msg.success("Cargo(s) borrado(s) correctamente.");
                _getPlannedProducts();
            });
        }

        function periodicalAccept(){
            api.partners.periodicalProducts.save(vm.periodicalProductNew, function(response){
                msg.success("Cargo periodico guardado correctamente.");
                vm.periodicalProductNew = null;
                _getPeriodicalProducts();
            });
        }

        function periodicalRemove(item){
            msg.confirm("Esta seguro que desea borrar este cargo?", function(){
                api.partners.periodicalProducts.delete({ id: item.id }, function(response){
                    msg.success("Cargo periodica borrado correctamente.");
                    _getPeriodicalProducts();
                });
            });                
        }

        function periodicalEdit(item){
            vm.periodicalProductNew = angular.copy(item);
            if (!item.isDue){
                vm.periodicalProductNew.inventory = vm.inventory.filter(function(i){ return i.product.id == item.productId })[0];
            }else{
                periodicalDueChange(true);
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerLevelsController', PartnersPartnerLevelsController);

    /** @ngInject */
    function PartnersPartnerLevelsController($state, api, $scope, CONST_DATATABLES, $mdDialog, $document, msg)
    {
        var vm = this;

        /// Methods
        vm.detail = detail;
        vm.remove = remove;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(vm.parentScope.item);            
            _refresh();            
        }

        function _refresh(){
            api.partners.levels.query({ familyId: vm.partner.familyId }, function(response){
                vm.levels = response;
            });
        }

        function detail(ev, item){
            $mdDialog.show({
                controller         : 'PartnersPartnerLevelDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-levels/dialogs/dialog-level.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Level          : item,
                    RefreshTable   : _refresh,
                    FamilyId       : vm.partner.familyId
                }
            });
        }

        function remove(item){
            msg.confirm("Esta seguro que desea borrar este avance?", function(){
                api.partners.levels.delete({ id: item.id }, function(response){
                    msg.success("Nivel de avance borrado correctamente.");
                    _refresh();
                });
            });
        }

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerActivitiesController', PartnersPartnerActivitiesController);

    /** @ngInject */
    function PartnersPartnerActivitiesController($state, api, $scope, CONST_DATATABLES, $mdDialog, msg)
    {
        var vm = this;

        /// Methods
        vm.detail = detail;
        vm.remove = remove;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(vm.parentScope.item);
            _getPartnersActivities();
        }

        function _getPartnersActivities(){
            api.partners.activities.query({ familyId: vm.partner.familyId }, function(response){
                vm.partnerActivities = response;
            });
        }

        function detail(ev, item){
            $mdDialog.show({
                controller         : 'PartnersPartnerActivityDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-activities/dialogs/dialog-activity.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    PartnerActivity : item,
                    Callback        : _detailCallback,
                    FamilyId        : vm.partner.familyId
                }
            });
        }

        function _detailCallback(){
            _getPartnersActivities();
        }

        function remove(item){
            msg.confirm("Esta seguro que desea borrar esta actividad?", function(){
                api.partners.activities.delete({ id: item.id }, function(response){
                    msg.success("Actividad borrada correctamente.");
                    _getPartnersActivities();
                });
            });
        }

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerInvoicesController', PartnersPartnerInvoicesController);

    /** @ngInject */
    function PartnersPartnerInvoicesController($state, api, $scope, CONST_DATATABLES, msg, $mdDialog)
    {
        var vm = this;

        /// Methods
        vm.receipt = receipt;
        vm.coupon = coupon;
        vm.getData = getData;        
        vm.select = select;
        vm.generateInvoice = generateInvoice;
        vm.showOrderDetail = showOrderDetail;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = vm.parentScope.item;
            var now = moment();
            var from = moment([now.year(), 0, 1]);
            var to = now.endOf('month');

            vm.from = from.format('MM/DD/YYYY');
            vm.to = to.format('MM/DD/YYYY');

           vm.selected = []; 
            _getOrders();            
            _getInvoices();
        }

        function _getOrders(){
            api.invoices.orders.getByPartner({
                from: moment(vm.from).format('DD-MM-YYYY'),
                to: moment(vm.to).format('DD-MM-YYYY') ,
                partnerId: vm.partner.id
            }, function(response){
                vm.orders = response;
            });
        }

        function _getInvoices(){
            api.invoices.invoices.getByPartner({
                from: moment(vm.from).format('DD-MM-YYYY'),
                to: moment(vm.to).format('DD-MM-YYYY') ,
                partnerId: vm.partner.id
            }, function(response){
                vm.invoices = response;
            });
        }

        function getData(){
            _getInvoices();
            _getOrders();
        }

        function receipt(id){
            $state.go('app.invoices.orders.receipt', { id: id });
        }
        
        function coupon(id){
            $state.go('app.invoices.orders.coupon', { id: id, id2 : 0, id3 : 0 });
        }

        function select(item){
            if (vm.selected.indexOf(item) == -1){
                item.selected = true;
                vm.selected.push(item);
            }else{
                vm.selected.splice(vm.selected.indexOf(item), 1);
                item.selected = false;
            }
        }

        function generateInvoice(){
            msg.confirm("Esta seguro que desea convertir " + vm.selected.length + " recibo(s) en factura?", function(){
                alert("Aun no llegamos aqui");
            });
        }

        function invoice(){
            alert("Aun no llegamos aca tampoco.");
        }

        function showOrderDetail(ev, id){
            $mdDialog.show({
                controller         : 'PartnersPartnerOrderDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-invoices/dialogs/dialog-order/dialog-order.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    OrderId : id
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerFamilyController', PartnersPartnerFamilyController);

    /** @ngInject */
    function PartnersPartnerFamilyController($state, api, $scope, CONST_DATATABLES, $mdDialog, $document, msg, utils)
    {
        var vm = this;

        /// Methods
        vm.detail = detail;
        vm.remove = remove;
        vm.showClubAccess = showClubAccess;   
        vm.showDetail = false;     

        vm.save = save;
        vm.cancel = cancel;
        vm.birthdateChange = birthdateChange;
        vm.dueChange = dueChange;
        vm.showAutomaticPayment = showAutomaticPayment;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = vm.parentScope.item;
            _refresh();            
            
            vm.picturesUrl = api.baseUrl.replace("api/","");     
            api.catalogs.dues.get({id: vm.partner.dueId }, function(response){
                vm.partnerDue = response;
            });
        }

        function _refresh(){
            api.partners.family.query({ partnerId: vm.partner.id }, function(response){
                vm.family = response;
                if (vm.family.length > 0)
                    vm.familiarSelected = vm.family[0];
            });
        }

        function detail(ev, item, Locked){
            if (!item && vm.family.length >= vm.partnerDue.familiarMaxNumber)
            {
                msg.error("No puede agregar mas familiares porque el tipo de cuota del titular no lo permite.");
                return;   
            }
            vm.familiarSelected = item;
            _initDetail({
                    dues         : vm.parentScope.dues,
                    countries    : vm.parentScope.countries,
                    agreements   : vm.parentScope.agreements,
                    professions  : vm.parentScope.professions,
                    genders      : vm.parentScope.genders,
                    clubAccess   : vm.parentScope.clubAccess,
                    calculationModes: vm.parentScope.calculationModes,
                    partnerTypes : vm.parentScope.partnerTypes,
                    accessTimeZones: vm.parentScope.accessTimeZones,
                    branches: vm.parentScope.branches,
                },
                vm.partner,
                item,
                Locked
            );

            vm.showDetail = true;
            
            // $mdDialog.show({
            //     controller         : 'PartnersPartnerFamilyDialogController',
            //     controllerAs       : 'vm',
            //     templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-family/dialogs/dialog-family.html',
            //     parent: angular.element(document.body),
            //     disableParentScroll: false,
            //     targetEvent        : ev,
            //     escapeToClose      : false,
            //     clickOutsideToClose: false,
            //     hasBackdrop        : false,
            //     locals             : {
            //         Familiar    : item,
            //         RefreshTable: _refresh,
            //         Partner     : vm.partner,
            //         Catalogs    : {
            //             dues         : vm.parentScope.dues,
            //             countries    : vm.parentScope.countries,
            //             agreements   : vm.parentScope.agreements,
            //             professions  : vm.parentScope.professions,
            //             genders      : vm.parentScope.genders,
            //             clubAccess   : vm.parentScope.clubAccess,
            //             calculationModes: vm.parentScope.calculationModes,
            //             partnerTypes : vm.parentScope.partnerTypes,
            //             accessTimeZones: vm.parentScope.accessTimeZones,
            //             branches: vm.parentScope.branches,
            //         },
            //         isLocked: Locked
            //     }
            // });
        }

        function remove(item){
            msg.confirm("Esta seguro que desea borrar este familiar?", function(){
                api.partners.family.delete({ id: item.id }, function(response){
                    msg.success("Familiar borrado correctamente.");
                    if ($state.current.name == "app.partners.partners.detail")
                        $state.reload();
                    else
                        $state.go("app.partners.partners.detail", { id: vm.partner.id });
                });
            });
        }

        function showClubAccess(ev, familiar){
            $mdDialog.show({
                controller         : 'PartnersPartnerDialogAccessController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/dialogs/dialog-clubAccess/dialog-clubAccess.html',
                targetEvent        : ev,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals             : {
                    Partner : familiar
                }
            });
        }

        function _initDetail(Catalogs, Partner, Familiar, isLocked){
            vm.catalogs = Catalogs;
            vm.partner = Partner;
            vm.minBirthdate = moment(vm.today).subtract(100, 'years').toDate();
            vm.maxBirthdate = moment(vm.today).toDate();
            vm.duePrices = [];
            vm.isLocked = isLocked;
                
            if (Familiar){
                vm.title = "EDITAR FAMILIAR";
                api.partners.family.get({
                    partnerId  : Familiar.parentPartnerId,
                    id         : Familiar.id
                }, function(response){
                    vm.familiar = response;
                    
                    // Set agreements
                    var agreements = angular.copy(vm.familiar.agreements);
                    vm.familiar.agreements = [];
                    angular.forEach(agreements, function(x) {
                        vm.familiar.agreements.push(vm.catalogs.agreements.filter(function(a){ return a.id == x.id })[0]); 
                    });
                    
                    // Set branches 
                    var branches = angular.copy(vm.familiar.branches);
                    vm.familiar.branches = [];
                    angular.forEach(branches, function(ca) {
                        vm.familiar.branches.push(vm.catalogs.branches.filter(function(branch){ return branch.id == ca.id })[0]); 
                    });

                    vm.birthdate = vm.familiar.birthdate;
                    birthdateChange();
                    dueChange();
                    vm.inscriptionDate = moment(vm.familiar.inscriptionDate).toDate();
                    vm.initPayDate = moment(vm.familiar.initPayDate).toDate();            
                });
            }else{
                vm.title = "AGREGAR FAMILIAR";
                vm.familiar = {
                    id             : 0,
                    parentPartnerId: Partner.id,
                    familyId       : Partner.familyId,
                    isFamily       : true,
                    active         : true,
                    birthdate      : new Date(),
                    dues           : [],
                    agreements     : [],
                    initPayDate    : new Date(),
                    inscriptionDate: new Date()
                };
                vm.birthdate = vm.familiar.birthdate;
                birthdateChange();
                vm.inscriptionDate = moment(vm.familiar.inscriptionDate).toDate();
            
            }

        }

        function save(){
            api.partners.family.save(vm.familiar, function(response){
                msg.success("Familiar guardada correctamente.");
                if ($state.current.name == "app.partners.partners.detail")
                    $state.reload();
                else
                    $state.go("app.partners.partners.detail", { id: vm.partner.id });
                cancel();
            });
        }

        function cancel(){
            vm.showDetail = false;
        }

        function birthdateChange(){
            if (moment(vm.birthdate) > moment()){
                msg.error("Fecha invalida!");
                return;
            }

            vm.familiar.birthdate = vm.birthdate;

            var birthdate = moment(vm.birthdate);     
            vm.familiar.age = utils.calculateAge(birthdate.date(), birthdate.month(),  birthdate.year())               
            vm.birthdate = moment(vm.familiar.birthdate).toDate();
        }

        function dueChange(){
            api.catalogs.duePrices.get({ 
                dueId         : vm.familiar.dueId,
                searchType    : 3,
                searchId      : vm.partner.duePeriodicityId
            }, function(response){
                if (response.length == 0){
                    msg.error("No hay precios vigentes configurados para esa cuota");
                    vm.duePrices = [];
                }else{
                    vm.familiar.duePeriodicityId = response[0].periodicity.id;
                    vm.duePeriodicityText = response[0].periodicity.name + " ($ " + response[0].price.toFixed(2) + " )" ;
                }
            });
        }

        function showAutomaticPayment(ev){
            $mdDialog.show({
                controller         : 'PartnersPartnerAutomaticPaymentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/dialogs/dialog-automaticPayment/dialog-automaticPayment.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Partner     : vm.familiar
                }
            });
        }  
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerBecasController', PartnersPartnerBecaController);

    /** @ngInject */
    function PartnersPartnerBecaController($state, api, $scope, CONST_DATATABLES, $mdDialog, $document, msg)
    {
        var vm = this;

        /// Methods
        vm.detail = detail;
        vm.remove = remove;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(vm.parentScope.item);            
            _refresh();            
        }

        function _refresh(){
            api.partners.becas.query({ familyId: vm.partner.familyId }, function(response){
                vm.becas = response;
            });
        }

        function detail(ev, item){
            $mdDialog.show({
                controller         : 'PartnersPartnerBecasDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-becas/dialogs/dialog-beca.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Beca     : item,
                    RefreshTable: _refresh,
                    FamilyId    : vm.partner.familyId
                }
            });
        }

        function remove(item){
            msg.confirm("Esta seguro que desea borrar esta beca?", function(){
                api.partners.becas.delete({ id: item.id }, function(response){
                    msg.success("Beca borrada correctamente.");
                    _refresh();
                });
            });
        }

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerAddressController', partnersPartnerController);

    /** @ngInject */
    function partnersPartnerController($state, api, $scope, CONST_DATATABLES, $mdDialog, $document, msg)
    {
        var vm = this;

        /// Methods
        vm.detail = detail;
        vm.deleteAddress = deleteAddress;
        ///

        _init();

        function _init(){
            var parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(parentScope.item);
            _refresh();

            // vm.dtAddressInstance = {};
            // vm.dtAddressOptions = angular.copy(angular.extend(CONST_DATATABLES.OPTIONS, {
            //     columnDefs  : [
            //         {
            //             // Target the ID column
            //             targets           : 0,
            //             responsivePriority: 0,
            //         },
            //         {
            //             // Target the default column
            //             targets           : 3,
            //             filterable        : false,
            //             sortable          : false
            //         },
            //         {
            //             // Target the active column
            //             targets           : 4,
            //             filterable        : false,
            //             sortable          : false
            //         },
            //         {
            //             // Target the actions column
            //             targets           : 5,
            //             responsivePriority: 1,
            //             filterable        : false,
            //             sortable          : false
            //         }
            //     ],
            // }));
        }

        function _refresh(){
            api.partners.addresses.query({ partnerId: vm.partner.id }, function(addresses){
                vm.addresses = addresses;
            })
        }

        function detail(ev, item){
            $mdDialog.show({
                controller         : 'PartnersPartnerAddressDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-address/dialogs/dialog-address.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Address     : item,
                    RefreshTable: _refresh,
                    PartnerID   : vm.partner.id
                }
            });
        }

        function deleteAddress(item){
            msg.confirm("Esta seguro que desea borrar la dirección actual?", function(){
                api.partners.addresses.delete({ id: item.id }, function(response){
                    msg.success("Dirección borrada correctamente.");
                    _refresh();
                });
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerAbsencesController', PartnersPartnerAbsenceController);

    /** @ngInject */
    function PartnersPartnerAbsenceController($state, api, $scope, CONST_DATATABLES, $mdDialog, $document, msg)
    {
        var vm = this;

        /// Methods
        vm.detail = detail;
        vm.remove = remove;
        ///

        _init();

        function _init(){
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = angular.copy(vm.parentScope.item);            
            _refresh();            
        }

        function _refresh(){
            api.partners.absences.query({ familyId: vm.partner.familyId }, function(response){
                vm.absences = response;
            });
        }

        function detail(ev, item){
            $mdDialog.show({
                controller         : 'PartnersPartnerAbsencesDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/tabs/tab-absences/dialogs/dialog-absence.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Absence     : item,
                    RefreshTable: _refresh,
                    FamilyId    : vm.partner.familyId
                }
            });
        }

        function remove(item){
            msg.confirm("Esta seguro que desea borrar esta ausencia?", function(){
                api.partners.absences.delete({ id: item.id }, function(response){
                    msg.success("Ausencia borrada correctamente.");
                    _refresh();
                });
            });
        }

        
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerDialogSignatureMouseController', partnersPartnerDialogSignatureMouseController);

    /** @ngInject */
    function partnersPartnerDialogSignatureMouseController($mdDialog, Callback, $scope)
    {        
        var vm = this;
        _init();
        
        function _init(){
            
            vm.signature = '';        
            vm.callback = Callback;
        }
        
        vm.clearSignature = function() {
            vm.signature = '';
            $scope.$broadcast('clearSignature');
        };
        
        vm.onClear = function() {
            vm.clearSignature();
        }
        
        vm.onDone = function()
        {
            if (vm.signature) {
                var newSignature = vm.signature.replace("data:image/png;base64,", "")
                vm.callback(newSignature);
                vm.close();
            } else {
                alert('No ingreso su firma');
            }
        }   
        
        vm.close = function(){
            $mdDialog.hide();
        }                                            
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerDialogSignatureController', partnersPartnerDialogSignatureController);

    /** @ngInject */
    function partnersPartnerDialogSignatureController($mdDialog, Callback, $scope)
    {
        //////////////////////////// NEW WAY //////////////////////////////////////        
        // var vm = this;
        // _init();
        
        // function _init(){
            
        //     vm.signature = '';        
        //     vm.callback = Callback;
        // }
        
        // vm.clearSignature = function() {
        //     vm.signature = '';
        //     $scope.$broadcast('clearSignature');
        // };
        
        // vm.onClear = function() {
        //     vm.clearSignature();
        // }
        
        // vm.onDone = function()
        // {
        //     if (vm.signature) {
        //         var newSignature = vm.signature.replace("data:image/png;base64,", "")
        //         vm.callback(newSignature);
        //         vm.close();
        //     } else {
        //         alert('No ingreso su firma');
        //     }
        // }   
        
        // vm.close = function(){
        //     $mdDialog.hide();
        // }
        
        ////////////////////////////  / NEW WAY //////////////////////////////////////
        
        
        
        
        
        //////////////////////////// OLD WAY //////////////////////////////////////
        
        // ///////////// SIGN ///////////////
        var vm = this;
        var tmr;

        vm.onClear = onClear;
        vm.onDone = onDone;

        function onSign()
        {
            var ctx = document.getElementById('cnv').getContext('2d');         
            SetDisplayXSize( 500 );
            SetDisplayYSize( 100 );
            SetTabletState(0, tmr);
            SetJustifyMode(0);
            ClearTablet();
            if(tmr == null)
            {
                tmr = SetTabletState(1, ctx, 50);
            }
            else
            {
                SetTabletState(0, tmr);
                tmr = null;
                tmr = SetTabletState(1, ctx, 50);
            }
        }

        function onClear()
        {
            ClearTablet();
        }

        function onDone()
        {
            if(NumberOfTabletPoints() == 0)
            {
                alert("Agrega tu firma para continuar");
            }
            else
            {
                SetTabletState(0, tmr);
                //RETURN TOPAZ-FORMAT SIGSTRING
                SetSigCompressionMode(1);

                //RETURN BMP BYTE ARRAY CONVERTED TO BASE64 STRING
                SetImageXSize(500);
                SetImageYSize(100);
                SetImagePenWidth(5);
                GetSigImageB64(SigImageCallback);
            }
        }

        function SigImageCallback( str )
        {
            document.getElementById("hdn-base64sign").value = str;
            vm.accept();   
        }       

        window.onunload = window.onbeforeunload = (function(){
            closingSigWeb()
        })

        function closingSigWeb()
        {
            ClearTablet();
            SetTabletState(0, tmr);
        }
        ///////////// END SIGN ///////////////
        
        _init();

        /// Methods
        vm.accept = accept;
        vm.close = close;
        ////

        function _init(){            
            vm.callback = Callback;
            setTimeout(function(){
                onSign();
            }, 10)
        }   

        function close(){
            $mdDialog.hide();
        }

        function accept(){
            close();
            var hdn = document.getElementById("hdn-base64sign");
            vm.callback(hdn.value);
        }        
        ////////////////////////////  / OLD WAY //////////////////////////////////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerDuesDialogController', partnersPartnerDuesDialogController);

    /** @ngInject */
    function partnersPartnerDuesDialogController(api, $mdDialog, msg, Partner)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.close = close;
        vm.dueChange = dueChange;
        ////

        function _init(){
            vm.partner = Partner;
            api.catalogs.dues.query(function(response){
                vm.dues = response.filter(function(d){                     
                        // Titular/Familiar validation
                    return d.isFamiliar == vm.partner.isFamiliar 
                        && d.isTitular == !vm.partner.isFamiliar
                        // Age range validation
                        && (d.minAge != 0 && d.minAge <= vm.partner.age)
                        && (d.maxAge != 0 && vm.partner.age <= d.minAge)
                        // Partner Type validation
                        && (d.partnerType == vm.partner.partnerType);
                }); 
            });
            vm.duePrices = [];
        }

        function dueChange(){
            if (!vm.due || !vm.due.id || vm.due.id == 0)
            return;
        
            api.catalogs.duePrices.get({ 
                dueId         : vm.due.id,
                searchType    : 2 /*By Due*/,
                searchId      : vm.due.id
            }, function(response){
                if (response.length == 0){
                    msg.error("No hay precios vigentes configurados para esa cuota");
                    vm.duePrices = [];
                }else{
                    vm.duePrices = response;
                }
                vm.item.duePeriodicityId = null;
            });
        }

        function close(){
            $mdDialog.hide();
        }

        function save(){
            // TODO: Validate     

            api.partners.automaticPayment.save(vm.automaticPayment, function(response){
                vm.automaticPayment.id = response.id;
                msg.success("Cambios guardados correctamente");
                close();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerDialogAccessController', partnersPartnerDialogAccessController);

    /** @ngInject */
    function partnersPartnerDialogAccessController(api, $mdDialog, msg, Partner)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.close = close;
        vm.accessChecked = accessChecked;
        ////

        function _init(){
            vm.partner = Partner;
            var selectedBranchesIds = vm.partner.branches.map(function(b){ return b.id });
            api.catalogs.clubAccess.getAll(function(response){
                
                vm.clubAccess = response.filter(function(ca){ return selectedBranchesIds.indexOf(ca.branchId) != -1 });
                api.catalogs.accessTimeZones.getAll(function(timeZonesResponse){
                    angular.forEach(vm.clubAccess, function(ca) {
                        var branchTimeZones = timeZonesResponse.filter(function(tz){ return tz.branchId == ca.branchId });
                        ca.timeZones = angular.copy(branchTimeZones);
                    });
                    
                    // Get Partner Access
                    api.partners.accessTimeZones.get({
                        id: vm.partner.id
                    }, function(response){

                        angular.forEach(response.access, function(acc){
                            var filter = vm.clubAccess.filter(function(a){ return a.id == acc.clubAccessId });     
                            if (filter.length > 0)
                            {   
                                var clubAccess = filter[0];
                                clubAccess.selected = true;
                                var tzFilter = clubAccess.timeZones.filter(function(tz){ return tz.id == acc.timeZoneId });
                                if (tzFilter.length > 0){
                                    tzFilter[0].selected = true;
                                }     
                            }
                        });

                        // Group ResultList
                        vm.groups = vm.clubAccess.groupBy('branchId'); 
                    });
                });           
            });

        }   

        function close(){
            $mdDialog.hide();            
        }

        function save(){
            // Generate object to send
            var access = [];
            var error = "";
            var selectedClubAccess = vm.clubAccess.filter(function(ca){ return ca.selected });
            if (selectedClubAccess.length == 0)
                error = "Debe seleccionar al menos un horario para el acceso";
            angular.forEach(selectedClubAccess, function(ca){
                var timeZones = ca.timeZones.filter(function(tz){ return tz.selected });
                if (timeZones.length == 0){
                    error = "Debe seleccionar al menos un horario para el acceso " + ca.name;
                    return;
                }
                
                angular.forEach(timeZones, function(tz){
                    access.push({
                        partnerId       : vm.partner.id,
                        clubAccessId    : ca.id,
                        timeZoneId      : tz.id
                    });
                });
            });

            if (error != '')
            {
                msg.error(error);
                return;
            }

            api.partners.accessTimeZones.save({
                access: access
            }, function(response){
                msg.success("Accesos a club guardados correctamente.");
                $mdDialog.hide();
            });
        }

        function accessChecked(access){
            if (!access.selected){
                angular.forEach(access.timeZones, function(tz) {
                    tz.selected = false;
                });
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerAutomaticPaymentController', partnersPartnerAddressDialogController);

    /** @ngInject */
    function partnersPartnerAddressDialogController(api, $mdDialog, msg, Partner)
    {
        var vm = this;
        _init();

        /// Methods
        vm.save = save;
        vm.close = close;
        vm.enable = enable;
        vm.disable = disable;
        vm.getDataFromTitular = getDataFromTitular;
        ////

        function _init(){
            vm.partner = Partner;
            vm.paymentMethods = api.catalogs.paymentMethods.query();
            vm.paymentMethodOptions = api.catalogs.paymentMethodOptions.query();

            // Get Automatic Payment from API
            api.partners.automaticPayment.get({ id: vm.partner.id }, function(response){
                if (!response.id){
                    vm.automaticPayment = {
                        id: 0,
                        partnerId: vm.partner.id,
                        isEnabled: false,
                        expirationDate: new Date()
                    };
                    vm.isCreating = false;
                }else{
                    vm.automaticPayment = response;
                }
            });
        }

        function close(){
            $mdDialog.hide();
        }

        function save(){
            // Validate     
            var error = '';
            var expirationMonth = parseInt(vm.automaticPayment.cardExpiration.substr(0,2));
            var expirationYear =  parseInt(vm.automaticPayment.cardExpiration.substr(2,4));
            if (vm.automaticPayment.cardNumber.length < 15 || vm.automaticPayment.cardNumber.length > 16)
                error = "Numero de tarjeta incorrecto.";
            else if (expirationMonth < 1 || expirationMonth > 12)
                error = "Fecha de Expiración incorrecta";
            else if (expirationYear < parseInt(moment().format("YY")))
                error = "Fecha de Expiración incorrecta";
            else if (moment(expirationMonth + '/' + expirationYear, "MM/YY") < moment())
                error = "Tarjeta expirada";

            if (error != ''){
                msg.error(error);
                return;
            }

            api.partners.automaticPayment.save(vm.automaticPayment, function(response){
                vm.automaticPayment.id = response.id;
                msg.success("Cambios guardados correctamente");
                close();
            });
        }

        function enable(){
            vm.automaticPayment.isEnabled = true;
            if (vm.automaticPayment.id != 0)
                api.partners.automaticPayment.save(vm.automaticPayment, function(response){
                    msg.success("Cargo automatico habilitado");
                });
        }

        function disable(){
            vm.automaticPayment.isEnabled = false;
            if (vm.automaticPayment.id != 0)
                api.partners.automaticPayment.save(vm.automaticPayment, function(response){
                    msg.success("Cargo automatico deshabilitado");
                });
        }

        function getDataFromTitular(){
            api.partners.automaticPayment.get({ id: vm.partner.parentPartnerId }, function(response){
                if (response.id && response.isEnabled){
                    vm.automaticPayment = angular.extend(response, {
                        id : 0,
                        partnerId : vm.partner.id
                    });
                }else{
                    msg.error("El titular no tiene cargo automatico");
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerDialogAccionesController', partnersPartnerDialogAccionesController);

    /** @ngInject */
    function partnersPartnerDialogAccionesController(api, $mdDialog, msg, Acciones, Callback)
    {
        var vm = this;
        _init();

        /// Methods
        vm.accept = accept;
        vm.close = close;
        ////

        function _init(){
            vm.acciones = Acciones;
            vm.callback = Callback;
            vm.selectedAccion = null;
        }   

        function close(){
            $mdDialog.hide();
        }

        function accept(){
            if (!vm.selectedAccion)
            {
                msg.error("Seleccione accion para continuar");
                return;                
            }

            close();
            vm.callback(vm.selectedAccion);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerInfoDialogMessagesController', partnersPartnerInfoDialogMessagesController);

    /** @ngInject */
    function partnersPartnerInfoDialogMessagesController(api, $mdDialog, msg, Partner)
    {
        var vm = this;
        _init();

        /// Methods
        vm.add = add;
        vm.save = save;
        vm.cancel = cancel;
        vm.close = close;
        vm.read = read;
        vm.unread = unread;
        ////

        function _init(){
            vm.partner = Partner;
            vm.message = null;
            vm.messages = [];
            _getMessages();
            vm.filterIsView = false;
        }   

        function _getMessages(){
            api.partners.messages.get({ id: vm.partner.id }, function(response){
                vm.messages = response;
                if (vm.messages.length > 0)
                    vm.selectedMessage = vm.messages[0];
            });
        }

        function close(){
            $mdDialog.hide();
        }

        function add(){
            vm.message = {
                id          : 0,
                partnerId   : vm.partner.id,
                isviewed    : false,
                message     : ''
            };
        }           

        function save(){
            api.partners.messages.save(vm.message, function(response){
                msg.success("Mensaje guardado correctamente.");
                _getMessages();
                cancel();
            });
        }

        function cancel(){
            vm.message = null;
        }

        function read(){
            vm.selectedMessage.isViewed = true;
            api.partners.messages.save(vm.selectedMessage, function(response){
                msg.success("Mensaje marcado como leido.");
                _getMessages();
            });
        }

        function unread(){
            vm.selectedMessage.isViewed = false;
            api.partners.messages.save(vm.selectedMessage, function(response){
                msg.success("Mensaje marcado como NO leido.");
                _getMessages();
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerInfoDialogPassesController', partnersPartnerInfoDialogPassesController);

    /** @ngInject */
    function partnersPartnerInfoDialogPassesController(api, $mdDialog, msg, Partner, $state)
    {
        var vm = this;
        _init();

        /// Methods
        vm.add = add;
        vm.save = save;
        vm.cancel = cancel;
        vm.close = close;
        vm.checkPassNumber = checkPassNumber;
        vm.getPasses = getPasses;
        vm.remove = remove;
        vm.showPrintable = showPrintable;
        ////

        function _init(){
            vm.partner = Partner;
            vm.pass = null;
            vm.passes = [];
            api.inventory.products.query(function(response){
                vm.inventory = response.filter(function(i){ return i.quantity > 0 || !i.product.isStockRequired });
            });
            vm.passTypes = api.catalogs.passTypes.query();
            api.partners.partners.getByFamily({
                id: 0,
                familyId: vm.partner.familyId
            }, function(response){
                vm.partners = response;
                vm.partner = vm.partners.filter(function(p){ return p.id == vm.partner.id })[0];
            });

            // date filters
            var now = moment();
            var from = moment([now.year(), now.month()]);
            var to = moment(from).endOf('month');
            vm.from = from.toDate();
            vm.to = to.toDate();

            getPasses();
            
        }

        function getPasses(){
            api.partners.passes.get({ 
                familyId: vm.partner.familyId,
                from: moment(vm.from).format('DD-MM-YYYY'),
                to: moment(vm.to).format('DD-MM-YYYY'),
            }, function(response){
                vm.passes = response;
                if (vm.passes.length > 0)
                    vm.selectedPass = vm.passes[0];
            })
        }

        function close(){
            $mdDialog.hide();
        }

        function add(){
            vm.pass = {
                id          : 0,
                passId      : null,
                partnerId    : vm.partner.id,
                validFrom   : now(),
                validTo     : now(),
                generatePlannedProduct: false,
                productPrice: 0,
                active      : true
            };
            vm.passNumber = '';
            vm.validFrom = vm.pass.validFrom;
            vm.validTo = vm.pass.validTo;
            vm.pass.name = vm.partner.completeName;
            vm.pass.email = vm.partner.email;
        }

        function save(){
            var print = vm.pass.isPrintable;
            api.partners.passes.save(vm.pass, function(response){
                var str = vm.pass.isSendByEmail ? ", en breve lo recibirá por correo electrónico." : ".";
                msg.success("Pase/Credencial guardado correctamente" + str);
                if (print){
                    close();
                    $state.go('app.partners.info.pass-print', { id: response.id });
                }else{
                    getPasses();
                    cancel();
                }
            });
        }

        function cancel(){
            vm.pass = null;
        }

        function checkPassNumber(){
            if ( isNaN(vm.passNumber)){
                msg.error("Se esperaba un número");
                return;
            }

            var number = parseInt(vm.passNumber);

            api.partners.passes.checkPassNumber({
                familyId: vm.partner.familyId,
                passNumber: number
            }, function(response){
                if (response){
                    vm.checkPassNumberOk = true;
                    vm.pass.passId = response.id;
                    vm.pass.pass = response;
                    vm.pass.isSendByEmail = vm.pass.pass.passType.isSendByEmail;
                }else{
                    vm.checkPassNumberOk = false;
                    vm.pass.passId = null;
                    vm.pass.pass = null;
                }
            }, function(errorResponse){
                vm.checkPassNumberOk = false;
                vm.pass.pass = null;
                vm.pass.passId = null;
            });
        }

        function remove(){
            if (confirm("Esta seguro que desea borrar este pase?")){
                api.partners.passes.delete({ id: vm.selectedPass.id }, function(response){
                    msg.success("Pase borrado correctamente.");
                    getPasses();
                });
            }
        }

        function showPrintable(passId){
            cancel();
            close();
            $state.go('app.partners.info.pass-print', { id: passId });
            //$state.go('app.invoices.orders.receipt', { id: id });
        }

        function now(){
            var d = new Date();
            return d.getFullYear() + '-' + 
                ('0' + (d.getMonth()+1)).slice(-2) + '-' + 
                ('0' + d.getDate()).slice(-2);
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerInfoDialogCredentialController', partnersPartnerInfoDialogCredentialController);

    /** @ngInject */
    function partnersPartnerInfoDialogCredentialController(api, $mdDialog, msg, Partner, $state, authService) {
        // Generate QR code
        // var tempotal = document.getElementById("qrcode");
        var tempotal = document.createElement("div");
        var qrcode = new QRCode(tempotal);
        qrcode.makeCode("http://www.kiaraorozco.com/");
        var vm = this;
        _init();

        /// Methods
        vm.add = add;
        vm.save = save;
        vm.cancel = cancel;
        vm.close = close;
        vm.checkPassNumber = checkPassNumber;
        vm.getPasses = getPasses;
        vm.remove = remove;
        vm.showPrintable = showPrintable;
        ////

        var loquesea = 10;

        function _init() {
            vm.appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + vm.appData.settings.logoFile;
            vm.picturesUrl = api.baseUrl.replace("api/", "");
            vm.partner = Partner;
            vm.pass = null;
            vm.passes = [];
            vm.div = tempotal;
            api.inventory.products.query(function (response) {
                vm.inventory = response.filter(function (i) { return i.quantity > 0 || !i.product.isStockRequired });
            });
            vm.passTypes = api.catalogs.passTypes.query();
            api.partners.partners.getByFamily({
                id: 0,
                familyId: vm.partner.familyId
            }, function (response) {
                vm.partners = response;
                vm.partner = vm.partners.filter(function (p) { return p.id == vm.partner.id })[0];
            });

            // date filters
            var now = moment();
            var from = moment([now.year(), now.month()]);
            var to = moment(from).endOf('month');
            vm.from = from.toDate();
            vm.to = to.toDate();

            getPasses();

        }

        function getPasses() {
            api.partners.passes.get({
                familyId: vm.partner.familyId,
                from: moment(vm.from).format('DD-MM-YYYY'),
                to: moment(vm.to).format('DD-MM-YYYY'),
            }, function (response) {
                vm.passes = response;
                if (vm.passes.length > 0)
                    vm.selectedPass = vm.passes[0];
            })
        }

        function close() {
            $mdDialog.hide();
        }

        function add() {
            vm.pass = {
                id: 0,
                passId: null,
                partnerId: vm.partner.id,
                validFrom: new Date(),
                validTo: new Date(),
                generatePlannedProduct: false,
                productPrice: 0,
                active: true
            };
            vm.passNumber = '';
            vm.validFrom = vm.pass.validFrom;
            vm.validTo = vm.pass.validTo;
            vm.pass.name = vm.partner.completeName;
            vm.pass.email = vm.partner.email;
        }

        function save() {
            var print = vm.pass.isPrintable;
            api.partners.passes.save(vm.pass, function (response) {
                var str = vm.pass.isSendByEmail ? ", en breve lo recibirá por correo electrónico." : ".";
                msg.success("Pase/Credencial guardado correctamente" + str);
                if (print) {
                    close();
                    $state.go('app.partners.info.pass-print', { id: response.id });
                } else {
                    getPasses();
                    cancel();
                }
            });
        }

        function cancel() {
            vm.pass = null;
        }

        function checkPassNumber() {
            if (isNaN(vm.passNumber)) {
                msg.error("Se esperaba un número");
                return;
            }

            var number = parseInt(vm.passNumber);

            api.partners.passes.checkPassNumber({
                familyId: vm.partner.familyId,
                passNumber: number
            }, function (response) {
                if (response) {
                    vm.checkPassNumberOk = true;
                    vm.pass.passId = response.id;
                    vm.pass.pass = response;
                    vm.pass.isSendByEmail = vm.pass.pass.passType.isSendByEmail;
                } else {
                    vm.checkPassNumberOk = false;
                    vm.pass.passId = null;
                    vm.pass.pass = null;
                }
            }, function (errorResponse) {
                vm.checkPassNumberOk = false;
                vm.pass.pass = null;
                vm.pass.passId = null;
            });
        }

        function remove() {
            if (confirm("Esta seguro que desea borrar este pase?")) {
                api.partners.passes.delete({ id: vm.selectedPass.id }, function (response) {
                    msg.success("Pase borrado correctamente.");
                    getPasses();
                });
            }
        }

        function showPrintable(passId) {
            cancel();
            close();
            $state.go('app.partners.info.pass-print', { id: passId });
            //$state.go('app.invoices.orders.receipt', { id: id });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.invoices.notasCredito', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.invoices.notasCredito', {
                url      : '/notasCredito',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/notasCredito/notasCredito/notasCredito.html',
                        controller : 'InvoicesNotasCreditoController as vm'
                    }
                },
                resolve  : {
                    NotasCredito: function (apiResolver)
                    {
                        return apiResolver.resolve('invoices.notasCredito@query');
                    }
                }
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.invoices.notasCredito', {
            title: 'Notas de Credito',
            shortcuticon  : 'icon-repeat',                        
            state: 'app.invoices.notasCredito'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices.notasCredito')
        .controller('InvoicesNotasCreditoDialogController', invoicesNotasCreditoDialogController);

    /** @ngInject */
    function invoicesNotasCreditoDialogController(api, $mdDialog, msg, NotaCredito, authService, $state)
    {
        var vm = this;
        _init();

        /// Methods
        vm.close = close;
        vm.searchInvoice = searchInvoice;
        vm.save = save;
        vm.orderSelectedChange = orderSelectedChange;
        ////

        function _init(){
            
            vm.settings = authService.getAppData().settings;
            vm.invoiceSerie = vm.settings.invoiceSerie;
            vm.conceptos = api.catalogs.conceptosNotaCredito.query();
            vm.cfdiRelacionado = api.sat.cfdiRelacionado.query();
            vm.saving = false;
            if (NotaCredito){
                vm.item = NotaCredito;
            }else{
                vm.item = {
                    id: 0,
                    invoice: {}
                };
            }
            vm.searchInvoiceLoading = false;
        }        

        function searchInvoice(){
            if (vm.invoiceSerie == '' || !vm.invoiceNumber || vm.invoiceNumber == ''){
                msg.error("Ingrese datos para buscar factura");
                return;
            }
            
            vm.searchInvoiceLoading = true;
            api.invoices.invoices.getByFolio({ 
                serie: vm.invoiceSerie, 
                folio: vm.invoiceNumber
            }, function(response){

                vm.invoice = angular.copy(response);
                vm.item = angular.extend(response,{
                    id       : 0,
                    invoiceId: vm.invoice.id,
                    invoiceFolio: vm.invoice.folio,    
                    xmlString: null,
                    xmlPath  : null,
                    serie    : null,
                    number   : null,
                    folio    : null,              
                    subtotal : 0,
                    details: [],
                    nCorderId: 0 ,
                    orderFolio: '',
                    SatCfdiRelacionadoId: null,
                    reactiveReceipt: false
                });
                if (vm.invoice.ncOrders.length > 0){
                    vm.selectedOrder = vm.invoice.ncOrders[0];
                    vm.item.nCorderId = vm.invoice.ncOrders[0].id;
                    vm.item.orderFolio = vm.invoice.ncOrders[0].folio;
                    vm.item.total = vm.invoice.ncOrders[0].remainingAmount;
                }
                vm.searchInvoiceLoading = false;
            }, function(){
                vm.searchInvoiceLoading = false;
            });
        }

        function close(){
            $mdDialog.hide();
        }

        function save(){
            vm.saving = true; 
            // Add Details 
            vm.item.details.push({
                conceptoNotaCreditoId: vm.conceptoNotaCredito.id,
                description: vm.conceptoNotaCredito.name
            });
            vm.item.SatCfdiRelacionadoId = vm.cfdiRelacionado.id;
            api.invoices.notasCredito.save(vm.item, function(response){
                msg.success("Nota de Crédito Generada correctamente.");
                vm.saving = false;
                close();
                // Go to Receipt
                $state.go("app.invoices.receipt", { id: response.id });
            }, function(){
                vm.saving = false;
            });
        }

        function orderSelectedChange(selectedOrder){
            vm.item.total = selectedOrder.remainingAmount;
            vm.item.nCorderId = selectedOrder.id;
            vm.item.orderFolio = selectedOrder.folio;
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.inventory.inventories', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.inventory.inventories', {
                url      : '/inventories',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/inventory/views/inventories/inventories/inventories.html',
                        controller : 'InventoryInventoriesController as vm'
                    }
                }
            })
            .state('app.inventory.inventories.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/inventory/views/inventories/inventory/inventory.html',
                        controller : 'InventoryInventoryController as vm'
                    }
                },
                resolve  : {
                    Inventory: function ()
                    {
                        return { id: 0, name: '', quantity: 0, cost: 0, price: 0, productId: 0, warehouseId: 0 };
                    },
                },
            })
            .state('app.inventory.inventories.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/inventory/views/inventories/inventory/inventory.html',
                        controller : 'InventoryInventoryController as vm'
                    }
                },
                resolve  : {
                    Inventory: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('inventory.inventory@get', { id: $stateParams.id });
                    }
                },
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.inventory.inventories', {
            title: 'Inventarios',
            state: 'app.inventory.inventories',
            shortcuticon  : 'icon-basket-fill',
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.inventory.inventories')
        .controller('InventoryInventoriesDialogInventoryController', InventoryInventoriesDialogInventoryController);

    /** @ngInject */
    function InventoryInventoriesDialogInventoryController($mdDialog, msg, Callback, api)
    {
        var vm = this;

        init();

        // Methods
        vm.accept = accept;            
        vm.close = close;
        ////////

        function init(){
            vm.callback = Callback;
            api.catalogs.products.query(function(response){
                vm.products = response.filter(function(p) { return p.active }); 
            });
            vm.warehouses = api.catalogs.warehouses.query();
            vm.inventory = {
                id          : 0,
                productId   : 0,
                warehouseId : 0,
                quantity    : 0,
                price       : 0
            };
        }

        function accept(){  
            api.inventory.inventory.save(vm.inventory, function(response){
                vm.callback(response);
                close();
            });
        }

        function close(){
            $mdDialog.hide();
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.invoices.orders', [ 
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.invoices.orders', {
                url      : '/orders',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/orders/orders/orders.html',
                        controller : 'InvoicesOrdersController as vm'
                    }
                }
            })
            .state('app.invoices.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/orders/order/order.html',
                        controller : 'InvoicesOrderController as vm'
                    }
                },
                resolve  : {
                    Partners: function (apiResolver)
                    {
                        return apiResolver.resolve('partners.partners@getByFilters', { keyword: 'dummy', pageNumber: 0, pageSize: 0 });
                    },
                    PaymentMethods: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.paymentMethods@query');
                    },
                    PaymentMethodOptions: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.paymentMethodOptions@query');
                    },
                    Tpvs: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.tpvs@query');
                    },
                    Partner: function() {
                        return { id: 0 }
                    }
                },
            })
            .state('app.invoices.add.partner', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/orders/order/order.html',
                        controller : 'InvoicesOrderController as vm'
                    }
                },
                resolve  : {
                    Partners: function (apiResolver)
                    {
                        return apiResolver.resolve('partners.partners@getByFilters', { keyword: 'dummy', pageNumber: 0, pageSize: 0 });
                    },
                    PaymentMethods: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.paymentMethods@query');
                    },
                    PaymentMethodOptions: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.paymentMethodOptions@query');
                    },
                    Tpvs: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.tpvs@query');
                    },
                    Partner: function(apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('partners.partners@get', { id : $stateParams.id });
                    }
                },
            })
            .state('app.invoices.orders.receipt', {
                    url      : '/receipt/:id',
                    views    : {
                        'content@app': {
                            templateUrl: 'app/main/invoices/views/orders/receipt/receipt.html',
                            controller : 'InvoicesOrdersReceiptController as vm'
                        }
                    },
                    resolve  : {
                        Order: function (apiResolver, $stateParams)
                        {
                            return apiResolver.resolve('invoices.orders@get', { id : $stateParams.id });
                        }
                    },
                    bodyClass: 'invoice printable'
                })
            .state('app.invoices.orders.coupon', {
                    url      : '/coupon/:id',
                    views    : {
                        'content@app': {
                            templateUrl: 'app/main/invoices/views/orders/coupon/coupon.html',
                            controller : 'InvoicesOrdersCouponController as vm'
                        }
                    },
                    resolve  : {
                        Order: function (apiResolver, $stateParams)
                        {
                            return apiResolver.resolve('invoices.orders@get', { id : $stateParams.id, id2 : 0, id3 : 0 });
                        }
                    },
                    bodyClass: 'invoice printable'
                })            
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.invoices.add', {
            title: 'Facturar',
            shortcuticon   : 'icon-currency-usd',
            state: 'app.invoices.add'
        });
        msNavigationServiceProvider.saveItem('apps.invoices.orders', {
            title: 'Recibos/Facturas',
            shortcuticon  : 'icon-file-document',            
            state: 'app.invoices.orders'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices.orders')
        .controller('InvoicesOrderDialogIncompletePeriodsController', InvoicesInvoiceDialogIncompletePeriodsController);

    /** @ngInject */
    function InvoicesInvoiceDialogIncompletePeriodsController($mdDialog, msg, Periods, Callback)
    {
        var vm = this;

        init();

        // Methods
        vm.accept = accept;            
        vm.cancel = cancel;
        ////////

        function init(){
            vm.callback = Callback;
            vm.periods = Periods;
        }

        function accept(){  
            vm.callback(vm.periods);
            cancel();
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices.orders')
        .controller('InvoicesOrdersOrderDialogController', invoicesOrdersOrderDialogController);

    /** @ngInject */
    function invoicesOrdersOrderDialogController(api, $mdDialog, msg, OrderId)
    {
        var vm = this;
        _init();

        /// Methods
        vm.close = close;
        ////

        function _init(){
            vm.id = OrderId;
            api.invoices.orders.get({
                id : OrderId
            }, function(response){
                vm.order = response;
            });
        }        

        function close(){
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices.orders')
        .controller('InvoicesOrderDialogMessagesController', invoicesOrderDialogMessagesController);

    /** @ngInject */
    function invoicesOrderDialogMessagesController($mdDialog, Messages)
    {
        var vm = this;
        _init();

        /// Methods
        vm.close = close;
        ////

        function _init(){
            vm.messages = Messages;
            vm.partners = [];
            angular.forEach(vm.messages, function(m) {
                if (vm.partners.filter(function(p) { return p.id == m.partnerId }).length == 0)
                    vm.partners.push({ id: m.partnerId, completeName: m.partner.completeName, isFamily: m.partner.isFamily });
            });
        }   

        function close(){
            $mdDialog.hide();
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.invoices.orders")
    .controller(
      "InvoicesOrdersInvoiceDialogController",
      invoicesOrdersInvoiceDialogController
    );

  /** @ngInject */
  function invoicesOrdersInvoiceDialogController(
    $mdDialog,
    msg,
    Callback,
    Invoice,
    api,
    $state
  ) {
    var vm = this;

    init();

    // Methods
    vm.accept = accept;
    vm.close = close;
    vm.zipCodeChange = zipCodeChange;
    vm.targetZipCodeChange = targetZipCodeChange;
    vm.usesCFDI = usesCFDI;

    ////////

    function init() {
      vm.title = "GENERAR FACTURA";
      vm.invoice = Invoice;
      vm.callback = Callback;
      vm.expeditionDateString = new moment(vm.invoice.expeditionDate).format(
        "DD/MM/YYYY HH:mm"
      );

      // View
      if ((vm.viewMode = vm.invoice.id != 0)) {
        vm.title = "DATOS DE FACTURA No " + vm.invoice.id;
        if (vm.invoice.orderFolio)
          vm.title =
            vm.title + " (Folio de orden: " + vm.invoice.orderFolio + ")";
      }

      if (vm.invoice.satZipcode) {
        vm.zipCode = vm.invoice.satZipcode.code;
        zipCodeChange();
      }

      if (vm.invoice.targetSatZipcode) {
        vm.targetSatZipcode = vm.invoice.targetSatZipcode.code;
        targetZipCodeChange();
      }

      // Sat Catalogs
      vm.satInvoiceTypes = api.sat.invoiceTypes.query();
      vm.satCoins = api.sat.coins.query();
      vm.satPayments = api.sat.payments.query();
      vm.satPaymentMethods = api.sat.paymentMethods.query();
      vm.satCfdiUses = api.sat.cfdiUses.query();
      vm.satRegimenFiscales = api.sat.regimenFiscales.query();
      vm.satCfdiUsesRegimenFiscal =
        api.catalogs.satCfdiUsesRegimenFiscal.query();
    }

    vm.sending = false;
    function accept() {
      if (confirm("Esta seguro que desea generar la factura?")) {
        vm.sending = true;
        api.invoices.invoices.save(
          vm.invoice,
          function (response) {
            msg.success("Factura generada correctamente");
            vm.sending = false;
            if (vm.callback) vm.callback(response);
            close();
            $state.go("app.invoices.receipt", { id: response.id });
          },
          function (error) {
            vm.sending = false;
          }
        );
      }
    }

    function close() {
      $mdDialog.hide();
    }

    function zipCodeChange() {
      vm.validatingZipCode = true;
      vm.invoice.satZipcode = null;
      vm.invoice.satZipcodeId = 0;
      api.sat.zipCodes.get(
        { zipcode: vm.zipCode },
        function (response) {
          if (response.id) {
            vm.invoice.satZipcode = response;
            vm.invoice.satZipcodeId = response.id;
          }
          vm.validatingZipCode = false;
        },
        function (response) {
          vm.validatingZipCode = false;
        }
      );
    }

    function targetZipCodeChange() {
      vm.validatingTargetZipCode = true;
      vm.invoice.targetSatZipcode = null;
      vm.invoice.targetSatZipcodeId = 0;
      api.sat.zipCodes.get(
        { zipcode: vm.targetSatZipcode },
        function (response) {
          if (response.id) {
            vm.invoice.targetSatZipcode = response;
            vm.invoice.targetSatZipcodeId = response.id;
          }
          vm.validatingTargetZipCode = false;
        },
        function (response) {
          vm.validatingTargetZipCode = false;
        }
      );
    }

    function usesCFDI(satRegimenFiscalId) {
      api.catalogs.satCfdiUsesRegimenFiscal.get(
        {
          id: satRegimenFiscalId,
        },
        function (response) {
          if (response.length == 0) {
            msg.error(
              "No hay Usos de CFDI existentes para este Regimen Fiscal"
            );
            vm.satCfdiUses = [];
          } else {
            vm.satCfdiUses = response;
          }
        },
        function (response) {
          // if (response.length == 0) {
          //   msg.error(
          //     "No hay Usos de CFDI existentes para este Regimen Fiscal"
          //   );
          //   vm.usesCFDI = [];
          // } else {
          //   vm.usesCFDI = response;
          // }
        }
      );
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.invoices.orders")
    .controller(
      "InvoicesOrdersCancelDialogController",
      invoicesOrdersCancelDialogController
    );

  /** @ngInject */
  function invoicesOrdersCancelDialogController(
    $mdDialog,
    msg,
    Callback,
    InvoiceId,
    api,
    $state
  ) {
    var vm = this;

    init();

    // Methods
    vm.accept = accept;
    vm.close = close;
    // vm.zipCodeChange = zipCodeChange;
    ////////

    function init() {
      vm.title = "CANCELAR FACTURA";
      vm.catInvoiceCancellationReason = "";
      vm.invoiceId = InvoiceId;
      vm.callback = Callback;
      vm.paymentConditions = "";
      // vm.expeditionDateString = new moment(vm.invoice.expeditionDate).format(
      //   "DD/MM/YYYY HH:mm"
      // );

      // View
      // if ((vm.viewMode = vm.invoice.id != 0)) {
      //   vm.title = "DATOS DE FACTURA No " + vm.invoice.id;
      //   if (vm.invoice.orderFolio)
      //     vm.title =
      //       vm.title + " (Folio de orden: " + vm.invoice.orderFolio + ")";
      // }

      // if (vm.invoice.satZipcode) {
      //   vm.zipCode = vm.invoice.satZipcode.code;
      //   zipCodeChange();
      // }

      // Sat Catalogs
      // vm.satInvoiceTypes = api.sat.invoiceTypes.query();
      // vm.satCoins = api.sat.coins.query();
      // vm.satPayments = api.sat.payments.query();
      // vm.satPaymentMethods = api.sat.paymentMethods.query();
      // vm.satCfdiUses = api.sat.cfdiUses.query();
      vm.catInvoiceCancellationReasons =
        api.sat.catInvoiceCancellationReasons.query();
    }

    vm.sending = false;
    function accept() {
      msg.confirm(
        "Estas seguro que deseas cancelar la factura, no se podran deshacer los cambios?",
        function () {
          api.invoices.invoices.delete(
            {
              id: vm.invoiceId,
              invoiceCancellationReasonId: vm.catInvoiceCancellationReason.id,
              UuidReference: vm.paymentConditions + "A",
            },
            function (response) {
              msg.success("Factura cancelada correctamente.");
              // getData();
              vm.sending = false;
              if (vm.callback) vm.callback(response);
              close();
              $state.go("app.invoices.receipt", { id: response.id });
            }
          );
        }
      );
    }

    function close() {
      $mdDialog.hide();
    }

    // function zipCodeChange() {
    //   vm.validatingZipCode = true;
    //   vm.invoice.satZipcode = null;
    //   vm.invoice.satZipcodeId = 0;
    //   api.sat.zipCodes.get(
    //     { zipcode: vm.zipCode },
    //     function (response) {
    //       if (response.id) {
    //         vm.invoice.satZipcode = response;
    //         vm.invoice.satZipcodeId = response.id;
    //       }
    //       vm.validatingZipCode = false;
    //     },
    //     function (response) {
    //       vm.validatingZipCode = false;
    //     }
    //   );
    // }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices.orders')
        .controller('InvoicesOrderDialogProductController', controllerFunction);

    /** @ngInject */
    function controllerFunction($mdDialog, api, msg, Callback, CONST_DATATABLES)
    {
        var vm = this;
        _init();

        // Methods
        vm.closeDialog = closeDialog;
        vm.select = select;
        vm.setSelected = setSelected;
        vm.accept = accept;
        ////////

        function _init(){
            api.inventory.products.query(function(response){
                vm.inventory = response.filter(function(i) { return i.quantity > 0 || !i.product.isStockRequired  });
            });
        }

        function closeDialog(){
            $mdDialog.hide();
        }

        function select(item)
        {
            Callback(item);
            closeDialog();
        }

        function setSelected(item)
        {
            vm.selected = item;
        }

        function accept(){
            select(vm.selected);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices.orders')
        .controller('InvoicesOrderDialogTurnsController', controllerFunction);

    /** @ngInject */
    function controllerFunction($mdDialog, api, msg, Callback, CONST_DATATABLES)
    {
        var vm = this;
        _init();

        // Methods
        vm.closeDialog = closeDialog;
        vm.closeTurn = closeTurn;
        vm.openTurn = openTurn;
        vm.getTurns = getTurns;
        ////////

        function _init(){
            var from = moment().add(-1, 'days');
            var to = moment();            
            
            vm.from = from.format('MM/DD/YYYY');
            vm.to = to.format('MM/DD/YYYY');

            getTurns();

            vm.dtInstance = {};
            vm.dtOptions = angular.copy(angular.extend(CONST_DATATABLES.OPTIONS,{
                filter: true,
                pageLength  : 8,
            }));

            vm.filterOpenOptions = [
                { text: 'Todos', value: '' },
                { text: 'Solo Abiertos', value: true },
                { text: 'Solo Cerrados', value: false },
            ];
            vm.isOpen = '';
        }

        function getTurns(){
            api.invoices.turns.get({
                dateIni: moment(vm.from).format("DD-MM-YYYY"), 
                dateEnd: moment(vm.to).format("DD-MM-YYYY")
            },function(response){
                vm.turns = response;
            });
        }

        function closeDialog(){
            $mdDialog.hide();
        }        

        function closeTurn(turn){
            if (confirm("Estas seguro que deseas cerrar el turno " + turn.id + "?")){
                turn.isOpen = false;
                api.invoices.turns.save(turn, function(response){
                    getTurns();
                    msg.success("Turno cerrado");
                });
            }
        }

        function openTurn(){
            if (confirm("Se abrira un nuevo turno, desea continuar?")){
                api.invoices.turns.save({
                    id: 0
                }, function(response){
                    msg.success("Turno creado correctamente.");
                    Callback(response);
                    closeDialog();
                });
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices.orders')
        .controller('InvoicesOrderDiscountDialogController', controllerFunction);

    /** @ngInject */
    function controllerFunction($mdDialog, msg, ApplyDiscount, Product)
    {
        var vm = this;

        vm.applyDiscount = ApplyDiscount;
        vm.product = Product;
        
        // Data
        init();

        // Methods
        vm.discountAccept = discountAccept;            
        vm.cancel = cancel;
        ////////

        function init(){
            vm.discount = {
                type: 2,
                ammount: 0
            };

            vm.discountTypes = [
                { id: 1, name: "Monto" },
                { id: 2, name: "Porcentaje" },
            ]; 
        }

        function discountAccept(){  
            vm.applyDiscount(vm.product, vm.discount);
            cancel();
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices.orders')
        .controller('InvoicesOrderDialogEditController', invoicesInvoiceDialogEditController);

    /** @ngInject */
    function invoicesInvoiceDialogEditController($mdDialog, msg, Callback, Detail)
    {
        var vm = this;

        init();

        // Methods
        vm.accept = accept;            
        vm.cancel = cancel;
        ////////

        function init(){
            vm.callback = Callback;
            vm.detail = angular.copy(Detail);
        }

        function accept(){  
            vm.detail.subtotal = vm.detail.price * vm.detail.quantity;
            vm.detail.total = (vm.detail.price * vm.detail.quantity) + vm.detail.interest - vm.detail.discountAmmount;
            vm.callback(Detail, vm.detail);
            cancel();
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.dues', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.dues', {
                url      : '/dues',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/dues/dues/dues.html',
                        controller : 'CatalogsDuesController as vm'
                    }
                },
                resolve  : {
                    Dues: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.dues@query');
                    }
                }
            })
            .state('app.catalogs.dues.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/dues/due/due.html',
                        controller : 'CatalogsDueController as vm'
                    }
                },
                resolve  : {
                    Due: function (){ 
                        return { id: 0, periodicityId: 0, isTitular: true, name: '', prices: [], active: true, minAge: 0, maxAge: 150, familiarMinNumber: 0, familiarMaxNumber: 150, partnerTypeId: null }
                    },
                    Periodicities: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.periodicities@query');
                    },
                    PartnerTypes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.partnerTypes@query');
                    },
                    Accounts: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.accounts@query');
                    }
                }
            })
            .state('app.catalogs.dues.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/dues/due/due.html',
                        controller : 'CatalogsDueController as vm'
                    }
                },
                resolve  : {
                    Due: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('catalogs.dues@get', { id : $stateParams.id });
                    },
                    Periodicities: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.periodicities@query');
                    },
                    PartnerTypes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.partnerTypes@query');
                    },
                    Accounts: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.accounts@query');
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.dues', {
            title: 'Cuotas',
            state: 'app.catalogs.dues'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.dues')
        .controller('CatalogsDuePricesDialogController', CatalogsDuePricesDialogController);

    /** @ngInject */
    function CatalogsDuePricesDialogController($mdDialog, PriceGroupId, DueId, api, msg, Callback, settingsService)
    {
        var vm = this;

        _init();

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;
        //////////

        function _init(){
            vm.callback = Callback;
            api.catalogs.periodicities.query(function(response){
                vm.periodicities = response;
            
                if (!PriceGroupId || PriceGroupId == 0)
                {
                    vm.priceHeader = {
                        id              : 0,
                        validFrom       : new Date(),
                        dueId           : DueId,
                        interes         : settingsService.interes,
                        daysOfGrace     : settingsService.daysOfGrace
                    };

                    vm.newPrices = [];
                    angular.forEach(vm.periodicities, function(p){
                        vm.newPrices.push({
                            periodicity: angular.copy(p),
                            price      :  null,
                            pricePerClass: 0
                        });
                    });
                }else{
                    // GEt Prices by PriceGroupId
                    api.catalogs.duePrices.get({ 
                        dueId       : DueId, 
                        searchType  : 1,
                        searchId    : PriceGroupId 
                    }, function(prices){
                        if (prices && prices.length > 0){
                            var header = prices[0];
                            vm.priceHeader = {
                                validFrom   : moment(header.validFrom).toDate(),
                                interes     : header.interes,
                                daysOfGrace : header.daysOfGrace
                            };
                            vm.newPrices = [];
                            vm.newPrices = prices;
                            vm.validFrom = vm.priceHeader.validFrom;
                        }
                    });
                }            
            });
        }

        function save(){
            vm.priceHeader.validFrom = moment(vm.priceHeader.validFrom).format("MM-DD-YYYY");
            var prices = [];
            angular.forEach(vm.newPrices, function(price){        
                price.periodicityId = price.periodicity.id;        
                prices.push(angular.copy(angular.extend(price, vm.priceHeader)));
            });          
            
            api.catalogs.duePrices.save(prices, function(response){
                msg.success("Precios Agregado correctamente");
                vm.callback();
                closeDialog();
            });
        }

        function closeDialog(){
            $mdDialog.hide();
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.rentableZones', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.rentableZones', {
                url      : '/rentableZones',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/rentable-zones/rentable-zones/rentable-zones.html',
                        controller : 'CatalogsRentableZonesController as vm'
                    }
                },
                resolve  : {
                    RentableZones: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.rentableZones@query');
                    }
                }
            })
            .state('app.catalogs.rentableZones.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/rentable-zones/rentable-zone/rentable-zone.html',
                        controller : 'CatalogsRentableZoneController as vm'
                    }
                },
                resolve  : {
                    RentableZone: function (){ 
                        return { id: 0, name: '', active: true, matrixRows: 0, matrixColumns: 0 }
                    },
                }
            })
            .state('app.catalogs.rentableZones.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/rentable-zones/rentable-zone/rentable-zone.html',
                        controller : 'CatalogsRentableZoneController as vm'
                    }
                },
                resolve  : {
                    RentableZone: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('catalogs.rentableZones@get', { id : $stateParams.id });
                    },
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.rentableZones', {
            title: 'Rentables',
            state: 'app.catalogs.rentableZones'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.rentableZones')
        .controller('CatalogsRentableZonesPricesDialogController', CatalogsRentableZonesPricesDialogController);

    /** @ngInject */
    function CatalogsRentableZonesPricesDialogController($mdDialog, PriceGroupId, RentableZoneId, api, msg, Callback, settingsService)
    {
        var vm = this;

        _init();

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;
        //////////

        function _init(){
            vm.callback = Callback;
            api.catalogs.periodicities.query(function(response){
                vm.periodicities = response;
            
                if (!PriceGroupId || PriceGroupId == 0)
                {
                    vm.priceHeader = {
                        id              : 0,
                        validFrom       : new Date(),
                        rentableZoneId  : RentableZoneId,
                        interes         : settingsService.interes,
                        daysOfGrace     : settingsService.daysOfGrace
                    };

                    vm.newPrices = [];
                    angular.forEach(vm.periodicities, function(p){
                        vm.newPrices.push({
                            periodicityId: p.id,
                            periodicity: angular.copy(p),
                            price      :  null,
                            pricePerDay: 0
                        });
                    });
                }else{
                    // GEt Prices by PriceGroupId
                    api.catalogs.rentableZonePrices.get({ 
                        rentableZoneId: RentableZoneId, 
                        groupId: PriceGroupId 
                    }, function(response){
                        if (response && response.length > 0){
                            var header = response[0];
                            vm.priceHeader = {
                                validFrom   : moment(header.validFrom).toDate(),
                                interes     : header.interes,
                                daysOfGrace : header.daysOfGrace
                            };
                            vm.newPrices = [];
                            vm.newPrices = response;
                            vm.validFrom = vm.priceHeader.validFrom;
                        }
                    });
                }            
            });
        }

        function save(){
            vm.priceHeader.validFrom = moment(vm.priceHeader.validFrom).format("MM-DD-YYYY");
            var prices = [];
            angular.forEach(vm.newPrices, function(price){        
                price.periodicityId = price.periodicity.id;        
                prices.push(angular.copy(angular.extend(price, vm.priceHeader)));
            });          
            
            api.catalogs.rentableZonePrices.save(prices, function(response){
                msg.success("Precios Agregado correctamente");
                vm.callback();
                closeDialog();
            });
        }

        function closeDialog(){
            $mdDialog.hide();
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.partners.prospects', [ 
            'ui.calendar'            
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.partners.prospects', {
                url      : '/prospects',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/prospects/prospects.html',
                        controller : 'PartnersProspectsController as vm'
                    }
                },
                resolve  : {
                    Prospects: function (apiResolver)
                    {
                        return apiResolver.resolve('partners.prospects@query');
                    }
                }
            })
            .state('app.partners.prospects.calendar', {
                url      : '/calendar',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/prospectCalendar/prospectCalendar.html',
                        controller : 'PartnersProspectCalendarController as vm'
                    }
                },
                resolve  : {
                    Seller: function ()
                    {
                        return { id: 0 }
                    },
                    Prospect: function ()
                    {
                        return { id: 0 }
                    }
                }
            })
            .state('app.partners.prospects.calendar.employee', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/prospectCalendar/prospectCalendar.html',
                        controller : 'PartnersProspectCalendarController as vm'
                    }
                },
                resolve  : {
                    Seller: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('catalogs.employees@get', { id : $stateParams.id });
                    },
                    Prospect: function ()
                    {
                        return {id: 0 };
                    }
                },
            })
            .state('app.partners.prospects.calendar.employee-prospect', {
                url      : '/:id/:prospectId',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/partners/views/prospectCalendar/prospectCalendar.html',
                        controller : 'PartnersProspectCalendarController as vm'
                    }
                },
                resolve  : {
                    Seller: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('catalogs.employees@get', { id : $stateParams.id });
                    },
                    Prospect: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('partners.prospects@get', { id : $stateParams.prospectId });
                    }
                },
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.partners.prospects', {
            title: 'Prospectos',
            shortcuticon  : 'icon-account-multiple-outline',
            state: 'app.partners.prospects'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.prospects')
        .controller('PartnersProspectsProspectDialogController', partnersProspectsProspectDialogController);

    /** @ngInject */
    function partnersProspectsProspectDialogController($mdDialog, msg, Callback, Prospect, api, authService)
    {
        var vm = this;

        init();

        // Methods
        vm.accept = accept;            
        vm.close = close;
        ////////

        function init(){
            vm.title = "Agregar prospecto";
            vm.prospect = Prospect;
            vm.callback = Callback;

            // View            
            if (vm.prospect){
                if (vm.prospect.isSignedUp)
                    vm.title = "Ver Prospecto";                
                else
                    vm.title = "Editar Prospecto";
            }else{
                vm.prospect = {
                    id: 0
                };
            }

            var appData = authService.getAppData();             
            api.catalogs.employees.query(function(response){
                vm.sellers = response.filter(function(e){ return e.employeeTypeId == 1 /*Seller*/ ;})                
                if (!appData.user.userType.isShowAllProspects){
                    vm.sellers = vm.sellers.filter(function(e){ return e.userId && e.userId == appData.user.id });
                }
            });
            vm.media = api.catalogs.media.query();
        }

        vm.sending = false;
        function accept(){  
            vm.sending = true;
            api.partners.prospects.save(vm.prospect, function(response){                    
                msg.success("Prospecto guardado correctamente");
                vm.sending = false;                    
                vm.callback();
                close();
            }, function(error){
                vm.sending = false;
            });
        }

        function close(){
            $mdDialog.hide();
        }
    }
})();
(function(){
    
    'use strict';
    
    angular
        .module('app.partners')
        .controller('PartnersProspectCalendarEventController', partnerProspectCallendarEventController);

    /** @ngInject */
    function partnerProspectCallendarEventController($mdDialog, api, msg, DialogData, Seller, Prospects, Prospect)
    {
        var vm = this;
        
        // Data
        vm.dialogData = DialogData;
        vm.selectedSeller = Seller;

        // Methods
        vm.saveEvent = saveEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init(){
            vm.calendars = [];
            vm.prospects = Prospects;

            
            // Da por echo que las fechas son "moment"  
            vm.calendarEvent = angular.extend({}, vm.dialogData.calendarEvent, {
                id       : vm.dialogData.calendarEvent ? vm.dialogData.calendarEvent.id : 0, 
                start    : new Date(vm.dialogData.start.format("MM/DD/YYYY HH:mm:ss")),
                end      : new Date(vm.dialogData.end.format("MM/DD/YYYY HH:mm:ss")),
                startTime: vm.dialogData.start.format("HH:mm"),
                endTime  : vm.dialogData.end.format("HH:mm"),
            });            
            
            switch (vm.dialogData.type){
                case "add":
                    vm.dialogTitle = 'Agregar nueva cita';
                    vm.calendarEvent.prospect = Prospect;
                break;
                case "edit":
                    vm.dialogTitle = 'Editar cita: ' + vm.dialogData.calendarEvent.title;
                    vm.selectedSeller = vm.dialogData.calendarEvent.employee;
                    vm.calendarEvent.prospect = vm.prospects.filter(function(p){ return p.id == vm.dialogData.calendarEvent.prospectId })[0];
                break;
            }

        }

        /**
         * Save the event
         */
        function saveEvent(){ 
            api.catalogs.employeeCalendarEvents.save({
                id          : vm.calendarEvent.id,
                employeeId  : vm.selectedSeller.id,
                prospectId  : vm.calendarEvent.prospect.id,
                title       : vm.calendarEvent.prospect.completeName,
                start       : moment (moment(vm.calendarEvent.start).format("YYYY-MM-DD") + " " + vm.calendarEvent.startTime, "YYYY-MM-DD hhmm").format('MM-DD-YYYY HH:mm'),
                end         : moment (moment(vm.calendarEvent.end).format("YYYY-MM-DD") + " " + vm.calendarEvent.endTime, "YYYY-MM-DD hhmm").format('MM-DD-YYYY HH:mm'),
                notes       : vm.calendarEvent.notes,
                visible     : true,
                insertDate  : vm.calendarEvent.insertDate,
                insertUserId: vm.calendarEvent.insertUserId
            }, function(response){     
                msg.success("Cita guardada correctamente.");
                $mdDialog.hide(response);
            });
        }

        /**
         * Close the dialog
         */
        function closeDialog(){
            $mdDialog.hide();
        }
    }

})();


(function () {
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnerKardexController', partnersPartnerKardexController);

    /** @ngInject */
    function partnersPartnerKardexController(api, $scope, authService, Partner) {
        var vm = this;

        _init();

        function _init() {
            vm.appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + vm.appData.settings.logoFile;
            vm.parentScope = $scope.$parent.$parent.vm;
            vm.partner = Partner;
            vm.date = new Date();
            if (vm.partner.partnerAutomaticPayment == null) {
                vm.partner.domiciliado = "No";
            }
            else {
                vm.partner.domiciliado = "Si";
                vm.partner.MontoDomiciliado = vm.partner.partnerAutomaticPayment.ammount;
                vm.partner.FechaExpiracion = vm.partner.partnerAutomaticPayment.expirationDate;
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnerContractController', partnersPartnerContractController);

    /** @ngInject */ 
    function partnersPartnerContractController($mdDialog, Contract, msg, authService, api)
    {
        var vm = this;

        //// Methods
        vm.showSignature = showSignature;
        vm.save = save;
        vm.sendByEmail = sendByEmail;
        vm.getLastData = getLastData;
        vm.settings = authService.getAppData().settings;
        vm.logoSource = "data:image/jpeg;base64, " + vm.settings.logoBase64String;
        vm.calculateAge = calculateAge;
        ////////////

        _init();

        function _init(){
            vm.data = Contract;
            if (vm.data.signatureBase64 && vm.data.signatureBase64 != '')
                vm.signatureSrc = "data:image/png;base64, " + vm.data.signatureBase64;
            vm.sendingEmail = false;
        }
        
        function save(){
            api.partners.contracts.save(vm.data, function(response){
              vm.data.id = response.id;
              vm.data.insertDate = response.insertDate; 
              msg.success("Contrato guardado correctamente");              
            });
        }

        function showSignature(ev){
            var controllerName = vm.settings.useSignatureMouse 
                ? 'PartnersPartnerDialogSignatureMouseController' 
                : 'PartnersPartnerDialogSignatureController';
            var templateUrl = vm.settings.useSignatureMouse 
                ? 'app/main/partners/views/partners/partner/dialogs/dialog-signature-mouse/dialog-signature-mouse.html'
                : 'app/main/partners/views/partners/partner/dialogs/dialog-signature/dialog-signature.html';

            $mdDialog.show({
                controller         : controllerName,
                controllerAs       : 'vm',
                templateUrl        : templateUrl,
                targetEvent        : ev,
                escapeToClose      : false,
                clickOutsideToClose: false,
                locals             : {
                    Callback : showSignatureCallback
                }
            });            
        } 

        function showSignatureCallback(base64Sign){
            vm.data.signatureBase64 = base64Sign;
            vm.signatureSrc = "data:image/png;base64, " + base64Sign;
            save();
        }

        function sendByEmail(){
            msg.prompt("Correo Electrónico", "Ingrese correo electrónico", function(email){
                if (!email || email == ''){
                    msg.error("Correo electrónico inválido. verifique");
                    return;
                }

                vm.sendingEmail = true;
                api.partners.emails.save({
                    type : 1,
                    entityId: vm.data.partnerId,
                    emails: email
                }, function(_){
                    msg.success("Se ha enviado el correo electronico correctamente!");
                    vm.sendingEmail = false;
                }, function(_){
                    vm.sendingEmail = false;
                });

            }, null, null, vm.data.email);
        }

        function getLastData(){
            msg.confirm("Esta seguro que quieres sobreescribir los datos del contrato?", function(){
                api.partners.contracts.getContract({
                    id: vm.data.partnerId,
                    isLastData : true
                }, function(response){
                    vm.data = response;
                });
            });
        }

        function calculateAge(birthDate) {
            var today = new Date();
            var birth = new Date(birthDate);

            var age = today.getFullYear() - birth.getFullYear();
            var month = today.getMonth() - birth.getMonth();

            if (month < 0 || (month === 0 && today.getDate() < birth.getDate())) {
                age--;
            }

            return age;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnersInfoPassPrintController', partnersPartnersInfoPassPrintController);

    /** @ngInject */
    function partnersPartnersInfoPassPrintController($scope, api, Item, authService, msg)
    {
        var vm = this;
        
        vm.item = Item;
        vm.imageSaving = true;
        vm.emailSending = false;
        
        // Logo Image by URL
        vm.picturesUrl = api.baseUrl.replace("api/","");
        vm.settings = authService.getAppData().settings;
        // vm.logoUrl = vm.picturesUrl + vm.settings.logoFile;

        // Logo Image by Base64
        vm.logoSource = "data:image/jpeg;base64, " + vm.settings.logoBase64String;
        
        // Generate BarCode
        JsBarcode("#barcode", vm.item.pass.number, {
            displayValue: true
        });

        $scope.$on('$viewContentLoaded', function() {
            // Send to Api for Save in PDF
            vm.imageSaving = true;            
            setTimeout(sendToApi, 1500);
        });


        // Save PDF
        vm.pdfDownload = function(){
            html2canvas(document.getElementById("pass-card")).then(function(canvas){
                var data = canvas.toDataURL();
                var docDefinition = {
                    content: [{
                        image: data,
                        width: 500,
                    }]
                };
                vm.tst = "data:image/jpeg;base64, " + data;
                // pdfMake.createPdf(docDefinition).download(vm.item.pass.number + ".pdf");   
            });
        }

        vm.sendMail = function(){
            msg.prompt("Correo Electronico", "Ingrese correo electronico", function(email){
                if (!email || email == ''){
                    msg.error("Correo electronico inválido. verifique");
                    return;
                }
                vm.emailSending = true;
                api.partners.passesFiles.sendMail({
                    partnerPassId: vm.item.id,
                    email: email
                }, function(response){
                    msg.success("Correo Electronico enviado correctamente.");
                    vm.emailSending = false;
                }, function(errorResponse){
                    vm.emailSending = false;
                });

            }, null, null, vm.item.email);
        }

        function sendToApi(){
            vm.imageSaving = true;
            html2canvas(document.querySelector("#pass-card")).then(function(canvas){
                var data = canvas.toDataURL();

                // Send to API Service
                api.partners.passesFiles.save({
                    passId       : vm.item.id,                
                    base64String : data
                }, function(response){
                    console.log("PDF Guardado correctamente");
                    vm.imageSaving = false;
                });
            });
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.partners.partners")
    .controller(
      "PartnersPartnerCredentialController",
      partnersPartnerCredentialController
    );

  /** @ngInject */
  function partnersPartnerCredentialController(
    $scope,
    api,
    Partner,
    authService,
    msg
  ) {
    var vm = this;
    vm.partner = Partner;

    var qrcode = new QRCode(document.getElementById("qrcode"));
    qrcode.makeCode("" + vm.partner.credentialCode);

    // Logo Image by URL
    vm.picturesUrl = api.baseUrl.replace("api/", "");
    vm.appData = authService.getAppData();
    vm.logoSource =
      "data:image/jpeg;base64, " + vm.appData.settings.logoBase64String;

    vm.sendMail = function () {
      msg.prompt(
        "Correo Electronico",
        "Ingrese correo electronico",
        function (email) {
          if (!email || email == "") {
            msg.error("Correo electronico inválido. verifique");
            return;
          }
          vm.emailSending = true;
          api.partners.credentialFiles.sendMail(
            {
              PartnerCredentialId: vm.partner.id,
              email: email,
              QR: document.getElementById("qrcode").outerHTML,
            },
            function (response) {
              msg.success("Correo Electronico enviado correctamente.");
              vm.emailSending = false;
            },
            function (errorResponse) {
              vm.emailSending = false;
            }
          );
        },
        null,
        null,
        vm.partner.email
      );
    };
  }
})();

/* eslint-disable comma-dangle */
(function () {
  "use strict";

  angular
    .module(
      "app.reports", 
      [
        "datatables", 
        "chart.js"
      ]
    ).config(config);  

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state("app.reports", {
        abstract: true,
        url: "/reports",
      })
      .state("app.reports.reports", {
        url: "/selector",
        views: {
          "content@app": {
            templateUrl: "app/main/reports/views/selector/selector.html",
            controller: "ReportsSelectorController as vm",
          },
        },
        resolve: {
          ReportGroups: function (apiResolver) {
            return apiResolver.resolve("reports.groups@query");
          },
          Branches: function (apiResolver) {
            return apiResolver.resolve("catalogs.branches@query");
          },
          Users: function (apiResolver) {
            return apiResolver.resolve("security.users@query");
          },
        },
      })
      .state("app.reports.dashboard", {
        url: "/dashboard",
        views: {
          "content@app": {
            templateUrl: "app/main/reports/views/dashboard/dashboard.html",
            controller: "ReportsDashboardController as vm"
          }
        }
      })      
      .state("app.reports.tst", {
        url: "/tst",
        views: {
          "content@app": {
            templateUrl: "app/main/reports/views/tst/tst.html",
            controller: "ReportsTstController as vm",
          },
        },
      })
      .state("app.reports.cortecobranza-desglosado", {
        url: "/corteCobranzaDesglosado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-cobranza/layout-desglosado.html",
            controller: "ReportsCortesCajaCorteCobranzaController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.cortecobranza-consolidado", {
        url: "/corteCobranzaConsolidado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-cobranza/layout-consolidado.html",
            // templateUrl: 'app/main/invoices/views/orders/receipt/receipt.html',
            controller: "ReportsCortesCajaCorteCobranzaController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-altas", {
        url: "/sociosAltas",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/altas/layout.html",
            controller: "ReportsSociosaltasController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.corteformapago-desglosado", {
        url: "/corteFormaPagoDesglosado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-forma-pago/layout-desglosado.html",
            controller: "ReportsCortesCajaCorteFormaPagoController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.ingresos-otros", {
        url: "/corteOtrosIngresosDesglosado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/ingresos/otros/layout.html",
            controller: "ReportsOtrosIngresosController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.corteformapago-consolidado", {
        url: "/corteFormaPagoConsolidado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-forma-pago/layout-consolidado.html",
            controller: "ReportsCortesCajaCorteFormaPagoController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.corteproducts-desglosado", {
        url: "/corteProductsDesglosado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-products/layout-desglosado.html",
            controller: "ReportsCortesCajaCorteProductsController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.corteproducts-consolidado", {
        url: "/corteProductsConsolidado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-products/layout-consolidado.html",
            controller: "ReportsCortesCajaCorteProductsController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.cortedue-desglosado", {
        url: "/corteDueDesglosado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-due/layout-desglosado.html",
            controller: "ReportsCortesCajaCorteDueController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.cortedue-consolidado", {
        url: "/corteDueConsolidado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-due/layout-consolidado.html",
            controller: "ReportsCortesCajaCorteDueController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.ingresosgenerales-desglosado", {
        url: "/ingresosGeneralesDesglosado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/ingresos/general/layout-desglosado.html",
            controller: "ReportsCortesCajaIngresosGeneralesController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.ingresosgenerales-consolidado", {
        url: "/ingresosGeneralesConsolidado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/ingresos/general/layout-consolidado.html",
            controller: "ReportsCortesCajaIngresosGeneralesController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-vigentes", {
        url: "/sociosVigentes",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/vigentes/layout.html",
            controller: "ReportsSociosVigentesController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-status", {
        url: "/sociosStatus",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/status/layout.html",
            controller: "ReportsSociosStatusController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-activos", {
        url: "/sociosActivos",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/activos/layout.html",
            controller: "ReportsSociosActivosController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-inactivos", {
        url: "/sociosInactivos",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/inactivos/layout.html",
            controller: "ReportsSociosInactivosController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-cupo", {
        url: "/sociosCupo",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/cupo/layout.html",
            controller: "ReportsSociosCupoController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-rangoedad-consolidado", {
        url: "/sociosAgesRangeConsolidado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/agesRange/layout-consolidado.html",
            controller: "ReportsSociosAgeRangesController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-rangoedad-desglosado", {
        url: "/sociosAgesRangeDesglosado",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/agesRange/layout-desglosado.html",
            controller: "ReportsSociosAgeRangesController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-general", {
        url: "/sociosGeneral",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/general/layout.html",
            controller: "ReportsSociosGeneralController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-general-pago", {
        url: "/sociosGeneralPago",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/generalPago/layout.html",
            controller: "ReportsSociosGeneralPagoController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-vendedor", {
        url: "/vendedor",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/vendedor/layout.html",
            controller: "ReportsSociosVendedorController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-cargoautomatico", {
        url: "/cargoautomatico",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/cargoautomatico/layout.html",
            controller: "ReportsSociosCargoAutomaticoController as vm",
          }
        },
        bodyClass: "printable"
      })
      .state("app.reports.socios-cargoautomaticobanco", {
        url: "/cargoautomaticobanco",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/cargoautomaticobanco/layout.html",
            controller: "ReportsSociosCargoAutomaticoBancoController as vm",
          }
        },
        bodyClass: "printable"
      })
      .state("app.reports.socios-invoicesorders", {
        url: "/invoicesorders",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/invoicesorders/layout.html",
            controller: "ReportsSociosInvoicesOrdersController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.invoicesorders", {
        url: "/invoicesordersall",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/invoicesordersall/layout.html",
            controller: "ReportsSociosInvoicesOrdersAllController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.exports-general", {
        url: "/Exports",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/exports/general/layout.html",
            controller: "ReportsExportsGeneralController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.exports-general-intelisis", {
        url: "/ExportsIntelisis",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/exports/generalIntelisis/layout.html",
            controller: "ReportsExportsGeneralIntelisisController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.exports-general-intelisis-recibos", {
        url: "/ExportsIntelisisRecip",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/exports/generalIntelisisRecip/layout.html",
            controller: "ReportsExportsGeneralIntelisisReciptController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.prospectos-general", {
        url: "/prospectos",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/prospectos/general/layout.html",
            controller: "ReportsProspectosGeneralController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.notascredito", {
        url: "/notascredito",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-notas-credito/layout.html",
            controller: "ReportsNotasCreditoController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.servicios-rentables", {
        url: "/rentables",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/servicios/rentables/layout.html",
            controller: "ReportsRentablesController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socio-tipo", {
        url: "/socioTipo",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/tipo/layout.html",
            controller: "ReportsSociosTipoController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socio-birthday", {
        url: "/birthday",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/birthdate/layout.html",
            controller: "ReportsSociosBirthdayController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socio-tipoCuota", {
        url: "/TypeDue",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/typeDue/layout.html",
            controller: "ReportsSociosTypeDueController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.corteTPV", {
        url: "/CorteTPV",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-TPV/layout.html",
            controller: "ReportsCorteTPVController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.documentCancel", {
        url: "/documentCancel",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/document-cancel/layout.html",
            controller: "ReportsDocumentCancelController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.convenios", {
        url: "/SocioConvenios",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/convenio/layout.html",
            controller: "ReportsSocioConvenio as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.ausencia", {
        url: "/SocioAusencias",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/ausencia/layout.html",
            controller: "ReportsSocioAusencia as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.socios-between-dates", {
        url: "/sociosBetweenDates",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/between-dates/layout.html",
            controller: "ReportsSociosBetweenDatesController as vm"
          }
        },
        bodyClass: "printable"
      })
      .state("app.reports.socios-byinscription-date", {
        url: "/sociosByInscriptionDate",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/socios/byincscription-date/layout.html",
            controller: "ReportsSociosByInscriptionDateController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.cortecuentacontable", {
        url: "/corteCuentaContable",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-cuenta-contable/layout-desglosado.html",
            controller: "ReportsCortesCajaCorteCuentaContableController as vm",
          },
        },
        bodyClass: "printable",
      })
      .state("app.reports.invoices", {
        url: "/corteFacturas",
        views: {
          "content@app": {
            templateUrl:
              "app/main/reports/views/reports/cortes-caja/corte-facturas/layout.html",
            controller: "ReportsCortesCajaInvoicesController as vm",
          },
        },
        bodyClass: "printable",
      })
      ;

    // Navigation
    msNavigationServiceProvider.saveItem("apps", {
      title: "",
      group: true,
      weight: 1,
    });

    msNavigationServiceProvider.saveItem("apps.reports", {
      title: "Reportes",
      icon: "icon-file-document",
      weight: 3,
    });

    msNavigationServiceProvider.saveItem("apps.reports.reports", {
      title: "Selector de reportes",
      state: "app.reports.reports",
    });
    
    msNavigationServiceProvider.saveItem("apps.reports.dashboard", {
      title: "Dashboard",
      state: "app.reports.dashboard"
    });
  }
})();

    (function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsSociosVigentesController', reportsSociosVigentesController);
    
    /** @ngInject */
    function reportsSociosVigentesController(reportsService, api, authService, $filter)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.dueGroups = vm.reportData.data.groupBy('dueName');         
            angular.forEach(vm.dueGroups , function(dueGroup){
                dueGroup.periodicityGroups = dueGroup.items.groupBy('periodicityName');                         
            });
            
            // Get Summary
            // Summary
            vm.summary = [];
            angular.forEach(vm.dueGroups, function(dg){
                angular.forEach(dg.periodicityGroups, function(pg){
                    var count = pg.items.length;
                    vm.summary.push({
                        due: dg.key,
                        periodicity: pg.key,
                        count: pg.items.length
                    });
                });
            });
            // Totals Summary
            vm.summary.push({
                due: 'Socios Totales',
                periodicity:  '',
                count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
            });
            
        }        
    }
})();
    (function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsSociosVendedorController', reportsSociosVendedorController);
    
    /** @ngInject */
    function reportsSociosVendedorController(reportsService, api, authService)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            
            vm.branchGroups = vm.reportData.data.groupBy('branchName');         
            
            // Grouping
            angular.forEach(vm.branchGroups , function(branchGroup){
                branchGroup.sellerGroup = branchGroup.items.groupBy('sellerName');                         
            });
            
            // Get Summary
            // Summary
            vm.summary = [];
            angular.forEach(vm.branchGroups, function(bg){
                angular.forEach(bg.sellerGroup, function(sg){
                    vm.summary.push({
                        branch: bg.key,
                        sellerName: sg.key,
                        count: sg.items.length
                    });
                });
            });
            
            // Totals Summary
            vm.summary.push({
                branch: 'Totales',
                ageRange:  '',
                count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
            });        
        }        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosTypeDueController', reportsSociosTypeDueController);

    /** @ngInject */
    function reportsSociosTypeDueController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.group = vm.reportData.data.groupBy('brancheName');
            angular.forEach(vm.group, function (g) {
                g.due = g.items.groupBy('due');
                angular.forEach(g.due, function (due) {
                    due.typePeriodo = due.items.groupBy('typePeriodo');
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosTipoController', reportsSociosTipoController);

    /** @ngInject */
    function reportsSociosTipoController(reportsService, api, authService, $filter) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.groups = vm.reportData.data.groupBy('branchName');
            angular.forEach(vm.groups, function (group) {
                group.tipoCuota = group.items.groupBy('dueName');
                group.masculino = 0;
                group.femenino = 0;
                group.vencido = 0;
                group.vigente = 0;

                group.menVencido = 0;
                group.menVigente = 0;
                group.biVencido = 0;
                group.biVigente = 0;
                group.triVencido = 0;
                group.triVigente = 0;
                group.cuaVencido = 0;
                group.cuaVigente = 0;
                group.semVencido = 0;
                group.semVigente = 0;
                group.anuVencido = 0;
                group.anuVigente = 0;
                group.semanalVencido = 0;
                group.semanalVigente = 0;

                angular.forEach(group.tipoCuota, function (tipoCuota) {
                    tipoCuota.masculino = 0;
                    tipoCuota.femenino = 0;
                    tipoCuota.vencido = 0;
                    tipoCuota.vigente = 0;
                    tipoCuota.menVencido = 0;
                    tipoCuota.menVigente = 0;
                    tipoCuota.biVencido = 0;
                    tipoCuota.biVigente = 0;
                    tipoCuota.triVencido = 0;
                    tipoCuota.triVigente = 0;
                    tipoCuota.cuaVencido = 0;
                    tipoCuota.cuaVigente = 0;
                    tipoCuota.semVencido = 0;
                    tipoCuota.semVigente = 0;
                    tipoCuota.anuVencido = 0;
                    tipoCuota.anuVigente = 0;
                    tipoCuota.semanalVencido = 0;
                    tipoCuota.semanalVigente = 0;

                    tipoCuota.Periodicities = tipoCuota.items.groupBy('periodicitiesName');
                    angular.forEach(tipoCuota.Periodicities, function (Periodicities) {
                        Periodicities.vencido = 0;
                        Periodicities.vigente = 0;
                        angular.forEach(Periodicities.items, function (item) {
                            if (item.genderName == 'Masculino') {
                                tipoCuota.masculino++;
                                group.masculino++;
                            }
                            else {
                                tipoCuota.femenino++;
                                group.femenino++;
                            }
                            if (item.periodicitiesName == 'Semanal') {
                                if (item.vigencia == 'Vigente') {
                                    tipoCuota.semanalVigente++;
                                    group.semanalVigente++;
                                    tipoCuota.vigente++;
                                    group.vigente++;
                                }
                                else {
                                    tipoCuota.semanalVencido++;
                                    group.semanalVencido++;
                                    tipoCuota.vencido++;
                                    group.vencido++;
                                }
                            }
                            if (item.periodicitiesName == 'Mensual') {
                                if (item.vigencia == 'Vigente') {
                                    tipoCuota.menVigente++;
                                    group.menVigente++;
                                    tipoCuota.vigente++;
                                    group.vigente++;
                                }
                                else {
                                    tipoCuota.menVencido++;
                                    group.menVencido++;
                                    tipoCuota.vencido++;
                                    group.vencido++;
                                }
                            }
                            if (item.periodicitiesName == 'Bimestral') {
                                if (item.vigencia == 'Vigente') {
                                    tipoCuota.biVigente++;
                                    group.biVigente++;
                                    tipoCuota.vigente++;
                                    group.vigente++;
                                }
                                else {
                                    tipoCuota.biVencido++;
                                    group.biVencido++;
                                    tipoCuota.vencido++;
                                    group.vencido++;
                                }
                            }
                            if (item.periodicitiesName == 'Trimestral') {
                                if (item.vigencia == 'Vigente') {
                                    tipoCuota.triVigente++;
                                    group.triVigente++;
                                    tipoCuota.vigente++;
                                    group.vigente++;
                                }
                                else {
                                    tipoCuota.triVencido++;
                                    group.triVencido++;
                                    tipoCuota.vencido++;
                                    group.vencido++;
                                }
                            }
                            if (item.periodicitiesName == 'Cuatrimestral') {
                                if (item.vigencia == 'Vigente') {
                                    tipoCuota.cuaVigente++;
                                    group.cuaVigente++;
                                    tipoCuota.vigente++;
                                    group.vigente++;
                                }
                                else {
                                    tipoCuota.cuaVencido++;
                                    group.cuaVencido++;
                                    tipoCuota.vencido++;
                                    group.vencido++;
                                }
                            }
                            if (item.periodicitiesName == 'Semestral') {
                                if (item.vigencia == 'Vigente') {
                                    tipoCuota.semVigente++;
                                    group.semVigente++;
                                    tipoCuota.vigente++;
                                    group.vigente++;
                                }
                                else {
                                    tipoCuota.semVencido++;
                                    group.semVencido++;
                                    tipoCuota.vencido++;
                                    group.vencido++;
                                }
                            }
                            if (item.periodicitiesName == 'Anual') {
                                if (item.vigencia == 'Vigente') {
                                    tipoCuota.anuVigente++;
                                    group.anuVigente++;
                                    tipoCuota.vigente++;
                                    group.vigente++;
                                }
                                else {
                                    tipoCuota.anuVencido++;
                                    group.anuVencido++;
                                    tipoCuota.vencido++;
                                    group.vencido++;
                                }
                            }
                        });
                    });
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosStatusController', ReportsSociosStatusController);



    /** @ngInject */
    function ReportsSociosStatusController(reportsService, api, authService, $filter) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.summary = [];

            var totalGroup = 0;
            var totalGroupRecurrente = 0;
            vm.groups = vm.reportData.data.groupBy('branchesName');
            angular.forEach(vm.groups, function (group) {
                group.membershipType = group.items.groupBy('membershipType');
                angular.forEach(group.membershipType, function (membershipType) {
                    membershipType.period = membershipType.items.groupBy('periodo');
                    membershipType.total = 0;
                    angular.forEach(membershipType.period, function (period) {
                        var totalperiod = period.items.length;
                        period.total = totalperiod;
                        membershipType.total += totalperiod;
                        totalGroup += totalperiod;
                        angular.forEach(period.items, function (item){
                            if (item.isRecurrent == 1){
                                totalGroupRecurrente ++;
                            }
                            if (item.parentPartner == null)
                            {
                                item.parentPartner = '------';
                            }
                        });
                    });
                });
                group.total = totalGroup;
                group.totalRecurrente = totalGroupRecurrente;
                group.totalNoRecurrente = totalGroup - totalGroupRecurrente;
                group.periodType = group.items.groupBy('periodo');
                angular.forEach(group.periodType, function (period) {
                    period.membershipType = period.items.groupBy('membershipType');
                    period.total = period.items.length;
                    period.recurrent = period.items.groupBy('recurrente');
                    angular.forEach(period.recurrent, function (recurrent) {
                        recurrent.total = recurrent.items.length;
                    });
                    angular.forEach(period.membershipType, function (membershipType) {
                        vm.summary.push({
                            branch: group.key,
                            membershipType: membershipType.key,
                            period: period.key,
                            totalPeriod: membershipType.items.length
                        });
                    });
                });
            });

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosInvoicesOrdersAllController', reportsSociosInvoicesOrdersAllController);

    /** @ngInject */
    function reportsSociosInvoicesOrdersAllController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.group = vm.reportData.data.groupBy('partnerName');
            angular.forEach(vm.group, function (g) {
                g.orderTypeGroups = g.items.groupBy("orderType");
                angular.forEach(g.orderTypeGroups, function (orderType) {
                    orderType.InvoiceGroup = orderType.items.groupBy("folio");
                });
            });

            // Get Summary
            // Summary
            vm.summary = [];
            angular.forEach(vm.group, function (group) {
                angular.forEach(group.orderTypeGroups, function (g) {
                    vm.summary.push({
                        orderType: g.key,
                        count: g.items.length,
                        total: (g && g.items && g.items.length) ? g.items.map(function (x) { return x.isCanceled ? 0 : x.total; }).reduce(function (x, y) { return x + y }) : 0
                    });
                });
            });

            // Totals Summary
            vm.summary.push({
                orderType: 'Totales',
                count: (vm.summary.length > 0) ? vm.summary.map(function (s) { return s.count }).reduce(function (a, b) { return a + b }) : 0,
                total: (vm.summary.length > 0) ? vm.summary.map(function (s) { return s.total }).reduce(function (a, b) { return a + b }) : 0,
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosInactivosController', reportsSociosInactivosController);



    /** @ngInject */
    function reportsSociosInactivosController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosInvoicesOrdersController', reportsSociosInvoicesOrdersController);

    /** @ngInject */
    function reportsSociosInvoicesOrdersController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.group = vm.reportData.data.groupBy('partnerName');
            angular.forEach(vm.group, function (g) {
                g.orderTypeGroups = g.items.groupBy("orderType");
                angular.forEach(g.orderTypeGroups, function (orderType) {
                    orderType.InvoiceGroup = orderType.items.groupBy("folio");
                });
            });

            // Get Summary
            // Summary
            vm.summary = [];
            angular.forEach(vm.group, function (group) {
                angular.forEach(group.orderTypeGroups, function (g) {
                    vm.summary.push({
                        orderType: g.key,
                        count: g.items.length,
                        total: (g && g.items && g.items.length) ? g.items.map(function (x) { return x.isCanceled ? 0 : x.total; }).reduce(function (x, y) { return x + y }) : 0
                    });
                });
            });

            // Totals Summary
            vm.summary.push({
                orderType: 'Totales',
                count: (vm.summary.length > 0) ? vm.summary.map(function (s) { return s.count }).reduce(function (a, b) { return a + b }) : 0,
                total: (vm.summary.length > 0) ? vm.summary.map(function (s) { return s.total }).reduce(function (a, b) { return a + b }) : 0,
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosGeneralPagoController', reportsSociosGeneralPagoController);

    /** @ngInject */
    function reportsSociosGeneralPagoController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.group = vm.reportData.data.groupBy('brancheName');
            vm.total = vm.reportData.data.length;
            vm.vigentes = 0;
            vm.vencidos = 0;
            angular.forEach(vm.group, function (g) {
                g.vigentes = 0;
                g.vencidos = 0;
                g.total = g.items.length;
                g.dueName = g.items.groupBy("dueName");
                angular.forEach(g.dueName, function (due) {
                    due.total = due.items.length;
                    due.vigentes = 0;
                    due.vencidos = 0;
                    angular.forEach(due.items, function (items) {
                        if(items.statusPartners == 'VIGENTE')
                        {
                            due.vigentes++;
                        }
                        else
                        {
                            due.vencidos++;
                        }
                    });
                    g.vigentes = g.vigentes + due.vigentes;
                    g.vencidos = g.vencidos + due.vencidos;
                });
                vm.vigentes = vm.vigentes + g.vigentes;
                vm.vencidos = vm.vencidos + g.vencidos;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosGeneralController', reportsSociosGeneralController);

    /** @ngInject */
    function reportsSociosGeneralController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.group = vm.reportData.data.groupBy('brancheName');
            vm.totalActive = 0;
            vm.totalInactive = 0; 
            angular.forEach(vm.group, function (g) {
                g.totalActive = 0;
                g.totalInactive = 0;
                g.total = g.items.length;
                g.orderTypeGroups = g.items.groupBy("membershipTypePeriodo");
                angular.forEach(g.orderTypeGroups, function (otg) {
                    otg.total = otg.items.length;
                    otg.totalActive = 0;
                    otg.totalInactive = 0;
                    angular.forEach(otg.items, function (items) {
                        if (items.estatus == 'Activo') {
                            otg.totalActive++;
                        }
                        else {
                            otg.totalInactive++;
                        }
                    });
                    g.totalActive += otg.totalActive;
                    g.totalInactive += otg.totalInactive;
                });
                vm.totalActive += g.totalActive;
                vm.totalInactive += g.totalInactive;
                vm.total = vm.reportData.data.length;
            });

            // // Get Summary
            // // Summary
            // vm.summary = [];
            // angular.forEach(vm.group, function (group) {
            //     angular.forEach(group.orderTypeGroups, function (g) {
            //         vm.summary.push({
            //             orderType: g.key,
            //             count: g.items.length,
            //             total: (g && g.items && g.items.length) ? g.items.map(function (x) { return x.isCanceled ? 0 : x.total; }).reduce(function (x, y) { return x + y }) : 0
            //         });
            //     });
            // });

            // // Totals Summary
            // vm.summary.push({
            //     orderType: 'Totales',
            //     count: (vm.summary.length > 0) ? vm.summary.map(function (s) { return s.count }).reduce(function (a, b) { return a + b }) : 0,
            //     total: (vm.summary.length > 0) ? vm.summary.map(function (s) { return s.total }).reduce(function (a, b) { return a + b }) : 0,
            // });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSocioConvenio', reportsSocioConvenio);



    /** @ngInject */
    function reportsSocioConvenio(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.groups = vm.reportData.data.groupBy('branchName');
            angular.forEach(vm.groups, function (g) {
                g.agreements = g.items.groupBy('agreementsName');
            });
            vm.agreements = vm.reportData.data.groupBy('agreementsName');
        }
    }
})();
    (function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsSociosCupoController', reportsSociosCupoController);
    
    /** @ngInject */
    function reportsSociosCupoController(reportsService, api, authService, $filter)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            
            // Grouping
            vm.branchGroups = vm.reportData.data.groupBy('branchName');         
            angular.forEach(vm.branchGroups , function(branchGroup){
                branchGroup.activityGroups = branchGroup.items.groupBy('activityName');                         
            });
            
            // Get Summary
            // Summary
            vm.summary = [];
            angular.forEach(vm.branchGroups, function(bg){
                angular.forEach(bg.activityGroups, function(ag){
                    vm.summary.push({
                        branch: bg.key,
                        activity: ag.key,
                        quota: ag.items[0].quota,
                        count: ag.items.length
                    });
                });
            });
            
            // Totals Summary
            vm.summary.push({
                branch: 'Totales',
                periodicity:  '',
                quota: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.quota }).reduce(function(a,b){ return a + b }) : 0,
                count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
            });
            
        }        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosByInscriptionDateController', reportsSociosByInscriptionDateController);

    /** @ngInject */
    function reportsSociosByInscriptionDateController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.groups = vm.reportData.data.groupBy('branchesName');
            angular.forEach(vm.groups, function (groups) {
                groups.mediaGroup = groups.items.groupBy('medio');
            });
        }
    }
})();
    (function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsSociosCargoAutomaticoBancoController', reportsSociosCargoAutomaticoBancoController);
    
    /** @ngInject */
    function reportsSociosCargoAutomaticoBancoController(reportsService, api, authService)
    {
        var vm = this;
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            
            
            // // Grouping
            // vm.branchGroups = vm.reportData.data.groupBy('branchName');         
            // angular.forEach(vm.branchGroups , function(bg){
            //     bg.paymentMethodGroups = bg.items.groupBy('paymentMethodName');                         
            //     angular.forEach(bg.paymentMethodGroups , function(pmg){
            //         pmg.paymentMethodOptionsGroups = pmg.items.groupBy('paymentMethodOptionName');
            //     });
            // });            
        }        
    }
})();
    (function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsSociosBetweenDatesController', reportsSociosBetweenDatesController);
    
    /** @ngInject */
    function reportsSociosBetweenDatesController(reportsService, api, authService, $filter)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.dueGroups = vm.reportData.data.groupBy('dueName');
            angular.forEach(vm.dueGroups , function(dueGroup){
                dueGroup.periodicityGroups = dueGroup.items.groupBy('periodicityName');                         
            });
            
            // Get Summary
            // Summary
            vm.summary = [];
            angular.forEach(vm.dueGroups, function(dg){
                angular.forEach(dg.periodicityGroups, function(pg){
                    vm.summary.push({
                        due         : dg.key,
                        periodicity : pg.key,
                        count       : pg.items.length
                    });
                });
            });
            // Totals Summary
            vm.summary.push({
                due: 'Socios Totales',
                periodicity:  '',
                count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
            });
            
        }        
    }
})();
    (function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsSociosCargoAutomaticoController', reportsSociosCargoAutomaticoController);
    
    /** @ngInject */
    function reportsSociosCargoAutomaticoController(reportsService, api, authService)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            
            
            // Grouping
            vm.branchGroups = vm.reportData.data.groupBy('branchName');         
            angular.forEach(vm.branchGroups , function(bg){
                bg.paymentMethodGroups = bg.items.groupBy('paymentMethodName');                         
                angular.forEach(bg.paymentMethodGroups , function(pmg){
                    pmg.paymentMethodOptionsGroups = pmg.items.groupBy('paymentMethodOptionName');
                });
            });
            
            // Get Summary
            // Summary
            vm.summary = [];
            angular.forEach(vm.branchGroups, function(bg){
                angular.forEach(bg.paymentMethodGroups, function(pmg){
                    angular.forEach(pmg.paymentMethodOptionsGroups, function(pmog){
                        vm.summary.push({
                            branch: bg.key,
                            pmName: pmg.key,
                            pmoName: pmog.key,
                            total: (pmog && pmog.items && pmog.items.length > 0)? pmog.items.map(function(x){ return x.amount }).reduce(function(x, y){ return x + y }) : 0,
                            count: pmog.items.length
                        });
                    });
                });
            });
            
            // Totals Summary
            vm.summary.push({
                branch: 'Totales',
                pmName: '',
                pmoName: '',
                total: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.total }).reduce(function(a,b){ return a + b }) : 0,
                count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
            });        
        }        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosBirthdayController', reportsSociosBirthdayController);

    /** @ngInject */
    function reportsSociosBirthdayController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.group = vm.reportData.data.groupBy('branchesName');
            // angular.forEach(vm.group, function (g) {
            //     g.total = g.items.length;
            // });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSocioAusencia', reportsSocioAusencia);



    /** @ngInject */
    function reportsSocioAusencia(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.groups = vm.reportData.data.groupBy('branchName');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosaltasController', reportsSociosaltasController);



    /** @ngInject */
    function reportsSociosaltasController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.groups = vm.reportData.data.groupBy('brancheName');
            vm.totalDomicialiado = 0;
            vm.totalNoDomicialiado = 0;
            angular.forEach(vm.groups, function (g) {
                g.totalDomicialiado = 0;
                g.totalNoDomicialiado = 0;
                g.total = g.items.length;
                g.membershipType = g.items.groupBy("membershipType");
                angular.forEach(g.membershipType, function (otg) {
                    otg.total = otg.items.length;
                    otg.totalDomicialiado = 0;
                    otg.totalNoDomicialiado = 0;
                    angular.forEach(otg.items, function (items) {
                        if (items.domiciliado == 'SI') {
                            otg.totalDomicialiado++;
                        }
                        else {
                            otg.totalNoDomicialiado++;
                        }
                    });
                    g.totalDomicialiado += otg.totalDomicialiado;
                    g.totalNoDomicialiado += otg.totalNoDomicialiado;

                    otg.periodo = otg.items.groupBy("periodo");
                    angular.forEach(otg.periodo, function (p) {
                        p.total = p.items.length;
                    });
                });
                vm.totalDomicialiado += g.totalDomicialiado;
                vm.totalNoDomicialiado += g.totalNoDomicialiado;
                vm.total = vm.reportData.data.length;

                g.periodo = g.items.groupBy("periodo");
                angular.forEach(g.periodo, function (p) {
                    p.total = p.items.length;
                });
            });

        }
    }
})();
    (function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsSociosAgeRangesController', reportsSociosAgeRangesController);
    
    /** @ngInject */
    function reportsSociosAgeRangesController(reportsService, api, authService, $filter)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            
            vm.branchGroups = vm.reportData.data.groupBy('branchName');         
            
            if (vm.reportData.report.parameters[2].value.id == 2 /*DESGLOSADO*/){            
                // Grouping
                angular.forEach(vm.branchGroups , function(branchGroup){
                    branchGroup.rangeGroups = branchGroup.items.groupBy('ageRange');                         
                });
                
                // Get Summary
                // Summary
                vm.summary = [];
                angular.forEach(vm.branchGroups, function(bg){
                    angular.forEach(bg.rangeGroups, function(rg){
                        vm.summary.push({
                            branch: bg.key,
                            ageRange: rg.key,
                            count: rg.items.length
                        });
                    });
                });
                
                // Totals Summary
                vm.summary.push({
                    branch: 'Totales',
                    ageRange:  '',
                    count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
                });
            }
            
        }        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsSociosActivosController', reportsSociosActivosController);



    /** @ngInject */
    function reportsSociosActivosController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.groups = vm.reportData.data.groupBy('brancheName');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsProspectosGeneralController', reportsProspectosGeneralController);



    /** @ngInject */
    function reportsProspectosGeneralController(reportsService, api, authService, $filter) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;


            vm.groups = vm.reportData.data.groupBy('branchesName');
            angular.forEach(vm.groups, function (groups) {
                groups.sellerGroup = groups.items.groupBy('sellerName');
                groups.totalInscritos = 0;
                groups.totalNoInscritos = 0
                angular.forEach(groups.sellerGroup, function (seller) {
                    seller.totalInscritos = 0;
                    seller.totalNoInscritos = 0
                    angular.forEach(seller.items, function (item) {
                        if (item.inscrito == 'Si') {
                            seller.totalInscritos++;
                        }
                        else {
                            seller.totalNoInscritos++;
                        }
                    });
                    groups.totalInscritos = groups.totalInscritos + seller.totalInscritos;
                    groups.totalNoInscritos = groups.totalNoInscritos + seller.totalNoInscritos;
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsRentablesController', reportsRentablesController);

    /** @ngInject */
    function reportsRentablesController(reportsService, api, authService, $filter) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.groups = vm.reportData.data.groupBy('branchName');
            angular.forEach(vm.groups, function (group) {
                group.total = group.items.length;
                group.disponibles = 0;
                group.ocupados = 0;
                group.vencidos = 0;
                group.vigentes = 0;
                group.tipoCasillero = group.items.groupBy('tipoCasillero');
                angular.forEach(group.tipoCasillero, function (tipoCasillero) {
                    tipoCasillero.total = tipoCasillero.items.length;
                    tipoCasillero.ocupados = 0;
                    tipoCasillero.disponibles = 0;
                    tipoCasillero.vencidos = 0;
                    tipoCasillero.vigentes = 0;
                    angular.forEach(tipoCasillero.items, function (item) {
                        if (item.vencido == 'Si') {
                            tipoCasillero.vencidos++;
                            group.vencidos++;
                        }
                        if (item.vencido == 'No') {
                            tipoCasillero.vigentes++;
                            group.vigentes++;
                        }
                        if (item.namePartner == 'Disponible') {
                            tipoCasillero.disponibles++;
                            group.disponibles++;
                        }
                        else {
                            tipoCasillero.ocupados++;
                            group.ocupados++;
                        }
                    });
                });
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsCortesCajaIngresosGeneralesController', reportsCortesCajaIngresosGeneralesController);



    /** @ngInject */
    function reportsCortesCajaIngresosGeneralesController(reportsService, api, authService, $filter) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            if (vm.reportData.report.parameters[2].value.id == 1 /*CONSOLIDADO*/) {
                vm.groups = vm.reportData.data.groupBy('branchesName');
                angular.forEach(vm.groups, function (groups) {
                    var totalGroup = 0;
                    groups.sellerGroup = groups.items.groupBy('sellerName');
                    angular.forEach(groups.sellerGroup, function (seller) {
                        var totalSeller = $filter('sum')(seller.items, 'total');
                        seller.total = totalSeller;
                        totalGroup += totalSeller;
                    });
                    groups.total = totalGroup;
                });
            }
            else { /* DESGLOCE */
                vm.groups = vm.reportData.data.groupBy('branchesName');
                angular.forEach(vm.groups, function (groups) {
                    var totalGroup = 0;
                    groups.sellerGroup = groups.items.groupBy('sellerName');
                    angular.forEach(groups.sellerGroup, function (seller) {
                        var totalSeller = $filter('sum')(seller.items, 'total');
                        seller.total = totalSeller;
                        totalGroup += totalSeller;
                        seller.typeIncomeGroup = seller.items.groupBy('tipoIngreso');
                        angular.forEach(seller.typeIncomeGroup, function (typeIncome) {
                            var totalTypeIncomeGroup = $filter('sum')(typeIncome.items, 'total');
                            typeIncome.total = totalTypeIncomeGroup;
                        });
                    });
                    groups.total = totalGroup;
                });
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsOtrosIngresosController', reportsOtrosIngresosController);



    /** @ngInject */
    function reportsOtrosIngresosController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.reports")
    .controller(
      "ReportsExportsGeneralIntelisisReciptController",
      reportsExportsGeneralIntelisisReciptController
    );

  /** @ngInject */
  function reportsExportsGeneralIntelisisReciptController(
    reportsService,
    api,
    authService,
    $filter
  ) {
    var vm = this;

    _init();

    function _init() {
      var appData = authService.getAppData();
      vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
      vm.report =
        api.baseUrl.replace("api/", "") + "Files\\Temp\\reporteEspecialIR.xlsx";
      vm.reportData = reportsService.getReportData().data;

      // vm.branchGroups = vm.reportData.data.groupBy('branchName');

      // if (vm.reportData.report.parameters[2].value.id == 2 /*DESGLOSADO*/){
      //     // Grouping
      //     angular.forEach(vm.branchGroups , function(branchGroup){
      //         branchGroup.rangeGroups = branchGroup.items.groupBy('ageRange');
      //     });

      //     // Get Summary
      //     // Summary
      //     vm.summary = [];
      //     angular.forEach(vm.branchGroups, function(bg){
      //         angular.forEach(bg.rangeGroups, function(rg){
      //             vm.summary.push({
      //                 branch: bg.key,
      //                 ageRange: rg.key,
      //                 count: rg.items.length
      //             });
      //         });
      //     });

      //     // Totals Summary
      //     vm.summary.push({
      //         branch: 'Totales',
      //         ageRange:  '',
      //         count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
      //     });
      // }
    }
  }
})();

(function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsExportsGeneralController', reportsExportsGeneralController);
    
    /** @ngInject */
    function reportsExportsGeneralController(reportsService, api, authService, $filter)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.report = api.baseUrl.replace("api/","") + "Files\\Temp\\reporteEspecial.xlsx";
            vm.reportData = reportsService.getReportData().data;
            
            // vm.branchGroups = vm.reportData.data.groupBy('branchName');         
            
            // if (vm.reportData.report.parameters[2].value.id == 2 /*DESGLOSADO*/){            
            //     // Grouping
            //     angular.forEach(vm.branchGroups , function(branchGroup){
            //         branchGroup.rangeGroups = branchGroup.items.groupBy('ageRange');                         
            //     });
                
            //     // Get Summary
            //     // Summary
            //     vm.summary = [];
            //     angular.forEach(vm.branchGroups, function(bg){
            //         angular.forEach(bg.rangeGroups, function(rg){
            //             vm.summary.push({
            //                 branch: bg.key,
            //                 ageRange: rg.key,
            //                 count: rg.items.length
            //             });
            //         });
            //     });
                
            //     // Totals Summary
            //     vm.summary.push({
            //         branch: 'Totales',
            //         ageRange:  '',
            //         count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
            //     });
            // }
            
        }        
    }
})();
(function () {
  "use strict";

  angular
    .module("app.reports")
    .controller(
      "ReportsExportsGeneralIntelisisController",
      reportsExportsGeneralIntelisisController
    );

  /** @ngInject */
  function reportsExportsGeneralIntelisisController(
    reportsService,
    api,
    authService,
    $filter
  ) {
    var vm = this;

    _init();

    function _init() {
      var appData = authService.getAppData();
      vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
      vm.report =
        api.baseUrl.replace("api/", "") + "Files\\Temp\\reporteEspecialI.xlsx";
      vm.reportData = reportsService.getReportData().data;

      // vm.branchGroups = vm.reportData.data.groupBy('branchName');

      // if (vm.reportData.report.parameters[2].value.id == 2 /*DESGLOSADO*/){
      //     // Grouping
      //     angular.forEach(vm.branchGroups , function(branchGroup){
      //         branchGroup.rangeGroups = branchGroup.items.groupBy('ageRange');
      //     });

      //     // Get Summary
      //     // Summary
      //     vm.summary = [];
      //     angular.forEach(vm.branchGroups, function(bg){
      //         angular.forEach(bg.rangeGroups, function(rg){
      //             vm.summary.push({
      //                 branch: bg.key,
      //                 ageRange: rg.key,
      //                 count: rg.items.length
      //             });
      //         });
      //     });

      //     // Totals Summary
      //     vm.summary.push({
      //         branch: 'Totales',
      //         ageRange:  '',
      //         count: (vm.summary.length > 0) ? vm.summary.map(function(s){ return s.count }).reduce(function(a,b){ return a + b }) : 0,
      //     });
      // }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsDocumentCancelController', reportsDocumentCancelController);



    /** @ngInject */
    function reportsDocumentCancelController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.groups = vm.reportData.data.groupBy('branchName');
            vm.ImporteTotal = 0;
            vm.IvaTotal = 0;
            vm.TotalTotal = 0;
            angular.forEach(vm.groups, function (g) {
                g.orderTypes = g.items.groupBy('orderType');
                g.ImporteTotal = 0;
                g.IvaTotal = 0;
                g.TotalTotal = 0;
                angular.forEach(g.orderTypes, function (orderType) {
                    orderType.ImporteTotal = 0;
                    orderType.IvaTotal = 0;
                    orderType.TotalTotal = 0;
                    angular.forEach(orderType.items, function (item) {
                        orderType.ImporteTotal += item.importe;
                        orderType.IvaTotal += item.iva;
                        orderType.TotalTotal += item.total;
                    });
                    g.ImporteTotal += orderType.ImporteTotal;
                    g.IvaTotal += orderType.IvaTotal;
                    g.TotalTotal += orderType.TotalTotal;
                });
                vm.ImporteTotal += g.ImporteTotal;
                vm.IvaTotal += g.IvaTotal;
                vm.TotalTotal += g.TotalTotal;
            });
        }
    }
})();
(function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsCortesCajaCorteProductsController', reportsCortesCajaCorteProductsController);
    
    /** @ngInject */
    function reportsCortesCajaCorteProductsController(reportsService, api, authService, $filter)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            
            // Calc Percentages
            if (vm.reportData.report.parameters[2].value.id == 1 /*CONSOLIDADO*/){
                vm.group = vm.reportData.data.groupBy('branchName');                            
            }else{
                vm.group = vm.reportData.data.groupBy('productName');                                            
            }
        }        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsNotasCreditoController', reportsNotasCreditoController);



    /** @ngInject */
    function reportsNotasCreditoController(reportsService, api, authService, $filter) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;

            vm.groups = vm.reportData.data.groupBy('branchName');
            vm.totalItems = vm.reportData.data.length;
            vm.totalItemsNoParciales = 0;
            vm.totalItemsParciales = 0;
            vm.noParciales = 0;
            vm.parciales = 0;
            vm.total = 0;
            angular.forEach(vm.groups, function (g) {
                g.totalItems = g.items.length;
                g.totalItemsNoParciales = 0;
                g.totalItemsParciales = 0;
                g.noParciales = 0;
                g.parciales = 0;
                g.total = 0;
                angular.forEach(g.items, function (items) {
                    if (items.esTotal == 'Si') {
                        g.noParciales = g.noParciales + items.ncTotal;
                        g.totalItemsNoParciales++;
                    }
                    else {
                        g.parciales = g.parciales + items.ncTotal;
                        g.totalItemsParciales++;
                    }
                    g.total = g.total + items.ncTotal;
                });
                vm.noParciales = vm.noParciales + g.noParciales;
                vm.parciales = vm.parciales + g.parciales;
                vm.total = vm.total + g.total;
                vm.totalItemsNoParciales = vm.totalItemsNoParciales + g.totalItemsNoParciales;
                vm.totalItemsParciales = vm.totalItemsParciales + g.totalItemsParciales;
            });
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.reports")
    .controller(
      "ReportsCortesCajaCorteCuentaContableController",
      reportsCortesCajaCorteCuentaContableController
    );

  /** @ngInject */
  function reportsCortesCajaCorteCuentaContableController(
    reportsService,
    api,
    authService
  ) {
    var vm = this;

    _init();

    function _init() {
      var appData = authService.getAppData();
      vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
      vm.reportData = reportsService.getReportData().data;
      
        // Summary
        vm.summary = [];
        vm.subtotal = 0;
        vm.discountAmmount = 0;
        vm.iva = 0;
        vm.total = 0;
        vm.group = vm.reportData.data.groupBy("branchName");
        angular.forEach(vm.group, function (g) {
          var receipts = [];
          var receiptsSubtotal = [];
          var receiptsDiscount = [];
          var receiptsIva = [];
          var invoices = [];
          var invoicesSubtotal = [];
          var invoicesDiscount = [];
          var invoicesIva = [];
          var ncs = [];
          var ncsSubtotal = [];
          var ncsIva = [];
          receipts = g.items
            .filter(function (group) {
              return group.orderType == "RECIBO";
            })
            .map(function (m) {
              return m.total;
            });
          receiptsSubtotal = g.items
            .filter(function (group) {
              return group.orderType == "RECIBO";
            })
            .map(function (m) {
              return m.subtotal;
            });
          receiptsDiscount = g.items
            .filter(function (group) {
              return group.orderType == "RECIBO";
            })
            .map(function (m) {
              return m.discountAmmount;
            });
          receiptsIva = g.items
            .filter(function (group) {
              return group.orderType == "RECIBO";
            })
            .map(function (m) {
              return m.iva;
            });
          invoices = g.items
            .filter(function (group) {
              return group.orderType == "FACTURA";
            })
            .map(function (m) {
              return m.total;
            });
          invoicesSubtotal = g.items
            .filter(function (group) {
              return group.orderType == "FACTURA";
            })
            .map(function (m) {
              return m.subtotal;
            });
          invoicesDiscount = g.items
            .filter(function (group) {
              return group.orderType == "FACTURA";
            })
            .map(function (m) {
              return m.discountAmmount;
            });
          invoicesIva = g.items
            .filter(function (group) {
              return group.orderType == "FACTURA";
            })
            .map(function (m) {
              return m.iva;
            });
          ncs = g.items
            .filter(function (group) {
              return group.orderType == "NC";
            })
            .map(function (m) {
              return m.total;
            });
          ncsSubtotal = g.items
            .filter(function (group) {
              return group.orderType == "NC";
            })
            .map(function (m) {
              return m.subtotal;
            });
          ncsIva = g.items
            .filter(function (group) {
              return group.orderType == "NC";
            })
            .map(function (m) {
              return m.iva;
            });
          vm.summary.push({
            branch: g.key,
            receiptTotal:
              receipts.length > 0
                ? receipts.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
            receiptDiscountTotal:
              receiptsDiscount.length > 0
                ? receiptsDiscount.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
            invoiceTotal:
              invoices.length > 0
                ? invoices.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
            invoicesDiscountTotal:
              invoicesDiscount.length > 0
                ? invoicesDiscount.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
            ncTotal:
              ncs.length > 0
                ? ncs.reduce(function (a, b) {
                    return a + b;
                  })
                : 0
          });
          var receip =
            receiptsSubtotal.length > 0
              ? receiptsSubtotal.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          var invoice =
            invoicesSubtotal.length > 0
              ? invoicesSubtotal.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          var invoiceDiscont =
            invoicesDiscount.length > 0
              ? invoicesDiscount.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          var orderDiscont =
            receiptsDiscount.length > 0
              ? receiptsDiscount.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          var nc =
            vm.reportData.report.parameters[5].value.id == 1
              ? ncsSubtotal.length > 0
                ? ncsSubtotal.reduce(function (a, b) {
                    return a + b;
                  })
                : 0
              : 0;
          vm.subtotal = vm.subtotal + receip + invoice - nc;
          vm.discountAmmount =
            vm.discountAmmount + invoiceDiscont + orderDiscont;
          receip =
            receiptsIva.length > 0
              ? receiptsIva.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          invoice =
            invoicesIva.length > 0
              ? invoicesIva.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          nc =
            vm.reportData.report.parameters[5].value.id == 1
              ? ncsIva.length > 0
                ? ncsIva.reduce(function (a, b) {
                    return a + b;
                  })
                : 0
              : 0;
          vm.iva = vm.iva + receip + invoice - nc;
          vm.total = vm.subtotal + vm.iva - vm.discountAmmount;
          g.groupType = g.items.groupBy("orderType");
          angular.forEach(g.groupType, function (groupType) {
            groupType.groupAccount = groupType.items.groupBy("account");
            angular.forEach(groupType.groupAccount, function (groupAccount) {
              groupAccount.groupDate = groupAccount.items.groupBy("fecha");
            });
          });
        });
        // Totals Summary
        var allReceipts = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "RECIBO";
          })
          .map(function (m) {
            return m.total;
          });
        var allReceiptsDiscount = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "RECIBO";
          })
          .map(function (m) {
            return m.discountAmmount;
          });
        var allInvoices = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "FACTURA";
          })
          .map(function (m) {
            return m.total;
          });
        var allInvoicesDiscount = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "FACTURA";
          })
          .map(function (m) {
            return m.discountAmmount;
          });
        var allNc = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "NC";
          })
          .map(function (m) {
            return m.total;
          });

        vm.summary.push({
          branch: "Total",
          receiptTotal:
            allReceipts.length > 0
              ? allReceipts.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
          receiptDiscountTotal:
            allReceiptsDiscount.length > 0
              ? allReceiptsDiscount.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
          invoiceTotal:
            allInvoices.length > 0
              ? allInvoices.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
          invoicesDiscountTotal:
            allInvoicesDiscount.length > 0
              ? allInvoicesDiscount.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
          ncTotal:
            allNc.length > 0
              ? allNc.reduce(function (a, b) {
                  return a + b;
                })
              : 0
        });      
    }
  }
})();

(function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsCortesCajaCorteDueController', reportsCortesCajaCorteDueController);
    
    /** @ngInject */
    function reportsCortesCajaCorteDueController(reportsService, api, authService, $filter)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            
            // Calc Percentages
            if (vm.reportData.report.parameters[2].value.id == 1 /*CONSOLIDADO*/){
                vm.group = vm.reportData.data.groupBy('branchName');                            
            }else{
                vm.group = vm.reportData.data.groupBy('dueName');                                            
            }
        }        
    }
})();
(function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsCortesCajaCorteFormaPagoController', reportsCortesCajaCorteFormaPagoController);
    
    /** @ngInject */
    function reportsCortesCajaCorteFormaPagoController(reportsService, api, authService, $filter, Excel, $timeout)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.group = vm.reportData.data.groupBy('branchName');            
            
            // Calc Percentages
            if (vm.reportData.report.parameters[3].value.id == 1 /*CONSOLIDADO*/){
                var totalAll = $filter('sum')(vm.reportData.data, 'total');
                angular.forEach(vm.group, function(g){
                    var totalGroup = $filter('sum')(g.items, 'total');
                    angular.forEach(g.items, function(item){
                        item.branchPercentage = (item.total * 100) / totalGroup;
                        item.totalPercentage = (item.total * 100) / totalAll;
                    });
                });
            }
        }        
    }
})();
(function ()
{
    'use strict';    

    angular
        .module('app.reports')
        .controller('ReportsCortesCajaInvoicesController', reportsCortesCajaInvoicesController);
    
    /** @ngInject */
    function reportsCortesCajaInvoicesController(reportsService, api, authService)
    {
        var vm = this;
        
        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
        }        
    }
})();
(function () {
  "use strict";

  angular
    .module("app.reports")
    .controller(
      "ReportsCortesCajaCorteCobranzaController",
      reportsCortesCajaCorteCobranzaController
    );

  /** @ngInject */
  function reportsCortesCajaCorteCobranzaController(
    reportsService,
    api,
    authService,
    $filter
  ) {
    var vm = this;

    _init();

    function _init() {
      var appData = authService.getAppData();
      vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
      vm.reportData = reportsService.getReportData().data;

      if (vm.reportData.report.parameters[5].value.id == 1 /*CONSOLIDADO*/) {
        vm.group = vm.reportData.data.groupBy("branchName");
        angular.forEach(vm.group, function (g) {
          g.totalFR = 0;
          g.totalNC = 0;
          g.totalGroup = 0;
          g.fecha = g.items.groupBy("fecha");
          angular.forEach(g.fecha, function (fecha) {
            fecha.totalFR = 0;
            fecha.totalNC = 0;
            angular.forEach(fecha.items, function (item) {
              if (item.orderType == "NC") {
                fecha.totalNC = fecha.totalNC + item.total;
              } else {
                fecha.totalFR = fecha.totalFR + item.total;
              }
            });
            g.totalNC = fecha.totalNC + g.totalNC;
            g.totalFR = fecha.totalFR + g.totalFR;
          });
          g.totalGroup =
            vm.reportData.report.parameters[6].value.id == 1
              ? g.totalFR - g.totalNC
              : g.totalFR;
          angular.forEach(g.fecha, function (fecha) {
            fecha.branchPercentage =
              ((vm.reportData.report.parameters[6].value.id == 1
                ? fecha.totalFR - fecha.totalNC
                : fecha.totalFR) *
                100) /
              g.totalGroup;
          });
        });
      } else {
        /* DESGLOCE */
        // Summary
        vm.summary = [];
        vm.subtotal = 0;
        vm.discountAmmount = 0;
        vm.iva = 0;
        vm.total = 0;
        vm.group = vm.reportData.data.groupBy("branchName");
        angular.forEach(vm.group, function (g) {
          var receipts = [];
          var receiptsSubtotal = [];
          var receiptsDiscount = [];
          var receiptsIva = [];
          var invoices = [];
          var invoicesSubtotal = [];
          var invoicesDiscount = [];
          var invoicesIva = [];
          var ncs = [];
          var ncsSubtotal = [];
          var ncsIva = [];
          receipts = g.items
            .filter(function (group) {
              return group.orderType == "RECIBO";
            })
            .map(function (m) {
              return m.total;
            });
          receiptsSubtotal = g.items
            .filter(function (group) {
              return group.orderType == "RECIBO";
            })
            .map(function (m) {
              return m.subtotal;
            });
          receiptsDiscount = g.items
            .filter(function (group) {
              return group.orderType == "RECIBO";
            })
            .map(function (m) {
              return m.discountAmmount;
            });
          receiptsIva = g.items
            .filter(function (group) {
              return group.orderType == "RECIBO";
            })
            .map(function (m) {
              return m.iva;
            });
          invoices = g.items
            .filter(function (group) {
              return group.orderType == "FACTURA";
            })
            .map(function (m) {
              return m.total;
            });
          invoicesSubtotal = g.items
            .filter(function (group) {
              return group.orderType == "FACTURA";
            })
            .map(function (m) {
              return m.subtotal;
            });
          invoicesDiscount = g.items
            .filter(function (group) {
              return group.orderType == "FACTURA";
            })
            .map(function (m) {
              return m.discountAmmount;
            });
          invoicesIva = g.items
            .filter(function (group) {
              return group.orderType == "FACTURA";
            })
            .map(function (m) {
              return m.iva;
            });
          ncs = g.items
            .filter(function (group) {
              return group.orderType == "NC";
            })
            .map(function (m) {
              return m.total;
            });
          ncsSubtotal = g.items
            .filter(function (group) {
              return group.orderType == "NC";
            })
            .map(function (m) {
              return m.subtotal;
            });
          ncsIva = g.items
            .filter(function (group) {
              return group.orderType == "NC";
            })
            .map(function (m) {
              return m.iva;
            });
          vm.summary.push({
            branch: g.key,
            receiptTotal:
              receipts.length > 0
                ? receipts.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
            receiptDiscountTotal:
              receiptsDiscount.length > 0
                ? receiptsDiscount.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
            invoiceTotal:
              invoices.length > 0
                ? invoices.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
            invoicesDiscountTotal:
              invoicesDiscount.length > 0
                ? invoicesDiscount.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
            ncTotal:
              ncs.length > 0
                ? ncs.reduce(function (a, b) {
                    return a + b;
                  })
                : 0,
          });
          var receip =
            receiptsSubtotal.length > 0
              ? receiptsSubtotal.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          var invoice =
            invoicesSubtotal.length > 0
              ? invoicesSubtotal.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          var invoiceDiscont =
            invoicesDiscount.length > 0
              ? invoicesDiscount.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          var orderDiscont =
            receiptsDiscount.length > 0
              ? receiptsDiscount.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          var nc =
            vm.reportData.report.parameters[6].value.id == 1
              ? ncsSubtotal.length > 0
                ? ncsSubtotal.reduce(function (a, b) {
                    return a + b;
                  })
                : 0
              : 0;
          vm.subtotal = vm.subtotal + receip + invoice - nc;
          vm.discountAmmount =
            vm.discountAmmount + invoiceDiscont + orderDiscont;
          receip =
            receiptsIva.length > 0
              ? receiptsIva.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          invoice =
            invoicesIva.length > 0
              ? invoicesIva.reduce(function (a, b) {
                  return a + b;
                })
              : 0;
          nc =
            vm.reportData.report.parameters[6].value.id == 1
              ? ncsIva.length > 0
                ? ncsIva.reduce(function (a, b) {
                    return a + b;
                  })
                : 0
              : 0;
          vm.iva = vm.iva + receip + invoice - nc;
          vm.total = vm.subtotal + vm.iva - vm.discountAmmount;
          g.groupType = g.items.groupBy("orderType");
          angular.forEach(g.groupType, function (groupType) {
            groupType.groupDate = groupType.items.groupBy("fecha");
          });
        });
        // Totals Summary
        var allReceipts = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "RECIBO";
          })
          .map(function (m) {
            return m.total;
          });
        var allReceiptsDiscount = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "RECIBO";
          })
          .map(function (m) {
            return m.discountAmmount;
          });
        var allInvoices = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "FACTURA";
          })
          .map(function (m) {
            return m.total;
          });
        var allInvoicesDiscount = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "FACTURA";
          })
          .map(function (m) {
            return m.discountAmmount;
          });
        var allNc = vm.reportData.data
          .filter(function (group) {
            return group.orderType == "NC";
          })
          .map(function (m) {
            return m.total;
          });

        vm.summary.push({
          branch: "Total",
          receiptTotal:
            allReceipts.length > 0
              ? allReceipts.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
          receiptDiscountTotal:
            allReceiptsDiscount.length > 0
              ? allReceiptsDiscount.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
          invoiceTotal:
            allInvoices.length > 0
              ? allInvoices.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
          invoicesDiscountTotal:
            allInvoicesDiscount.length > 0
              ? allInvoicesDiscount.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
          ncTotal:
            allNc.length > 0
              ? allNc.reduce(function (a, b) {
                  return a + b;
                })
              : 0,
        });
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsCorteTPVController', reportsCorteTPVController);



    /** @ngInject */
    function reportsCorteTPVController(reportsService, api, authService) {
        var vm = this;

        _init();

        function _init() {
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/", "") + appData.settings.logoFile;
            vm.reportData = reportsService.getReportData().data;
            vm.groups = vm.reportData.data.groupBy('branchName');
            vm.total = 0;
            angular.forEach(vm.groups, function (g) {
                g.TPVS = g.items.groupBy('tpvName');
                g.total = 0;
                angular.forEach(g.TPVS, function (TPV) {
                    TPV.total = 0;
                    angular.forEach(TPV.items, function (item) {
                        if (item.cancelado == 'Falso') {
                            TPV.total += item.ammount;
                        }
                    });
                    g.total += TPV.total;
                });
                vm.total += g.total;
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.duesRules', [ 
        ])
        .config(duesRulesConfig);

    /** @ngInject */
    function duesRulesConfig($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.duesRules', {
                url      : '/duesRules',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/duesRules/duesRules.html',
                        controller : 'CatalogsDuesRulesController as vm'
                    }
                },
                resolve  : {
                    DuesRules: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.duesRules@query');
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.duesRules', {
            title: 'Reglas de cuotas',
            state: 'app.catalogs.duesRules'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.duesRules')
        .controller('CatalogsDuesRulesDetailDialogController', catalogsDuesRulesDetailDialogController);

    /** @ngInject */
    function catalogsDuesRulesDetailDialogController($mdDialog, Callback, api, msg, DueRule)
    {
        var vm = this;

        _init();

        // Methods
        vm.save = save;
        vm.close = close;
        vm.dueChange = dueChange;
        //////////

        function _init(){
            vm.callback = Callback;
            vm.genders = api.catalogs.genders.query();
            vm.actions = [
                { key: 'NOTIFY', name: 'Notificar' },
                { key: 'CHANGE', name: 'Cambiar' },
            ]
            vm.item = {
                id: 0,
                action: ''
                // branch: { id: 0, name: 'dummy' },
            };

            api.catalogs.dues.query(function(response){
                vm.dues = response;
                if (DueRule){
                    vm.item = angular.copy(DueRule);
                    dueChange();
                }
            });
        }
        
        function close(){
            $mdDialog.hide();
        }

        function dueChange(){
            vm.newDues = vm.dues.filter(function(d){ return d.id != vm.item.dueCurrentId });
        }

        function save(){
            api.catalogs.duesRules.save(vm.item, function(response){
                msg.success("Regla guardada correctamente!");
                close();
                vm.callback();
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.security.userTypes', [
            // 3rd Party Dependencies
            'xeditable'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.security.userTypes', {
                url      : '/usertypes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/userTypes/userTypes/userTypes.html',
                        controller : 'SecurityUserTypesController as vm'
                    }
                },
                resolve  : {
                    UserTypes: function (apiResolver)
                    {
                        return apiResolver.resolve('security.userTypes@query');
                    }
                }
            })
            .state('app.security.userTypes.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/userTypes/userType/userType.html',
                        controller : 'SecurityUserTypeController as vm'
                    }
                },
                resolve  : {
                    UserType: function ()
                    {
                        return { id: 0, name: '', active: true, access: [] };
                    },
                },
            })
            .state('app.security.userTypes.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/userTypes/userType/userType.html',
                        controller : 'SecurityUserTypeController as vm'
                    }
                },
                resolve  : {
                    UserType: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('security.userTypes@get', { id: $stateParams.id });
                    },
                }
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.security.userTypes', {
            title: 'Tipos de Usuarios',
            state: 'app.security.userTypes'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.security.userTypes')
        .controller('InvoicesPlannedProductsDialogAddController', invoicesPlannedProductsDialogAddController);

    /** @ngInject */
    function invoicesPlannedProductsDialogAddController($mdDialog, api, msg, Callback, CONST_DATATABLES)
    {
        var vm = this;

        _init();

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;
        vm.partnerChange = partnerChange;
        vm.productChange = productChange;
        //////////
        
        function _init(){
            vm.callback = Callback;
            vm.minExpiration = new Date();

            vm.addTypes= [
                { id: 1, name: 'Por Socio',         ariaLabel: 'ByPartner' },
                { id: 2, name: 'Por Cuota',         ariaLabel: 'ByDue' },
                { id: 3, name: 'Por Tipo de Socio', ariaLabel: 'ByPartnerType' },
                { id: 4, name: 'Solo Titulares',    ariaLabel: 'ByOnlyTitulars' },
                { id: 5, name: 'Solo Familiares',   ariaLabel: 'ByOnlyFamiliars' },
                { id: 6, name: 'Todos',             ariaLabel: 'ByAll' },
            ];

            vm.item = {
                id              : 0,
                product         : null,
                addType         : 1,
                expirationDate  : new Date(),
                partnerId       : 0
            };

            api.inventory.products.query(function(response){
                vm.inventory = response.filter(function(i){ return i.quantity > 0 || !i.product.isStockRequired });
            });
            // api.partners.partners.query(function(response){
            //     vm.titulares = response.filter(function(p){ return !p.isFamily; });
            // });
            api.partners.partners.getByFilters({
                 keyword: 'dummy', 
                 pageNumber: 0, 
                 pageSize: 0 
            }, function(response){
                vm.titulares = response.filter(function(p){ return !p.isFamily; });
            });
            vm.partnerTypes = api.catalogs.partnerTypes.query();
            vm.dues = api.catalogs.dues.query();
            vm.periodicities = api.catalogs.periodicities.query();
            vm.partners = [];            
        }   

        function save(){
            // Save planned Product
            vm.saving = true;
            if( !vm.item.partnerId)
                vm.item.partnerId = 0;
            api.invoices.plannedProducts.save(vm.item, function(response){
                vm.saving = false;
                msg.success("Cargo(s) agredado(s) correctamente.");
                vm.callback();
                closeDialog();
            }, function(){
                vm.saving = false;
            });
        }

        function closeDialog(){
            $mdDialog.hide();
        }

        function partnerChange(){
            vm.item.partnerId = "";
            vm.partners = [];
            api.partners.partners.getByFamily({
                id      : 0,
                familyId: vm.partner.familyId
            },function(response){
                vm.partners = response;
            });
        }

        function productChange(){
            vm.item.product = vm.product.product;
            vm.item.productId = vm.product.product.id;
            vm.item.price = vm.product.price;
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.products', [
            'ngSanitize'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.products', {
                url      : '/products',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/products/products/products.html',
                        controller : 'CatalogProductsController as vm'
                    }
                },
                // resolve: {
                //     Products: function (apiResolver)
                //     {
                //         return apiResolver.resolve('catalogs.products@query');
                //     }
                // }
            })
            .state('app.catalogs.products.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/products/product/product.html',
                        controller : 'CatalogProductController as vm'
                    }
                },
                resolve  : {
                    Product: function ()
                    {
                        return { id: 0, name: '', active: true, productTypeId: null, cost: 0, price: 0, isGenerateCoupons: false, isStockRequired: true };
                    },
                    ProductTypes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.productTypes@query');
                    },
                    Accounts: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.accounts@query');
                    }
                },
            })
            .state('app.catalogs.products.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/products/product/product.html',
                        controller : 'CatalogProductController as vm'
                    }
                },
                resolve  : {
                    Product: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('catalogs.products@get', { id : $stateParams.id });
                    },
                    ProductTypes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.productTypes@query');
                    },
                    Accounts: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.accounts@query');
                    }
                }
            })
            ;

        
        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.products', {
            title: 'Productos',
            shortcuticon  : 'icon-basket',            
            state: 'app.catalogs.products'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.products')
        .controller('ProductsMassiveDialogController', controllerFunction);

    /** @ngInject */
    function controllerFunction($mdDialog, msg, api, $sce, Refresh, msApi)
    {
        var vm = this;
        
        // Data
        _init();

        // Methods
        vm.close = close;
        vm.changeType = changeType;
        vm.checkAllChange = checkAllChange;
        vm.accept = accept;
        ////////

        function _init(){
            vm.product = {};
            vm.productTypes = api.catalogs.productTypes.query();
            vm.loadingTemplate = false;
        }        

        function close(){
            $mdDialog.hide();
        }

        function changeType(){
            vm.loadingTemplate = true;
            api.catalogs.massiveTemplates.get({
                productTypeId: vm.product.productTypeId,
            }, function(response){                
                vm.properties = response.properties;
                
                angular.forEach(vm.properties, function(prop) {
                    prop.isAllChecked = false;
                    prop.addToDescription = true;
                });

                vm.html = $sce.trustAsHtml(response.html);
                vm.loadingTemplate = false;
            });
        }

        function checkAllChange(property){
            angular.forEach(property.options, function(opt) {
                opt.selected = property.isAllChecked;
            });

        }

        function accept(){
            msg.confirm("La carga comenzará y no podra detenerse, desea continuar?", function(){
                vm.product.properties = vm.properties;
                api.catalogs.massiveProducts.save(vm.product, function(response){
                    msg.success("Carga realizada correctamente.");
                    Refresh();
                    close();
                });
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.passes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.passes', {
                url      : '/passes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/passes/passes.html',
                        controller : 'CatalogsPassesController as vm'
                    }
                },
                resolve  : {
                    Passes: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.passes@query');
                    }
                }
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.passes', {
            title: 'Pases y Credenciales',
            state: 'app.catalogs.passes'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.passes')
        .controller('CatalogsPassesMassiveRemoveDialogController', CatalogsPassesMassiveRemoveDialogController);

    /** @ngInject */
    function CatalogsPassesMassiveRemoveDialogController($mdDialog, Callback, api, msg, ChangeStatus)
    {
        var vm = this;        

        _init();

        // Methods
        vm.massiveRemove = massiveRemove;
        vm.closeDialog = closeDialog;
        //////////

        function _init(){
            vm.callback = Callback;
        }
        
        function closeDialog(){
            $mdDialog.hide();
        }

        function massiveRemove(){
            var initNumber = parseInt(vm.initNumber);
            var endNumber = parseInt(vm.endNumber);
            if (endNumber < initNumber){
                msg.error("El número final no puede ser menor al número inicial.")
                return;
            }

            msg.confirm("Esta seguro que desea borrar " + (endNumber - initNumber + 1) + " pase(s)?", function(){
                ChangeStatus("Borrando...");
                api.catalogs.passes.massiveDelete({ initNumber: initNumber, endNumber: endNumber }, function(response){
                    if (response){
                        msg.success("Pases borrados correctamente!");
                        vm.callback();
                        
                        ChangeStatus("Pases borrados correctamente!");
                        closeDialog();
                    }
                }, function(errorResponse){
                    ChangeStatus("Ocurrio un error.");                    
                });
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.passes')
        .controller('CatalogsPassesMassiveAddDialogController', CatalogsPassesMassiveAddDialogController);

    /** @ngInject */
    function CatalogsPassesMassiveAddDialogController($mdDialog, Callback, LastNumber, api, msg, ChangeStatus)
    {
        var vm = this;

        _init();

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;
        //////////

        function _init(){
            vm.lastNumber = LastNumber;
            vm.callback = Callback;
            vm.passTypes = api.catalogs.passTypes.query();
            vm.pass = {
                initNumber: vm.lastNumber + 1
            };
        }
        
        function closeDialog(){
            $mdDialog.hide();
        }

        function save(){
            var initNumber = parseInt(vm.pass.initNumber);
            var endNumber = parseInt(vm.pass.endNumber);
            if (endNumber < initNumber){
                msg.error("El número final no puede ser menor al número inicial.")
                return;
            }

            msg.confirm("Esta seguro que desea agregar " + (endNumber - initNumber + 1) + " pase(s)?", function(){
                vm.pass.initNumber = initNumber;
                vm.pass.endNumber = endNumber;
                ChangeStatus("Guardando...");
                api.catalogs.passes.save(vm.pass, function(response){
                    vm.callback();
                    closeDialog();
                    ChangeStatus("Pases guardados correctamente!");
                }, function(errorResponse){
                    ChangeStatus("Ocurrio un error.");                    
                });
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.accionistas.acciones', [ 
        ])
        .config(accionistasAccionesConfig);

    /** @ngInject */
    function accionistasAccionesConfig($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.accionistas.acciones', {
                url      : '/acciones',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/accionistas/views/acciones/acciones.html',
                        controller : 'AccionistasAccionesController as vm'
                    }
                },
                resolve  : {
                    Acciones: function (apiResolver)
                    {
                        return apiResolver.resolve('accionistas.acciones@query');
                    }
                }
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.accionistas.acciones', {
            title: 'Acciones',
            shortcuticon  : 'icon-cash-multiple',            
            state: 'app.accionistas.acciones'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.accionistas.acciones')
        .controller('AccionistasAccionesMassiveAddDialogController', accionistasAccionesMassiveAddDialogController);

    /** @ngInject */
    function accionistasAccionesMassiveAddDialogController($mdDialog, Callback, api, msg, ChangeStatus)
    {
        var vm = this;

        _init();

        // Methods
        vm.save = save;
        vm.closeDialog = closeDialog;
        //////////

        function _init(){
            vm.callback = Callback;
            vm.item = {
                date: new Date(),
            };
        }
        
        function closeDialog(){
            $mdDialog.hide();
        }

        function save(){
            var initNumber = parseInt(vm.item.initNumber);
            var endNumber = parseInt(vm.item.endNumber);
            if (endNumber < initNumber){
                msg.error("El número final no puede ser menor al número inicial.")
                return;
            }

            msg.confirm("Esta seguro que desea agregar " + (endNumber - initNumber + 1) + " accion(es)?", function(){
                vm.item.initNumber = initNumber;
                vm.item.endNumber = endNumber;
                ChangeStatus("Guardando...");
                api.accionistas.acciones.save(vm.item, function(response){
                    vm.callback();
                    closeDialog();
                    ChangeStatus("Acciones guardadas correctamente!");
                }, function(errorResponse){
                    ChangeStatus("Ocurrio un error al guardar.");                    
                });
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.security', 
            [
                'datatables',
                
                // Security Catalogs
                'app.security.branches',                
                'app.security.users',
                'app.security.userTypes'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.security', {
                abstract: true,
                url     : '/security'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.security', {
            title : 'Seguridad',
            icon  : 'icon-lock',
            weight: 3
        });
    }
})();
(function ()
{
    'use strict';

    var treeViewAccessData = [];

    angular
        .module('app.security')
        .controller('SecurityUserController', securityUserController);

    /** @ngInject */
    function securityUserController($state, User, UserTypes, api, msg, Branches)
    {
        var vm = this;

//         // Methods
        vm.gotoReturn = gotoReturn;
        vm.save = save;
//         //////////

        init();

        function init(){
            vm.item = User;
            vm.userTypes = UserTypes;
            vm.branches = Branches;

            angular.forEach(vm.branches, function(branch){
                if (vm.item && vm.item.branches)
                    branch.selected = vm.item.branches.filter(function(s){ return s.id == branch.id }).length > 0;
            });

        }

        function gotoReturn(){
            $state.go('app.security.users');
        }

        function save(){
            vm.item.branches = [];
            angular.forEach(vm.branches, function(branch){
                if (branch.selected == true)
                    vm.item.branches.push(branch);
            });

            api.security.users.save(vm.item, function(response){
                if (response){
                    msg.success('Usuario guardado correctamente.');
                    if (vm.item.id != 0)
                        $state.go('app.security.users');
                    else
                        vm.item = response;
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.security')
        .controller('SecurityUsersController', controllerFunction);

    /** @ngInject */
    function controllerFunction($state, api, msg)
    {
        var vm = this;

        init();

        function init(){
            api.security.users.query(function(response) { return  vm.users = response }); 
            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px'
                    },
                    {
                        // Target the actions column
                        targets           : 3,
                        responsivePriority: 3,
                        filterable        : false,
                        sortable          : false
                    },
                    {
                        // Target the actions column
                        targets           : 4,
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true
            };
        }

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoDetail = gotoDetail;
        vm.resetPassword = resetPassword;
        //////////

        function gotoAdd()
        {
            $state.go('app.security.users.add');
        }

        function gotoDetail(id){
            $state.go('app.security.users.detail', { id: id });
        }

        function resetPassword(id){
            msg.confirm("Esta seguro que desea reestablecer la contraseña de este usuario?", function(){
                api.security.users.change({
                    changeType: 1 /* reset */,
                    userId: id
                }, function(response){
                    msg.success("Contraseña reestablecida correctamente");
                })
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.security')
        .controller('SecurityBranchesController', securityBranchesController);

    /** @ngInject */
    function securityBranchesController($state, api, CONST_DATATABLES)
    {
        var vm = this;

        init();

        function init(){
            api.catalogs.branches.query(function(response) { return  vm.branches = response }); 
            vm.dtBranchInstance = {};
            vm.dtBranchOptions = angular.copy($.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px'
                    },
                    {
                        // Target the actions column
                        targets           : 3,
                        responsivePriority: 5,
                        sortable          : false
                    },
                    {
                        // Target the actions column
                        targets           : 4,
                        responsivePriority: 1,
                        sortable          : false
                    }
                ],
                initComplete: function (){
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true
            }));
        }

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoDetail = gotoDetail;
        //////////

        function gotoAdd()
        {
            $state.go('app.security.branches.add');
        }

        function gotoDetail(id)
        {
            $state.go('app.security.branches.detail', { id: id });
        }
    }
})();
(function ()
{
    'use strict';

    var treeViewAccessData = [];

    angular
        .module('app.security')
        .controller('SecurityBranchController', securityBranchController);

    /** @ngInject */
    function securityBranchController($state, Branch, api, msg, Warehouses, files)
    {
        var vm = this;

//         // Methods
        vm.gotoReturn = gotoReturn;
        vm.save = save;
        vm.uploadFile = uploadFile;
        vm.uploadCerFile = uploadCerFile;
        vm.uploadKeyFile = uploadKeyFile;
        vm.uploadXsltFile = uploadXsltFile;
        vm.uploadPfxFile = uploadPfxFile;
        vm.zipCodeChange = zipCodeChange;

//         //////////

        init();

        function init(){
            vm.item = Branch;            
            vm.picturesUrl = api.baseUrl.replace("api/","");
            

            vm.discountTypes = [
                { id: 1, name: "Descuento sobre descuento" },
                { id: 2, name: "Descuento sobre total" },
            ];
            
            vm.discountOrders = [
                { id: 1, name: "Beca -> Convenio -> Ausencia" },
                { id: 2, name: "Beca -> Ausencia -> Convenio" },
                { id: 3, name: "Ausencia -> Convenio -> Beca" },
                { id: 4, name: "Ausencia -> Beca  -> Convenio" },
                { id: 5, name: "Convenio -> Beca -> Ausencia" },
                { id: 6, name: "Convenio -> Ausencia -> Beca" },
            ];

            vm.warehouses = Warehouses;

            // Sat Security
            vm.satTaxes = api.sat.taxes.query();
            vm.satTaxTypes = api.sat.taxTypes.query();
            vm.satRegimenFiscales = api.sat.regimenFiscales.query();
            vm.satCoins = api.sat.coins.query();
            vm.satInvoiceTypes = api.sat.invoiceTypes.query();
            vm.satPaymentMethods = api.sat.paymentMethods.query();

            vm.invoicingModes = [
                { name : "Prueba", value: 0 },
                { name : "Produccción", value: 1 },
            ]; 

            if (vm.item.setting.satZipCode){
                vm.zipCode = vm.item.setting.satZipCode.code;
            }
        }

        function gotoReturn(){
            $state.go('app.security.branches');
        }

        function save(){
            if (vm.item.setting.satProduct && vm.item.setting.satUnit ){
                vm.item.setting.satProductId = vm.item.setting.satProduct.id;
                vm.item.setting.satUnitId = vm.item.setting.satUnit.id;
            }

            api.catalogs.branches.save(vm.item, function(response){
                if (response){
                    msg.success('Sucursal guardada correctamente.');
                    if (vm.item.id == 0){
                        vm.item = response;
                    }else
                        $state.go('app.security.branches');
                }
            });
        }

        function uploadFile(){
            files.uploadImage("inputFile", "settings", [
                {
                    key: "branchId",
                    value: vm.item.id
                }
            ],
            function(response){
                msg.success("Imagen guardada correctamente");      
                vm.item.setting.logoFile = response.fileName;
            });
        }

        function uploadCerFile(){
            files.uploadImage("inputFileCertificate", "settings-certificate", [
                {
                    key: "branchId",
                    value: vm.item.id
                }
            ],
            function(response){
                msg.success("Certificado guardado correctamente.");      
                vm.item.setting.certificateFilePath = response.fileName;
                vm.item.setting.certificateFileName = $("#inputFileCertificate").get(0).files[0].name;
                vm.certificateEdit = false;                  
            });
        }

        function uploadKeyFile(){
            files.uploadImage("inputFileKey", "settings-key", [
                {
                    key: "branchId",
                    value: vm.item.id
                }
            ],
            function(response){
                msg.success("Llave guardada correctamente.");    
                vm.item.setting.keyFilePath = response.fileName;
                vm.item.setting.keyFileName = $("#inputFileKey").get(0).files[0].name;
                vm.keyEdit = false;  
            });
        }

        function uploadXsltFile(){
            files.uploadImage("inputFileXslt", "settings-xslt", [
                {
                    key: "branchId",
                    value: vm.item.id
                }
            ],
            function(response){
                msg.success("Cadena original guardada correctamente.");    
                vm.item.setting.satTransformationFilePath = response.fileName;
                vm.xsltEdit = false;  
            });
        }

        function uploadPfxFile(){
            files.uploadImage("inputFilePfx", "settings-pfx", [
                {
                    key: "branchId",
                    value: vm.item.id
                }
            ],
            function(response){
                msg.success("Archivo PFX guardado correctamente.");    
                vm.item.setting.pfxFilePath = response.fileName;
                vm.pfxEdit = false;  
            });
        }

        function zipCodeChange(){            
            vm.validatingZipCode = true;
            vm.item.setting.satZipCode = null;
            vm.item.setting.satZipCodeId = 0;
            api.sat.zipCodes.get({ zipcode: vm.zipCode }, function(response){
                if (response.id){
                    vm.item.setting.satZipCode = response;
                    vm.item.setting.satZipCodeId = response.id;
                }
                vm.validatingZipCode = false;
            }, function(response){
                vm.validatingZipCode = false;                
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.security.userTypes')
        .controller('SecurityUserTypesController', controllerFunction);

    /** @ngInject */
    function controllerFunction($scope, UserTypes, $mdDialog, $document, msg, api, CONST_DATATABLES, $state)
    {

        var vm = this;
        
        _init();

        // Methods
        vm.deleteItem = deleteItem;
        vm.add = add;
        vm.edit = edit;
        //////////

        function _init(){
            vm.items = UserTypes;
            vm.dtUserTypesInstance = {};
            vm.dtUserTypesOptions = angular.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px'
                    },
                    {
                        // Target the status column
                        targets     : 2,
                        filterable  : false,
                        sortable    : false
                    },
                    {
                        // Target the actions column
                        targets           : 3,
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true,
                filter      : true
            });

            vm.items = api.security.userTypes.query();
        }

        function add(){
            $state.go('app.security.userTypes.add');            
        }

        function edit(item)
        {
            $state.go('app.security.userTypes.detail', { id: item.id });
        }

        function deleteItem(item)
        {
            msg.confirm('Estas seguro que deseas borrar este elemento?', function(){
                api.security.userTypes.delete({ id: item.id }, function(response){
                    if (response){
                        api.security.userTypes.query(function(response){
                            vm.items = response;
                            msg.success('Tipo borrado correctamente.');
                        });
                    }
                });
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.security.userTypes')
        .controller('SecurityUserTypeController', securityUserTypeController);

    /** @ngInject */
    function securityUserTypeController(msUtils, api, msg, $state, UserType)
    {
        var vm = this;

        // Methods
        vm.save = save;
        vm.gotoReturn = gotoReturn;
        vm.selectAll = selectAll;
        //////////

        _init();

        function _init(){
            vm.item = angular.copy(UserType);
            if (!vm.item )
            {
                vm.item = {
                    id      : 0,
                    name    : '',
                    active   : true
                };
            }

            // Get Access            
            var treeViewAccessData = [];   
            vm.access = [];         
            api.security.access.query(function(response){
                vm.originalAccess = response;
                angular.forEach(response.filter(function(a) { return a.isMenu; }), function(access){
                    var menu = {
                        id: access.id,
                        label: access.name,
                        children: []                        
                    };

                    angular.forEach(response.filter(function(a) { return a.fatherAccessId == access.id }), function(subAcceso){
                        var submenu = {
                            id: subAcceso.id,
                            label: subAcceso.name,
                            selected: vm.item.access.filter(function(a) { return a.id == subAcceso.id }).length > 0,
                            children: []
                        };
                        
                        angular.forEach(response.filter(function(a) { return a.fatherAccessId == submenu.id }), function(control){
                            submenu.children.push({
                                id      : control.id,
                                label   : control.name,
                                selected: vm.item.access.filter(function(a) { return a.id == control.id }).length > 0,
                            });
                        });

                        menu.children.push(submenu);
                    });
                    treeViewAccessData.push(menu);
                });
                angular.forEach(treeViewAccessData, function(menu){
                    menu.selected = 
                        response.filter(function(x){ return x.fatherAccessId == menu.id }).length == menu.children.filter(function(x){ return x.selected }).length;
                });

                vm.access = treeViewAccessData;                
            });
        }

        function gotoReturn(){
            $state.go("app.security.userTypes");            
        }

        function save(){
            // Access
            vm.item.access = [];
            angular.forEach(vm.access, function(menu){
                // Submenus
                angular.forEach(menu.children, function(subMenu){
                    if (subMenu.selected == true){
                        // Add Submenu Access
                        var access = vm.originalAccess.filter(function(a){ return a.id == subMenu.id });
                        if (access.length > 0){
                            vm.item.access.push({
                                id: access[0].id,
                                name: access[0].name
                            });
                        }

                        // Controls
                        angular.forEach(subMenu.children, function(control){
                            if (control.selected == true){
                                //Add control access
                                var accessControl = vm.originalAccess.filter(function(a){ return a.id == control.id });
                                if (accessControl.length > 0)
                                    vm.item.access.push({
                                        id: accessControl[0].id,
                                        name: accessControl[0].name
                                    });
                            }
                        });
                    }
                });
            });

            // Save Item
            api.security.userTypes.save(vm.item, function(response){
                if (response){
                    msg.success("Tipo de usuario guardado correctamente.")
                    $state.go("app.security.userTypes");
                }
            });
        }

        function selectAll(menu){
            angular.forEach(menu.children, function(submenu){
                submenu.selected = menu.selected;
                angular.forEach(submenu.children, function(control){
                    control.selected = menu.selected;
                });
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersPartnersController', controllerFunction);

    /** @ngInject */
    function controllerFunction($state, api, CONST_DATATABLES, msg, $mdDialog)
    {
        var vm = this;
        vm.keyword = "";
        vm.innerKeyword = "";
        vm.showFamiliars = false;
        vm.total = 0;
        vm.pageIndex = 1;
        vm.pageSize = 10;
        vm.pageTotal = 0;

        _init();

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoDetail = gotoDetail;
        vm.changePayedDatesShow = changePayedDatesShow;
        vm.sendToOrder = sendToOrder;
        vm.showClubAccess = showClubAccess;
        vm.getPartners = getPartners;
        vm.nextPage = nextPage;
        vm.previousPage = previousPage;
        vm.search = search;
        //////////

        function getPartners(){
            api.partners.partners.getByFiltersPaginated({
                keyword: vm.innerKeyword !== "" ? vm.innerKeyword : "empty",
                pageNumber: vm.pageIndex,
                pageSize: vm.pageSize,
                showFamiliars: vm.showFamiliars
            }, function(response) { 
                vm.partners = response.items;
                vm.total = response.total;
                vm.pageTotal = Math.ceil(vm.total / vm.pageSize);
                
                vm.selectedPartner =  (vm.partners.length > 0) 
                    ? vm.partners[0]
                    : null
            }); 
        }
        
        function nextPage(){
            vm.pageIndex++;
            getPartners();
        }
        
        function previousPage(){
            vm.pageIndex--;
            getPartners();
        }

        function search(){
            vm.innerKeyword = vm.keyword;
            vm.pageIndex = 1;
            vm.pageSize = 10;
            getPartners();
        }

        function _init(){
            vm.familiarsFilter = false;
            getPartners();
            vm.dtPartnersInstance = {};
            vm.dtPartnersOptions = angular.copy(
                angular.extend(
                    CONST_DATATABLES.OPTIONS, 
                    {
                        dom         : 'rt',
                        columnDefs  : [
                            {
                                // ID
                                targets           : 0,
                                responsivePriority: 1,
                                filterable        : false,
                                searchable        : false,
                                sortable          : false,
                                type              : 'num'
                            },
                            {
                                // INSCRIPTION DATE
                                targets           : 3,
                                responsivePriority: 2,
                                searchable        : false,
                                sortable          : false
                            },
                            {
                                // PAYED DATE
                                targets           : 4,
                                responsivePriority: 3,
                                searchable        : false,
                                sortable          : false                        
                            }

                        ],
                        pagingType  : 'simple',
                        scrollY     : 'auto',
                        responsive  : true,                
                        filter      : false,
                        order       : [[0, 'asc']]                        
                    }
                )
            );

            vm.picturesUrl = api.baseUrl.replace("api/","");            
        }        

        function gotoAdd(){
            $state.go('app.partners.partners.add');
        }

        function gotoDetail(item){
            var titularId = 0;
            if (item.isFamily){
                titularId = item.parentPartnerId;
            }else
                titularId = item.id;
            $state.go('app.partners.partners.detail', { id: titularId });
        }

        function changePayedDatesShow(ev){
            if (!vm.selectedPartner){
                msg.error("Seleccione Socio para continuar.");
                return;
            }

            if (vm.selectedPartner.isFamily)
                vm.selectedPartner = vm.partners.filter(function(p){ return !p.isFamily && p.id == vm.selectedPartner.parentPartnerId })[0];

            $mdDialog.show({
                controller         : 'PartnersChangePayedDatesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partners/dialogs/dialog-changePayedDates/dialog-changePayedDates.html',
                targetEvent        : ev,
                locals             : {
                    Titular : vm.selectedPartner,
                    Callback : _changePayedDates
                }
            });
        }
        
        function _changePayedDates(){
            getPartners();
        }

        function sendToOrder(item){
            var titularId = 0;
            if (item.isFamily){
                titularId = item.parentPartnerId;
            }else
                titularId = item.id;
            $state.go("app.invoices.add.partner", { id: titularId })
        }        

        function showClubAccess(ev, partner){
            $mdDialog.show({
                controller         : 'PartnersPartnerDialogAccessController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/dialogs/dialog-clubAccess/dialog-clubAccess.html',
                targetEvent        : ev,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals             : {
                    Partner     : partner
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    var treeViewAccessData = [];

    angular
        .module('app.partners')
        .controller('PartnersPartnerController', partnersPartnerController);

    /** @ngInject */
    function partnersPartnerController($state, $mdDialog, $document, Partner, api, msg, Dues, Media, Countries, Agreements, Professions, Genders, ClubAccess, Employees, CalculationModes, utils, PartnerTypes, AccessTimeZones, Branches, settingsService, Acciones, authService)
    {
        var vm = this;

//         // Methods
        vm.gotoReturn = gotoReturn;
        vm.save = save;
        vm.birthdateChange = birthdateChange;

        vm.dueChange = dueChange;
        vm.showAutomaticPayment = showAutomaticPayment;
        vm.sendToOrder = sendToOrder;

        vm.showClubAccess = showClubAccess;
        vm.showAcciones = showAcciones;
        vm.searchAccion = searchAccion;
        vm.partnerTypeChange = partnerTypeChange;

        vm.sendToContract = sendToContract;
        vm.sendToKardex = sendToKardex;
//         //////////

        _init();

        function _init(){
            vm.picturesUrl = api.baseUrl.replace("api/","");            
            vm.item = Partner;
            vm.partnerTypes = PartnerTypes;
            vm.dues = Dues;
            vm.media = Media;
            vm.countries = Countries;
            vm.agreements = Agreements;
            vm.professions = Professions;
            vm.genders = Genders;
            vm.clubAccess = ClubAccess;
            vm.employees = Employees.filter(function(e) { return e.employeeTypeId == 1 /*Seller*/;  })
            vm.calculationModes = CalculationModes;
            vm.accessTimeZones = AccessTimeZones;
            vm.branches = Branches;
            vm.acciones = Acciones.filter(function(a) { return a.accionistaId != null && a.partnerId == null });
            vm.settings = authService.getAppData().settings;          
            
            if (vm.item.accionId != 0)
                vm.accion = vm.item.accion;

            vm.minBirthdate = moment(vm.today).subtract(100, 'years').toDate();
            vm.maxBirthdate = moment(vm.today).subtract(1, 'years').toDate();
            
            vm.birthdate = vm.item.birthdate;            
            birthdateChange();

            var agreements = angular.copy(vm.item.agreements);
            vm.item.agreements = [];
            angular.forEach(agreements, function(x) {
                vm.item.agreements.push(vm.agreements.filter(function(a){ return a.id == x.id })[0]); 
            });
            
            var branches = angular.copy(vm.item.branches);
            vm.item.branches = [];
            angular.forEach(branches, function(ca) {
                vm.item.branches.push(vm.branches.filter(function(branch){ return branch.id == ca.id })[0]); 
            });

            vm.saving = false;

            var duePeriodicityId = vm.item.duePeriodicityId;
            vm.duePrices = [];
            dueChange(function(){
                vm.item.duePeriodicityId = duePeriodicityId;
            });

            if (vm.item.prospectId && vm.item.id == 0){
                api.partners.prospects.get({id : vm.item.prospectId}, function(prospect){
                    vm.item = angular.extend(vm.item, prospect, { id: 0, prospectId: prospect.id });
                });
            }
        }

        function gotoReturn(){
            $state.go('app.partners.partners');
        }

        function save(){
            var isNew = vm.item.id == 0;
            vm.saving = true;
            api.partners.partners.save(vm.item, function(response){
                if (response){
                    msg.success('Socio guardado correctamente.');
                    vm.item = response;
                    
                    var branches = angular.copy(response.branches);
                    vm.item.branches = [];
                    angular.forEach(branches, function(ca) {
                        vm.item.branches.push(vm.branches.filter(function(branch){ return branch.id == ca.id })[0]); 
                    });
        
                    var agreements = angular.copy(response.agreements);
                    vm.item.agreements = [];
                    angular.forEach(agreements, function(x) {
                        vm.item.agreements.push(vm.agreements.filter(function(a){ return a.id == x.id })[0]); 
                    });

                    if (isNew)
                        showClubAccess(null);
                }

                vm.saving = false;
            }, function(){
                vm.saving = false;
            });
        }

        function birthdateChange(){
            if (moment(vm.birthdate) > moment()){
                msg.error("Fecha invalida!");
                return;
            }

            vm.item.birthdate = vm.birthdate;

            var birthdate = moment(vm.birthdate);     
            vm.item.age = utils.calculateAge(birthdate.date(), birthdate.month(),  birthdate.year())               
        }        

        function dueChange(success){
            if (!vm.item || !vm.item.dueId || vm.item.dueId == 0)
                return;
            
            api.catalogs.duePrices.get({ 
                dueId         : vm.item.dueId,
                searchType    : 2,
                searchId      : vm.item.dueId
            }, function(response){
                if (response.length == 0){
                    msg.error("No hay precios vigentes configurados para esa cuota");
                    vm.duePrices = [];
                }else{
                    vm.duePrices = response;
                }
                vm.item.duePeriodicityId = null;
                if (success)
                    success();
            });
        }

        function showAutomaticPayment(ev){
            $mdDialog.show({
                controller         : 'PartnersPartnerAutomaticPaymentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/dialogs/dialog-automaticPayment/dialog-automaticPayment.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    Partner     : vm.item
                }
            });
        }

        function sendToOrder(id){
            $state.go("app.invoices.add.partner", { id: id })
        }

        function showClubAccess(ev){
            $mdDialog.show({
                controller         : 'PartnersPartnerDialogAccessController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/dialogs/dialog-clubAccess/dialog-clubAccess.html',
                targetEvent        : ev,
                escapeToClose: false,
                clickOutsideToClose: false,
                locals             : {
                    Partner     : vm.item
                }
            });
        }

        function showAcciones(ev){
            $mdDialog.show({
                controller         : 'PartnersPartnerDialogAccionesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/partner/dialogs/dialog-acciones/dialog-acciones.html',
                targetEvent        : ev,
                escapeToClose      : true,
                clickOutsideToClose: true,
                locals             : {
                    Acciones     : vm.acciones,
                    Callback     : _accionesCallback
                }
            });
        }

        function _accionesCallback(item){
            var accion = angular.copy(item);
            vm.item.accion = accion;
            vm.item.accionId = accion.id;
            vm.accion = vm.item.accion;
            if (vm.item.partnerTypeId == 2 /*Propietario*/){
                vm.item.fatherLastname = accion.accionista.fatherLastname;
                vm.item.motherLastname = accion.accionista.motherLastname;
                vm.item.name = accion.accionista.name;
            }
        }

        function searchAccion(){
                if (!vm.accion || !vm.accion.serie || vm.accion.serie == '' || !vm.accion.number || vm.accion.number == '')
                    return;

            var accionesFilter = vm.acciones.filter(function(a){ return a.serie.toUpperCase() == vm.accion.serie.toUpperCase() && a.number == vm.accion.number });
            if (accionesFilter.length > 0)
                _accionesCallback(accionesFilter[0]);
            else
                msg.error("Accion no encontrada");
        }

        function partnerTypeChange(){
            switch(vm.item.partnerTypeId){
                case 1:
                    vm.item.accionId = null;
                    vm.item.accion = null;
                    vm.accion = null;
                break;
                case 2:
                    if(vm.item.accionId != null && vm.item.accion){
                        vm.item.fatherLastname = vm.item.accion.accionista.fatherLastname;
                        vm.item.motherLastname = vm.item.accion.accionista.motherLastname;
                        vm.item.name = vm.item.accion.accionista.name;
                    }
                break
            }
        }

        function sendToContract(partnerId){   
            if (!vm.settings.contractLayout || vm.settings.contractLayout === ''){
                $state.go('app.partners.partners.contract', { id: partnerId });
            }else{
                $state.go('app.partners.partners.contract.' + vm.settings.contractLayout, { id: partnerId });
            }
        }

        function sendToKardex(partnerId){
            $state.go('app.partners.partners.kardex', { id: partnerId });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners.partners')
        .controller('PartnersPartnersInfoController', partnersPartnersInfoController);

    /** @ngInject */
    function partnersPartnersInfoController($state, api, msg, $mdDialog)
    {
        var vm = this;

        _init();

        // Methods
        vm.search = search;
        vm.partnerSelect = partnerSelect;
        vm.familiarSelected = familiarSelected;
        vm.goToPartnerDetails = goToPartnerDetails;
        vm.goToPartnerDgoToPartnerCredentialetails = goToPartnerDgoToPartnerCredentialetails;
        vm.showMessages = showMessages;
        vm.showPasses = showPasses;
        vm.showCredential = showCredential;
        //////////

        function _init(){
            vm.picturesUrl = api.baseUrl.replace("api/","");            
            vm.filtersOptions = [
                { id: 1, name: "Familia" },
                { id: 2, name: "Nombre" },
            ];
            vm.filterType = 1;
            vm.titulars = [];
            vm.familiars = [];
            vm.keyword = '';
        }

        function search(){
            if (vm.keyword == '')
            {
                msg.error("Ingrese texto de busqueda");
                return;   
            }else if (vm.filterType == 1 && isNaN(vm.keyword)){
                msg.error("Se esperaba un número");
                return;   
            }

            vm.titulars = [];
            vm.familiars = [];
    
            api.partners.info.get({
                filterType  : vm.filterType,
                keyword     : vm.keyword
            },function(response){
                vm.searchResult = response;                
                if(vm.searchResult.length > 0)
                    partnerSelect(vm.searchResult[0]);
                else
                    msg.error("No se encontraron resultados");                    
            });
        }

        function partnerSelect(item){
            if (vm.selectedPartner == item)
                return;
            vm.selectedPartner = item;
            var parentPartnerId = 0;
            if (item.isFamily){
                parentPartnerId = item.parentPartnerId;
            }else{
                parentPartnerId = item.id; 
            }
            
            // Find All Family partners
            api.partners.info.get({
                filterType  : 1,
                keyword     : item.sequentialNumber
            },function(response){
                vm.familiars = response;
                if (vm.familiars.length > 0)
                    familiarSelected(vm.familiars[0]);
            });
        }
        
        function familiarSelected(item){
            if (vm.selectedFamiliar == item)
                return;
            vm.selectedFamiliar = item;
            if (vm.selectedFamiliar.isFamily)
                vm.selectedTitular = vm.familiars.filter(function(f){ return f.id == vm.selectedFamiliar.parentPartnerId })[0];
            else
                vm.selectedTitular = vm.selectedFamiliar;
            
            vm.inscriptionDate = new Date(vm.selectedFamiliar.inscriptionDate);
            vm.payedDate = new Date(vm.selectedFamiliar.payedDate);
            vm.birthdate = new Date(vm.selectedFamiliar.birthdate);
        }

        function goToPartnerDetails(){
            $state.go('app.partners.partners.detail', { id: vm.selectedTitular.id });
        }

        function goToPartnerDgoToPartnerCredentialetails(){
            $state.go('app.partners.info.credential', { id: vm.selectedFamiliar.id });
        }

        function showMessages(ev){
            $mdDialog.show({
                controller         : 'PartnersPartnerInfoDialogMessagesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/info/dialogs/dialog-messages/dialog-messages.html',
                targetEvent        : ev,
                escapeToClose      : true,
                clickOutsideToClose: false,
                locals             : {
                    Partner     : vm.selectedFamiliar
                }
            });
        }

        function showPasses(ev){
            $mdDialog.show({
                controller         : 'PartnersPartnerInfoDialogPassesController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/info/dialogs/dialog-passes/dialog-passes.html',
                targetEvent        : ev,
                escapeToClose      : true,
                clickOutsideToClose: false,
                locals             : {
                    Partner : vm.selectedFamiliar
                }
            });
        }

        function showCredential(ev){
            $mdDialog.show({
                controller         : 'PartnersPartnerInfoDialogCredentialController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/partners/info/dialogs/dialog-credential/dialog-credential.html',
                targetEvent        : ev,
                escapeToClose      : true,
                clickOutsideToClose: false,
                locals             : {
                    Partner : vm.selectedFamiliar
                }
            });
        }
    }
})();  

(function ()
{
    'use strict';

    angular
        .module('app.inventory.inventories')        
        .controller('InventoryInventoriesController', InventoryInventoriesController);

    /** @ngInject */
    function InventoryInventoriesController($state, api, CONST_DATATABLES, $mdDialog)
    {
        var vm = this;

        init();

        
        // Methods
        vm.add = add;
        vm.save = save;
        //////////
        
        function init(){
            _get();

            vm.dtInventoryInstance = {};
            vm.dtInventoryOptions = angular.copy($.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',         
                columnDefs  :[
                    {
                        targets     : 3,
                        searchable  : false,
                        sortable    : false
                    },
                    {
                        targets     : 4,
                        searchable  : false,
                        sortable    : false
                    },
                ],    
                initComplete: function (){
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                filter: true,
                scrollY     : 'auto',
            }));
            vm.saving = false;
        }

        function _get(){
            api.inventory.inventory.query(function(response){
                vm.inventory = response;
            });
        }

        function add(ev){
            $mdDialog.show({
                templateUrl        : 'app/main/inventory/views/inventories/inventories/dialogs/dialog-inventory/dialog-inventory.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                disableParentScroll: true,
                controller         : "InventoryInventoriesDialogInventoryController",
                controllerAs       : "vm",
                locals             : {
                    Callback : _get,
                },
            });
        }

        function save(item){
            if (item.oldQuantity != item.quantity || item.oldPrice != item.price){
                vm.saving = true;
                api.inventory.inventory.save(item, function(response){
                    vm.selected = response;
                    vm.saving = false;
                });
            }
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.invoices.orders")
    .controller("InvoicesOrdersController", InvoicesOrdersController);

  function InvoicesOrdersController(
    api,
    CONST_DATATABLES,
    msg,
    $state,
    $mdDialog
  ) {
    var vm = this;

    /// Methods
    vm.cancelOrder = cancelOrder;
    vm.getData = getData;
    vm.receipt = receipt;
    vm.coupon = coupon;
    vm.showOrderDetail = showOrderDetail;
    vm.select = select;
    vm.selectAll = selectAll;
    vm.generateInvoice = generateInvoice;
    vm.showInvoiceDetail = showInvoiceDetail;
    vm.showInvoice = showInvoice;
    vm.cancelInvoice = cancelInvoice;
    /////

    _init();

    function _init() {
      var now = moment();
      var from = moment([now.year(), now.month()]);
      var to = moment(from).endOf("month");

      vm.from = from.toDate();
      vm.to = to.toDate();

      getData();
    }

    function _getOrders() {
      api.invoices.orders.getByPeriod(
        {
          from: moment(vm.from).format("DD-MM-YYYY"),
          to: moment(vm.to).format("DD-MM-YYYY"),
        },
        function (response) {
          vm.orders = response;
          _getPartnersFromOrders();
        }
      );
    }

    function _getPartnersFromOrders() {
      vm.partnersInOrders = [];
      angular.forEach(vm.orders, function (order) {
        if (
          vm.partnersInOrders.filter(function (p) {
            return p.id == order.partner.id;
          }).length == 0
        ) {
          vm.partnersInOrders.push(order.partner);
        }
      });
    }

    function getData() {
      _getOrders();
      _getInvoices();
    }

    function receipt(id) {
      $state.go("app.invoices.orders.receipt", { id: id });
    }

    function coupon(id) {
      $state.go("app.invoices.orders.coupon", { id: id, id2: 0, id3: 0 });
    }

    function cancelOrder(item) {
      msg.confirm(
        "Esta seguro que desea cancelar el recibo: " + item.folio + "?",
        function () {
          api.invoices.orders.cancel({ id: item.id }, function (response) {
            msg.success("Recibo cancelado correctamente.");
            _getOrders();
          });
        }
      );
    }

    function showOrderDetail(ev, id) {
      $mdDialog.show({
        controller: "InvoicesOrdersOrderDialogController",
        controllerAs: "vm",
        templateUrl:
          "app/main/invoices/views/orders/orders/dialogs/dialog-order/dialog-order.html",
        targetEvent: ev,
        escapeToClose: true,
        clickOutsideToClose: true,
        locals: {
          OrderId: id,
        },
      });
    }

    vm.ordersSelected = [];
    function select(item) {
      if (item.invoiceId || item.isCanceled) return;

      if (vm.ordersSelected.indexOf(item) == -1) {
        item.selected = true;
        vm.ordersSelected.push(item);
      } else {
        vm.ordersSelected.splice(vm.ordersSelected.indexOf(item), 1);
        item.selected = false;
      }
    }

    vm.selectAllFlag = false;
    function selectAll() {
      vm.ordersSelected = [];
      angular.forEach(
        vm.ordersFiltered.filter(function (o) {
          return !o.invoiceId;
        }),
        function (order) {
          if (vm.selectAllFlag == true) {
            order.selected = true;
            vm.ordersSelected.push(order);
          } else order.selected = false;
        }
      );
    }

    vm.invoiceGenerating = false;
    function generateInvoice(ev) {
      vm.invoiceGenerating = true;
      api.invoices.generate.save(
        vm.ordersSelected,
        function (response) {
          vm.invoice = response;
          vm.invoiceGenerating = false;
          $mdDialog.show({
            templateUrl:
              "app/main/invoices/views/orders/orders/dialogs/dialog-invoice/dialog-invoice.html",
            targetEvent: ev,
            clickOutsideToClose: false,
            escapeToClose: false,
            disableParentScroll: true,
            controller: "InvoicesOrdersInvoiceDialogController",
            controllerAs: "vm",
            locals: {
              Invoice: response,
              Callback: _generateInvoiceCallback,
            },
          });
        },
        function (response) {
          vm.invoiceGenerating = false;
        }
      );
    }

    function _generateInvoiceCallback() {
      getData();
    }

    function _getInvoices() {
      api.invoices.invoices.getByPeriod(
        {
          from: moment(vm.from).format("DD-MM-YYYY"),
          to: moment(vm.to).format("DD-MM-YYYY"),
        },
        function (response) {
          vm.invoices = response;
        }
      );
    }

    function showInvoiceDetail(ev, invoice) {
      api.invoices.invoices.get({ id: invoice.id }, function (response) {
        $mdDialog.show({
          templateUrl:
            "app/main/invoices/views/orders/orders/dialogs/dialog-invoice/dialog-invoice.html",
          targetEvent: ev,
          clickOutsideToClose: false,
          escapeToClose: false,
          disableParentScroll: true,
          controller: "InvoicesOrdersInvoiceDialogController",
          controllerAs: "vm",
          locals: {
            Invoice: response,
            Callback: function () {},
          },
        });
      });
    }

    function showInvoice(invoiceId) {
      $state.go("app.invoices.receipt", { id: invoiceId });
    }

    function cancelInvoice(invoiceId) {
      //   msg.confirm("Estas seguro que deseas cancelar la factura, no se podran deshacer los cambios?", function(){
      //       api.invoices.invoices.delete({ id: invoiceId }, function(response){
      //           msg.success("Factura cancelada correctamente.");
      //           getData();
      //       });
      //   });
      vm.invoiceGenerating = true;
      api.invoices.generate.save(
        vm.ordersSelected,
        function (response) {
          vm.invoice = response;
          vm.invoiceGenerating = false;
          $mdDialog.show({
            templateUrl:
              "app/main/invoices/views/orders/orders/dialogs/dialog-cancel/dialog-cancel.html",
            targetEvent: invoiceId,
            clickOutsideToClose: false,
            escapeToClose: false,
            disableParentScroll: true,
            controller: "InvoicesOrdersCancelDialogController",
            controllerAs: "vm",
            locals: {
              InvoiceId: invoiceId,
              Callback: function (response) {
                msg.success("Factura cancelada correctamente.");
                getData();
              },
            },
          });
        },
        function (response) {
          vm.invoiceGenerating = false;
        }
      );
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.invoices.orders")
    .controller(
      "InvoicesOrdersReceiptController",
      InvoicesOrdersReceiptController
    );

  /** @ngInject */
  function InvoicesOrdersReceiptController($mdDialog, api, msg, Order, $state) {
    var vm = this;
    vm.order = Order;
    vm.picturesUrl = api.baseUrl.replace("api/", "");
    vm.settings = vm.order.branch.setting;
    vm.copies = [];
    vm.emailSending = false;
    if (vm.settings.receiptCopies == 0) {
      msg.error(
        "El numero de copias del recibo es 0, verifique en las configuraciones de la sucursal."
      );
      return;
    } else {
      for (var i = 0; i < vm.settings.receiptCopies; i++) {
        vm.copies.push({ number: i });
      }
    }

    vm.invoiceGenerating = false;
    vm.generateInvoice = function (ev) {
      vm.invoiceGenerating = true;
      api.invoices.generate.save(
        [vm.order],
        function (response) {
          vm.invoice = response;
          vm.invoiceGenerating = false;
          $mdDialog.show({
            templateUrl:
              "app/main/invoices/views/orders/orders/dialogs/dialog-invoice/dialog-invoice.html",
            targetEvent: ev,
            clickOutsideToClose: false,
            escapeToClose: false,
            disableParentScroll: true,
            controller: "InvoicesOrdersInvoiceDialogController",
            controllerAs: "vm",
            locals: {
              Invoice: response,
              Callback: function (invoice) {
                $state.go("app.invoices.receipt", { id: invoice.id });
              },
            },
          });
        },
        function (response) {
          vm.invoiceGenerating = false;
        }
      );
    };

    vm.chageSize = function () {
      var divLetter = document.getElementById("InvoiceLetter");
      var divSeven = document.getElementById("InvoiceSeven");
      var btnChangeSize = document.getElementById("btnChangeSize");
      if (divLetter.classList.contains("invisible")) {
        divLetter.classList.remove("invisible");
        divSeven.classList.add("invisible");
        btnChangeSize.classList.remove("icon-arrow-expand");
        btnChangeSize.classList.add("icon-arrow-collapse");
      } else {
        divLetter.classList.add("invisible");
        divSeven.classList.remove("invisible");
        btnChangeSize.classList.add("icon-arrow-expand");
        btnChangeSize.classList.remove("icon-arrow-collapse");
      }
    };

    vm.sendMail = function(){

      html2canvas(document.querySelector("#InvoiceLetter")).then(function(canvas){
        vm.emailSending = true;
        var data = canvas.toDataURL();
        var docDefinition = {
            content: [{
                image: data,
                width: 500,
            }]
        };

        pdfMake.createPdf(docDefinition).getBase64(function(base64String){
          vm.emailSending = false;
          msg.prompt("Correo Electrónico", "Ingrese correo electrónico", function(email){
            vm.emailSending = true;
            if (!email || email == ''){
                msg.error("Correo electrónico inválido. verifique");
                return;
            }

            api.invoices.orders.email({
                invoiceId: vm.order.id,
                invoiceFolio : vm.order.folio,
                email: email,
                base64String: base64String
            }, function(response){
              vm.emailSending = false;
              msg.success("Correo Electrónico enviado correctamente.");
            }, function(error){
              vm.emailSending = false;
            });
          }, null, null, vm.order.partner.email);
        });
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.invoices.orders")
    .controller("InvoicesOrderController", invoicesOrderController);

  /** @ngInject */
  function invoicesOrderController(
    $state,
    $scope,
    api,
    msg,
    $mdDialog,
    $document,
    PaymentMethods,
    PaymentMethodOptions,
    Tpvs,
    Partner,
    Partners
  ) {
    var vm = this;

    _init();

    function _init() {
      vm.picturesUrl = api.baseUrl.replace("api/", "");
      vm.order = {};

      _initStep1();
      _initStep2();
    }

    // Step 1 - Calculo de cuotas y selección de productos

    //// Methods
    vm.calculate = calculate;
    vm.searchPartnerByCode = searchPartnerByCode;
    vm.searchProduct = searchProduct;
    vm.searchProductByCode = searchProductByCode;
    vm.showDiscountDialog = showDiscountDialog;
    vm.productRemove = productRemove;
    vm.cleanDiscount = cleanDiscount;
    vm.cleanAll = cleanAll;
    vm.cleanInterests = cleanInterests;
    vm.detailEditShow = detailEditShow;
    vm.productQuantityChange = productQuantityChange;
    //////////

    function _initStep1() {
      vm.partners = Partners;
      vm.titulares = vm.partners.filter(function (p) {
        return !p.isFamily;
      });
      vm.order.details = [];
      (vm.order.calcDate = new Date()),
        (vm.order.subtotal = 0),
        (vm.order.discountAmmount = 0),
        (vm.order.total = 0);

      if (Partner.id != 0) {
        vm.partnerSeachCode = Partner.sequentialNumber;
        vm.order.partner = Partner;
        calculate();
      }
    }

    $scope.$watch("vm.order.partner", function (newValue) {
      if (newValue && !newValue.birthdate) {
        api.partners.partners.get({ id: newValue.id }, function (response) {
          vm.order.partner = response;
          console.log("Partner asignado: " + response.id);
        });
      }
    });

    function searchPartnerByCode() {
      if (!vm.partnerSeachCode || vm.partnerSeachCode == "") {
        msg.error("Ingrese código de socio");
        return;
      }
      var filter = vm.titulares.filter(function (p) {
        return p.sequentialNumber == vm.partnerSeachCode;
      });

      if (filter && filter.length > 0) {
        vm.order.partner = filter[0];
        calculate();
      } else {
        msg.error("El socio no existe, verifique.");
        vm.partnerSeachCode = "";
      }
    }

    function calculate() {
      if (!vm.order.partner || !vm.order.calcDate) {
        msg.error("Seleccione socio y fecha de calculo para continuar");
        return;
      }

      vm.calculating = true;
      // Verificar si hay turno del día abierto
      api.invoices.turns.get(
        {
          dateIni: moment().format("DD-MM-YYYY"),
        },
        function (response) {
          var turns = response;
          if (turns.length == 0) {
            vm.calculating = false;
            msg.error("No hay turno abierto");
            _showTurns();
            return;
          }
          if (vm.order.details.length > 0) {
            msg.confirm(
              "Los detalles actuales de borraran esta seguro que desea recalcular?",
              function () {
                _calculate();
              },
              function () {
                vm.calculating = false;
              }
            );
          } else _calculate();
        }
      );
    }

    vm.calculating = false;
    function _calculate() {
      // Check incompletePeriods
      api.invoices.calculation.check(
        {
          partnerId: vm.order.partner.id,
          calculationDate: moment(vm.order.calcDate).format("DD-MM-YYYY"),
        },
        function (response) {
          var filter = response.filter(function (p) {
            return p.isIncomplete && p.type == 2 /*ByClass*/;
          });
          if (filter.length > 0) {
            $mdDialog.show({
              templateUrl:
                "app/main/invoices/views/orders/order/dialogs/dialog-incompletePeriods/dialog-incompletePeriods.html",
              disableParentScroll: true,
              controller: "InvoicesOrderDialogIncompletePeriodsController",
              controllerAs: "vm",
              locals: {
                Periods: filter,
                Callback: __calculate,
              },
            });
            vm.calculating = false;
          } else {
            __calculate();
          }
        }
      );
    }

    function __calculate(periods) {
      vm.calculating = true;
      vm.order.details = [];

      // Get messages
      api.partners.messages.getByFamily(
        {
          familyId: vm.order.partner.familyId,
        },
        function (response) {
          vm.partnerMessages = response.filter(function (m) {
            return !m.isViewed && m.isVisibleInOrder;
          });
          if (vm.partnerMessages.length > 0) {
            $mdDialog.show({
              templateUrl:
                "app/main/invoices/views/orders/order/dialogs/dialog-messages/dialog-messages.html",
              clickOutsideToClose: true,
              escapeToClose: true,
              disableParentScroll: true,
              controller: "InvoicesOrderDialogMessagesController",
              controllerAs: "vm",
              locals: {
                Messages: vm.partnerMessages,
              },
            });
          }
        }
      );

      // Check Dues Rules
      api.catalogs.duesRules.checkByPartnerId(
        { id: vm.order.partner.id },
        function (duesRulesResponse) {
          // if array: show messages
          if (duesRulesResponse.length > 0) {
            // Show messages
            for (var i = 0; i < duesRulesResponse.length; i++) {
              var message = duesRulesResponse[i].message;
              alert(message);
            }
          }

          // Calculate
          api.invoices.calculation.calculate(
            {
              partnerId: vm.order.partner.id,
              calculationDate: vm.order.calcDate,
              incompletePeriods: periods,
            },
            function (response) {
              vm.calculating = false;
              vm.order.details = response;
              _updateTotals();
            },
            function () {
              vm.calculating = false;
            }
          );
        }
      );

      // Get titular due data
      api.catalogs.dues.get(
        { id: vm.order.partner.dueId },
        function (response) {
          vm.due = response;
        }
      );
    }

    function _showTurns() {
      $mdDialog.show({
        templateUrl:
          "app/main/invoices/views/orders/order/dialogs/dialog-turns/dialog-turns.html",
        // clickOutsideToClose: true,
        // escapeToClose      : true,
        disableParentScroll: true,
        controller: "InvoicesOrderDialogTurnsController",
        controllerAs: "vm",
        locals: {
          Callback: _turnsCallback,
        },
      });
    }

    function _turnsCallback(turn) {
      _calculate();
    }

    function searchProductByCode() {
      var code = angular.copy(vm.codeToSearch);
      vm.codeToSearch = "";
      api.inventory.products.get(
        {
          code: code,
        },
        function (response) {
          if (!response.id || response.id === 0) {
            msg.error("No existe el código en el inventario.");
            return;
          } else if (
            response.product.isStockRequired &&
            response.quantity == 0
          ) {
            msg.error("No hay disponibilidad del producto.");
            return;
          }
          _searchProductCallback(response);
        }
      );
    }

    function _updateTotals() {
      if (vm.order.details.length > 0) {
        vm.order.subtotal =
          vm.order.details
            .map(function (x) {
              return x.subtotal;
            })
            .reduce(function (a, b) {
              return a + b;
            })
            .toFixed(2) / 1;
        vm.order.interests =
          vm.order.details
            .map(function (x) {
              return x.interest;
            })
            .reduce(function (a, b) {
              return a + b;
            })
            .toFixed(2) / 1;
        vm.order.discountAmmount =
          vm.order.details
            .map(function (x) {
              return x.discountAmmount;
            })
            .reduce(function (a, b) {
              return a + b;
            })
            .toFixed(2) / 1;
        vm.order.total =
          vm.order.details
            .map(function (x) {
              return x.total;
            })
            .reduce(function (a, b) {
              return a + b;
            })
            .toFixed(2) / 1;
      } else {
        vm.order.subtotal = 0;
        vm.order.interests = 0;
        vm.order.discountAmmount = 0;
        vm.order.total = 0;
      }
      vm.payment.ammount = (vm.order.total - vm.order.payed).toFixed(2) / 1;
      _updatePayed();
    }

    function searchProduct(ev) {
      $mdDialog.show({
        templateUrl:
          "app/main/invoices/views/orders/order/dialogs/dialog-products/dialog-products.html",
        parent: angular.element($document.find("#content-container")),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        disableParentScroll: true,
        controller: "InvoicesOrderDialogProductController",
        controllerAs: "vm",
        locals: {
          Callback: _searchProductCallback,
        },
      });
    }

    function _searchProductCallback(inventory) {
      var filter = vm.order.details.filter(function (d) {
        return d.productId == inventory.productId && d.detailType == 0;
      });
      if (filter.length == 0) {
        vm.order.details.push({
          productId: inventory.product.id,
          description: inventory.product.name,
          price: inventory.price,
          quantity: 1,
          subtotal: inventory.price,
          discountAmmount: 0,
          discountPercentage: 0,
          interest: 0,
          total: inventory.price,
          periodDate: new Date(),
          initialPeriodDate: new Date(),
          detailType: 0,
        });
      } else {
        filter[0].quantity = filter[0].quantity + 1;
        productQuantityChange(filter[0]);
      }

      _updateTotals();
    }

    function productRemove(item) {
      msg.confirm("Esta seguro que desea borrar este producto?", function () {
        var deletable = true;
        if (item.serialDelete) {
          angular.forEach(vm.order.details, function (d) {
            if (
              d.detailType == item.detailType &&
              d.serialDelete &&
              d.serialDelete > item.serialDelete &&
              item.partnerId &&
              item.partnerId == d.partnerId
            ) {
              deletable = false;
              return;
            }
          });
        }
        if (!deletable) {
          msg.error(
            "No se puede borrar este registro, debe borrar primero los registros con fecha posterior."
          );
          return;
        }
        vm.order.details.splice(vm.order.details.indexOf(item), 1);
        msg.success("Producto borrado correctamente.");
        _updateTotals();
      });
    }

    function showDiscountDialog(ev, item) {
      $mdDialog.show({
        templateUrl:
          "app/main/invoices/views/orders/order/dialogs/dialog-discount/dialog-discount.html",
        parent: angular.element($document.find("#content-container")),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        disableParentScroll: true,
        controller: "InvoicesOrderDiscountDialogController",
        controllerAs: "vm",
        locals: {
          ApplyDiscount: _discountAccept,
          Product: item,
        },
      });
    }

    function _discountAccept(product, discount) {
      if (product) {
        _applyDiscount(product, discount);
      } else {
        angular.forEach(vm.order.details, function (p) {
          _applyDiscount(p, discount);
        });
      }
    }

    function _applyDiscount(product, discount) {
      if (!discount) return;
      var discountAmmount = 0;
      if (product.quantity) product.subtotal = product.price * product.quantity;
      else product.subtotal = product.price;
      if (discount.type == 1) {
        // Ammount
        if (discount.ammount > product.subtotal)
          discountAmmount = product.subtotal;
        else discountAmmount = discount.ammount;
      } else if (discount.type == 2) {
        // Percentage
        discountAmmount = product.subtotal * (discount.ammount / 100);
      }

      product.subtotal = product.subtotal;
      product.total = product.subtotal - discountAmmount + product.interest;
      product.discountType = discount.type;
      product.discount = discount.ammount;
      product.discountAmmount = discountAmmount;

      _updateTotals();
    }

    function cleanDiscount() {
      msg.confirm(
        "Todos los DESCUENTOS seran borrados, desea continuar?",
        function () {
          angular.forEach(vm.order.details, function (detail) {
            _applyDiscount(detail, {
              type: 1,
              ammount: 0,
            });
          });
          _updateTotals();
        }
      );
    }

    function cleanAll() {
      msg.confirm(
        "Todos los PRODUCTOS/SERVICIOS serán borrados, desea continuar?",
        function () {
          vm.order.details = [];
          _updateTotals();
        }
      );
    }

    function cleanInterests() {
      msg.confirm(
        "Todos los INTERESES seran borrados, desea continuar?",
        function () {
          angular.forEach(vm.order.details, function (detail) {
            detail.interest = 0;
            detail.total =
              detail.price * detail.quantity +
              detail.interest -
              detail.discountAmmount;
          });
          _updateTotals();
        }
      );
    }

    function detailEditShow(ev, detail) {
      $mdDialog.show({
        templateUrl:
          "app/main/invoices/views/orders/order/dialogs/dialog-edit/dialog-edit.html",
        parent: angular.element($document.find("#content-container")),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        disableParentScroll: true,
        controller: "InvoicesOrderDialogEditController",
        controllerAs: "vm",
        locals: {
          Callback: _detailEditCallback,
          Detail: detail,
        },
      });
    }

    function _detailEditCallback(oldItem, newItem) {
      vm.order.details[vm.order.details.indexOf(oldItem)] = newItem;
      _updateTotals();
    }

    function productQuantityChange(productDetail) {
      if (productDetail.detailType && productDetail.detailType != 0) {
        msg.error("No se puede cambiar la cantidad de este producto");
        productDetail.quantity = 1;
        return;
      }

      productDetail.subtotal = productDetail.price * productDetail.quantity;
      productDetail.total = productDetail.subtotal;

      _applyDiscount(productDetail, {
        type: productDetail.discountType,
        ammount: productDetail.discount,
      });
      _updatePayed();
      _updateTotals();
    }
    //// Step 1

    // Step 2 - Forma de pago
    /// Methods
    vm.paymentMethodChange = paymentMethodChange;
    vm.addPayment = addPayment;
    vm.paymentRemove = paymentRemove;
    vm.generateNotes = generateNotes;
    /////

    function _initStep2() {
      vm.paymentMethods = PaymentMethods;
      vm.options = angular.copy(PaymentMethodOptions);
      vm.tpvs = Tpvs;

      vm.order.payments = [];
      vm.order.address = {};
      vm.order.partnerAddresses = [];
      vm.order.payed = 0;
      vm.modifyAddress = false;
      _newPayment();
    }

    function _newPayment() {
      vm.payment = {};
      if (vm.paymentMethods && vm.paymentMethods.length > 0)
        vm.payment.paymentMethod = vm.paymentMethods[0];
    }

    function paymentMethodChange() {
      vm.payment.paymentMethodId == vm.payment.paymentMethod.id;
      vm.paymentMethodOptions = vm.options.filter(function (o) {
        return o.paymentMethodId === vm.payment.paymentMethod.id;
      });
      vm.payment.paymentMethodOption = null;
    }

    function addPayment() {
      // Si ya existe efectivo
      var paymentFilter = vm.order.payments.filter(function (p) {
        return p.paymentMethod.id == vm.payment.paymentMethod.id;
      });
      if (
        vm.payment.paymentMethod.name.toLowerCase() == "efectivo" &&
        paymentFilter.length > 0
      )
        paymentFilter[0].ammount =
          paymentFilter[0].ammount + vm.payment.ammount;
      else vm.order.payments.push(angular.copy(vm.payment));
      _newPayment();
      vm.paymentMethodOptions = [];
      _updatePayed();
    }

    function _updatePayed() {
      if (vm.order.payments.length > 0)
        vm.order.payed =
          vm.order.payments
            .map(function (x) {
              return x.ammount;
            })
            .reduce(function (a, b) {
              return a + b;
            })
            .toFixed(2) / 1;
      else vm.order.payed = 0;
      vm.payment.ammount = (vm.order.total - vm.order.payed).toFixed(2) / 1;
    }

    function paymentRemove(item) {
      vm.order.payments.splice(vm.order.payments.indexOf(item), 1);
      msg.success("Pago borrado correctamente");
      _updatePayed();
    }

    $scope.$watch("vm.order.partner", function (newPartner) {
      if (!newPartner) return;
      api.partners.addresses.query(
        { partnerId: newPartner.id },
        function (response) {
          vm.partnerAddresses = response;
          if (response.length > 0) {
            var filter = response.filter(function (a) {
              return a.isDefault;
            });
            if (filter && filter.length > 0) vm.order.address = filter[0];
            else vm.order.address = response[0];
          }
        }
      );
    });

    function generateNotes() {
      var monthsAbrevs = [
        { month: 1, abrev: "ene" },
        { month: 2, abrev: "feb" },
        { month: 3, abrev: "mzo" },
        { month: 4, abrev: "abr" },
        { month: 5, abrev: "may" },
        { month: 6, abrev: "jun" },
        { month: 7, abrev: "jul" },
        { month: 8, abrev: "ago" },
        { month: 9, abrev: "sep" },
        { month: 10, abrev: "oct" },
        { month: 11, abrev: "nov" },
        { month: 12, abrev: "div" },
      ];

      var notes = "";
      angular.forEach(vm.order.details, function (detail) {
        if (detail.detailType == 1 /*Cuotas*/) {
          var periodicityAbrev = "";
          var description = detail.description.toLowerCase();
          if (description.indexOf("anual") != -1) {
            periodicityAbrev = "anu";
          } else if (description.indexOf("semestral") != -1) {
            periodicityAbrev = "sem";
          } else if (description.indexOf("trimestral") != -1) {
            periodicityAbrev = "trim";
          } else if (description.indexOf("mensual") != -1) {
            periodicityAbrev = "men";
          } else if (description.indexOf("semanal") != -1) {
            periodicityAbrev = "sem";
          }

          var periodNote = "";
          var initPeriodDate = moment(detail.initPeriodDate);
          var endPeriodDate = moment(detail.endPeriodDate);
          if (initPeriodDate.month() == endPeriodDate.month())
            periodNote =
              initPeriodDate.format("DD") +
              "-" +
              endPeriodDate.format("DD") +
              monthsAbrevs.filter(function (m) {
                return m.month == initPeriodDate.month() + 1;
              })[0].abrev;

          notes = notes + "Cuota " + periodicityAbrev + " " + periodNote + ", ";
        }
      });

      if (vm.order.payments.length > 0) notes = notes + "- ";
      angular.forEach(vm.order.payments, function (payment) {
        var paymentAbrev = "";
        if (payment.paymentMethod.name.length > 3)
          paymentAbrev = payment.paymentMethod.name.substring(0, 3);
        else paymentAbrev = payment.paymentMethod.name;

        if (payment.reference && payment.reference != "")
          notes = notes + paymentAbrev + " " + payment.reference + "/";
        else notes = notes + paymentAbrev + "/";
      });

      vm.order.notes = notes.toUpperCase();
    }
    //// Step 2

    // Step 3 - Preview
    /// Methods
    vm.saveOrder = saveOrder;
    /////

    function saveOrder() {
      vm.order.sending = true;
      vm.order.zipcode = vm.order.address.zipCode;
      api.invoices.orders.save(
        vm.order,
        function (response) {
          msg.success("Recibo guardado correctamente.");
          $state.go("app.invoices.orders.receipt", { id: response.id });
          vm.order.sending = false;
        },
        function (errorResponse) {
          vm.order.sending = false;
        }
      );
    }

    //// Step 3
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices.orders')
        .controller('InvoicesOrdersCouponController',InvoicesOrdersCouponController);

    /** @ngInject */
    function InvoicesOrdersCouponController($mdDialog, api, msg, Order, $state)
    {
        var vm = this;
        vm.order = Order;
        vm.picturesUrl = api.baseUrl.replace("api/","");
        vm.settings = vm.order.branch.setting;
        vm.products = Order.details[0].product;
        vm.range = new Array(Order.details[0].product.couponNumber);
        vm.partner = Order.partner;
        
        vm.copies = [];
        if (vm.products.couponNumber == 0)
        {
            msg.error("Este Recibo/Factura no contiene cupones");
            return;
        }else{
            for(var i = 0; i < vm.products.couponNumber; i++ ){
                vm.copies.push({ number: i });
            }
        }

        vm.imageSaving = true;
        vm.emailSending = false;
        
        vm.logoSource = "data:image/jpeg;base64, " + vm.settings.logoBase64String;
        
        vm.invoiceGenerating = false;
        vm.generateInvoice = function(ev){
            vm.invoiceGenerating = true;
            api.invoices.generate.save([vm.order], function(response){
                vm.invoice = response;
                vm.invoiceGenerating = false;
                $mdDialog.show({
                    templateUrl        : 'app/main/invoices/views/orders/orders/dialogs/dialog-invoice/dialog-invoice.html',
                    targetEvent        : ev,
                    clickOutsideToClose: false,
                    escapeToClose      : false,
                    disableParentScroll: true,
                    controller         : "InvoicesOrdersInvoiceDialogController",
                    controllerAs       : "vm",
                    locals             : {
                        Invoice   : response,
                        Callback : function(invoice){
                            $state.go("app.invoices.receipt", { id: invoice.id });
                        }
                    },
                });
            }, function(response){
                vm.invoiceGenerating = false;
            });            
        }        
    }
})();
(function(){
	'use strict';

    angular
        .module('app.invoices.complements', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.invoices.complements', {
                url      : '/complements',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/complements/complements.html',
                        controller : 'InvoicesComplementsController as vm'
                    }
                }
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.invoices.complements', {
            title: 'Complementos',
            shortcuticon  : 'icon-plus',                        
            state: 'app.invoices.complements'
        });
    }
})();
(function () {
  "use strict";

  angular
    .module("app.invoices.complements")
    .controller(
      "InvoicesComplementsCancelDialogController",
      invoicesComplementsCancelDialogController
    );

  /** @ngInject */
  function invoicesComplementsCancelDialogController(
    $mdDialog,
    msg,
    Callback,
    ComplementId,
    api,
    $state
  ) {
    var vm = this;

    init();

    // Methods
    vm.accept = accept;
    vm.close = close;
    ////////

    function init() {
      vm.title = "CANCELAR COMPLEMENTO";
      vm.catInvoiceCancellationReason = "";
      vm.complementId = ComplementId;
      vm.callback = Callback;
      vm.paymentConditions = "";      
      vm.catInvoiceCancellationReasons =
        api.sat.catInvoiceCancellationReasons.query();
    }

    vm.sending = false;
    function accept() {
      msg.confirm(
        "Estas seguro que deseas cancelar el complemento, no se podran deshacer los cambios?",
        function () {
          api.invoices.complements.cancel(
            {
              complementId: vm.complementId,
              invoiceCancellationReasonId: vm.catInvoiceCancellationReason.id,
              UuidReference: vm.paymentConditions
            },
            function (response) {
              msg.success("Complemento cancelado correctamente.");              
              vm.sending = false;
              
              if (vm.callback) vm.callback(response);
              close();              
            }
          );
        }
      );
    }

    function close() {
      $mdDialog.hide();
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices.notasCredito')
        .controller('InvoicesNotasCreditoController', invoicesNotasCreditoController);

    /** @ngInject */
    function invoicesNotasCreditoController(api, msg, NotasCredito, $mdDialog, $state)
    {
        var vm = this;
        _init();

        // Methods
        vm.showNotaCredito = showNotaCredito;
        vm.getNotasCredito = getNotasCredito;
        vm.view = view;
        ////////

        
        function _init(){
            var now = moment();
            var from = moment([now.year(), now.month()]);
            var to = moment(from).endOf('month');
            
            vm.from = from.format('MM/DD/YYYY');
            vm.to = to.format('MM/DD/YYYY');
            
            vm.notasCredito = [];
            getNotasCredito();
        }
        
        function getNotasCredito(){
            api.invoices.notasCredito.get({
                from: moment(vm.from).format("DD-MM-YYYY"), 
                to: moment(vm.to).format("DD-MM-YYYY")
            },function(response){
                vm.notasCredito = response;
            });
        }

        function showNotaCredito(ev, nota){
            $mdDialog.show({
                controller         : 'InvoicesNotasCreditoDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/invoices/views/notasCredito/notasCredito/dialogs/dialog-nota-credito/dialog-nota-credito.html',
                targetEvent        : ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals             : {
                    NotaCredito : nota
                }
            });
        }

        function view(id){
            console.log('hola');            
            $state.go("app.invoices.receipt", { id: id, type: "creditNote" });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.rentableZones')
        .controller('CatalogsRentableZoneController', rentableZoneController);

    /** @ngInject */
    function rentableZoneController(api, msg, $state, CONST_DATATABLES, RentableZone, $mdDialog, $document){
        var vm = this;
        _init();

        // Methods
        vm.returnBack = returnBack;
        vm.save = save;
        vm.generateMatrix = generateMatrix;
        vm.configSelected = configSelected;

        vm.showPrices = showPrices;
        vm.priceDelete = priceDelete;
        //////////

        function _init(){
            // Data
            vm.item = RentableZone;
            vm.rentablesGenerated = false;
            vm.saving = false;
            vm.startNumber = 1;
            
            if (vm.item && vm.item.id > 0){
                _getPrices();
            }

            // Sat Catalogs
            vm.satTaxes = api.sat.taxes.query();
            vm.satTaxTypes = api.sat.taxTypes.query();

            api.partners.rentables.getByRentableZone({familyId: 0, rentableZoneId: vm.item.id }, function(response){
                vm.assignedRentables = response;
            })
        }
        
        function returnBack(){
            $state.go("app.catalogs.rentableZones");
        }

        function _save(){
            if (!vm.item.satProduct || !vm.item.satProduct.id || !vm.item.satUnit || !vm.item.satUnit.id)
            {
                msg.error("Seleccione producto del SAt y Unidad del SAT.");
                vm.saving = false;
                return;
            }
            vm.item.satProductId = vm.item.satProduct.id;
            vm.item.satUnitId = vm.item.satUnit.id;
            // Save Item
            api.catalogs.rentableZones.save(
                vm.item,
                function(response){
                    msg.success("Zona de rentables guardada correctamente.");
                    if (vm.item.id == 0)
                        vm.item = response;
                    else
                        $state.go("app.catalogs.rentableZones");
                    vm.saving = false;
                }, function(errorResponse){
                    vm.saving = false;
                });
        }

        function save(){
            vm.saving = true;
            if (vm.item.id == 0){
                _save();
                return;
            }
            
            // Get rentables config
            var rentables = $("#matrix td.selected");
            if (vm.item.id != 0 && rentables.length == 0){
                msg.confirm("NO HA CONFIGURADO NINGUN CASILLERO, Desea continuar?", _save);
                return;                
            }

            if (rentables.length > 0){
                msg.confirm("Esta seguto que desea guardar la configuración para " + rentables.length + " rentables", function(){
                    vm.item.rentables = [];
                    rentables.each(function() {
                        var id = $(this).attr("id");
                        var hdn = $(this).find("input[type='hidden']");
                        var name = $(this).html();
                        vm.item.rentables.push({
                            id: hdn && hdn.val() && hdn.val() != '' ? parseInt(hdn.val()) : 0,
                            matrixId: id,
                            name: name,
                            rentableZoneId: vm.item.id,
                            active: true
                        });
                    });
                    
                    _save();
                }, function(){
                    vm.saving = false;                
                });
                return;
            }
        }

        function generateMatrix(){
            // Clear table             
            $("#matrix").remove(); 

            var table = document.createElement("TABLE");
            table.id = "matrix";

            // Create table
            var counter = 1;
            var width = 700 / vm.item.matrixColumns;
            var height = 500 / vm.item.matrixRows;
            for(var row = 0; row < vm.item.matrixRows; row++){
                var htmlRow = document.createElement("TR");
                for(var col = 0; col < vm.item.matrixColumns; col++){                
                    var cell = document.createElement("TD");
                    cell.id = counter;
                    cell.style.width = width + 'px';
                    cell.style.height = height + 'px';
                    // var inp = document.createElement("INPUT");
                    // cell.appendChild(inp);
                    // htmlCol.innerHTML = counter;
                    htmlRow.appendChild(cell);
                    counter++;
                }
                table.appendChild(htmlRow);
            }

            $("#matrix-container").html(table);

            
            if (vm.item.rentables && vm.item.rentables.length > 0){
                $("#matrix td").each(function(index){
                    var id = $(this).attr("id");
                    var filter = vm.item.rentables.filter(function(l){
                        return l.matrixId ==  id;
                    });
                    if (filter.length > 0){
                        
                        $(this).html("<input type='hidden' id='hdn_" + filter[0].id + "' value='" + filter[0].id + "' />" + filter[0].name);
                        $(this).addClass("selected");

                        if (vm.assignedRentables.filter(function(partnerRentable){ return partnerRentable.rentableId == filter[0].id }).length > 0){
                            $(this).addClass("ignore");
                        }                            
                    }
                });
            }

            // Rebind events
            $("#matrix td")
                .mousedown(function () {
                    isMouseDown = true;
                    if (!$(this).hasClass("ignore")){
                        // Numeration
                        if (!$(this).hasClass("selected")){
                            $(this).html($("#prefix").val() + ($("#matrix td.selected").length + parseInt($("#startNumber").val())) + $("#postfix").val());
                        }else{
                            // Get number and check if is last to Delete
                            var html = $(this).html();
                            var posibleNumber = html.substring(html.length - 2, html.length);
                            var number = 0;
                            if (isNaN(posibleNumber))
                                number = parseInt(posibleNumber.substring(1,2));
                            else
                                number = parseInt(posibleNumber);
                            // If is Last then delete html else show error
                            if (parseInt(number) && parseInt(number) == $("#matrix td.selected").length)
                                $(this).html("");
                            else{
                                msg.error("Comience a borrar a partir del último casillero.");
                                return;
                            }
                        }
                        $(this).toggleClass("selected");
                        isHighlighted = $(this).hasClass("selected");
                    }
                    return false; // prevent text selection
                })
                .mouseover(function () {
                    if (isMouseDown) {
                        if (!$(this).hasClass("ignore")){
                            // Numeration
                            if (!$(this).hasClass("selected") && isHighlighted){
                                $(this).html($("#prefix").val() + ($("#matrix td.selected").length + parseInt($("#startNumber").val())) + $("#postfix").val());
                            }else if(!isHighlighted){
                                $(this).html("");
                            }
                            $(this).toggleClass("selected", isHighlighted);
                        }
                    }
                })
                .bind("selectstart", function () {
                    return false;
                });
        }

        function configSelected(){
            if (vm.item && vm.item.matrixRows > 0 && vm.item.matrixColumns > 0){
                generateMatrix();
                vm.rentablesGenerated = true;
            }
        }

        // Prices
        function _getPrices(){
            if (vm.item && vm.item.id != 0)
                vm.prices = api.catalogs.rentableZonePrices.query({ rentableZoneId: vm.item.id });
        }

        function showPrices(ev, rentableZoneId, priceGroupId){
            $mdDialog.show({
                templateUrl        : 'app/main/catalogs/views/rentable-zones/rentable-zone/dialogs/dialog-prices/dialog-prices.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                disableParentScroll: true,
                controller         : "CatalogsRentableZonesPricesDialogController",
                controllerAs       : "vm",
                locals             : {
                    Callback : _priceCallback,
                    PriceGroupId   : priceGroupId,
                    RentableZoneId : rentableZoneId
                },
            });            
        }

        function _priceCallback(){
            _getPrices();
        }

        function priceDelete(groupId){
            msg.confirm("Esta seguro que desea borrar este precio?", function(){
                api.catalogs.rentableZonePrices.delete({ groupId: groupId }, function(){
                    msg.success("Precio borrado correctamente.");
                    _getPrices();
                });
            })
        }

        // /Prices
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.rentableZones')
        .controller('CatalogsRentableZonesController', CatalogsRentableZonesController);

    /** @ngInject */
    function CatalogsRentableZonesController($scope, RentableZones, $mdDialog, $document, msg, api, CONST_DATATABLES, $state)
    {
        var vm = this;
        _init();

        // Methods
        vm.add = add;
        vm.detail = detail;
        vm.remove = remove;
        //////////

        function _init(){
            // Data
            _refresh();
            vm.dtInstance = {};
            vm.dtOptions = angular.copy(angular.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px',
                        responsivePriority: 0,
                    },
                    {
                        // Target the actions column
                        targets           : 3,
                        responsivePriority: 2,
                        filterable        : false,
                        sortable          : false
                    },
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true
            }));
        }

        function _refresh(){
            vm.zones = api.catalogs.rentableZones.query();
        }

        function add(){
            $state.go("app.catalogs.rentableZones.add");
        }

        function detail(item){
            $state.go("app.catalogs.rentableZones.detail", { id: item.id });
        }

        function remove(item){
            msg.confirm('Estas seguro que deseas borrar esta zona zon todos sus rentables?', function(){
                api.catalogs.dues.delete({ id: item.id }, function(response){
                    if (response){
                        _refresh();
                    }
                });
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.products')
        .controller('CatalogProductsController', controllerFunction);

    /** @ngInject */
    function controllerFunction($state, api, CONST_DATATABLES, $mdDialog, $document, msApi)
    {
        var vm = this;

        init();
        function init(){
            _getProducts();
            vm.dtInstance = {};
            vm.dtOptions = $.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the Code column
                        targets: 0,
                        width  : '72px',
                        sortable: false,
                    },
                    {
                        // Target the actions column
                        targets           : 4,
                        width             : '80px',
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function (){
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pageLength  : 8,
                scrollY     : 'auto',
                responsive  : true,
                filter      : true,
            });
        }

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoDetail = gotoDetail;
        vm.massiveAdd = massiveAdd;
        //////////

        function gotoAdd(){
            $state.go('app.catalogs.products.add');
        }

        function gotoDetail(id){
            $state.go('app.catalogs.products.detail', { id: id });
        }

        function _getProducts(){
            vm.products = api.catalogs.products.query();
        }

        function massiveAdd(ev){
            $mdDialog.show({
                templateUrl        : 'app/main/catalogs/views/products/products/dialogs/dialog-massive.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: false,
                escapeToClose      : false,
                disableParentScroll: true,
                controller         : "ProductsMassiveDialogController",
                controllerAs       : "vm",
                locals             :{
                    Refresh : _getProducts
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.products')
        .controller('CatalogProductController', CatalogProductController);

    /** @ngInject */
    function CatalogProductController($scope, $document, $state, Product, ProductTypes, api, msg, $sce, Accounts)
    {
        var vm = this;
        vm.product = Product;
        vm.productTypes = ProductTypes;
        vm.accounts = Accounts;

//         // Methods
        vm.gotoProducts = gotoProducts;
        vm.save = save;
        vm.changeType = changeType;
//         //////////

        init();

        function init(){
            vm.loadingTemplate = false;
            if (vm.product.id != 0)
                changeType();

            // Sat Catalogs
            vm.satTaxes = api.sat.taxes.query();
            vm.satTaxTypes = api.sat.taxTypes.query();
        }

        function gotoProducts(){
            $state.go('app.catalogs.products');
        }

        function changeType(){
            vm.loadingTemplate = true;

            var options = vm.product.options;

            api.catalogs.templates.get({
                productTypeId: vm.product.productTypeId,
            }, function(response){                
                vm.product.options = [];
                angular.forEach(response.properties, function(p){
                    var newOption = { 
                        productPropertyId: p.id,  
                        value: ""                       
                    };

                    if (options && options.length > 0){
                        var filteredOptions = options.filter(function(opt){ return opt.productPropertyId == p.id });
                        if (filteredOptions.length > 0)
                            newOption = filteredOptions[0];
                    }

                    vm.product.options.push(newOption);
                });

                vm.html = $sce.trustAsHtml(response.html);
                
                vm.loadingTemplate = false;
            });
        }

        function save(){
            vm.product.satProductId = vm.product.satProduct.id; 
            vm.product.satUnitId = vm.product.satUnit.id;
            api.catalogs.products.save(vm.product,function(response){
                if (response){
                    msg.success("Producto guardado correctamente");
                    $state.go("app.catalogs.products");
                }
            });
        }        
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.productTypes', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.productTypes', {
                url      : '/productTypes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/productTypes/productTypes/productTypes.html',
                        controller : 'CatalogsProductTypesController as vm'
                    }
                }
            })
            .state('app.catalogs.productTypes.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/productTypes/productType/productType.html',
                        controller : 'CatalogsProductTypeController as vm'
                    }
                },
                resolve  : {
                    ProductType: function ()
                    {
                        return { id: 0, name: '', active: true, properties: [] };
                    }
                },
            })
            .state('app.catalogs.productTypes.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/productTypes/productType/productType.html',
                        controller : 'CatalogsProductTypeController as vm'
                    }
                },
                resolve  : {
                    ProductType: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('catalogs.productTypes@get', { id: $stateParams.id });
                    }
                },
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.productTypes', {
            title: 'Tipos de productos',
            state: 'app.catalogs.productTypes'
        });
    }
})();
(function ()
{
    'use strict';

    var treeViewAccessData = [];

    angular
        .module('app.catalogs.productTypes')
        .controller('CatalogsProductTypeController', catalogsProductTypeController);

    /** @ngInject */
    function catalogsProductTypeController($state, ProductType, api, msg)
    {
        var vm = this;

//         // Methods
        vm.gotoReturn = gotoReturn;
        vm.save = save;

        vm.propertyAdd = propertyAdd;
        vm.propertyEdit = propertyEdit;
        vm.propertySave = propertySave;
        vm.propertyDelete = propertyDelete;

        vm.optionAdd = optionAdd;
        vm.optionSave = optionSave;
        vm.optionDelete = optionDelete;
        
//         //////////

        init();

        function init(){
            vm.item = ProductType;
            vm.properties = [];
            _getProperties();
        }

        function gotoReturn(){
            $state.go('app.catalogs.productTypes');
        }

        function save(){
            vm.item.properties = [];
            angular.forEach(vm.properties, function(prop){
                if (prop.selected == true)
                    vm.item.properties.push(prop);
            });

            api.catalogs.productTypes.save(vm.item, function(response){
                if (response){
                    msg.success('Tipo de producto guardado correctamente.');
                    if (vm.item.id != 0)
                        $state.go('app.catalogs.productTypes');
                    else
                        vm.item = response;
                }
            });
        }

        /// Properties
        function _getProperties(){
            api.catalogs.productProperties.query(function(response){
                vm.properties = response;
                
                angular.forEach(vm.properties, function(prop){
                    if (vm.item && vm.item.properties)
                        prop.selected = vm.item.properties.filter(function(p){ return p.id == prop.id }).length > 0;
                });
            })
        }

        function propertyAdd(){
            vm.property = {
                id: 0,
                name: "",
                active: true,
                options: []
            };
            optionAdd();
        }
        
        function propertyEdit(item){
            vm.property = angular.copy(item);
            vm.property.isEditMode = true;
            _getOptions();
            optionAdd();
        }

        function propertySave(){


            api.catalogs.productProperties.save(vm.property, function(response){
                vm.property.id = response.id;
                _getProperties();
                optionAdd();
                msg.success("Propiedad guardada correctamente.");
            });
        }

        function propertyDelete(item){
            msg.confirm("Esta seguro que quiere borrar la propiedad " + item.name, function(){
                api.catalogs.productProperties.delete({ id: item.id }, function(response){
                    _getProperties();
                    msg.success("Propiedad borrada correctamente");
                });
            });
        }

        /// Options
        function _getOptions(){
            if (!vm.property || vm.property.id == 0){
                msg.error("Seleccione propiedad");
                return;
            }

            api.catalogs.productPropertyOptions.get({ propertyId: vm.property.id }, function(options){
                vm.options = options;                
            });
        }

        function optionAdd(){
            vm.option = {
                productPropertyId : vm.property.id,
                id: 0,
                name: "",
                active: true
            };
        }

        function optionSave(){
            api.catalogs.productPropertyOptions.save(vm.option, function(option){
                _getOptions();
                optionAdd();
                msg.success("Opción guardada correctamente.");                
            });
        }

        function optionDelete(item){
            msg.confirm("Esta seguro que quiere borrar la opción " + item.value, function(){
                api.catalogs.productPropertyOptions.delete({ id: item.id }, function(option){
                    _getOptions();
                    msg.success("Opción borrada correctamente");
                });
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs', 
            [
                'datatables',
                // Catalogs
                'app.catalogs.warehouses',
                'app.catalogs.employeeTypes',
                'app.catalogs.employees',
                'app.catalogs.clubAccess',
                'app.catalogs.partnerTypes',
                'app.catalogs.dues',
                'app.catalogs.duesRules',
                'app.catalogs.productTypes',
                'app.catalogs.products',
                'app.catalogs.rentableZones',                
                'app.catalogs.countries',
                'app.catalogs.professions',
                'app.catalogs.addressTypes',
                'app.catalogs.media',
                'app.catalogs.agreements',
                'app.catalogs.accessTimeZones',
                'app.catalogs.activities',
                'app.catalogs.levels',
                'app.catalogs.evaluations',
                'app.catalogs.levelScores',
                'app.catalogs.becas',
                
                'app.catalogs.tpvs',
                'app.catalogs.paymentMethods',
                'app.catalogs.paymentMethodOptions',
                
                'app.catalogs.zones',
                'app.catalogs.passTypes',
                'app.catalogs.passes',
                'app.catalogs.conceptosNotaCredito',
                'app.catalogs.accounts'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs', {
                abstract: true,
                url     : '/catalogs'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : '',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.catalogs', {
            title : 'Catalogos',
            icon  : 'icon-archive',
            weight: 3
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs')
        .controller('CatalogsProductTypesController', controllerFunction);

    /** @ngInject */
    function controllerFunction($state, api, msg)
    {
        var vm = this;

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoDetail = gotoDetail;
        vm.delete = remove;
        //////////

        _init();

        function _getProductTypes(){
            api.catalogs.productTypes.query(function(response) { 
                return  vm.productTypes = response 
            }); 
        }

        function _init(){
            _getProductTypes();
            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px'
                    },
                    {
                        // Target the status column
                        targets   : 2,
                        filterable: false,
                        render    : function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                if ( data === 'true' )
                                {
                                    return '<i class="icon-checkbox-marked-circle green-500-fg"></i>';
                                }

                                return '<i class="icon-cancel red-500-fg"></i>';
                            }

                            if ( type === 'filter' )
                            {
                                if ( data )
                                {
                                    return '1';
                                }

                                return '0';
                            }

                            return data;
                        }
                    },
                    {
                        // Target the actions column
                        targets           : 3,
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false,
                        width             : '120px'
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true
            };
        }        

        function gotoAdd()
        {
            $state.go('app.catalogs.productTypes.add');
        }

        function gotoDetail(id)
        {
            $state.go('app.catalogs.productTypes.detail', { id: id });
        }

        function remove(item){
            msg.confirm("Estas seguro que quieres dar de baja el tipo de producto " + item.name, function(){
                api.catalogs.productTypes.delete({ id: item.id }, function(response){
                    _getProductTypes();
                    msg.success("Tipo de producto borrado correctamente");
                });
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.employees', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.employees', {
                url      : '/employees',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/employees/employees/employees.html',
                        controller : 'CatalogsEmployeesController as vm'
                    }
                }
            })
            .state('app.catalogs.employees.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/employees/employee/employee.html',
                        controller : 'CatalogsEmployeeController as vm'
                    }
                },
                resolve  : {
                    Employee: function ()
                    {
                        return { id: 0, name: '', active: true, birthdate: new Date(), startDate: new Date() };
                    },
                    EmployeeTypes: function(apiResolver){
                        return apiResolver.resolve('catalogs.employeeTypes@query');
                    },
                    Users:  function(apiResolver){
                        return apiResolver.resolve('security.users@query');
                    }
                },
            })
            .state('app.catalogs.employees.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/employees/employee/employee.html',
                        controller : 'CatalogsEmployeeController as vm'
                    }
                },
                resolve  : {
                    Employee: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('catalogs.employees@get', { id: $stateParams.id });
                    },
                    EmployeeTypes: function(apiResolver){
                        return apiResolver.resolve('catalogs.employeeTypes@query');
                    },
                    Users:  function(apiResolver){
                        return apiResolver.resolve('security.users@query');
                    }
                },
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.employees', {
            title: 'Empleados',
            state: 'app.catalogs.employees'
        });
    }
})();
(function ()
{
    'use strict';

    var treeViewAccessData = [];

    angular
        .module('app.catalogs.employees')
        .controller('CatalogsEmployeeController', catalogsEmployeeController);

    /** @ngInject */
    function catalogsEmployeeController($state, Employee, EmployeeTypes, Users, api, msg)
    {
        var vm = this;

//         // Methods
        vm.gotoReturn = gotoReturn;
        vm.save = save;
        vm.showCalendar = showCalendar;        
//         //////////

        init();

        function init()
        {
            vm.item = Employee;
            vm.employeeTypes = EmployeeTypes;
            vm.users = Users;
        }

        function gotoReturn()
        {
            $state.go('app.catalogs.employees');
        }

        function save(){
            api.catalogs.employees.save(vm.item, function(response){
                if (response){
                    msg.success('Empleado guardado correctamente.');
                    $state.go('app.catalogs.employees');
                }
            });
        }

        function showCalendar(){
            $state.go("app.partners.prospects.calendar.employee", { id: vm.item.id });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs')
        .controller('CatalogsEmployeesController', controllerFunction);

    /** @ngInject */
    function controllerFunction($state, api, msg)
    {
        var vm = this;

        init();

        function init(){
            api.catalogs.employees.query(function(response) { return  vm.employees = response }); 
            vm.dtInstance = {};
            vm.dtOptions = {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px'
                    },
                    {
                        // Target the status column
                        targets   : 3,
                        filterable: false                        
                    },
                    {
                        // Target the actions column
                        targets           : 4,
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false,
                        width             : '120px'
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true
            };
        }

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoDetail = gotoDetail;
        vm.delete = remove;
        vm.showCalendar = showCalendar;
        //////////

        function gotoAdd()
        {
            $state.go('app.catalogs.employees.add');
        }

        function gotoDetail(id)
        {
            $state.go('app.catalogs.employees.detail', { id: id });
        }

        function remove(item){
            msg.confirm("Estas seguro que quieres dar de baja a " + item.name + " " + item.fatherLastname, function(){
                api.catalogs.employees.delete({ id: item.id }, function(response){
                    api.catalogs.employees.query(function(response) { return  vm.employees = response }); 
                    msg.success("Empleado borrado correctamente");
                });
            });
        }

        function showCalendar(employeeId){
            $state.go("app.partners.prospects.calendar.employee", { id: employeeId });
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.catalogs.dues")
    .controller("CatalogsDuesController", controllerFunction);

  /** @ngInject */
  function controllerFunction(
    $scope,
    Dues,
    $mdDialog,
    $document,
    msg,
    api,
    CONST_DATATABLES,
    $state
  ) {
    var vm = this;
    _init();

    // Methods
    vm.add = add;
    vm.openDetail = openDetail;
    vm.deleteItem = deleteItem;
    //////////

    function _init() {
      // Data
      // vm.dues = Dues;
      _refresh();
      vm.dtInstance = {};
      vm.dtOptions = $.extend(CONST_DATATABLES.OPTIONS, {
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
        columnDefs: [
          {
            // Target the ID column
            targets: 0,
            width: "72px",
            responsivePriority: 0,
          },
          {
            // Target the Active column
            targets: 2,
            responsivePriority: 2,
            filterable: false,
            sortable: false,
          },
          {
            // Target the Active column
            targets: 3,
            responsivePriority: 2,
            filterable: false,
            sortable: false,
          },
          {
            // Target the actions column
            targets: 4,
            responsivePriority: 1,
            filterable: false,
            sortable: false,
          },
        ],
        initComplete: function () {
          var api = this.api(),
            searchBox = angular.element("body").find("#keyword-search");

          // Bind an external input as a table wide search box
          if (searchBox.length > 0) {
            searchBox.on("keyup", function (event) {
              api.search(event.target.value).draw();
            });
          }
        },
        pagingType: "simple",
        pageLength: 10,
        scrollY: "auto",
        responsive: true,
        filter: true,
      });
    }

    function _refresh() {
      vm.dues = api.catalogs.dues.query();
    }

    function add() {
      $state.go("app.catalogs.dues.add");
    }

    function openDetail(item) {
      $state.go("app.catalogs.dues.detail", { id: item.id });
    }

    function deleteItem(item) {
      msg.confirm("Estas seguro que deseas borrar este elemento?", function () {
        api.catalogs.dues.delete({ idDue: item.id }, function (response) {
          if (response) {
            window.location.reload();
          }
        });
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.catalogs.dues')
        .controller('CatalogsDueController', dueController);

    /** @ngInject */
    function dueController(api, msg, $state, CONST_DATATABLES, Due, Periodicities, $mdDialog, $document, PartnerTypes, Accounts)
    {
        var vm = this;
        _init();

        // Methods
        vm.returnBack = returnBack;
        vm.save = save;

        vm.showPrices = showPrices;
        vm.priceDelete = priceDelete;
        //////////

        function _init(){
            
            // Data
            vm.item = Due;
            vm.periodicities = Periodicities;
            vm.partnerTypes = PartnerTypes;
            vm.accounts = Accounts;

            vm.partnerTypes.push({ id: null, name: "Todos", active: true });

            if (vm.item && vm.item.id > 0){
                _getPrices();
            }

            vm.priceDtInstance = {};
            vm.priceDtOptions = $.extend(CONST_DATATABLES.OPTIONS, {
                filter: true                
            });

            // Sat Catalogs
            vm.satTaxes = api.sat.taxes.query();
            vm.satTaxTypes = api.sat.taxTypes.query();
        }
        
        function returnBack(){
            $state.go("app.catalogs.dues");
        }

        function save(){
            vm.item.satProductId = vm.item.satProduct.id; 
            vm.item.satUnitId = vm.item.satUnit.id;             

            // Save Item
            api.catalogs.dues.save(
                vm.item,
                function(response){
                    msg.success("Cuota guardada correctamente.");
                    if (vm.item.id > 0){
                        $state.go("app.catalogs.dues");
                    }else{
                        vm.item = response;                        
                    }
                });
        }


        // Prices
        function _getPrices(){
            if (vm.item && vm.item.id != 0)
                vm.prices = api.catalogs.duePrices.query({ dueId: vm.item.id });
        }

        function showPrices(ev, dueId, priceGroupId){
            $mdDialog.show({
                templateUrl        : 'app/main/catalogs/views/dues/due/dialogs/dialog-prices/dialog-prices.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                disableParentScroll: true,
                controller         : "CatalogsDuePricesDialogController",
                controllerAs       : "vm",
                locals             : {
                    Callback : _priceCallback,
                    PriceGroupId   : priceGroupId,
                    DueId : dueId
                },
            });            
        }

        function _priceCallback(){
            _getPrices();
        }

        function priceDelete(groupId){
            msg.confirm("Esta seguro que desea borrar este precio?", function(){
                api.catalogs.duePrices.delete({ groupId: groupId }, function(){
                    msg.success("Precio borrado correctamente.");
                    _getPrices();
                });
            })
        }
        // /Prices
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.conceptosNotaCredito', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.conceptosNotaCredito', {
                url      : '/conceptosNotaCredito',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/conceptos-nota-credito/conceptos-nota-credito/conceptos-nota-credito.html',
                        controller : 'CatalogsConceptosNotaCreditoController as vm'
                    }
                },
                resolve  : {
                    ConceptosNotaCredito: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.conceptosNotaCredito@query');
                    }
                }
            })
            .state('app.catalogs.conceptosNotaCredito.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/conceptos-nota-credito/concepto-nota-credito/concepto-nota-credito.html',
                        controller : 'CatalogsConceptoNotaCreditoController as vm'
                    }
                },
                resolve  : {
                    ConceptoNotaCredito: function (){ 
                        return { id: 0, name: '', active: true }
                    },
                }
            })
            .state('app.catalogs.conceptosNotaCredito.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/conceptos-nota-credito/concepto-nota-credito/concepto-nota-credito.html',
                        controller : 'CatalogsConceptoNotaCreditoController as vm'
                    }
                },
                resolve  : {
                    ConceptoNotaCredito: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('catalogs.conceptosNotaCredito@get', { id : $stateParams.id });
                    },
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.conceptosNotaCredito', {
            title: 'Conceptos de NC',
            state: 'app.catalogs.conceptosNotaCredito'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.conceptosNotaCredito')
        .controller('CatalogsConceptoNotaCreditoController', catalogsConceptoNotaCreditoController);

    /** @ngInject */
    function catalogsConceptoNotaCreditoController(api, msg, $state, CONST_DATATABLES, ConceptoNotaCredito, $mdDialog, $document){
        var vm = this;
        _init();

        // Methods
        vm.returnBack = returnBack;
        vm.save = save;
        //////////

        function _init(){
            // Data
            vm.item = ConceptoNotaCredito;
            vm.saving = false;
            
            // Sat Catalogs
            vm.satTaxes = api.sat.taxes.query();
            vm.satTaxTypes = api.sat.taxTypes.query();
        }
        
        function returnBack(){
            $state.go("app.catalogs.conceptosNotaCredito");
        }

        function save(){
            if (!vm.item.satProduct || !vm.item.satProduct.id || !vm.item.satUnit || !vm.item.satUnit.id)
            {
                msg.error("Seleccione producto del SAt y Unidad del SAT.");
                vm.saving = false;
                return;
            }
            vm.item.satProductId = vm.item.satProduct.id;
            vm.item.satUnitId = vm.item.satUnit.id;
            // Save Item
            api.catalogs.conceptosNotaCredito.save(
                vm.item,
                function(response){
                    msg.success("Concepto guardado correctamente.");
                    $state.go("app.catalogs.conceptosNotaCredito");
                    vm.saving = false;
                }, function(errorResponse){
                    vm.saving = false;
                });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.conceptosNotaCredito')
        .controller('CatalogsConceptosNotaCreditoController', catalogsConceptosNotaCreditoController);

    /** @ngInject */
    function catalogsConceptosNotaCreditoController($scope, ConceptosNotaCredito, $mdDialog, msg, api, CONST_DATATABLES, $state)
    {
        var vm = this;
        _init();

        // Methods
        vm.add = add;
        vm.detail = detail;
        vm.remove = remove;
        //////////

        function _init(){
            // Data
            _refresh();
            vm.dtConceptosInstance = {};
            vm.dtConceptosOptions = angular.copy(angular.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px',
                        responsivePriority: 0,
                    },
                    {
                        // Target the actions column
                        targets           : 3,
                        responsivePriority: 2,
                        filterable        : false,
                        sortable          : false
                    },
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true,
                filter      : true
            }));
        }

        function _refresh(){
            vm.conceptos = api.catalogs.conceptosNotaCredito.query();
        }

        function add(){
            $state.go("app.catalogs.conceptosNotaCredito.add");
        }

        function detail(item){
            $state.go("app.catalogs.conceptosNotaCredito.detail", { id: item.id });
        }

        function remove(item){
            msg.confirm('Estas seguro que deseas borrar este concepto?', function(){
                api.catalogs.conceptosNotaCredito.delete({ id: item.id }, function(response){
                    if (response){
                        _refresh();
                    }
                });
            });
        }
    }

})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.activities', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.activities', {
                url      : '/activities',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/activities/activities/activities.html',
                        controller : 'CatalogsActivitiesController as vm'
                    }
                },
                resolve  : {
                    Activities: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.activities@query');
                    }
                }
            })
            .state('app.catalogs.activities.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/activities/activity/activity.html',
                        controller : 'CatalogsActivityController as vm'
                    }
                },
                resolve  : {
                    Activity: function (){ 
                        return { id: 0, periodicityId: 0, name: '', prices: [], active: true }
                    },
                    Employees: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.employees@query');
                    }
                }
            })
            .state('app.catalogs.activities.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/activities/activity/activity.html',
                        controller : 'CatalogsActivityController as vm'
                    }
                },
                resolve  : {
                    Activity: function (apiResolver, $stateParams)
                    {
                        return apiResolver.resolve('catalogs.activities@get', { id : $stateParams.id });
                    },
                    Employees: function (apiResolver)
                    {
                        return apiResolver.resolve('catalogs.employees@query');
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.activities', {
            title: 'Actividades',
            state: 'app.catalogs.activities'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.activities')
        .controller('CatalogsActivityController', activityController);

    /** @ngInject */
    function activityController(api, msg, $state, CONST_DATATABLES, Activity, Employees, $mdDialog, $document)
    {
        var vm = this;
        _init();

        // Methods
        vm.returnBack = returnBack;
        vm.save = save;

        vm.scheduleAdd = scheduleAdd;
        vm.scheduleAddCancel = scheduleAddCancel;
        vm.scheduleSave = scheduleSave;
        vm.scheduleEdit = scheduleEdit;
        vm.scheduleDelete = scheduleDelete;

        vm.allQuotaChange = allQuotaChange;
        //////////

        function _init(){
            // Data
            vm.item = Activity;
            vm.employees = Employees.filter(function(e) { return e.active && e.employeeTypeId == 2 });
            vm.zones = api.catalogs.zones.query();

            if (vm.item && vm.item.id > 0){
                _getSchedule();
            }

            vm.scheduleDtInstance = {};
            vm.scheduleDtOptions = $.extend(CONST_DATATABLES.OPTIONS, {
                filter: true                
            });
        }
        
        function returnBack(){
            $state.go("app.catalogs.activities");
        }

        function save(){
            // Save Item
            api.catalogs.activities.save(
                vm.item,
                function(response){
                    msg.success("Actividad guardada correctamente.");
                    if (vm.item.id > 0){
                        $state.go("app.catalogs.activities");
                    }else{
                        vm.item = response;                  
                    }
                });
        }

        function _getSchedule(){
            if (vm.item && vm.item.id != 0)
                api.catalogs.activitiesSchedules.query({ activityId: vm.item.id }, function(response){
                    vm.schedules = response;
                });
        }

        function scheduleAdd(ev){
            vm.schedule = {
                id          : 0,
                activityId  : vm.item.id,
                active      : true,
                isMonday    : true,
                mondayInitHour: "1200",
                mondayEndHour: "1300",
                isTuesday   : false, 
                tuesdayInitHour: "1200",
                tuesdayEndHour: "1300",
                isWednesday : false, 
                wednesdayInitHour: "1200",
                wednesdayEndHour: "1300",
                isThursday  : false, 
                thursdayInitHour: "1200",
                thursdayEndHour: "1300",
                isFriday    : false, 
                fridayInitHour: "1200",
                fridayEndHour: "1300",
                isSaturday  : false, 
                saturdayInitHour: "1200",
                saturdayEndHour: "1300",
                isSunday    : false, 
                sundayInitHour: "1200",
                sundayEndHour: "1300",
            };
            angular.forEach(vm.zones, function(zone){ zone.selected = false });            

            $mdDialog.show({
                contentElement     : '#detail-dialog-schedule',
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        function scheduleAddCancel(){
            vm.schedule = null;
            $mdDialog.hide();
        }

        function scheduleSave(){
            vm.schedule.timeFrom = vm.schedule.fromHour + ":" + vm.schedule.fromMinutes + ":00" ;
            vm.schedule.timeTo = vm.schedule.toHour + ":" + vm.schedule.toMinutes + ":00";

            vm.schedule.zones = [];
            angular.forEach(vm.zones, function(zone) {
                if (zone.selected){
                    vm.schedule.zones.push({
                        id                  : 0,
                        zoneId              : zone.id,
                        activityScheduleId  : vm.schedule.id,
                        quota               : zone.quota
                    });
                }
            });
            api.catalogs.activitiesSchedules.save(vm.schedule, function(response){
                msg.success("Horario agregado correctamente");
                scheduleAddCancel();
                _getSchedule();
            });
        }

        function scheduleEdit(item, ev){
            vm.schedule = angular.copy(item);
            angular.forEach(vm.zones, function(zone){ zone.selected = false });
            angular.forEach(vm.schedule.zones, function(zone){
                
                var currentZone = vm.zones.filter(function(z){ return z.id == zone.zoneId})[0]
                currentZone.selected = true;
                currentZone.quota = zone.quota;
            });
            $mdDialog.show({
                contentElement     : '#detail-dialog-schedule',
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        function scheduleDelete(item){
            msg.confirm("Esta seguro que desea borrar este horario?", function(){
                api.catalogs.activitiesSchedules.delete({ id: item.id }, function(){
                    msg.success("Horario borrado correctamente.");
                    _getSchedule();
                });
            })
        }

        function allQuotaChange(){
            vm.schedule.mondayQuota = vm.allQuota;
            vm.schedule.tuesdayQuota = vm.allQuota;
            vm.schedule.wednesdayQuota = vm.allQuota;
            vm.schedule.thursdayQuota = vm.allQuota;
            vm.schedule.fridayQuota = vm.allQuota;
            vm.schedule.saturdayQuota = vm.allQuota;
            vm.schedule.sundayQuota = vm.allQuota;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.activities')
        .controller('CatalogsActivitiesController', controllerFunction);

    /** @ngInject */
    function controllerFunction($scope, Activities, $mdDialog, $document, msg, api, CONST_DATATABLES, $state)
    {
        var vm = this;
        _init();

        // Methods
        vm.add = add;
        vm.openDetail = openDetail;
        vm.deleteItem = deleteItem;
        //////////

        function _init(){
            // Data
            vm.activities = Activities;
            vm.dtInstance = {};
            vm.dtOptions = $.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px',
                        responsivePriority: 0,
                    },
                    {
                        // Target the actions column
                        targets           : 3,
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true
            });

            _refresh();
        }

        function _refresh(){
            vm.activities = api.catalogs.activities.query();
        }

        function add(){
            $state.go("app.catalogs.activities.add");
        }

        function openDetail(item){
            $state.go("app.catalogs.activities.detail", { id: item.id });
        }

        function deleteItem(item){
            msg.confirm('Estas seguro que deseas borrar esta Actividad?', function(){
                api.catalogs.activities.delete({ id: item.id }, function(response){
                    if (response){
                        _refresh();
                    }
                });
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs')
        .controller('CatalogsAccessTimeZonesController', catalogsAccessTimeZonesController);

    /** @ngInject */
    function catalogsAccessTimeZonesController($state, api, CONST_DATATABLES)
    {
        var vm = this;

        init();

        function init(){
            api.catalogs.accessTimeZones.query(function(response) { return  vm.accessTimeZones = response }); 
            vm.dtAccessTimeZoneInstance = {};
            vm.dtAccessTimeZoneOptions = angular.copy($.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        responsivePriority: 1,
                    },
                    {
                        // Target the actions column
                        targets           : 9,
                        filterable        : false,
                        sortable          : false
                    },
                    {
                        // Target the actions column
                        targets           : 10,
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function (){
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true,
                filter      : true
            }));
        }

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoDetail = gotoDetail;
        //////////

        function gotoAdd()
        {
            $state.go('app.catalogs.accessTimeZones.add');
        }

        function gotoDetail(id)
        {
            $state.go('app.catalogs.accessTimeZones.detail', { id: id });
        }
    }
})();
(function ()
{
    'use strict';

    var treeViewAccessData = [];

    angular
        .module('app.catalogs')
        .controller('CatalogsAccessTimeZoneController', catalogsAccessTimeZoneController);

    /** @ngInject */
    function catalogsAccessTimeZoneController($state, AccessTimeZone, api, msg)
    {
        var vm = this;

//         // Methods
        vm.gotoReturn = gotoReturn;
        vm.save = save;
//         //////////

        init();

        function init()
        {
            vm.item = AccessTimeZone;
        }

        function gotoReturn(){
            $state.go('app.catalogs.accessTimeZones');
        }

        function save(){
            api.catalogs.accessTimeZones.save(vm.item, function(response){
                if (response){
                    msg.success('Horario de acceso guardado correctamente.');
                    $state.go('app.catalogs.accessTimeZones');
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.partners')
        .controller('PartnersProspectsController', partnersProspectsController);

    /** @ngInject */
    function partnersProspectsController($state, api, CONST_DATATABLES, msg, $mdDialog, Prospects)
    {
        var vm = this;

        _init();

        // Methods
        vm.selectProspect = selectProspect;
        vm.showDetail = showDetail;
        vm.prospectRemove = prospectRemove;
        vm.prospectSignup = prospectSignup;
        vm.prospectsFilter = prospectsFilter
        vm.commentAdd = commentAdd;
        vm.commentAccept = commentAccept;
        vm.commentCancel = commentCancel;
        vm.showCalendar = showCalendar;
        ////////////

        function _init(){
            vm.prospects = Prospects;
            vm.prospectComments = [];            
            _getProspects();
        }

        function _getProspects(){
            vm.prospects = api.partners.prospects.query();            
            vm.prospectComments = [];
        }

        function showDetail(ev, item){
            $mdDialog.show({
                templateUrl        : 'app/main/partners/views/prospects/dialogs/dialog-prospect/dialog-prospect.html',
                targetEvent        : ev,
                clickOutsideToClose: false,
                escapeToClose      : false,
                disableParentScroll: true,
                controller         : "PartnersProspectsProspectDialogController",
                controllerAs       : "vm",
                locals             : {
                    Prospect   : item,
                    Callback  : _getProspects
                }
            });
        }

        vm.selecting = false;
        function selectProspect(prospect, fromSuccesComment){
            if (vm.selectedProspect && (vm.selectedProspect.id == prospect.id && !fromSuccesComment))
                return;
            vm.selecting = true;
            vm.selectedProspect = prospect;
            vm.prospectComments = [];
            api.partners.prospects.get({id: prospect.id }, function(response){
                vm.prospectComments = response.comments;
                vm.selecting = false;
            }, function(error){
                vm.selecting = false;
            });
        }

        function prospectRemove(prospect){
            msg.confirm("Esta seguro que desea remover este prospecto", function(){
                api.partners.prospects.delete({id: prospect.id}, function(response){
                    msg.success("Prospecto borrado correctamente.");
                    _showDetailCallback();
                });
            });
        }

        function commentAdd(){
            if (!vm.selectedProspect)
            {
                msg.error("Seleccione prospecto");
                return;
            }
            vm.addingComment = true;
            vm.comment = {
                id: 0,
                comment: '',
                prospectId: vm.selectedProspect.id,
                prospect: vm.prospect
            };
        }

        function commentAccept(){
            api.partners.prospectComments.save(vm.comment, function(response){
                msg.success("Comentario guardado correctamente");
                vm.comment = {};
                selectProspect(vm.selectedProspect, true);
                vm.addingComment = false;
            });
        }

        function commentCancel(){
            vm.comment = {};
            vm.addingComment = false;            
        }

        function prospectSignup(prospect){
            msg.confirm("Esta seguro que desea inscribir a " + prospect.completeName + "?", function(){
                $state.go("app.partners.partners.add.prospect", { id: prospect.id });
            });
        }

        function prospectsFilter(){            
            vm.prospectsFiltered = vm.prospects;
            if (vm.onlySignedUpFilter === true){
                vm.prospectsFiltered =  vm.prospects.filter(function(p){ return p.isSignedUp });
            }
        }

        function showCalendar(employeeId, prospectId){
            if (employeeId && prospectId)
                $state.go("app.partners.prospects.calendar.employee-prospect", { id: employeeId, prospectId: prospectId });            
            else
                $state.go("app.partners.prospects.calendar");
        }
    }
})();
(function(){

    'use strict';
    
    angular
        .module('app.partners')
        .controller('PartnersProspectCalendarController', partnerProspectCallendarController);

    /** @ngInject */
    function partnerProspectCallendarController($mdDialog, api, msg, Seller, Prospect, authService)
    {
        var vm = this;
        
        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;
        vm.closeDialog = closeDialog;
        vm.selectedSellerChange = selectedSellerChange;
        vm.selectedProspectChange = selectedProspectChange;
        //////////

        _init();
        
        function _init(){
            vm.events = [];
            var appData = authService.getAppData(); 
            api.catalogs.employees.query(function(response){
                vm.sellers = response.filter(function(e){ return e.employeeTypeId == 1 /*Seller*/ ;})
                
                if (!appData.user.userType.isShowAllProspects){
                    vm.sellers = vm.sellers.filter(function(e){ return e.userId == appData.user.id });
                }

                if (vm.sellers.length > 0){
                    if (Seller.id == 0)
                        vm.selectedSeller = vm.sellers[0]; 
                    else
                        vm.selectedSeller = vm.sellers.filter(function(s){ return s.id == Seller.id })[0];                
                }
                _getEvents();
            });

            api.partners.prospects.query(function(response){
                vm.prospects = response.filter(function(p){ return !p.isSignedUp; })
                if (vm.prospects.length > 0){
                    if (Prospect.id != 0)
                        vm.selectedProspect = vm.prospects.filter(function(p){ return p.id == Prospect.id })[0];                
                }
                _getEvents();
            });

            vm.calendarUiConfig = {
                calendar: {
                    defaultView       : 'month',
                    editable          : true,
                    eventLimit        : false,
                    header            : '',
                    handleWindowResize: false,
                    aspectRatio       : 1,
                    dayNames          : ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
                    dayNamesShort     : ['Domingo', 'Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado'],
                    monthNames        : ["Enero", 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
                    viewRender        : function (view)
                    {
                        vm.calendarView = view;
                        vm.calendar = vm.calendarView.calendar;
                        vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                    },
                    columnFormat      : {
                        month: 'ddd',
                        week : 'ddd D',
                        day  : 'ddd D'
                    },
                    selectable        : true,
                    selectHelper      : true,
                    eventClick        : eventDetail,
                    select            : select
                }
            };
        }

        function _getEvents(){
            // vm.events = [];

            if (!vm.selectedSeller)
                return;


            if (vm.prospect){
                api.catalogs.employeeCalendarEvents.getByProspect({
                    id: vm.selectedSeller.id,
                    prospectId: vm.prospect.id
                }, function(response){ 
                    _getEventsResponse(response); 
                });
            }else{
                api.catalogs.employeeCalendarEvents.getByProspect({
                    id: vm.selectedSeller.id }, function(response){ 
                        _getEventsResponse(response);
                    });
            }

        }

        function _getEventsResponse(response){
            var eventList = [];
            eventList = response;
            if (vm.events.length == 0)
                vm.events.push(eventList);
            else
                vm.events[0] = eventList;
        }

        /**
         * Go to next on current view (week, month etc.)
         */
        function next(){
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev(){
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e){
            // if (calendarEvent.title && calendarEvent.title != '' && calendarEvent.title.indexOf(" - (") != -1)
            //     calendarEvent.title = calendarEvent.title.split(" - (")[0];
            showEventFormDialog("edit", calendarEvent, calendarEvent.start, calendarEvent.end, e );
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e){
            if (start.format("HHmmss") == "000000" && end.format("HHmmss") == "000000")
                end.add(-1,'d');
            showEventFormDialog('add', null, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e){
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', null, start, end, e);
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e){
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : moment.utc(start),
                end          : moment.utc(end)
            };

            $mdDialog.show({
                controller         : 'PartnersProspectCalendarEventController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/partners/views/prospectCalendar/dialogs/dialog-event/dialog-event.html',
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    DialogData  : dialogData,
                    Seller      : vm.selectedSeller,
                    Prospects   : vm.prospects,
                    Prospect    : vm.selectedProspect
                }
            }).then(function (response){
                _getEvents();
                // if (response){
                //     $scope.onLoadCallback({newEvent: response });
                //     _getEvents();
                // }
            });
        }

        function closeDialog(){
            $mdDialog.hide();
        }

        function selectedSellerChange(){
            _getEvents();
        }

        function selectedProspectChange(){
            _getEvents();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.reports')
        .controller('ReportsTstController', reportsTstController);

    /** @ngInject */
    function reportsTstController(reportsService, api, authService)
    {
        var vm = this;
        
        vm.print = print;

        _init();

        function _init(){
            var appData = authService.getAppData();
            vm.logo = api.baseUrl.replace("api/","") + appData.settings.logoFile;
            vm.data = reportsService.getReportData().data;
        }

        function print(){
            var printContents = document.getElementById('printable').innerHTML;
            var originalContents = document.body.innerHTML;      
        
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                var popupWin = window.open('', '_blank', 'width=600,height=600,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
                popupWin.window.focus();
                popupWin.document.write(
                    '<!DOCTYPE html><html><head>' +
                    '<link rel="stylesheet" type="text/css" href="style.css" />' +
                    '</head>'+
                    '<body onload="window.print()">'+
                    '<div class="reward-body">' + 
                        printContents + 
                    '</div>'+
                    '</body>'+
                    '</html>');
                popupWin.onbeforeunload = function (event) {
                    popupWin.close();
                    return '.\n';
                };
                popupWin.onabort = function (event) {
                    popupWin.document.close();
                    popupWin.close();
                }
            } else {
                var popupWin = window.open('', '_blank', 'width=800,height=600');
                popupWin.document.open();
                popupWin.document.write(
                    '<html><head>'+
                    '<link rel="stylesheet" type="text/css" href="style.css" />'+
                    '</head>'+
                    '<body onload="window.print()">' + 
                        printContents + 
                    '</body>'+
                    '</html>');
                popupWin.document.close();
            }
            popupWin.document.close();

            // var printContents = document.getElementById('printable').innerHTML;
            // var popupWin = window.open('', '_blank', 'width=800,height=800');
            // popupWin.document.open();
            // popupWin.document.write(
            //     '<html>'+
            //     '<head>' + 
            //     '<link rel="stylesheet" type="text/css" href="/assets/css/reports.css" />'+
            //     '<link rel="stylesheet" type="text/css" href="/assets/css/helpers.scss" />'+
            //     '<link rel="stylesheet" type="text/css" href="/assets/css/layouts-template.scss" />'+
            //     '<link rel="stylesheet" type="text/css" href="/assets/css/layouts-page.scss" />'+
            //     '<link rel="stylesheet" type="text/css" href="/assets/css/material.scss" />'+
            //     '</head>'+
            //     '<body onload="window.print()">' + printContents + '</body>'+
            //     '</html>');
            // popupWin.document.close();
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.reports")
    .controller("ReportsSelectorController", reportsSelectorController);

  /** @ngInject */
  function reportsSelectorController(
    api,
    msg,
    ReportGroups,
    $state,
    reportsService,
    Branches,
    Users,
    authService
  ) {
    var vm = this;
    var appData = authService.getAppData();
    vm.user = appData.user;
    vm.branch = appData.branch;

    /// Methods
    vm.generate = generate;
    vm.paymentMethodChange = paymentMethodChange;
    /////////

    _init();

    function _init() {
      vm.branches = Branches;
      vm.users = Users.filter(function (u) {
        return u.active;
      });
      // vm.products = Products.filter(function(u) { return u.active });
      vm.products = api.catalogs.products.query();
      vm.dues = api.catalogs.dues.query();
      vm.periodicities = api.catalogs.periodicities.query();
      vm.employees = api.catalogs.employees.query();
      vm.paymentMethods = api.catalogs.paymentMethods.query();
      vm.paymentMethodOptions = api.catalogs.paymentMethodOptions.query();
      vm.agreements = api.catalogs.agreements.query();

      api.partners.partners.getByFilters(
        {
          keyword: "dummy",
          pageNumber: 0,
          pageSize: 0
        },
        function (response) {
          vm.partners = response;
        }
      );

      vm.generating = false;
      vm.selectedGroup = {
        reports: []
      };
      vm.selectedReport = {
        parameters: []
      };
      vm.groups = ReportGroups;

      vm.orderTypes = [
        { id: 0, name: "TODOS" },
        { id: 1, name: "Recibos" },
        { id: 2, name: "Facturas" }
      ];

      vm.viewModes = [
        { id: 1, name: "Consolidado" },
        { id: 2, name: "Desglosado" }
      ];

      vm.statusVigente = [
        { id: 1, name: "Vigentes" },
        { id: 2, name: "Vencidos" }
      ];

      vm.include = [
        { id: 1, name: "Si" },
        { id: 2, name: "No" }
      ];
      vm.generating = false;
    }

    function generate() {      
      vm.generating = true;
      api.reports.reports.generate(
        vm.selectedReport,
        function (response) {
          vm.data = response;
          vm.generating = false;
          reportsService.setReportData({
            report: vm.selectedReport,
            data: response
          });
          var viewModeFilter = vm.selectedReport.parameters.filter(function (
            p
          ) {
            return p.type == 9; /*ViewMode*/
          });
          if (viewModeFilter.length > 0)
            $state.go(
              vm.selectedReport.state +
                "-" +
                viewModeFilter[0].value.name.toLowerCase()
            );
          else $state.go(vm.selectedReport.state);
        },
        function () {
          vm.generating = false;                    
        }
      );
    }

    function paymentMethodChange(itemId) {
      vm.pmid = itemId;
    }

    vm.selectedUsers = [];
    vm.usersSelectUnselectAll = function () {
      if (vm.selectedUsers.length == vm.users.length) vm.selectedUsers = [];
      else vm.selectedUsers = vm.users;
    };

    vm.selectedProducts = [];
    vm.productSelectUnselectAll = function () {
      if (vm.selectedProducts.length == vm.products.length)
        vm.selectedProducts = [];
      else vm.selectedProducts = vm.products;
    };

    vm.selectedDues = [];
    vm.dueSelectUnselectAll = function () {
      if (vm.selectedDues.length == vm.dues.length)
        vm.selectedDues = [];
      else 
        vm.selectedDues = vm.dues;
    };
  }
})();

/* eslint-disable no-undef */
(function () {
  "use strict";

  angular
    .module("app.reports")
    .controller("ReportsDashboardController", reportsDashboardController);

  /** @ngInject */
  function reportsDashboardController(
    api,
    $filter,
    localStorageService
  ) {
    var vm = this;        
    var currencyTooltipConfig = {
      callbacks: {
          label: function(tooltipItem) {
            return currencyFriendlyFormat(tooltipItem.value);
          }
      }
    };
    var currnecyYAxisTicksConfig = {                      
      callback: function (label) {
          return currencyFriendlyFormat(label, 0)
      }
    };

    _init();

    function _init() {
      _getBranch();
      _loadPopulation();
      _loadDebts();
      _loadPartnersByAge();
      _loadPartnersByGender();
      _loadInscriptions();
      _loadInscriptionsByWeek();
      _loadSales();
      _loadSalesByType();
      _loadSalesTop();
      _loadSalesTopByType();
      _loadSalesYear();
      _loadSalesYearByType();
    }

    function _getBranch(){
      var appData = localStorageService.get("appData");
      vm.branchName = appData.branch.name;
    }

    function _loadPopulation(){
      api.reports.dashboard.population(
        function(data){
          if (!data || !data.length) {
            vm.population = {
              labels: [],
              data: [],
              total: [],
              options: { 
                legend : { 
                    display : true, 
                    position : "right"
                }
              }
            };
          }else{
            vm.population = {
              labels: data.map(function(x) { return x.name }),
              data: data.map(function(x) { return x.amount }),
              total: data.map(function(x) { return x.amount}).reduce(function(a,b) {return a + b}),
              options: { 
                legend : { 
                    display : true, 
                    position : "right"
                }
              }
            };
          }
        }
      );      

    }

    function _loadDebts(){
      api.reports.dashboard.debts(
        function(data){          
          vm.debts = {
            labels: data.map(function(x) { return  x.name }),
            data: data.map(function(x) { return x.amount }),
            total: _(data).sumBy(function(x) { return x.amount }),
            options: { 
              legend : { 
                  display : true, 
                  position : "right"
              }
            }
          };
        }
      );
    }
    
    function _loadPartnersByAge(){
      api.reports.dashboard.age(
        function(data){          
          vm.byage = {
            labels: data.map(function(x) { return x.name }),
            data: data.map(function(x) { return x.amount }),
            total: _(data).sumBy(function(x) { return x.amount }),
            options: { 
              legend : { 
                  display : true, 
                  position : "right"
              }
            }
          };
        }
      );
    }
    
    function _loadPartnersByGender(){
      api.reports.dashboard.gender(
        function(data){          
          vm.bygender = {
            labels: data.map(function(x) { return x.name }),
            data: data.map(function(x) { return x.amount }),
            total: _(data).sumBy(function(x) { return x.amount }),
            options: { 
              legend : { 
                  display : true, 
                  position : "right"
              }
            }
          };
        }
      );
    }
    
    function _loadInscriptions(){
      api.reports.dashboard.inscriptions(
        function(data){   
          
          var group = _(data)
            .groupBy(function(x) { return x.type })
            .map(function(i, k) { return ({
              type: k,
              items: i
            })})
            .value();          

          if (group && group.length > 0 && group[0].items && group[0].items.length > 0){
            vm.inscriptions = {
              labels: group[0].items.map(function(x) { return x.name }),
              data: group.map(function(x) { return x.items.map(function(y) { return y.amount }) }),
              total: _(data).sumBy(function(x) { return x.amount }),
              series: group.map(function(x) { return x.type }),
              options: { 
                legend : { 
                    display : true, 
                    position : "right"
                }
              }
            };
          }else{
            vm.inscriptions = [];
          }

        }
      );
    
    }
    
    function _loadInscriptionsByWeek(){
      api.reports.dashboard.inscriptionsbyweek(
        function(data){                          
          if (!data || !data.length){
            vm.inscriptionsbyweek = {};
            return;
          }
          var group = _(data)
            .groupBy(function(x) { return x.type })
            .map(function(i, k) { return ({
              type: k,
              items: i
            })})
            .value();                    

          vm.inscriptionsbyweek = {
            labels: group[0].items.map(function(x) { return x.name }),
            data: group.map(function(x) { return x.items.map(function(y) { return y.amount }) }),
            total: _(data).sumBy(function(x) { return x.amount }),
            series: group.map(function(x) { return x.type }),
            options: { 
              legend : { 
                  display : true, 
                  position : "right"
              }
            }
          };
        }
      );
    
    }
    
    function _loadSales(){
      api.reports.dashboard.sales(
        function(data){     
          data = _(data).orderBy(["date"], ["asc"]).value();
          vm.sales = {
            labels: data.map(function(x) { return x.date.split('T')[0] }),
            data: data.map(function(x) { return x.amount }),
            total: _(data).sumBy(function(x) { return x.amount }),
            options: {           
              scales: {
                yAxes: [{                  
                  ticks: currnecyYAxisTicksConfig
                }]
              },
              tooltips: currencyTooltipConfig
            }      
          };
        }
      );    
    }
    
    function _loadSalesByType(){
      api.reports.dashboard.salesbytype(
        function(data){      
          if (!data || !data.length){
            vm.salesbytype = {}
            return;
          }

          var group = _(data)
            .groupBy(function(x) { return x.type })
            .map(function(i, k) { return ({
              type: k,
              items: i
            })})
            .value();          

          vm.salesbytype = {
            labels : group[0].items.map(function(x) { return x.date.split('T')[0] }),
            data   : group.map(function(x) { return x.items.map(function(y) { return y.amount }) }),
            total  : _(data).sumBy(function(x) { return x.amount }),
            series : group.map(function(x) { return x.type }),
            options: {
              legend : { 
                display : true, 
                position : "top"
              },
              scaleShowVerticalLines: false,
              responsive: true,
              scales: {
                xAxes: [{
                    stacked: true                    
                }],
                yAxes: [{
                    stacked: true,
                    ticks: currnecyYAxisTicksConfig
                }]
              },
              tooltips: currencyTooltipConfig
            }
          };
        }
      );    
    }

    function _loadSalesTop(){
      api.reports.dashboard.salestop(
        function(data){  
          if (!data || !data.length){
            vm.salestop = {}
            return;
          }

          vm.salestop = {
            labels: data.map(function(x) { return x.name }),
            data: data.map(function(x) { return x.amount }),
            total: _(data).sumBy(function(x) { return x.amount }),
            options: { 
              legend : { 
                  display : true, 
                  position : "right"
              }
            }
          };
        }
      );    
    }

    function _loadSalesTopByType(){
      api.reports.dashboard.salestopbytype(
        function(data){  
          var total = _(data).sumBy(function(x) { return x.amount });
          vm.salestopbytype = {
            labels: data.map(function(x) { return x.name + ' - ' + Math.round((x.amount / total) * 100) + '%'  }),
            data: data.map(function(x) { return x.amount }),
            total: total,
            options: { 
              legend : { 
                  display : true, 
                  position : "right"
              }                            
            }
          };
        }
      );    
    }
    
    function _loadSalesYear(){
      api.reports.dashboard.salesyear(
        function(data){  
          if (!data || !data.length){
            vm.salesyear = {}
            return;
          }


          var group = _(data)
              .groupBy(function(x) { return x.year })
              .map(function(i, k) { return ({
                year: k,
                items: i
              })})
              .value();

          vm.salesyear = {
            labels: group[0].items.map(function(x) { return x.monthName }),
            data: group.map(function(x) { return x.items.map(function(y) { return y.amount }) }),
            series : group.map(function(x) { return x.year }),
            total: _(data).sumBy(function(x) { return x.amount }),
            options: {
              legend : { 
                display : true, 
                position : "top"
              },              
              scales: {
                yAxes: [{                  
                  ticks: currnecyYAxisTicksConfig
                }]
              },
              tooltips: currencyTooltipConfig
            }      
          };
        }
      );    
    }

    function _loadSalesYearByType(){
      api.reports.dashboard.salesyearbytype(
        function(data){             
          if (!data || !data.length){
            vm.salesyearbytype = {}
            return;
          }

          var group = _(data)
            .groupBy(function(x) { return x.type })
            .map(function(i, k) { return ({
              type: k,
              items: i.map(function(item){ return Object.assign(item, { key: item.year + (item.monthNumber / 100) })})
            })})
            .value();          

          // Complete Series
          var maxItems = [];
          group.forEach(function(g){
              g.items.map              
              var maxItemsGroup = g.items.map(function(i){ return {year: i.year, monthName: i.monthName, monthNumber: i.monthNumber, key: i.key }});                
              maxItems.forEach(function(mi){                                  
                if (maxItemsGroup.filter(function(mig){ return mi.key === mig.key}).length === 0){
                  g.items.push(Object.assign(mi, { amount: 0 }));
                }
              });
              maxItemsGroup.forEach(function(mig){                                  
                if (maxItems.filter(function(mi){ return mi.key === mig.key}).length === 0){
                  maxItems.push(mig);
                }
              });

              g.items = _(g.items).orderBy(["key"], ["asc"]).value();              
          });

          vm.salesyearbytype = {
            labels : group[0].items.map(function(x) { return x.monthName }),
            data   : group.map(function(x) { return x.items.map(function(y) { return y.amount }) }),
            total  : _(data).sumBy(function(x) { return x.amount }),
            series : group.map(function(x) { return x.type }),
            options: {
              legend : { 
                display : true, 
                position : "top"
              },
              scaleShowVerticalLines: false,
              responsive: true,              
              scales: {
                xAxes: [{
                    stacked: true                    
                }],
                yAxes: [{
                    stacked: true,
                    ticks: currnecyYAxisTicksConfig
                }]
              },
              tooltips: currencyTooltipConfig
            }
          };
        }
      );    
    }

    function currencyFriendlyFormat(value, decimals){
      if (value >= 1000000){
        return $filter('currency')(value / 1000000, '$ ', decimals ? decimals : 2) + ' M';
      }else if(value > 10000) {
        return $filter('currency')(value / 1000, '$ ', decimals ? decimals : 0) + ' k';
      }else{
        return $filter('currency')(value, '$ ', decimals ? decimals : 0);
      }
    }

  }
})();

(function(){
	'use strict';

    angular
        .module('app.invoices', 
            [
                'datatables',
                // Submodules
                'app.invoices.orders',                
                'app.invoices.plannedProducts',
                'app.invoices.turns',
                'app.invoices.notasCredito',
                'app.invoices.complements',
                'app.invoices.batch'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.invoices', {
                abstract: true,
                url     : '/invoices'
            })
            .state('app.invoices.receipt', {
                url      : '/:id/:type',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/receipt/receipt.html',
                        controller : 'InvoicesReceiptController as vm'
                    }
                },
                resolve  : {
                    Item: function (apiResolver, $stateParams)
                    {                        
                        if ($stateParams.type && $stateParams.type !== '' && $stateParams.type === "complement")
                            return apiResolver.resolve('invoices.complements@getReceipt', { id : $stateParams.id });
                        else
                            return apiResolver.resolve('invoices.invoices@get', { id : $stateParams.id });
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : '',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.invoices', {
            title : 'Facturación',
            icon  : 'icon-currency-usd',
            weight: 3
        });            
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.invoices')
        .controller('InvoicesTurnsController', invoicesTurnsController);

    /** @ngInject */
    function invoicesTurnsController(api, msg)
    {
        var vm = this;
        _init();

        // Methods
        vm.closeTurn = closeTurn;
        vm.openTurn = openTurn;
        vm.getTurns = getTurns;
        ////////

        function _init(){
            var from = moment().add(-1, 'days');
            var to = moment();            
            
            vm.from = from.format('MM/DD/YYYY');
            vm.to = to.format('MM/DD/YYYY');

            getTurns();

            vm.filterOpenOptions = [
                { text: 'Todos', value: '' },
                { text: 'Solo Abiertos', value: true },
                { text: 'Solo Cerrados', value: false },
            ];
            vm.isOpen = '';
        }

        function getTurns(){
            api.invoices.turns.get({
                dateIni: moment(vm.from).format("DD-MM-YYYY"), 
                dateEnd: moment(vm.to).format("DD-MM-YYYY")
            },function(response){
                vm.turns = response;
            });
        }

        function closeTurn(turn){
            if (confirm("Estas seguro que deseas cerrar el turno " + turn.id + "?")){
                turn.isOpen = false;
                api.invoices.turns.save(turn, function(response){
                    getTurns();
                    msg.success("Turno cerrado");
                });
            }
        }

        function openTurn(){
            if (confirm("Se abrira un nuevo turno, desea continuar?")){
                api.invoices.turns.save({
                    id: 0
                }, function(response){
                    getTurns();
                    msg.success("Turno creado correctamente.");
                });
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.license', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.license', {
                url      : '/license',
                views    : {
                    'main@'                       : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.license': {
                        templateUrl: 'app/main/license/license.html',
                        controller: 'LicenseController as vm'
                    }
                }
            });
    }

   
})();
(function ()
{
    'use strict';

    angular
        .module('app.license')
        .controller('LicenseLoginDialogController', licenseLoginDialogController);

    /** @ngInject */
    function licenseLoginDialogController(api, $mdDialog, msg, Callback)
    {
        var vm = this;
        _init();

        /// Methods
        vm.accept = accept;
        vm.close = close;
        ////

        function _init(){
            vm.callback = Callback;
            vm.item = {
                date: new Date()
            };
        }   

        function close(){
            $mdDialog.hide();
        }

        function accept(){
            api.app.access.license(vm.item, function(response){
                vm.callback(response.license);
                close();
            });
        }
    }
})();
(function ()
{
    'use strict';



    angular
        .module('app.invoices')
        .controller('InvoicesReceiptController', invoicesReceiptController);

    /** @ngInject */
    function invoicesReceiptController($scope, api, Item, authService, msg, $stateParams)
    {
        var vm = this;

        vm.item = Item;
        vm.picturesUrl = api.baseUrl.replace("api/","");
        vm.settings = authService.getAppData().settings;
        vm.logoSource = "data:image/jpeg;base64, " + vm.settings.logoBase64String;
        vm.pdfSaving = true;            

        // Generate QR code
        var qrcode = new QRCode(document.getElementById("qrcode"));
        qrcode.makeCode(vm.item.qrCode);
        
        $scope.$on('$viewContentLoaded', function() {
            vm.pdfSaving = true;            
            // Send to Api for Save in PDF
            setTimeout(sendToApi, 1500);
        });


        // Save PDF
        vm.pdfDownload = function(){
            html2canvas(document.querySelector("#invoice-card")).then(function(canvas){
                var data = canvas.toDataURL();
                var docDefinition = {
                    content: [{
                        image: data,
                        width: 500,
                    }]
                };
                pdfMake.createPdf(docDefinition).download(vm.item.folio + ".pdf");    
                // pdfMake.createPdf(docDefinition).open();
            });            
        }

        vm.sendMail = function(){
            msg.prompt("Correo Electrónico", "Ingrese correo electrónico", function(email){
                if (!email || email == ''){
                    msg.error("Correo electrónico inválido. verifique");
                    return;
                }

                api.invoices.email.save({
                    invoiceId: vm.item.id,
                    invoiceFolio : vm.item.folio,
                    email: email
                }, function(response){
                    msg.success("Correo Electrónico enviado correctamente.");
                });

            }, null, null, vm.item.partner.email);
        }

        function sendToApi(){
            vm.pdfSaving = true;
            html2canvas(document.querySelector("#invoice-card")).then(function(canvas){
                var data = canvas.toDataURL();
                var docDefinition = {
                    content: [{
                        image: data,
                        width: 500,
                    }]
                };
                pdfMake.createPdf(docDefinition).getBase64(function(encodedString) {
                    // Send to API Service
                    api.invoices.pdf.save({
                        invoiceId    : vm.item.id,
                        invoiceFolio : vm.item.folio,
                        base64String : encodedString
                    }, function(response){
                        vm.pdfSaving = false;
                    });
                });
            });
        }

        vm.fileDownload = function(filePath,extension){
            api.catalogs.files.getFile({
                data: filePath
            }, function(response){
                // Set up the link
                var link = document.createElement("a");
                link.setAttribute("target","_blank");
                link.setAttribute("href","data:application/octet-stream;base64," + response.data);
                link.setAttribute("download",vm.item.folio + "." + extension );
                link.click();
            });
        }

        
        var unidades = ["", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"];
        var especiales = ["diez", "once", "doce", "trece", "catorce", "quince", "dieciséis", "diecisiete", "dieciocho", "diecinueve"];
        var decenas = ["", "", "veinte", "treinta", "cuarenta", "cincuenta", "sesenta", "setenta", "ochenta", "noventa"];
        var centenas = ["", "ciento", "doscientos", "trescientos", "cuatrocientos", "quinientos", "seiscientos", "setecientos", "ochocientos", "novecientos"];
        
        function convertirGrupo(n) {
            if (n === "000") return "";
            var texto = "";
            var c = parseInt(n[0]), d = parseInt(n[1]), u = parseInt(n[2]);
            
            if (c > 0) {
                texto += (c === 1 && d === 0 && u === 0) ? "cien" : centenas[c] + " ";
            }
            if (d === 1) {
                texto += especiales[u];
            } else {
                texto += decenas[d] + (d > 2 && u > 0 ? " y " : "") + (u === 1 ? "un" : unidades[u]);
            }
            return texto.trim();
        }

        function convertirNumero(num) {
            var numStr = num.toString().split(".");
            var entero = numStr[0].padStart(9, "0"); // Asegura que tenga al menos 9 dígitos
            var centavos = numStr[1] ? numStr[1].padEnd(2, "0").substring(0, 2) : "00"; // Obtiene los centavos
    
            var millones = entero.substring(0, 3);
            var miles = entero.substring(3, 6);
            var centenas = entero.substring(6, 9);
    
            var texto = "";
    
            if (millones !== "000") {
                texto += millones === "001" ? "un millón " : convertirGrupo(millones) + " millones ";
            }
            if (miles !== "000") {
                texto += miles === "001" ? "mil " : convertirGrupo(miles) + " mil ";
            }
            if (centenas !== "000") {
                texto += convertirGrupo(centenas);
            }
    
            texto = texto.trim() || "cero"; // Si el número es 0, devolver "cero"    
    
            return texto + (parseInt(num) === 1 ? ' peso ' : ' pesos ') + centavos + '/100 M.N.';
        }
        
        vm.numberToLetters = function(num) {
            
            if (isNaN(num)) return "Valor no válido";                                
            return convertirNumero(num).toUpperCase();                        
        }

    }
})();
(function () {
  "use strict";

  angular
    .module("app.invoices.complements")
    .controller("InvoicesComplementsController", invoicesComplementsController);

  /** @ngInject */
  function invoicesComplementsController(api, msg, $state, $mdDialog) {
    var vm = this;
    _init();

    // Methods
    vm.getPendingInvoices = getPendingInvoices;
    // vm.view = view;
    vm.selectInvoice = selectInvoice;
    vm.saveComplement = saveComplement;
    vm.view = view;
    vm.cancel = cancel;
    ////////

    function _init() {
      var now = moment();

      var fromFake = moment([now.year() - 1, now.month()]); // TODO: HARDCODE - Quitar
      var from = moment([now.year(), now.month()]);

      var to = moment(from).endOf("month");
      vm.from = fromFake.format("MM/DD/YYYY");
      vm.to = to.format("MM/DD/YYYY");
      vm.maxDate = new Date();

      vm.invoice = null;
      vm.pendingInvoices = [];
      vm.invoiceComplements = [];
      vm.includeCompletePayed = false;
      vm.complement = {};
      vm.satPayments = [];

      // Get SAT Payment Methods
      api.sat.payments.query(function (response) {
        vm.satPayments = response;
      });

      api.sat.banks.query(function (response) {
        vm.satBanks = response;
      });

      api.sat.cadenas.query(function (response) {
        vm.satCadenas = response;
      });

      getPendingInvoices();

      vm.balance = 0;
    }

    function selectInvoice(invoice) {      
      vm.selectedInvoice = invoice;
      vm.complement = {
        id: 0,
        invoiceId: invoice.id,
        rfcReceptor: invoice.targetRfc,
        rfcEmisorBeneficiario: invoice.rfc,
        paymentDate: new moment()
      };
      api.invoices.invoices.get({ id: invoice.id }, function (response) {
        vm.invoice = response;
        vm.complement.satCoin = response.satCoin;
        vm.complement.satCoinId = response.satCoin.id;
        vm.complement.expeditionSatZipCode = response.satZipcode;
        vm.complement.expeditionSatZipCodeId = response.satZipcode.id;
        

        // Get complements
        getcomplementsByInvoice(invoice);
        
      });
    }
      
    function getcomplementsByInvoice(invoice){        
      api.invoices.complements.get({ id: invoice.id },
        function (complementsResponse) {
          vm.invoiceComplements = complementsResponse;
          if (complementsResponse.length > 0)
            vm.complement.sequentialNumber = complementsResponse.length + 1;
          else vm.complement.sequentialNumber = 1;

          var totalComplements =
            complementsResponse.length == 0
              ? 0
              : complementsResponse                  
                  .map(function (comp) {
                    return comp.isCanceled ? 0 : comp.amount;
                  })
                  .reduce(function (a, b) {
                    return a + b;
                  });

          vm.balance = vm.invoice.total - totalComplements;

          var MontoAnterior = invoice.total;
          angular.forEach(vm.invoiceComplements, function (Complement) {
            if (!Complement.isCanceled){
              Complement.saldoAnterior = MontoAnterior;
              Complement.saldoInsoluto = MontoAnterior - Complement.amount;
              MontoAnterior = Complement.saldoInsoluto;
            }
          });
        }
      );
    }

    function getPendingInvoices() {
      api.invoices.complements.getByPeriod(
        {
          from: moment(vm.from).format("DD-MM-YYYY"),
          to: moment(vm.to).format("DD-MM-YYYY"),
          includeCompletePayed: vm.includeCompletePayed
        },
        function (response) {
          vm.pendingInvoices = response;
        }
      );
    }

    function saveComplement() {
      vm.complement.satCoinId = vm.complement.satCoin.id;
      vm.complement.expeditionSatZipCodeId = vm.complement.expeditionSatZipCode.id;
      vm.complement.satPaymentId = vm.complement.satPayment.id;

      api.invoices.complements.save(
        vm.complement,
        function (_) {
          msg.success("Complemento registrado correctamente.");
          getcomplementsByInvoice(vm.selectedInvoice);
        },
        function (errorResponse) {
          msg.success("Auch, algo salio mal, Error:" + errorResponse);
        }
      );
    }
    
    function view(id){      
      $state.go("app.invoices.receipt", { id: id, type: "complement" });
    }
    
    function cancel(item){   
      $mdDialog.show({
          templateUrl:
            "app/main/invoices/views/complements/dialog-cancel/dialog-cancel.html",
          targetEvent: item.id,
          clickOutsideToClose: false,
          escapeToClose: false,
          disableParentScroll: true,
          controller: "InvoicesComplementsCancelDialogController",
          controllerAs: "vm",
          locals: {
            ComplementId: item.id,
            Callback: function (_) {
              getcomplementsByInvoice(vm.selectedInvoice);
            }
          }
        });      
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.invoices')
        .controller('InvoicesPlannedProductsController', invoicesPlannedProductsController);

    /** @ngInject */
    function invoicesPlannedProductsController($state, api, CONST_DATATABLES, $mdDialog, $document, PlannedProducts, msg)
    {
        var vm = this;

        init();

        // Methods
        vm.add = add;
        vm.remove = remove;
        //////////

        function init(){
            vm.plannedProducts = PlannedProducts;
        }

        function add(ev){
            $mdDialog.show({
                controller         : 'InvoicesPlannedProductsDialogAddController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/invoices/views/plannedProducts/dialogs/dialog-add/dialog-add.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Callback : _addCallback
                }
            });
        }
        
        function _addCallback(){
            vm.plannedProducts = api.invoices.plannedProducts.query();
        }

        function remove(item){
            msg.confirm("Esta seguro que desea borrar este elemento?", function(){
                if (item.groupId && item.groupId != 0){
                    msg.confirm("Este registro pertenece a un lote, se borrara el lote completo, desea continuar?", function(){
                        _remove(item);
                    });
                }else{
                    _remove(item);
                }
            });
        }

        function _remove(item){
            api.invoices.plannedProducts.delete({ id: item.id }, function(response){
                msg.success("Registro(s) borrado(s) correctamente.");
                _addCallback();
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.invoices.batch', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.invoices.batch', {
                url      : '/batch',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/batch/batch.html',
                        controller : 'InvoicesBatchOrdersController as vm'
                    }
                }
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.invoices.batch', {
            title: 'Carga Masiva',
            shortcuticon  : 'icon-plus',                        
            state: 'app.invoices.batch'
        });
    }
})();
/* eslint-disable no-undef */
(function () {
  "use strict";

  angular
    .module("app.invoices.batch")
    .controller("InvoicesBatchOrdersController", InvoicesBatchOrdersController);

  /** @ngInject */
  function InvoicesBatchOrdersController(api, msg, $scope, localStorageService) {
    var vm = this;
    vm.result;    
    vm.loading = false;    
    vm.apiUrl = api.baseUrl.replace("api/","");

    _init();

    // Methods
    vm.save = save;
    ////////

    function _init() {
      
    }

    function save(){
      vm.result = null;
      var files = $("#inputFile").get(0).files;

      // Validate data
      if (files.length == 0) {
          msg.error("Seleccione  archivo a subir!.");
          return;
      }

      var file = files[0];
      var data = new FormData();
      data.append("file", file);

      var authData = localStorageService.get('authorizationData');      
      var appData = localStorageService.get("appData");
      vm.loading = true;
      $.ajax({
          type: "POST",
          url: api.baseUrl + "BatchOrders",
          contentType: false,
          processData: false,
          data: data,
          headers: { 
              "Authorization": 'Bearer ' + authData.token,
              "BranchId": appData.branch.id
          },
          success: function (response) {
            $scope.$apply(function() {
              vm.result = response;              
              vm.loading = false;    
            });
          },
          error: function (errorResponse) {
            $scope.$apply(function() {
              vm.loading = false;    
            });
            if (errorResponse.status == 400 && errorResponse.responseText != null){
                msg.error(errorResponse.responseText);
            }else                    
                msg.error("Error al subir archivo, comunicate con el administrador!!!!"); 
          }          
      });
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.catalogs.passes')
        .controller('CatalogsPassesController', catalogsPassesController);

    /** @ngInject */
    function catalogsPassesController($scope, $mdDialog, msg, api, CONST_DATATABLES, Passes, $filter)
    {
        var vm = this;
        _init();

        // Methods
        vm.massiveAdd = massiveAdd;
        vm.remove = remove;
        vm.massiveRemove = massiveRemove;
        //////////

        function _init(){
            // Data
            _getPasses();
            vm.dtPassesInstance = {};
            vm.dtPassesOptions = angular.copy(angular.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true,
                filter      : true
            }));
            vm.status="";
        }

        function _getPasses(){
            vm.items = api.catalogs.passes.query();
        }

        function massiveAdd(ev){
            var last = 50000;
            if (vm.items.length > 0){
                var ordered = $filter('orderBy')(vm.items, 'number');
                var last = ordered[ordered.length - 1].number;
            }
            $mdDialog.show({
                templateUrl        : 'app/main/catalogs/views/passes/dialogs/dialog-massivePasses/dialog-massivePasses.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                disableParentScroll: true,
                controller         : "CatalogsPassesMassiveAddDialogController",
                controllerAs       : "vm",
                locals             : {
                    Callback    : _getPasses,
                    LastNumber  : last,
                    ChangeStatus : _changeStatus
                },
            });    
        }

        function remove(item){
            msg.confirm('Estas seguro que deseas borrar este pase?', function(){
                api.catalogs.passes.delete({ id: item.id }, function(response){
                    if (response){
                        _getPasses();
                    }
                });
            });
        }

        vm.deleting = false;
        function massiveRemove(ev){
            $mdDialog.show({
                templateUrl        : 'app/main/catalogs/views/passes/dialogs/dialog-massivePassesRemove/dialog-massivePassesRemove.html',
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true,
                disableParentScroll: true,
                controller         : "CatalogsPassesMassiveRemoveDialogController",
                controllerAs       : "vm",
                locals             : {
                    Callback : _getPasses,
                    ChangeStatus : _changeStatus
                },
            });  
        }

        function _changeStatus(message){
            vm.status = message;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.catalogs.duesRules')
        .controller('CatalogsDuesRulesController', catalogsDuesRulesController);

    /** @ngInject */
    function catalogsDuesRulesController($scope, $mdDialog, msg, api, CONST_DATATABLES, DuesRules)
    {
        var vm = this;
        _init();

        // Methods
        vm.detail = detail;
        vm.remove = remove;
        //////////

        function _init(){
            // Data
            _getDuesRules();
            vm.dtDuesRulesInstance = {};
            vm.dtDuesRulesOptions = angular.copy(angular.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true,
                filter      : true
            }));
        }

        function _getDuesRules(){
            vm.items = api.catalogs.duesRules.query();
        }

        function detail(ev, item){
            $mdDialog.show({
                templateUrl        : 'app/main/catalogs/views/duesRules/dialogs/dialog-detail/dialog-detail.html',
                targetEvent        : ev,
                disableParentScroll: true,
                controller         : "CatalogsDuesRulesDetailDialogController",
                controllerAs       : "vm",
                locals             : {
                    Callback    : _getDuesRules,
                    DueRule     : item    
                },
            });    
        }

        function remove(id){
            msg.confirm('Estas seguro que deseas borrar esta regla?', function(){
                api.catalogs.duesRules.delete({ id: id }, function(response){
                    if (response){
                        _getDuesRules();
                        msg.success("Regla de cuota borrada correctamente");
                    }
                });
            });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.accionistas.purchase', [ 
        ])
        .config(accionistasPurchaseConfig);

    /** @ngInject */
    function accionistasPurchaseConfig($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.accionistas.purchase', {
                url      : '/purchase',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/accionistas/views/purchase/purchase.html',
                        controller : 'AccionistasPurchaseController as vm'
                    }
                },
                resolve  : {
                    Acciones: function (apiResolver)
                    {
                        return apiResolver.resolve('accionistas.acciones@query');
                    },
                    Accionistas: function (apiResolver)
                    {
                        return apiResolver.resolve('accionistas.accionistas@query');
                    }
                }
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.accionistas.purchase', {
            title: 'Compra',
            shortcuticon  : 'icon-cash-multiple',            
            state: 'app.accionistas.purchase'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.accionistas.purchase')
        .controller('AccionistasTransferController', accionistasTransferController);

    /** @ngInject */
    function accionistasTransferController($scope, $mdDialog, msg, api, $state, Accionistas)
    {
        var vm = this;
        _init();

        // Methods
        vm.accionistaSourceChange = accionistaSourceChange;
        vm.selectAccion = selectAccion;
        vm.save = save;
        //////////

        function _init(){
            vm.accionistas = Accionistas;
            vm.transferToClub = true;
            vm.accionesSource = [];
            vm.accionistaSource = null;
            vm.book = '';
            vm.folio = '';
            vm.row = '';
        }

        function accionistaSourceChange(){
            vm.accionistasTaget = vm.accionistas.filter(function(a){ return a.id != vm.accionistaSource.id });
            vm.selectedAcciones = [];            
            api.accionistas.accionistas.get({   
                id: vm.accionistaSource.id
            }, function(response){
                vm.accionesSource = response.acciones;
            });
        }

        function selectAccion(accion){
            accion.selected = !accion.selected;            
        }

        function save(){
            var error = '';            
            var selectedAcciones = vm.accionesSource.filter(function(a){ return a.selected });
            if (selectedAcciones.length == 0)
                error = "Seleccione al menos una accion a tranferir";
            else if (!vm.transferToClub){
                if(!vm.accionistaTarget)
                    error = "Seleccione accionista a traspasar las acciones";
                else if ((!vm.book || vm.book == '') || (!vm.folio || vm.folio == '') || (!vm.row || vm.row == ''))
                    error = "Ingrese todos los campos obligatorios";
            }
            if (error != '')
            {
                msg.error(error);
                return;
            }            

            angular.forEach(selectedAcciones, function(a){
                a.book = vm.book;
                a.folio = vm.folio;
                a.row = vm.row;
            });
            
            msg.confirm("Estas seguro que deseas transferir " + selectedAcciones.length + " accion(es)?", function(){
                api.accionistas.transfers.save({
                    type            : vm.transferToClub ? 1: 2,
                    acciones        : selectedAcciones,
                    accionistaSource: vm.accionistaSource,
                    accionistaTarget: vm.accionistaTarget
                }, function(response){
                    msg.success("Acciones transferidas");
                    _init();
                    vm.accionistas = api.accionistas.accionistas.query();
                });
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.accionistas.purchase')
        .controller('AccionistasPurchaseController', accionistasPurchaseController);

    /** @ngInject */
    function accionistasPurchaseController($scope, $mdDialog, msg, api, Acciones, $state, Accionistas)
    {
        var vm = this;
        _init();

        // Methods
        vm.goToStep = goToStep;
        vm.selectAccion = selectAccion;
        vm.selectAllAcciones = selectAllAcciones;
        vm.unselectAccion = unselectAccion;
        vm.unselectAllAcciones = unselectAllAcciones;
        vm.newAccionista = newAccionista;
        vm.fromClubChange = fromClubChange;
        vm.getAccionesFromAccionista = getAccionesFromAccionista;
        //////////

        function _init(){
            vm.accionistas = Accionistas;
            vm.acciones = Acciones;            
            vm.isAccionista = true;
            vm.step = 1;
            vm.purchaseFromClub = true;

            fromClubChange();
            newAccionista();
        }

        function newAccionista(){
            if (vm.accionista && vm.accionista.acciones && vm.accionista.acciones.length > 0)
                unselectAllAcciones();

            vm.accionista = {
                id      : 0,
                date    : new Date(),
                active  : true,
                acciones: []
            };
        }

        function goToStep(stepNumber){
            
            var error = '';
            switch(stepNumber){
                case 2: // Client selection To Acciones selection
                if ((!vm.accionista.fatherLastname || vm.accionista.fatherLastname == '') && (!vm.accionista.companyName || vm.accionista.companyName == ''))
                    error = "Ingrese al menos el nombre de la persona y/o empresa."
                break;
                case 3: // Save
                if (!vm.accionista.acciones || vm.accionista.acciones.length == 0)
                    error = "Seleccione al menos una acción a comprar";
                break
            }

            if (error != '')
            {
                msg.error(error);
                return;    
            }

            // STEP 3 IS SAVE
            if (stepNumber == 3)
                _save();
            else
                vm.step = stepNumber; 
            
            // POST SELECT ACTIONS
            switch(stepNumber){
                case 2: // Client selection To Acciones selection           
                if (vm.accionista.acciones.length > 0)
                {
                    vm.currentAcciones = vm.accionista.acciones;
                    vm.accionista.acciones = [];
                }     
                if (vm.availableAcciones.length > 0)
                    vm.availableAccion = vm.availableAcciones[0];
                break;
            }

        }

        function selectAccion(accion){
            vm.accionista.acciones.push(accion);
            vm.availableAcciones.splice(vm.availableAcciones.indexOf(accion), 1);
            if (vm.availableAcciones.length > 0)
                vm.availableAccion = vm.availableAcciones[0];
        }

        function selectAllAcciones(){
            angular.forEach(vm.availableAcciones, function(a) {
                vm.accionista.acciones.push(a);
            });
            vm.availableAcciones = [];
        }

        function unselectAccion(accion){
            vm.availableAcciones.push(accion);
            vm.accionista.acciones.splice(vm.accionista.acciones.indexOf(accion), 1);
            if (vm.accionista.acciones.length > 0)
                vm.selectedAccion = vm.accionista.acciones[0];
        }

        function unselectAllAcciones(){
            angular.forEach(vm.accionista.acciones, function(a) {
                vm.availableAcciones.push(a);
            });
            vm.accionista.acciones = [];
        }

        function _save(){
            angular.forEach(vm.accionista.acciones, function(a){
                a.book = vm.book;
                a.folio = vm.folio;
                a.row = vm.row;
            });

            api.accionistas.accionistas.save(vm.accionista, function(response){
                msg.success("Accionista guardado correctamente.");
                $state.reload();
            });
        }

        function getAccionesFromAccionista(){
            if (vm.accionista.id == vm.sellerAccionistaId){
                msg.error("No puedes comprarte acciones a ti mismo");
                return;
            }
            api.accionistas.accionistas.get({
                id: vm.sellerAccionistaId
            }, function(response){
                vm.availableAcciones = response.acciones;
            });
        }

        function fromClubChange(){
            if (vm.purchaseFromClub){
                vm.availableAcciones = vm.acciones.filter(function(a){ return !a.accionistaId });
                if (vm.availableAcciones.length > 0)
                    vm.availableAccion = vm.availableAcciones[0];
            }else{
                vm.availableAcciones = [];
                vm.availableAccion = null;
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.accionistas.acciones')
        .controller('AccionistasAccionesController', accionistasAccionesController);

    /** @ngInject */
    function accionistasAccionesController($scope, $mdDialog, msg, api, CONST_DATATABLES, Acciones)
    {
        var vm = this;

        // Methods
        vm.massiveAdd = massiveAdd;
        vm.remove = remove;
        //////////

        _init();
        
        function _init(){
            // Data
            _getAcciones();
            vm.dtAccionesInstance = {};
            vm.dtAccionesOptions = angular.copy(angular.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true,
                filter      : true
            }));
            vm.status="";
        }

        function _getAcciones(){
            vm.items = api.accionistas.acciones.query();
        }

        function massiveAdd(ev){
            $mdDialog.show({
                templateUrl        : 'app/main/accionistas/views/acciones/dialogs/dialog-massiveAdd/dialog-massiveAdd.html',
                targetEvent        : ev,
                disableParentScroll: true,
                controller         : "AccionistasAccionesMassiveAddDialogController",
                controllerAs       : "vm",
                locals             : {
                    Callback    : _getAcciones,
                    ChangeStatus : _changeStatus
                },
            });    
        }

        vm.removing = false;
        function remove(id){
            msg.confirm('Estas seguro que deseas borrar esta accíon?', function(){
                vm.removing = true;
                _changeStatus("Borrando...");            
                api.accionistas.acciones.delete({ id: id }, function(response){
                    if (response){
                        _getAcciones();
                        vm.removing = false;
                        _changeStatus("Accion borrada correctamente");
                    }
                }, function(errorResponse){
                    vm.removing = false;
                    _changeStatus("Ocurrio un error al borrar la accion");
                });
            });
        }

        function _changeStatus(message){
            vm.status = message;
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.test', 
            [
                'datatables',
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.test', {
                abstract: true,
                url     : '/test'
            })
            .state('app.test.selection', {
                url      : '/selection',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/test/drag-selection/drag-selection.html',
                        controller : 'TestSelectionController as vm'
                    }
                }
            })
            .state('app.test.excel', {
                url      : '/excel',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/test/excel/excel1.html',
                        controller : 'ExcelController as vm'
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.test', {
            title : 'Pruebas',
            icon  : 'icon-lock',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('apps.test.selection', {
            title: 'Multiseleccion',
            state: 'app.test.selection'
        });
        
        msNavigationServiceProvider.saveItem('apps.test.excel', {
            title: 'Excel',
            state: 'app.test.excel'
        });
    }
})();
var isMouseDown = false,
    isHighlighted;
(function ()
{
    'use strict';


    angular
        .module('app.test')
        .factory('Excel',function($window){
            var uri='data:application/vnd.ms-excel;base64,',
                template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
                base64=function(s){return $window.btoa(unescape(encodeURIComponent(s)));},
                format=function(s,c){return s.replace(/{(\w+)}/g,function(m,p){return c[p];})};
            return {
                tableToExcel:function(tableId,worksheetName){
                    var table=$(tableId),
                        ctx={worksheet:worksheetName,table:table.html()},
                        href=uri+base64(format(template,ctx));
                    return href;
                }
            };
        })
        .controller('ExcelController', excelController);

    /** @ngInject */
    function excelController(Excel,$timeout)
    {
        var vm = this;

        _init();

        function _init(){

        }

        vm.excelExport = function(tableId){ // ex: '#my-table'
            var exportHref=Excel.tableToExcel(tableId,'TestSheetName');
            $timeout(function(){location.href=exportHref;},100); // trigger download
        }
    }
})();
var isMouseDown = false,
    isHighlighted;
(function ()
{
    'use strict';

    angular
        .module('app.test')
        .controller('TestSelectionController', TestSelectionController);

    /** @ngInject */
    function TestSelectionController($state, api, msg)
    {
        var vm = this;

        vm.generate = generate;


        function generate(){
            // Clear table             
            $("#our_table > tr").remove(); 

            // Create table
            var counter = 1;
            var width = 900 / vm.cols;
            var height = 600 / vm.rows;
            for(var row = 0; row < vm.rows; row++){
                var htmlRow = document.createElement("TR");
                for(var col = 0; col < vm.cols; col++){                
                    var cell = document.createElement("TD");
                    cell.id = counter;
                    cell.style.width = width + 'px';
                    cell.style.height = height + 'px';
                    // var inp = document.createElement("INPUT");
                    // cell.appendChild(inp);
                    // htmlCol.innerHTML = counter;
                    htmlRow.appendChild(cell);
                    counter++;
                }
                document.getElementById("our_table").appendChild(htmlRow);
            }

            // Rebind events
            $("#our_table td")
                .mousedown(function () {
                    isMouseDown = true;
                    $(this).toggleClass("highlighted");
                    isHighlighted = $(this).hasClass("highlighted");
                    return false; // prevent text selection
                })
                .mouseover(function () {
                    if (isMouseDown) {
                        $(this).toggleClass("highlighted", isHighlighted);
                    }
                })
                .bind("selectstart", function () {
                    return false;
                });
        }
    }
})();
(function(){
	'use strict';

    angular
        .module('app.pages', 
            [
                'app.pages.profile',
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages', {
                abstract: true,
                url     : '/pages'
            });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages')
        .controller('PagesProfileController', pagesProfileController);

    function pagesProfileController($state, api, msg, authService, localStorageService)
    {
        var vm = this;
        
        // Methods
        vm.mainSave = mainSave;
        vm.mainAvatarSave = mainAvatarSave;
        vm.pwdSave = pwdSave;
        ////////////

        init();

        function init()
        {
            var appData = authService.getAppData();
            vm.user = appData.user;
            vm.avatarsUrl = api.baseUrl.replace("api/","");            
        }

        function mainSave(){
            vm.user.username = authService.getAppData().user.username;
            api.security.users.save(vm.user, function(response){
                msg.success("Datos guardados correctamente");
                authService.updateUserData(vm.user);
                $state.reload();
            });
        }

        function mainAvatarSave(){
            var files = $("#inputFile").get(0).files;

            // Validate data
            if (files.length == 0) {
                msg.error("Seleccione  archivo a subir!.");
                return;
            }

            var file = files[0];
            var data = new FormData();
            data.append("file", file);
            data.append("userId", vm.user.id);

            var authData = localStorageService.get('authorizationData');
            $.ajax({
                type: "POST",
                url: api.baseUrl + "UserFiles",
                contentType: false,
                processData: false,
                data: data,
                headers: { 
                    "Authorization": 'Bearer ' + authData.token
                },
                success: function (response) {
                    msg.success("Avatar cambiado!");
                    $("#inputFile").val('');
                    vm.user.avatar = response.avatar;
                    authService.updateUserData(vm.user);
                    $state.reload();
                },
                error: function (errorResponse) {
                    if (errorResponse.status == 500){
                        msg.error(errorResponse.responseJSON.exceptionMessage);
                    }else                    
                        msg.error("Error al subir archivo, comunicate con el administrador!!!!"); 
                }
            });
        }

        function pwdSave(){
            vm.changePassword.username = vm.user.username;
            vm.changePassword.changeType = 2; /* Change */
            api.security.users.change(vm.changePassword, function(response){
                msg.success("Cantraseña modificada correctamente");
                vm.changePassword = {};
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.login', {
                url      : '/',
                views    : {
                    'main@'                       : {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.login': {
                        templateUrl: 'app/main/login/login.html',
                        controller: 'LoginController as vm'
                    }
                }
            });
    }

   
})();
(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginDialogController2', LoginDialogController2);

    /** @ngInject */
    function LoginDialogController2(api, $mdDialog, Callback, User, Password) {
        var vm = this;
        _init();

        /// Methods
        vm.cerrarSesiones = cerrarSesiones;
        vm.cancel = cancel;
        ////

        function _init() {
            vm.contesena = "";
        }

        function cerrarSesiones() {
            Callback.login({
                userName: User,
                password: Password
            }).then(function () {

                // Get APP access 
                api.app.access.closeSession({contrasena: vm.contesena},
                    function (accessResponse) {
                        if (accessResponse.$resolved) {
                            //SUCCESS
                            $mdDialog.hide(vm.contesena);
                        }
                        else {
                            $mdDialog.hide("02");
                        }
                    }
                );
            });
        }

        function cancel() {
            $mdDialog.hide("02");
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('LoginDialogController', loginDialogController);

    /** @ngInject */
    function loginDialogController(api, $mdDialog, Callback)
    {
        var vm = this;
        _init();

        /// Methods
        vm.accept = accept;
        vm.close = close;
        ////

        function _init(){
            vm.item = {};
            vm.callback = Callback;
        }   

        function close(){
            $mdDialog.hide();
        }

        function accept(){
            api.security.controlsAccess.login(vm.item, function(response){
                vm.callback(response);
                close();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function (){
    'use strict';

    angular
        .module('app.core')
        .directive('selectOnFocus', selectOnFocus);

    function selectOnFocus($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var focusedElement = null;

                element.on('focus', function () {
                    var self = this;
                    if (focusedElement != self) {
                        focusedElement = self;
                        $timeout(function () {
                            self.select();
                        }, 10);
                    }
                });

                element.on('blur', function () {
                    focusedElement = null;
                });
            }
        }
    }        
})();
(function () {
  "use strict";

  angular
    .module("app.core")
    .directive("cdReportDatesRange", reportDatesRangeDirective);

  function reportDatesRangeDirective() {
    return {
      restrict: "E",
      // scope: true,
      scope: {
        ngModel: "=",
      },
      require: "^ngModel",
      transclude: true,
      link: function (scope, element, attrs, catalogCtrl) {
        scope.date = {
          // from: getNowUTC(),
          // to: getNowUTC(),
          from: new Date(),
          to: new Date(),
        };

        scope.changeEvent = function () {
          scope.ngModel = scope.date;
        };

        scope.changeEvent();
      },
      templateUrl:
        "app/main/directives/cd-report-dates-range/cd-report-dates-range.template.html",
    };
  }

  // function getNowUTC() {
  //   const now = new Date();
  //   console.log('Now');
  //   console.log(now);
  //   console.log('Time');
  //   console.log(now.getTime() + now.getTimezoneOffset() * 60000);
  //   console.log(now.getTime());
  //   console.log(now.getTimezoneOffset());
  //   console.log(now.getTime() + now.getTimezoneOffset() * 60000);
    
  //   return now.getTime() + now.getTimezoneOffset() * 60000;
  // }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('dynamicTemplate', ["$compile", "$parse", dynamicTemplate]);
    
    function dynamicTemplate($compile, $parse) {
        return {
            restrict: 'A',
            link: function($scope, element, attr) {
                var parse = $parse(attr.ngBindHtml);
                function value() { return (parse($scope) || '').toString(); }

                $scope.$watch(value, function() {
                    $compile(element, null, -9999)($scope); 
                });
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('compareTo', compareTo);

    function compareTo() {
        return {
            require: "ngModel",
            scope: {
                otherModelValue: "=compareTo"
            },
            link: function(scope, element, attributes, ngModel) {
                
                ngModel.$validators.compareTo = function(modelValue) {
                    return modelValue == scope.otherModelValue;
                };
    
                scope.$watch("otherModelValue", function() {
                    ngModel.$validate();
                });
            }
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdSatSelect', ['api', catalogSelect]);
    
    function catalogSelect(api) {
        return {
            restrict: 'E',
            scope: {
                mdSelectedItem : '='
            },
            transclude: true,
            link: function(scope, element, attrs, catalogCtrl){ 
                scope.label = attrs.label;                
                var apiGroupName = "sat";
                var apiName = attrs.apiList;
                var apiService = api[apiGroupName][apiName];
                
                scope.required = attrs.required === undefined ? false: true;
                scope.search = function(keyword){
                    return apiService.get({id: keyword}, function(response){
                        return response;
                    });                     
                }
            },
            templateUrl: 'app/main/directives/cd-sat-select/cd-sat-select.template.html'
        }
    }
})();
(function ()
{
    'use strict';

  angular.module('app.core')
  .directive('signaturePad', function($window) {
    return {
      restrict: 'E',
      template: '<canvas id="signature-pad" class="signature-pad" width=700 height=180></canvas>',
      scope: {
        signature: '='
      },
      link: function(scope, element) {
        var canvas = element.find('canvas')[0];
        var signaturePad = new SignaturePad(canvas, {
          backgroundColor: 'rgba(255, 255, 255, 0)',
          penColor: 'rgb(0, 0, 0)'
        });

        function initSignaturePad() {
          var ratio = Math.max($window.devicePixelRatio || 1, 2);
          canvas.width = (element[0].clientWidth * ratio)-20;
          canvas.height = (element[0].clientHeight * ratio)-20;
          canvas.getContext('2d').scale(ratio, ratio);

          signaturePad = new SignaturePad(canvas, {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            penColor: 'rgb(0, 0, 0)'
          });
        }

        function resizeCanvas() {
          var ratio = Math.max($window.devicePixelRatio || 1, 1);
          canvas.width = element[0].clientWidth * ratio;
          canvas.height = element[0].clientHeight * ratio;
          canvas.getContext('2d').scale(ratio, ratio);
          if (signaturePad) {
            signaturePad.clear(); // clear the canvas on resize
          }
        }

        angular.element($window).on('load', function() {
          initSignaturePad();
        });


        $window.addEventListener('resize', resizeCanvas);
        // resizeCanvas();

        scope.$watch('signature', function(newValue) {
          if (newValue) {
            signaturePad.fromDataURL(newValue);
          }
        });

        scope.$on('$destroy', function() {
          $window.removeEventListener('resize', resizeCanvas);
        });

        signaturePad.onEnd = function() {
          scope.$apply(function() {
            scope.signature = signaturePad.toDataURL();
          });
        };

        scope.$on('clearSignature', function() {
          signaturePad.clear();
        });
      }
    };

    // DirectiveEnd
  
  });

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdReportDatePeriod', cdReportDatePeriod);
    
    function cdReportDatePeriod() {
        return {
            restrict: 'E',
            // scope: true,                    
            scope: {
                ngModel: "=",
                periodicities: '='
            },
            require: '^ngModel',
            transclude: true,
            link: function(scope, element, attrs, catalogCtrl){ 
                scope.filterByDate = true;
                scope.date = {
                    type : 1,
                    from : new Date(),
                    to   : new Date()
                };
                scope.period = {
                    type: 2,
                    periodicityId: null,
                    periods   : 1
                };

                scope.changeEvent = function(){
                    if (scope.filterByDate){
                        scope.ngModel = scope.date;
                    }else{
                        scope.ngModel = scope.period;
                    }
                }

                scope.changeEvent();                
            },
            templateUrl: 'app/main/directives/cd-report-date-period/cd-report-date-period.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdRentableSelection', directive);

    function directive() {

        function mainController($scope, msg, api, $element){
            var vm = this;

            _init();

            /// Methods 
            vm.zoneChange = zoneChange;
            ///

            function _init(){
                api.catalogs.rentableZones.query(function(response){
                    vm.rentableZones = response;
                    if ($scope.zoneId){
                        vm.rentableZone = vm.rentableZones.filter(function(z){ return z.id == $scope.zoneId })[0];
                        zoneChange();
                    }
                });
                vm.rentable = $scope.rentable;
            }

            function zoneChange(){
                
                $scope.ngModel = null;
                api.partners.rentables.getByRentableZone({
                    familyId: 0,
                    rentableZoneId: vm.rentableZone.id
                }, function(response){
                    vm.assignedRentables = [];
                    angular.forEach(response, function(assigned){
                        vm.assignedRentables.push(angular.extend(assigned.rentable, { partnerName: assigned.partner.completeName }));
                    });

                    api.catalogs.rentableZones.get({ id: vm.rentableZone.id }, function(response){
                        vm.rentableZone.rentables = response.rentables;                        
                        _generateMatrix();
                    });
                });
            }

            function _generateMatrix(){
                // Clear table             
                $("#matrix").remove(); 

                var table = document.createElement("TABLE");
                table.id = "matrix";

                // Create matrix
                var counter = 1;
                var width = 700 /  vm.rentableZone.matrixColumns;
                var height = 470 / vm.rentableZone.matrixRows;
                for(var row = 0; row < vm.rentableZone.matrixRows; row++){
                    var htmlRow = document.createElement("TR");
                    for(var col = 0; col < vm.rentableZone.matrixColumns; col++){                
                        var cell = document.createElement("TD");
                        cell.id = counter;
                        cell.style.width = width + 'px';
                        cell.style.height = height + 'px';
                        htmlRow.appendChild(cell);
                        counter++;
                    }
                    table.appendChild(htmlRow);
                }
                $("#matrix-container").html(table);

                // Create current created rentables 
                if (vm.rentableZone.rentables && vm.rentableZone.rentables.length > 0){
                    $("#matrix td").each(function(index){
                        var id = $(this).attr("id");
                        var filter = vm.rentableZone.rentables.filter(function(l){
                            return l.matrixId ==  id;
                        });
                        if (filter.length > 0){
                            $(this).html("<input type='hidden' id='hdn_" + filter[0].id + "' value='" + filter[0].id + "' />" + filter[0].name);
                            $(this).addClass("available");
                        }
                    });
                }

                // Mark available rentables
                $("#matrix td").each(function(index){
                    if ($(this).hasClass("available")){
                        var id = $(this).attr("id");
                        var filter = vm.assignedRentables.filter(function(l){ return l.matrixId ==  id; });
                        if (filter.length > 0){
                            $(this).removeClass("available").addClass("occuped");
                            $(this).html($(this).html() + "<span class='tooltip'>"+ filter[0].partnerName +"</span>");
                        }
                    }
                });


                // Set events
                $("#matrix td")
                    .mousedown(function () {
                        if ($(this).hasClass("available")){
                            $("#matrix td.assign").removeClass("assign");
                            $(this).addClass("assign");

                            // Set Rentable Id to ng-model
                            var rentableId = parseInt($(this).find("input[type='hidden']").val());
                            var ngModel = $element.controller('ngModel');
                            ngModel.$setViewValue(rentableId);
                        }else{
                            $(this).find(".tooltip").show();
                        }
                        return false; // prevent text selection
                    });
                
                $("#matrix td")
                    .mouseup(function () {
                            $(this).find(".tooltip").hide();                        
                    });
            }

        }

        return {
            restrict    : 'E',
            transclude  : true,
            require     : 'ngModel',
            scope       : {
                ngModel : '=', 
                zoneId : '='
            },
            controllerAs: 'vm',
            controller  : mainController,
            templateUrl : 'app/main/directives/cd-rentable-selection/cd-rentable-selection.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdReportAgeRanges', cdReportAgeRangesDirective);
    
    function cdReportAgeRangesDirective(msg) {
        return {
            restrict: 'E',
            // scope: true,                    
            scope: {
                ngModel: "="
            },
            require: '^ngModel',
            transclude: true,
            link: function(scope, element, attrs, catalogCtrl){ 
                scope.ageRanges = 
                [
                    { id: 1, from: 0, to: 0 },
                ];

                scope.changeEvent = function(){
                    scope.ngModel = scope.ageRanges;
                };

                scope.addRange = function(){
                    if (scope.ageRanges.length == 4)
                    {
                        msg.error("No se pueden agregar mas rangos");
                        return;
                    }
                    scope.ageRanges.push({
                        id: scope.ageRanges.length + 1,
                        from: null,
                        to: null
                    });
                };

                // scope.removeRange = function(range){
                //     scope.ageRanges.splice(scope.ageRanges.indexOf(range), 1);
                // };

                scope.changeEvent();
            },
            templateUrl: 'app/main/directives/cd-report-age-ranges/cd-report-age-ranges.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdPatternModel', function patternModelOverwriteDirective() {
            return {
            restrict: 'A',
            require: '?ngModel',
            priority: 1,
            compile: function() {
                var regexp, patternExp;
        
                return {
                pre: function(scope, elm, attr, ctrl) {
                    if (!ctrl) return;
        
                    attr.$observe('pattern', function(regex) {
                    /**
                     * The built-in directive will call our overwritten validator
                     * (see below). We just need to update the regex.
                     * The preLink fn guarantees our observer is called first.
                     */
                    if (angular.isString(regex) && regex.length > 0) {
                        regex = new RegExp('^' + regex + '$');
                    }
        
                    if (regex && !regex.test) {
                        //The built-in validator will throw at this point
                        return;
                    }
        
                    regexp = regex || undefined;
                    });
        
                },
                post: function(scope, elm, attr, ctrl) {
                    if (!ctrl) return;
        
                    regexp, patternExp = attr.ngPattern || attr.pattern;
        
                    //The postLink fn guarantees we overwrite the built-in pattern validator
                    ctrl.$validators.pattern = function(value) {
                    return ctrl.$isEmpty(value) ||
                        angular.isUndefined(regexp) ||
                        regexp.test(value);
                    };
                }
                };
            }
            };
        });
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdPartnersRange', partnersDirective);
    
    function partnersDirective() {
        return {
            restrict: 'E',
            // scope: true,                    
            scope: {
                ngModel: "="
            },
            require: '^ngModel',
            transclude: true,
            link: function(scope, element, attrs, catalogCtrl){ 
                scope.partnersRange = {
                    from :0,
                    to   :0
                };

                scope.changeEvent = function(){
                    scope.ngModel = scope.partnersRange;
                };

                scope.changeEvent();            
            },
            templateUrl: 'app/main/directives/cd-partners-range/cd-partners-range.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdInputTime', inputTime);
    
    function inputTime() {
        return {
            restrict: 'E',
            require: '?ngModel',
            transclude: true,
            scope: {
              ngModel: "="
            },
            templateUrl: 'app/main/directives/cd-input-time/cd-input-time.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('Excel',function($window){
            var uri='data:application/vnd.ms-excel;base64,',
                template=
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" >'+
                        '<head>'+
                        '   <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>'+
                        '   <!--[if gte mso 9]>'+
                        '   <xml>'+
                        '       <x:ExcelWorkbook>'+
                        '           <x:ExcelWorksheets>'+
                        '               <x:ExcelWorksheet>'+
                        '                   <x:Name>{worksheet}</x:Name>+'+
                        '                       <x:WorksheetOptions>'+
                        '                           <x:DisplayGridlines/>'+
                        '                       </x:WorksheetOptions>'+
                        '               </x:ExcelWorksheet>'+
                        '           </x:ExcelWorksheets>'+
                        '       </x:ExcelWorkbook>'+
                        '   </xml>'+
                        '   <![endif]-->'+
                        '</head>'+
                        '<body>'+
                        '   <table>{table}</table>'+
                        '</body>'+
                    '</html>',
                base64=function(s){return $window.btoa(unescape(encodeURIComponent(s)));},
                format=function(s,c){return s.replace(/{(\w+)}/g,function(m,p){return c[p];})};
            return {
                tableToExcel:function(tableId,worksheetName){
                    var table=$(tableId),
                    // ctx={worksheet:worksheetName,table:table.html()},
                    // var table = document.getElementById(tableId),
                        ctx={worksheet:worksheetName, table:processTable(table)},
                        href=uri+base64(format(template,ctx));
                    return href;
                }
            };
        })
        .directive('cdExportExcelButton', exportExcelDirective);
    
        function processTable($table) {
            var rows = $table.find('tr');
            rows.each(function() {
                var cells = $(this).find('td');
                cells.each(function() {
                    var cellContent = $(this).text();                    
                    if (!isNaN(cellContent) && cellContent.length > 15) {
                        $(this).html('<span style="mso-number-format:\\\'@\\\'">="' + cellContent + '"</span>');
                    }
                });
            });
            return $table.html();
        }

    function exportExcelDirective(Excel, $timeout, msg) {
        return {
            restrict: 'E',
            scope: true,                    
            transclude: true,
            link: function(scope){ 
                scope.exportToExcel = function(){                    
                    if ($('.excel-exportable').length == 0)
                    {
                        msg.info('Nothing to export');
                        return;
                    }
                    var exportHref = Excel.tableToExcel('.excel-exportable','ReportData');                    
                    $timeout(
                        function(){
                            location.href=exportHref;
                        },1);
                }               
            },
            templateUrl: 'app/main/directives/cd-export-excel-button/cd-export-excel-button.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdDateFolio', dateFolioDirective);
    
    function dateFolioDirective() {
        return {
            restrict: 'E',
            // scope: true,                    
            scope: {
                ngModel: "="
            },
            require: '^ngModel',
            transclude: true,
            link: function(scope){ 
                scope.filterByDate = true;
                scope.date = {
                    type : 1,
                    from : new Date(),
                    to   : new Date()
                };                
                scope.folio = {
                    type: 2,
                    from : null,
                    to   : null
                };

                scope.changeEvent = function(){
                    if (scope.filterByDate){
                        // scope.ngModel = '|1|' + moment(scope.date.from).format('DD-MM-YYYY') + '|' + moment(scope.date.to).format('DD-MM-YYYY') + '|'
                        scope.ngModel = scope.date;
                    }else{
                        // scope.ngModel = '|2|' + scope.folio.from + '|' + scope.folio.to + '|';
                        scope.ngModel = scope.folio;
                    }
                }

                scope.changeEvent();                
            },
            templateUrl: 'app/main/directives/cd-date-folio/cd-date-folio.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            'LocalStorageModule',
            'ui.mask',
            'moment-picker',            
            
            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            'app.quick-panel',
            
            // Apps
            'app.login',
            'app.license',
            'app.home',
            'app.accionistas',
            'app.partners',
            'app.invoices',
            'app.catalogs',
            'app.inventory',
            'app.security',
            'app.pages',
            'app.reports',            
        ]);
})();
(function () {
    'use strict';

    angular
        .module ('fuse')
        .directive("cdEnter", cdEnterDirective);

    function cdEnterDirective () {
        function mainController($scope, $element, $attrs){
            $element.bind("keydown keypress", function (event) {
                if(event.which === 13) {
                    $scope.$apply(function (){
                        $scope.$eval($attrs.cdEnter);
                    });
    
                    event.preventDefault();
                }
            });
        }

        return {
            restrict: 'A',
            controller: mainController
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdCatalogSelect', ['api', catalogSelect]);
    
    function catalogSelect(api) {
        return {
            restrict: 'E',
            scope: true,
            transclude: true,
            require: '^^cdCatalog',
            link: function(scope, element, attrs, catalogCtrl){ 
                scope.label = attrs.label;
                
                var apiGroupName = attrs.listApiGroup || "catalogs";
                var apiName = attrs.listApiSource;
                var apiService = api[apiGroupName][apiName];
                
                scope.required = attrs.required === undefined ? false: true;

                apiService.query(function(response){
                    scope.list = response;
                });

                scope.$on('itemChangeEvent', function (event, args) {
                    scope.model = args.item[attrs.modelName];
                });
                
                scope.$watch('model', function(m){
                    scope.$emit("itemChildChangeEvent", {
                        modelName: attrs.modelName,
                        value: scope.model  
                    });
                });
            },
            templateUrl: 'app/main/directives/cd-catalog-select/cd-catalog-select.template.html'
        }
    }
})();
(function() {
    
    /**
     * Config
     */
    var moduleName = 'app.core';
    var DEFAULT_ID = '__default';

    /**
     * Module
     */
    angular.module(moduleName)
        .directive('cdCustomGrid', ['$compile', '$parse', 'paginationService', dirPaginateDirective])
        .directive('dirPaginateNoCompile', noCompileDirective)
        .directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective])
        .filter('itemsPerPage', ['paginationService', itemsPerPageFilter])
        .service('paginationService', paginationService)
        .provider('paginationTemplate', paginationTemplateProvider)
        .run(['$templateCache',dirPaginationControlsTemplateInstaller]);

    function dirPaginateDirective($compile, $parse, paginationService) {

        return  {
            terminal: true,
            multiElement: true,
            priority: 100,
            compile: dirPaginationCompileFn
        };

        function dirPaginationCompileFn(tElement, tAttrs){

            var expression = tAttrs.cdCustomGrid;
            // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
            if (expression.indexOf("itemsPerPage") == -1){
                expression = expression + ' | itemsPerPage: (10)';                
            }
            
            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
            
            var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
            if (match[2].match(filterPattern) === null) {
                throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
            }
            var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
            var collectionGetter = $parse(itemsPerPageFilterRemoved);

            addNoCompileAttributes(tElement);

            // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
            // dir-pagination-controls directives that may be looking for this ID.
            var rawId = tAttrs.paginationId || DEFAULT_ID;
            paginationService.registerInstance(rawId);

            return function dirPaginationLinkFn(scope, element, attrs){

                // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
                // potentially register a new ID if it evaluates to a different value than the rawId.
                var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;
                
                // (TODO: this seems sound, but I'm reverting as many bug reports followed it's introduction in 0.11.0.
                // Needs more investigation.)
                // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
                // before registering using paginationId
                // paginationService.deregisterInstance(rawId);
                paginationService.registerInstance(paginationId);

                var repeatExpression = getRepeatExpression(expression, paginationId);
                addNgRepeatToElement(element, attrs, repeatExpression);

                removeTemporaryAttributes(element);
                var compiled =  $compile(element);

                var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
                paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);

                if (typeof attrs.totalItems !== 'undefined') {
                    paginationService.setAsyncModeTrue(paginationId);
                    scope.$watch(function() {
                        return $parse(attrs.totalItems)(scope);
                    }, function (result) {
                        if (0 <= result) {
                            paginationService.setCollectionLength(paginationId, result);
                        }
                    });
                } else {
                    paginationService.setAsyncModeFalse(paginationId);
                    scope.$watchCollection(function() {
                        return collectionGetter(scope);
                    }, function(collection) {
                        if (collection) {
                            var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
                            paginationService.setCollectionLength(paginationId, collectionLength);
                        }
                    });
                }

                // Delegate to the link function returned by the new compilation of the ng-repeat
                compiled(scope);
                    
                // (TODO: Reverting this due to many bug reports in v 0.11.0. Needs investigation as the
                // principle is sound)
                // When the scope is destroyed, we make sure to remove the reference to it in paginationService
                // so that it can be properly garbage collected
                // scope.$on('$destroy', function destroyDirPagination() {
                //     paginationService.deregisterInstance(paginationId);
                // });
            };
        }

        /**
         * If a pagination id has been specified, we need to check that it is present as the second argument passed to
         * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
         *
         * @param expression
         * @param paginationId
         * @returns {*}
         */
        function getRepeatExpression(expression, paginationId) {
            var repeatExpression,
                idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);

            if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
                repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
            } else {
                repeatExpression = expression;
            }

            return repeatExpression;
        }

        /**
         * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
         * appropriate multi-element ng-repeat to the first and last element in the range.
         * @param element
         * @param attrs
         * @param repeatExpression
         */
        function addNgRepeatToElement(element, attrs, repeatExpression) {
            if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
                // using multiElement mode (dir-paginate-start, dir-paginate-end)
                attrs.$set('ngRepeatStart', repeatExpression);
                element.eq(element.length - 1).attr('ng-repeat-end', true);
            } else {
                attrs.$set('ngRepeat', repeatExpression);
            }
        }

        /**
         * Adds the dir-paginate-no-compile directive to each element in the tElement range.
         * @param tElement
         */
        function addNoCompileAttributes(tElement) {
            angular.forEach(tElement, function(el) {
                if (el.nodeType === 1) {
                    angular.element(el).attr('dir-paginate-no-compile', true);
                }
            });
        }

        /**
         * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
         * @param element
         */
        function removeTemporaryAttributes(element) {
            angular.forEach(element, function(el) {
                if (el.nodeType === 1) {
                    angular.element(el).removeAttr('dir-paginate-no-compile');
                }
            });
            element.eq(0).removeAttr('dir-paginate-start').removeAttr('cd-custom-grid').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
            element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
        }

        /**
         * Creates a getter function for the current-page attribute, using the expression provided or a default value if
         * no current-page expression was specified.
         *
         * @param scope
         * @param attrs
         * @param paginationId
         * @returns {*}
         */
        function makeCurrentPageGetterFn(scope, attrs, paginationId) {
            var currentPageGetter;
            if (attrs.currentPage) {
                currentPageGetter = $parse(attrs.currentPage);
            } else {
                // If the current-page attribute was not set, we'll make our own.
                // Replace any non-alphanumeric characters which might confuse
                // the $parse service and give unexpected results.
                // See https://github.com/michaelbromley/angularUtils/issues/233
                var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
                scope[defaultCurrentPage] = 1;
                currentPageGetter = $parse(defaultCurrentPage);
            }
            return currentPageGetter;
        }
    }

    /**
     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
     */
    function noCompileDirective() {
        return {
            priority: 5000,
            terminal: true
        };
    }

    function dirPaginationControlsTemplateInstaller($templateCache) {
        $templateCache.put('angularUtils.directives.dirPagination.template', '<span class="rows-counter">{{range.total}} registro(s)</span><ul class="pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
    }

    function dirPaginationControlsDirective(paginationService, paginationTemplate) {

        var numberRegex = /^\d+$/;

        var DDO = {
            restrict: 'AE',
            scope: {
                maxSize: '=?',
                onPageChange: '&?',
                paginationId: '=?',
                autoHide: '=?'
            },
            link: dirPaginationControlsLinkFn
        };

        // We need to check the paginationTemplate service to see whether a template path or
        // string has been specified, and add the `template` or `templateUrl` property to
        // the DDO as appropriate. The order of priority to decide which template to use is
        // (highest priority first):
        // 1. paginationTemplate.getString()
        // 2. attrs.templateUrl
        // 3. paginationTemplate.getPath()
        var templateString = paginationTemplate.getString();
        if (templateString !== undefined) {
            DDO.template = templateString;
        } else {
            DDO.templateUrl = function(elem, attrs) {
                return attrs.templateUrl || paginationTemplate.getPath();
            };
        }
        return DDO;

        function dirPaginationControlsLinkFn(scope, element, attrs) {

            // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
            // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
            // no corresponding dir-paginate directive and wrongly throwing an exception.
            var rawId = attrs.paginationId ||  DEFAULT_ID;
            var paginationId = scope.paginationId || attrs.paginationId ||  DEFAULT_ID;

            if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
                var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
                if (window.console) {
                    console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
                }
            }

            if (!scope.maxSize) { scope.maxSize = 9; }
            scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
            scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
            scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

            var paginationRange = Math.max(scope.maxSize, 5);
            scope.pages = [];
            scope.pagination = {
                last: 1,
                current: 1
            };
            scope.range = {
                lower: 1,
                upper: 1,
                total: 1
            };

            scope.$watch('maxSize', function(val) {
                if (val) {
                    paginationRange = Math.max(scope.maxSize, 5);
                    generatePagination();
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
                }
            }, function(length) {
                if (0 < length) {
                    generatePagination();
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getItemsPerPage(paginationId));
                }
            }, function(current, previous) {
                if (current != previous && typeof previous !== 'undefined') {
                    goToPage(scope.pagination.current);
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return paginationService.getCurrentPage(paginationId);
                }
            }, function(currentPage, previousPage) {
                if (currentPage != previousPage) {
                    goToPage(currentPage);
                }
            });

            scope.setCurrent = function(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    num = parseInt(num, 10);
                    paginationService.setCurrentPage(paginationId, num);
                }
            };

            /**
             * Custom "track by" function which allows for duplicate "..." entries on long lists,
             * yet fixes the problem of wrongly-highlighted links which happens when using
             * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
             * @param id
             * @param index
             * @returns {string}
             */
            scope.tracker = function(id, index) {
                return id + '_' + index;
            };

            function goToPage(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    var oldPageNumber = scope.pagination.current;

                    scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = num;
                    updateRangeValues();

                    // if a callback has been set, then call it with the page number as the first argument
                    // and the previous page number as a second argument
                    if (scope.onPageChange) {
                        scope.onPageChange({
                            newPageNumber : num,
                            oldPageNumber : oldPageNumber
                        });
                    }
                }
            }

            function generatePagination() {
                if (paginationService.isRegistered(paginationId)) {
                    var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;
                    scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = page;
                    scope.pagination.last = scope.pages[scope.pages.length - 1];
                    if (scope.pagination.last < scope.pagination.current) {
                        scope.setCurrent(scope.pagination.last);
                    } else {
                        updateRangeValues();
                    }
                }
            }

            /**
             * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
             * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
             */
            function updateRangeValues() {
                if (paginationService.isRegistered(paginationId)) {
                    var currentPage = paginationService.getCurrentPage(paginationId),
                        itemsPerPage = paginationService.getItemsPerPage(paginationId),
                        totalItems = paginationService.getCollectionLength(paginationId);

                    scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
                    scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
                    scope.range.total = totalItems;
                }
            }
            function isValidPageNumber(num) {
                return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
            }
        }

        /**
         * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
         * links used in pagination
         *
         * @param currentPage
         * @param rowsPerPage
         * @param paginationRange
         * @param collectionLength
         * @returns {Array}
         */
        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
            var pages = [];
            var totalPages = Math.ceil(collectionLength / rowsPerPage);
            var halfWay = Math.ceil(paginationRange / 2);
            var position;

            if (currentPage <= halfWay) {
                position = 'start';
            } else if (totalPages - halfWay < currentPage) {
                position = 'end';
            } else {
                position = 'middle';
            }

            var ellipsesNeeded = paginationRange < totalPages;
            var i = 1;
            while (i <= totalPages && i <= paginationRange) {
                var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);

                var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
                var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                    pages.push('...');
                } else {
                    pages.push(pageNumber);
                }
                i ++;
            }
            return pages;
        }

        /**
         * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
         *
         * @param i
         * @param currentPage
         * @param paginationRange
         * @param totalPages
         * @returns {*}
         */
        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
            var halfWay = Math.ceil(paginationRange/2);
            if (i === paginationRange) {
                return totalPages;
            } else if (i === 1) {
                return i;
            } else if (paginationRange < totalPages) {
                if (totalPages - halfWay < currentPage) {
                    return totalPages - paginationRange + i;
                } else if (halfWay < currentPage) {
                    return currentPage - halfWay + i;
                } else {
                    return i;
                }
            } else {
                return i;
            }
        }
    }

    /**
     * This filter slices the collection into pages based on the current page number and number of items per page.
     * @param paginationService
     * @returns {Function}
     */
    function itemsPerPageFilter(paginationService) {

        return function(collection, itemsPerPage, paginationId) {
            if (typeof (paginationId) === 'undefined') {
                paginationId = DEFAULT_ID;
            }
            if (!paginationService.isRegistered(paginationId)) {
                throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
            }
            var end;
            var start;
            if (angular.isObject(collection)) {
                itemsPerPage = parseInt(itemsPerPage) || 9999999999;
                if (paginationService.isAsyncMode(paginationId)) {
                    start = 0;
                } else {
                    start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
                }
                end = start + itemsPerPage;
                paginationService.setItemsPerPage(paginationId, itemsPerPage);

                if (collection instanceof Array) {
                    // the array just needs to be sliced
                    return collection.slice(start, end);
                } else {
                    // in the case of an object, we need to get an array of keys, slice that, then map back to
                    // the original object.
                    var slicedObject = {};
                    angular.forEach(keys(collection).slice(start, end), function(key) {
                        slicedObject[key] = collection[key];
                    });
                    return slicedObject;
                }
            } else {
                return collection;
            }
        };
    }

    /**
     * Shim for the Object.keys() method which does not exist in IE < 9
     * @param obj
     * @returns {Array}
     */
    function keys(obj) {
        if (!Object.keys) {
            var objKeys = [];
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    objKeys.push(i);
                }
            }
            return objKeys;
        } else {
            return Object.keys(obj);
        }
    }

    /**
     * This service allows the various parts of the module to communicate and stay in sync.
     */
    function paginationService() {

        var instances = {};
        var lastRegisteredInstance;

        this.registerInstance = function(instanceId) {
            if (typeof instances[instanceId] === 'undefined') {
                instances[instanceId] = {
                    asyncMode: false
                };
                lastRegisteredInstance = instanceId;
            }
        };

        this.deregisterInstance = function(instanceId) {
            delete instances[instanceId];
        };
        
        this.isRegistered = function(instanceId) {
            return (typeof instances[instanceId] !== 'undefined');
        };

        this.getLastInstanceId = function() {
            return lastRegisteredInstance;
        };

        this.setCurrentPageParser = function(instanceId, val, scope) {
            instances[instanceId].currentPageParser = val;
            instances[instanceId].context = scope;
        };
        this.setCurrentPage = function(instanceId, val) {
            instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
        };
        this.getCurrentPage = function(instanceId) {
            var parser = instances[instanceId].currentPageParser;
            return parser ? parser(instances[instanceId].context) : 1;
        };

        this.setItemsPerPage = function(instanceId, val) {
            instances[instanceId].itemsPerPage = val;
        };
        this.getItemsPerPage = function(instanceId) {
            return instances[instanceId].itemsPerPage;
        };

        this.setCollectionLength = function(instanceId, val) {
            instances[instanceId].collectionLength = val;
        };
        this.getCollectionLength = function(instanceId) {
            return instances[instanceId].collectionLength;
        };

        this.setAsyncModeTrue = function(instanceId) {
            instances[instanceId].asyncMode = true;
        };

        this.setAsyncModeFalse = function(instanceId) {
            instances[instanceId].asyncMode = false;
        };

        this.isAsyncMode = function(instanceId) {
            return instances[instanceId].asyncMode;
        };
    }

    /**
     * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
     */
    function paginationTemplateProvider() {

        var templatePath = 'angularUtils.directives.dirPagination.template';
        var templateString;

        /**
         * Set a templateUrl to be used by all instances of <dir-pagination-controls>
         * @param {String} path
         */
        this.setPath = function(path) {
            templatePath = path;
        };

        /**
         * Set a string of HTML to be used as a template by all instances
         * of <dir-pagination-controls>. If both a path *and* a string have been set,
         * the string takes precedence.
         * @param {String} str
         */
        this.setString = function(str) {
            templateString = str;
        };

        this.$get = function() {
            return {
                getPath: function() {
                    return templatePath;
                },
                getString: function() {
                    return templateString;
                }
            };
        };
    }
})();
    
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdCatalogNumeric', catalogInput);
    
    function catalogInput() {
        return {
            restrict: 'E',
            scope: true,
            transclude: true,
            require: '^^cdCatalog',
            link: function(scope, element, attrs, catalogCtrl){ 
                scope.label = attrs.label;
                scope.required = attrs.required === undefined ? false: true;
                scope.min = attrs.min === undefined ? 0 : attrs.min;
                if (attrs.max !== undefined)
                    scope.max = attrs.max;

                scope.$on('itemChangeEvent', function (event, args) {
                    scope.model = args.item[attrs.modelName];
                });
                
                scope.$watch('model', function(m){
                    scope.$emit("itemChildChangeEvent", {
                        modelName: attrs.modelName,
                        value: scope.model  
                    });
                });
            },
            templateUrl: 'app/main/directives/cd-catalog-numeric/cd-catalog-numeric.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdCatalog', catalog);

    function catalog() {

        function mainController($scope, $mdDialog, $document, msg, api, $attrs, CONST_DATATABLES){
            var vm = this;

            vm.title = $attrs.title;
            vm.itemName = $attrs.itemName || "elemento";
            var apiGroupName = $attrs.apiGroup || "catalogs";
            var apiName = $attrs.apiService;
            var apiService = api[apiGroupName][apiName];

            // Data
            vm.items = [];
            vm.item = { nombre: 'tst' };
            loadData();
            vm.dtInstance = {};
            vm.dtOptions =angular.copy($.extend(CONST_DATATABLES.OPTIONS, {
                dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                columnDefs  : [
                    {
                        // Target the ID column
                        targets: 0,
                        width  : '72px'
                    },
                    {
                        // Target the actions column
                        targets           : 3,
                        responsivePriority: 1,
                        filterable        : false,
                        sortable          : false
                    }
                ],
                initComplete: function ()
                {
                    var api = this.api(),
                        searchBox = angular.element('body').find('#keyword-search');

                    // Bind an external input as a table wide search box
                    if ( searchBox.length > 0 )
                    {
                        searchBox.on('keyup', function (event)
                        {
                            api.search(event.target.value).draw();
                        });
                    }
                },
                pagingType  : 'simple',
                lengthMenu  : [10, 20, 30, 50, 100],
                pageLength  : 10,
                scrollY     : 'auto',
                responsive  : true,
                filter      : true
            }));

            // Methods
            vm.openDetailDialog = openDetailDialog;
            vm.deleteItem = deleteItem;
            vm.save = save;
            vm.closeDialog = closeDialog;
            //////////

            $scope.$on("itemChildChangeEvent", function(ev, args){
                vm.item[args.modelName] = args.value;
            });

            function loadData(){
                apiService.query(function (response) { 
                    vm.items = response 
                });
            }

            function openDetailDialog(ev, item){
                if ( !item ){
                    vm.item = {
                        id      : 0,
                        name    : '',
                        active   : true
                    };
                    vm.detailTitle = 'Agregar ' + vm.itemName;
                }else{
                    vm.item = angular.copy(item);
                    vm.detailTitle = 'Editar ' + vm.itemName;
                }

                $scope.$broadcast('itemChangeEvent', { item: vm.item });

                $mdDialog.show({
                    contentElement     : '#detail-dialog',
                    parent             : angular.element($document.find('#content-container')),
                    targetEvent        : ev,
                    clickOutsideToClose: true
                });
            }

            function deleteItem(item, event){
                msg.confirm('Estas seguro que deseas borrar este ' + vm.itemName + '?', function(){
                    apiService.delete({ id: item.id }, function(response){
                        if (response){
                            loadData();
                            msg.success(vm.itemName + ' borrado correctamente.');
                        }
                    });
                });
            }

            vm.saving = false;
            function save(){
                vm.saving = true;
                // Save Item
                apiService.save(
                    vm.item,
                    function(response){
                        if (response){
                            msg.success(vm.itemName + ' guardado correctamente.');
                            loadData();
                            closeDialog();
                            vm.saving = false;
                        }
                    }, function(errorResponse){
                        vm.saving = false;
                    });
            }

            function closeDialog(){
                $mdDialog.hide();
            }
        }

        return {
            restrict: 'E',
            transclude: true,
            scope: {
                item: '='
            },
            controllerAs: 'vm',
            controller: mainController,
            templateUrl: 'app/main/directives/cd-catalog/cd-catalog.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdCatalogInput', catalogInput);
    
    function catalogInput() {
        return {
            restrict: 'E',
            scope: true,
            transclude: true,
            require: '^^cdCatalog',
            link: function(scope, element, attrs, catalogCtrl){ 
                scope.label = attrs.label;
                scope.required = attrs.required === undefined ? false: true;
                
                scope.$on('itemChangeEvent', function (event, args) {
                    scope.model = args.item[attrs.modelName];
                });
                
                scope.$watch('model', function(m){
                    scope.$emit("itemChildChangeEvent", {
                        modelName: attrs.modelName,
                        value: scope.model  
                    });
                });
            },
            templateUrl: 'app/main/directives/cd-catalog-input/cd-catalog-input.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('cdCatalogCheck', catalogCheck);
    
    function catalogCheck() {
        return {
            restrict: 'E',
            scope: true,
            transclude: true,
            require: '^^cdCatalog',
            link: function(scope, element, attrs, catalogCtrl){ 
                scope.label = attrs.label;
                scope.required = attrs.required === undefined ? false: true;
                
                scope.$on('itemChangeEvent', function (event, args) {
                    scope.model = args.item[attrs.modelName];
                });
                
                scope.$watch('model', function(m){
                    scope.$emit("itemChildChangeEvent", {
                        modelName: attrs.modelName,
                        value: scope.model  
                    });
                });
            },
            templateUrl: 'app/main/directives/cd-catalog-check/cd-catalog-check.template.html'
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        // msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        // msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        // msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        // msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        // var vm = this;

        // // Data
        // vm.chat = {};
        // vm.chatActive = false;
        // vm.replyMessage = '';

        // // msApi.request('quickPanel.contacts@get', {},
        // //     // Success
        // //     function (response)
        // //     {
        // //         vm.contacts = response.data;
        // //     }
        // // );

        // // Methods
        // vm.toggleChat = toggleChat;
        // vm.reply = reply;

        // //////////

        // function toggleChat(contact)
        // {
        //     vm.chatActive = !vm.chatActive;

        //     if ( vm.chatActive )
        //     {
        //         vm.replyMessage = '';
        //         vm.chat.contact = contact;
        //         scrollToBottomOfChat(0);
        //     }
        // }

        // function reply()
        // {
        //     if ( vm.replyMessage === '' )
        //     {
        //         return;
        //     }

        //     if ( !vm.chat.contact.dialog )
        //     {
        //         vm.chat.contact.dialog = [];
        //     }

        //     vm.chat.contact.dialog.push({
        //         who    : 'user',
        //         message: vm.replyMessage,
        //         time   : 'Just now'
        //     });

        //     vm.replyMessage = '';

        //     scrollToBottomOfChat(400);
        // }

        // function scrollToBottomOfChat(speed)
        // {
        //     var chatDialog = angular.element('#chat-dialog');

        //     $timeout(function ()
        //     {
        //         chatDialog.animate({
        //             scrollTop: chatDialog[0].scrollHeight
        //         }, speed);
        //     }, 0);

        // }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    // {
                    //     'title'      : 'Sample',
                    //     'icon'       : 'icon-tile-four',
                    //     'state'      : 'app.sample',
                    //     'weight'     : 1,
                    //     'children'   : [],
                    //     '_id'        : 'sample',
                    //     '_path'      : 'apps.sample',
                    //     'uisref'     : 'app.sample',
                    //     'hasShortcut': true
                    // }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .factory('msg', MessagesFactory);
        
        function MessagesFactory($mdToast, $mdDialog) {
            
            var service = {
                error: function (errorMessage) {
                    showMessage(errorMessage, 'error');
                },
                info: function (infoMessage) {
                    showMessage(infoMessage, 'info');
                },
                success: function (successMessage) {
                    showMessage(successMessage, 'success');
                },
                confirm: showConfirm,
                prompt: prompt

            };

            return service;


            function showMessage (message, type) {
                $mdToast.show({
                    hideDelay   : 3000,
                    position    : 'top right',
                    template : 
                        '<md-toast class="msg-toast ' + type +'">' +
                        '<div class="md-toast-content">' +
                            message +
                        '</div>' +
                        '</md-toast>',
                });
            }

            function showConfirm(text, successFunction, cancelfunction, content){
                text = text || "Esta seguro que desea realizar esta operación?";
                content = content || "";
                cancelfunction = cancelfunction || null;

                var confirm = $mdDialog.confirm()
                    .title(text)
                    .htmlContent(content)
                    .ok('Aceptar')
                    .cancel('Cancelar');

                $mdDialog.show(confirm).then(function ()
                {
                    successFunction();
                }, function(){
                    if (cancelfunction)
                        cancelfunction();
                });
            }    

            function prompt(text, label, successFunction, cancelfunction, config, initialValue){
                text = text || "Ingrese valor?";
                label = label || "Ingrese valor?";
                initialValue = initialValue || '';          
                cancelfunction = cancelfunction || null;
                config = angular.extend({
                    content: '',
                    acceptText: 'Aceptar',
                    cancelText: 'Cancelar'
                }, config);

                var confirm = $mdDialog.prompt()
                    .title(text)
                    .htmlContent(config.content)
                    .placeholder(label)
                    .ariaLabel(label)
                    .initialValue(initialValue)
                    .ok(config.acceptText)
                    .cancel(config.cancelText);

                $mdDialog.show(confirm).then(function (result)
                {
                    successFunction(result);
                }, function(){
                    if (cancelfunction)
                        cancelfunction();
                });
            }
        }
})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .factory('utils', HelpersFactory);
        
        function HelpersFactory() {
            var _calculateAge = function(birth_day, birth_month, birth_year) {
                var today_date = new Date();
                var today_year = today_date.getFullYear();
                var today_month = today_date.getMonth();
                var today_day = today_date.getDate();
                var age = today_year - birth_year;

                if (today_month < (birth_month - 1)) {
                    age--;
                }
                if ((birth_month == today_month) && (today_day < birth_day)) {
                    age--;
                }
                return age;
            }

            var _groupBy = function(xs, key) {
                return xs.reduce(function(rv, x) {
                  (rv[x[key]] = rv[x[key]] || []).push(x);
                  return rv;
                }, {});
              };

            return {
                calculateAge: _calculateAge,
                groupBy: _groupBy 
            };            
        }
        
})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .factory('files', filesFactory);
        
        function filesFactory(api, localStorageService, msg) {
            return {
                uploadImage : uploadImage
            };


            function uploadImage(inputFileId, uploadType, uploadData, success){
                var files = $("#" + inputFileId).get(0).files;
    
                // Validate data
                if (files.length == 0) {
                    msg.error("Seleccione  archivo a subir!.");
                    return;
                }
    
                var file = files[0];
                var data = new FormData();
                data.append("file", file);
                data.append("uploadType", uploadType);            

                if (uploadData && uploadData.length){
                    for(var i = 0; i < uploadData.length; i++){
                        var element = uploadData[i];
                        data.append(element.key, element.value);
                    }
                }
    
                var authData = localStorageService.get('authorizationData');
                $.ajax({
                    type: "POST",
                    url: api.baseUrl + "Files",
                    contentType: false,
                    processData: false,
                    data: data,
                    headers: { 
                        "Authorization": 'Bearer ' + authData.token
                    },
                    success: function (response) {
                        if (success)
                            success(response);
                    },
                    error: function (errorResponse) {
                        if (errorResponse.status == 500 || errorResponse.status == 400){
                            msg.error(errorResponse.responseText);
                        }else                    
                            msg.error("Error al subir archivo, comunicate con el administrador!!!!"); 
                    }
                });
            }
        }
})();
(function ()
{
    'use strict';

    angular
        .module('app.tempLogin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        // $stateProvider
        //     .state('app.login', {
        //         url      : '/',
        //         views    : {
        //             'main@'                       : {
        //                 templateUrl: 'app/core/layouts/content-only.html',
        //                 controller: 'MainController as vm'
        //             },
        //             'content@app.login': {
        //                 templateUrl: 'app/main/login/login.html',
        //                 controller: 'LoginController as vm'
        //             }
        //         }
        //     });
    }

   
})();
(function ()
{
    'use strict';

    angular
        .module('app.tempLogin')
        .controller('TempLoginDialogController', tempLoginDialogController);

    /** @ngInject */
    function tempLoginDialogController($mdDialog, msg)
    {
        var vm = this;

        init();

        // Methods
        vm.accept = accept;            
        vm.cancel = cancel;
        ////////

        function init(){
        }

        function accept(){  
            // TODO: Ejecutar accion de boton
            cancel();
        }

        function cancel(){
            $mdDialog.hide();
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .factory('reportsService', reportsService);

    function reportsService(localStorageService){
        
        var reportsServiceFactory = {};

        var _setReportData = function(data){
            localStorageService.set("reportData", { data: data });
        }

        var _getReportData = function(){
            return localStorageService.get("reportData");
        }

        reportsService.setReportData = _setReportData;
        reportsService.getReportData = _getReportData;

        return reportsService;

    }
})();
(function(){
    'use strict';

    angular
        .module('app.core')
        .factory('settingsService', settingsService);

    function settingsService($q, api, $http, authService){
        return function(){
            var appData = authService.getAppData();
            return appData.settings;
        }
        // return { 
        //     daysOfGrace : 10,
        //     interes     : 10
        // };
    }
})();
(function () {
  "use strict";

  angular.module("app.core").factory("authService", authService);

  function authService($q, api, $http, localStorageService) {
    var authServiceFactory = {};

    var serviceBase = api.baseUrl.replace("api/", "");
    var _authentication = {
      isAuth: false,
      userName: "",
      branch: null,
      user: null,
      access: null,
    };

    var _login = function (loginData) {
      _logOut();
      var data =
        "grant_type=password&username=" +
        loginData.userName +
        "&password=" +
        loginData.password;
      var deferred = $q.defer();
      $http
        .post(serviceBase + "token", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .success(function (response) {
          localStorageService.set("authorizationData", {
            token: response.access_token,
            userName: loginData.userName,
          });
          _authentication.isAuth = true;
          _authentication.userName = loginData.userName;
          deferred.resolve(response);
        })
        .error(function (err, status) {
          _logOut();
          deferred.reject(err);
        });

      return deferred.promise;
    };

    var _logOut = function () {
      localStorageService.remove("authorizationData");
      localStorageService.remove("appData");

      _authentication.isAuth = false;
      _authentication.userName = "";
    };

    var _fillAuthData = function () {
      var authData = localStorageService.get("authorizationData");
      if (authData) {
        _authentication.isAuth = true;
        _authentication.userName = authData.userName;
      }
    };

    var _addBranch = function (branch) {
      _authentication.branch = branch;
    };

    var _addUser = function (user) {
      _authentication.user = user;
    };

    var _addAccess = function (access) {
      _authentication.access = access;
    };

    var _setAppData = function () {
      localStorageService.set("appData", {
        user: _authentication.user,
        branch: _authentication.branch,
        access: _authentication.access,
        settings: _authentication.branch.setting,
      });
    };

    var _getAppData = function () {
      return localStorageService.get("appData");
    };

    var _updateUserData = function (user) {
      var appData = localStorageService.get("appData");
      appData.user = user;
      localStorageService.set("appData", appData);
    };

    authServiceFactory.login = _login;
    authServiceFactory.logOut = _logOut;
    authServiceFactory.fillAuthData = _fillAuthData;
    authServiceFactory.authentication = _authentication;
    authServiceFactory.addBranch = _addBranch;
    authServiceFactory.addUser = _addUser;
    authServiceFactory.addAccess = _addAccess;
    authServiceFactory.setAppData = _setAppData;
    authServiceFactory.getAppData = _getAppData;
    authServiceFactory.updateUserData = _updateUserData;

    return authServiceFactory;
  }
})();

(function () {
    'use strict';

    angular
        .module('app.login')
        .controller('LoginController', LoginController)

    function LoginController($state, $http, $mdDialog, api, authService, msg, $location) {
        var vm = this;

        vm.form = {};
        vm.branches = [];
        vm.branch = {};

        _init();

        // Methods 
        vm.login = login;
        vm.selectBranch = selectBranch;
        vm.cerrarSesiones = cerrarSesiones;
        vm.detail = detail;
        ////////

        function _init() {
            authService.logOut();
        }

        function login() {
            vm.loading = true;
            vm.sesion = {
                userName: vm.form.user,
                password: vm.form.password
            }
            authService.login({
                userName: vm.form.user,
                password: vm.form.password
            }).then(function () {

                // Get APP access 
                api.app.access.request(function (accessResponse) {
                    if (accessResponse.success) { //SUCCESS                        

                        api.security.access.query(function (response) {
                            // Set Access in Local Storage
                            authService.addAccess(response);

                            // Get User Data
                            api.security.users.getByUsername({
                                username: authService.authentication.userName,
                                id: 0
                            }, function (user) {
                                vm.loading = false;
                                authService.addUser(user);
                                if (user.branches.length == 0) {
                                    msg.error("El usuario no cuenta con sucursales asignadas, no puede ingresar al sistema.");
                                    vm.form = {};
                                } else if (user.branches.length == 1) {
                                    authService.addBranch(user.branches[0]);
                                    authService.setAppData();
                                    //window.location.href = "/home";
                                    $location.path("home");
                                } else {
                                    vm.branches = user.branches;
                                }
                            });
                        });

                    } else {
                        // ERROR
                        vm.loading = false;

                        if (accessResponse.errorCode == "01") {
                            $state.go("app.license")
                        }

                        if (accessResponse.errorCode == "02") {
                            vm.errorCode = accessResponse.errorCode;
                        }
                        msg.error(accessResponse.errorMessage);
                    }

                });

            }, function () {
                vm.loading = false;
            });
        }

        function selectBranch() {
            var branch = vm.branches.filter(function (b) { return b.id == vm.branchId; })[0];
            authService.addBranch(branch);
            authService.setAppData();
            window.location.href = "/home";
            // $state.go('app.home');
        }

        function cerrarSesiones() {
            authService.login({
                userName: vm.form.user,
                password: vm.form.password
            }).then(function () {

                // Get APP access 
                api.app.access.closeSession(
                    function (accessResponse) {
                        if (accessResponse.$resolved) {
                            //SUCCESS
                            vm.errorCode = "";
                        }
                        else {
                            // ERROR
                            vm.errorCode = "04";
                        }

                    }
                );
            });
        }

        function detail(ev) {
            $mdDialog.show({
                controller: 'LoginDialogController2',
                controllerAs: 'vm',
                templateUrl: 'app/main/login/dialogs/dialog-close-sesions.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                escapeToClose: true,
                clickOutsideToClose: true,
                locals: {
                    Callback: authService,
                    User: vm.form.user,
                    Password: vm.form.password
                }
            }).then(function (returnValue) {
                vm.errorCode = returnValue;
            });;
        }
    }
})();
(function(){
    'use strict';

    angular
        .module('app.license')
        .controller('LicenseController', licenseController)

    function licenseController($state, $http, api, authService, msg, $mdDialog){
        var vm = this;

        // Methods 
        vm.save = save;
        vm.showAdminLogin = showAdminLogin;
        ////////

        _init();

        function _init(){
            vm.loading = false;
            // authService.login({
            //     userName: vm.form.user,
            //     password: vm.form.password
            // }).then(function(){

            //     // TODO: Get APP access 
            //     api.app.access.request(function(accessResponse){
            //         if (accessResponse.success){ //SUCCESS                        
                        
            //             api.security.access.query(function(response){
            //                 authService.addAccess(response);
            //             });
        
            //             api.security.users.getByUsername({
            //                 username: authService.authentication.userName,
            //                 id: 0
            //             }, function(user){
            //                 vm.loading = false;
        
                            
        
            //                 authService.addUser(user);
            //                 if (user.branches.length == 0){
            //                     msg.error("El usuario no cuenta con sucursales asignadas, no puede ingresar al sistema.");
            //                     vm.form = {};
            //                 }else if(user.branches.length == 1){
            //                     authService.addBranch(user.branches[0]);
            //                     authService.setAppData();
            //                     // $state.go('app.home');
            //                     window.location.href = "/home";
            //                 }else{
            //                     vm.branches = user.branches;
            //                 }
            //             });
            //         }else{
            //             // ERROR
            //             vm.loading = false;
            //             msg.error(accessResponse.errorMessage);
            //         }

            //     });

            // }, function(){  
            //     vm.loading = false;
            // });
        }

        function save(){
            api.app.access.addLicense({ license: vm.license }, function(response){
                msg.success("Licencia agregada correctamente.");
                $state.go("app.login");
            });
        }

        function showAdminLogin(ev){
            $mdDialog.show({
                controller         : 'LicenseLoginDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/license/dialogs/dialog-login/dialog-login.html',
                targetEvent        : ev,
                escapeToClose      : false,
                clickOutsideToClose: false,
                locals             : {
                    Callback     : _loginCallback
                }
            });
        }

        function _loginCallback(license){
            vm.license = license;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.home', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.home', {
                url      : '/home',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/home/home.html',
                        controller : 'HomeController as vm'
                    }
                },
                bodyClass: 'home'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.home', {
            title : 'Principal',
            icon  : 'icon-home',
            state: 'app.home'
        });        
    }
})();
(function(){

    'use strict';

    angular
        .module('app.home')
        .controller("HomeController", homeController);
    
    function homeController(){
        var vm = this;            
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .filter('toDate', toDateFilter);

    function toDateFilter() {
        return function(input) {
            if (input)
                return new Date(input);
            else 
                return new Date();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .filter('sum', sumFilter);

    function sumFilter() {
        return function (data, key) {        
            if (angular.isUndefined(data) || angular.isUndefined(key))
                return 0;        
            var sum = 0;        
            angular.forEach(data,function(value){
                sum = sum + parseFloat(value[key], 10);
            });        
            return sum;
        }
    }
})();
(function ()
{
    'use strict';

    Array.prototype.groupBy = function(prop) {
        return this.reduce(function(groups, item) {
            var val = item[prop];
            groups[val] = groups[val] || { key: val, items: [] };
            groups[val].items.push(item);
            return groups;
        }, {});
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {        
        default  : {
            primary   : {
                name: 'blue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        
        // 'tealTheme': {
        //     primary   : {
        //         name: 'fuse-blue',
        //         hues: {
        //             'default': '900',
        //             'hue-1'  : '600',
        //             'hue-2'  : '500',
        //             'hue-3'  : 'A100'
        //         }
        //     },
        //     accent    : {
        //         name: 'teal',
        //         hues: {
        //             'default': '500',
        //             'hue-1'  : '400',
        //             'hue-2'  : '600',
        //             'hue-3'  : 'A100'
        //         }
        //     },
        //     warn      : {
        //         name: 'deep-orange'
        //     },
        //     background: {
        //         name: 'grey',
        //         hues: {
        //             'default': 'A100',
        //             'hue-1'  : 'A100',
        //             'hue-2'  : '100',
        //             'hue-3'  : '300'
        //         }
        //     }
        // }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    // 'use strict';

    // angular
    //     .module('app.core')
    //     .controller('MsThemeOptionsController', MsThemeOptionsController)
    //     .directive('msThemeOptions', msThemeOptions);

    // /** @ngInject */
    // function MsThemeOptionsController($cookies, fuseTheming)
    // {
    //     var vm = this;

    //     // Data
    //     vm.themes = fuseTheming.themes;

    //     vm.layoutModes = [
    //         {
    //             label: 'Boxed',
    //             value: 'boxed'
    //         },
    //         {
    //             label: 'Wide',
    //             value: 'wide'
    //         }
    //     ];
    //     vm.layoutStyles = [
    //         {
    //             label : 'Vertical Navigation',
    //             value : 'verticalNavigation',
    //             figure: '/assets/images/theme-options/vertical-nav.jpg'
    //         },
    //         {
    //             label : 'Vertical Navigation with Fullwidth Toolbar',
    //             value : 'verticalNavigationFullwidthToolbar',
    //             figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
    //         },
    //         {
    //             label : 'Vertical Navigation with Fullwidth Toolbar 2',
    //             value : 'verticalNavigationFullwidthToolbar2',
    //             figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
    //         },
    //         {
    //             label : 'Horizontal Navigation',
    //             value : 'horizontalNavigation',
    //             figure: '/assets/images/theme-options/horizontal-nav.jpg'
    //         },
    //         {
    //             label : 'Content with Toolbar',
    //             value : 'contentWithToolbar',
    //             figure: '/assets/images/theme-options/content-with-toolbar.jpg'
    //         },
    //         {
    //             label : 'Content Only',
    //             value : 'contentOnly',
    //             figure: '/assets/images/theme-options/content-only.jpg'
    //         },
    //     ];

    //     vm.layoutMode = 'wide';
    //     vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    //     // Methods
    //     vm.setActiveTheme = setActiveTheme;
    //     vm.getActiveTheme = getActiveTheme;
    //     vm.updateLayoutMode = updateLayoutMode;
    //     vm.updateLayoutStyle = updateLayoutStyle;

    //     //////////

    //     /**
    //      * Set active theme
    //      *
    //      * @param themeName
    //      */
    //     function setActiveTheme(themeName)
    //     {
    //         fuseTheming.setActiveTheme(themeName);
    //     }

    //     /**
    //      * Get active theme
    //      *
    //      * @returns {service.themes.active|{name, theme}}
    //      */
    //     function getActiveTheme()
    //     {
    //         return fuseTheming.themes.active;
    //     }

    //     /**
    //      * Update layout mode
    //      */
    //     function updateLayoutMode()
    //     {
    //         var bodyEl = angular.element('body');

    //         // Update class on body element
    //         bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
    //     }

    //     /**
    //      * Update layout style
    //      */
    //     function updateLayoutStyle()
    //     {
    //         // Update the cookie
    //         $cookies.put('layoutStyle', vm.layoutStyle);

    //         // Reload the page to apply the changes
    //         location.reload();
    //     }
    // }

    // /** @ngInject */
    // function msThemeOptions($mdSidenav)
    // {
    //     return {
    //         restrict   : 'E',
    //         scope      : {},
    //         controller : 'MsThemeOptionsController as vm',
    //         templateUrl: 'app/core/theme-options/theme-options.html',
    //         compile    : function (tElement)
    //         {
    //             tElement.addClass('ms-theme-options');

    //             return function postLink(scope)
    //             {
    //                 /**
    //                  * Toggle options sidenav
    //                  */
    //                 function toggleOptionsSidenav()
    //                 {
    //                     // Toggle the fuse theme options panel
    //                     $mdSidenav('fuse-theme-options').toggle();
    //                 }

    //                 // Expose the toggle function
    //                 scope.toggleOptionsSidenav = toggleOptionsSidenav;
    //             };
    //         }
    //     };
    // }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, authService, api, $mdDialog, localStorageService, msg)
    {
        var vm = this;
        var appData = authService.getAppData();
        vm.user = appData.user;
        vm.branch = appData.branch;
        vm.avatarsUrl = api.baseUrl.replace("api/", "");

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            es: {
                'title'      : 'Spanish',
                'translation': 'TOOLBAR.SPANISH',
                'code'       : 'es',
                'flag'       : 'es'
            },
            tr: {
                'title'      : 'Turkish',
                'translation': 'TOOLBAR.TURKISH',
                'code'       : 'tr',
                'flag'       : 'tr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.toggleLock = toggleLock;
        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            // Close Session
            api.app.access.close(function(){
                // Destroy token
                authService.logOut();
                $state.go('app.login');
            });
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en' )
            {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 100);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }

        function toggleLock(ev){
            if ($rootScope.isLocked){
                // Unlock
                $mdDialog.show({
                    controller         : 'LoginDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/login/dialog-login/dialog-login.html',
                    targetEvent        : ev,
                    escapeToClose      : true,
                    clickOutsideToClose: false,
                    locals             : {
                        Callback : loginCallback
                    }
                });
            }else{
                // Lock
                var appData = localStorageService.get('appData');
                var userAccess = appData.user.userType.access;
                var allAccess = appData.access;                    
                var validatedControls = allAccess.filter(function(a){ return a.isControl && window.location.href.indexOf(a.url) != -1 });
                if (validatedControls.length){
                    angular.forEach(validatedControls, function(control){
                        if (userAccess.filter(function(a){ return a.id == control.id }).length == 0){
                            if (control.state === 'hidden'){                                                      
                                $(document).find(control.controlName).attr("style", "display: none;");
                            }else{                                
                                $(document).find(control.controlName).attr("disabled", true);
                                $(document).find("#" + control.controlName).attr("disabled", true);
                            }
                        }
                    });
                }
                $rootScope.isLocked = true;

                msg.success("Se volvieron a bloquear los controles");
            }
        }

        function loginCallback(controls){
            // Unlock Controls
            
            var validatedControls = controls.filter(function(a){ return a.isControl && window.location.href.indexOf(a.url) != -1 });
            angular.forEach(validatedControls, function(control){
                if (control.state === 'hidden'){
                    $(document).find(control.controlName).attr("style", "display: block;");
                }else{                    
                    $(document).find(control.controlName).attr("disabled", false);
                }
            });
            msg.success("Controles desbloqueados");
            $rootScope.isLocked = false;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };
        

        // msApi.request('quickPanel.activities@get', {},
        //     // Success
        //     function (response)
        //     {
        //         vm.activities = response.data;
        //     }
        // );

        // msApi.request('quickPanel.events@get', {},
        //     // Success
        //     function (response)
        //     {
        //         vm.events = response.data;
        //     }
        // );

        // msApi.request('quickPanel.notes@get', {},
        //     // Success
        //     function (response)
        //     {
        //         vm.notes = response.data;
        //     }
        // );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, authService)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        authService.fillAuthData();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigationFullwidthToolbar2';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .constant("CONST_DATATABLES", {
            "OPTIONS": {
                // dom         : 'rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType  : 'simple_numbers',
                lengthChange    : false,
                pageLength  : 10,
                // scrollY     : 'auto',
                responsive  : true,
                filter: false,
                language: {
                    "lengthMenu": "Mostrando _MENU_ registros por página",
                    "zeroRecords": "No hay registros encontrados",
                    "info": "Pagina _PAGE_ de _PAGES_",
                    "infoEmpty": "No se encontraron registros",
                    "infoFiltered": "(Filtrados de _MAX_ elementos totales)",
                    "search": "Buscar",                    
                    "paginate": {
                        "first":      "Primera",
                        "last":       "Ultima",
                        "next":       "Siguiente",
                        "previous":   "Anterior"
                    },
                },
                // initComplete: function ()
                // {
                //     var api = this.api(),
                //         searchBox = angular.element(this).find('#keyword-search');

                //     // Bind an external input as a table wide search box
                //     if ( searchBox.length > 0 )
                //     {
                //         searchBox.on('keyup', function (event)
                //         {
                //             api.search(event.target.value).draw();
                //         });
                //     }
                // },
            }
    });
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('interceptors', interceptorsFactory)
        .config(config)
        .config(treeViewConfig)
        .config(mdDateConfig)
        .config(['uiMask.ConfigProvider', maskConfig]);

    function config($translateProvider, $httpProvider, $mdDateLocaleProvider, ivhTreeviewOptionsProvider){
        // Put your common app configurations here

        // angular-translate configuration
        // $translateProvider.useLoader('$translatePartialLoader', {
        //     urlTemplate: '{part}/i18n/{lang}.json'
        // });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        $httpProvider.interceptors.push('interceptors');
    }

    function treeViewConfig(ivhTreeviewOptionsProvider){
        ivhTreeviewOptionsProvider.set({
            defaultSelectedState: false,
            validate: true,
            expandToDepth: -1,
            twistieCollapsedTpl: '<md-icon md-font-icon="icon-chevron-right"></md-icon>',
            twistieExpandedTpl: '<md-icon md-font-icon="icon-chevron-down"></md-icon>',
            twistieLeafTpl: '<span style="cursor: default;">&#8192;&#8192;</span>'
        });
    }

    function mdDateConfig($mdDateLocaleProvider){
        $mdDateLocaleProvider.formatDate = function(date) {      
            if (date !== null) {
                return moment(date).locale("es").format("DD/MM/YYYY");
            }
        };
        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };
    }

    function maskConfig(uiMaskConfigProvider){
        uiMaskConfigProvider.clearOnBlur(true);
        uiMaskConfigProvider.addDefaultPlaceholder(false); 
    }

    function interceptorsFactory($q, localStorageService, $location, msNavigationService, $rootScope, $window) {
        return {
            request: function (config) {            
                config.headers = config.headers || {};
                
                var appData = localStorageService.get('appData');
                if (config.method.toLowerCase() == 'get' && config.url.indexOf("app/main") != -1){
                    // When request is from change page in app
                    // Delete not access menu
                    if (!appData)
                        return config;
                    var menu = appData.access;
                    
                    if (appData.user.userType)
                    {
                        var userAccess = appData.user.userType.access;
                        angular.forEach(menu, function(access) {
                            if (access.isMenu){
                                // Si es menu y no tiene ningun submenu permitido
                                if (userAccess.filter(function(a){ return a.fatherAccessId == access.id }).length == 0)
                                    msNavigationService.deleteItem(access.navigationPath);
                            }else {
                                // Si es submenu y no tiene acceso permitido
                                if (userAccess.filter(function(a){ return a.name == access.name }).length == 0)
                                    msNavigationService.deleteItem(access.navigationPath);
                            }
                        });
                    }
                }else if (config.url.indexOf("app") == -1){
                    // When the request is to Api service
                    var authData = localStorageService.get('authorizationData');                    
                    if (authData) {
                        
                        config.headers.Authorization = 'Bearer ' + authData.token;

                        if (appData && appData.branch)
                            config.headers.BranchId = appData.branch.id;
                    }
                    
                    if (config.data && config.url.indexOf('token') == -1)
                        config.data = JSON.stringify(config.data);
                }

                return config;
            },
            responseError: function (response) {
                var error = '';
                switch (response.status) {
                    case 401: // Unauthorize
                        alert('No esta autorizado para esta operación');
                        $location.path('/');
                        return;
                    case 400: // Bad Request
                        if (response.data.modelState){
                            error = '<ul>';
                            for (var key in response.data.modelState) {
                                for (var i = 0; i < response.data.modelState[key].length; i++) {
                                    error += '<li>' + response.data.modelState[key][i] + '</li>';
                                }
                            }
                            error += '</ul>';
                        }else if (response.data.message)
                            error = response.data.message;
                        else if(response.data.error && response.data.error == 'validation_ex'){
                            error = response.data.error_description;
                        }else if (response.data != ''){
                            error = response.data;                            
                        }
                        break;
                    case 404: // Not Found
                        error = 'Recurso no encontrado';
                        break;
                    case 500: // Internal server Error
                        if (response.data && response.data.exceptionType && response.data.exceptionType.indexOf("AppValidationException") != -1)
                            error = response.data.exceptionMessage;
                            break;
                    case -1:
                        error = "Error de conexion, por favor reintente, si el problema persiste comuniquese con el administrador." 
                    break;
                }
                if (error  && error != '') {
                    showError(error);
                } else if(response.status != '-1') {                    
                    showError('Comunicate con el administrador');
                }

                return $q.reject(response);
            },
            response: function(response){
                if (response.config.method.toLowerCase() == 'get' && 
                response.config.url.indexOf("app/main") != -1 && 
                response.config.url.indexOf("app/main/login") == -1 && // Except Login
                response.config.url.indexOf("app/main/license") == -1 // Except License
            ){
                    $rootScope.isLocked = true;
                    var content = $(response.data);
                    var appData = localStorageService.get('appData');
                    var userAccess = appData.user.userType.access;
                    var allAccess = appData.access;     
                    
                    if (!allAccess || allAccess.length == 0)
                        window.location.href = "/";    
                    // $window.location.reload();
                    
                    var validatedControls = [];
                    validatedControls = allAccess.filter(function(a){ return a.isControl && response.config.url.indexOf(a.navigationPath) != -1 });
                    if (validatedControls.length > 0){                        
                        angular.forEach(validatedControls, function(control){                            
                            if (userAccess.filter(function(a){ return a.id == control.id }).length == 0){                                   
                                if (control.state === 'hidden'){
                                    if(content.length && content[0].id === control.controlName ){      
                                        $(content[0]).attr("style", "display: none;");                                        
                                    }else{
                                        content.find(control.controlName).attr("style", "display: none;");
                                    }                                    
                                }else{                                    
                                    content.find(control.controlName).attr("disabled", true);
                                    content.find("#" + control.controlName).attr("disabled", true);
                                }
                            }
                        });
                        response.data = content.get(0).outerHTML;
                    }
                }
                    
                return response;
            }
        };        
    }
    
    function showError(message){
        var message = $('<div class="message-container-error"><span>' + message + '</span></div>');
        $('body').append(message);
        message.show();
        setTimeout(function(){
            message.remove()
        }, 4000);
    }
})();
/* eslint-disable comma-dangle */
(function () {
  "use strict";

  angular.module("fuse").factory("api", apiService);

  /** @ngInject */
  function apiService($resource) { 
    var api = {};

    // Base Url
    // api.baseUrl = "http://localhost:8000/api/";
    // api.baseUrl = "https://api.kalaclub.net/api/";
    // api.baseUrl = "https://api.altea.club/api/";
    // api.baseUrl = "https://api.operactive.club/api/";
    // api.baseUrl = "https://api.hazegym.club/api/";
    // api.baseUrl = "https://api.omada.city/api/";
    // api.baseUrl = "https://api.urban-fitness.club/api/";
    // api.baseUrl = "https://api.bylifefit.com/api/"
    api.baseUrl = "https://api.newton-fitness.com.mx/api/"

    api.catalogs = {
      branches: $resource(api.baseUrl + "Branches/:id", { id: "@id" }),
      clubAccess: $resource(
        api.baseUrl + "ClubAccess/:id",
        { id: "@id" },
        {
          getAll: {
            method: "GET",
            url: api.baseUrl + "ClubAccessAll/1",
            isArray: true
          }
        }
      ),
      media: $resource(api.baseUrl + "Media/:id", { id: "@id" }),
      countries: $resource(api.baseUrl + "Countries/:id", { id: "@id" }),
      professions: $resource(api.baseUrl + "Professions/:id", { id: "@id" }),
      addressTypes: $resource(api.baseUrl + "AddressTypes/:id", { id: "@id" }),
      activities: $resource(api.baseUrl + "Activities/:id", { id: "@id" }),
      employees: $resource(api.baseUrl + "Employees/:id", { id: "@id" }),
      employeeTypes: $resource(api.baseUrl + "EmployeeTypes/:id", {
        id: "@id",
      }),
      partnerTypes: $resource(api.baseUrl + "PartnerTypes/:id", { id: "@id" }),
      productTypes: $resource(api.baseUrl + "ProductTypes/:id", { id: "@id" }),
      productProperties: $resource(api.baseUrl + "ProductProperties/:id", {
        id: "@id",
      }),
      productPropertyOptions: $resource(
        api.baseUrl + "ProductPropertyOptions/:propertyId",
        { propertyId: "@propertyId" },
        {
          get: { method: "GET", isArray: true },
        }
      ),
      products: $resource(
        api.baseUrl + "Products/:id",
        { id: "@id" },
        {
          getByCode: {
            method: "GET",
            isArray: false,
            url: api.baseUrl + "Products/:id/:code",
          },
          // save:      { method: 'POST', url: api.baseUrl + 'Products' },
        }
      ),
      templates: $resource(api.baseUrl + "Templates/:productTypeId", {
        productTypeId: "@productTypeId",
      }),
      massiveTemplates: $resource(
        api.baseUrl + "MassiveTemplates/:productTypeId",
        { productTypeId: "@productTypeId" }
      ),
      massiveProducts: $resource(api.baseUrl + "MassiveProducts", {}),
      periodicities: $resource(api.baseUrl + "Periodicities", {}),
      dues: $resource(api.baseUrl + "Dues/:id", { id: "@id" }),
      duePrices: $resource(
        api.baseUrl + "DuePrices/:dueId/:searchType/:searchId",
        {},
        {
          get: { isArray: true },
        }
      ),
      agreements: $resource(api.baseUrl + "Agreements/:id", { id: "@id" }),
      genders: $resource(api.baseUrl + "Genders/:id", { id: "@id" }),
      rentableZones: $resource(api.baseUrl + "RentableZones/:id", {
        id: "@id",
      }),
      rentableZonePrices: $resource(
        api.baseUrl + "RentableZonePrices/:rentableZoneId/:groupId",
        {},
        {
          get: { isArray: true },
        }
      ),
      activitiesSchedules: $resource(
        api.baseUrl + "ActivitiesSchedules",
        {},
        {
          query: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "ActivitiesSchedules/:activityId",
          },
        }
      ),
      banks: $resource(api.baseUrl + "Banks/:id", { id: "@id" }),
      tpvs: $resource(api.baseUrl + "Tpvs/:id", { id: "@id" }),
      levels: $resource(api.baseUrl + "Levels/:id", { id: "@id" }),
      levelScores: $resource(api.baseUrl + "LevelScores/:id", { id: "@id" }),
      paymentMethods: $resource(api.baseUrl + "PaymentMethods/:id", {
        id: "@id",
      }),
      paymentMethodOptions: $resource(
        api.baseUrl + "PaymentMethodOptions/:id",
        { id: "@id" }
      ),
      satCodeTypes: $resource(api.baseUrl + "SatCodeTypes/:id", { id: "@id" }),
      satCodes: $resource(api.baseUrl + "SatCodes/:id", { id: "@id" }),
      satCfdiUsesRegimenFiscal: $resource(
        api.baseUrl + "SatCfdiUsesRegimenFiscal/:id",
        { id: "@id" },
        {
          get: { method: "GET", isArray: true },
        }
      ),
      evaluations: $resource(api.baseUrl + "Evaluations/:id", { id: "@id" }),
      becas: $resource(api.baseUrl + "Becas/:id", { id: "@id" }),
      calculationModes: $resource(api.baseUrl + "CalculationModes/:id", {
        id: "@id",
      }),
      warehouses: $resource(api.baseUrl + "Warehouses/:id", { id: "@id" }),
      accessTimeZones: $resource(
        api.baseUrl + "AccessTimeZones/:id",
        { id: "@id" },
        {
          getAll: {
            method: "GET",
            url: api.baseUrl + "ClubAccessAll/2",
            isArray: true,
          },
        }
      ),
      employeeCalendarEvents: $resource(
        api.baseUrl + "EmployeeCalendarEvents/:id",
        {},
        {
          get: { isArray: true },
          getByProspect: {
            isArray: true,
            url: api.baseUrl + "EmployeeCalendarEvents/:id/:prospectId",
          },
        }
      ),
      zones: $resource(api.baseUrl + "Zones/:id", { id: "@id" }),
      activitiesSchedulesZones: $resource(
        api.baseUrl + "ActivitiesSchedulesZones/:scheduleId",
        {},
        {
          get: { isArray: true },
        }
      ),
      passTypes: $resource(api.baseUrl + "PassTypes/:id", { id: "@id" }),
      passes: $resource(
        api.baseUrl + "Passes/:id",
        { id: "@id" },
        {
          massiveDelete: {
            method: "DELETE",
            url: api.baseUrl + "Passes/:initNumber/:endNumber",
          },
        }
      ),
      duesRules: $resource(
        api.baseUrl + "DuesRules/:id",
        { id: "@id" },
        {
          checkByPartnerId: { method: "GET", isArray: true },
        }
      ),
      conceptosNotaCredito: $resource(
        api.baseUrl + "ConceptosNotaCredito/:id",
        {}
      ),
      files: $resource(
        api.baseUrl + "Files",
        {},
        {
          getFile: { method: "PUT", isArray: false },
        }
      ),
      accounts: $resource(
        api.baseUrl + "accounts/:id",
        { id: "@id" }
      )
    };

    api.partners = {
      partners: $resource(
        api.baseUrl + "Partners/:id",
        { id: "@id" },
        {
          getByFamily: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "Partners/:id/:familyId",
          },
          getByFilters: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "Partners/:keyword/:pageNumber/:pageSize"
          },
          getByFiltersPaginated: {
            method: "GET",
            isArray: false,
            url: api.baseUrl + "Partners/paginated/:keyword/:pageNumber/:pageSize/:showFamiliars"
          }
          // getByKardex : { method: 'GET', isArray: true, url: api.baseUrl + 'Partners/:id/:dummy1/:dummy2/:dummy3' },
        }
      ),
      family: $resource(
        api.baseUrl + "PartnersFamily/:partnerId",
        { partnerId: "@partnerId" },
        {
          get: {
            method: "GET",
            isArray: false,
            url: api.baseUrl + "PartnersFamily/:partnerId/:id",
          },
        }
      ),
      addresses: $resource(
        api.baseUrl + "PartnerAddresses/:partnerId",
        { partnerId: "@partnerId" },
        {
          save: { method: "POST", url: api.baseUrl + "PartnerAddresses/:id" },
        }
      ),
      absences: $resource(
        api.baseUrl + "PartnerAbsences",
        {},
        {
          query: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "PartnerAbsences/:familyId",
          },
          save: { method: "POST", url: api.baseUrl + "PartnerAbsences" },
        }
      ),
      levels: $resource(
        api.baseUrl + "PartnerLevels",
        {},
        {
          query: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "PartnerLevels/:familyId",
          },
          save: { method: "POST", url: api.baseUrl + "PartnerLevels" },
        }
      ),
      rentables: $resource(
        api.baseUrl + "PartnerRentables/:id",
        { id: "@id" },
        {
          query: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "PartnerRentables/:familyId",
          },
          save: { method: "POST", url: api.baseUrl + "PartnerRentables" },
          getByRentableZone: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "PartnerRentables/:familyId/:rentableZoneId",
          },
          delete: {
            method: "DELETE",
            url: api.baseUrl + "PartnerRentables/:id",
          },
        }
      ),
      automaticPayment: $resource(
        api.baseUrl + "PartnerAutomaticPayments/:id",
        { id: "@id" }
      ),
      becas: $resource(
        api.baseUrl + "PartnerBecas",
        {},
        {
          query: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "PartnerBecas/:familyId",
          },
        }
      ),
      tags: $resource(
        api.baseUrl + "PartnerTags",
        {},
        {
          query: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "PartnerTags/:familyId",
          },
        }
      ),
      changeDates: $resource(api.baseUrl + "PartnerChangeDates", {}),
      prospects: $resource(api.baseUrl + "Prospects/:id", {}),
      prospectComments: $resource(api.baseUrl + "ProspectComments/:id", {}),
      periodicalProducts: $resource(
        api.baseUrl + "PartnerPeriodicalProducts/:id",
        {},
        {
          get: { method: "GET", isArray: true },
        }
      ),
      activities: $resource(
        api.baseUrl + "PartnerActivitiesSchedules/:familyId",
        {},
        {
          get: { method: "GET", isArray: true },
          verify: {
            method: "GET",
            isArray: true,
            url:
              api.baseUrl +
              "PartnerActivitiesSchedules/:id/:activityScheduleZoneId",
          },
        }
      ),
      info: $resource(
        api.baseUrl + "PartnersInfo/:filterType/:keyword",
        {},
        {
          get: { method: "GET", isArray: true },
        }
      ),
      messages: $resource(
        api.baseUrl + "PartnerMessages/:id",
        {},
        {
          get: { method: "GET", isArray: true },
          getByFamily: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "PartnerMessages/:familyId/dummy",
          },
        }
      ),
      passes: $resource(
        api.baseUrl + "PartnerPasses/:id",
        { id: "@id" },
        {
          getById: {
            method: "GET",
            isArray: false,
            url: api.baseUrl + "PartnerPasses/:id",
          },
          get: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "PartnerPasses/:familyId/:from/:to",
          },
          checkPassNumber: {
            method: "GET",
            isArray: false,
            url: api.baseUrl + "PartnerPasses/:familyId/:passNumber",
          },
          delete: { method: "DELETE", url: api.baseUrl + "PartnerPasses/:id" },
        }
      ),
      accessTimeZones: $resource(
        api.baseUrl + "PartnerClubAccessTimeZones/:id",
        { id: "@id" }
      ),
      passesFiles: $resource(
        api.baseUrl + "PartnerPassesFiles",
        {},
        {
          sendMail: { method: "PUT", isArray: false },
        }
      ),
      credentialFiles: $resource(
        api.baseUrl + "PartnerCredentialFiles",
        {},
        {
          sendMail: { method: "PUT", isArray: false },
        }
      ),
      contracts: $resource(
        api.baseUrl + "PartnerContracts/:id",
        {},
        {
          getContract: {
            method: "GET",
            url: api.baseUrl + "PartnerContracts/:id/:isLastData",
            isArray: false,
          },
        }
      ),
      emails: $resource(api.baseUrl + "PartnerEmails", {}),
    };

    api.security = {
      users: $resource(
        api.baseUrl + "Users",
        {},
        {
          getByUsername: {
            method: "GET",
            url: api.baseUrl + "Users/:id/:username",
            isArray: false,
          },
          query: { method: "GET", url: api.baseUrl + "Users", isArray: true },
          get: {
            method: "GET",
            url: api.baseUrl + "Users/:id",
            isArray: false,
          },
          save: { method: "POST", url: api.baseUrl + "Users" },
          delete: { method: "DELETE", url: api.baseUrl + "Users/:id" },
          change: { method: "PUT", url: api.baseUrl + "Users" },
        }
      ),
      roles: $resource(api.baseUrl + "Roles/:id", { id: "@id" }),
      access: $resource(api.baseUrl + "Access/:id", { id: "@id" }),
      userTypes: $resource(api.baseUrl + "UserTypes/:id", { id: "@id" }),
      controlsAccess: $resource(
        api.baseUrl + "ControlsAccess",
        {},
        {
          login: { method: "POST", isArray: true },
        }
      ),
    };

    api.invoices = {
      calculation: $resource(
        "",
        {},
        {
          check: {
            method: "GET",
            url: api.baseUrl + "Calculation/:partnerId/:calculationDate",
            isArray: true,
          },
          calculate: {
            method: "POST",
            url: api.baseUrl + "Calculation",
            isArray: true,
          },
        }
      ),
      orders: $resource(
        api.baseUrl + "Orders",
        {},
        {
          save: { method: "POST", isArray: false },
          get: {
            method: "GET",
            isArray: false,
            url: api.baseUrl + "Orders/:id",
          },
          getByPeriod: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "Orders/:from/:to",
          },
          getByPartner: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "Orders/:from/:to/:partnerId",
          },
          cancel: { 
            method: "DELETE", 
            url: api.baseUrl + "Orders/:id" 
          },
          email: { 
            method: "POST", 
            url: api.baseUrl + "Orders/email", 
            isArray: false 
          }
        }
      ),
      invoices: $resource(
        api.baseUrl + "Invoices/:id",
        {},
        {
          getByPeriod: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "Invoices/:from/:to",
          },
          getByPartner: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "Invoices/:from/:to/:partnerId",
          },
          getByFolio: {
            method: "GET",
            isArray: false,
            url: api.baseUrl + "Invoices/:serie/:folio/0/0",
          },
          delete: {
            method: "DELETE",
            url:
              api.baseUrl +
              "Invoices/:id/:invoiceCancellationReasonId/:UuidReference",
          },
        }
      ),
      invoicesOrders: $resource(
        api.baseUrl + "InvoicesOrders",
        {},
        {
          get: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "InvoicesOrders",
          },
        }
      ),
      turns: $resource(
        api.baseUrl + "Turns/:dateIni/:dateEnd",
        {},
        {
          get: { method: "GET", isArray: true },
        }
      ),
      plannedProducts: $resource(
        api.baseUrl + "PlannedProducts/:id",
        {},
        {
          get: { method: "GET", isArray: true },
        }
      ),
      generate: $resource(api.baseUrl + "InvoiceGenerate", {}),
      notasCredito: $resource(
        api.baseUrl + "NotasCredito/:from/:to",
        {},
        {
          get: { method: "GET", isArray: true }
        }
      ),
      pdf: $resource(api.baseUrl + "Pdf", {}),
      email: $resource(api.baseUrl + "Email", {}),
      complements: $resource(
        api.baseUrl + "Complements",
        {},
        {
          save: { method: "POST", isArray: false },          
          get: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "Complements/:id"
          },
          getReceipt: {
            method: "GET",
            isArray: false,
            url: api.baseUrl + "Complements/:id/receipt"
          },
          getByPeriod: {
            method: "GET",
            isArray: true,
            url: api.baseUrl + "Complements/:from/:to/:includeCompletePayed"
          },
          cancel: { 
            method: "POST", 
            url: api.baseUrl + "Complements/cancel" 
          }
        }
      ),
    };

    api.inventory = {
      inventory: $resource(api.baseUrl + "Inventory/:id", {}),
      products: $resource(api.baseUrl + "InventoryProducts/:code", {})
    };

    api.sat = {
      cfdiUses: $resource(api.baseUrl + "SatCfdiUses/:id", {}),
      coins: $resource(api.baseUrl + "SatCoins/:id", {}),
      invoiceTypes: $resource(api.baseUrl + "SatInvoiceTypes/:id", {}),
      paymentMethods: $resource(api.baseUrl + "SatPaymentMethods/:id", {}),
      payments: $resource(api.baseUrl + "SatPayments/:id", {}),
      products: $resource(
        api.baseUrl + "SatProducts/:id",
        {},
        {
          get: { isArray: true },
        }
      ),
      taxes: $resource(api.baseUrl + "SatTaxes/:id", {}),
      taxTypes: $resource(api.baseUrl + "SatTaxTypes/:id", {}),
      units: $resource(
        api.baseUrl + "SatUnits/:id",
        {},
        {
          get: { isArray: true },
        }
      ),
      zipCodes: $resource(api.baseUrl + "SatZipCodes/:zipcode", {}),
      regimenFiscales: $resource(api.baseUrl + "SatRegimenFiscales/:id", {}),
      banks: $resource(api.baseUrl + "SatBanks/:id", {}),
      cadenas: $resource(api.baseUrl + "SatCadenas/:id", {}),
      cfdiRelacionado: $resource(api.baseUrl + "SatCfdiRelacionado/:id", {}),
      catInvoiceCancellationReasons: $resource(
        api.baseUrl + "catInvoiceCancellationReason/:id",
        {}
      ),
    };

    api.accionistas = {
      acciones: $resource(api.baseUrl + "Acciones/:id", {}),
      accionistas: $resource(api.baseUrl + "Accionistas/:id", {}),
      transfers: $resource(api.baseUrl + "AccionesTransfers", {}),
    };

    api.app = {
      access: $resource(
        api.baseUrl + "AppAccess",
        {},
        {
          request: { method: "GET" },
          addLicense: { method: "POST" },
          license: { method: "PUT" },
          close: { method: "DELETE" },
          closeSession: {
            method: "DELETE",
            url: api.baseUrl + "AppAccess/:contrasena",
          },
        }
      ),
    };

    api.reports = {
      reports: $resource(
        api.baseUrl + "Reports",
        {},
        {
          generate: { method: "POST", isArray: true },
        }
      ),
      groups: $resource(api.baseUrl + "ReportGroups", {}),
      dashboard: $resource(
        api.baseUrl + "Dashboard",
        {},
        {
          population: { url: api.baseUrl + "dashboard/population", method: "GET", isArray: true },
          debts: { url: api.baseUrl + "dashboard/debts", method: "GET", isArray: true },
          age: { url: api.baseUrl + "dashboard/age", method: "GET", isArray: true },
          gender: { url: api.baseUrl + "dashboard/gender", method: "GET", isArray: true },
          inscriptions: { url: api.baseUrl + "dashboard/inscriptions", method: "GET", isArray: true },
          inscriptionsbyweek: { url: api.baseUrl + "dashboard/inscriptionsbyweek", method: "GET", isArray: true },
          sales: { url: api.baseUrl + "dashboard/sales", method: "GET", isArray: true },
          salestop: { url: api.baseUrl + "dashboard/salestop", method: "GET", isArray: true },
          salesbytype: { url: api.baseUrl + "dashboard/salesbytype", method: "GET", isArray: true },
          salestopbytype: { url: api.baseUrl + "dashboard/salestopbytype", method: "GET", isArray: true },
          salesyear: { url: api.baseUrl + "dashboard/salesyear", method: "GET", isArray: true },
          salesyearbytype: { url: api.baseUrl + "dashboard/salesyearbytype", method: "GET", isArray: true },
        }
      )
    };

    return api;
  }
})();

(function(){
	'use strict';

    angular
        .module('app.security.users', [
            'ivh.treeview',            
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.security.users', {
                url      : '/users',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/users/users/users.html',
                        controller : 'SecurityUsersController as vm'
                    }
                }
            })
            .state('app.security.users.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/users/user/user.html',
                        controller : 'SecurityUserController as vm'
                    }
                },
                resolve  : {
                    User: function ()
                    {
                        return { id: 0, name: '', active: true, access: [] };
                    },
                    UserTypes: function(apiResolver){
                        return apiResolver.resolve('security.userTypes@query');
                    },
                    Branches: function(apiResolver){
                        return apiResolver.resolve('catalogs.branches@query');
                    }
                },
            })
            .state('app.security.users.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/users/user/user.html',
                        controller : 'SecurityUserController as vm'
                    }
                },
                resolve  : {
                    User: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('security.users@get', { id: $stateParams.id });
                    },
                    UserTypes: function(apiResolver){
                        return apiResolver.resolve('security.userTypes@query');
                    },
                    Branches: function(apiResolver){
                        return apiResolver.resolve('catalogs.branches@query');
                    }
                },
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.security.users', {
            title: 'Usuarios',
            state: 'app.security.users'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.security.branches', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.security.branches', {
                url      : '/branches',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/branches/branches/branches.html',
                        controller : 'SecurityBranchesController as vm'
                    }
                }
            })
            .state('app.security.branches.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/branches/branch/branch.html',
                        controller : 'SecurityBranchController as vm'
                    }
                },
                resolve  : {
                    Branch: function ()
                    {
                        return { id: 0, name: '', active: true, setting: { interes: 10, daysOfGrace: 10, discountType: 2 } };
                    },
                    Warehouses: function(apiResolver){
                        return apiResolver.resolve('catalogs.warehouses@query');
                    }
                },
            })
            .state('app.security.branches.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/security/views/branches/branch/branch.html',
                        controller : 'SecurityBranchController as vm'
                    }
                },
                resolve  : {
                    Branch: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('catalogs.branches@get', { id: $stateParams.id });
                    },
                    Warehouses: function(apiResolver){
                        return apiResolver.resolve('catalogs.warehouses@query');
                    }
                },
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.security.branches', {
            title: 'Sucursales',
            state: 'app.security.branches'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.invoices.turns', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.invoices.turns', {
                url      : '/turns',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/turns/turns.html',
                        controller : 'InvoicesTurnsController as vm'
                    }
                },
                resolve  : {
                    Turns: function (apiResolver)
                    {
                        return apiResolver.resolve('invoices.turns@query');
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.invoices.turns', {
            title: 'Turnos',
            shortcuticon  : 'icon-repeat',                        
            state: 'app.invoices.turns'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.invoices.plannedProducts', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.invoices.plannedProducts', {
                url      : '/plannedProducts',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/invoices/views/plannedProducts/plannedProducts.html',
                        controller : 'InvoicesPlannedProductsController as vm'
                    }
                },
                resolve: {
                    PlannedProducts: function(apiResolver){
                        return apiResolver.resolve('invoices.plannedProducts@query');
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.invoices.plannedProducts', {
            title: 'Cargos planificados',
            state: 'app.invoices.plannedProducts'
        });
    }
})();

(function(){
	'use strict';

    angular
        .module('app.catalogs.zones', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.zones', {
                url      : '/zones',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/zones/zones.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.zones', {
            title: 'Ubicaciones de club',
            state: 'app.catalogs.zones'
        });
    }
})();

(function(){
	'use strict';

    angular
        .module('app.catalogs.warehouses', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.warehouses', {
                url      : '/warehouses',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/warehouses/warehouses.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.warehouses', {
            title: 'Almacenes',
            state: 'app.catalogs.warehouses'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.satCodes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.satCodes', {
                url      : '/satCodes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/satCodes/satCodes.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.satCodes', {
            title: 'Códigos del SAT',
            state: 'app.catalogs.satCodes'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.tpvs', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.tpvs', {
                url      : '/tpvs',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/tpvs/tpvs.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.tpvs', {
            title: "TPV's",
            state: 'app.catalogs.tpvs'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.paymentMethods', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.paymentMethods', {
                url      : '/paymentMethods',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/paymentMethods/paymentMethods.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.paymentMethods', {
            title: 'Formas de pago',
            state: 'app.catalogs.paymentMethods'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.professions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.professions', {
                url      : '/professions',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/professions/professions.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.professions', {
            title: 'Profesiones',
            state: 'app.catalogs.professions'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.passTypes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.passTypes', {
                url      : '/passTypes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/passTypes/passTypes.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.passTypes', {
            title: 'Tipos de pases',
            state: 'app.catalogs.passTypes'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.paymentMethodOptions', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.paymentMethodOptions', {
                url      : '/paymentMethodOptions',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/paymentMethodOptions/paymentMethodOptions.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.paymentMethodOptions', {
            title: 'Formas de pago (Opciones)',
            state: 'app.catalogs.paymentMethodOptions'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.partnerTypes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.partnerTypes', {
                url      : '/partnerTypes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/partnerTypes/partnerTypes.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.partnerTypes', {
            title: 'Tipos de socio',
            state: 'app.catalogs.partnerTypes'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.levels', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.levels', {
                url      : '/levels',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/levels/levels.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.levels', {
            title: 'Niveles de Avance',
            state: 'app.catalogs.levels'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.levelScores', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.levelScores', {
                url      : '/levelScores',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/levelScores/levelScores.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.levelScores', {
            title: 'Calificaciones',
            state: 'app.catalogs.levelScores'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.media', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.media', {
                url      : '/media',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/media/media.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.media', {
            title: 'Medios',
            state: 'app.catalogs.media'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.evaluations', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.evaluations', {
                url      : '/evaluations',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/evaluations/evaluations.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.evaluations', {
            title: 'Evaluaciones',
            state: 'app.catalogs.evaluations'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.employeeTypes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.employeeTypes', {
                url      : '/employeeTypes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/employeeTypes/employeeTypes.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.employeeTypes', {
            title: 'Tipos de empleados',
            state: 'app.catalogs.employeeTypes'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.countries', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.countries', {
                url      : '/countries',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/countries/countries.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.countries', {
            title: 'Paises',
            state: 'app.catalogs.countries'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.clubAccess', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.clubAccess', {
                url      : '/clubAccess',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/clubAccess/clubAccess.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.clubAccess', {
            title: 'Accesos Club',
            state: 'app.catalogs.clubAccess'
        });
    }
})();

(function(){
	'use strict';

    angular
        .module('app.catalogs.becas', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.becas', {
                url      : '/becas',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/becas/becas.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.becas', {
            title: 'Becas',
            state: 'app.catalogs.becas'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.agreements', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.agreements', {
                url      : '/agreements',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/agreements/agreements.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.agreements', {
            title: 'Convenios',
            state: 'app.catalogs.agreements'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.addressTypes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.addressTypes', {
                url      : '/addressTypes',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/addressTypes/addressTypes.html',
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.addressTypes', {
            title: 'Tipos de direccion',
            state: 'app.catalogs.addressTypes'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.accounts', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.accounts', {
                url      : '/accounts',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/accounts/accounts.html'
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.accounts', {
            title: 'Cuentas',
            state: 'app.catalogs.accounts'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.accionistas.transfer', [ 
        ])
        .config(accionistasTransferConfig);

    /** @ngInject */
    function accionistasTransferConfig($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.accionistas.transfer', {
                url      : '/transfer',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/accionistas/views/transfer/transfer.html',
                        controller : 'AccionistasTransferController as vm'
                    }
                },
                resolve  : {
                    Accionistas: function (apiResolver)
                    {
                        return apiResolver.resolve('accionistas.accionistas@query');
                    }
                }
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.accionistas.transfer', {
            title: 'Traspaso',
            shortcuticon  : 'icon-cash-multiple',            
            state: 'app.accionistas.transfer'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.catalogs.accessTimeZones', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.catalogs.accessTimeZones', {
                url      : '/accessTimeZones',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/accessTimeZones/accessTimeZones/accessTimeZones.html',
                        controller : 'CatalogsAccessTimeZonesController as vm'
                    }
                }
            })
            .state('app.catalogs.accessTimeZones.add', {
                url      : '/add',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/accessTimeZones/accessTimeZone/accessTimeZone.html',
                        controller : 'CatalogsAccessTimeZoneController as vm'
                    }
                },
                resolve  : {
                    AccessTimeZone: function ()
                    {
                        return { 
                            id          : 0, 
                            name        : '',
                            isMonday    : true,
                            mondayInitHour: "0500",
                            mondayEndHour: "2359",
                            isTuesday   : true, 
                            tuesdayInitHour: "0500",
                            tuesdayEndHour: "2359",
                            isWednesday : true, 
                            wednesdayInitHour: "0500",
                            wednesdayEndHour: "2359",
                            isThursday  : true, 
                            thursdayInitHour: "0500",
                            thursdayEndHour: "2359",
                            isFriday    : true, 
                            fridayInitHour: "0500",
                            fridayEndHour: "2359",
                            isSaturday  : true, 
                            saturdayInitHour: "0500",
                            saturdayEndHour: "2359",
                            isSunday    : true, 
                            sundayInitHour: "0500",
                            sundayEndHour: "2359",
                            active      : true 
                        };
                    }
                },
            })
            .state('app.catalogs.accessTimeZones.detail', {
                url      : '/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/catalogs/views/accessTimeZones/accessTimeZone/accessTimeZone.html',
                        controller : 'CatalogsAccessTimeZoneController as vm'
                    }
                },
                resolve  : {
                    AccessTimeZone: function ($stateParams, apiResolver)
                    {
                        return apiResolver.resolve('catalogs.accessTimeZones@get', { id: $stateParams.id });
                    }
                },
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps.catalogs.accessTimeZones', {
            title: 'Horarios de acceso',
            state: 'app.catalogs.accessTimeZones'
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        // State
        $stateProvider
            .state('app.pages.profile', {
                url      : '/profile',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/profile/profile.html',
                        controller : 'PagesProfileController as vm'
                    }
                },
            });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.inventory', 
            [
                'datatables',
                // Catalogs
                'app.inventory.inventories',
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.inventory', {
                abstract: true,
                url     : '/inventory'
            });

        // Navigation
        msNavigationServiceProvider.saveItem('apps.inventory', {
            title : 'Inventario',
            icon  : 'icon-archive',
            weight: 3
        });
    }
})();
(function(){
	'use strict';

    angular
        .module('app.accionistas', 
            [
                'datatables',
                // Accionistas
                'app.accionistas.acciones',                
                'app.accionistas.purchase',                
                // 'app.accionistas.accionistas',                
                'app.accionistas.transfer',                
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.accionistas', {
                abstract: true,
                url     : '/accionistas'
            })
            ;

        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : '',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.accionistas', {
            title : 'Accionistas',
            icon  : 'icon-cash',
            weight: 3
        });
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/home/home.html","<div id=\"home\"><div class=\"logo\"><img src=\"assets/images/logo.png\"></div></div>");
$templateCache.put("app/main/license/license.html","<div id=\"license\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\" \nng-dblclick=\"vm.showAdminLogin($event)\"><div class=\"logo\" style=\"width: 290px; margin: auto\"><img \nsrc=\"assets/images/logo.jpg\" width=\"150\"></div></div><div class=\"title\">Ingrese licencia</div><form name=\"licenseForm\">\n<md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"license\" ng-model=\"vm.license\" \nplaceholder=\"Licencia\" required md-autofocus><div ng-messages=\"licenseForm.license.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese licencia</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent md-raised submit-button\" aria-label=\"submitButton\" ng-click=\"vm.save()\" \nng-disabled=\"licenseForm.$invalid || vm.loading\"><span ng-show=\"!vm.loading\">Guardar</span> <span ng-show=\"vm.loading\">\nGuardando...</span></md-button></form></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center start\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><div class=\"logo\" \nstyle=\"width: 290px; margin: auto\"><img src=\"assets/images/logo.jpg\" width=\"150\"></div></div><div class=\"title\">\nIngrese usuario y contraseña</div><form name=\"loginForm\" novalidate><md-input-container class=\"md-block\" md-no-float>\n<input type=\"text\" name=\"user\" ng-model=\"vm.form.user\" placeholder=\"Usuario\" required><div \nng-messages=\"loginForm.user.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEl usuario es obligatorio</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Contraseña\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>La contraseña es obligatoria.\n</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"Iniciar sesion\" ng-click=\"vm.login()\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine || vm.loading\" ng-show=\"vm.branches.length <= 1\"><span \nng-show=\"vm.loading\">Iniciando...</span> <span ng-show=\"!vm.loading\">Iniciar sesion</span></md-button><md-button \ntype=\"submit\" class=\"md-raised md-warn submit-button\" aria-label=\"Cerrar sesiones\" ng-click=\"vm.detail($event)\" \nng-show=\"vm.errorCode == \'02\'\"><span>Cerrar sesiones</span></md-button><md-input-container class=\"md-block\" \nmd-no-float ng-show=\"vm.branches.length > 1\"><label>Sucursales</label><md-select ng-model=\"vm.branchId\" \naria-label=\"Sucursales\"><md-option ng-repeat=\"item in vm.branches\" value=\"{{item.id}}\">{{item.name}}</md-option>\n</md-select></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"Seleccionar sucursal\" ng-click=\"vm.selectBranch()\" ng-disabled=\"!vm.branchId\" \nng-show=\"vm.branches.length > 1\"><span>Entrar</span></md-button></form></div></div></div>");
$templateCache.put("app/main/temp-login/temp-login.html","<md-dialog class=\"discount-dialog\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nLogin</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div></md-toolbar><form \nname=\"editDetailForm\"><md-dialog-content ms-scroll><div class=\"page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><div class=\"address-form\"><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Descripción</label><input type=\"text\" name=\"description\" \nng-model=\"vm.detail.description\"><div ng-messages=\"editDetailForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Descripción.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Precio (Subtotal)</label><input ng-model=\"vm.detail.price\" \ntype=\"number\" name=\"price\" required min=\"0\"><div ng-messages=\"editDetailForm.price.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Precio.</span></div><div ng-message=\"number\"><span>El campo debe ser numérico.\n</span></div><div ng-message=\"min\"><span>Valor incorrecto</span></div><div ng-message=\"max\"><span>Valor incorrecto.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Interés</label><input \nng-model=\"vm.detail.interest\" type=\"number\" name=\"interest\" required min=\"0\"><div \nng-messages=\"editDetailForm.interest.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese Interés.</span>\n</div><div ng-message=\"number\"><span>El campo debe ser numérico.</span></div><div ng-message=\"min\"><span>\nValor incorrecto.</span></div><div ng-message=\"max\"><span>Valor incorrecto.</span></div></div></md-input-container>\n</div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.accept()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"editDetailForm.$invalid\" aria-label=\"ACEPTAR\">Aceptar</md-button>\n</div><div layout=\"row\"><md-button ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">Cancelar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Buscar...\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">Sin resultados!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.shortcuticon\" class=\"icon {{result.shortcuticon}}\"></i><div ng-if=\"!result.shortcuticon\" \nclass=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div><div class=\"description\" \nng-if=\"result.description\">{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><md-icon \nng-if=\"!shortcut.icon && shortcut.shortcuticon\" md-font-icon=\"{{shortcut.shortcuticon}}\" class=\"icon s24\"></md-icon>\n<div ng-if=\"!shortcut.icon && !shortcut.shortcuticon\" class=\"first-letter\">{{shortcut.title.charAt(0)}}</div>\n<md-tooltip md-direction=\"bottom\">{{shortcut.title}}</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" \nclass=\"shortcut-menu hide show-gt-xs\"><md-button class=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\">\n</md-icon><md-tooltip md-direction=\"bottom\">Click para agregar/quitar acceso directo</md-tooltip></md-button>\n<md-menu-content><div id=\"ms-shortcut-add-menu\"><div class=\"shortcut-search\" layout=\"row\" layout-align=\"start center\">\n<div class=\"search-icon\" layout=\"row\" layout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon \nmd-menu-align-target md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" \nlayout=\"row\" layout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Buscar\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">Sin resultados!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.shortcuticon\" \nclass=\"{{result.shortcuticon}}\"></i> <i ng-if=\"!result.shortcuticon && result.icon\" class=\"{{result.icon}}\"></i><div \nng-if=\"!result.shortcuticon && !result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/login/dialog-login/dialog-login.html","<md-dialog id=\"dialog-login\" class=\"catalogs-dialog-detail\" aria-label=\"login\"><form name=\"loginForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">DESBLOQUEAR</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout=\"column\" class=\"p-20 pt-40\" ms-scroll><md-input-container class=\"md-block\" flex><label>\nUsuario</label><input type=\"text\" name=\"user\" ng-model=\"vm.item.user\" required><div \nng-messages=\"loginForm.user.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEl usuario es obligatorio</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex><label>\nContraseña</label><input type=\"password\" name=\"password\" ng-model=\"vm.item.password\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>La contraseña es obligatoria.\n</span></div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"end center\"><md-button type=\"submit\" ng-click=\"vm.accept()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"save\">Aceptar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/login/dialogs/dialog-close-sesions.html","<md-dialog id=\"dialog-close-sesions\" class=\"dialog-close-sesions\"><form name=\"closeSesionForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\" flex><label>Contraseña</label><input type=\"text\" \nname=\"contrasena\" ng-model=\"vm.contesena\" required md-autofocus><div ng-messages=\"contrasenaForm.contrasena.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ingrese contraseña.</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.cerrarSesiones()\" class=\"send-button md-accent md-raised\" aria-label=\"GUARDAR\">\nCERRAR SESIONES</md-button><md-button class=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">\nCANCELAR</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nng-if=\"vm.user.avatar && vm.user.avatar != \'\'\" class=\"profile-image avatar huge\" \nng-src=\"{{vm.avatarsUrl}}{{vm.user.avatar}}\"> <img ng-if=\"!vm.user.avatar || vm.user.avatar == \'\'\" \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/profile.jpg\"><div class=\"name\">\n{{vm.user.name}} {{vm.user.lastname}}</div></div></div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span>Datos de usuario</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/profile/tabs/main/main.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span>Cambiar contraseña</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/profile/tabs/change-password/change-password.html\'\"></md-content></md-tab-body></md-tab>\n</md-tabs></div></div>");
$templateCache.put("app/main/directives/cd-catalog/cd-catalog.template.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>{{vm.title}}</span></div><div \nclass=\"product-count secondary-text\"><span>No de registros:</span> <span>{{vm.items.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.openDetailDialog($event)\">\n<span>Nuevo {{vm.itemName}}</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text w-30\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text w-50\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text w-110\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.items\"><td>{{item.id}}</td><td>{{item.name}}</td><td><i ng-if=\"item.active\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-if=\"!item.active\" class=\"icon-cancel red-500-fg\"></i></td>\n<td><md-button class=\"md-icon-button show-gt-xs\" ng-click=\"vm.openDetailDialog($event, item)\" aria-label=\"Editar\" \nng-if=\"!item.bySystem\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-icon-button show-gt-xs\" ng-click=\"vm.deleteItem(item, $event)\" aria-label=\"Editar\" ng-if=\"!item.bySystem\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div><div \nstyle=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"detail-dialog\"><md-dialog \nclass=\"catalogs-dialog-detail\"><form name=\"detailForm\" id=\"detailForm\" class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.detailTitle}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label>Nombre</label>\n<input ng-model=\"vm.item.name\" name=\"name\" type=\"text\" md-autofocus required><div ng-messages=\"detailForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ingrese Nombre.</span></div></div></md-input-container><ng-transclude>\n</ng-transclude><md-input-container class=\"md-block\" flex><md-checkbox ng-model=\"vm.item.active\">Activo</md-checkbox>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><md-button class=\"md-icon-button\" ng-click=\"vm.deleteItem(vm.item, $event)\" \naria-label=\"Borrar\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>Borrar</span></md-tooltip>\n</md-button><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"detailForm.$invalid || vm.saving\" aria-label=\"GUARDAR\"><span ng-hide=\"vm.saving\">GUARDAR</span> <span \nng-show=\"vm.saving\">GUARDANDO...</span></md-button></div></md-dialog-actions></form></md-dialog></div></div>");
$templateCache.put("app/main/directives/cd-catalog-check/cd-catalog-check.template.html","<md-input-container class=\"md-icon-float md-block\"><md-checkbox ng-model=\"model\" ng-required=\"required\">{{label}}\n</md-checkbox></md-input-container>");
$templateCache.put("app/main/directives/cd-catalog-input/cd-catalog-input.template.html","<md-input-container class=\"md-icon-float md-block\"><label>{{label}}</label><input type=\"text\" ng-model=\"model\" \nng-required=\"required\"></md-input-container>");
$templateCache.put("app/main/directives/cd-catalog-select/cd-catalog-select.template.html","<md-input-container class=\"md-icon-float md-block\"><label>{{label}}</label><md-select ng-model=\"model\" \nng-required=\"required\"><md-option ng-value=\"item.id\" ng-repeat=\"item in list | filter: { active: true }\">\n{{ item.name }}</md-option></md-select></md-input-container>");
$templateCache.put("app/main/directives/cd-catalog-numeric/cd-catalog-numeric.template.html","<md-input-container class=\"md-icon-float md-block\"><label>{{label}}</label><input type=\"number\" ng-model=\"model\" \nng-required=\"required\" ng-min=\"min\" ng-max=\"max\"></md-input-container>");
$templateCache.put("app/main/directives/cd-date-folio/cd-date-folio.template.html","<div layout=\"row\"><div layout=\"column\"><div flex><md-radio-group ng-model=\"filterByDate\" layout=\"row\" \nng-change=\"changeEvent()\"><md-radio-button ng-value=\"{{true}}\" aria-label=\"ByDate\" layout=\"row\">Por Fecha\n</md-radio-button><md-radio-button ng-value=\"{{false}}\" aria-label=\"ByFolio\">Por Folio</md-radio-button>\n</md-radio-group></div><div flex><div ng-if=\"filterByDate\" layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Fecha inicial</label><md-datepicker ng-model=\"date.from\" name=\"dateIni\" required md-placeholder=\"Ingrese fecha\" \nmd-hide-icons=\"calendar\" ng-change=\"changeEvent()\" md-current-view=\"month\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Fecha final</label><md-datepicker ng-model=\"date.to\" name=\"birthdate\" \nrequired md-hide-icons=\"calendar\" ng-change=\"changeEvent()\" md-placeholder=\"Ingrese fecha\" md-current-view=\"month\">\n</md-datepicker></md-input-container></div><div ng-if=\"!filterByDate\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Del</label><input type=\"number\" min=\"1\" ng-model=\"folio.from\" required \nng-change=\"changeEvent()\"></md-input-container><md-input-container class=\"md-block\" flex><label>Al</label><input \ntype=\"number\" min=\"1\" ng-model=\"folio.to\" required ng-change=\"changeEvent()\"></md-input-container></div>{{item | json}}\n</div></div></div>");
$templateCache.put("app/main/directives/cd-export-excel-button/cd-export-excel-button.template.html","<div class=\"buttons\"><md-button class=\"md-icon-button\" flex ng-click=\"exportToExcel()\"><md-icon \nmd-font-icon=\"icon-file-excel\"></md-icon><md-tooltip>Exportar a Excel</md-tooltip></md-button></div>");
$templateCache.put("app/main/directives/cd-input-time/cd-input-time.template.html","<input class=\"cd-input-time\" type=\"text\" placeholder=\"hh:mm\" ng-model=\"ngModel\" \nng-pattern=\"/^([0-2]|0[0-9]|1[0-9]|2[0-3]):?[0-5][0-9]$/\" ui-mask=\"99:99\" cd-pattern-model>");
$templateCache.put("app/main/directives/cd-partners-range/cd-partners-range.template.html","<div layout=\"row\"><div layout=\"column\"><div flex><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Del\n</label><input type=\"number\" min=\"1\" ng-model=\"partnersRange.from\" required ng-change=\"changeEvent()\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Al</label><input type=\"number\" min=\"1\" \nng-model=\"partnersRange.to\" required ng-change=\"changeEvent()\"></md-input-container></div></div></div></div>");
$templateCache.put("app/main/directives/cd-rentable-selection/cd-rentable-selection.template.html","<div id=\"rentables-selection\"><div layout-gt-sm=\"row\"><md-input-container flex=\"100\"><label>Zona de rentable</label>\n<md-select ng-model=\"vm.rentableZone\" ng-change=\"vm.zoneChange()\"><md-option ng-repeat=\"item in vm.rentableZones\" \nng-value=\"item\">{{item.name}}</md-option></md-select></md-input-container></div><div layout-gt-sm=\"row\"><div \nlayout-gt-sm=\"column\" flex-gt-sm=\"80\" id=\"matrix-container\" class=\"ml-50\"></div></div></div>");
$templateCache.put("app/main/directives/cd-report-age-ranges/cd-report-age-ranges.template.html","<div flex layout=\"column\"><h3 flex-1>Rango de edades<md-button class=\"md-icon-button\" ng-click=\"addRange()\" \nng-disabled=\"ageRanges.length == 4\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></h3><table flex><tbody><tr\n ng-repeat=\"range in ageRanges\"><td class=\"w-80\">Rango {{range.id}}</td><td><md-input-container class=\"md-block\" flex>\n<label>De</label><input type=\"number\" ng-model=\"range.from\" ng-change=\"changeEvent()\"></md-input-container></td><td>\n<md-input-container class=\"md-block\" flex><label>A</label><input type=\"number\" ng-model=\"range.to\" \nng-change=\"changeEvent()\"></md-input-container></td></tr></tbody></table></div>");
$templateCache.put("app/main/directives/cd-report-dates-range/cd-report-dates-range.template.html","<div layout=\"row\"><md-input-container class=\"md-block mb-0\" flex><label>Fecha inicial</label><md-datepicker \nng-model=\"date.from\" name=\"dateIni\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nng-change=\"changeEvent()\" md-current-view=\"month\"></md-datepicker></md-input-container><md-input-container \nclass=\"md-block mb-0\" flex><label>Fecha final</label><md-datepicker ng-model=\"date.to\" name=\"birthdate\" required \nmd-hide-icons=\"calendar\" ng-change=\"changeEvent()\" md-placeholder=\"Ingrese fecha\" md-current-view=\"month\">\n</md-datepicker></md-input-container></div>");
$templateCache.put("app/main/directives/cd-report-date-period/cd-report-date-period.template.html","<div layout=\"row\"><div layout=\"column\"><div flex><md-radio-group ng-model=\"filterByDate\" layout=\"row\" \nng-change=\"changeEvent()\"><md-radio-button ng-value=\"{{true}}\" aria-label=\"ByDate\" layout=\"row\">Por Fecha\n</md-radio-button><md-radio-button ng-value=\"{{false}}\" aria-label=\"ByPeriod\">Por Periodo</md-radio-button>\n</md-radio-group></div><div flex><div ng-if=\"filterByDate\" layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Fecha inicial</label><md-datepicker ng-model=\"date.from\" name=\"dateIni\" required md-placeholder=\"Ingrese fecha\" \nmd-hide-icons=\"calendar\" ng-change=\"changeEvent()\" md-current-view=\"month\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Fecha final</label><md-datepicker ng-model=\"date.to\" name=\"birthdate\" \nrequired md-hide-icons=\"calendar\" ng-change=\"changeEvent()\" md-placeholder=\"Ingrese fecha\" md-current-view=\"month\">\n</md-datepicker></md-input-container></div><div ng-if=\"!filterByDate\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Periodicidades</label><md-select ng-model=\"period.periodicityId\" required><md-option \nng-repeat=\"opt in periodicities\" ng-value=\"opt.id\">{{opt.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Periodos</label><input type=\"number\" min=\"1\" \nng-model=\"period.periods\" required ng-change=\"changeEvent()\"></md-input-container></div>{{item | json}}</div></div>\n</div>");
$templateCache.put("app/main/directives/cd-sat-select/cd-sat-select.template.html","<md-autocomplete flex md-selected-item=\"mdSelectedItem\" md-search-text=\"searchText\" \nmd-items=\"item in search(searchText)\" md-item-text=\"item.name\" md-floating-label=\"{{label}}\" md-delay=\"500\" \nng-required=\"required\" md-selected-item-change=\"testChange()\"><md-item-template><span md-highlight-text=\"searchText\" \nmd-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>No se hay resultados.</md-not-found>\n</md-autocomplete>");
$templateCache.put("app/main/test/drag-selection/drag-selection.html","<script>$(function () {\n  $(document)\n    .mouseup(function () {\n      isMouseDown = false;\n    });\n});</script><style>\ntable td {\n    width:20px;\n    height:20px;\n    text-align:center;\n    vertical-align:middle;\n    background-color:#ccc;\n    border:0.2px solid #fff;\n  }\n\n  table td.highlighted {\n    background-color:#999;\n  }\n</style>Renglones: <input type=\"number\" min=\"1\" ng-model=\"vm.rows\"><br>Columnas: <input type=\"number\" min=\"1\" \nng-model=\"vm.cols\"><md-button class=\"md-button md-raised md-accent\" ng-click=\"vm.generate();\">Generar matriz\n</md-button><table cellpadding=\"0\" cellspacing=\"0\" id=\"our_table\"></table>");
$templateCache.put("app/main/test/excel/excel1.html","<h1>Export to Excel</h1><button class=\"btn btn-link\" ng-click=\"vm.exportToExcel(\'#tableToExport\')\"><span \nclass=\"glyphicon glyphicon-share\"></span> Export to Excel</button><div id=\"tableToExport\"><table border=\"1\"><thead><tr \nclass=\"table-header\"><th>Team</th><th>Process Type</th><th>Cedent</th></tr></thead><tbody><tr><td>value 1</td><td>\nvalue 2</td><td>value 3</td></tr><tr><td>value 4</td><td>value 5</td><td>value 6</td></tr><tr><td>10.12.2015</td><td>\nAXA Affin</td><td>101024 - Quota Share QS</td></tr></tbody></table></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">AR</span> <span class=\"logo-text\">\nANIMAL REST</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><img src=\"assets/images/logo.jpg\" width=\"50\"> <span class=\"logo-text\">\nKalaClub Web</span></div><div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-button class=\"md-icon-button\" ng-click=\"vm.toggleLock()\" aria-label=\"show login\">\n<md-icon ng-show=\"isLocked\" md-font-icon=\"icon-lock\" class=\"icon\"></md-icon><md-icon ng-show=\"!isLocked\" \nmd-font-icon=\"icon-lock-unlocked\" class=\"md-warn\" class=\"icon\"></md-icon><md-tooltip>Bloquear/Desbloquear controles\n</md-tooltip></md-button><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img ng-if=\"!vm.user.avatar || vm.user.avatar == \'\'\" md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"> <img ng-if=\"vm.user.avatar && vm.user.avatar != \'\'\" md-menu-align-target \nclass=\"avatar\" ng-src=\"{{vm.avatarsUrl}}{{vm.user.avatar}}\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\n{{vm.user.name}} {{vm.user.lastname}}/{{vm.branch.name}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages.profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>Mi perfil\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon>\n<md-button ng-click=\"vm.logout()\">Salir</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/accionistas/views/purchase/purchase.html","<div id=\"accionistas-purchase\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1 no-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon>\n<span>Compra de acciones</span></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><md-card class=\"h-70\"><md-card-content layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\"><div ng-show=\"vm.step == 1\" layout=\"row\" flex><h3 flex-1 \nclass=\"mr-10\">Quien realizará la compra:</h3><md-radio-group ng-model=\"vm.isAccionista\" layout=\"row\" \nlayout-align=\"start center\" flex-1><md-radio-button ng-value=\"{{true}}\">Accionista existente</md-radio-button>\n<md-radio-button ng-value=\"{{false}}\">Ex-Accionista</md-radio-button><md-radio-button ng-value=\"{{null}}\" \nng-click=\"vm.newAccionista()\">Accionista nuevo</md-radio-button></md-radio-group></div><div ng-show=\"vm.step == 2\" \nlayout=\"row\" flex><h3 flex-1>Comprar acciones:</h3><md-radio-group ng-model=\"vm.purchaseFromClub\" \nng-click=\"vm.fromClubChange()\" layout=\"row\" layout-align=\"start center\" flex-1><md-radio-button ng-value=\"{{true}}\">\nAl club</md-radio-button><md-radio-button ng-value=\"{{false}}\">A otro accionista</md-radio-button></md-radio-group>\n<md-select ng-model=\"vm.sellerAccionistaId\" ng-show=\"!vm.purchaseFromClub\" ng-change=\"vm.getAccionesFromAccionista()\" \nflex><md-option ng-repeat=\"opt in vm.accionistas | filter : { isExAccionista: false }\" ng-value=\"opt.id\">\n{{opt.completeName}}</md-option></md-select></div></div><md-button class=\"md-button md-accent md-warn\" \nng-if=\"vm.step == 2\" ng-click=\"vm.goToStep(vm.step -1)\" flex-1 aria-label=\"back\">Atras</md-button><md-button \nclass=\"md-button md-accent md-raised\" flex-1 ng-click=\"vm.goToStep(vm.step + 1)\" \nng-disabled=\"accionistaForm.$invalid || (vm.step == 2 && complementData.$invalid)\" aria-label=\"next\"><span \nng-if=\"vm.step == 1\">Siguiente</span> <span ng-if=\"vm.step == 2\">Guardar y salir</span></md-button></md-card-content>\n</md-card><div ng-show=\"vm.step == 1\" class=\"p-15 pt-0\" ms-scroll><div layout=\"column\" ng-if=\"vm.isAccionista != null\">\n<div layout=\"row\" flex><md-input-container flex class=\"md-block\"><label>Accionista</label><md-select \nng-model=\"vm.accionista\" aria-label=\"selected-accionista\"><md-option \nng-repeat=\"opt in vm.accionistas | filter: { active: true, isExAccionista: !vm.isAccionista }\" ng-value=\"opt\" \naria-label=\"option_{{opt.id}\">{{opt.completeName}}</md-option></md-select></md-input-container></div></div><div \nlayout=\"column\" ng-show=\"vm.isAccionista == null\"><form name=\"accionistaForm\"><div layout=\"row\" class=\"pt-0\"><h3>\nPersonales</h3></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Apellido Paterno</label><input \ntype=\"text\" name=\"fatherLastname\" ng-model=\"vm.accionista.fatherLastname\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Materno</label><input type=\"text\" name=\"motherLastname\" \nng-model=\"vm.accionista.motherLastname\"></md-input-container><md-input-container class=\"md-block\" flex><label>Nombre(s)\n</label><input type=\"text\" name=\"names\" ng-model=\"vm.accionista.name\"></md-input-container><md-input-container \nclass=\"md-block\" flex-1><md-checkbox ng-model=\"vm.accionista.haveOther\">y/o</md-checkbox></md-input-container></div>\n<div layout=\"row\" ng-if=\"vm.accionista.haveOther\"><md-input-container class=\"md-block\" flex><label>Otro nombre</label>\n<input type=\"text\" name=\"street\" ng-model=\"vm.accionista.other\" ng-required=\"vm.accionista.haveOther\"><div \nng-messages=\"accionistaForm.other.$error\"><div ng-message=\"required\">Dato obligatorio</div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Calle y Número</label><input type=\"text\" \nname=\"street\" ng-model=\"vm.accionista.street\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nColonia</label><input type=\"text\" name=\"colony\" ng-model=\"vm.accionista.colony\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Estado</label><input type=\"text\" name=\"state\" \nng-model=\"vm.accionista.state\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Municipio</label><input type=\"text\" name=\"municipio\" ng-model=\"vm.accionista.municipio\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Teléfono</label><input type=\"text\" name=\"phone\" \nng-model=\"vm.accionista.phone\"></md-input-container><md-input-container class=\"md-block\" flex><label>Teléfono 2</label>\n<input type=\"text\" name=\"phone2\" ng-model=\"vm.accionista.phone2\"></md-input-container></div><div layout=\"row\"><h3>\nEmpresa</h3></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre</label><input type=\"text\" \nname=\"companyName\" ng-model=\"vm.accionista.companyName\"></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Calle y numero</label><input type=\"text\" name=\"campanyStreet\" ng-model=\"vm.accionista.companyStreet\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Colonia</label><input type=\"text\" \nname=\"companyColony\" ng-model=\"vm.accionista.companyColony\"></md-input-container><md-input-container class=\"md-block\" \nflex><label>Estado</label><input type=\"text\" name=\"companyState\" ng-model=\"vm.accionista.companyState\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Delegación o municipio\n</label><input type=\"text\" name=\"companyMunicipio\" ng-model=\"vm.accionista.companyMunicipio\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Teléfono</label><input type=\"text\" name=\"campanyPhone\" \nng-model=\"vm.accionista.campanyPhone\"></md-input-container><md-input-container class=\"md-block\" flex><label>Teléfono 2\n</label><input type=\"text\" name=\"campanyPhone2\" ng-model=\"vm.accionista.campanyPhone2\"></md-input-container></div>\n</form></div></div><div ng-show=\"vm.step == 2\" layout=\"column\"><div layout=\"row\" layout-align=\"center center\"><form \nname=\"complementData\" layout=\"row\"><md-input-container flex><label>Libro</label><input type=\"text\" name=\"book\" \nng-model=\"vm.book\" required><div ng-messages=\"complementData.book.$error\"><div ng-message=\"required\">Dato obligatorio\n</div></div></md-input-container><md-input-container flex><label>Folio</label><input type=\"text\" name=\"folio\" \nng-model=\"vm.folio\" required><div ng-messages=\"complementData.folio.$error\"><div ng-message=\"required\">Dato obligatorio\n</div></div></md-input-container><md-input-container flex><label>Renglon</label><input type=\"text\" name=\"row\" \nng-model=\"vm.row\" required><div ng-messages=\"complementData.row.$error\"><div ng-message=\"required\">Dato obligatorio\n</div></div></md-input-container></form></div><div layout=\"row\"><div layout=\"column\" flex=\"30\" class=\"ml-20\" \nlayout-align=\"start center\"><h3 class=\"w-300 md-accent-bg p-15 m-0 mt-20 white-fg\">Disponibles</h3><div layout=\"row\" \nlayout-align=\"center start\" class=\"border\"><table class=\"dataTable row-border border w-300\"><thead><tr><th>Serie</th>\n<th>Número</th></tr></thead><tbody><tr cd-custom-grid=\"item in vm.availableAcciones | itemsPerPage: (8)\" \npagination-id=\"availablePaginator\" class=\"selectable\" ng-class=\"{\'selected\': item.id == vm.availableAccion.id }\" \nng-click=\"vm.availableAccion = item\" ng-dblclick=\"vm.selectAccion(vm.availableAccion)\"><td>{{item.serie}}</td><td>\n{{item.number}}</td></tr></tbody><tr><td colspan=\"2\"><dir-pagination-controls pagination-id=\"availablePaginator\">\n</dir-pagination-controls></td></tr></table></div></div><div layout=\"column\" flex=\"30\" layout-align=\"center center\">\n<md-button class=\"md-button md-accent md-raised\" ng-click=\"vm.selectAccion(vm.availableAccion)\" \nng-disabled=\"!vm.availableAccion\" aria-label=\"select\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n<md-button class=\"md-button md-accent md-raised\" ng-click=\"vm.selectAllAcciones()\" \nng-disabled=\"vm.availableAcciones.length == 0\" aria-label=\"selectAll\"><md-icon \nmd-font-icon=\"icon-chevron-double-right\"></md-icon></md-button><md-button class=\"md-button md-accent md-raised\" \nng-click=\"vm.unselectAccion(vm.selectedAccion)\" ng-disabled=\"!vm.selectedAccion\" aria-label=\"unselect\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-button md-accent md-raised\" \nng-click=\"vm.unselectAllAcciones()\" ng-disabled=\"vm.accionista.acciones.length == 0\" aria-label=\"unselectAll\"><md-icon \nmd-font-icon=\"icon-chevron-double-left\"></md-icon></md-button></div><div layout=\"column\" flex=\"30\" \nlayout-align=\"start center\"><h3 class=\"w-300 md-accent-bg p-15 m-0 mt-20 white-fg\">Seleccionados</h3><div layout=\"row\" \nlayout-align=\"center start\" class=\"border\"><table class=\"dataTable row-border border w-300\"><thead><tr><th>Serie</th>\n<th>Número</th></tr></thead><tbody><tr cd-custom-grid=\"item in vm.currentAcciones\" class=\"read-only\"><td>{{item.serie}}\n</td><td>{{item.number}}</td></tr><tr cd-custom-grid=\"item in vm.accionista.acciones | itemsPerPage: (8)\" \npagination-id=\"selectedPaginator\" class=\"selectable\" ng-class=\"{\'selected\': item.id == vm.selectedAccion.id }\" \nng-click=\"vm.selectedAccion = item\" ng-dblclick=\"vm.unselectAccion(vm.selectedAccion)\"><td>{{item.serie}}</td><td>\n{{item.number}}</td></tr></tbody><tr><td colspan=\"2\"><dir-pagination-controls pagination-id=\"selectedPaginator\">\n</dir-pagination-controls></td></tr></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/accionistas/views/acciones/acciones.html","<div id=\"acciones\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Acciones</span></div><div \nclass=\"product-count secondary-text\"><span>No de acciones:</span> <span>{{vm.items.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background w-40\" ng-click=\"vm.massiveAdd($event)\" \nid=\"btnMassiveAdd\"><md-icon md-font-icon=\"icon-library-plus\"></md-icon><md-tooltip>Agregar multiple</md-tooltip>\n</md-button><md-button class=\"md-raised md-warn w-40\" ng-click=\"vm.remove(vm.selectedAccion.id)\" \nng-disabled=\"!vm.selectedAccion || vm.removing\" id=\"btnRemove\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip>Borrar seleccionada</md-tooltip></md-button></div><div class=\"status\">{{vm.status}}</div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable no-padding\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtAccionesInstance\" \ndt-options=\"vm.dtAccionesOptions\"><thead><tr><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Número</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Serie</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Fecha</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Asignado a:</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Fecha Asignación</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" \nclass=\"selectable\" ng-click=\"vm.selectedAccion = item\" ng-class=\"{\'selected\': vm.selectedAccion.id == item.id }\"><td>\n{{item.number}}</td><td>{{item.serie}}</td><td>{{item.date | date : \'dd/MM/yyyy\'}}</td><td>\n{{item.accionista.completeName}}</td><td>{{item.assignedDate | date : \'dd/MM/yyyy\'}}</td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/catalogs/views/agreements/agreements.html","<cd-catalog title=\"Convenios\" item-name=\"Convenio\" api-service=\"agreements\"><cd-catalog-numeric \nmodel-name=\"discountPercentage\" label=\"Porcentaje de descuento\" required min=\"1\" max=\"100\"></cd-catalog-numeric>\n</cd-catalog>");
$templateCache.put("app/main/catalogs/views/addressTypes/addressTypes.html","<cd-catalog title=\"Tipos de domicilio\" item-name=\"Tipo\" api-service=\"addressTypes\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/accounts/accounts.html","<cd-catalog title=\"Cuentas contables\" item-name=\"Cuenta contable\" api-service=\"accounts\"><cd-catalog-input \nmodel-name=\"code\" label=\"Cuenta\" required></cd-catalog-input><cd-catalog-input model-name=\"satAccount\" \nlabel=\"Cuenta SAT\"></cd-catalog-input></cd-catalog>");
$templateCache.put("app/main/accionistas/views/transfer/transfer.html","<div id=\"accionistas-transfer\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1 no-padding\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon>\n<span>Traspaso de acciones</span></div></div><div><md-button class=\"md-button md-raised\" ng-click=\"vm.save()\" \naria-label=\"save\">Guardar</md-button></div></div><div class=\"content-card\" layout=\"row\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><div layout=\"row\" layout-align=\"center start\" flex>\n<md-card flex=\"40\"><md-card-content layout=\"column\" layout-align=\"start start\" flex><form name=\"sourceForm\" \nclass=\"sourceForm\" layout=\"row\"><md-input-container class=\"md-block\" flex><label>Accionista que traspasa</label>\n<md-select ng-model=\"vm.accionistaSource\" ng-change=\"vm.accionistaSourceChange()\"><md-option \nng-repeat=\"opt in vm.accionistas | filter : { isExAccionista: false }\" ng-value=\"opt\">{{opt.completeName}}</md-option>\n</md-select></md-input-container></form><div layout=\"row\" flex class=\"mb-20\"><div layout=\"column\" flex><div \nlayout=\"column\" flex><h3 flex-1 class=\"mr-10\">Traspasar a:</h3><div layout=\"row\"><md-radio-group \nng-model=\"vm.transferToClub\" layout=\"row\" layout-align=\"start center\" flex-1><md-radio-button ng-value=\"{{true}}\">\nEl Club</md-radio-button><md-radio-button ng-value=\"{{false}}\">Otro accionista</md-radio-button></md-radio-group></div>\n</div><div layout=\"column\" flex ng-if=\"!vm.transferToClub\" layout-align=\"start start\"><form name=\"transferForm\" \nlayout=\"column\" flex><div layout=\"row\" flex><md-input-container flex><label>Libro</label><input type=\"text\" \nname=\"book\" ng-model=\"vm.book\" required><div ng-messages=\"complementData.book.$error\"><div ng-message=\"required\">\nDato obligatorio</div></div></md-input-container><md-input-container flex><label>Folio</label><input type=\"text\" \nname=\"folio\" ng-model=\"vm.folio\" required><div ng-messages=\"complementData.folio.$error\"><div ng-message=\"required\">\nDato obligatorio</div></div></md-input-container><md-input-container flex><label>Renglon</label><input type=\"text\" \nname=\"row\" ng-model=\"vm.row\" required><div ng-messages=\"complementData.row.$error\"><div ng-message=\"required\">\nDato obligatorio</div></div></md-input-container></div><div layout=\"row\" flex><md-input-container class=\"md-block\" \nflex><label>Accionista al que se transfieren las acciones</label><md-select ng-model=\"vm.accionistaTarget\" required>\n<md-option ng-repeat=\"opt in vm.accionistasTaget | filter : { isExAccionista: false }\" ng-value=\"opt\">\n{{opt.completeName}}</md-option></md-select></md-input-container></div></form></div></div></div></md-card-content>\n</md-card><md-card flex=\"40\"><md-card-content layout=\"column\" class=\"no-padding\"><h2 class=\"p-15 pb-0\">\nAcciones a traspasar</h2><table class=\"dataTable row-border border\"><thead><tr><th>Serie</th><th>Número</th></tr>\n</thead><tbody><tr cd-custom-grid=\"item in vm.accionesSource | itemsPerPage: (8)\" pagination-id=\"accionesPaginator\" \nclass=\"selectable\" ng-class=\"{\'selected\': item.selected }\" ng-click=\"item.selected = !item.selected\"><td>{{item.serie}}\n</td><td>{{item.number}}</td></tr></tbody><tr><td colspan=\"2\"><dir-pagination-controls \npagination-id=\"accionesPaginator\"></dir-pagination-controls></td></tr></table></md-card-content></md-card></div></div>\n</div></div></div>");
$templateCache.put("app/main/catalogs/views/becas/becas.html","<cd-catalog title=\"Becas\" item-name=\"Beca\" api-service=\"becas\"><cd-catalog-numeric model-name=\"discountPercentage\" \nlabel=\"Porcentaje de descuento\" required min=\"1\" max=\"100\"></cd-catalog-numeric></cd-catalog>");
$templateCache.put("app/main/catalogs/views/clubAccess/clubAccess.html","<cd-catalog title=\"Accesos Club\" item-name=\"Acceso\" api-service=\"clubAccess\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/duesRules/duesRules.html","<div id=\"duesRules\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Reglas de cuotas</span></div><div \nclass=\"product-count secondary-text\"><span>No de reglas:</span> <span>{{vm.items.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background md-raised\" ng-click=\"vm.detail($event)\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>Agregar</md-button></div></div><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtDuesRulesInstance\" dt-options=\"vm.dtDuesRulesOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cuota Actual</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cuota Nueva</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Sexo</span></div></th><th \nclass=\"secondary-text w-120\"><div class=\"table-header\"><span class=\"column-title\">Acción</span></div></th><th \nclass=\"secondary-text w-120\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.items\" class=\"selectable\" ng-click=\"vm.selectedRule = item\" \nng-class=\"{\'selected\': vm.selectedRule.id == item.id }\"><td>{{item.dueCurrent.name}}</td><td>{{item.dueNew.name}}</td>\n<td>{{item.gender.name}}</td><td>{{item.action}} <span ng-show=\"{{item.isForced}}\">- Forzado</span></td><td><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.detail($event, item)\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button class=\"md-icon-button md-raised md-warn\" \nng-click=\"vm.remove(item.id)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip></md-button>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/countries/countries.html","<cd-catalog title=\"Paises\" item-name=\"Pais\" api-service=\"countries\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/employeeTypes/employeeTypes.html","<cd-catalog title=\"Tipos de empleados\" item-name=\"Tipo de empledo\" api-service=\"employeeTypes\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/evaluations/evaluations.html","<cd-catalog title=\"Evaluaciones\" item-name=\"Evaluacion\" api-service=\"evaluations\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/levels/levels.html","<cd-catalog title=\"Niveles\" item-name=\"Nivel\" api-service=\"levels\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/media/media.html","<cd-catalog title=\"Medios\" item-name=\"Medio\" api-service=\"media\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/levelScores/levelScores.html","<cd-catalog title=\"Calificaciones\" item-name=\"Calificacion\" api-service=\"levelScores\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/passTypes/passTypes.html","<cd-catalog title=\"Tipos de pases\" item-name=\"Tipo\" api-service=\"passTypes\"><cd-catalog-input \nmodel-name=\"emailGreeting\" label=\"Saludo\" required></cd-catalog-input><cd-catalog-input model-name=\"emailBody\" \nlabel=\"Mensaje\" required></cd-catalog-input><cd-catalog-input model-name=\"emailSignature\" label=\"Despedida\" required>\n</cd-catalog-input><cd-catalog-check model-name=\"isSendByEmail\" label=\"Se envía por email??\"></cd-catalog-check>\n</cd-catalog>");
$templateCache.put("app/main/catalogs/views/passes/passes.html","<div id=\"passes\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Pases y Credenciales</span></div><div \nclass=\"product-count secondary-text\"><span>No de pases/credenciales:</span> <span>{{vm.items.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background w-40\" ng-click=\"vm.massiveAdd($event)\">\n<md-icon md-font-icon=\"icon-library-plus\"></md-icon><md-tooltip>Agregar multiple</md-tooltip></md-button><md-button \nclass=\"md-raised md-warn w-40\" ng-click=\"vm.remove(vm.pass)\" ng-disabled=\"!vm.pass\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip>Borrar seleccionado</md-tooltip></md-button><md-button class=\"md-icon md-raised md-warn w-60\" \nng-click=\"vm.massiveRemove($event)\" ng-disabled=\"vm.deleting\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar multiple</md-tooltip></md-button></div><div class=\"status\">\n{{vm.status}}</div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtPassesInstance\" dt-options=\"vm.dtPassesOptions\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">Tipo de pase</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Numero de pase</span></div></th><th class=\"secondary-text w-80\"><div \nclass=\"table-header\"><span class=\"column-title\">Fecha de alta</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.items\" class=\"selectable\" ng-click=\"vm.pass = item\" \nng-class=\"{\'selected\': vm.pass.id == item.id }\"><td>{{item.passType.name}}</td><td>{{item.number}}</td><td>\n{{item.insertDate | date : \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/partnerTypes/partnerTypes.html","<cd-catalog title=\"Tipos de socio\" item-name=\"Tipo de socio\" api-service=\"partnerTypes\"><cd-catalog-check \nmodel-name=\"isFamiliar\" label=\"Es Para Familiar\"></cd-catalog-check></cd-catalog>");
$templateCache.put("app/main/catalogs/views/paymentMethodOptions/paymentMethodOptions.html","<cd-catalog title=\"Opciones de forma de pago\" item-name=\"Opción\" api-service=\"paymentMethodOptions\"><cd-catalog-select \nlist-api-source=\"paymentMethods\" label=\"Forma de pago\" model-name=\"paymentMethodId\" required></cd-catalog-select>\n<cd-catalog-check model-name=\"isAutomaticPayment\" label=\"Aplica en cargo autmático\"></cd-catalog-check></cd-catalog>");
$templateCache.put("app/main/catalogs/views/paymentMethods/paymentMethods.html","<cd-catalog title=\"Formas de pago\" item-name=\"Forma de pago\" api-service=\"paymentMethods\"><cd-catalog-select \nmodel-name=\"satPaymentId\" label=\"Forma de pago de SAT\" list-api-group=\"sat\" list-api-source=\"payments\" required>\n</cd-catalog-select><cd-catalog-check model-name=\"referenceRequired\" label=\"Requiere referencia\"></cd-catalog-check>\n<cd-catalog-check model-name=\"isAutomaticPayment\" label=\"Aplica en cargo autmático\"></cd-catalog-check></cd-catalog>");
$templateCache.put("app/main/catalogs/views/satCodes/satCodes.html","<cd-catalog title=\"Códigos de SAT\" item-name=\"Código SAT\" api-service=\"satCodes\"><cd-catalog-input model-name=\"code\" \nlabel=\"Código\" required></cd-catalog-input><cd-catalog-select model-name=\"satCodeTypeId\" label=\"Tipo de código\" \nlist-api-source=\"satCodeTypes\" required></cd-catalog-select></cd-catalog>");
$templateCache.put("app/main/catalogs/views/professions/professions.html","<cd-catalog title=\"Profesiones\" item-name=\"Profesión\" api-service=\"professions\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/warehouses/warehouses.html","<cd-catalog title=\"Almacenes\" item-name=\"Almacen\" api-service=\"warehouses\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/tpvs/tpvs.html","<cd-catalog title=\"TPV\'s\" item-name=\"TPV\" api-service=\"tpvs\"></cd-catalog>");
$templateCache.put("app/main/catalogs/views/zones/zones.html","<cd-catalog title=\"Ubicaciones\" item-name=\"Ubicacion\" api-service=\"zones\"></cd-catalog>");
$templateCache.put("app/main/invoices/views/batch/batch.html","<div id=\"batch\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-file\"></md-icon><div class=\"w-10\">\n</div><span>CARGA MASIVA DE RECIBOS</span></div></div></div><div class=\"content\"><div class=\"p-20\"><h2>\nSube un archivo con el layout correcto para procesar masivamente las solicitudes y generar los recibos correspondientes\n</h2><div layout=\"row\" layout-align=\"start center\" class=\"w-480\"><input type=\"file\" id=\"inputFile\" flex><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.save()\" ng-disabled=\"vm.loading\" flex-1><span ng-if=\"vm.loading\">\nSUBIENDO ARCHIVO...</span> <span ng-if=\"!vm.loading\">SUBIR</span></md-button></div></div><div class=\"p-20\" \nng-if=\"vm.result !== null && vm.result !== undefined\"><h2>\nSe procesaron {{vm.result.successLines}} registros correctamente</h2><div \nng-if=\"vm.result.errorLines && vm.result.errorLines > 0\"><h2>\nSe encontraron {{vm.result.errorLines}} errores, descarga el archivo de registros con error <a \nng-href=\"{{vm.apiUrl}}{{vm.result.errorFilePath}}\" download target=\"_blank\">AQUI</a></h2><h2>Detalle de errores:</h2>\n<ul><li ng-repeat=\"item in vm.result.errorMessages\">{{item}}</li></ul></div></div></div></div>");
$templateCache.put("app/main/invoices/views/complements/complements.html","<div id=\"complements\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-cube-outline\"></md-icon><span>RECIBOS ELECTRÓNICOS DE PAGOS</span></div></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab id=\"pendingInvoices\"><md-tab-label><span>\nFacturas con pago parcial o diferido</span></md-tab-label><md-tab-body><div layout=\"column\" flex><div \nclass=\"invoices md-background-bg md-whiteframe-1dp h-200\" layout=\"row\" flex ms-scroll><div layout=\"column\" flex><div \nlayout=\"row\" flex><table class=\"dataTable row-border hover bordered\"><thead><tr><th colspan=\"7\"><div layout=\"column\" \nflex><div layout=\"row\" layout-align=\"space-between center\" flex><div class=\"p-25\">Facturas con pago parcial o diferido\n</div><div layout=\"row\" class=\"pr-15\"><md-input-container class=\"md-block mb-0 h-40\" flex-1><label>Desde</label>\n<md-datepicker ng-init=\"vm.dummy.from = (vm.from | toDate)\" \nng-change=\"vm.from = vm.dummy.from; vm.getPendingInvoices();\" ng-model=\"vm.dummy.from\" name=\"from\" \nmd-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block mb-0 h-40 mr-10\" flex-1><label>Hasta</label><md-datepicker \nng-init=\"vm.dummy.to = (vm.to | toDate)\" ng-change=\"vm.to = vm.dummy.to; vm.getPendingInvoices();\" \nng-model=\"vm.dummy.to\" name=\"to\" md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker></md-input-container><md-checkbox class=\"mb-0 pt-20 ml-15 mr-10\" ng-model=\"vm.includeCompletePayed\" \nng-click=\"vm.getPendingInvoices()\">Incluir Pagadas</md-checkbox></div></div></div></th></tr><tr><th \nclass=\"secondary-text w-100\"><div class=\"table-header\"><span class=\"column-title\">Folio</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Familia</span></div></th><th \nclass=\"secondary-text w-100\"><div class=\"table-header\"><span class=\"column-title\">Fecha</span></div></th><th \nclass=\"secondary-text w-150\"><div class=\"table-header\"><span class=\"column-title\">RFC</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Cliente</span></div></th><th \nclass=\"secondary-text w-150\"><div class=\"table-header\"><span class=\"column-title\">Monto</span></div></th><th \nclass=\"secondary-text w-200\"><div class=\"table-header\"><span class=\"column-title\">Responsable</span></div></th></tr>\n</thead><tbody><tr cd-custom-grid=\"item in vm.pendingInvoices | itemsPerPage: (8)\" pagination-id=\"invoicesPaginator\" \nclass=\"selectable\" ng-class=\"{\'selected\': item.id == vm.selectedInvoice.id }\" ng-click=\"vm.selectInvoice(item)\"><td>\n{{item.folio}}</td><td>{{item.partner.sequentialNumber}}</td><td>{{item.expeditionDate | date : \'dd/MM/yyyy\'}}</td><td>\n{{item.rfc}}</td><td>{{item.razonSocial}}</td><td>{{item.total | currency: \'$ \': 2}}</td><td></td></tr></tbody><tr><td \ncolspan=\"7\"><dir-pagination-controls pagination-id=\"invoicesPaginator\"></dir-pagination-controls></td></tr></table>\n</div></div></div><div class=\"complements md-background-bg md-whiteframe-1dp mt-20 h-200\" layout=\"row\" flex ms-scroll>\n<div layout=\"row\" flex><table class=\"dataTable row-border hover bordered\"><thead><tr><th colspan=\"7\">\nPagos de Factura Seleccionada (REP)</th></tr><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Folio</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Fecha</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Forma Pago</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Parcialidad</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Pago</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Saldo Anterior</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Saldo Insoluto</span></div></th><th class=\"secondary-text w-120\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.invoiceComplements | itemsPerPage: (3)\" pagination-id=\"complementsPaginator\"><td>{{item.id}}\n</td><td>{{item.paymentDate | date : \'dd/MM/yyyy\'}}</td><td>{{item.satPayment.description}}</td><td>\n{{item.sequentialNumber}}</td><td>{{item.amount | currency: \'$ \': 2}}</td><td>\n{{item.saldoAnterior | currency: \'$ \': 2}}</td><td>{{item.saldoInsoluto | currency: \'$ \': 2}}</td><td><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"vm.view(item.id)\" ng-if=\"item.xmlString && !item.isCanceled\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><md-tooltip>Ver archivo</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-accent\" ng-click=\"vm.cancel(item)\" ng-if=\"item.xmlString && !item.isCanceled\"><md-icon \nmd-font-icon=\"icon-block-helper\"></md-icon><md-tooltip>Cancelar complemento</md-tooltip></md-button><span \nng-if=\"item.isCanceled\">CANCELADO</span></td></tr></tbody><tr><td colspan=\"7\"><dir-pagination-controls \npagination-id=\"complementsPaginator\"></dir-pagination-controls></td></tr></table></div></div></div></md-tab-body>\n</md-tab><md-tab ng-disabled=\"!vm.selectedInvoice\"><md-tab-label><span>Generación de Recibo Electrónico de Pago</span>\n</md-tab-label><md-tab-body><div layout=\"row\" flex><div class=\"invoices md-background-bg md-whiteframe-1dp\" \nlayout=\"row\" flex ms-scroll><form name=\"complementForm\" layout=\"column\" flex><table flex><tr><td><md-input-container>\n<label>RFC Receptor</label><input type=\"text\" ng-model=\"vm.complement.rfcReceptor\" ng-disabled=\"true\">\n</md-input-container></td><td><md-input-container flex class=\"mr-15\"><label>Lugar de expedición</label><input \ntype=\"text\" ng-model=\"vm.complement.expeditionSatZipCodeId\" ng-disabled=\"{{true}}\"></md-input-container></td><td>\n<md-input-container flex class=\"mr-15\"><label>Moneda</label><input type=\"text\" ng-model=\"vm.complement.satCoin.name\" \nng-disabled=\"{{true}}\"></md-input-container></td><td><md-input-container class=\"md-block\"><label>Fecha de pago</label>\n<md-datepicker class=\"w-200\" ng-init=\"vm.date = (vm.complement.paymentDate | toDate)\" ng-model=\"vm.date\" \nng-change=\"vm.complement.paymentDate = vm.date\" md-placeholder=\"Seleccione\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\" md-max-date=\"vm.maxDate\" name=\"payDate\" required></md-datepicker><div \nng-messages=\"complementForm.payDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo requerido.</span></div>\n</div></md-input-container></td><td><md-input-container flex class=\"mt-0\"><label>Forma de pago</label><md-select \nng-model=\"vm.complement.satPayment\" class=\"w-200\" flex name=\"payment\" required><md-option \nng-repeat=\"opt in vm.satPayments\" ng-value=\"opt\">{{opt.name}}</md-option></md-select><div \nng-messages=\"complementForm.payment.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo requerido.</span></div>\n</div></md-input-container></td><td><md-input-container flex><label>Monto</label><input type=\"number\" \nng-max=\"vm.balance\" ng-model=\"vm.complement.amount\" name=\"amount\" required><div \nng-messages=\"complementForm.amount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo requerido.</span></div>\n</div></md-input-container></td></tr><tr><td><md-input-container class=\"w-200\"><label>No. Operación<md-icon \nclass=\"icon-info s16\" md-font-icon=\"icon-question-mark-circle\"><md-tooltip>\nNumero de Cheque, No de Autorización, Cve de rastreo (SPEI), linea de captura o algun No de referencia</md-tooltip>\n</md-icon></label><input type=\"text\" ng-model=\"vm.complement.operationNumber\"></md-input-container></td><td>\n<md-input-container flex><label>RFC Emisor Cta Ord.<md-icon class=\"icon-info mt-10 pt-0 s16\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip>\nBanco, operadora, inst. financiera. emisor modero electrónico, etc.</md-tooltip></md-icon></label><input type=\"text\" \nname=\"rfcOrdenante\" ng-model=\"vm.complement.rfcEmisorOrdenante\" \nng-pattern=\"/^([A-ZÑ&]{3,4}) ?(?:- ?)?(\\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\\d|3[01])) ?(?:- ?)?([A-Z\\d]{2})([A\\d])$/\">\n<div ng-messages=\"complementForm.rfcOrdenante.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>RFC Invalido.</span>\n</div></div></md-input-container></td><td><md-input-container flex class=\"mt-0\"><label>Nombre del Banco</label>\n<md-select class=\"w-200\" ng-model=\"vm.complement.satBankId\" flex><md-option ng-repeat=\"opt in vm.satBanks\" \nng-value=\"opt.id\">{{opt.name}}</md-option></md-select></md-input-container></td><td><md-input-container flex><label>\nCuenta Ordenante</label><input type=\"text\" ng-model=\"vm.complement.cuentaOrdenante\"></md-input-container></td><td>\n<md-input-container flex><label>RFC Emisor Cta Ben<md-icon class=\"icon-info mt-10 pt-0 s16\" \nmd-font-icon=\"icon-question-mark-circle\"><md-tooltip>\nBanco, operadora, inst. financiera. emisor modero electrónico, etc.</md-tooltip></md-icon></label><input type=\"text\" \nng-model=\"vm.complement.rfcEmisorBeneficiario\"></md-input-container></td><td><md-input-container flex><label>\nCuenta Beneficiario</label><input type=\"text\" ng-model=\"vm.complement.cuentaBeneficiario\"></md-input-container></td>\n</tr><tr><td class=\"mt-0 w-200\"><md-input-container flex class=\"h-60\" ng-if=\"vm.complement.satPayment.code == \'03\'\">\n<label>Tipo cadena de pago</label><md-select ng-model=\"vm.complement.satCadena\"><md-option \nng-repeat=\"opt in vm.satCadenas\" ng-value=\"opt\">{{opt.name}}</md-option></md-select></md-input-container></td><td>\n<md-input-container flex ng-if=\"vm.complement.satPayment.code == \'03\' && vm.complement.satCadena.code == \'01\'\"><label>\nCadena de pago SPEI</label><input type=\"text\" ng-model=\"vm.complement.spei\" name=\"spei\" required><div \nng-messages=\"complementForm.spei.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo requerido.</span></div>\n</div></md-input-container></td><td><md-input-container flex \nng-if=\"vm.complement.satPayment.code == \'03\' && vm.complement.satCadena.code == \'01\'\"><label>Certificado de Pago SPEI\n</label><input type=\"text\" ng-model=\"vm.complement.speiCertificate\" name=\"speiCertificate\" required><div \nng-messages=\"complementForm.speiCertificate.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo requerido.\n</span></div></div></md-input-container></td><td><md-input-container flex \nng-if=\"vm.complement.satPayment.code == \'03\' && vm.complement.satCadena.code == \'01\'\"><label>Sello de pago SPEI</label>\n<input type=\"text\" ng-model=\"vm.complement.speiSello\" name=\"speiSello\" required><div \nng-messages=\"complementForm.speiSello.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo requerido.</span>\n</div></div></md-input-container></td><td></td><td><md-button class=\"md-raised md-accent md-background\" \nng-disabled=\"!complementForm.$valid\" ng-click=\"vm.saveComplement()\"><span>Agregar complemento</span></md-button></td>\n</tr></table></form></div></div></md-tab-body></md-tab></md-tabs><div class=\"md-background-bg md-whiteframe-1dp p-5\" \nlayout=\"column\" flex ms-scroll><div layout=\"row\" flex><table flex><tr><td>Factura</td><td>Total Factura</td><td>\nParcialidad</td><td>Saldo</td><td>Familia</td><td>Titular</td><td>Email</td></tr><tr><td>{{vm.invoice.folio}}</td><td>\n{{vm.invoice.total | currency: \'$ \': 2}}</td><td>{{vm.complement.sequentialNumber}}</td><td>\n{{vm.balance | currency: \'$ \': 2}}</td><td>{{vm.invoice.partner.sequentialNumber}}</td><td>\n{{vm.invoice.partner.completeName}}</td><td>{{vm.invoice.partner.email}}</td></tr></table></div></div></div></div>");
$templateCache.put("app/main/invoices/views/plannedProducts/plannedProducts.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Cargos Planificados</span></div><div \nclass=\"product-count secondary-text\"><span>No de cargos planificados:</span> <span>{{vm.plannedProducts.length}}</span>\n</div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input ng-model=\"vm.keyword\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.add($event)\"><span>Nuevo\n</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex ms-scroll><table class=\"dataTable row-border hover\">\n<thead><tr><th class=\"secondary-text w-70 h-30\"><div class=\"table-header\"><span class=\"column-title\"># Socio</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nombre de Socio</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Producto</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Vencimiento</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr \ncd-custom-grid=\"item in vm.plannedProducts | filter: vm.keyword | orderBy: \'id\' : true | itemsPerPage: (6)\"><td>\n{{item.id}}</td><td>{{item.partner.completeName}}</td><td>{{item.product.name}} - {{item.price | currency: \'$ \': 2}}\n</td><td>{{item.expirationDate | date: \'dd/MM/yyyy\'}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.remove(item)\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-trash\" class=\"s16\"></md-icon></md-button>\n</td></tr></tbody><tr><td colspan=\"5\"><dir-pagination-controls></dir-pagination-controls></td></tr></table></div></div>\n</div></div>");
$templateCache.put("app/main/invoices/views/receipt/receipt.html","<div id=\"comprobante\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-click=\"vm.pdfDownload()\"><md-icon md-font-icon=\"icon-file-pdf\"></md-icon><md-tooltip>Ver PDF</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" flex ng-click=\"vm.fileDownload(vm.item.xmlPath, \'xml\')\"><md-icon \nmd-font-icon=\"icon-file-xml\"></md-icon><md-tooltip>Ver XML</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-disabled=\"vm.pdfSaving\" ng-click=\"vm.sendMail()\"><md-icon md-font-icon=\"icon-email\"></md-icon><md-tooltip>\nEnviar por Email</md-tooltip></md-button></div><div id=\"invoice-card\" class=\"card md-whiteframe-8dp\"><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" layout=\"column\"><div layout=\"row\" \nclass=\"seller\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img \nwidth=\"120\" ng-src=\"{{vm.logoSource}}\"></div><div class=\"detail\"><div class=\"bold\">{{vm.settings.name}}</div><div \nclass=\"address\">{{vm.settings.address}}</div><div class=\"phone\"><span>Telefono</span>: {{vm.settings.phone}}</div><div \nclass=\"email\"><span>Email</span>: {{vm.settings.email}}</div></div></div></div><table class=\"document-summary\"><tr><td \nclass=\"title\">Tipo de Documento</td></tr><tr><td><span ng-if=\"!vm.item.isNotaCredito && !vm.item.isComplement\">\nFACTURA ({{vm.item.folio}})</span> <span ng-if=\"vm.item.isNotaCredito\">NOTA DE CREDITO ({{vm.item.folio}})</span> <span\n ng-if=\"vm.item.isComplement\">RECIBO ELECTRÓNICO DE PAGO ({{vm.item.folio}})</span></td></tr><tr><td class=\"title\">\nFecha y hora de emisión</td></tr><tr><td>{{vm.item.expeditionDate}}</td></tr><tr><td class=\"title\">\nFecha y hora de certificación</td></tr><tr><td>{{vm.item.satData.fechaCertificacion}}</td></tr></table></div><div \nclass=\"content\"><div class=\"receptor\" layout=\"row\"><div layout=\"column\" flex=\"70\"><table class=\"receptor-fiscal\"><tr>\n<td class=\"title\">Receptor del comprobante Fiscal</td></tr><tr ng-if=\"vm.item.partner && vm.item.partner.addresses\">\n<td>\n{{vm.item.partner.addresses[0].street}} No {{vm.item.partner.addresses[0].number}} COL. {{vm.item.partner.addresses[0].colony}}, {{vm.item.partner.addresses[0].municipio}}, CP. {{vm.item.partner.addresses[0].zipCode}}\n</td></tr><tr><td>{{vm.item.targetRazonSocial}} - {{vm.item.targetRfc}}</td></tr><tr \nng-if=\"vm.item.partner && vm.item.partner.sequentialNumber\"><td>No Membresía: {{vm.item.partner.sequentialNumber}}</td>\n</tr><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr><tr><td></td></tr></table></div><div layout=\"column\" \nflex=\"30\" class=\"pl-10\"><table class=\"folio-fiscal\"><tr><td class=\"title\">Folio fiscal</td></tr><tr><td class=\"folio\">\n{{vm.item.satData.folioFiscal}}</td></tr><tr><td class=\"title\">No. Certificado Digital</td></tr><tr><td>\n{{vm.item.satData.numeroCertificado}}</td></tr><tr><td class=\"title\">Vigencia del certificado</td></tr><tr><td>\nDel {{vm.settings.certificateValidFrom | date: \'dd/MM/yyyy\'}} al {{vm.settings.certificateValidTo | date: \'dd/MM/yyyy\'}}\n</td></tr><tr><td class=\"title\">No. Serie Certificado SAT</td></tr><tr><td>{{vm.item.satData.numeroSerieCertificado}}\n</td></tr></table></div></div><table class=\"invoice-details\"><thead><th class=\"title w-60\">Cantidad</th><th \nclass=\"title w-100\">Unidad</th><th class=\"title\">Concepto</th><th class=\"title w-100\">Precio Unitario</th><th \nclass=\"title w-100\">Importe</th></thead><tbody><tr ng-repeat=\"item in vm.item.details\"><td class=\"text-center\">\n{{item.quantity}}</td><td class=\"text-center\">{{item.satUnit.name}}</td><td class=\"text-left\">\n{{item.satProduct.code}} - {{item.description}}</td><td class=\"text-right pr-10\">{{item.unityValue | currency}}</td><td\n class=\"text-right pr-10\">{{item.subtotal | currency}}</td></tr></tbody></table><table class=\"invoice-details-footer\" \nng-if=\"!vm.item.complement\"><tr><td class=\"title\" colspan=\"2\">Importe con letra: {{vm.numberToLetters(vm.item.total)}}\n</td></tr><tr><td><table class=\"payments\"><tr ng-if=\"!vm.item.isComplement\"><td>Metodo de pago:</td><td>\n{{vm.item.satPaymentMethod.name}}</td><td>Tipo de comprobante: {{vm.item.satInvoiceType.name}}</td></tr><tr><td>\nForma de pago:</td><td>{{vm.item.satPayment.name}}</td><td>Moneda: {{vm.item.satCoin.name}}</td></tr><tr><td></td></tr>\n</table></td><td><table class=\"totals\"><tr><td>Subtotal:</td><td class=\"amount\">{{vm.item.subtotal | currency}}</td>\n</tr><tr><td>Descuento:</td><td class=\"amount\">{{vm.item.discount | currency}}</td></tr><tr><td>IVA:</td><td \nclass=\"amount\">{{vm.item.transferedTaxesTotal | currency}}</td></tr><tr><td>Total:</td><td class=\"amount\">\n{{vm.item.total | currency}}</td></tr></table></td></tr></table><div ng-if=\"vm.item.complement\"><h3>\nInformación del pago</h3><table class=\"invoice-details-footer\"><tr><td class=\"title\" colspan=\"2\">\nImporte: {{vm.item.complement.amount|currency}}<br>Importe con letra: {{vm.numberToLetters(vm.item.complement.amount)}}\n</td></tr><tr><td>Tipo de Comprobante: (P) pago<br><br>\nLugar de Expedición: {{vm.item.complement.expeditionSatZipCode.code}}</td><td><table class=\"totals\"><tr><td>Subtotal:\n</td><td class=\"amount\">{{vm.item.subtotal | currency}}</td></tr><tr><td>IVA:</td><td class=\"amount\">\n{{vm.item.complement.amount | currency}}</td></tr><tr><td>Total:</td><td class=\"amount\">\n{{vm.item.complement.amount | currency}}</td></tr></table></td></tr></table><table class=\"invoice-details-footer\">\n<thead><tr><th class=\"title\">Forma de Pago</th><th class=\"title\">Fecha de Pago</th><th class=\"title\">Moneda</th><th \nclass=\"title\">Tipo de cambio</th><th class=\"title\">Monto</th></tr></thead><tbody><tr><td>\n{{vm.item.complement.satPayment.description}}</td><td>{{vm.item.complement.paymentDate|date:\'dd/MM/yyyy HH:mm:ss\'}}\n</td><td>{{vm.item.complement.satCoin.code}}</td><td>1.0</td><td>{{vm.item.complement.amount}}</td></tr></tbody>\n</table><h3>Documento relacionado</h3><table class=\"invoice-details-footer\"><tr><td>Id documento:</td><td>\n{{vm.item.cfdiRelacionado}}</td><td>Número parcialidad</td><td>{{vm.item.complement.sequentialNumber}}</td></tr><tr>\n<td>Folio de la factura:</td><td>{{vm.item.invoiceFolio}}</td><td>Importe total a pagar:</td><td>\n{{vm.item.complement.invoice.total|currency}}</td></tr><tr><td>Objeto Impuesto documento relacionado:</td><td>\nSí objeto de impuesto</td><td>Importe pagado:</td><td>{{vm.item.complementPayed|currency}}</td></tr><tr><td>\nMoneda del documento relacionado:</td><td>{{vm.item.complement.invoice.satCoin.description}}</td><td>\nImporte de saldo insoluto:</td><td>{{vm.item.complementDebt|currency}}</td></tr></table></div><div \nng-if=\"vm.item.isNotaCredito\" class=\"mt-10\"><span class=\"bold\">Referencia: Factura {{vm.item.invoiceFolio}}</span><br>\nObservaciones: {{vm.item.notes}}<br><span class=\"bold\">Documentos relacionados: {{vm.item.cfdiRelacionado}}</span>\n</div><table class=\"w-100- border mt-10\"><tr><td class=\"title\">Cadena Original del Complemento de Certificación del SAT\n</td></tr><tr><td class=\"cadena-original text-wrap\">{{vm.item.satData.cadenaOriginalComplemento}}</td></tr></table><div\n layout=\"row\" class=\"qrcode-wrapper mt-10\"><div layout=\"column\" flex=\"20\"><div id=\"qrcode\"></div></div><div \nlayout=\"column\" flex=\"80\"><table class=\"w-100- border\"><tr><td class=\"title\">Sello Digital del CFDI</td></tr><tr><td \nclass=\"w-500 text-wrap sello\">{{vm.item.satData.selloDigitalCfdi}}</td></tr></table><table class=\"w-100- mt-10 border\">\n<tr><td class=\"title\">Sello Digital SAT</td></tr><tr><td class=\"w-500 text-wrap sello\">\n{{vm.item.satData.selloDigitalSat}}</td></tr></table><div class=\"footer-notes\"><span>\nEste Documento es una representacion impresa de un CFDI</span><br><span>Versión del CFDI 4.0</span><br><span>\nUso de CFDI: {{vm.item.satCfdiUse.name}}</span></div></div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/license/dialogs/dialog-login/dialog-login.html","<md-dialog id=\"license-dialog-login\" class=\"catalogs-dialog-detail\" aria-label=\"partner-dialog-club-access\"><form \nname=\"loginForm\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nGENERAR LICENCIA</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nclass=\"p-20 pt-40\" ms-scroll><md-input-container class=\"md-block\" flex><label>Vigencia hasta</label><md-datepicker \nng-init=\"vm.date = (vm.item.date | toDate)\" ng-model=\"vm.date\" ng-change=\"vm.item.date = vm.date\" \nmd-placeholder=\"Seleccione\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Usuario</label><input type=\"text\" name=\"user\" ng-model=\"vm.item.user\" \nrequired><div ng-messages=\"loginForm.user.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEl usuario es obligatorio</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex><label>\nContraseña</label><input type=\"password\" name=\"password\" ng-model=\"vm.item.password\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>La contraseña es obligatoria.\n</span></div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"end center\"><md-button type=\"submit\" ng-click=\"vm.accept()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"save\">Aceptar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/views/turns/turns.html","<div id=\"turns\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Turnos</span></div><div class=\"product-count secondary-text\">\n<span>No total de turnos:</span> <span>{{vm.turns.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input class=\"search-input\" type=\"text\" placeholder=\"Buscar\" flex ng-model=\"vm.keyword\"></div><div><md-button \nng-click=\"vm.openTurn()\" class=\"send-button md-raised\" aria-label=\"Aceptar\">Abrir turno</md-button></div><div \nclass=\"actions\" layout=\"row\" layout-align=\"end center\"><md-input-container class=\"md-block mb-0 h-40\" flex-1><label>\nDesde</label><md-datepicker ng-init=\"vm.dummy.from = (vm.from | toDate)\" \nng-change=\"vm.from = vm.dummy.from; vm.getTurns();\" ng-model=\"vm.dummy.from\" name=\"from\" \nmd-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block mb-0 h-40\" flex-1><label>Hasta</label><md-datepicker \nng-init=\"vm.dummy.to = (vm.to | toDate)\" ng-change=\"vm.to = vm.dummy.to; vm.getTurns();\" ng-model=\"vm.dummy.to\" \nname=\"to\" md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker>\n</md-input-container><md-input-container class=\"mb-0 w-150\"><label>Mostrar:</label><md-select ng-model=\"vm.isOpen\">\n<md-option ng-repeat=\"item in vm.filterOpenOptions\" ng-value=\"item.value\">{{item.text}}</md-option></md-select>\n</md-input-container></div></div><div class=\"content-card fullpage-datatable no-padding\" layout=\"row\" flex><div \nclass=\"content fullpage-datatable no-padding\" flex><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text w-20\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">FechaApertura</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Turno</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">UsuarioApertura</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">FechaCierre</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">UsuarioCierre</span></div></th><th \nclass=\"secondary-text w-60\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr \ncd-custom-grid=\"item in vm.turns | filter: { isOpen: vm.isOpen } | filter : vm.keyword | orderBy: \'id\': true | itemsPerPage: (7)\">\n<td>{{item.id}}</td><td>{{item.openDate | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{item.turnNumber}}</td><td>\n{{item.user.name}}</td><td>{{item.closeDate | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{item.closeUser.name}}</td><td \nclass=\"actions\"><md-button class=\"md-icon-button no-padding w-30 h-30\" ng-if=\"item.isOpen\" \nng-click=\"vm.closeTurn(item)\"><md-icon md-font-icon=\"icon-alarm-off\"></md-icon><md-tooltip>Cerrar turno</md-tooltip>\n</md-button></td></tr></tbody><tr><td colspan=\"7\"><dir-pagination-controls></dir-pagination-controls></td></tr></table>\n</div></div></div></div>");
$templateCache.put("app/main/partners/views/prospects/prospects.html","<div id=\"prospects\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header h-100\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\" flex=\"70\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div flex><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Prospectos\n</span></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" ng-model=\"vm.prospectsKeyword\" \nplaceholder=\"Buscar\" flex></div><md-button class=\"md-button md-raised md-white\" flex-1 \nng-click=\"vm.showDetail($event)\" aria-label=\"add-prospect\">Agregar prospecto</md-button></div><div \nclass=\"product-count secondary-text\"><span>No de prospectos:</span> <span>{{vm.prospects.length}}</span></div></div>\n<div layout=\"column\" flex=\"30\" class=\"pl-15\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block\" flex><label class=\"white-fg\">Mostrar</label><md-select class=\"white-fg\" \nng-model=\"vm.onlySignedUpFilter\"><md-option ng-value=\"{{null}}\">TODOS</md-option><md-option ng-value=\"{{true}}\">\nSolo Inscritos</md-option><md-option ng-value=\"{{false}}\">Solo NO Inscritos</md-option></md-select>\n</md-input-container><md-button class=\"md-button md-raised md-white\" flex-1 ng-click=\"vm.showCalendar()\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon>Calendario</md-button></div></div></div><div class=\"\" layout=\"column\" flex><div \nlayout=\"row\" flex><md-card layout=\"column\" flex=\"70\" class=\"no-padding m-0\"><md-card-content class=\"no-padding\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text w-20\"><div class=\"table-header\"><span \nclass=\"column-title\">ID</span></div></th><th class=\"secondary-text w-60 text-align-center\"><div class=\"table-header\">\n<span class=\"column-title\">Fecha</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nombre de Prospecto</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Vendedor</span></div></th><th class=\"secondary-text w-50\"><div class=\"table-header\"><span \nclass=\"column-title\">Inscrito?</span></div></th><th class=\"secondary-text w-130\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr ng-if=\"vm.prospects.length == 0\"><td \ncolspan=\"6\">No hay registros a mostrar</td></tr><tr \ncd-custom-grid=\"item in vm.prospectsFiltered = ( vm.prospects | filter: vm.prospectsKeyword | filter: { isSignedUp: vm.onlySignedUpFilter } ) | itemsPerPage: (5)\" \npagination-id=\"prospectsPaginator\" class=\"selectable\" ng-click=\"vm.selectProspect(item)\" \nng-class=\"{ \'selected\' : item.id == vm.selectedProspect.id }\"><td>{{item.id}}</td><td>\n{{item.insertDate | date: \'dd/MM/yyyy\'}}</td><td>{{item.completeName}}</td><td>\n{{item.seller.name}} {{item.seller.fatherLastname}} {{item.seller.motherLastname}}</td><td class=\"text-align-center\">\n<span ng-show=\"item.isSignedUp\">SI</span> <span ng-hide=\"item.isSignedUp\">NO</span></td><td><md-button \nclass=\"md-icon-button\" flex-1 ng-click=\"vm.showDetail($event, item)\" aria-label=\"detail-prospect\"><md-icon \nmd-font-icon=\"icon-pencil\" ng-if=\"!item.isSignedUp\"></md-icon><md-tooltip ng-if=\"!item.isSignedUp\">Editar prospecto\n</md-tooltip><md-icon md-font-icon=\"icon-eye\" ng-if=\"item.isSignedUp\"></md-icon><md-tooltip ng-if=\"item.isSignedUp\">\nVer prospecto</md-tooltip></md-button><md-button class=\"md-icon-button\" flex-1 ng-click=\"vm.prospectRemove(item)\" \nng-if=\"!item.isSignedUp\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar prospecto</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" flex-1 ng-click=\"vm.prospectSignup(item)\" ng-if=\"!item.isSignedUp\">\n<md-icon md-font-icon=\"icon-account-plus\"></md-icon><md-tooltip>Inscribir prospecto</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" flex-1 ng-click=\"vm.showCalendar(item.sellerId, item.id)\" ng-if=\"!item.isSignedUp\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><md-tooltip>Mostrar calendario de vendedor</md-tooltip></md-button></td></tr>\n<tr><td colspan=\"6\"><dir-pagination-controls pagination-id=\"prospectsPaginator\"></dir-pagination-controls></td></tr>\n</tbody></table></md-card-content></md-card><md-card layout=\"column\" flex=\"30\" class=\"no-padding m-0 ml-15\">\n<md-card-content class=\"no-padding\" ms-scroll><table class=\"comments dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text no-padding h-48\"><div class=\"table-header\" layout=\"row\" layout-align=\"space-between center\"><span\n class=\"column-title p-10\">Comentarios</span><md-button class=\"md-button md-raised md-accent\" flex-1 \nng-click=\"vm.commentAdd()\" ng-hide=\"vm.addingComment || vm.selectedProspect.isSignedUp\">Agregar comentario</md-button>\n</div></th></tr></thead><tbody><tr ng-show=\"vm.addingComment\"><td><form name=\"commentForm\" layout=\"column\"><div><label \nfor=\"comment\">Ingrese Comentarios</label><textarea name=\"comment\" id=\"\" cols=\"30\" rows=\"10\" class=\"border p-8\" \nng-model=\"vm.comment.comment\" required md-autofocus></textarea></div><div layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-button md-accent\" type=\"submit\" ng-disabled=\"commentForm.$invalid\" ng-click=\"vm.commentAccept()\">\nGuardar</md-button><md-button class=\"md-button md-warn\" ng-click=\"vm.commentCancel()\">Cancelar</md-button></div></form>\n</td></tr><tr ng-show=\"vm.selecting\"><td><h3>Cargando comentarios...</h3></td></tr><tr \nng-show=\"!vm.selecting && (!vm.prospectComments || vm.prospectComments.length == 0)\"><td><h3>\nNo hay comentarios a mostrar</h3></td></tr><tr ng-hide=\"vm.selecting\" \ncd-custom-grid=\"item in vm.prospectComments | orderBy: \'id\' : true | itemsPerPage: (5)\" \npaginate-id=\"commentsPaginator\"><td><h4>{{item.insertDate | date: \'dd/MM/yyyy HH:mm\'}}</h4><span>{{item.comment}}\n</span></td></tr></tbody><tr ng-hide=\"vm.selecting || !vm.prospectComments || vm.prospectComments.length == 0\"><td>\n<dir-pagination-controls paginate-id=\"commentsPaginator\"></dir-pagination-controls></td></tr></table></md-card-content>\n</md-card></div></div></div></div>");
$templateCache.put("app/main/partners/views/prospectCalendar/prospectCalendar.html","<div id=\"calendar\" class=\"page-layout no-padding\" layout=\"column\"><div class=\"header\" ng-class=\"vm.currentMonthShort\">\n<div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\">Agenda de\n</span><md-input-container class=\"sellers\"><md-select ng-model=\"vm.selectedSeller\" \nng-change=\"vm.selectedSellerChange()\" aria-label=\"sellers\"><md-option ng-repeat=\"opt in vm.sellers\" ng-value=\"opt\" \naria-label=\"seller_opt_{{opt.id}}\">{{opt.completeName}}</md-option></md-select></md-input-container><span \nclass=\"logo-text\">con</span><md-input-container class=\"prospects\"><md-select ng-model=\"vm.prospect\" \nng-change=\"vm.selectedProspectChange()\" aria-label=\"prospects\"><md-option ng-value=\"{{null}}\" \naria-label=\"prospect_opt_{{opt.id}}\">Todos</md-option><md-option ng-repeat=\"opt in vm.prospects\" ng-value=\"opt\">\n{{opt.completeName}}</md-option></md-select></md-input-container></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"Hoy\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip>Hoy</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Dia\"><md-icon md-font-icon=\"icon-view-day\"></md-icon>\n<md-tooltip>Dia</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Semana\"><md-icon md-font-icon=\"icon-view-week\"></md-icon>\n<md-tooltip>Semana</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Mes\"><md-icon md-font-icon=\"icon-view-module\"></md-icon>\n<md-tooltip>Mes</md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Anterior\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">\n{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" \naria-label=\"Siguiente\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><md-button \nclass=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Agregar evento\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"content\"><div id=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/reports/views/dashboard/dashboard.html","<div id=\"dashboard\" class=\"page-layout fullwidth\" layout=\"row\"><div class=\"center\" layout=\"column\" flex \nperfectscrollbar><div class=\"header pl-30 pt-40\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"grey-700-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1 no-padding\" layout=\"row\" \nlayout-align=\"start center\"><span>Dashboard</span></div><div class=\"secondary-text\"><span>Sucursal: {{vm.branchName}}\n</span></div></div></div><div flex class=\"loading\" \nng-if=\"!vm.inscriptions || !vm.inscriptionsbyweek || !vm.population || !vm.debts || !vm.byage || !vm.bygender\">\nCargando información...</div><div class=\"content p-20\" layout=\"column\" flex \nng-if=\"vm.inscriptions && vm.inscriptionsbyweek && vm.population && vm.debts && vm.byage && vm.bygender\"><div \nlayout=\"row\" fxlayoutalign=\"start start\" flex><md-card flex><md-card-title class=\"h2\" fxlayout=\"row\" \nfxlayoutalign=\"space-between center\"><span flex>Ventas</span></md-card-title><md-card-content layout=\"row\" \nlayout-align=\"start start\" flex><canvas id=\"salesyear\" class=\"chart chart-line\" chart-data=\"vm.salesyear.data\" \nchart-labels=\"vm.salesyear.labels\" chart-series=\"vm.salesyear.series\" chart-options=\"vm.salesyear.options\"></canvas>\n</md-card-content></md-card><md-card flex><md-card-title class=\"h2\" fxlayout=\"row\" \nfxlayoutalign=\"space-between center\"><span flex>Ventas últimos 12 meses</span> <span>\nTotal: {{vm.salesyearbytype.total|currency}}</span></md-card-title><md-card-content layout=\"row\" \nlayout-align=\"start start\" flex><canvas id=\"salesyearbytype\" class=\"chart chart-bar\" \nchart-data=\"vm.salesyearbytype.data\" chart-labels=\"vm.salesyearbytype.labels\" chart-series=\"vm.salesyearbytype.series\" \nchart-options=\"vm.salesyearbytype.options\"></canvas></md-card-content></md-card></div><div layout=\"row\" \nfxlayoutalign=\"start start\" flex><md-card flex><md-card-title class=\"h2\" fxlayout=\"row\" \nfxlayoutalign=\"space-between center\"><span flex>Ventas últimos 7 días</span> <span>Total: {{vm.sales.total|currency}}\n</span></md-card-title><md-card-content layout=\"row\" layout-align=\"start start\" flex><canvas id=\"sales\" \nclass=\"chart chart-line\" chart-data=\"vm.sales.data\" chart-labels=\"vm.sales.labels\" chart-options=\"vm.sales.options\">\n</canvas></md-card-content></md-card><md-card flex><md-card-title class=\"h2\" fxlayout=\"row\" \nfxlayoutalign=\"space-between center\"><span flex>Ventas últimos 7 días</span> <span>\nTotal: {{vm.salesbytype.total|currency}}</span></md-card-title><md-card-content layout=\"row\" \nlayout-align=\"start start\" flex><canvas id=\"salesbytype\" class=\"chart chart-bar\" chart-data=\"vm.salesbytype.data\" \nchart-labels=\"vm.salesbytype.labels\" chart-series=\"vm.salesbytype.series\" chart-options=\"vm.salesbytype.options\">\n</canvas></md-card-content></md-card></div><div layout=\"row\" fxlayoutalign=\"start start\" flex><md-card flex>\n<md-card-title class=\"h2\" fxlayout=\"row\" fxlayoutalign=\"space-between center\"><span flex>Top 10 productos más vendidos\n</span> <span>Total: {{vm.salestop.total|currency}}</span></md-card-title><md-card-content layout=\"row\" \nlayout-align=\"start start\" flex><canvas id=\"salestop\" class=\"chart chart-doughnut\" chart-data=\"vm.salestop.data\" \nchart-labels=\"vm.salestop.labels\"></canvas></md-card-content></md-card><md-card flex><md-card-title class=\"h2\" \nfxlayout=\"row\" fxlayoutalign=\"space-between center\"><span flex>Ventas por tipo últimos 30 días</span> <span>\nTotal: {{vm.salestopbytype.total|currency}}</span></md-card-title><md-card-content layout=\"row\" \nlayout-align=\"start start\" flex><canvas id=\"salestopbytype\" class=\"chart chart-pie\" \nchart-data=\"vm.salestopbytype.data\" chart-labels=\"vm.salestopbytype.labels\" chart-series=\"vm.salestopbytype.series\" \nchart-options=\"vm.salestopbytype.options\"></canvas></md-card-content></md-card></div><div layout=\"row\" \nfxlayoutalign=\"start start\" flex><md-card flex><md-card-title class=\"h2\" fxlayout=\"row\" \nfxlayoutalign=\"space-between center\"><span flex>Inscripciones últimos 12 meses</span> <span>\nTotal: {{vm.inscriptions.total|number}}</span></md-card-title><md-card-content layout=\"row\" layout-align=\"start start\" \nflex><canvas id=\"incriptions\" class=\"chart chart-bar\" chart-data=\"vm.inscriptions.data\" \nchart-labels=\"vm.inscriptions.labels\" chart-series=\"vm.inscriptions.series\" chart-options=\"vm.inscriptions.options\">\n</canvas></md-card-content></md-card><md-card flex><md-card-title class=\"h2\" fxlayout=\"row\" \nfxlayoutalign=\"space-between center\"><span flex>Inscripciones últimas 4 semanas</span> <span>\nTotal: {{vm.inscriptionsbyweek.total|number}}</span></md-card-title><md-card-content layout=\"row\" \nlayout-align=\"start start\" flex><canvas id=\"inscriptionsbyweek\" class=\"chart chart-line\" \nchart-data=\"vm.inscriptionsbyweek.data\" chart-labels=\"vm.inscriptionsbyweek.labels\" \nchart-series=\"vm.inscriptionsbyweek.series\" chart-options=\"vm.inscriptionsbyweek.options\"></canvas></md-card-content>\n</md-card></div><div layout=\"row\" layout-align=\"top start\" flex><md-card flex><md-card-title class=\"h2\" fxlayout=\"row\" \nfxlayoutalign=\"space-between center\" flex><div flex>Socios activos</div><div>Total: {{vm.population.total|number}}\n</div></md-card-title><md-card-content layout=\"column\" layout-align=\"start start\" flex><canvas id=\"total-population\" \nclass=\"chart chart-doughnut\" chart-data=\"vm.population.data\" chart-labels=\"vm.population.labels\" \nchart-options=\"vm.population.options\"></canvas></md-card-content></md-card><md-card flex><md-card-title class=\"h2\">\nDeudores por tipo</md-card-title><md-card-content layout=\"column\" layout-align=\"start start\" flex><canvas id=\"debts\" \nclass=\"chart chart-pie\" chart-data=\"vm.debts.data\" chart-labels=\"vm.debts.labels\" chart-options=\"vm.debts.options\">\n</canvas></md-card-content></md-card></div><div layout=\"row\" layout-align=\"top start\" flex><md-card flex><md-card-title\n class=\"h2\" fxlayout=\"row\" fxlayoutalign=\"space-between center\" flex><div flex>Socios activos por edad</div><div>\nTotal: {{vm.byage.total|number}}</div></md-card-title><md-card-content layout=\"column\" layout-align=\"start start\" flex>\n<canvas id=\"age\" class=\"chart chart-pie\" chart-data=\"vm.byage.data\" chart-labels=\"vm.byage.labels\" \nchart-options=\"vm.byage.options\"></canvas></md-card-content></md-card><md-card flex><md-card-title class=\"h2\" \nfxlayout=\"row\" fxlayoutalign=\"space-between center\" flex><div flex>Socios por genero</div><div>\nTotal: {{vm.bygender.total|number}}</div></md-card-title><md-card-content layout=\"column\" layout-align=\"start start\" \nflex><canvas id=\"gender\" class=\"chart chart-doughnut\" chart-data=\"vm.bygender.data\" chart-labels=\"vm.bygender.labels\" \nchart-options=\"vm.bygender.options\"></canvas></md-card-content></md-card></div></div></div></div>");
$templateCache.put("app/main/reports/views/selector/selector.html","<div id=\"report-groups\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1 no-padding\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Selección de reportes</span>\n</div></div><div><md-button class=\"md-button md-raised\" ng-click=\"vm.generate()\" aria-label=\"generate\" \nng-disabled=\"!vm.selectedGroup.id || !vm.selectedReport.id || paramsForm.$invalid || vm.generating\"><span \nng-show=\"!vm.generating\">Generar reporte</span> <span ng-show=\"vm.generating\">Generando...</span></md-button></div>\n</div><div class=\"content-card\" layout=\"row\" flex><div class=\"content fullpage-datatable no-padding\" layout=\"column\" \nflex><div layout=\"row\" layout-align=\"center start\" flex><md-card flex=\"30\"><md-card-content layout=\"column\" \nlayout-align=\"start start\" flex class=\"no-padding\"><h2 class=\"p-15 pb-0\">Grupos</h2><table \nclass=\"dataTable row-border border\"><thead><tr><th>Grupo</th><th class=\"text-center w-80\">No Reportes</th></tr></thead>\n<tbody><tr cd-custom-grid=\"item in vm.groups | itemsPerPage: (8)\" pagination-id=\"groupsPaginator\" class=\"selectable\" \nng-class=\"{\'selected\': vm.selectedGroup.id == item.id }\" ng-click=\"vm.selectedGroup = item\"><td>{{item.name}}</td><td \nclass=\"text-center\">{{item.reports.length}}</td></tr></tbody><tr><td colspan=\"2\"><dir-pagination-controls \npagination-id=\"groupsPaginator\"></dir-pagination-controls></td></tr></table></md-card-content></md-card><md-card \nflex=\"30\"><md-card-content layout=\"column\" class=\"no-padding\"><h2 class=\"p-15 pb-0\">Reportes</h2><table \nclass=\"dataTable row-border border\"><thead><tr><th>Reporte</th><th>Número</th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.selectedGroup.reports | itemsPerPage: (8)\" pagination-id=\"reportsPaginator\" \nclass=\"selectable\" ng-class=\"{\'selected\': vm.selectedReport.id == item.id }\" ng-click=\"vm.selectedReport = item\"><td>\n{{item.name}}</td><td>{{item.number}}</td></tr></tbody><tr><td colspan=\"2\"><dir-pagination-controls \npagination-id=\"reportsPaginator\"></dir-pagination-controls></td></tr></table></md-card-content></md-card><md-card \nflex=\"30\"><md-card-content layout=\"column\" ms-scroll><h2 class=\"p-15 pb-0\">Parametros</h2><label class=\"description\">\n{{vm.selectedReport.description}}</label><form name=\"paramsForm\" layout=\"column\"><div \nng-repeat=\"param in vm.selectedReport.parameters\"><md-input-container class=\"md-block mb-0\" ng-if=\"param.type == 1\">\n<label>{{param.label}}</label><input type=\"text\" ng-name=\"param.id\" ng-model=\"param.value\" \nng-required=\"param.isRequired\"></md-input-container><md-input-container class=\"md-block mb-0\" ng-if=\"param.type == 2\">\n<label>{{param.label}}</label><input type=\"number\" ng-name=\"param.id\" ng-model=\"param.value\" \nng-required=\"param.isRequired\"></md-input-container><md-input-container class=\"md-block\" ng-if=\"param.type == 3\">\n<label>{{param.label}}</label><md-datepicker ng-init=\"vm.value = new Date()\" ng-model=\"vm.value\" \nng-change=\"param.value = vm.value\" md-placeholder=\"Seleccione\" md-hide-icons=\"calendar\" md-current-view=\"month\" \nng-required=\"param.isRequired\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" \nng-if=\"param.type == 4\"><md-checkbox ng-model=\"param.value\">{{param.label}}</md-checkbox></md-input-container>\n<cd-date-folio ng-model=\"param.value\" ng-if=\"param.type == 5\"></cd-date-folio><md-input-container class=\"md-block\" \nflex ng-if=\"param.type == 6\"><label>{{param.label}}</label><md-select name=\"branches\" ng-model=\"param.value\" \nmultiple=\"multiple\" ng-required=\"param.isRequired\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.branches | filter: { active: true }\">{{ item.name }}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex ng-if=\"param.type == 7\"><label>{{param.label}}</label><md-select \nname=\"users\" ng-model=\"vm.selectedUsers\" multiple=\"multiple\" ng-required=\"param.isRequired\" \nng-change=\"param.value = vm.selectedUsers\"><md-button \nng-click=\"vm.usersSelectUnselectAll(); param.value = vm.selectedUsers\"><span \nng-if=\"vm.selectedUsers.length != vm.users.length\">Seleccionar todos</span> <span \nng-if=\"vm.selectedUsers.length == vm.users.length\">Quitar seleccion</span></md-button><md-option ng-value=\"item\" \nng-repeat=\"item in vm.users | filter: { active: true }\">{{ item.name }} {{ item.fatherLastname }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex ng-if=\"param.type == 8\"><label>Metodo\n</label><md-select name=\"orderType\" ng-model=\"param.value\" required><md-option ng-value=\"item\" \nng-repeat=\"item in vm.orderTypes\">{{ item.name }}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex ng-if=\"param.type == 9\"><label>Despliegue</label><md-select name=\"viewMode\" \nng-model=\"param.value\" required><md-option ng-value=\"item\" ng-repeat=\"item in vm.viewModes\">{{ item.name }}</md-option>\n</md-select></md-input-container><cd-report-dates-range ng-model=\"param.value\" ng-if=\"param.type == 10\">\n</cd-report-dates-range><md-input-container class=\"md-block\" flex ng-if=\"param.type == 11\"><label>{{param.label}}\n</label><md-select name=\"products\" ng-model=\"vm.selectedProducts\" multiple=\"multiple\" ng-required=\"param.isRequired\" \nng-change=\"param.value = vm.selectedProducts\"><md-button \nng-click=\"vm.productSelectUnselectAll(); param.value = vm.selectedProducts\"><span \nng-if=\"vm.selectedProducts.length != vm.products.length\">Seleccionar todos</span> <span \nng-if=\"vm.selectedProducts.length == vm.products.length\">Quitar seleccion</span></md-button><md-option ng-value=\"item\" \nng-repeat=\"item in vm.products | filter: { active: true }\">{{ item.name }}</md-option></md-select></md-input-container>\n<cd-report-date-period ng-model=\"param.value\" periodicities=\"vm.periodicities\" ng-if=\"param.type == 12\">\n</cd-report-date-period><md-input-container class=\"md-block\" flex ng-if=\"param.type == 13\"><label>Status</label>\n<md-select name=\"statusVigente\" ng-model=\"param.value\" required><md-option ng-value=\"item\" \nng-repeat=\"item in vm.statusVigente\">{{ item.name }}</md-option></md-select></md-input-container><cd-report-age-ranges \nng-model=\"param.value\" ng-if=\"param.type == 14\"></cd-report-age-ranges><md-input-container class=\"md-block\" flex \nng-if=\"param.type == 15\"><label>{{param.label}}</label><md-select name=\"sellers\" ng-model=\"param.value\" \nng-required=\"param.isRequired\"><md-option ng-value=\"{{0}}\">TODOS</md-option><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.employees | filter: { active: true, employeeTypeId: 1 } | orderBy: \'completeName\'\">\n{{ item.completeName }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"param.type == 16\"><label>{{param.label}}</label><md-select name=\"paymentMethods\" ng-model=\"param.value\" \nng-required=\"param.isRequired\" ng-change=\"vm.paymentMethodChange(param.value)\"><md-option ng-value=\"{{0}}\">TODOS\n</md-option><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.paymentMethods | filter: { active: true }\">\n{{ item.name }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"param.type == 17\"><label>{{param.label}}</label><md-select name=\"paymentMethodOptions\" ng-model=\"param.value\" \nng-disabled=\"!vm.pmid || vm.pmid == 0\"><md-option ng-value=\"{{0}}\">TODOS</md-option><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.paymentMethodOptions | filter: { active: true, paymentMethodId: vm.pmid } | orderBy: \'name\'\">\n{{ item.name }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"param.type == 18\"><label>{{param.label}}</label><md-select name=\"partners\" ng-model=\"param.value\" \nng-required=\"param.isRequired\"><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.partners | filter: { isFamily: false } | orderBy: \'completeName\'\">{{ item.completeName }}\n</md-option></md-select></md-input-container><cd-partners-range ng-model=\"param.value\" ng-if=\"param.type == 19\">\n</cd-partners-range><md-input-container class=\"md-block\" flex ng-if=\"param.type == 20\" ng-model=\"vm.selectedDues\" \nng-change=\"param.value = vm.selectedDues\"><label>{{param.label}}</label><md-select name=\"due\" ng-model=\"param.value\" \nmultiple=\"multiple\" ng-required=\"param.isRequired\"><md-button \nng-click=\"vm.dueSelectUnselectAll(); param.value = vm.selectedDues\"><span \nng-if=\"vm.selectedDues.length != vm.dues.length\">Seleccionar todos</span> <span \nng-if=\"vm.selectedDues.length == vm.dues.length\">Quitar seleccion</span></md-button><md-option ng-value=\"item\" \nng-repeat=\"item in vm.dues | filter: { active: true, branchId: vm.branch.id }\">{{ item.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex ng-if=\"param.type == 21\"><label>{{param.label}}</label>\n<md-select name=\"include\" ng-model=\"param.value\" required><md-option ng-value=\"item\" ng-repeat=\"item in vm.include\">\n{{ item.name }}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"param.type == 22\"><label>{{param.label}}</label><md-select name=\"convenio\" ng-model=\"param.value\" \nng-required=\"param.isRequired\"><md-option ng-value=\"{{0}}\">TODOS</md-option><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.agreements | filter: { active: true, branchId: vm.branch.id } | orderBy: \'name\'\">{{ item.name }}\n</md-option></md-select></md-input-container></div></form></md-card-content></md-card></div></div></div></div></div>");
$templateCache.put("app/main/reports/views/tst/tst.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><button ng-click=\"vm.print()\">Imprimir</button><div \nclass=\"report-container\" id=\"printable\"><div class=\"card md-whiteframe-8dp\"><div class=\"header\"><div \nclass=\"invoice-date\">{{vm.invoice.date}}</div><div layout=\"row\" layout-align=\"space-between stretch\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE PRUEBA</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\">No de socios</span></div><div class=\"info\"><div class=\"title\">\nLorem Ipsum es simplemente el texto de relleno de las</div></div></div><div class=\"issuer\" layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div>\n</div></div></div><div class=\"content\"><table class=\"simple report-table\"><thead><th>Credencial</th><th>Familia</th>\n<th>Nombre</th><th>Cuota</th></thead><tbody><tr ng-repeat=\"item in vm.data\"><td>{{item.credentialCode}}</td><td>\n{{item.sequentialNumber}}</td><td>{{item.name}}</td><td>{{item.dueName}}</td></tr><tr ng-repeat=\"item in vm.data\"><td>\n{{item.credentialCode}}</td><td>{{item.sequentialNumber}}</td><td>{{item.name}}</td><td>{{item.dueName}}</td></tr><tr \nng-repeat=\"item in vm.data\"><td>{{item.credentialCode}}</td><td>{{item.sequentialNumber}}</td><td>{{item.name}}</td>\n<td>{{item.dueName}}</td></tr></tbody></table><table class=\"simple report-table-footer\"><tbody><tr class=\"subtotal\">\n<td>No Registros</td><td>{{vm.data.length}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\" width=\"120\"></div><div \nclass=\"small-note\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/main/catalogs/views/accessTimeZones/accessTimeZone/accessTimeZone.html","<div id=\"access-time-zone\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-return-button md-icon-button\" aria-label=\"Ir a clientes\" \nng-click=\"vm.gotoReturn()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.item.name}}</div><div \nclass=\"subtitle secondary-text\"><span>Detalle de Horario de Acceso</span></div></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" ng-disabled=\"!detailForm.$valid\"><span>GUARDAR</span></md-button>\n</div></div><div class=\"content\"><div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><form \nname=\"detailForm\" layout=\"row\"><div layout=\"column\" flex=\"40\"><md-input-container class=\"md-block\" flex-1><label>Nombre\n</label><input type=\"text\" name=\"name\" ng-model=\"vm.item.name\" required md-autofocus><div \nng-messages=\"detailForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese nombre(s).</span></div>\n</div></md-input-container><div layout-md=\"row\" flex><md-input-container class=\"md-block\"><label>Panel</label><input \ntype=\"text\" name=\"panel\" ng-model=\"vm.item.panel\" required><div ng-messages=\"detailForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Panel.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex-1><md-checkbox ng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div></div><div \nlayout=\"column\" flex=\"60\"><div layout=\"row\" layout-align=\"center center\"><table \nclass=\"dataTable row-border border w-300\" flex><thead><tr><th class=\"text-align-center w-50\">Día</th><th \nclass=\"text-align-center w-50\">Hora Inicio</th><th class=\"text-align-center w-50\">Hora Fin</th></tr></thead><tbody><tr>\n<td><md-checkbox ng-model=\"vm.item.isMonday\">Lunes</md-checkbox></td><td><input type=\"text\" \nng-model=\"vm.item.mondayInitHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.item.isMonday\"></td><td><input type=\"text\" \nng-model=\"vm.item.mondayEndHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.item.isMonday\"></td></tr><tr><td><md-checkbox\n ng-model=\"vm.item.isTuesday\">Martes</md-checkbox></td><td><input type=\"text\" ng-model=\"vm.item.tuesdayInitHour\" \nclass=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.item.isTuesday\"></td><td><input type=\"text\" ng-model=\"vm.item.tuesdayEndHour\" \nclass=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.item.isTuesday\"></td></tr><tr><td><md-checkbox ng-model=\"vm.item.isWednesday\">\nMiercoles</md-checkbox></td><td><input type=\"text\" ng-model=\"vm.item.wednesdayInitHour\" class=\"hour\" ui-mask=\"99:99\" \nng-show=\"vm.item.isWednesday\"></td><td><input type=\"text\" ng-model=\"vm.item.wednesdayEndHour\" class=\"hour\" \nui-mask=\"99:99\" ng-show=\"vm.item.isWednesday\"></td></tr><tr><td><md-checkbox ng-model=\"vm.item.isThursday\">Jueves\n</md-checkbox></td><td><input type=\"text\" ng-model=\"vm.item.thursdayInitHour\" class=\"hour\" ui-mask=\"99:99\" \nng-show=\"vm.item.isThursday\"></td><td><input type=\"text\" ng-model=\"vm.item.thursdayEndHour\" class=\"hour\" \nui-mask=\"99:99\" ng-show=\"vm.item.isThursday\"></td></tr><tr><td><md-checkbox ng-model=\"vm.item.isFriday\">Viernes\n</md-checkbox></td><td><input type=\"text\" ng-model=\"vm.item.fridayInitHour\" class=\"hour\" ui-mask=\"99:99\" \nng-show=\"vm.item.isFriday\"></td><td><input type=\"text\" ng-model=\"vm.item.fridayEndHour\" class=\"hour\" ui-mask=\"99:99\" \nng-show=\"vm.item.isFriday\"></td></tr><tr><td><md-checkbox ng-model=\"vm.item.isSaturday\">Sabado</md-checkbox></td><td>\n<input type=\"text\" ng-model=\"vm.item.saturdayInitHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.item.isSaturday\"></td>\n<td><input type=\"text\" ng-model=\"vm.item.saturdayEndHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.item.isSaturday\">\n</td></tr><tr><td><md-checkbox ng-model=\"vm.item.isSunday\">Domingo</md-checkbox></td><td><input type=\"text\" \nng-model=\"vm.item.sundayInitHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.item.isSunday\"></td><td><input type=\"text\" \nng-model=\"vm.item.sundayEndHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.item.isSunday\"></td></tr></tbody></table>\n</div></div></form></div></div></div>");
$templateCache.put("app/main/catalogs/views/activities/activities/activities.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Actividades</span></div><div \nclass=\"product-count secondary-text\"><span>No de actividades:</span> <span>{{vm.activities.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.add()\"><span>Nuevo</span>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text w-70\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text w-120\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.activities\"><td>{{item.id}}</td><td>{{item.name}}</td><td><i ng-show=\"item.active\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-show=\"!item.active\" class=\"icon-cancel red-500-fg\"></i>\n</td><td><md-button class=\"md-icon-button hide show-gt-xs\" ng-click=\"vm.openDetail(item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.deleteItem(item, $event)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/activities/activity/activity.html","<div id=\"product\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Ir a productes\" ng-click=\"vm.returnBack()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.item.name}}</div><div class=\"subtitle secondary-text\">\n<span>Detalle de Actividad</span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.save()\" ng-disabled=\"!detailForm.$valid\"><span>GUARDAR</span></md-button></div></div><div \nclass=\"content no-padding\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span>Información principal</span>\n</md-tab-label><md-tab-body><form name=\"detailForm\" id=\"detailForm\" class=\"md-inline-form p-15 pt-25\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block mb-0\" flex><label>Nombre</label><input ng-model=\"vm.item.name\" \nname=\"name\" type=\"text\" required><div ng-messages=\"detailForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Ingrese Nombre.</span></div></div></md-input-container><md-input-container class=\"md-block mt-0\" flex>\n<md-checkbox class=\"m-0\" ng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div></form></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.item && vm.item.id > 0\"><md-tab-label><span>Horarios</span></md-tab-label><md-tab-body \nclass=\"no-padding\"><div><div layout-gt-sm=\"row\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-button md-accent-bg\" ng-click=\"vm.scheduleAdd($event)\">Nuevo</md-button></div><table \nclass=\"dataTable row-border hover border\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Horario</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Instructor</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Lunes</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Martes</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Miercoles</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Jueves</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Viernes</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Sabado</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Domingo</span></div></th><th class=\"w-120\"></th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.schedules | itemsPerPage: (4)\"><td>{{item.name}}</td><td>\n{{item.employee.name}} {{item.employee.fatherLastname}} {{item.employee.motherLastname}}</td><td><div \nng-if=\"item.isMonday\"><span>\n{{item.mondayInitHour.substr(0,2)}}:{{item.mondayInitHour.substr(2,2)}} - {{item.mondayEndHour.substr(0,2)}}:{{item.mondayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isTuesday\"><span>\n{{item.tuesdayInitHour.substr(0,2)}}:{{item.tuesdayInitHour.substr(2,2)}} - {{item.tuesdayEndHour.substr(0,2)}}:{{item.tuesdayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isWednesday\"><span>\n{{item.wednesdayInitHour.substr(0,2)}}:{{item.wednesdayInitHour.substr(2,2)}} - {{item.wednesdayEndHour.substr(0,2)}}:{{item.wednesdayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isThursday\"><span>\n{{item.thursdayInitHour.substr(0,2)}}:{{item.thursdayInitHour.substr(2,2)}} - {{item.thursdayEndHour.substr(0,2)}}:{{item.thursdayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isFriday\"><span>\n{{item.fridayInitHour.substr(0,2)}}:{{item.fridayInitHour.substr(2,2)}} - {{item.fridayEndHour.substr(0,2)}}:{{item.fridayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isSaturday\"><span>\n{{item.saturdayInitHour.substr(0,2)}}:{{item.saturdayInitHour.substr(2,2)}} - {{item.saturdayEndHour.substr(0,2)}}:{{item.saturdayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isSunday\"><span>\n{{item.sundayInitHour.substr(0,2)}}:{{item.sundayInitHour.substr(2,2)}} - {{item.sundayEndHour.substr(0,2)}}:{{item.sundayEndHour.substr(2,2)}}\n</span></div></td><td><md-button class=\"md-icon-button hide show-gt-xs\" ng-click=\"vm.scheduleEdit(item, $event)\" \naria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-icon-button hide show-gt-xs\" ng-click=\"vm.scheduleDelete(item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody><tr><td colspan=\"10\"><dir-pagination-controls>\n</dir-pagination-controls></td></tr></table></div></md-tab-body></md-tab></md-tabs></div></div><div \nstyle=\"visibility: hidden\"><div class=\"md-dialog-container\" id=\"detail-dialog-schedule\"><md-dialog \nclass=\"catalogs-dialog-detail\"><form name=\"scheduleForm\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nHORARIO</span><md-button class=\"md-icon-button\" ng-click=\"vm.scheduleAddCancel()\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"no-padding\"><div\n layout=\"row\" flex><div layout=\"column\" flex=\"50\" class=\"mb-0 p-10\"><div layout=\"row\"><md-input-container \nclass=\"md-block mb-0\" flex><label>Nombre</label><input type=\"text\" ng-model=\"vm.schedule.name\" name=\"employee\" \nrequired><div ng-messages=\"scheduleForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese nombre.\n</span></div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block mb-0\" flex><label>Seleccione Instructor</label><md-select ng-model=\"vm.schedule.employeeId\" \nname=\"employee\"><md-option ng-value=\"{{null}}\">SIN INSTRUCTOR</md-option><md-option ng-repeat=\"item in vm.employees\" \nng-value=\"item.id\">{{item.name}} {{item.fatherLastname}} {{item.motherLastname}}</md-option></md-select>\n</md-input-container><md-checkbox ng-model=\"vm.schedule.isQuotaRequired\" flex-1 class=\"mt-15 mb-0\">Req. Cupo\n</md-checkbox></div><div layout=\"row\" ms-scroll class=\"mt-20\"><table class=\"dataTable zones border row-border\"><thead>\n<tr><th>Ubicaciones</th><th>Cupo</th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.zones | filter: {active: true}  | itemsPerPage: (4)\" pagination-id=\"zonesPaginator\"><td>\n<md-checkbox ng-model=\"item.selected\">{{item.name}}</md-checkbox></td><td><input type=\"number\" ng-model=\"item.quota\" \nclass=\"quota\" ng-if=\"item.selected && vm.schedule.isQuotaRequired\" required min=\"1\"></td></tr></tbody><tr><td \ncolspan=\"2\"><dir-pagination-controls pagination-id=\"zonesPaginator\"></dir-pagination-controls></td></tr></table></div>\n</div><div layout=\"column\" flex=\"50\" class=\"mb-0 p-10\"><div layout-gt-sm=\"row\" class=\"mt-15\" \nlayout-align=\"center start\"><table class=\"dataTable row-border border w-350\" flex><thead><tr><th \nclass=\"text-align-center w-80\">Día</th><th class=\"text-align-center w-80\">Hora Inicio</th><th \nclass=\"text-align-center w-80\">Hora Fin</th></tr></thead><tbody><tr><td><md-checkbox ng-model=\"vm.schedule.isMonday\">\nLunes</md-checkbox></td><td><input type=\"text\" ng-model=\"vm.schedule.mondayInitHour\" class=\"hour\" ui-mask=\"99:99\" \nng-show=\"vm.schedule.isMonday\"></td><td><input type=\"text\" ng-model=\"vm.schedule.mondayEndHour\" class=\"hour\" \nui-mask=\"99:99\" ng-show=\"vm.schedule.isMonday\"></td></tr><tr><td><md-checkbox ng-model=\"vm.schedule.isTuesday\">Martes\n</md-checkbox></td><td><input type=\"text\" ng-model=\"vm.schedule.tuesdayInitHour\" class=\"hour\" ui-mask=\"99:99\" \nng-show=\"vm.schedule.isTuesday\"></td><td><input type=\"text\" ng-model=\"vm.schedule.tuesdayEndHour\" class=\"hour\" \nui-mask=\"99:99\" ng-show=\"vm.schedule.isTuesday\"></td></tr><tr><td><md-checkbox ng-model=\"vm.schedule.isWednesday\">\nMiercoles</md-checkbox></td><td><input type=\"text\" ng-model=\"vm.schedule.wednesdayInitHour\" class=\"hour\" \nui-mask=\"99:99\" ng-show=\"vm.schedule.isWednesday\"></td><td><input type=\"text\" ng-model=\"vm.schedule.wednesdayEndHour\" \nclass=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isWednesday\"></td></tr><tr><td><md-checkbox \nng-model=\"vm.schedule.isThursday\">Jueves</md-checkbox></td><td><input type=\"text\" \nng-model=\"vm.schedule.thursdayInitHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isThursday\"></td><td><input \ntype=\"text\" ng-model=\"vm.schedule.thursdayEndHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isThursday\"></td>\n</tr><tr><td><md-checkbox ng-model=\"vm.schedule.isFriday\">Viernes</md-checkbox></td><td><input type=\"text\" \nng-model=\"vm.schedule.fridayInitHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isFriday\"></td><td><input \ntype=\"text\" ng-model=\"vm.schedule.fridayEndHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isFriday\"></td></tr>\n<tr><td><md-checkbox ng-model=\"vm.schedule.isSaturday\">Sabado</md-checkbox></td><td><input type=\"text\" \nng-model=\"vm.schedule.saturdayInitHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isSaturday\"></td><td><input \ntype=\"text\" ng-model=\"vm.schedule.saturdayEndHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isSaturday\"></td>\n</tr><tr><td><md-checkbox ng-model=\"vm.schedule.isSunday\">Domingo</md-checkbox></td><td><input type=\"text\" \nng-model=\"vm.schedule.sundayInitHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isSunday\"></td><td><input \ntype=\"text\" ng-model=\"vm.schedule.sundayEndHour\" class=\"hour\" ui-mask=\"99:99\" ng-show=\"vm.schedule.isSunday\"></td></tr>\n</tbody></table></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" class=\"md-button md-raised md-accent h-40 mt-20\" ng-click=\"vm.scheduleSave()\" \nng-disabled=\"!scheduleForm.$valid\" flex-1>Guardar</md-button><md-button class=\"md-button md-raised md-warn h-40 mt-20\" \nng-click=\"vm.scheduleAddCancel()\" flex-1>Cancelar</md-button></md-dialog-actions></form></md-dialog></div></div>");
$templateCache.put("app/main/catalogs/views/accessTimeZones/accessTimeZones/accessTimeZones.html","<div id=\"time-zones\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Horarios de Acceso</span></div><div \nclass=\"product-count secondary-text\"><span>No de horarios:</span> <span>{{vm.accessTimeZones.length}}</span></div>\n</div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAdd()\"><span>Nuevo\n</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtAccessTimeZoneInstance\" dt-options=\"vm.dtAccessTimeZoneOptions\"><thead><tr><th \nclass=\"secondary-text w-30\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Lunes</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Martes</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Miercoles</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Jueves</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Viernes</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Sabado</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Domingo</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.accessTimeZones\"><td>{{item.id}}</td><td>{{item.name}}</td><td><div \nng-if=\"item.isMonday\"><span>\n{{item.mondayInitHour.substr(0,2)}}:{{item.mondayInitHour.substr(2,2)}} - {{item.mondayEndHour.substr(0,2)}}:{{item.mondayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isTuesday\"><span>\n{{item.tuesdayInitHour.substr(0,2)}}:{{item.tuesdayInitHour.substr(2,2)}} - {{item.tuesdayEndHour.substr(0,2)}}:{{item.tuesdayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isWednesday\"><span>\n{{item.wednesdayInitHour.substr(0,2)}}:{{item.wednesdayInitHour.substr(2,2)}} - {{item.wednesdayEndHour.substr(0,2)}}:{{item.wednesdayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isThursday\"><span>\n{{item.thursdayInitHour.substr(0,2)}}:{{item.thursdayInitHour.substr(2,2)}} - {{item.thursdayEndHour.substr(0,2)}}:{{item.thursdayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isFriday\"><span>\n{{item.fridayInitHour.substr(0,2)}}:{{item.fridayInitHour.substr(2,2)}} - {{item.fridayEndHour.substr(0,2)}}:{{item.fridayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isSaturday\"><span>\n{{item.saturdayInitHour.substr(0,2)}}:{{item.saturdayInitHour.substr(2,2)}} - {{item.saturdayEndHour.substr(0,2)}}:{{item.saturdayEndHour.substr(2,2)}}\n</span></div></td><td><div ng-if=\"item.isSunday\"><span>\n{{item.sundayInitHour.substr(0,2)}}:{{item.sundayInitHour.substr(2,2)}} - {{item.sundayEndHour.substr(0,2)}}:{{item.sundayEndHour.substr(2,2)}}\n</span></div></td><td><i ng-if=\"item.active\" class=\"icon-checkbox-marked-circle green-500-fg\"></i> <i \nng-if=\"!item.active\" class=\"icon-cancel red-500-fg\"></i></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoDetail(item.id)\" aria-label=\"Detalles de usuario\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/dues/due/due.html","<div id=\"product\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Ir a productes\" ng-click=\"vm.returnBack()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.item.name}}</div><div class=\"subtitle secondary-text\">\n<span>Detalle de Cuota</span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.save()\" ng-disabled=\"detailForm.$invalid\"><span>GUARDAR</span></md-button></div></div><div \nclass=\"content no-padding\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span>Información de Cuota</span>\n</md-tab-label><md-tab-body><form name=\"detailForm\" id=\"detailForm\" class=\"md-inline-form p-15 pt-25\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block mb-0\" flex><label>Nombre</label><input ng-model=\"vm.item.name\" \nname=\"name\" type=\"text\" required><div ng-messages=\"detailForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Ingrese Nombre.</span></div></div></md-input-container><div flex=\"30\"><md-radio-group \nng-model=\"vm.item.isTitular\" ng-change=\"vm.item.isFamiliar = !vm.item.isTitular\"><md-radio-button ng-value=\"{{true}}\" \naria-label=\"titularOption\">Para Titular</md-radio-button><md-radio-button ng-value=\"{{false}}\" \naria-label=\"familiarOption\">Para Familiar</md-radio-button></md-radio-group></div><md-input-container \nclass=\"md-block mt-0\" flex-1><md-checkbox ng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div><div\n layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Edad mínima</label><input type=\"number\" \nname=\"minAge\" ng-model=\"vm.item.minAge\" min=\"0\" max=\"150\" required><div ng-messages=\"detailForm.minAge.$error\" \nmultiple=\"multiple\"><div ng-message=\"required\">Dato requerido</div><div ng-message=\"number\">El valor debe ser numerico\n</div><div ng-message=\"min\">Valor demasiado pequeño</div><div ng-message=\"max\">Valor demasiado grande</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Edad máxima</label><input type=\"number\" \nname=\"maxAge\" ng-model=\"vm.item.maxAge\" min=\"0\" max=\"150\" required><div ng-messages=\"detailForm.minAge.$error\" \nmultiple=\"multiple\"><div ng-message=\"required\">Dato requerido</div><div ng-message=\"number\">El valor debe ser numerico\n</div><div ng-message=\"min\">Valor demasiado pequeño</div><div ng-message=\"max\">Valor demasiado grande</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex ng-if=\"vm.item.isTitular\"><label>No mínimo de familiares\n</label><input type=\"number\" name=\"familiarMinNumber\" ng-model=\"vm.item.familiarMinNumber\" min=\"0\" max=\"100\" required>\n<div ng-messages=\"detailForm.familiarMinNumber.$error\" multiple=\"multiple\"><div ng-message=\"required\">Dato requerido\n</div><div ng-message=\"number\">El valor debe ser numerico</div><div ng-message=\"min\">Valor demasiado pequeño</div><div \nng-message=\"max\">Valor demasiado grande</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"vm.item.isTitular\"><label>No máximo de familiares</label><input type=\"number\" name=\"familiarMaxNumber\" \nng-model=\"vm.item.familiarMaxNumber\" min=\"0\" required><div ng-messages=\"detailForm.familiarMaxNumber.$error\" \nmultiple=\"multiple\"><div ng-message=\"required\">Dato requerido</div><div ng-message=\"number\">El valor debe ser numerico\n</div><div ng-message=\"min\">Valor demasiado pequeño</div><div ng-message=\"max\">Valor demasiado grande</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Tipo de socio</label><md-select \nng-model=\"vm.item.partnerTypeId\" name=\"partnerType\" required><md-option \nng-repeat=\"opt in vm.partnerTypes | filter: { active: true }\" ng-value=\"opt.id\">{{opt.name}}</md-option></md-select>\n<div ng-messages=\"detailForm.partnerType.$error\" multiple=\"multiple\"><div ng-message=\"required\">Dato requerido</div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><cd-sat-select label=\"Unidad del SAT\" api-list=\"units\" \nmd-selected-item=\"vm.item.satUnit\" required flex></cd-sat-select><cd-sat-select label=\"Producto del SAT\" \napi-list=\"products\" md-selected-item=\"vm.item.satProduct\" required flex></cd-sat-select><md-input-container \nclass=\"md-block\" flex><label>Cuenta Contable</label><md-select ng-model=\"vm.item.accountId\" name=\"accountId\"><md-option\n ng-repeat=\"opt in vm.accounts | filter: { active: true }\" ng-value=\"opt.id\">{{opt.name}} - {{opt.code}}</md-option>\n</md-select></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>\nImpuesto</label><md-select ng-model=\"vm.item.satTaxId\" name=\"satTaxId\" required><md-option \nng-repeat=\"item in vm.satTaxes\" ng-value=\"item.id\">[{{item.code}}] {{item.description}}</md-option></md-select><div \nng-messages=\"detailForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Tipo de Impuesto</label>\n<md-select ng-model=\"vm.item.satTaxTypeId\" name=\"satTaxTypeId\" required><md-option ng-repeat=\"item in vm.satTaxTypes\" \nng-value=\"item.id\">[{{item.code}}] {{item.description}}</md-option></md-select><div \nng-messages=\"detailForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Valor de impuesto</label>\n<input type=\"text\" name=\"satTaxValue\" ng-model=\"vm.item.satTaxValue\" required><div \nng-messages=\"detailForm.satTaxValue.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Valor de Impuesto del SAT.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-if=\"vm.item && vm.item.id > 0\"><md-tab-label><span>Precios</span></md-tab-label><md-tab-body \nclass=\"no-padding\"><div><div layout-gt-sm=\"row\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-button md-accent-bg\" ng-click=\"vm.showPrices($event, vm.item.id)\">Nuevo</md-button></div><table \nclass=\"dataTable row-border hover border\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Vigencia</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Interes</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Dias de gracia</span></div></th><th class=\"w-120\"></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.prices | orderBy: \'validFrom\' : true\"><td>\n{{item.validFrom | date : \'dd/MM/yyyy\'}} - {{item.validTo | date : \'dd/MM/yyyy\'}}</td><td>{{item.interes}}</td><td>\n{{item.daysOfGrace}}</td><td><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.showPrices($event, item.dueId, item.priceGroupId)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.priceDelete(item.priceGroupId)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></td></tr></tbody></table></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/catalogs/views/dues/dues/dues.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Cuotas</span></div><div class=\"product-count secondary-text\">\n<span>No de cuotas:</span> <span>{{vm.dues.length}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input id=\"keyword-search\" class=\"search-input\" type=\"text\" placeholder=\"Buscar\" flex></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.add()\"><span>Nuevo</span></md-button></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable no-padding\" layout=\"column\" flex>\n<table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead>\n<tr><th class=\"secondary-text w-30\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th \nclass=\"secondary-text w-60\"><div class=\"table-header\"><span class=\"column-title\">Tipo</span></div></th><th \nclass=\"secondary-text w-40\"><div class=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th \nclass=\"secondary-text w-120\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.dues\"><td>{{item.id}}</td><td>{{item.name}}</td><td><i \nng-show=\"item.isTitular\" class=\"icon-account\"></i> <i ng-show=\"item.isFamiliar\" class=\"icon-account-multiple-plus\"></i>\n</td><td><i ng-show=\"item.active\" class=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-show=\"!item.active\" \nclass=\"icon-cancel red-500-fg\"></i></td><td><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.openDetail(item)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button\n class=\"md-icon-button hide show-gt-xs\" ng-click=\"vm.deleteItem(item, $event)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/conceptos-nota-credito/concepto-nota-credito/concepto-nota-credito.html","<div id=\"concepto-nota-credito\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" \nlayout-align=\"start center\" flex><md-button class=\"goto-products-button md-icon-button\" aria-label=\"Ir a productes\" \nng-click=\"vm.returnBack()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.item.name}}</div><div \nclass=\"subtitle secondary-text\"><span>Concepto de Nota de Crédito</span></div></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" ng-disabled=\"!detailForm.$valid || vm.saving\"><span \nng-show=\"vm.saving\">GUARDANDO...</span> <span ng-hide=\"vm.saving\">GUARDAR</span></md-button></div></div><div \nclass=\"content no-padding\"><form name=\"detailForm\" id=\"detailForm\" class=\"md-inline-form p-15 pt-25\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre</label><input type=\"text\" name=\"name\" \nng-model=\"vm.item.name\" required><div ng-messages=\"detailForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Ingrese nombre.</span></div></div></md-input-container><md-input-container class=\"md-block mt-0\" flex-1>\n<md-checkbox ng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div><div layout-gt-sm=\"row\">\n<cd-sat-select label=\"Unidad del SAT\" api-list=\"units\" md-selected-item=\"vm.item.satUnit\" required flex>\n</cd-sat-select><cd-sat-select label=\"Producto del SAT\" api-list=\"products\" md-selected-item=\"vm.item.satProduct\" \nrequired flex></cd-sat-select></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Impuesto\n</label><md-select ng-model=\"vm.item.satTaxId\" name=\"satTaxId\" required><md-option ng-repeat=\"item in vm.satTaxes\" \nng-value=\"item.id\">[{{item.code}}] {{item.description}}</md-option></md-select><div \nng-messages=\"detailForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Tipo de Impuesto</label>\n<md-select ng-model=\"vm.item.satTaxTypeId\" name=\"satTaxTypeId\" required><md-option ng-repeat=\"item in vm.satTaxTypes\" \nng-value=\"item.id\">[{{item.code}}] {{item.description}}</md-option></md-select><div \nng-messages=\"detailForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Valor de impuesto</label>\n<input type=\"text\" name=\"satTaxValue\" ng-model=\"vm.item.satTaxValue\" required><div \nng-messages=\"detailForm.satTaxValue.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Valor de Impuesto del SAT.</span></div></div></md-input-container></div></form></div></div>");
$templateCache.put("app/main/catalogs/views/conceptos-nota-credito/conceptos-nota-credito/conceptos-nota-credito.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Conceptos de Notas de Crédito</span></div><div \nclass=\"product-count secondary-text\"><span>No de conceptos:</span> <span>{{vm.conceptos.length}}</span></div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.add()\"><span>Nuevo</span>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtConceptosInstance\" dt-options=\"vm.dtConceptosOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th \nclass=\"secondary-text w-120\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.conceptos\"><td>{{item.id}}</td><td>{{item.name}}</td><td><i \nng-show=\"item.active\" class=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-show=\"!item.active\" \nclass=\"icon-cancel red-500-fg\"></i></td><td><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.detail(item)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button><md-button \nclass=\"md-icon-button hide show-gt-xs\" ng-click=\"vm.remove(item, $event)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/employees/employees/employees.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Empleados</span></div><div \nclass=\"product-count secondary-text\"><span>No de empleados:</span> <span>{{vm.employees.length}}</span></div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAdd()\"><span>Nuevo\n</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tipo de empleado</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.employees\"><td>{{item.id}}</td><td>{{item.completeName}}<div ng-if=\"item.user\"><span>\nUsr: {{item.user.username}}</span></div></td><td>{{item.employeeType.name}}<md-button class=\"md-icon-button\" \nng-if=\"item.employeeTypeId == 1\" ng-click=\"vm.showCalendar(item.id)\"><md-icon md-font-icon=\"icon-calendar\"></md-icon>\n<md-tooltip>Mostrar calendario</md-tooltip></md-button></td><td><i ng-show=\"item.active\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-hide=\"item.active\" class=\"icon-cancel red-500-fg\"></i></td>\n<td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.gotoDetail(item.id)\" aria-label=\"Detalles de empleado\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.delete(item)\" aria-label=\"Borrar empleado\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/employees/employee/employee.html","<div class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-return-button md-icon-button\" aria-label=\"Ir a clientes\" ng-click=\"vm.gotoReturn()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.item.name}} {{vm.item.fatherLastname}} {{vm.item.motherLastname}}</div><div class=\"subtitle secondary-text\"><span>\nDetalle de Empleado</span></div></div></div></div><div><md-button class=\"md-icon-button md-raised md-white\" \nng-if=\"vm.item.id && vm.item.id != 0 && vm.item.employeeTypeId == 1\" ng-click=\"vm.showCalendar()\"><md-icon \nmd-font-icon=\"icon-calendar\"></md-icon><md-tooltip>Mostrar calendario</md-tooltip></md-button><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\"><span>GUARDAR</span></md-button></div></div><div class=\"content\">\n<div class=\"detail-form-container md-background-bg md-whiteframe-1dp\"><form nombre=\"detailForm\" id=\"detailForm\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre(s)</label><input type=\"text\" \nnombre=\"nombre\" ng-model=\"vm.item.name\" required md-autofocus><div ng-messages=\"detailForm.nombre.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Ingrese nombre(s).</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Paterno</label><input type=\"text\" nombre=\"fatherLastname\" \nng-model=\"vm.item.fatherLastname\" required><div ng-messages=\"detailForm.fatherLastname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Apellido Paterno.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Materno</label><input type=\"text\" nombre=\"motherLastname\" \nng-model=\"vm.item.motherLastname\"></md-input-container><md-input-container class=\"md-block\" flex-1 \nng-show=\"vm.item.id && vm.item.id > 0\"><label>Código de credencial</label><input type=\"text\" \nng-model=\"vm.item.credentialCode\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm=\"33\" flex><label>Tipo de empleado</label><md-select name=\"employeeType\" \nng-model=\"vm.item.employeeTypeId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.employeeTypes | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"detailForm.employeeType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione tipo de empleado.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex flex-gt-sm=\"33\"><label>Usuario\n</label><md-select name=\"user\" ng-model=\"vm.item.userId\"><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.users | filter: { active: true }\">{{item.name}} {{item.fatherLastname}} {{item.motherLastname}}\n</md-option></md-select><div ng-messages=\"detailForm.user.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Usuario.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nFecha nacimiento</label><md-datepicker ng-init=\"vm.birthdate = (vm.item.birthdate | toDate)\" \nng-change=\"vm.item.birthdate = vm.birthdate\" ng-model=\"vm.birthdate\" name=\"birthdate\" required \nmd-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"year\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex layout-align=\"center center\"><label>Fecha de inicio</label><md-datepicker \nng-init=\"vm.startDate = (vm.item.startDate | toDate)\" ng-change=\"vm.item.startDate = vm.startDate\" \nng-model=\"vm.startDate\" name=\"startDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex-1><md-checkbox \nng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>RFC</label><input type=\"text\" name=\"rfc\" ng-model=\"vm.item.rfc\"></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Patron</label><input type=\"text\" name=\"patron\" \nng-model=\"vm.item.patron\"></md-input-container><md-input-container class=\"md-block\" flex><label>Nomina</label><input \ntype=\"text\" name=\"nomina\" ng-model=\"vm.item.nomina\"></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Codigo de percepción</label><input type=\"text\" name=\"perceptionCode\" ng-model=\"vm.item.perceptionCode\">\n</md-input-container></div></form></div></div></div>");
$templateCache.put("app/main/catalogs/views/productTypes/productType/productType.html","<div class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-return-button md-icon-button\" aria-label=\"Ir a clientes\" ng-click=\"vm.gotoReturn()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.item.name}}</div><div class=\"subtitle secondary-text\">\n<span>Detalle de Tipo de Producto</span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.save()\"><span>GUARDAR</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height>\n<md-tab><md-tab-label><span>Información de principal</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><form nombre=\"detailForm\" id=\"detailForm\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre(s)</label><input type=\"text\" nombre=\"name\" \nng-model=\"vm.item.name\" required><div ng-messages=\"detailForm.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Ingrese nombre de tipo.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<md-checkbox ng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div></form></div></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.item.id > 0\"><md-tab-label><span>Propiedades</span></md-tab-label><md-tab-body><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"p-15\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">\nPropiedades</div><md-button class=\"md-button md-accent-bg\" ng-click=\"vm.propertyAdd()\">Agregar</md-button></div><div \nclass=\"h-400\" ms-scroll><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text w-50\"></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Propiedad</span></div></th><th \nclass=\"secondary-text w-120\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.properties\"><td><md-checkbox class=\"mt-10\" ng-model=\"item.selected\">\n</md-checkbox></td><td>{{item.name}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.propertyEdit(item)\" aria-label=\"Detalles de propiedad\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip>Editar</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.propertyDelete(item)\" \naria-label=\"Borrar\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr>\n</tbody></table></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" \nng-show=\"vm.property\"><ms-widget-front class=\"white-bg\"><div class=\"p-15 border-bottom\" \nlayout-align=\"space-between center\"><div class=\"h2\">Nueva propiedad</div></div><div><form name=\"propertyForm\" \nclass=\"p-10 pb-0\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre de propiedad</label>\n<input type=\"text\" name=\"property\" ng-model=\"vm.property.name\" required \nng-disabled=\"!vm.property.isEditMode && vm.property.id != 0\"><div ng-messages=\"propertyForm.property.$error\" \nrole=\"alert\"><div ng-message=\"required\">Ingrese Propiedad.</div></div></md-input-container></div><div \nlayout-gt-sm=\"row\" layout-align=\"end center\" ng-show=\"vm.property && (vm.property.isEditMode || vm.property.id == 0)\">\n<md-button class=\"md-button md-accent-bg\" ng-click=\"vm.propertySave()\">GUARDAR PROPIEDAD</md-button></div></form></div>\n<div layout-gt-sm=\"row\" ng-hide=\"vm.property.id == 0\"><div flex-gt-sm=\"50\"><form name=\"optionForm\" class=\"p-10 pb-0\">\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Opción</label><input type=\"text\" \nname=\"option\" ng-model=\"vm.option.value\" required><div ng-messages=\"optionForm.option.$error\" role=\"alert\"><div \nng-message=\"required\">Ingrese opción.</div></div></md-input-container></div><div layout-gt-sm=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-button md-accent-bg\" ng-disabled=\"!optionForm.$valid\" \nng-click=\"vm.optionSave()\">GUARDAR OPCION</md-button></div></form></div><div flex-gt-sm=\"50\" ms-scroll class=\"h-250\">\n<table class=\"dataTable row-border border hover\"><thead><tr><th colspan=\"2\" class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Opciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"opt in vm.options\"><td>{{opt.value}}</td><td class=\"w-50\"><md-button class=\"md-icon-button\" \nng-click=\"vm.optionDelete(opt)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar opción</md-tooltip>\n</md-button></td></tr></tbody></table></div></div></ms-widget-front></ms-widget></div></md-tab-body></md-tab></md-tabs>\n</div></div>");
$templateCache.put("app/main/catalogs/views/productTypes/productTypes/productTypes.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Tipos de productos</span></div><div \nclass=\"product-count secondary-text\"><span>No de tipos:</span> <span>{{vm.productTypes.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAdd()\"><span>Nuevo\n</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.productTypes\"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{item.active}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.gotoDetail(item.id)\" aria-label=\"Detalles de empleado\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.delete(item)\" aria-label=\"Borrar empleado\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar\n</md-tooltip></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/products/product/product.html","<div id=\"product\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Ir a productes\" ng-click=\"vm.gotoProducts()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.product.name}}</div><div \nclass=\"subtitle secondary-text\"><span>Detalle de Producto</span></div></div></div></div><div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.save()\" ng-disabled=\"!productForm.$valid\"><span>GUARDAR</span></md-button>\n</div></div><div class=\"content\"><form id=\"productForm\" name=\"productForm\"><md-tabs md-dynamic-height><md-tab>\n<md-tab-label><span>Información de Producto</span></md-tab-label><md-tab-body><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp p-20\"><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Tipo de producto</label><md-select \nng-model=\"vm.product.productTypeId\" aria-label=\"Tipo de producto\" flex ng-show=\"!vm.product.isService\" \nng-change=\"vm.changeType()\" ng-required=\"!vm.product.isService\"><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.productTypes | filter: { active: true }\">{{ item.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Descripcion del producto</label><input \ntype=\"text\" ng-model=\"vm.product.name\" name=\"name\" required><div ng-messages=\"productForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Ingrese descripción del producto.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex-1><md-checkbox ng-model=\"vm.product.isGenerateCoupons\">Genera cupones?\n</md-checkbox></md-input-container></div><h3 class=\"mt-30\" style=\"margin-bottom: 47px\" ng-show=\"vm.loadingTemplate\">\nCargando...</h3><div ng-show=\"!vm.loadingTemplate\" dynamic-template ng-bind-html=\"vm.html\"></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block w-100\" flex><label>Costo</label><input type=\"text\" \nng-model=\"vm.product.cost\" name=\"cost\" required><div ng-messages=\"productForm.cost.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese costo del producto.</span></div></div></md-input-container><md-input-container \nclass=\"md-block w-200\" flex><label>Código</label><input type=\"text\" ng-model=\"vm.product.code\" name=\"code\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Código de barras</label><input type=\"text\" \nng-model=\"vm.product.barCode\" name=\"barcode\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nCódigo de proveedor</label><input type=\"text\" ng-model=\"vm.product.providerCode\" name=\"providerCode\">\n</md-input-container><md-input-container class=\"md-block\" flex-1><md-checkbox ng-model=\"vm.product.isStockRequired\">\nRequiere stock para venta?</md-checkbox></md-input-container><md-input-container class=\"md-block\" flex-1><md-checkbox \nng-model=\"vm.product.active\">Activo</md-checkbox></md-input-container></div><div layout-gt-sm=\"row\"><cd-sat-select \nlabel=\"Unidad del SAT\" api-list=\"units\" md-selected-item=\"vm.product.satUnit\" required flex></cd-sat-select>\n<cd-sat-select label=\"Producto del SAT\" api-list=\"products\" md-selected-item=\"vm.product.satProduct\" required flex>\n</cd-sat-select><md-input-container class=\"md-block\" flex><label>Cuenta Contable</label><md-select \nng-model=\"vm.product.accountId\" name=\"accountId\"><md-option ng-repeat=\"opt in vm.accounts | filter: { active: true }\" \nng-value=\"opt.id\">{{opt.name}} - {{opt.code}}</md-option></md-select></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Impuesto</label><md-select ng-model=\"vm.product.satTaxId\" \nname=\"satTaxId\" required><md-option ng-repeat=\"item in vm.satTaxes\" ng-value=\"item.id\">\n[{{item.code}}] {{item.description}}</md-option></md-select><div ng-messages=\"productForm.satTaxId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Tipo de Impuesto</label><md-select ng-model=\"vm.product.satTaxTypeId\" \nname=\"satTaxTypeId\" required><md-option ng-repeat=\"item in vm.satTaxTypes\" ng-value=\"item.id\">\n[{{item.code}}] {{item.description}}</md-option></md-select><div ng-messages=\"productForm.satTaxId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Valor de impuesto</label><input type=\"text\" name=\"satTaxValue\" \nng-model=\"vm.product.satTaxValue\" required><div ng-messages=\"productForm.satTaxValue.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Seleccione Valor de Impuesto del SAT.</span></div></div></md-input-container></div></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.product.isGenerateCoupons\"><md-tab-label><span>Cupones</span></md-tab-label>\n<md-tab-body><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp p-20\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label># de Cupones</label><input type=\"number\" \nng-model=\"vm.product.couponNumber\" name=\"couponNumber\" required min=\"1\"><div \nng-messages=\"productForm.couponNumber.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nIngrese número de cupones.</span></div><div ng-message=\"min\"><span>Al menos debe imprimir 1 cupon.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Dias de vigencia</label><input type=\"number\" \nng-model=\"vm.product.couponValidityDays\" name=\"couponValidityDays\" required min=\"1\"><div \nng-messages=\"productForm.couponValidityDays.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nIngrese dias de validez del cupon.</span></div><div ng-message=\"min\"><span>Debe tener validez al menos de un dia.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Pago a terceros($)</label>\n<input type=\"number\" ng-model=\"vm.product.couponAmount\" name=\"couponAmount\" required min=\"0\"><div \nng-messages=\"productForm.couponAmount.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nIngrese monto de pago a terceros.</span></div><div ng-message=\"min\"><span>El monto minimo es 0.</span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Descripción a imprimir\n</label><input type=\"text\" ng-model=\"vm.product.couponPrintDescription\" name=\"couponPrintDescription\" required><div \nng-messages=\"productForm.couponPrintDescription.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIngrese descripción a imprimir.</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Observaciones</label><input type=\"text\" ng-model=\"vm.product.couponNotes\" \nname=\"couponNotes\"></md-input-container></div></div></md-tab-body></md-tab></md-tabs></form></div></div>");
$templateCache.put("app/main/catalogs/views/products/products/products.html","<div id=\"products\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Productos</span></div><div \nclass=\"product-count secondary-text\"><span>No Productos:</span> <span>{{vm.products.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAdd()\"><span>Nuevo\n</span></md-button><md-button class=\"md-raised md-background\" ng-click=\"vm.massiveAdd($event)\"><span>Masivo</span>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Tipo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.products\"><td>{{item.code}}</td><td>{{item.name}}</td><td>{{item.productType.name}}</td><td><i \nng-if=\"item.active\" class=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-if=\"!item.active\" \nclass=\"icon-cancel red-500-fg\"></i></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoDetail(item.id)\" aria-label=\"Detalles de producto\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/catalogs/views/rentable-zones/rentable-zone/rentable-zone.html","<script>$(function () {\n  $(document)\n    .mouseup(function () {\n      isMouseDown = false;\n    });\n});</script><div \nid=\"rentable-zones\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-products-button md-icon-button\" aria-label=\"Ir a productes\" ng-click=\"vm.returnBack()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.item.name}}</div><div class=\"subtitle secondary-text\">\n<span>Detalle de Zona de rentables</span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.save()\" ng-disabled=\"!detailForm.$valid || vm.saving\"><span ng-show=\"vm.saving\">GUARDANDO...</span> <span \nng-hide=\"vm.saving\">GUARDAR</span></md-button></div></div><div class=\"content no-padding\"><md-tabs md-dynamic-height>\n<md-tab><md-tab-label><span>Información de Zona</span></md-tab-label><md-tab-body><form name=\"detailForm\" \nid=\"detailForm\" class=\"md-inline-form p-15 pt-25\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Nombre</label><input type=\"text\" name=\"name\" ng-model=\"vm.item.name\" required><div \nng-messages=\"detailForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese nombre.</span></div></div>\n</md-input-container><md-input-container class=\"md-block w-150\" flex-1><label>Prefijo</label><input type=\"text\" \nname=\"prefix\" ng-model=\"vm.item.prefix\" id=\"prefix\"></md-input-container><md-input-container class=\"md-block w-150\" \nflex-1><label>Sufijo</label><input type=\"text\" name=\"postfix\" ng-model=\"vm.item.postfix\" id=\"postfix\">\n</md-input-container><md-input-container class=\"md-block mt-0\" flex-1><md-checkbox ng-model=\"vm.item.active\">Activo\n</md-checkbox></md-input-container></div><div layout-gt-sm=\"row\"><cd-sat-select label=\"Unidad del SAT\" \napi-list=\"units\" md-selected-item=\"vm.item.satUnit\" required flex></cd-sat-select><cd-sat-select \nlabel=\"Producto del SAT\" api-list=\"products\" md-selected-item=\"vm.item.satProduct\" required flex></cd-sat-select></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Impuesto</label><md-select \nng-model=\"vm.item.satTaxId\" name=\"satTaxId\" required><md-option ng-repeat=\"item in vm.satTaxes\" ng-value=\"item.id\">\n[{{item.code}}] {{item.description}}</md-option></md-select><div ng-messages=\"detailForm.satTaxId.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Seleccione Impuesto del SAT.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Tipo de Impuesto</label><md-select ng-model=\"vm.item.satTaxTypeId\" \nname=\"satTaxTypeId\" required><md-option ng-repeat=\"item in vm.satTaxTypes\" ng-value=\"item.id\">\n[{{item.code}}] {{item.description}}</md-option></md-select><div ng-messages=\"detailForm.satTaxId.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Seleccione Impuesto del SAT.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Valor de impuesto</label><input type=\"text\" name=\"satTaxValue\" \nng-model=\"vm.item.satTaxValue\" required><div ng-messages=\"detailForm.satTaxValue.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Seleccione Valor de Impuesto del SAT.</span></div></div></md-input-container></div></form>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.item && vm.item.id > 0\"><md-tab-label><span>Precios</span></md-tab-label>\n<md-tab-body class=\"no-padding\"><div><div layout-gt-sm=\"row\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-button md-accent-bg\" ng-click=\"vm.showPrices($event, vm.item.id)\">Nuevo</md-button></div><table \nclass=\"dataTable row-border hover border\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Vigencia</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Interés</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Dias de gracia</span></div></th><th class=\"w-120\"></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.prices | orderBy: \'validFrom\': true\"><td>\n{{item.validFrom | date : \'dd/MM/yyyy\'}} - {{item.validTo | date : \'dd/MM/yyyy\'}}</td><td>{{item.interes}}</td><td>\n{{item.daysOfGrace}}</td><td><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.showPrices($event, item.rentableZoneId, item.priceGroupId)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.priceDelete(item.priceGroupId)\" aria-label=\"Remove\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></td></tr></tbody></table></div></md-tab-body></md-tab><md-tab ng-if=\"vm.item.id > 0\" \nmd-on-select=\"vm.configSelected()\"><md-tab-label><span>Configuración de rentables</span></md-tab-label><md-tab-body \nclass=\"no-padding\"><form name=\"rentablesForm\" class=\"md-inline-form\"><div layout-gt-sm=\"row\"><div \nlayout-gt-sm=\"column\" flex-gt-sm=\"15\"><md-input-container class=\"md-block\"><label>Renglones</label><input \ntype=\"number\" name=\"matrixRows\" min=\"1\" max=\"500\" ng-model=\"vm.item.matrixRows\" required \nng-disabled=\"vm.rentablesGenerated\"><div ng-messages=\"rentablesForm.matrixRows.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese numero de renglones.</span></div><div ng-message=\"min\"><span>El valor minimo es 0.\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><label>Columnas</label><input \ntype=\"number\" name=\"matrixColumns\" min=\"1\" max=\"500\" ng-model=\"vm.item.matrixColumns\" required \nng-disabled=\"vm.rentablesGenerated\"><div ng-messages=\"rentablesForm.matrixColumns.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese numero de columnas.</span></div><div ng-message=\"min\"><span>El valor minimo es 0.\n</span></div></div></md-input-container><md-input-container class=\"md-block w-150\" flex-1><label>Iniciar en:</label>\n<input type=\"number\" min=\"1\" id=\"startNumber\" ng-model=\"vm.item.startNumber\" required \nng-disabled=\"vm.rentablesGenerated\"></md-input-container><md-button type=\"submit\" \nclass=\"md-button md-raised md-accent h-40\" ng-disabled=\"!rentablesForm.$valid || vm.rentablesGenerated\" \nng-click=\"vm.generateMatrix()\">Generar Matriz</md-button></div><div layout-gt-sm=\"column\" flex-gt-sm=\"80\" \nid=\"matrix-container\" class=\"ml-50\"></div></div></form></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/catalogs/views/rentable-zones/rentable-zones/rentable-zones.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Zonas de rentables</span></div><div \nclass=\"product-count secondary-text\"><span>No de zonas:</span> <span>{{vm.zones.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.add()\"><span>Nuevo</span>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text w-70\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text w-120\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.zones\"><td>{{item.id}}</td><td>{{item.name}}</td><td><i ng-show=\"item.active\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-show=\"!item.active\" class=\"icon-cancel red-500-fg\"></i>\n</td><td><md-button class=\"md-icon-button hide show-gt-xs\" ng-click=\"vm.detail(item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.remove(item, $event)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td>\n</tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/inventory/views/inventories/inventories/inventories.html","<div id=\"inventory\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Inventario</span></div><div \nclass=\"product-count secondary-text\"><span>No de productos:</span> <span>{{vm.inventory.length}}</span></div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-icon md-font-icon=\"icon-cloud-upload\" class=\"s16\" \nng-class=\"{\'white-fg\': vm.saving, \'transparent-fg\': !vm.saving }\"></md-icon><md-button class=\"md-raised md-background\" \nng-click=\"vm.add($event)\"><span>Nuevo</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div\n class=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInventoryInstance\" dt-options=\"vm.dtInventoryOptions\"><thead><tr><th \nclass=\"secondary-text w-100 text-align-center\"><div class=\"table-header\"><span class=\"column-title\">Código</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Producto</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Almacen</span></div></th><th \nclass=\"secondary-text w-75\"><div class=\"table-header\"><span class=\"column-title\">Cantidad</span></div></th><th \nclass=\"secondary-text w-100 text-align-center\"><div class=\"table-header\"><span class=\"column-title\">Precio</span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.inventory\" class=\"selectable\" ng-click=\"vm.selected = item\" \nng-class=\"{\'selected\' : vm.selected.id == item.id }\"><td class=\"text-align-center\">{{item.product.code}}</td><td>\n{{item.product.name}}</td><td>{{item.warehouse.name}}</td><td><input type=\"number\" ng-model=\"item.quantity\" min=\"0\" \nclass=\"text-align-center w-70\" ng-blur=\"vm.save(item)\" cd-enter=\"vm.save(item)\" select-on-focus \nng-if=\"item.product.isStockRequired\"></td><td>$ <input type=\"number\" ng-model=\"item.price\" min=\"0\" \nclass=\"text-align-right w-80\" ng-blur=\"vm.save(item)\" cd-enter=\"vm.save(item)\" select-on-focus></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/inventory/views/inventories/inventory/inventory.html","");
$templateCache.put("app/main/invoices/views/complements/dialog-cancel/dialog-cancel.html","<md-dialog id=\"complement-dialog-cancel\" class=\"\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall h-50\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.close()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div></md-toolbar><form \nname=\"detailForm\"><md-dialog-content class=\"no-padding\"><div class=\"page-layout carded fullwidth\" layout=\"column\"><div \nlayout=\"row\" class=\"p-0 pl-15 pr-15 pt-10 m-0\"><div layout=\"column\" flex><div layout=\"row\"><md-input-container flex>\n<label>Motivo de cancelación</label><md-select ng-model=\"vm.catInvoiceCancellationReason\" \nname=\"catInvoiceCancellationReason\" required ng-disabled=\"vm.viewMode\"><md-option \nng-repeat=\"item in vm.catInvoiceCancellationReasons\" ng-value=\"item\">{{item.description}}</md-option></md-select><div \nng-messages=\"detailForm.catInvoiceCancellationReasonId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Motivo</span></div></div></md-input-container></div></div></div><div layout=\"row\" \nclass=\"p-0 pl-15 pr-15 m-0\"><md-input-container class=\"md-block\" flex \nng-if=\"vm.catInvoiceCancellationReason.code == \'01\'\"><label>Folio fiscal</label><input type=\"text\" \nng-model=\"vm.paymentConditions\" name=\"paymentConditions\" ng-disabled=\"vm.viewMode\" required><div \nng-messages=\"detailForm.paymentConditions.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIngrese el folio fiscal de la nueva factura</span></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.accept()\" \nclass=\"send-button md-accent md-raised w-150\" ng-disabled=\"!detailForm.$valid\" aria-label=\"ACEPTAR\"><span \nng-hide=\"vm.sending\">GENERAR </span><span ng-show=\"vm.sending\">GENERANDO...</span></md-button><md-button \nng-click=\"vm.close()\" aria-label=\"Cancelar\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/views/notasCredito/notasCredito/notasCredito.html","<div id=\"notas-credito\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Notas de Crédito</span></div><div\n class=\"product-count secondary-text\"><span>No total de notas de crédito:</span> <span>{{vm.notasCredito.length}}\n</span></div></div><div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar por folio\" flex ng-model=\"vm.keyword\"></div><div><md-button class=\"md-button md-raised\" \nng-click=\"vm.showNotaCredito($ev)\">Nueva Nota de Credito</md-button></div><div class=\"actions\" layout=\"row\" \nlayout-align=\"end center\"><md-input-container class=\"md-block mb-0 h-40\" flex-1><label>Desde</label><md-datepicker \nng-init=\"vm.dummy.from = (vm.from | toDate)\" ng-change=\"vm.from = vm.dummy.from; vm.getNotasCredito();\" \nng-model=\"vm.dummy.from\" name=\"from\" md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block mb-0 h-40\" flex-1><label>Hasta</label>\n<md-datepicker ng-init=\"vm.dummy.to = (vm.to | toDate)\" ng-change=\"vm.to = vm.dummy.to; vm.getNotasCredito();\" \nng-model=\"vm.dummy.to\" name=\"to\" md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker></md-input-container></div></div><div class=\"content-card fullpage-datatable no-padding\" layout=\"row\" \nflex><div class=\"content fullpage-datatable no-padding\" flex><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Folio</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Folio Fact.</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Recibo</span></div></th><th \nclass=\"secondary-text w-100\"><div class=\"table-header text-center\"><span class=\"column-title\">Monto</span></div></th>\n<th class=\"secondary-text w-120\"><div class=\"table-header\"><span class=\"column-title\">Fecha</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Notas</span></div></th><th \nclass=\"secondary-text w-50\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr cd-custom-grid=\"item in vm.notasCredito | filter: { folio: vm.keyword } | itemsPerPage: (7)\"><td>\n{{item.folio}}</td><td>{{item.invoiceFolio}}</td><td>{{item.orderFolio}}</td><td class=\"text-center\">\n{{item.total | currency : \'$ \': 2 }}</td><td>{{item.expeditionDate | date : \'dd/MM/yyyy HH:mm\' }}</td><td>\n{{item.notes}}</td><td><md-button class=\"md-icon-button md-accent\" ng-click=\"vm.view(item.id)\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><md-tooltip>Ver archivo</md-tooltip></md-button></td></tr></tbody><tr><td \ncolspan=\"7\"><dir-pagination-controls></dir-pagination-controls></td></tr></table></div></div></div></div>");
$templateCache.put("app/main/invoices/views/orders/coupon/coupon.html","<div id=\"coupon\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"coupon-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button></div><table \nclass=\"simple invoice-table\"><tbody><tr ng-repeat=\"coupon in vm.range track by $index\"><td><div id=\"pass-card\" \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"center center\"><div layout=\"column\"><div \nlayout=\"row\" class=\"seller\" layout-align=\"center center\">\nCUPON {{ (\'000000\'+vm.order.id).slice(-6)}}{{ (\'00\'+($index + 1)).slice(-2)}}</div><div layout=\"row\" class=\"seller\" \nlayout-align=\"center center\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img id=\"img-logo\" \nng-src=\"{{vm.logoSource}}\"></div></div><div layout=\"row\" class=\"seller\" layout-align=\"center center\">\n{{vm.partner.completeName}}</div><div layout=\"row\" class=\"seller\" layout-align=\"center center\">{{vm.products.name}}\n</div></div></div></div><br></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/invoices/views/orders/order/order.html","<div id=\"order\"><ms-form-wizard flex \nng-show=\"!vm.order.selectingProduct && !vm.order.addingProductData  && !vm.order.selectingCalendars\"><div \nclass=\"top-total\"><h3>Total</h3><span>{{vm.order.total | currency: \'$ \': 2}}</span></div><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab ng-disabled=\"vm.validated\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-green-600-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\">\n</i> </span><span class=\"ms-form-wizard-step-text\">Cuotas y Productos</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" ms-form-wizard-form class=\"no-padding\" ms-scroll><input type=\"hidden\" ng-model=\"vm.dummy\" \nng-required=\"!vm.order.details || vm.order.details.length == 0\"><md-card class=\"md-card\"><md-card-content \nclass=\"p-5 table-partner-selection\"><div layout-gt-sm=\"row\" layout=\"row\" class=\"h-70\"><div flex-1 class=\"w-80\"><img \nng-if=\"vm.order.partner && vm.order.partner.picturePathName && vm.order.partner.picturePathName && vm.order.partner.picturePathName != \'\'\" \nclass=\"partner-image\" ng-src=\"{{vm.picturesUrl}}{{vm.order.partner.picturePathName}}\"> <img \nng-if=\"!vm.order.partner || !vm.order.partner.picturePathName || vm.order.partner.picturePathName == \'\'\" \nclass=\"partner-image\" src=\"assets/images/avatars/profile.jpg\"></div><md-input-container class=\"md-block mb-0\" \nflex=\"10\"><label>Clave</label><input type=\"number\" ng-model=\"vm.partnerSeachCode\" cd-enter=\"vm.searchPartnerByCode()\" \nmd-autofocus ng-disabled=\"vm.calculating\"></md-input-container><div flex=\"5\" class=\"pt-10\"><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.searchPartnerByCode()\" \nng-disabled=\"!vm.partnerSeachCode || vm.partnerSeachCode == \'\' || vm.calculating\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><md-tooltip>Buscar código de socio</md-tooltip></md-button></div><md-autocomplete flex \nmd-selected-item=\"vm.order.partner\" md-selected-item-change=\"vm.partnerSeachCode = vm.order.partner.sequentialNumber\" \nmd-search-text=\"vm.searchTextpartner\" md-items=\"item in vm.titulares | filter: { completeName: vm.searchTextpartner }\" \nmd-item-text=\"item.completeName\" md-min-length=\"0\" md-floating-label=\"Seleccione Socio\" cd-enter=\"vm.calculate()\" \nrequired ng-disabled=\"vm.calculating\"><md-item-template><span md-highlight-text=\"vm.searchTextpartner\" \nmd-highlight-flags=\"^i\">{{item.completeName}}</span></md-item-template><md-not-found>No se hay resultados.\n</md-not-found></md-autocomplete><md-input-container flex=\"10\" class=\"mb-0\"><label>Fecha de cálculo</label>\n<md-datepicker ng-init=\"vm.calcDate = (vm.order.calcDate | toDate)\" ng-change=\"vm.order.calcDate = vm.calcDate\" \nng-model=\"vm.calcDate\" name=\"calcDate\" required md-placeholder=\"Fecha de calculo\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\" ng-disabled=\"vm.calculating\"></md-datepicker></md-input-container><div flex=\"5\" class=\"pt-10\">\n<md-button class=\"md-icon-button md-raised md-accent\" ng-click=\"vm.calculate()\" \nng-disabled=\"!vm.order.partner || !vm.order.calcDate || vm.calculating\"><span ng-show=\"vm.calculating\">...</span>\n<md-icon ng-hide=\"vm.calculating\" md-font-icon=\"icon-calculator\"></md-icon><md-tooltip>Calcular</md-tooltip>\n</md-button></div></div></md-card-content></md-card><md-card class=\"md-card\"><md-card-content \nclass=\"pl-0 pr-0 pt-10 pb-0\"><div class=\"pl-10 pr-10 table-filters\"><md-button \nclass=\"md-icon-button md-accent-bg md-blue-200-bg\" aria-label=\"Mostrar productos y servicios\" \nng-click=\"vm.searchProduct($event)\" flex><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip>Buscar productos\n</md-tooltip></md-button><md-input-container flex class=\"no-margin\"><input type=\"text\" class=\"w-250\" \nplaceholder=\"Agregar por codigo...\" flex cd-enter=\"vm.searchProductByCode()\" ng-model=\"vm.codeToSearch\">\n</md-input-container><div class=\"right\" flex><md-button id=\"btnDiscount\" \nclass=\"md-button md-accent-bg md-green-300-bg\" aria-label=\"AllDiscounts\" ng-click=\"vm.showDiscountDialog($event)\" \nng-hide=\"vm.order.details.length == 0\" flex><md-icon md-font-icon=\"icon-sale\"></md-icon>Descuento general</md-button>\n<md-button id=\"btnRemoveAllDiscounts\" class=\"md-button md-accent-bg md-red-300-bg\" aria-label=\"CleanAllDiscounts\" \nng-click=\"vm.cleanDiscount()\" ng-hide=\"vm.order.details.length == 0\" flex><md-icon md-font-icon=\"icon-window-close\">\n</md-icon>Quitar descuentos</md-button><md-button id=\"btnRemoveAllInterests\" \nclass=\"md-button md-accent-bg md-red-300-bg\" aria-label=\"CleanAllInterests\" ng-click=\"vm.cleanInterests()\" \nng-hide=\"vm.order.details.length == 0\" flex><md-icon md-font-icon=\"icon-window-close\"></md-icon>Quitar intereses\n</md-button><md-button class=\"md-button md-accent-bg md-red-300-bg\" aria-label=\"CleanAll\" ng-click=\"vm.cleanAll()\" \nng-hide=\"vm.order.details.length == 0\" flex><md-icon md-font-icon=\"icon-trash\"></md-icon>Borrar todo</md-button></div>\n</div><table class=\"details-table dataTable row-border hover\"><thead><th class=\"secondary-text w-70\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header text-align-left\"><span class=\"column-title\">Producto o servcio</span></div></th><th \nclass=\"secondary-text w-140\"><div class=\"table-header\"><span class=\"column-title\">Periodo</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">P.Unitario</span></div></th><th \nclass=\"secondary-text w-30\"><div class=\"table-header text-align-left\"><span class=\"column-title\">Cant.</span></div>\n</th><th class=\"secondary-text w-80\"><div class=\"table-header text-align-left\"><span class=\"column-title\">Importe\n</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Intereses</span>\n</div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Descuento</span></div>\n</th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th>\n</thead><tbody><tr ng-if=\"!vm.order.details || vm.order.details.length == 0 && !vm.calculating\" class=\"no-products\"><td\n colspan=\"9\"><h3>No hay productos ni cuotas por pagar</h3></td></tr><tr \nng-if=\"vm.order.details.length == 0 && vm.calculating\" class=\"no-products\"><td colspan=\"9\"><h3>Calculando...</h3></td>\n</tr><tr cd-custom-grid=\"item in vm.order.details | itemsPerPage: (5)\" pagination-id=\"detailsPaginator\" \nclass=\"selectable\" ng-click=\"vm.detail = item;\" ng-class=\"{\'selected\': vm.detail == item }\"><td><div layout=\"row\" \nlayout-align=\"center center\"><md-button id=\"btnRowDiscount\" class=\"md-button w-25 m-0 p-0\" \naria-label=\"Aplicar descuento\" ng-click=\"vm.showDiscountDialog($event, item)\"><md-icon class=\"md-accent s16\" \nmd-font-icon=\"icon-sale\"></md-icon><md-tooltip>Aplicar descuento</md-tooltip></md-button><md-button \nclass=\"md-button w-25 m-0 p-0\" aria-label=\"Seleccionar servicio\" ng-click=\"vm.productRemove(item)\"><md-icon \nclass=\"md-accent s16\" md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar producto</md-tooltip></md-button>\n<md-button id=\"btnRowEdit\" class=\"md-button w-25 m-0 p-0\" aria-label=\"detailEdit\" \nng-click=\"vm.detailEditShow($event, item)\"><md-icon class=\"md-accent s16\" md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip>Editar</md-tooltip></md-button></div></td><td class=\"product-service\">{{item.description}}<div \nclass=\"partner\">{{item.partner.completeName}}</div></td><td class=\"period\">\n{{item.initPeriodDate | date :\'dd/MM/yyyy\' }} - {{item.endPeriodDate | date :\'dd/MM/yyyy\' }}</td><td \nclass=\"text-align-right\">{{item.price | currency: \'$\': 2}}</td><td class=\"text-align-center\"><label \nng-if=\"item.detailType && item.detailType != 0\">{{item.quantity}}</label><input \nng-if=\"!item.detailType || item.detailType == 0\" type=\"number\" ng-model=\"item.quantity\" min=\"1\" class=\"inp-quantity\" \nng-change=\"vm.productQuantityChange(item)\"></td><td class=\"text-align-right\">{{item.subtotal | currency: \'$\': 2}}</td>\n<td class=\"text-align-right\">{{item.interest | currency: \'$\': 2}}</td><td class=\"text-align-right\">\n{{item.discountAmmount | currency: \'$\': 2}}</td><td class=\"text-align-right\">{{item.total | currency: \'$\': 2}}</td>\n</tr></tbody><tr><td colspan=\"9\"><dir-pagination-controls pagination-id=\"detailsPaginator\"></dir-pagination-controls>\n</td></tr></table></md-card-content></md-card><md-card id=\"totals\" class=\"md-card md-side-nav-right\"><md-card-content \nclass=\"no-padding\"><table class=\"dataTable row-border\"><tbody><tr><td><strong>Subtotal</strong></td><td><div>\n{{ vm.order.subtotal | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Intereses</strong></td><td><div>\n+ {{ vm.order.interests | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Descuento</strong></td><td><div>\n- {{ vm.order.discountAmmount | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Total</strong></td><td><div>\n{{ vm.order.total | currency : \'$\' : 2}}</div></td></tr></tbody></table></md-card-content></md-card></form>\n</md-tab-body></md-tab><md-tab class=\"tabPayment\" ng-disabled=\"wizardStep1.$invalid || vm.validated\"><md-tab-label>\n<span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep2.$invalid\">2</span> <span class=\"ms-form-wizard-step-number md-green-600-bg\" \nng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">Forma de pago\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form class=\"no-padding\" ms-scroll>\n<input type=\"hidden\" value=\"\" ng-model=\"vm.dummy\" \nng-required=\"!((vm.order.total - vm.order.payed).toFixed(2)/1 === 0)\"></form><div layout-gt-sm=\"row\"><md-card \nclass=\"payments\" layout-gt-sm=\"column\" flex=\"50\"><md-card-header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><span>PAGOS ( {{vm.order.payments.length}} )</span> <span>\nRestan por pagar {{ vm.order.total - vm.order.payed | currency: \'$ \': 2 }} de {{ vm.order.total | currency: \'$ \': 2 }}\n</span></md-card-header><md-card-content class=\"no-padding\"><form name=\"paymentForm\" class=\"pl-10 pr-10\"><div \nlayout-gt-sm=\"row\"><md-input-container flex><label>Forma de pago</label><md-select name=\"paymentMethod\" \nng-model=\"vm.payment.paymentMethod\" required ng-change=\"vm.paymentMethodChange()\"><md-option \nng-repeat=\"item in vm.paymentMethods | filter: { active: true }\" ng-value=\"item\">{{item.name}}</md-option></md-select>\n<div ng-messages=\"paymentForm.paymentMethod.$error\" role=\"alert\"><div ng-message=\"required\">Obigatorio</div></div>\n</md-input-container><md-input-container flex ng-show=\"vm.paymentMethodOptions && vm.paymentMethodOptions.length > 0\">\n<label>Opciones</label><md-select ng-model=\"vm.payment.paymentMethodOption\"><md-option \nng-repeat=\"item in vm.paymentMethodOptions | filter: { active: true }\" ng-value=\"item\">{{item.name}}</md-option>\n</md-select></md-input-container><md-input-container flex><label>Importe</label><input type=\"number\" name=\"ammount\" \nng-model=\"vm.payment.ammount\" required min=\"0.01\" ng-max=\"(vm.order.total - vm.order.payed).toFixed(2)/1\"><div \nng-messages=\"paymentForm.ammount.$error\" role=\"alert\"><div ng-message=\"required\">Obligatiorio</div><div \nng-message=\"min\">El importe no puede ser menor a 0.01</div><div ng-message=\"max\">El importe excede el total a pagar.\n</div></div></md-input-container><md-input-container flex><label>Referencia</label><input type=\"text\" \nng-model=\"vm.payment.reference\" ng-required=\"vm.payment.paymentMethod.referenceRequired\"></md-input-container>\n<md-input-container flex><label>Terminal</label><md-select ng-model=\"vm.payment.tpv\"><md-option \nng-repeat=\"item in vm.tpvs | filter: { active: true }\" ng-value=\"item\">{{item.name}}</md-option></md-select>\n</md-input-container><div flex-1 class=\"pt-10\"><md-button class=\"md-button md-raised md-accent\" type=\"submit\" \nng-click=\"vm.addPayment()\" ng-disabled=\"paymentForm.$invalid\">Agregar</md-button></div></div></form><div ms-scroll \nclass=\"payments-grid\"><table class=\"dataTable row-border hover\"><thead><tr><th>Forma de pago</th><th>Opción</th><th>\nImporte</th><th>Referencia</th><th>TPV</th><th></th></tr></thead><tbody><tr><td colspan=\"6\" \nng-if=\"vm.order.payments.length == 0\"><h4>No hay pagos registrados</h4></td></tr><tr \ncd-custom-grid=\"item in vm.order.payments | itemsPerPage: (5)\" pagination-id=\"paymentsPaginator\"><td>\n{{item.paymentMethod.name}}</td><td>{{item.paymentMethodOption.name}}</td><td>{{item.ammount | currency : \'$ \': 2}}\n</td><td>{{item.reference}}</td><td>{{item.tpv.name}}</td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.paymentRemove(item)\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip>\n</md-button></td></tr></tbody><tr><td colspan=\"6\"><dir-pagination-controls pagination-id=\"paymentsPaginator\">\n</dir-pagination-controls></td></tr></table></div><div class=\"notes\" layout=\"row\" flex layout-align=\"start-center\">\n<md-input-container flex class=\"md-block textarea-container\" flex><label>Observaciones</label><textarea \nng-model=\"vm.order.notes\" md-maxlength=\"500\"></textarea></md-input-container><md-button \nclass=\"md-icon-button md-raised md-accent w-30 h-30\" flex-1 ng-click=\"vm.generateNotes()\"><md-icon \nmd-font-icon=\"icon-undo\" class=\"s16\"></md-icon><md-tooltip>Generar Observaciones</md-tooltip></md-button></div>\n</md-card-content></md-card><md-card layout-gt-sm=\"column\" flex=\"50\"><md-card-header class=\"md-accent-bg\"><span>\nDATOS DE FACTURACIÓN</span></md-card-header><md-card-content><form name=\"addressForm\"><div layout=\"row\">\n<md-input-container flex><label>Dirección</label><md-select ng-model=\"vm.order.address\"><md-option \nng-repeat=\"item in vm.partnerAddresses\" ng-value=\"item\">{{item.addressType.name}} - {{item.street}} {{item.number}} ...\n</md-option></md-select></md-input-container><md-input-container flex-1><md-checkbox ng-model=\"vm.modifyAddress\">\nModificar?</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container flex=\"75\"><label>\nNombre o Razon Social</label><input type=\"text\" ng-model=\"vm.order.address.razonSocial\" name=\"razonSocial\" required \nng-disabled=\"!vm.modifyAddress\"><div ng-messages=\"addressForm.razonSocial.$error\"><div ng-message=\"required\">\nIngrese nombre</div></div></md-input-container><md-input-container flex=\"25\"><label>RFC</label><input type=\"text\" \nng-model=\"vm.order.address.rfc\" name=\"rfc\" required ng-disabled=\"!vm.modifyAddress\"><div \nng-messages=\"addressForm.rfc.$error\"><div ng-message=\"required\">Ingrese RFC</div></div></md-input-container></div><div \nlayout=\"row\"><md-input-container flex=\"80\"><label>Calle</label><input type=\"text\" ng-model=\"vm.order.address.street\" \nname=\"address\" required ng-disabled=\"!vm.modifyAddress\"><div ng-messages=\"addressForm.address.$error\"><div \nng-message=\"required\">Ingrese dirección</div></div></md-input-container><md-input-container flex=\"10\"><label>No. Ext.\n</label><input type=\"text\" ng-model=\"vm.order.address.number\" name=\"number\" ng-disabled=\"!vm.modifyAddress\"><div \nng-messages=\"addressForm.number.$error\"><div ng-message=\"required\">Ingrese Extensión</div></div></md-input-container>\n<md-input-container flex=\"10\"><label>No. Int.</label><input type=\"text\" ng-model=\"vm.order.address.interiorNumber\" \nname=\"interiorNumber\" ng-disabled=\"!vm.modifyAddress\"></md-input-container></div><div layout=\"row\"><md-input-container \nflex><label>Estado</label><input type=\"text\" ng-model=\"vm.order.address.state\" name=\"state\" required \nng-disabled=\"!vm.modifyAddress\"><div ng-messages=\"addressForm.state.$error\"><div ng-message=\"required\">Ingrese Estado\n</div></div></md-input-container><md-input-container flex><label>Delegación/Municipio</label><input type=\"text\" \nng-model=\"vm.order.address.municipio\" name=\"municipio\" required ng-disabled=\"!vm.modifyAddress\"><div \nng-messages=\"addressForm.municipio.$error\"><div ng-message=\"required\">Ingrese Municipio</div></div>\n</md-input-container><md-input-container flex><label>Colonia</label><input type=\"text\" \nng-model=\"vm.order.address.colony\" name=\"colony\" required ng-disabled=\"!vm.modifyAddress\"><div \nng-messages=\"addressForm.colony.$error\"><div ng-message=\"required\">Ingrese colonia</div></div></md-input-container>\n<md-input-container flex=\"15\"><label>C.P.</label><input type=\"text\" ng-model=\"vm.order.address.zipCode\" name=\"zipcode\" \nrequired ng-disabled=\"!vm.modifyAddress\"><div ng-messages=\"addressForm.email.$error\"><div ng-message=\"required\">\nIngrese C.P.</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>Ciudad</label>\n<input type=\"text\" ng-model=\"vm.order.address.city\" name=\"city\" required ng-disabled=\"!vm.modifyAddress\"><div \nng-messages=\"addressForm.city.$error\"><div ng-message=\"required\">Ingrese ciudad</div></div></md-input-container>\n<md-input-container flex><label>Teléfono</label><input type=\"text\" ng-model=\"vm.order.address.phone\" name=\"phone\" \nng-disabled=\"!vm.modifyAddress\"></md-input-container><md-input-container flex><label>Email</label><input type=\"email\" \nng-model=\"vm.order.partner.email\" name=\"email\" required ng-disabled=\"!vm.modifyAddress\"><div \nng-messages=\"addressForm.email.$error\"><div ng-message=\"required\">Ingrese correo</div><div ng-message=\"email\">\nFormato de email incorrecto</div></div></md-input-container></div></form></md-card-content></md-card></div>\n</md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-green-600-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\">\n</i> </span><span class=\"ms-form-wizard-step-text\">Vista previa</span></span></md-tab-label><md-tab-body \nclass=\"preview\"><form name=\"wizardStep3\" class=\"no-padding\" ms-form-wizard-form><input type=\"hidden\" \nng-model=\"vm.notExistsDummy\" ng-required=\"!vm.validated\"><div class=\"pl-20 partner-info\"><h1>Datos de socio</h1><div \nlayout-gt-sm=\"row\"><label>Nombre:</label><span>{{vm.order.partner.completeName}}</span></div><div layout-gt-sm=\"row\">\n<label>Pagos:</label><span ng-repeat=\"item in vm.order.payments\" class=\"mr-10\">\n{{item.paymentMethod.name}} {{item.paymentMethodOption.name}}({{item.ammount | currency: \'$ \': 2}}),</span></div><div \nlayout-gt-sm=\"row\"><label>Dirección:</label><span>{{vm.order.address.razonSocial}} [{{vm.order.address.rfc}}]<br>\n{{vm.order.address.street}} No.{{vm.order.address.number}} Int.{{vm.order.address.interiorNumber}} {{vm.order.address.state}} {{vm.order.address.municipio}} {{vm.order.address.colony}} CP. {{vm.order.address.zipCode}}\n<br>Tel.{{vm.order.address.phone}} Email:{{vm.order.address.email}}</span></div></div><table \nclass=\"products-table dataTable row-border hover\"><thead><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Producto o servcio</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">P. Unitario</span></div></th><th class=\"secondary-text w-50\"><div class=\"table-header\"><span \nclass=\"column-title\">Cant.</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Subtotal</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Descuento</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Total</span></div></th></thead><tbody><tr ng-repeat=\"item in vm.order.details\"><td>\n{{item.description}}<div ng-show=\"item.data.length > 0\"><span ng-repeat=\"p in item.data\">\n{{p.productPropertyName}}: {{p.value}} /</span></div><div \nng-show=\"item.requireAddress || item.requireCalendar || item.requireEmployee || item.requirePet\"><span \nng-show=\"item.requireAddress\">/ Domicilio: {{item.address.selectingProductSelect}} </span><span \nng-show=\"item.requireCalendar\">/ Evento: {{item.calendarEvent.title}} </span><span ng-show=\"item.requireEmployee\">\n/ Empleado: {{item.employee.name}} {{item.employee.lastname}}</span> <span ng-show=\"item.requirePet\">\n/ Mascota: {{item.pet.name}}</span></div></td><td class=\"text-align-center\">{{item.price | currency: \'$\': 2}}</td><td \nclass=\"text-align-center\">{{item.quantity}}</td><td class=\"text-align-center\">{{item.subtotal | currency: \'$\': 2}}</td>\n<td class=\"text-align-center\">{{item.discountAmmount | currency: \'$\': 2}}</td><td class=\"text-align-center\">\n{{item.total | currency: \'$\': 2}}</td></tr></tbody></table><md-card id=\"totals\" class=\"md-card md-side-nav-right\">\n<md-card-content class=\"no-padding\"><table class=\"dataTable row-border\"><tbody><tr><td><strong>Subtotal</strong></td>\n<td><div>{{ vm.order.subtotal | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Intereses</strong></td><td><div>\n+ {{ vm.order.interests | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Descuento</strong></td><td><div>\n- {{ vm.order.discountAmmount | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Total</strong></td><td><div>\n{{ vm.order.total | currency : \'$\' : 2}}</div></td></tr><tr><td colspan=\"2\"><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-button md-raised md-green-500-bg w-150 white-fg\" \nng-click=\"vm.validated = true\" ng-if=\"!vm.validated\"><md-icon md-font-icon=\"icon-check\" class=\"s16 white-fg\"></md-icon>\nValidar</md-button><md-button class=\"md-button md-raised md-warn w-150\" ng-click=\"vm.validated = false\" \nng-if=\"vm.validated\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>Editar</md-button></div></td></tr>\n</tbody></table></md-card-content></md-card></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" \nng-disabled=\"msWizard.isFirstStep() || vm.validated\">Anterior</md-button><div class=\"steps\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div>\n<md-button class=\"md-raised md-accent wizard-next\" ng-click=\"msWizard.nextStep();\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid() || vm.validated\">Siguiente</md-button><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.saveOrder();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete() || !vm.validated || vm.order.sending\"><span ng-show=\"!vm.order.sending\">Guardar\n</span> <span ng-show=\"vm.order.sending\">Enviando...</span></md-button></div></ms-form-wizard></div>");
$templateCache.put("app/main/invoices/views/orders/orders/orders.html","<div id=\"orders\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div\n class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Recibos / Facturas</span></div></div><div class=\"actions\">\n<md-button ng-click=\"vm.generateInvoice($event)\" class=\"md-button white-bg w-200\" \nng-show=\"vm.ordersSelected.length > 0\" ng-disabled=\"vm.invoiceGenerating\"><span ng-show=\"vm.invoiceGenerating\">\nGENERANDO.... </span><span ng-hide=\"vm.invoiceGenerating\">Facturar {{vm.ordersSelected.length}} recibo(s)</span>\n</md-button></div><div class=\"dates-filters\" layout=\"row\" layout-align=\"start start\"><md-input-container \nclass=\"md-block\" flex-1><label>Desde</label><md-datepicker ng-model=\"vm.from\" md-placeholder=\"Seleccione\" \nmd-hide-icons=\"calendar\" md-current-view=\"month\" ng-change=\"vm.getData()\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex-1><label>Hasta</label><md-datepicker ng-model=\"vm.to\" \nmd-placeholder=\"Seleccione\" md-hide-icons=\"calendar\" md-current-view=\"month\" ng-change=\"vm.getData()\"></md-datepicker>\n</md-input-container></div></div><div class=\"main\" layout=\"row\" flex><md-card \nclass=\"fullpage-datatable no-padding mr-10\" layout-gt-sm=\"column\" flex=\"50\" ms-scroll><md-card-header layout=\"row\" \nflex class=\"h-60 pt-0\"><md-input-container flex><label>Socio</label><md-select ng-model=\"vm.filterPartnerId\"><md-option\n value=\"{{null}}\">TODOS</md-option><md-option ng-repeat=\"item in vm.partnersInOrders | orderBy : \'completeName\'\" \nng-value=\"item.id\">{{item.completeName}}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"w-150\"><label>Folio</label><input type=\"text\" ng-model=\"vm.filterFolio\"></md-input-container><md-input-container\n flex-1 class=\"w-130\"><md-select ng-model=\"vm.viewOptionsFilter\" aria-label=\"options-filter\"><md-option \nng-value=\"{{null}}\">Todos</md-option><md-option ng-value=\"{{true}}\">Facturados</md-option><md-option \nng-value=\"{{false}}\">NO Facturados</md-option></md-select></md-input-container></md-card-header><md-card-content \nclass=\"no-padding\"><table class=\"dataTable row-border\"><thead><tr><th class=\"secondary-text w-80\"><div \nclass=\"table-header\"><md-checkbox ng-model=\"vm.selectAllFlag\" ng-change=\"vm.selectAll()\" class=\"m-0\">Folio/Fact\n</md-checkbox><md-tooltip>Seleccionar todo</md-tooltip></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\">Socio</span></div></th><th class=\"secondary-text w-90\"><div class=\"table-header\"><span \nclass=\"column-title\">Fecha</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Total</span></div></th><th class=\"secondary-text w-70 text-align-center\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.ordersFiltered = (vm.orders | filter : { partnerId : vm.filterPartnerId, folio: vm.filterFolio, inInvoice: vm.viewOptionsFilter }) | itemsPerPage: (5) \" \npagination-id=\"ordersPaginator\" ng-click=\"vm.select(item)\" \nng-class=\"{\'selected\': item.selected == true, \'disabled\': item.invoiceId, \'canceled\': item.isCanceled }\" \nclass=\"selectable\"><td><md-checkbox ng-model=\"item.selected\" class=\"m-0\" ng-hide=\"item.invoiceId || item.isCanceled\">\n{{item.folio}}</md-checkbox><span ng-show=\"item.invoiceId\">{{item.folio}} / {{item.invoiceId}} </span><span \nng-show=\"item.isCanceled\">{{item.folio}}</span></td><td>{{item.partner.completeName}}</td><td class=\"date\">\n{{item.insertDate | date: \"dd/MM/yyyy HH:mm\"}}</td><td>{{item.total | currency}}</td><td class=\"actions\"><div \nng-hide=\"item.invoiceId || item.isCanceled\"><md-button class=\"md-icon-button\" ng-click=\"vm.coupon(item.id)\" \naria-label=\"coupon\" ng-show=\"item.details[0].product.isGenerateCoupons\"><md-icon md-font-icon=\"icon-receipt\" \nclass=\"s16\"></md-icon><md-tooltip>Reimprimir Cupones</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.receipt(item.id)\" aria-label=\"receipt\"><md-icon md-font-icon=\"icon-file-document\" class=\"s16\"></md-icon>\n<md-tooltip>Reimprimir Recibo</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelOrder(item)\" aria-label=\"cancel\"><md-icon md-font-icon=\"icon-block-helper\" class=\"s16\"></md-icon>\n<md-tooltip>Cancelar Recibo</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.showOrderDetail($event, item.id)\" aria-label=\"showOrderDetail\"><md-icon md-font-icon=\"icon-comment\" \nclass=\"s16\"></md-icon><md-tooltip>Mostrar detalles</md-tooltip></md-button><md-icon ng-show=\"item.allaCash\" \nmd-font-icon=\"icon-cash-usd\" class=\"s16\"></md-icon><md-icon ng-show=\"!item.allaCash\" md-font-icon=\"icon-credit-card\" \nclass=\"s16\"></md-icon></div></td></tr></tbody><tr><td colspan=\"6\"><dir-pagination-controls \npagination-id=\"ordersPaginator\"></dir-pagination-controls></td></tr></table></md-card-content></md-card><md-card \nclass=\"no-padding mr-10\" layout-gt-sm=\"column\" flex=\"50\" ms-scroll><md-card-header layout=\"row\" flex class=\"h-60 pt-0\">\n<h2>Facturas generadas</h2></md-card-header><md-card-content class=\"no-padding\"><table \nclass=\"invoices dataTable row-border\"><thead><tr><th class=\"secondary-text text-align-center w-10\"><div \nclass=\"table-header\"><span class=\"column-title\">Folio</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">RFC</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Razon Social</span></div></th><th class=\"secondary-text w-60\"><div \nclass=\"table-header\"><span class=\"column-title\">Fecha</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Total</span></div></th><th class=\"secondary-text w-50\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.invoices | itemsPerPage: (6)\" pagination-id=\"invoicesPaginator\" \nng-click=\"vm.invoiceSelected = item\" \nng-class=\"{\'selected\': vm.invoiceSelected.id == item.id, \'canceled\': item.isCanceled  }\" class=\"selectable\"><td \nclass=\"text-align-center\">{{item.folio}}</td><td class=\"td-rfc\">{{item.targetRfc}}<br><span ng-if=\"item.orderFolio\">\n{{item.orderFolio}}</span> <span ng-if=\"!item.orderFolio\">Varios folios</span></td><td>{{item.targetRazonSocial}}</td>\n<td class=\"date\">{{item.insertDate | date: \"dd/MM/yyyy HH:mm\"}}</td><td>{{item.total | currency}}</td><td><md-button \nclass=\"md-icon-button\" ng-click=\"vm.showInvoiceDetail($event, item)\" aria-label=\"showOrderDetail\"><md-icon \nmd-font-icon=\"icon-comment\" class=\"s16\"></md-icon><md-tooltip>Mostrar detalles</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.showInvoice(item.id)\" aria-label=\"showInvoice\"><md-icon \nmd-font-icon=\"icon-file-document\" class=\"s16\"></md-icon><md-tooltip>Ver factura</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelInvoice(item.id)\" aria-label=\"cancelInvoice\" ng-hide=\"item.isCanceled\">\n<md-icon md-font-icon=\"icon-block-helper\" class=\"s16\"></md-icon><md-tooltip>Cancelar factura</md-tooltip></md-button>\n</td></tr></tbody><tr><td colspan=\"6\"><dir-pagination-controls pagination-id=\"invoicesPaginator\">\n</dir-pagination-controls></td></tr></table></md-card-content></md-card></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/change-password/change-password.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"100\" flex-gt-md=\"100\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nCambio de contraseña</div></header><div class=\"content\"><form name=\"changePasswordForm\"><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Contraseña anterior</label><input type=\"password\" name=\"passwordLast\" \nng-model=\"vm.changePassword.lastPwd\" required><div ng-messages=\"changePasswordForm.passwordLast.$error\" role=\"alert\">\n<div ng-message=\"required\">Ingrese contraseña anterior</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Contraseña nueva</label><input type=\"password\" name=\"passwordNew\" \nng-model=\"vm.changePassword.newPwd\" required><div ng-messages=\"changePasswordForm.passwordNew.$error\" role=\"alert\"><div\n ng-message=\"required\">Ingrese nueva contraseña</div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Confirmación de nueva contraseña</label><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.changePassword.confirm\" required compare-to=\"vm.changePassword.newPwd\"><div \nng-messages=\"changePasswordForm.passwordConfirm.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nConfirme contraseña nueva</div><div ng-message=\"compareTo\"><span>Las contraseñas no coinciden</span></div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nclass=\"md-button md-raised md-accent\" ng-disabled=\"changePasswordForm.$invalid\" ng-click=\"vm.pwdSave()\">Cambiar\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/invoices/views/orders/receipt/receipt.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-click=\"vm.generateInvoice()\"><md-icon md-font-icon=\"icon-cash\"></md-icon><md-tooltip>Facturar</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" flex ng-click=\"vm.chageSize()\"><md-icon id=\"btnChangeSize\" \nmd-font-icon=\"icon-arrow-collapse\"></md-icon><md-tooltip>Tamaño</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" flex ng-disabled=\"vm.emailSending\" ng-click=\"vm.sendMail()\"><md-icon ng-if=\"vm.emailSending\" \nmd-font-icon=\"icon-dots-horizontal\"></md-icon><md-icon ng-if=\"!vm.emailSending\" md-font-icon=\"icon-email\"></md-icon>\n<md-tooltip>Enviar por Email</md-tooltip></md-button></div><div id=\"InvoiceLetter\" class=\"card md-whiteframe-8dp\" \nng-repeat=\"tst in vm.copies\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.picturesUrl}}{{vm.settings.logoFile}}\" width=\"120\"></div><div \nclass=\"divider\"></div><div class=\"detail\"><div class=\"title\">{{vm.settings.name}}</div><div class=\"address\">\n{{vm.settings.address}}</div><div class=\"phone\"><span>Telefono</span>: {{vm.settings.phone}}</div><div class=\"email\">\n<span>Email</span>: {{vm.settings.email}}</div><div class=\"website\"><span>Web</span>: {{vm.settings.webUrl}}</div>\n</div></div><div layout=\"row\" class=\"partner\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" \nlayout-align=\"end center\"><div>SOCIO</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.order.partner.completeName}}</div><div class=\"phone\"><span>Teléfono</span>: {{vm.order.partner.phone}}</div><div \nclass=\"email\"><span>Email</span>: {{vm.order.partner.email}}</div></div></div></div><table class=\"summary\"><tr \nclass=\"code\"><td class=\"label\">FOLIO</td><td class=\"value\">{{vm.order.folio}}</td></tr><tr><td class=\"label\">MEMBRESÍA\n</td><td class=\"value\">{{vm.order.partner.sequentialNumber}}</td></tr><tr><td class=\"label\">FECHA</td><td \nclass=\"value\">{{vm.order.insertDate | date : \'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td class=\"label\">TOTAL</td><td \nclass=\"value\">{{vm.order.total | currency}}</td></tr></table></div><div class=\"content\"><table \nclass=\"simple invoice-table\"><thead><th>CONCEPTOS</th><th class=\"text-right\">PRECIO</th><th class=\"text-right w-50\">\nCANT</th><th class=\"text-right\">INTERES</th><th class=\"text-right\">DESCUENTO</th><th class=\"text-right\">TOTAL</th>\n</thead><tbody><tr ng-repeat=\"item in vm.order.details\"><td><div class=\"title\">{{item.description}}</div><div \nclass=\"detail\">{{item.partner.completeName}}</div></td><td class=\"text-right\">{{item.price | currency}}</td><td \nclass=\"text-right\">{{item.quantity}}</td><td class=\"text-right\">{{item.interest | currency}}</td><td \nclass=\"text-right\">{{item.discountAmmount | currency}}</td><td class=\"text-right\">{{item.total | currency}}</td></tr>\n</tbody></table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td>SUBTOTAL</td><td>\n{{vm.order.subtotal | currency}}</td></tr><tr class=\"interes\"><td>INTERESES</td><td>+{{vm.order.interests | currency}}\n</td></tr><tr class=\"discount\"><td>DESCUENTO</td><td>-{{vm.order.discountAmmount | currency}}</td></tr><tr \nclass=\"total\"><td>TOTAL</td><td>{{vm.order.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div \nclass=\"note\" ng-if=\"vm.order.notes != \'\'\">Observaciones</div><div class=\"small-notes\">{{vm.order.notes}}</div><div \nclass=\"small-note\">Este documento no es un comprobante fiscal</div></div></div><div id=\"InvoiceSeven\" \nclass=\"card-7cm md-whiteframe-8dp invisible\" ng-repeat=\"tst in vm.copies\"><div class=\"header\" layout=\"row\" \nlayout-align=\"space-between start\" style=\"width: 100%\"><div class=\"ids\" layout=\"column\" style=\"width: 100%\"><div \nlayout=\"row\" class=\"seller\" layout-align=\"start center\" style=\"width: 100%\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\" style=\"width: 100%\"><img ng-src=\"{{vm.picturesUrl}}{{vm.settings.logoFile}}\" \nstyle=\"width: 85%\"></div></div><div layout=\"row\" class=\"seller\" layout-align=\"start center\" style=\"width: 100%\"><div \nclass=\"detail\" style=\"width: 100%\"><div class=\"title\">{{vm.settings.name}}</div><div class=\"address\">\n{{vm.settings.address}}</div><div class=\"phone\"><span>Teléfono</span>: {{vm.settings.phone}}</div><div class=\"email\">\n<span>Email</span>: {{vm.settings.email}}</div><div class=\"website\"><span>Web</span>: {{vm.settings.webUrl}}</div>\n</div></div><div layout=\"row\" class=\"partner\" style=\"width: 100%\"><div class=\"label\" layout=\"row\" style=\"width: 100%\">\nSOCIO</div></div><div layout=\"row\" class=\"partner\" layout-align=\"start center\" style=\"width: 100%\"><div class=\"detail\" \nstyle=\"width: 100%\"><div class=\"title\">{{vm.order.partner.completeName}}</div><div class=\"phone\"><span>Teléfono</span>\n: {{vm.order.partner.phone}}</div><div class=\"email\"><span>Email</span>: {{vm.order.partner.email}}</div></div></div>\n</div></div><div class=\"header\" layout=\"row\" layout-align=\"space-between start\" style=\"width: 100%; margin-top: 20px\">\n<table class=\"summary\" style=\"width: 100%\"><tr class=\"code\"><td class=\"label\"><b>FOLIO</b></td><td class=\"value\"><b>\n{{vm.order.folio}}</b></td></tr><tr><td class=\"label\">MEMBRESÍA</td><td class=\"value\">\n{{vm.order.partner.sequentialNumber}}</td></tr><tr><td class=\"label\">FECHA</td><td class=\"value\">\n{{vm.order.insertDate | date : \'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td class=\"label\">TOTAL</td><td class=\"value\">\n{{vm.order.total | currency}}</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead>\n<th>CONCEPTOS</th><th class=\"text-right\">PRECIO</th><th class=\"text-right\">CANT</th><th class=\"text-right\">INTERES</th>\n<th class=\"text-right\">DESCUENTO</th><th class=\"text-right\">TOTAL</th></thead><tbody><tr \nng-repeat=\"item in vm.order.details\"><td class=\"text-left\">{{item.description}}<br>{{item.partner.completeName}}</td>\n<td class=\"text-right\">{{item.price | currency}}</td><td class=\"text-right\">{{item.quantity}}</td><td \nclass=\"text-right\">{{item.interest | currency}}</td><td class=\"text-right\">{{item.discountAmmount | currency}}</td><td \nclass=\"text-right\">{{item.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td>SUBTOTAL</td><td>{{vm.order.subtotal | currency}}</td></tr><tr class=\"interes\"><td>\nINTERESES</td><td>+{{vm.order.interests | currency}}</td></tr><tr class=\"discount\"><td>DESCUENTO</td><td>\n-{{vm.order.discountAmmount | currency}}</td></tr><tr class=\"total\"><td>TOTAL</td><td>{{vm.order.total | currency}}\n</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" ng-if=\"vm.order.notes != \'\'\">Observaciones</div>\n<div layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"></div><div \nclass=\"small-note\">{{vm.order.notes}}</div></div><div layout=\"row\" layout-align=\"start start\"><div class=\"small-note\">\nEste documento no es un comprobante fiscal</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/main/main.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"60\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nInformación principal</div></header><div class=\"content\"><form name=\"mainForm\"><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Usuario</label><input type=\"text\" name=\"username\" ng-model=\"vm.user.username\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" flex><label>Email</label><input \ntype=\"email\" name=\"useremail\" ng-model=\"vm.user.email\" required><div ng-messages=\"mainForm.useremail.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Ingrese correo electronico</div><div ng-message=\"email\">\nFormato de email incorrecto</div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Nombre(s)</label><input type=\"text\" name=\"name\" ng-model=\"vm.user.name\" required><div \nng-messages=\"mainForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Ingrese Nombre(s)</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Apellidos</label><input type=\"text\" \nname=\"lastname\" ng-model=\"vm.user.lastname\" required><div ng-messages=\"mainForm.lastname.$error\" role=\"alert\"><div \nng-message=\"required\">Ingrese Apellidos</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" class=\"md-button md-raised md-accent\" \nng-disabled=\"mainForm.$invalid\" ng-click=\"vm.mainSave()\">Guardar</md-button></div></form></div></div></div><div \nclass=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"40\"><div \nclass=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\">\nCambiar Avatar</div></header><div class=\"content\"><div layout=\"row\"><input type=\"file\" id=\"inputFile\"></div><div \nlayout=\"row\" layout-align=\"end center\" class=\"pt-15\"><md-button class=\"md-button md-raised md-accent\" \nng-click=\"vm.mainAvatarSave()\">Cargar</md-button></div></div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/info/info.html","<div id=\"partners-info\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-account-alert\"></md-icon><span>Información de Socios</span>\n</div></div></div><div class=\"main\" layout=\"row\" flex><md-card class=\"no-padding mr-10\" flex=\"40\"><md-card-header \nclass=\"border\" layout=\"row\"><span flex>Buscar por:</span><div flex><md-radio-group ng-model=\"vm.filterType\" \nclass=\"pt-10\" layout=\"row\"><md-radio-button ng-repeat=\"opt in vm.filtersOptions\" ng-value=\"opt.id\" \naria-label=\"{{opt.id}}\">{{opt.name}}</md-radio-button></md-radio-group></div></md-card-header><md-card-content \nlayout=\"column\" class=\"no-padding\"><form name=\"filterForm\" class=\"filters p-10\" flex layout=\"row\"><div flex><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input type=\"text\" class=\"filter-keyword\" placeholder=\"Buscar...\" \nng-model=\"vm.keyword\"></div><div flex-1><md-button class=\"md-button md-raised md-accent pr-20\" type=\"submit\" \nng-click=\"vm.search()\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>Buscar</md-button></div></form><div flex=\"20\">\n<hr><table class=\"dataTable row-border\"><thead><tr><th class=\"w-30\">#</th><th>Resultados de busqueda</th></tr></thead>\n<tbody><tr ng-if=\"vm.searchResult.length == 0\"><td colspan=\"2\" class=\"empty-rows\">No se encontraron datos</td></tr><tr \ncd-custom-grid=\"item in vm.searchResult | itemsPerPage: (5)\" ng-click=\"vm.partnerSelect(item)\" class=\"selectable\" \nng-class=\"{\'selected\': vm.selectedPartner.id == item.id}\" pagination-id=\"titularsPaginator\"><td \nclass=\"text-align-center\">{{item.sequentialNumber}}</td><td>{{item.completeName}}</td></tr></tbody><tr><td colspan=\"2\">\n<dir-pagination-controls pagination-id=\"titularsPaginator\"></dir-pagination-controls></td></tr></table></div><div \nflex=\"50\" class=\"mt-50\"><hr><table class=\"dataTable row-border\"><thead><tr><th class=\"w-30\">#</th><th>Familiares</th>\n</tr></thead><tbody><tr ng-if=\"vm.familiars.length == 0\"><td colspan=\"2\" class=\"empty-rows\">No se encontraron datos\n</td></tr><tr cd-custom-grid=\"item in vm.familiars | itemsPerPage: (5)\" class=\"selectable\" \nng-click=\"vm.familiarSelected(item)\" ng-class=\"{\'selected\': vm.selectedFamiliar.id == item.id }\" \npagination-id=\"familiarsPaginator\"><td class=\"text-align-center\">{{item.id}}</td><td>{{item.completeName}}</td></tr>\n</tbody><tr><td colspan=\"2\"><dir-pagination-controls pagination-id=\"familiarsPaginator\"></dir-pagination-controls></td>\n</tr></table></div></md-card-content></md-card><md-card class=\"right-card no-padding mr-10\" flex=\"60\"><md-card-header \nclass=\"border\">Datos generales</md-card-header><md-card-content layout=\"row\" flex><div layout=\"column\" flex=\"75\" \nclass=\"mt-15\"><md-input-container class=\"md-block\" flex><label>Titular</label><input type=\"text\" \nng-model=\"vm.selectedTitular.completeName\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Telefono 1</label><input type=\"text\" ng-model=\"vm.selectedTitular.phone\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" flex><label>Telefono 2</label><input \ntype=\"text\" ng-model=\"vm.selectedTitular.phone2\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Cuota</label><input type=\"text\" ng-model=\"vm.selectedTitular.due.name\" \ndisabled=\"disabled\"></md-input-container><div flex layout=\"row\"><md-input-container class=\"md-block\" flex><label>\nFamilia</label><input type=\"text\" ng-model=\"vm.selectedTitular.sequentialNumber\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Id Titular</label><input type=\"text\" \nng-model=\"vm.selectedTitular.id\" disabled=\"disabled\"></md-input-container></div><div flex class=\"h-50 mb-10\"><h3 \nclass=\"m-0 pt-15 h-50\">Informacion de Titular o Familiar</h3></div><md-input-container class=\"md-block\" flex><label>\nNombre</label><input type=\"text\" ng-model=\"vm.selectedFamiliar.completeName\" disabled=\"disabled\"></md-input-container>\n<div flex layout=\"row\"><md-input-container class=\"md-block\" flex><label>Fecha de ingreso</label><md-datepicker \nng-model=\"vm.inscriptionDate\" disabled=\"disabled\" md-hide-icons=\"calendar\" ng-hide=\"!vm.selectedFamiliar\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block\" flex><label>Pagado hasta</label>\n<md-datepicker ng-model=\"vm.payedDate\" disabled=\"disabled\" md-hide-icons=\"calendar\" ng-hide=\"!vm.selectedFamiliar\">\n</md-datepicker></md-input-container></div><md-input-container class=\"md-block\" flex><label>Cuota</label><input \ntype=\"text\" ng-model=\"vm.selectedFamiliar.due.name\" disabled=\"disabled\"></md-input-container><div flex layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Fecha de nacimiento</label><md-datepicker ng-model=\"vm.birthdate\" \ndisabled=\"disabled\" md-hide-icons=\"calendar\" ng-hide=\"!vm.selectedFamiliar\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Parentesco</label><input type=\"text\" \nng-model=\"vm.selectedFamiliar.partnerType.name\" disabled=\"disabled\"></md-input-container></div></div><div \nlayout=\"column\" flex=\"25\"><div flex-1 layout=\"row\" layout-align=\"center start\" class=\"familiar-actions\"><img \nng-if=\"vm.selectedTitular && vm.selectedTitular.picturePathName && vm.selectedTitular.picturePathName && vm.selectedTitular.picturePathName != \'\'\" \nclass=\"partner-image\" ng-src=\"{{vm.picturesUrl}}{{vm.selectedTitular.picturePathName}}\"> <img \nng-if=\"!vm.selectedTitular || !vm.selectedTitular.picturePathName || vm.selectedTitular.picturePathName == \'\'\" \nclass=\"partner-image\" src=\"assets/images/avatars/profile.jpg\"></div><div flex-1 layout=\"row\" \nlayout-align=\"center start\" class=\"familiar-actions mt-15\"><md-button class=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.goToPartnerDetails()\" ng-disabled=\"!vm.selectedTitular\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n<md-tooltip>Modificar</md-tooltip></md-button><md-button class=\"md-icon-button md-raised md-accent\" \nng-disabled=\"!vm.selectedTitular\" ng-click=\"vm.showPasses($event)\"><md-icon md-font-icon=\"icon-credit-card-multiple\">\n</md-icon><md-tooltip>Pases y credenciales</md-tooltip></md-button></div><div flex-1 layout=\"row\" \nlayout-align=\"center start\" class=\"familiar-actions mt-15\" ng-hide=\"!vm.selectedFamiliar.isFamily\"><img \nng-if=\"vm.selectedFamiliar && vm.selectedFamiliar.picturePathName && vm.selectedFamiliar.picturePathName && vm.selectedFamiliar.picturePathName != \'\'\" \nclass=\"familiar-image\" ng-src=\"{{vm.picturesUrl}}{{vm.selectedFamiliar.picturePathName}}\"> <img \nng-if=\"!vm.selectedFamiliar || !vm.selectedFamiliar.picturePathName || vm.selectedFamiliar.picturePathName == \'\'\" \nclass=\"familiar-image\" src=\"assets/images/avatars/profile.jpg\"></div><div flex-1 layout=\"row\" \nlayout-align=\"center start\" class=\"familiar-actions mt-15\"><md-button class=\"md-icon-button md-raised md-accent\" \nng-disabled=\"!vm.selectedFamiliar\" ng-click=\"vm.showMessages($event)\"><md-icon md-font-icon=\"icon-email\"></md-icon>\n<md-tooltip>Mensajes</md-tooltip></md-button><md-button class=\"md-icon-button md-raised md-accent\" \nng-disabled=\"!vm.selectedFamiliar\" ng-click=\"vm.goToPartnerDgoToPartnerCredentialetails($event)\"><md-icon \nmd-font-icon=\"icon-account-box\"></md-icon><md-tooltip>Envia credencial</md-tooltip></md-button></div></div>\n</md-card-content></md-card></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partners/partners.html","<div id=\"partners\" class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Socios</span></div><div class=\"product-count secondary-text\">\n<span>No de socios:</span> <span>{{vm.total}}</span></div></div><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><form layout=\"row\" layout-align=\"start center\" flex><md-icon \nmd-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon><input ng-model=\"vm.keyword\" \nclass=\"search-input\" type=\"text\" placeholder=\"Buscar\" flex><div class=\"w-8\"></div><md-button \nng-disabled=\"vm.keyword === vm.innerKeyword\" type=\"submit\" class=\"md-raised md-background\" ng-click=\"vm.search()\">\n<span>BUSCAR</span></md-button></form></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAdd()\">\n<span>Nuevo</span></md-button></div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-radio-group \nng-model=\"vm.showFamiliars\" class=\"white-fg pt-10\" layout=\"row\" ng-change=\"vm.getPartners()\"><md-radio-button \nng-value=\"{{false}}\" aria-label=\"onlyTitulars\">Solo Titulares</md-radio-button><md-radio-button ng-value=\"{{true}}\" \naria-label=\"all\">Titulares y familiares</md-radio-button></md-radio-group></div></div><div class=\"main\" layout=\"row\" \nflex><md-card class=\"partners fullpage-datatable no-padding mr-10\" flex=\"80\"><md-card-content class=\"no-padding\"><table\n class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtPartnersInstance\" \ndt-options=\"vm.dtPartnersOptions\"><thead><tr><th class=\"secondary-text w-30\"><div class=\"table-header\"><span \nclass=\"column-title\">#</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nombre</span></div></th><th class=\"secondary-text w-120\"><div class=\"table-header\"><span \nclass=\"column-title\">No. Credencial</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Inscripción</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">Pagado</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.partners\" \nng-click=\"vm.selectedPartner = item\" ng-dblclick=\"vm.gotoDetail(item)\" \nng-class=\"{\'selected\': item.id === vm.selectedPartner.id }\" class=\"selectable\"><td class=\"text-align-center\">\n{{item.sequentialNumber}}</td><td>{{item.completeName}}</td><td>C{{item.credentialCode}}</td><td>\n{{item.inscriptionDate | date: \'dd/MM/yyyy\'}}</td><td>{{item.payedDate | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table>\n</md-card-content><div class=\"custom-paginator\" flex fxlayout=\"row\" fxlayoutalign=\"end center\" fxlayoutgap=\"10px\"><span\n class=\"info\">Página {{ vm.pageIndex }} de {{ vm.pageTotal }}</span><md-button class=\"md-raised ml-8\" \nng-disabled=\"vm.pageIndex == 1\" ng-click=\"vm.previousPage()\">Anterior</md-button><md-button class=\"md-raised\" \nng-disabled=\"vm.pageIndex >= vm.pageTotal\" ng-click=\"vm.nextPage()\">Siguiente</md-button></div></md-card><md-card \nclass=\"partner-details no-padding mr-10\" flex=\"20\"><md-card-content><div ng-if=\"vm.selectedPartner\"><div \nclass=\"text-align-center\"><img \nng-if=\"vm.selectedPartner && vm.selectedPartner.picturePathName && vm.selectedPartner.picturePathName && vm.selectedPartner.picturePathName != \'\'\" \nclass=\"partner-image\" ng-src=\"{{vm.picturesUrl}}{{vm.selectedPartner.picturePathName}}\"> <img \nng-if=\"!vm.selectedPartner || !vm.selectedPartner.picturePathName || vm.selectedPartner.picturePathName == \'\'\" \nclass=\"partner-image\" src=\"assets/images/avatars/profile.jpg\"></div><div layou=\"row\" class=\"pr-20 pt-5\"><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"edit-button md-icon-button md-raised md-accent\" flex-1 \nng-click=\"vm.gotoDetail(vm.selectedPartner)\" aria-label=\"Detalles de usuario\" ng-show=\"vm.selectedPartner\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Mostrar</md-tooltip></md-button><md-button id=\"btnChangeDates\" \nclass=\"md-button md-icon-button md-raised md-accent\" flex-1 ng-click=\"vm.changePayedDatesShow($event)\" \nng-show=\"vm.selectedPartner\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip>Cambio de fechas</md-tooltip>\n</md-button><md-button class=\"md-button md-icon-button md-raised md-accent\" flex-1 \nng-click=\"vm.sendToOrder(vm.selectedPartner)\" ng-show=\"vm.selectedPartner\"><md-icon md-font-icon=\"icon-currency-usd\">\n</md-icon><md-tooltip>Facturar</md-tooltip></md-button></div><div layout=\"row\"><md-input-container class=\"mb-0\" flex>\n<label>Tipo de Socio:</label><input type=\"text\" ng-model=\"vm.selectedPartner.partnerTypeName\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"mb-0 w-40\" flex><label>ID:</label><input type=\"text\" \nng-model=\"vm.selectedPartner.id\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"mb-0\" flex><label>Cuota:</label><input type=\"text\" ng-model=\"vm.selectedPartner.duePeriodicityDescription\" \ndisabled=\"disabled\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"mb-0\" flex><label>\nTipo de facturación:</label><input type=\"text\" ng-model=\"vm.selectedPartner.calculationModeName\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"mb-0\" flex><label>Número de credencial:</label>\n<input type=\"text\" ng-model=\"vm.selectedPartner.credentialCode\" disabled=\"disabled\"></md-input-container></div></div>\n</div></md-card-content></md-card></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/partner.html","<div id=\"partner\" class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button\n class=\"goto-return-button md-icon-button\" aria-label=\"Ir a clientes\" ng-click=\"vm.gotoReturn()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\"><img \nng-if=\"vm.item && vm.item.picturePathName && vm.item.picturePathName && vm.item.picturePathName != \'\'\" \nclass=\"partner-image\" ng-src=\"{{vm.picturesUrl}}{{vm.item.picturePathName}}\"> <img \nng-if=\"!vm.item || !vm.item.picturePathName || vm.item.picturePathName == \'\'\" class=\"partner-image\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><div layout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n# {{vm.item.sequentialNumber}} - {{vm.item.name}} {{vm.item.fatherLastname}} {{vm.item.motherLastname}}</div><div \nclass=\"subtitle secondary-text\"><span>Detalle de Usuario</span></div></div></div></div><div><md-button \nclass=\"md-icon-button md-raised md-background\" ng-click=\"vm.sendToOrder(vm.item.id)\" ng-show=\"vm.item.id != 0\"><md-icon\n md-font-icon=\"icon-currency-usd\"></md-icon><md-tooltip>Facturar</md-tooltip></md-button><md-button \nclass=\"md-raised md-background\" type=\"submit\" ng-click=\"vm.save()\" ng-disabled=\"!detailForm.$valid || vm.saving\"><span \nng-show=\"vm.saving\">GUARDANDO...</span> <span ng-hide=\"vm.saving\">GUARDAR</span></md-button></div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span>Principal</span></md-tab-label><md-tab-body><div\n class=\"detail-form-container md-background-bg md-whiteframe-1dp\" ms-scroll><form name=\"detailForm\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><label>Tipo de socio</label><md-select \nname=\"partnerType\" ng-model=\"vm.item.partnerTypeId\" required ng-change=\"vm.partnerTypeChange()\"><md-option \nng-value=\"item.id\" ng-repeat=\"item in vm.partnerTypes | filter: { isFamiliar: false, active: true }\">{{ item.name }}\n</md-option></md-select><div ng-messages=\"detailForm.partnerType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Tipo de socio.</span></div></div></md-input-container><div flex layout=\"row\" \nng-if=\"vm.item.partnerTypeId == 2 || vm.item.partnerTypeId == 3\"><md-input-container class=\"md-block w-80\" flex><label>\nSerie</label><input type=\"text\" name=\"accionSerie\" ng-model=\"vm.accion.serie\" cd-enter=\"vm.searchAccion()\" required>\n<div ng-messages=\"detailForm.accionSerie.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese serie.</span>\n</div></div></md-input-container><md-input-container class=\"md-block w-80\" flex><label>Número</label><input \ntype=\"text\" name=\"accionNumber\" ng-model=\"vm.accion.number\" required cd-enter=\"vm.searchAccion()\"><div \nng-messages=\"detailForm.accionNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese número.</span></div>\n</div></md-input-container><md-button class=\"md-icon-button md-accent md-raised\" ng-click=\"vm.showAcciones($event)\" \nflex-1><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip>Buscar Acción</md-tooltip></md-button>\n<md-input-container class=\"md-block\" flex><label>Dueño de la accion</label><input type=\"text\" \nng-model=\"vm.accion.accionista.completeName\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block w-150\" flex><label>Tel</label><input type=\"text\" ng-model=\"vm.accion.accionista.phone\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block w-150\" flex><label>Tel 2</label><input \ntype=\"text\" ng-model=\"vm.accion.accionista.phone2\" disabled=\"disabled\"></md-input-container></div></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre(s)</label><input type=\"text\" name=\"name\" \nng-model=\"vm.item.name\" required md-autofocus ng-disabled=\"isLocked && vm.item.id != 0\" \nng-disabled=\"vm.item.partnerTypeId == 2\"><div ng-messages=\"detailForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese nombre(s).</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Paterno</label><input type=\"text\" name=\"fatherLastname\" \nng-model=\"vm.item.fatherLastname\" required ng-disabled=\"isLocked && vm.item.id != 0\" \nng-disabled=\"vm.item.partnerTypeId == 2\"><div ng-messages=\"detailForm.fatherLastname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Apellido paterno(s).</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Materno</label><input type=\"text\" name=\"motherLastname\" \nng-model=\"vm.item.motherLastname\" ng-disabled=\"isLocked && vm.item.id != 0\" ng-disabled=\"vm.item.partnerTypeId == 2\">\n</md-input-container><div flex-1 ng-if=\"vm.item.id > 0 && vm.item.isRecurrent\"><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.showAutomaticPayment($event)\">Cargo automatico</md-button></div>\n<md-button class=\"md-icon-button md-raised md-accent\" ng-click=\"vm.sendToContract(vm.item.id)\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><md-tooltip>Mostrar Contrato</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-raised md-accent\" ng-click=\"vm.sendToKardex(vm.item.id)\"><md-icon md-font-icon=\"icon-export\">\n</md-icon><md-tooltip>Mostrar Kardex</md-tooltip></md-button></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>País</label><md-select name=\"country\" ng-model=\"vm.item.countryId\" required><md-option \nng-value=\"item.id\" ng-repeat=\"item in vm.countries | filter: { active: true }\">{{ item.name }}</md-option></md-select>\n<div ng-messages=\"detailForm.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione País.</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Sexo</label><md-select name=\"gender\" \nng-model=\"vm.item.genderId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.genders | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"detailForm.gender.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Sexo</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Profesión</label><md-select name=\"profession\" \nng-model=\"vm.item.professionId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.professions | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"detailForm.profession.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Profesión.</span>\n</div></div></md-input-container><md-input-container class=\"md-block w-140\" flex-1><label>Fecha nacimiento</label>\n<md-datepicker ng-init=\"vm.birthdate = (vm.item.birthdate | toDate)\" ng-change=\"vm.birthdateChange()\" \nng-model=\"vm.birthdate\" name=\"birthdate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"year\" md-min-date=\"vm.minBirthdate\" md-max-date=\"vm.maxBirthdate\"></md-datepicker><div \nng-messages=\"detailForm.birthdate.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Seleccione fecha\n</div><div ng-message=\"maxdate\">Fecha incorrecta</div></div></md-input-container><div flex-1 class=\"w-120 p-15 pt-25\">\n<span>({{vm.item.age}} años)</span></div></div><div layout-gt-sm=\"row\"><md-input-container id=\"txtPhone\" \nclass=\"md-block\" flex><label>Telefono</label><input type=\"text\" name=\"phone\" ng-model=\"vm.item.phone\" required><div \nng-messages=\"detailForm.phone.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese teléfono.</span></div>\n</div></md-input-container><md-input-container id=\"txtPhone2\" class=\"md-block\" flex><label>Telefono 2</label><input \ntype=\"text\" name=\"phone2\" ng-model=\"vm.item.phone2\"></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.item.email\" required><div \nng-messages=\"detailForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Ingrese Email.</div>\n<div ng-message=\"email\"><span>Formato de Email incorrecto.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Medio de comunicación</label><md-select name=\"media\" ng-model=\"vm.item.mediaId\" required>\n<md-option ng-value=\"item.id\" ng-repeat=\"item in vm.media | filter: { active: true }\">{{ item.name }}</md-option>\n</md-select><div ng-messages=\"detailForm.media.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccine medio de comunicación.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-1 \nng-show=\"vm.item.id && vm.item.id > 0\"><label>Código de credencial</label><input id=\"txtCredentialCode\" type=\"text\" \nng-model=\"vm.item.credentialCode\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Cuotas</label><md-select name=\"due\" ng-disabled=\"isLocked && vm.item.id != 0\" \nng-model=\"vm.item.dueId\" ng-change=\"vm.dueChange()\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.dues | filter: { active: true, isTitular: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"detailForm.due.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccine cuota.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Periodicidad</label><md-select \nname=\"duePeriodicity\" ng-disabled=\"isLocked && vm.item.id != 0\" ng-model=\"vm.item.duePeriodicityId\" \nng-disabled=\"!vm.item.dueId\" required><md-option ng-value=\"item.periodicityId\" ng-repeat=\"item in vm.duePrices\">\n{{ item.periodicity.name }} ({{item.price | currency : \'$ \' : 2}})</md-option></md-select><div \nng-messages=\"detailForm.duePeriodicity.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione periodicidad de cuota.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Convenios</label><md-select name=\"agreement\" ng-disabled=\"isLocked && vm.item.id != 0\" \nng-model=\"vm.item.agreements\" multiple=\"multiple\"><md-option ng-value=\"item\" ng-repeat=\"item in vm.agreements\">\n{{ item.name }} <span ng-if=\"!item.active\">(INACTIVO)</span></md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Tipo de facturacion</label><md-select name=\"agreement\" \nng-model=\"vm.item.calculationModeId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.calculationModes | filter: { active: true }\">{{ item.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Dias para actualización de fecha</label><input \ntype=\"number\" ng-model=\"vm.item.calculationModeUpdateDays\" min=\"0\"></md-input-container><md-input-container \nclass=\"md-block\" flex-1><md-checkbox ng-model=\"vm.item.isRecurrent\">Cálculo Recurrente</md-checkbox>\n</md-input-container></div><div layout-gt-sm=\"row\" class=\"pt-20\"><md-input-container class=\"md-block\" flex-1><label>\nInscripción</label><md-datepicker ng-init=\"vm.inscriptionDate = (vm.item.inscriptionDate | toDate)\" \nng-change=\"vm.item.inscriptionDate = vm.inscriptionDate\" ng-model=\"vm.inscriptionDate\" name=\"inscriptionDate\" required \nmd-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker></md-input-container>\n<md-input-container class=\"md-block\" flex-1><label>Inicio de pago</label><md-datepicker \nng-init=\"vm.initPayDate = (vm.item.initPayDate | toDate)\" ng-change=\"vm.item.initPayDate = vm.initPayDate\" \nng-model=\"vm.initPayDate\" name=\"initPayDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\" ng-disabled=\"vm.item.id != 0\"></md-datepicker></md-input-container><md-input-container \nclass=\"md-block\" flex-1 ng-if=\"vm.item.id > 0\"><label>Pagado hasta</label><md-datepicker \nng-init=\"vm.payedDate = (vm.item.payedDate | toDate)\" ng-model=\"vm.payedDate\" name=\"payedDate\" \nmd-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\" disabled=\"disabled\"></md-datepicker>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Número de inscripción</label><input \ntype=\"number\" ng-model=\"vm.item.inscriptionNumber\" min=\"0\"></md-input-container><md-input-container class=\"md-block\" \nflex><label>Vendedor:</label><md-select name=\"seller\" ng-model=\"vm.item.sellerId\" required><md-option \nng-value=\"item.id\" ng-repeat=\"item in vm.employees | filter: { active: true, employeeTypeId: 1 }\">\n{{ item.name }} {{item.fatherLastname}} {{item.motherLastname}}</md-option></md-select><div \nng-messages=\"detailForm.deal.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Vendedor.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>MultiClub</label><md-select \nname=\"multiclub\" ng-model=\"vm.item.branches\" multiple=\"multiple\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.branches | filter: { active: true }\">{{ item.name }}</md-option></md-select></md-input-container>\n<md-button flex-1 class=\"md-button md-raised md-accent h-40\" ng-click=\"vm.showClubAccess($event)\" \nng-if=\"vm.item.id > 0\" ng-disabled=\"!vm.item || !vm.item.branches || vm.item.branches.length == 0\">Accesos a club\n</md-button></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block mt-0 mr-10\" flex-1><md-checkbox \nng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container><md-input-container class=\"md-block mt-0 mr-10\" \nflex-1><md-checkbox ng-model=\"vm.item.isBlocked\">Bloqueado</md-checkbox></md-input-container><md-input-container \nclass=\"md-block mt-0 mr-10\" flex-1><md-checkbox ng-model=\"vm.item.isFingerAuthentication\">Autenticación por huella\n</md-checkbox></md-input-container></div></form></div></md-tab-body></md-tab><md-tab ng-if=\"vm.item.id > 0\">\n<md-tab-label><span>Otras cuotas</span></md-tab-label><md-tab-body class=\"no-padding\"><md-content \nclass=\"scrollable no-padding transparent-bg\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-otherCharges/tab-otherCharges.html\'\" \nng-controller=\"PartnersPartnerOtherChargesController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span>Fotos</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-pictures/tab-pictures.html\'\" \nng-controller=\"PartnersPartnerPicturesController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span id=\"tabAddress\">Direcciones</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-address/tab-address.html\'\" \nng-controller=\"PartnersPartnerAddressController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span>Familiares</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-family/tab-family.html\'\" \nng-controller=\"PartnersPartnerFamilyController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0 && vm.item.isRecurrent\"><md-tab-label><span>Ausencias</span></md-tab-label><md-tab-body>\n<md-content class=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-absences/tab-absences.html\'\" \nng-controller=\"PartnersPartnerAbsencesController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span>Actividades</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-activities/tab-activities.html\'\" \nng-controller=\"PartnersPartnerActivitiesController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span>Niveles de Avance</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-levels/tab-levels.html\'\" \nng-controller=\"PartnersPartnerLevelsController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span>Rentables</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-rentables/tab-rentables.html\'\" \nng-controller=\"PartnersPartnerRentablesController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span>Becas</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-becas/tab-becas.html\'\" \nng-controller=\"PartnersPartnerBecasController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span>Resumen Pagos</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-pagos/tab-pagos.html\'\" \nng-controller=\"PartnersPartnerPaymentsController as vm\"></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id > 0\"><md-tab-label><span>Tags</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll \nng-include=\"\'app/main/partners/views/partners/partner/tabs/tab-tags/tab-tags.html\'\" \nng-controller=\"PartnersPartnerTagsController as vm\"></md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/security/views/branches/branch/branch.html","<div class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-return-button md-icon-button\" aria-label=\"Ir a clientes\" ng-click=\"vm.gotoReturn()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">{{vm.item.name}}</div><div class=\"subtitle secondary-text\">\n<span>Detalle de Sucursal</span></div></div></div></div><div><md-button class=\"md-raised md-background\" \nng-click=\"vm.save()\" ng-disabled=\"detailForm.$invalid || (vm.item.id != 0 && settingsForm.$invalid)\"><span>GUARDAR\n</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label><span>\nInformación de Sucursal</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"detailForm\" id=\"detailForm\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre</label><input type=\"text\" name=\"name\" \nng-model=\"vm.item.name\" required md-autofocus><div ng-messages=\"detailForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese nombre(s).</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Almacen</label><md-select name=\"warehouse\" ng-model=\"vm.item.warehouseId\" required>\n<md-option ng-repeat=\"option in vm.warehouses | filter : { active: true }\" ng-value=\"option.id\">{{option.name}}\n</md-option></md-select><div ng-messages=\"detailForm.warehouse.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione almacen.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex-1><label>\nPrefijo de facturacion</label><input type=\"text\" name=\"orderPrefix\" ng-model=\"vm.item.orderPrefix\" required \nmaxlength=\"5\"><div ng-messages=\"detailForm.orderPrefix.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Ingrese prefijo de facturación.</span></div><div ng-message=\"maxlength\"><span>\nPrefijo demasiado largo.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div></form></div></md-tab-body></md-tab><md-tab \nng-disabled=\"vm.item.id == 0\"><md-tab-label><span>Configuraciones</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"settingsForm\" id=\"settingsForm\"><div \nlayout=\"column\"><div layout=\"row\"><h2>Configuraciones de sistema</h2></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Interes</label><input type=\"number\" min=\"0\" max=\"100\" name=\"interes\" \nng-model=\"vm.item.setting.interes\" required><div ng-messages=\"settingsForm.interes.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Interes.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Dias de gracia</label><input type=\"number\" min=\"0\" name=\"daysOfGrace\" \nng-model=\"vm.item.setting.daysOfGrace\" required><div ng-messages=\"settingsForm.daysOfGrace.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese dias de gracia.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-1><md-checkbox ng-model=\"vm.item.setting.useSignatureMouse\">Usa firma con mouse</md-checkbox>\n</md-input-container></div><div layout=\"row\" layout-gt-sm=\"row\"><md-input-container class=\"md-block mb-40\" flex><label>\nTipo de descuento</label><md-select name=\"discountType\" ng-model=\"vm.item.setting.discountType\" required><md-option \nng-repeat=\"item in vm.discountTypes\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div \nng-messages=\"settingsForm.discountType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione tipo de descuento.</span></div></div></md-input-container><md-input-container class=\"md-block mb-40\" flex \nng-if=\"vm.item.setting.discountType == 1\"><label>Orden de descuento</label><md-select \nng-model=\"vm.item.setting.discountOrder\" required><md-option ng-repeat=\"item in vm.discountOrders\" ng-value=\"item.id\">\n{{item.name}}</md-option></md-select></md-input-container></div><div layout=\"row\"><h2>Configuraciones de recibo</h2>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre de empresa</label><input type=\"text\" \nname=\"branchName\" ng-model=\"vm.item.setting.name\"><div ng-messages=\"settingsForm.branchName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Nombre de empresa.</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Dirección de la empresa</label><input type=\"text\" \nname=\"branchAddress\" ng-model=\"vm.item.setting.address\"><div ng-messages=\"settingsForm.branchAddress.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ingrese dirección de la empresa.</span></div></div></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Teléfono</label><input type=\"text\" \nname=\"branchPhone\" ng-model=\"vm.item.setting.phone\"><div ng-messages=\"settingsForm.branchPhone.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Ingrese teléfono.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Email</label><input type=\"text\" name=\"email\" ng-model=\"vm.item.setting.email\"><div \nng-messages=\"settingsForm.email.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese correo electrónico.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Página Web</label><input \ntype=\"text\" name=\"webUrl\" ng-model=\"vm.item.setting.webUrl\"><div ng-messages=\"settingsForm.webUrl.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Ingrese página web.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-1><label>No copias</label><input type=\"number\" name=\"receiptCopies\" \nng-model=\"vm.item.setting.receiptCopies\"><div ng-messages=\"settingsForm.receiptCopies.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese numero de copias del recibo.</span></div></div></md-input-container></div><div \nlayout=\"row\"><h3 class=\"m-0\">Imagen de recibo</h3></div><div layout=\"row\" ng-if=\"vm.item.setting.id != 0\" \nlayout-align=\"start center\"><input type=\"file\" id=\"inputFile\" flex-1><md-button class=\"md-button md-raised md-accent\" \nng-click=\"vm.uploadFile()\" flex-1>Subir</md-button><div class=\"w-50 h-50\" flex><img \nng-if=\"vm.item.setting.logoFile && vm.item.setting.logoFile != \'\'\" class=\"partner-image\" \nng-src=\"{{vm.picturesUrl}}{{vm.item.setting.logoFile}}\"></div></div><div layout=\"row\"><h2>Configuraciones del SAT</h2>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><label>RFC</label><input type=\"text\" name=\"rfc\" \nng-model=\"vm.item.setting.rfc\" required><div ng-messages=\"settingsForm.rfc.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese RFC.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Razon Social</label><input type=\"text\" name=\"razonSocial\" ng-model=\"vm.item.setting.razonSocial\" required>\n<div ng-messages=\"settingsForm.razonSocial.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese razon social.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Regimen Fiscal</label>\n<md-select ng-model=\"vm.item.setting.satRegimenFiscalId\" name=\"satRegimenFiscalId\"><md-option \nng-repeat=\"item in vm.satRegimenFiscales\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div \nng-messages=\"settingsForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container><md-input-container><label><span ng-show=\"vm.validatingZipCode\">... </span>\n<span ng-show=\"!vm.validatingZipCode && vm.item.setting.satZipCode\"><md-icon md-font-icon=\"icon-check\" \nclass=\"green-fg\"></md-icon></span><span ng-show=\"!vm.validatingZipCode && !vm.item.setting.satZipCode\"><md-icon \nmd-font-icon=\"icon-close\" class=\"red-fg\"></md-icon><md-tooltip>Codigo Postal Inválido</md-tooltip></span>Codigo Postal\n</label><input ng-model=\"vm.zipCode\" ng-change=\"vm.zipCodeChange()\" ng-model-options=\"{ debounce: 500 }\" required \nng-disabled=\"vm.viewMode\"></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"20\">\n<label>RFC Predeterminado</label><input type=\"text\" name=\"defaultTargetRfc\" \nng-model=\"vm.item.setting.defaultTargetRfc\" required><div ng-messages=\"settingsForm.defaultTargetRfc.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ingrese RFC predeterminado.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Razon Social Predeterminado</label><input type=\"text\" \nname=\"defaultTargetRazonSocial\" ng-model=\"vm.item.setting.defaultTargetRazonSocial\" required><div \nng-messages=\"settingsForm.defaultTargetRazonSocial.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIngrese Razon Social predeterminado.</span></div></div></md-input-container></div><div layout=\"row\"><h2>Para Facturar\n</h2></div><div layout=\"row\" ng-if=\"vm.item.setting.id != 0\" layout-align=\"start center\"><md-input-container \nclass=\"md-block mt-24\" flex-1><label>Serie</label><input type=\"text\" name=\"invoiceSerie\" \nng-model=\"vm.item.setting.invoiceSerie\" maxlength=\"3\" required><div ng-messages=\"settingsForm.invoiceSerie.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Ingrese Serie.</span></div><div \nng-message=\"maxlength\"><span>Solo se permiten 3 dígitos máximo.</span></div></div></md-input-container>\n<md-input-container class=\"md-block mt-24\" flex-1><label>Número inicial</label><input type=\"number\" \nname=\"invoiceNumberInit\" ng-model=\"vm.item.setting.invoiceNumberInit\" min=\"1\" required><div \nng-messages=\"settingsForm.invoiceNumberInit.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nIngrese Numero inicial.</span></div><div ng-message=\"min\"><span>Mínimo debe ser 1.</span></div></div>\n</md-input-container><md-input-container class=\"md-block w-200 mt-0\" flex-1><label>Modo de facturación</label>\n<md-select ng-model=\"vm.item.setting.invoicingMode\" name=\"invoicingMode\" required><md-option \nng-repeat=\"opt in vm.invoicingModes\" ng-value=\"opt.value\">{{opt.name}}</md-option></md-select><div \nng-messages=\"settingsForm.invoicingMode.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione modo de facturación.</span></div></div></md-input-container></div><div layout=\"row\" \nng-if=\"vm.item.setting.id != 0\" layout-align=\"start center\"><md-button class=\"md-button md-raised md-warn\" \nng-click=\"vm.certificateEdit = true\" ng-show=\"vm.item.setting.certificateFilePath != null && !vm.certificateEdit\">\nCambiar certificado</md-button><div ng-show=\"vm.item.setting.certificateFilePath == null || vm.certificateEdit\"><input \ntype=\"file\" id=\"inputFileCertificate\" flex-1><md-button class=\"md-button md-raised md-accent w-250\" \nng-click=\"vm.uploadCerFile()\" flex-1>Subir certificado</md-button></div><span \nng-show=\"vm.item.setting.certificateFilePath != null && !vm.certificateEdit\">{{vm.item.setting.certificateFileName}}\n</span></div><div layout=\"row\" ng-if=\"vm.item.setting.id != 0\" layout-align=\"start center\"><md-button \nclass=\"md-button md-raised md-warn\" ng-click=\"vm.keyEdit = true\" \nng-show=\"vm.item.setting.keyFilePath != null && !vm.keyEdit\">Cambiar llave</md-button><div \nng-show=\"vm.item.setting.keyFilePath == null || vm.keyEdit\"><input type=\"file\" id=\"inputFileKey\" flex-1><md-button \nclass=\"md-button md-raised md-accent w-250\" ng-click=\"vm.uploadKeyFile()\" flex-1>Subir llave</md-button></div><span \nng-show=\"vm.item.setting.keyFilePath != null && !vm.keyEdit\">{{vm.item.setting.keyFileName}}</span></div><div \nlayout=\"row\" ng-if=\"vm.item.setting.id != 0\" layout-align=\"start center\"><md-button \nclass=\"md-button md-raised md-warn\" ng-click=\"vm.xsltEdit = true\" \nng-show=\"vm.item.setting.satTransformationFilePath != null && !vm.xsltEdit\">Cambiar Cadena Original</md-button><div \nng-show=\"vm.item.setting.satTransformationFilePath == null || vm.xsltEdit\"><input type=\"file\" id=\"inputFileXslt\" \nflex-1><md-button class=\"md-button md-raised md-accent w-250\" ng-click=\"vm.uploadXsltFile()\" flex-1>\nSubir Cadena Original</md-button></div></div><div layout=\"row\" ng-if=\"vm.item.setting.id != 0\" \nlayout-align=\"start center\"><md-button class=\"md-button md-raised md-warn\" ng-click=\"vm.pfxEdit = true\" \nng-show=\"vm.item.setting.pfxFilePath != null && !vm.pfxEdit\">Cambiar PFX</md-button><div \nng-show=\"vm.item.setting.pfxFilePath == null || vm.pfxEdit\"><input type=\"file\" id=\"inputFilePfx\" flex-1><md-button \nclass=\"md-button md-raised md-accent w-250\" ng-click=\"vm.uploadPfxFile()\" flex-1>Subir PFX</md-button></div></div><div \nlayout=\"row\" ng-if=\"vm.item.setting.id != 0\"><md-input-container class=\"md-block\" flex><label>Contraseña</label><input \ntype=\"password\" name=\"certificatePassword\" ng-model=\"vm.item.setting.certificatePassword\"></md-input-container></div>\n<div layout=\"row\"><h2>Datos de detalle de orden de venta</h2></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Descripcion generica</label><input type=\"text\" name=\"satProductDescription\" \nng-model=\"vm.item.setting.satProductDescription\" required><div ng-messages=\"settingsForm.satProductDescription.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ingrese RFC.</span></div></div></md-input-container><cd-sat-select \nlabel=\"Producto del SAT\" api-list=\"products\" md-selected-item=\"vm.item.setting.satProduct\" required flex>\n</cd-sat-select><cd-sat-select label=\"Unidad del SAT\" api-list=\"units\" md-selected-item=\"vm.item.setting.satUnit\" \nrequired flex></cd-sat-select></div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Impuesto</label>\n<md-select ng-model=\"vm.item.setting.satTaxId\" name=\"satTaxId\" required><md-option ng-repeat=\"item in vm.satTaxes\" \nng-value=\"item.id\">[{{item.code}}] {{item.description}}</md-option></md-select><div \nng-messages=\"settingsForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Tipo de Impuesto</label>\n<md-select ng-model=\"vm.item.setting.satTaxTypeId\" name=\"satTaxTypeId\" required><md-option \nng-repeat=\"item in vm.satTaxTypes\" ng-value=\"item.id\">{{item.description}}</md-option></md-select><div \nng-messages=\"settingsForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Valor de impuesto</label>\n<input type=\"text\" name=\"satTaxValue\" ng-model=\"vm.item.setting.satTaxValue\" required><div \nng-messages=\"settingsForm.satTaxValue.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Valor de Impuesto del SAT.</span></div></div></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex><label>Tipo de factura predeterminado</label><md-select \nng-model=\"vm.item.setting.defaultSatInvoiceTypeId\" name=\"defaultSatInvoiceTypeId\"><md-option \nng-repeat=\"item in vm.satInvoiceTypes\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div \nng-messages=\"settingsForm.defaultSatInvoiceTypeId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCampo obligatorio.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nMoneda predeterminada</label><md-select ng-model=\"vm.item.setting.defaultSatCoinId\" name=\"defaultSatCoinId\"><md-option \nng-repeat=\"item in vm.satCoins | orderBy: \'Id\': true\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div \nng-messages=\"settingsForm.defaultSatCoinId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Campo obligatorio.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Metodo de pago predeterminado\n</label><md-select ng-model=\"vm.item.setting.defaultSatPaymentMethodId\" name=\"defaultSatPaymentMethodId\"><md-option \nng-repeat=\"item in vm.satPaymentMethods\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div \nng-messages=\"settingsForm.defaultSatPaymentMethodId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCampo obligatorio.</span></div></div></md-input-container></div><div layout=\"row\"><h2>\nConfiguración de Envío de Correo Electrónico</h2></div><div layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Cliente SMTP</label><input type=\"text\" name=\"emailSmtp\" ng-model=\"vm.item.setting.emailSmtp\">\n</md-input-container><md-input-container class=\"md-block\" flex><label>Email de envío</label><input type=\"text\" \nname=\"emailSender\" ng-model=\"vm.item.setting.emailSender\"></md-input-container><md-input-container class=\"md-block\" \nflex><label>Contraseña de Email de envío</label><input type=\"password\" name=\"emailPassword\" \nng-model=\"vm.item.setting.emailPassword\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nPuerto de envío</label><input type=\"number\" name=\"emailPort\" ng-model=\"vm.item.setting.emailPort\"></md-input-container>\n</div><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>Cliente SMTP Pases</label><input type=\"text\" \nname=\"emailSmtpPases\" ng-model=\"vm.item.setting.emailSmtpPases\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Email de envío Pases</label><input type=\"text\" name=\"emailSenderPases\" \nng-model=\"vm.item.setting.emailSenderPases\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nContraseña de Email de envío Pases</label><input type=\"password\" name=\"emailPasswordPases\" \nng-model=\"vm.item.setting.emailPasswordPases\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nPuerto de envío Pases</label><input type=\"number\" name=\"emailPortPases\" ng-model=\"vm.item.setting.emailPortPases\">\n</md-input-container></div></div></form></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/security/views/userTypes/userType/userType.html","<div class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-return-button md-icon-button\" aria-label=\"Ir a clientes\" ng-click=\"vm.gotoReturn()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.item.name}} {{vm.item.fatherLastname}} {{vm.item.motherLastname}}</div><div class=\"subtitle secondary-text\"><span>\nDetalle de Usuario</span></div></div></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\">\n<span>GUARDAR</span></md-button></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span>Información Principal</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><form nombre=\"detailForm\" id=\"detailForm\"><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Nombre(s)</label><input type=\"text\" \nnombre=\"nombre\" ng-model=\"vm.item.name\" required md-autofocus><div ng-messages=\"detailForm.nombre.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Ingrese nombre(s).</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><md-checkbox ng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><md-checkbox ng-model=\"vm.item.isShowAllProspects\">\nMostrar todos los prospectos</md-checkbox></md-input-container></div></form></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id != 0\"><md-tab-label><span>Accesos</span></md-tab-label><md-tab-body><div \nclass=\"tab-accesos detail-form-container md-background-bg md-whiteframe-1dp\"><div layout-gt-sm=\"row\" \nclass=\"no-padding\"><h2 class=\"w-300\">Seleccione Accesos</h2></div><div layout-gt-sm=\"row\" class=\"no-padding\"><ul \nclass=\"access\"><li ng-repeat=\"menu in vm.access\"><md-checkbox ng-model=\"menu.selected\" ng-change=\"vm.selectAll(menu)\">\n{{menu.label}}</md-checkbox><ul ng-if=\"menu.children.length > 0\"><li ng-repeat=\"submenu in menu.children\"><md-checkbox \nng-model=\"submenu.selected\">{{submenu.label}}</md-checkbox><ul ng-if=\"submenu.children.length > 0\"><li \nng-repeat=\"control in submenu.children\"><md-checkbox ng-model=\"control.selected\">{{control.label}}</md-checkbox></li>\n</ul></li></ul></li></ul></div></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/security/views/branches/branches/branches.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Sucursales</span></div><div \nclass=\"product-count secondary-text\"><span>No de sucursales:</span> <span>{{vm.branches.length}}</span></div></div><div\n class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAdd()\"><span>Nuevo\n</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtBranchInstance\" dt-options=\"vm.dtBranchOptions\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Almacen</span></div></th><th class=\"secondary-text w-50\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text w-70\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.branches\"><td>{{item.id}}</td><td>{{item.name}}</td><td>{{item.warehouse.name}}</td><td><i \nng-if=\"item.active\" class=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-if=\"!item.active\" \nclass=\"icon-cancel red-500-fg\"></i></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoDetail(item.id)\" aria-label=\"Detalles de usuario\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\">\n</md-icon></md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/security/views/userTypes/userTypes/userTypes.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Tipos de usuario</span></div><div \nclass=\"product-count secondary-text\"><span>No de tipos de usuario:</span> <span>{{vm.items.length}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.add()\"><span>Nuevo</span>\n</md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtUserTypesInstance\" dt-options=\"vm.dtUserTypesOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th \nclass=\"secondary-text w-50\"><div class=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th \nclass=\"secondary-text w-110\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.items\"><td>{{item.id}}</td><td>{{item.name}}</td><td><i ng-show=\"item.active\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-show=\"!item.active\" class=\"icon-cancel red-500-fg\"></i>\n</td><td><md-button class=\"md-icon-button hide show-gt-xs\" ng-click=\"vm.edit(item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon></md-button><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.deleteItem(item)\" aria-label=\"Delete\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/security/views/users/user/user.html","<div class=\"catalogs-detail page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"goto-return-button md-icon-button\" aria-label=\"Ir a clientes\" ng-click=\"vm.gotoReturn()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\"><div \nlayout=\"column\" layout-align=\"start start\"><div class=\"h2\">\n{{vm.item.name}} {{vm.item.fatherLastname}} {{vm.item.motherLastname}}</div><div class=\"subtitle secondary-text\"><span>\nDetalle de Usuario</span></div></div></div></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.save()\" \nng-disabled=\"detailForm.$invalid\"><span>GUARDAR</span></md-button></div></div><div class=\"content\"><md-tabs \nmd-dynamic-height><md-tab><md-tab-label><span>Información de Usuario</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><form name=\"detailForm\"><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Nombre(s)</label><input type=\"text\" nombre=\"nombre\" \nng-model=\"vm.item.name\" required md-autofocus><div ng-messages=\"detailForm.nombre.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese nombre(s).</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Paterno</label><input type=\"text\" nombre=\"apellidoPaterno\" \nng-model=\"vm.item.fatherLastname\" required></md-input-container><md-input-container class=\"md-block\" flex><label>\nApellido Materno</label><input type=\"text\" nombre=\"motherLastname\" ng-model=\"vm.item.motherLastname\">\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Usuario</label>\n<input type=\"text\" nombre=\"user\" ng-model=\"vm.item.username\" required><div ng-messages=\"detailForm.user.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ingrese usuario.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Correo electrónico</label><input type=\"text\" nombre=\"email\" \nng-model=\"vm.item.email\" required ng-pattern=\"/^.+@.+\\..+$/\"><div ng-messages=\"detailForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Ingrese correo electrónico.</span></div><div ng-message=\"pattern\">\n<span>No contiene formato de correo electrónico.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" \nng-if=\"vm.item.id == 0\"><md-input-container class=\"md-block\" flex><label>Contraseña</label><input type=\"password\" \nnombre=\"password\" ng-model=\"vm.item.password\" ng-required=\"vm.item.id == 0\"><div \nng-messages=\"detailForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese contraseña.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Confirmacion de Contraseña</label><input \ntype=\"password\" nombre=\"passwordConfirm\" ng-model=\"vm.item.confirmPassword\" ng-required=\"vm.item.id == 0\" \ncompare-to=\"vm.item.password\"><div ng-messages=\"detailForm.passwordConfirm.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese confirmación de contraseña.</span></div><div ng-message=\"compareTo\"><span>\nLas contraseñas no coinciden</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Tipo de usuario</label><md-select ng-model=\"vm.item.userTypeId\" required><md-option \nng-value=\"item.id\" ng-repeat=\"item in vm.userTypes | filter: { active: true }\">{{ item.name }}</md-option></md-select>\n<div ng-messages=\"detailForm.userType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione tipo de usuario.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><md-checkbox \nng-model=\"vm.item.active\">Activo</md-checkbox></md-input-container></div></form></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.item.id != 0\"><md-tab-label><span>Sucursales</span></md-tab-label><md-tab-body><div \nclass=\"detail-form-container md-background-bg md-whiteframe-1dp\"><h2>Sucursales</h2><md-list aria-label=\"Sucursales\">\n<md-list-item class=\"md-2-line\" ng-repeat=\"item in vm.branches\"><md-checkbox ng-model=\"item.selected\" \naria-label=\"Sucursal\"></md-checkbox><div class=\"md-list-item-text\">{{item.name}}</div></md-list-item></md-list></div>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/security/views/users/users/users.html","<div class=\"catalogs page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Usuarios</span></div><div \nclass=\"product-count secondary-text\"><span>No de usuarios:</span> <span>{{vm.users.length}}</span></div></div><div \nclass=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"keyword-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><div><md-button class=\"md-raised md-background\" ng-click=\"vm.gotoAdd()\"><span>Nuevo\n</span></md-button></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \ndatatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Usuario</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th class=\"secondary-text w-30\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text w-100\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.users\"><td>{{item.id}}</td><td>{{item.name}} {{item.fatherLastname}} {{item.motherLastname}}</td>\n<td>{{item.username}}</td><td><i ng-if=\"item.active\" class=\"icon-checkbox-marked-circle green-500-fg\"></i> <i \nng-if=\"!item.active\" class=\"icon-cancel red-500-fg\"></i></td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.gotoDetail(item.id)\" aria-label=\"Detalles de usuario\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\">\n</md-icon><md-tooltip>Editar usuario</md-tooltip></md-button><md-button class=\"edit-button md-icon-button\" \nng-hide=\"item.isBySystem\" ng-click=\"vm.resetPassword(item.id)\" aria-label=\"Detalles de usuario\"><md-icon \nmd-font-icon=\"icon-screen-rotation-lock\" class=\"s16\"></md-icon><md-tooltip>Reestablecer contraseña</md-tooltip>\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/accionistas/views/acciones/dialogs/dialog-massiveAdd/dialog-massiveAdd.html","<md-dialog id=\"acciones-dialog-add\" class=\"catalogs-dialog-detail\"><form name=\"addForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">AGREGAR ACCIONES MULTIPLES</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\" class=\"no-padding\"><div layout=\"row\" flex>\n<div layout=\"column\" flex><div layout=\"row\" layout-align=\"start center\" class=\"p-15\"><md-input-container flex \nclass=\"mr-15\"><label>Serie</label><input type=\"text\" ng-model=\"vm.item.serie\"></md-input-container><md-input-container \nclass=\"md-block\" flex-1><label>Fecha de creación</label><md-datepicker ng-init=\"vm.date = (vm.item.date | toDate)\" \nng-model=\"vm.date\" ng-change=\"vm.item.date = vm.date\" md-placeholder=\"Seleccione\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container class=\"md-icon-float md-block\" flex>\n<label>Inicial</label><input ng-model=\"vm.item.initNumber\" name=\"initNumber\" type=\"number\" min=\"1\" required><div \nng-messages=\"addForm.initNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese número inicial.</span>\n</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\" flex><label>Final</label><input \nng-model=\"vm.item.endNumber\" name=\"endNumber\" type=\"number\" min=\"1\" required><div \nng-messages=\"addForm.endNumber.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nIngrese número final.</span></div></div></md-input-container></div></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"addForm.$invalid || vm.saving\" aria-label=\"GUARDAR\"><span \nng-hide=\"vm.saving\">GUARDAR</span> <span ng-show=\"vm.saving\">GUARDANDO...</span></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/catalogs/views/duesRules/dialogs/dialog-detail/dialog-detail.html","<md-dialog id=\"duesRules-dialog-detail\" class=\"catalogs-dialog-detail\"><form name=\"detailForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">AGREGAR / EDITAR REGLA DE CUOTA</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><div layout=\"row\" flex><div \nlayout=\"column\" flex><md-input-container flex><label>Tipo actual</label><md-select ng-model=\"vm.item.dueCurrentId\" \nng-change=\"vm.dueChange()\" required><md-option ng-repeat=\"opt in vm.dues\" ng-value=\"opt.id\">{{opt.name}}</md-option>\n</md-select></md-input-container><md-radio-group ng-model=\"vm.item.genderId\" flex layout=\"row\"><md-radio-button \nng-repeat=\"item in vm.genders\" ng-value=\"item.id\">{{item.name}}</md-radio-button><md-radio-button ng-value=\"{{null}}\">\nMixto</md-radio-button></md-radio-group><md-input-container class=\"md-icon-float md-block\" flex><label>Acción</label>\n<md-select ng-model=\"vm.item.action\" required><md-option ng-repeat=\"opt in vm.actions\" ng-value=\"opt.key\">{{opt.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-icon-float md-block\" flex \nng-hide=\"!vm.item.action || vm.item.action == \'\'\"><label>Tipo nuevo</label><md-select ng-model=\"vm.item.dueNewId\" \nrequired><md-option ng-repeat=\"opt in vm.newDues\" ng-value=\"opt.id\">{{opt.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-icon-float md-block\" flex><md-checkbox ng-model=\"vm.item.isForced\">\nForzar?</md-checkbox></md-input-container></div></div></md-dialog-content><md-dialog-actions layout=\"row\"><div \nlayout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"detailForm.$invalid || vm.saving\" aria-label=\"GUARDAR\"><span \nng-hide=\"vm.saving\">GUARDAR</span> <span ng-show=\"vm.saving\">GUARDANDO...</span></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/catalogs/views/passes/dialogs/dialog-massivePassesRemove/dialog-massivePassesRemove.html","<div><div class=\"md-dialog-container\" id=\"detail-dialog\"><md-dialog class=\"catalogs-dialog-detail\"><form \nname=\"detailForm\" id=\"detailForm\" class=\"md-inline-form\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nBORRAR multiples pases</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\"><div \nlayout=\"row\"><md-input-container class=\"md-icon-float md-block\" flex><label>Inicial</label><input \nng-model=\"vm.initNumber\" name=\"initNumber\" type=\"number\" min=\"50000\" md-autofocus required><div \nng-messages=\"detailForm.initNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese número inicial.</span>\n</div><div ng-message=\"min\"><span>El numero inicial mínimo es 50,000.</span></div></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" flex><label>Final</label><input ng-model=\"vm.endNumber\" \nname=\"endNumber\" type=\"number\" min=\"50001\" required><div ng-messages=\"detailForm.endNumber.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Ingrese número final.</span></div><div ng-message=\"min\"><span>\nEl numero final mínimo es 50,001.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" ng-click=\"vm.massiveRemove()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"detailForm.$invalid || vm.saving\" aria-label=\"GUARDAR\"><span \nng-hide=\"vm.removing\">BORRAR</span> <span ng-show=\"vm.removing\">BORRANDO...</span></md-button></div>\n</md-dialog-actions></form></md-dialog></div></div>");
$templateCache.put("app/main/catalogs/views/passes/dialogs/dialog-massivePasses/dialog-massivePasses.html","<div><div class=\"md-dialog-container\" id=\"detail-dialog\"><md-dialog class=\"catalogs-dialog-detail\"><form \nname=\"detailForm\" id=\"detailForm\" class=\"md-inline-form\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nMultiples pases</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll layout=\"column\">\n<md-input-container class=\"md-icon-float md-block\" flex><label>Tipo de pase</label><md-select \nng-model=\"vm.pass.passTypeId\" name=\"passTypeId\" md-autofocus required><md-option ng-repeat=\"item in vm.passTypes\" \nng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"detailForm.passTypeId.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Seleccione tipo de pase.</span></div></div></md-input-container><div flex>\nUltimo generado: {{vm.lastNumber}}</div><div flex layout=\"row\"><md-input-container class=\"md-icon-float md-block\" flex>\n<label>Inicial</label><input ng-model=\"vm.pass.initNumber\" name=\"initNumber\" type=\"number\" min=\"50000\" required><div \nng-messages=\"detailForm.initNumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese número inicial.</span>\n</div><div ng-message=\"min\"><span>El numero inicial mínimo es 50,000.</span></div></div></md-input-container>\n<md-input-container class=\"md-icon-float md-block\" flex><label>Final</label><input ng-model=\"vm.pass.endNumber\" \nname=\"endNumber\" type=\"number\" min=\"50001\" required><div ng-messages=\"detailForm.endNumber.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Ingrese número final.</span></div><div ng-message=\"min\"><span>\nEl numero final mínimo es 50,001.</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"detailForm.$invalid || vm.saving\" aria-label=\"GUARDAR\"><span \nng-hide=\"vm.saving\">GUARDAR</span> <span ng-show=\"vm.saving\">GUARDANDO...</span></md-button></div></md-dialog-actions>\n</form></md-dialog></div></div>");
$templateCache.put("app/main/catalogs/views/products/products/dialogs/dialog-massive.html","<md-dialog id=\"massive-products\" class=\"dialogs\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Carga de productos masiva</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" \nng-click=\"vm.close()\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"content fullpage-datatable no-padding\" \nlayout=\"column\" flex><form name=\"massiveForm\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>\nTipo de producto</label><md-select ng-model=\"vm.product.productTypeId\" name=\"productType\" \naria-label=\"Tipo de producto\" ng-change=\"vm.changeType()\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.productTypes | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"massiveForm.productType.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione tipo de producto.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nPrefijo de descripcion de producto</label><input type=\"text\" ng-model=\"vm.product.description\" name=\"description\" \nrequired><div ng-messages=\"massiveForm.description.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIngrese prefijo de descripción del producto.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Prefijo de código</label><input type=\"text\" ng-model=\"vm.product.codePrefix\" \nname=\"codePrefix\" required><div ng-messages=\"massiveForm.codePrefix.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Ingrese prefijo de código.</span></div></div></md-input-container></div></form><h3 class=\"mt-30\" \nng-show=\"vm.loadingTemplate\">Cargando...</h3><div ms-scroll ng-show=\"!vm.loadingTemplate\" dynamic-template \nng-bind-html=\"vm.html\"></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\">\n<div layout=\"row\"><md-button class=\"md-button md-accent-bg\" ng-click=\"vm.accept()\" ng-disabled=\"massiveForm.$invalid\" \naria-label=\"Cargar\">Comenzar carga</md-button></div><div layout=\"row\"><md-button \nclass=\"md-button md-deep-orange-700-bg\" ng-click=\"vm.close()\" aria-label=\"Cerrar\">Cerrar</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/views/plannedProducts/dialogs/dialog-add/dialog-add.html","<md-dialog id=\"planned-products-add-dialog\" class=\"catalogs-dialog-detail\"><form name=\"addForm\" id=\"addForm\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAGREGAR CARGO(S) PERIODICOS</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nclass=\"\"><div layout=\"column\" flex=\"30\"><md-radio-group ng-model=\"vm.item.addType\" layout=\"column\" flex>\n<md-radio-button ng-repeat=\"item in vm.addTypes\" ng-value=\"item.id\" aria-label=\"{{item.ariaLabel}}\" class=\"mr-15\">\n{{item.name}}</md-radio-button></md-radio-group></div><div layout=\"column\" flex=\"70\"><div layout=\"row\" \nng-hide=\"vm.selectingProduct === true\"><div ng-if=\"vm.item.addType == 1\" layout=\"column\" flex><md-input-container \nclass=\"md-block mb-30\"><label>Seleccione un socio</label><md-select ng-model=\"vm.partner\" required \nng-change=\"vm.partnerChange()\"><md-option ng-repeat=\"item in vm.titulares\" ng-value=\"item\">{{item.completeName}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>El cargo corresponde a</label>\n<md-select ng-model=\"vm.item.partnerId\" required ng-disabled=\"!vm.partners || vm.partners.length == 0\"><md-option \nng-repeat=\"item in vm.partners\" ng-value=\"item.id\">{{item.completeName}}</md-option></md-select></md-input-container>\n</div><div ng-if=\"vm.item.addType == 2\" layout=\"column\" flex><md-input-container class=\"md-block mb-30\" flex><label>\nCuotas</label><md-select ng-model=\"vm.item.dueId\" required><md-option ng-repeat=\"item in vm.dues\" ng-value=\"item.id\">\n{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>\nPeriodicidades</label><md-select ng-model=\"vm.item.duePeriodicityId\"><md-option ng-repeat=\"item in vm.periodicities\" \nng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container></div><div ng-if=\"vm.item.addType == 3\" \nlayout=\"row\" flex><md-input-container class=\"md-block\" flex><label>Tipo de socio</label><md-select \nng-model=\"vm.item.partnerTypeId\" required><md-option ng-repeat=\"item in vm.partnerTypes\" ng-value=\"item.id\"><span \nng-hide=\"item.isFamiliar\">Titular - </span><span ng-show=\"item.isFamiliar\">Familiar - </span>{{item.name}}</md-option>\n</md-select></md-input-container></div></div></div></div><div layout=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Productos</label><md-select ng-model=\"vm.product\" required ng-change=\"vm.productChange()\"><md-option \nng-repeat=\"item in vm.inventory\" ng-value=\"item\">{{item.product.name}} - ({{item.price | currency: \'$ \': 2}})\n</md-option></md-select></md-input-container><md-input-container class=\"md-block w-100\" flex-1><label>Monto</label>\n<input type=\"number\" min=\"0\" name=\"productPrice\" ng-model=\"vm.item.price\" required></md-input-container>\n<md-input-container class=\"md-block w-120\" flex-1><label>Vencimiento</label><md-datepicker \nng-init=\"vm.expirationDate = (vm.item.expirationDate | toDate)\" ng-change=\"vm.item.expirationDate = vm.expirationDate\" \nng-model=\"vm.expirationDate\" name=\"expirationDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\" md-min-date=\"vm.minExpiration\"></md-datepicker><div \nng-messages=\"addForm.expirationDate.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nSeleccione fecha</div><div ng-message=\"mindate\">Fecha incorrecta</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><div flex layout=\"row\" layout-align=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"addForm.$invalid || vm.saving === true\" aria-label=\"GUARDAR\"><span ng-hide=\"vm.saving === true\">GUARDAR\n</span> <span ng-show=\"vm.saving === true\">GUARDANDO...</span></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/info/credential/credential.html","<div id=\"pass\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"pass-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-disabled=\"vm.imageSaving || vm.emailSending\" ng-click=\"vm.sendMail()\"><md-icon md-font-icon=\"icon-email\">\n</md-icon><md-tooltip>Enviar por Email</md-tooltip></md-button></div><div id=\"pass-card\" \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"center center\"><div layout=\"column\"><div \nlayout=\"row\" class=\"seller\" layout-align=\"center center\"><table class=\"credential\"><tr><td><table \nclass=\"credential-left\"><tr><td style=\"height: 2.25cm; text-align: left\"><img id=\"img-logo\" ng-src=\"{{vm.logoSource}}\">\n</td></tr><tr><td style=\"height: 3.5cm\"><img \nng-if=\"vm.partner && vm.partner.picturePathName && vm.partner.picturePathName && vm.partner.picturePathName != \'\'\" \nng-src=\"{{vm.picturesUrl}}{{vm.partner.picturePathName}}\"> <img \nng-if=\"!vm.partner || !vm.partner.picturePathName || vm.partner.picturePathName == \'\'\" \nsrc=\"assets/images/avatars/profile.jpg\"></td></tr><tr><td><label style=\"text-align: center\">\n{{vm.partner.name}} {{vm.partner.fatherLastname}} {{vm.partner.motherLastname}}</label></td></tr><tr><td><label \nstyle=\"text-align: center\">Tipo: {{vm.partner.due.name}}</label></td></tr><tr><td><label style=\"text-align: center\">\nNo. Socio: {{vm.partner.sequentialNumber}}</label></td></tr><tr><td style=\"height: 2.25cm\"><div id=\"qrcode\" class=\"qr\">\n</div></td></tr></table></td></tr></table></div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/contract/contract-altea.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Guardar</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.showSignature($event)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon><md-tooltip>Firmar</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.sendByEmail()\" ng-disabled=\"vm.sendingEmail\"><md-icon md-font-icon=\"icon-email\" \nng-show=\"!vm.sendingEmail\"></md-icon><md-icon md-font-icon=\"icon-dots-horizontal\" ng-show=\"vm.sendingEmail\"></md-icon>\n<md-tooltip>Enviar por email</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getLastData()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>Obtener datos nuevamente</md-tooltip></md-button></div><div \nid=\"complete-document\" class=\"card md-whiteframe-8dp\"><table class=\"contract-table\"><tr><td colspan=\"2\" \nstyle=\"border: none\"></td><td colspan=\"2\" style=\"text-align: center; border: none\"><img id=\"img-logo\" \nng-src=\"{{vm.logoSource}}\" class=\"imglogo\"></td><td colspan=\"2\" style=\"text-align: right;  border: none\">\nDIR/ADM/LEG/CSD/20.0<br>ACUERDO DE MEMBRESÍA | CARÁTULA</td></tr><tr><td colspan=\"6\" \nstyle=\"text-align: center; border: none\"><b>NORMAS ADMINISTRATIVAS Y CONTRATO DE SERVICIOS DEPORTIVOS Y RECREATIVOS</b>\n</td></tr><tr><td colspan=\"6\" style=\"text-align: center; border: none\">ACUSE DE RECIBO Y CONFORMIDAD</td></tr><tr><td \ncolspan=\"6\" style=\"text-align: left; border: none\">ALTEA FITNESS, S.A. DE C.V.</td></tr><tr><td style=\"border: none\">\nTipo de membresía:</td><td colspan=\"3\" style=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">\n{{vm.data.dueName}}</span></td><td style=\"border: none\">Fecha de Membresía</td><td \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.date| date: \'dd/MM/yyyy\'}}</span>\n</td></tr><tr><td style=\"border: none\">Nombre del titular y/o usuario(a)</td><td colspan=\"3\" \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.partnerName}}</span></td><td \nstyle=\"border: none\">Fecha de nacimiento<br><span style=\"font-size: 0.8rem\">(dd/mm/aa)</span></td><td \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.birthdate | date: \'dd/MM/yyyy\'}}\n</span></td></tr><tr><td style=\"border: none\">Domicilio:</td><td colspan=\"5\" \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">\n{{vm.data.addressStreet}}, {{vm.data.addressColony}}, {{vm.data.addressMunicipio}}, {{vm.data.addressState}}</span>\n</td></tr><tr><td style=\"border: none\">Correo electrónico</td><td \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.email}}</span></td><td \nstyle=\"border: none\">Teléfono fijo</td><td style=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">\n{{vm.data.addressPhoneNumber}}</span></td><td style=\"border: none\">Telefono celular</td><td \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.AddressPhoneNumber2}}</span></td>\n</tr><tr><td colspan=\"6\" style=\"border: none\"><p style=\"text-align: justify\">\nPor medio de la presente, manifiesto a ustedes que estoy enterado del contenido y alcance legal de las Normas Administrativas y Financieras de \n<b>ALTEA FITNESS S.A. DE C.V.</b>(en lo sucesivo <b>ALTEA WELLNESS CLUB</b>\n). Manifiesto que es mi deseo y voluntad inscribirme y/o reinscribirme al Club deportivo <b>ALTEA WELLNESS CLUB</b>\n, por lo cual, para los efectos administrativos y legales procedentes <b>\nMANIFIESTO QUE ALTEA WELLNESS CLUB HA HECHO DE MI CONOCIMIENTO, ME HA EXPLICADO Y HE ENTENDIDO LOS SERVICIOS OFERTADOS, LOS COSTOS DE INSCRIPCIÓN Y/O MEMBRESÍAS, LAS CUOTAS, PAGOS, PAGOS EXTRAORDINARIOS Y FORMAS DE PAGO, POR LO CUAL, EN ESTE MOMENTO EXPRESO MI ABSOLUTA CONFORMIDAD CON LA NORMATIVIDAD ADMINISTRATIVA, REGLAMENTO DEL CLUB Y LOS COSTOS DE LOS SERVICIOS OFERTADOS QUE ALTEA WELLNESS CLUB ME HA COMUNICADO, LOS CUALES ME OBLIGO A CUMPLIR.\n</b></p></td></tr><tr><td colspan=\"6\" style=\"text-align: center; border: none\">\nDatos fiscales (en caso de requerir factura)</td></tr><tr><td colspan=\"6\" style=\"border: none\">Nombre o Razón Social\n</td></tr><tr><td colspan=\"6\" style=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">\n{{vm.data.razonSocial}}</span></td></tr><tr><td style=\"border: none\">R.F.C:</td><td colspan=\"5\" \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.rfc}}</span></td></tr><tr><td \nstyle=\"border: none\">Calle y número</td><td colspan=\"5\" style=\"border: none; border-bottom: 1px solid #cccccc\"><span \nclass=\"data\">{{vm.data.factAddressStreet}}</span></td></tr><tr><td style=\"border: none\">Colonia:</td><td \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.factAddressColony}}</span></td><td \nstyle=\"border: none !important\">Localidad:</td><td style=\"border: none; border-bottom: 1px solid #cccccc\"><span \nclass=\"data\">{{vm.data.factAddressMunicipio}}</span></td><td style=\"border: none !important\">Estado:</td><td \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.addressState}}</span></td></tr><tr>\n<td style=\"border: none\">Correo electrónico:</td><td colspan=\"5\" \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.FactAddressEmail}}</span></td></tr>\n<tr><td colspan=\"6\" style=\"text-align: center; border: none\">\nAnexo II. Contrato de Servicios de ALTEA FITNESSS.A. DE C.V.</td></tr><tr><td style=\"border: none\">Tipo de membresía:\n</td><td colspan=\"2\" style=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.dueName}}\n</span></td><td style=\"border: none\">Folio de Membresía</td><td colspan=\"2\" \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.folioMembresia}}</span></td></tr>\n<tr><td style=\"border: none\">Nombre del Titular Y/O Usuario:</td><td colspan=\"5\" \nstyle=\"border: none; border-bottom: 1px solid #cccccc\"><span class=\"data\">{{vm.data.partnerName}}</span></td></tr><tr>\n<td style=\"border: none\"></td><td style=\"border: none\">Nombre(s)</td><td style=\"border: none\"></td><td \nstyle=\"border: none\">Apellido Paterno</td><td style=\"border: none\"></td><td style=\"border: none\">Apellido Materno</td>\n</tr><tr ng-repeat=\"dependent in vm.data.familyDetails.dependents\"><td style=\"border: none\">Usuario:</td><td \nstyle=\"border: none; border-bottom: 1px solid #cccccc\">{{dependent.completeName}}</td><td style=\"border: none\">\nFecha de nacimiento:</td><td style=\"border: none; border-bottom: 1px solid #cccccc\">\n{{dependent.birthdate| date: \'dd/MM/yyyy\'}}</td><td style=\"border: none\">Parentesco:</td><td \nstyle=\"border: none; border-bottom: 1px solid #cccccc\">{{dependent.partnerType.name}}</td></tr></table><div \nclass=\"regulation-signature\" style=\"text-align: center\"><img ng-src=\"{{vm.signatureSrc}}\"><br>\n________________________________________________________<div class=\"regulation-signature-data\"><p><span>Nombre:</span>\n {{vm.data.partnerName}}</p><p><span>Fecha</span> {{vm.data.date| date: \'dd/MM/yyyy\'}} <span>No. de Membresia:</span>\n {{vm.data.folioMembresia}}</p></div></div><div class=\"contract-table-footer\"><table \nclass=\"contract-table-footer-terms\"><tr><td style=\"text-align: left\">www.alteawellnessclub.com</td><td \nstyle=\"text-align: right\">Tel: 771 169 0005 / 7711690034</td></tr></table></div><div class=\"page-break\"></div><div \nclass=\"risks-container\"><div class=\"contract-title\" layout=\"row\" layout-align=\"left\">\nCONTRATO DE ADHESIÓN PARA LA PRESTACIÓN DE SERVICIOS DEPORTIVOS E INSTALACIONES</div><div class=\"contract-subtitle\">\nCON EL CONJUNTO DE DERECHOS Y OBLIGACIONES INHERENTES AL PRESENTE CONTRATO Y OBLIGACIONES</div><br><div class=\"risks\">\n<strong>CONTRATO DE ADHESIÓN PARA LA PRESTACIÓN DE SERVICIOS DEPORTIVOS E INSTALACIONES</strong>\n que celebran por una parte <strong>ALTEA FITNESS S.A. DE C.V.</strong> también conocida como <strong>\nALTEA WELLNESS CLUB</strong>, a quien en lo sucesivo se le denominará <strong>EL CLUB</strong>\n y por la otra, la persona cuyos datos aparecen en el presente contrato, denominado <strong>EL TITULAR</strong>\n el cual representa a la (s) persona (s) que además de él tendrán los derechos que concede el presente contrato en su calidad de \n<strong>USUARIO (S)</strong>\n, y que en lo sucesivo y para los efectos del presente contrato se les denominará conjuntamente como <strong>\nEL TITULAR Y/O USUARIO(S)</strong>\n los cuales están de acuerdo con sujetar su voluntad a lo establecido en las siguientes:</div><br><div \nclass=\"contract-subtitle\">CLÁUSULAS</div><br><div class=\"risks\"><strong>PRIMERA.- OBJETO DEL CONTRATO.-</strong>\n A través del presente contrato <strong>EL CLUB</strong> pone a disposición de <strong>EL TITULAR Y/O USUARIO(S)\n</strong>\n sus instalaciones, personal y equipos para la práctica de las actividades deportivas multidisciplinarias que para tal efecto diseñe y establezca \n<strong>EL CLUB</strong> en los términos señalados tanto en el presente contrato como en el reglamento interno de \n<strong>EL CLUB</strong> el cual forma parte integrante del presente contrato. <strong>EL TITULAR Y/O USUARIO (S)\n</strong> manifiesta (n)que previo a la celebración del presente contrato <strong>EL CLUB</strong>\n le dio a conocer sus instalaciones y equipos,los horarios de servicio, los tipos de servicios que presta, los costos y la periodicidad de los pagos, manifestando \n<strong>EL TITULAR Y/O USUARIO(S)</strong> conocer estos y estar conforme con los mismos.<br><br><strong>\nSEGUNDA.- LA MEMBRESÍA.-</strong> El objeto de la membresía, en adelante <strong>LA MEMBRESÍA</strong>\n, es constituir una afiliación entre <strong>EL TITULAR Y/O USUARIO(S) y EL CLUB</strong>\n para el acceso a las instalaciones, personal y equipos para la práctica de las actividades deportivas multidisciplinarias establecidas. A partir de la fecha de adquisición de \n<strong>LA MEMBRESÍA, EL CLUB</strong> acepta y reconoce la membresía de <strong>EL TITULAR Y/O USUARIO(S)</strong>\n, quedando obligado a conducirse conforme las reglas establecidas en el reglamento de <strong>EL CLUB.</strong><br><br>\n<strong>EL TITULAR Y/O USUARIO(S)</strong> reconocen y aceptan expresamente que los derechos que otorga <strong>\nLA MEMBRESÍA</strong> son extensivos únicamente para los miembros que integran <strong>LA MEMBRESÍA</strong>\n que previamente ha quedado establecido y registrado ante <strong>EL CLUB</strong>\n y que estos derechos son intransferibles.<br><br><strong>TERCERA.- COSTO DE LA MEMBRESÍA.-</strong>\n El costo y tipo de <strong>MEMBRESÍA</strong> que acredita a <strong>EL TITULAR Y/O USUARIO(S)</strong>\n como miembro de EL CLUB dependerá del número de usuarios, los cuales se detallan en el <strong>ANEXO 1</strong>\n del presente contrato y que forma parte integrante del mismo.<br><br>El costo de <strong>|LA MEMBRESÍA</strong>\n será único y cubre la filiación entre <strong>EL TITULAR Y/O USUARIO(S) y EL CLUB</strong>, <u>\ndicho costo será independiente</u>\n de las cuotas de mantenimiento, gastos de administración, cuotas extras y demás gastos extraordinarios que se generen por el uso de los servicios que presta \n<strong>EL CLUB</strong>, los cuales en todo caso deberán ser cubiertos por <strong>EL TITULAR Y/O USUARIO(S)</strong>.\n<br><br><strong>EL TITULAR Y/O USUARIO(S)</strong>\n reconocen y aceptan expresamente que el pago (costo) por concepto de <strong>LA MEMBRESÍA</strong>\n por ningún motivo y/o circunstancia será reembolsable.<br><br><strong>LA MEMBRESÍA</strong>\n será vitalicia y no requerirá de renovación siempre y cuando se haga uso de forma continua e ininterrumpida de la misma y se cubran puntual e ininterrumpidamente las cuotas de mantenimiento respectivas.\n<br><br><strong>CUARTA.- CUOTA DE MANTENIMIENTO.-</strong>\n Con el objeto de cubrir el costo de mantenimiento por los servicios, instalaciones y equipo <strong>\nEL TITULAR Y/O USUARIO(S)</strong>\n se obligan a cubrir de forma mensual o anual según su elección, las cuotas mensuales de mantenimiento cuyo costo dependerá del número de usuarios que hagan uso de las instalaciones de \n<strong>EL CLUB</strong> y cuyo costo se detalla en el <strong>ANEXO 1</strong>\n del presente contrato y que forma parte integrante del mismo.</div></div><div class=\"page-break\"></div><div \nclass=\"risks\"><div class=\"risks\"><strong>EL TITULAR Y/O USUARIO(S)</strong>\n están de acuerdo en que el costo de la cuota de mantenimiento tendrá un incremento de forma ANUAL el cual será informado previamente por \n<strong>EL CLUB</strong> con por lo menos <strong>TREINTA DÍAS</strong> de anticipación al incremento mencionado.<br>\n<br>Todo mes de pago es forzoso aun y a pesar de que <strong>EL TITULAR Y/O USUARIO(S)</strong>\n no hayan ocupado los servicios materia del presente contrato. Para el caso de que <strong>EL TITULAR Y/O USUARIO(S)\n</strong> no haya cubierto en tiempo y forma el pago de su cuota mensual, <strong>EL CLUB</strong>\n se reserva el derecho de negar el acceso y/o prestación de los servicios contratados sin responsabilidad alguna.<br>\n<br><strong>QUINTA.- FORMA DE PAGO.- EL TITULAR Y/O USUARIO(S)</strong>\n se obligan a pagar la cuota de mantenimiento mencionada en la cláusula CUARTA anterior <strong>\nA MÁS TARDAR EL QUINTO DÍA NATURAL (CALENDARIO) DE CADA MES</strong> con las siguientes formas de pago:<br><br><ol \nclass=\"olAlteaLetra\"><li><strong>\nDIRECTAMENTE EN SUCURSAL BANCARIA MEDIANTE EL USO DE FICHA DE DEPÓSITO EN EL BANCO (BANBAJIO) No. DE CUENTA 27415454 O BIEN POR TRANSFERENCIA ELECTRÓNICA O SPEI A LA CLABE 030290900020810846. BANCO BANBAJIO A NOMBRE DE ALTEA FITNESS, S.A. DE C.V.\n</strong></li><li><strong>MEDIANTE CARGO A TARJETA DE CREDITO Y/O DÉBITO CON TERMINAL PUNTO DE VENTA.</strong></li><li>\n<strong>\nMEDIANTE CARGO A TARJETAS DE CRÉDITO 3 Y 6 MESES SIN INTERESES (UNICAMENTE APLICA PARA EL PAGO DE CUATRO MESES DE LA CUOTA DE MANTENIMIENTO EN ADELANTE ASÍ COMO PARA LA MEMBRESÍA)\n</strong></li><li><strong>MEDIANTE LA DOMICILIACIÓN DE TARJETA DE CRÉDITO Y/O DÉBITO.</strong></li><li><strong>\nMEDIANTE PAGO EN EFECTIVO EN LA CAJA QUE SE UBICA DENTRO DE LAS INSTALACIONES DE EL CLUB.</strong></li></ol><br><br>\n<strong>EL CLUB</strong>\n no reconocerá los pagos que se hayan efectuado en forma diferente a los aquí establecidos. El recibo de caja, ficha de depósito o Boucher bancario obtenido será el comprobante de pago, el cual deberá ser conservado por \n<strong>EL TITULAR Y/O USUARIO(S)</strong> para el caso de cualquier aclaración posterior.<br><br><strong>\nEL TITULAR Y/O USUARIO(S)</strong>\n podrá optar por domiciliar el pago de su cuota mensual a una tarjeta de crédito o débito, en tal caso <strong>\nEL TITULAR Y/O USUARIO(S)</strong> se obligan a tener fondos suficientes para que se realice el cargo correspondiente.\n<br><br><strong>SEXTA.- RECARGOS.-</strong> Para el caso de que <strong>EL TITULAR Y/O USUARIO(S)</strong>\n no efectúen en tiempo y forma el pago de los servicios materia del presente contrato <strong>EL CLUB</strong>\n podrá cobrar a <strong>EL TITULAR Y/O USUARIO(S)</strong>\n un 5% adicional al costo mensual a partir del sexto día natural (calendario) de cada mes en que se preste el servicio; los recargos serán acumulables hasta en tanto \n<strong>EL TITULAR Y/O USUARIO (S)</strong> den cumplimiento con la obligación insoluta.<br><br><strong>\nSÉPTIMA.- CREDENCIAL DE IDENTIFICACIÓN.-</strong>\n Para tener acceso a las instalaciones y poder hacer uso de las mismas así como de los equipos y las actividades deportivas multidisciplinarias \n<strong>EL TITULAR Y/O USUARIO(S)</strong>\n deberán exhibir en el control de acceso la (s) credencial (es) que lo acrediten como miembros de <strong>EL CLUB\n</strong>, dicha (s) credencial (es) deberá (n) ser portada por <strong>EL TITULAR Y/O USUARIO(S)</strong>\n mientras permanezca en las instalaciones de <strong>EL CLUB</strong> y deberá se mostrada cuando el personal de \n<strong>EL CLUB</strong> la solicite.<br><br><strong>OCTAVA.- CUMPLIMIENTO DE LAS NORMAS Y REGLAMENTOS.-</strong>\n Con el objeto de preservar el orden y seguridad de todos los usuarios, <strong>EL TITULAR Y/O USUARIO(S)</strong>\n se obligan a respetar y cumplir en todo momento las disposiciones establecidas en las normas de seguridad, en los reglamentos de cada área de \n<strong>EL CLUB</strong>\n, así como en las indicaciones verbales que señalen los encargados de área y/o entrenadores y/o personal de <strong>\nEL CLUB</strong>\n. Cualquier violación a lo estipulado en la presente cláusula será causa suficiente para suspender los servicios materia del presente contrato sin responsabilidad alguna para \n<strong>EL CLUB</strong>.<br><br><strong>NOVENA.- LIMITE DE RESPONSABILIDAD.- EL TITULAR Y/O USUARIO(S)</strong>\n son los únicos responsables por su condición física, estado de salud y seguridad, por lo cual <strong>EL CLUB</strong>\n recomienda a <strong>EL TITULAR Y/O USUARIO(S)</strong>\n que antes de iniciar cualquier plan de entrenamiento acudan con su profesional de la salud a efecto de que tengan conocimiento de las conveniencias y/o riesgos específicos de practicar actividad física. Derivado de lo anterior \n<strong>EL TITULAR Y/O USUARIO(S)</strong>\n manifiesta (n) que se encuentra (n) apto (s) físicamente para realizar las actividades que ofrece <strong>EL CLUB\n</strong>\n a través de sus instructores y demás personal, por lo que, desde este momento libera de cualquier responsabilidad a \n<strong>EL CLUB</strong>\n por cualquier lesión, accidente, enfermedad, padecimiento,contagio, infección, peligro de muerte o incluso la muerte que \n<strong>EL TITULAR Y/O USUARIO(S)</strong>\n pudiesen sufrir antes, durante o después de efectuar cualquier actividad dentro de <strong>EL CLUB</strong>\n, ya sea por el uso de aparatos de ejercicio, de la práctica de algún deporte o de cualquier otra actividad que se realice dentro de las instalaciones de \n<strong>EL CLUB</strong>.<br><br>Así mismo, <strong>EL CLUB</strong>\n manifiesta que previo a la celebración del presente contrato, ha hecho del conocimiento a <strong>\nEL TITULAR Y/O USUARIO(S)</strong>\n,que los instructores, coaches, entrenadoresy personal en general que prestan sus servicios dentro de las instalaciones de \n<strong>EL CLUB</strong>\n únicamente fungen como personal de apoyo para indicar el uso de los aparatos, entrenamiento o la realización de una actividad física determinada pero en ningún motivo y bajo ninguna circunstancia podrán ser considerados profesionales de la salud, por lo cual tienen prohibido prescribir o sugerir cualquier tipo de dieta o medicamento. Para el caso de que algún miembro del personal de \n<strong>EL CLUB</strong> sugiera a <strong>EL TITULAR Y/O USUARIO(S)</strong>\n algún plan de nutrición o el consumo de algún alimento, medicamento, nutrimento o substancia de cualquier tipo, su consumo será bajo la estricta responsabilidad de \n<strong>EL TITULAR Y/O USUARIO(S)</strong> quienes desde este momento deslindan a <strong>EL CLUB</strong>\n de cualquier responsabilidad por los efectos que pudiesen causarle.<br><br><strong>DÉCIMA.- PERTENENCIAS PERSONALES.-\n</strong> El cuidado de las pertenencias personales y/o bienes de <strong>EL TITULAR Y/O USUARIO(S)</strong>\n serán responsabilidad de cada usuario, razón por la cual <strong>EL CLUB</strong>\n no se hará responsable por las perdidas, robos, extravío, daños y en general por cualquier menoscabo a los objetos de \n<strong>EL TITULAR Y/O USUARIO(S).</strong><br><br><strong>EL TITULAR Y/O USUARIO(S)</strong>\n podrán hacer uso de los lockers una vez que haya efectuado el proceso de contratación y pagado las cuotas establecidas para dicho servicio, esto con el objeto de depositar sus pertenencias, sin embargo, el correcto uso y seguridad de estos corren a cargo del propio \n<strong>TITULAR Y/O USUARIO(S)</strong>, por lo cual deslindan desde este momento de cualquier responsabilidad a \n<strong>EL CLUB</strong> por las pérdidas o robos de sus objetos y pertenecías depositados dentro de los lockers.<br>\n<br><strong>DÉCIMA PRIMERA.- ACCESO DE MENORES DE EDAD.-</strong>\n Los menores de edad deberán acceder a las instalaciones de <strong>EL CLUB</strong>\n acompañadosde un adulto quien será responsable de su integridad y quien deberá acompañar al menor en todo momento.<br>\n<br><strong>DÉCIMA SEGUNDA.- TERMINACIÓN ANTICIPADA.-</strong> Para el caso de que <strong>EL TITULAR Y/O USUARIO(S)\n</strong> decida terminar de forma anticipada el presente contrato, deberá hacerlo del conocimiento por escrito de \n<strong>EL CLUB</strong>\n con por lo menos treinta días de anticipación, debiendo cubrir la cantidad de a un mes de cuota de mantenimiento al momento de efectuar dicha solicitud por concepto de pena convencional.\n<br><br>La solicitud de terminación anticipada la deberá hacer el <strong>TITULAR Y/O USUARIO (S)</strong>\n en términos que se menciona en la presente cláusula y únicamente surtirá efectos cuando su trámite se realice por escrito en el área correspondiente (administración y/o atención al cliente). Cualquier otro procedimiento o solicitud efectuada ante un área o dependencia diferente de la que expresamente se señala en el cuerpo de la presente cláusula, se tendrá por no realizada y en todo caso subsistirá la obligación de pago a cargo de \n<strong>EL TITULAR Y/O USUARIO (S)</strong>\n, en términos y condiciones a que se refiere el apartado VI del presente contrato de servicios.<br><br>Cuando <strong>\nEL TITULAR Y/O USUARIO (S)</strong>\n hubiere efectuado el pago anticipado del periodo (12 meses) y se vean obligados a terminar anticipadamente el presente contrato, se \n<strong><u>\nAPLICARÁ LA DEVOLUCIÓN DEL MONTO PAGADO DEL MES O DE LOS MESES QUE NO DISFRUTARÁ DEL SERVICIO (PREVIA NOTIFICACIÓN POR ESCRITO) AL ÁREA DE ADMINISTRACION Y/O ATENCIÓN AL CLIENTES, CON 20 DÍAS NATURALES DE ANTICIPACIÓN.\n</u></strong><br><br><strong>DÉCIMA TERCERA.- DOMICILIO DE LAS PARTES.-</strong>\n Las partes señalan como sus respectivos domicilios para todo lo relacionado con la interpretación, cumplimiento y en su caso ejecución del presente contrato, los siguientes:\n<br><br><ol class=\"olAlteaLetra\"><li><strong>ELCLUB: ALTEA FITNESS S.A. DE C.V. (ALTEA WELLNESS CLUB)</strong>\n Ubicado en Boulevard Ramón G. Bonfil No. 1800. Col. Venta Prieta C.P. 42184, Pachuca de Soto, Hidalgo.</li><li>\n<strong>EL TITULAR Y/O USUARIO (S)</strong> el domicilio que aparece en los datos correspondientes de <strong>\nEL TITULAR Y/O USUARIO(S)</strong> en el anverso del presente contrato.</li></ol><br><br><strong>\nDÉCIMA CUARTA.- JURISDICCIÓN.-</strong>\n Para todo lo relativo a la interpretación y cumplimiento del presente contrato, las partes se someten de forma expresa a la jurisdicción y competencia de los tribunales de la Ciudad de Pachuca de Soto, Estado de Hidalgo, renunciando de forma expresa a cualquier otra jurisdicción que en razón de sus domicilios presentes o futuros les pudiesen corresponder.\n<br><br>\nEl presente contrato se firma por duplicado en la ciudad de Pachuca de Soto, Estado de Hidalgo, a {{vm.data.date| date: \'dd\'}} de {{vm.data.date| date: \'MM\'}} de {{vm.data.date| date: \'yyyy\'}}.\n</div></div><div class=\"contract-clauses\"><table class=\"contract-clauses-terms\" style=\"width: 100%\"><tbody><tr><td><img\n ng-src=\"{{vm.signatureSrc}}\"><md-button class=\"md-icon-button right md-primary sign-button\" flex \nng-click=\"vm.showSignature()\"><md-icon md-font-icon=\"icon-pencil-box-outline\"></md-icon><md-tooltip>Firmar</md-tooltip>\n</md-button><div class=\"contract-clauses-signature\" style=\"margin-top: 93px\"><label>Nombre:</label><span class=\"data\">\n{{vm.data.partnerName}}</span><br><label>Folio de Membresia:</label><span class=\"data\">{{vm.data.folioMembresia}}\n</span></div></td><td style=\"text-align: center; padding: 0 10px 0 10px\"><label>ALTEA FITNESS S.A. DE C.V.</label><div \nclass=\"contract-clauses-signature\" style=\"margin-top: 80px\"><label>Sello</label><span class=\"data\"></span></div></td>\n</tr></tbody></table></div><div class=\"page-break\"></div><table class=\"contract-table\"><tr><td colspan=\"2\" \nstyle=\"text-align: left;  border: none\">AVISO DE PRIVACIDAD</td><td colspan=\"2\" \nstyle=\"text-align: center; border: none\"></td><td colspan=\"2\" style=\"text-align: right; border: none\">\nDIR/ADM/LEG/APS/20.0<br><img id=\"img-logo\" ng-src=\"{{vm.logoSource}}\" class=\"imglogo\"></td></tr><tr><td colspan=\"6\" \nstyle=\"border: none\"><p style=\"text-align: justify\">\nALTEA FITNESS, S.A. DE C.V., mejor conocida como ALTEA WELLNESS CLUB con domicilio en Boulevard Ramón G. Bonfil, número 1800, Colonia Venta Prieta, en la Ciudad de Pachuca de Soto, Estado de Hidalgo, C.P. 42084 y portal de internet alteawellnessclub.com es responsable del uso y protección de sus datos personales razón por la cual le hacemos saber lo siguiente:\n</p><p>\nLos datos personales que recabaremos de usted serán utilizados para las siguientes finalidades necesarias para prestar el servicio que se solicita:\n</p><p><ul><li>Verificar y confirmar su identidad.</li><li>Estableces los datos de contacto.</li><li>\nComercialización de productos y servicios que ofrecemos.</li><li>\nDatos respecto de sus características y su condición física.</li><li>Elaboración y expedición de comprobantes fiscales.\n</li><li>Dar atención al cliente.</li><li>\nAtender y dar seguimiento a dudas, aclaraciones, quejas, sugerencias y reclamaciones.</li><li>\nTratándose de trabajadores o aspirantes que deseen trabajar en ALTEA WELLNESS CLUB los datos recabados se utilizarán para comprobar las cualidades manifestadas por el aspirante, para elaborar el contrato de trabajo y para conformar el expediente laboral.\n</li></ul></p><p>\nDe forma adicional, utilizaremos su información personal para las siguientes finalidades, las cuales NO SON NECESARIAS para prestar el servicio solicitado, pero que podrán permitirnos brindarle un mejor servicio y atención:\n</p><p><ul><li>Informarle respecto de nuestros servicios, ofertas y promociones.</li><li>\nParticipar en nuestros eventos, concursos y sorteos.</li><li>Evaluación de la calidad en el servicio.</li><li>\nEnvío propaganda comercial.</li></ul></p><p>\nEn caso de no desear que sus datos personales sean utilizados para los fines secundarios antes descritos, solicitamos nos escriba un correo a la siguiente dirección a contacto@alteawellnessclub.com; la negativa para el uso de sus datos personales para las finalidades secundarias no podrá ser motivo para que le neguemos los servicios o productos que solicite o contrate con nosotros.\n</p><p>\nPara conocer mayor información sobre los términos y condiciones en que serán tratados sus datos personales, como los terceros con quienes compartimos su información personal y la forma en que podrá ejercer sus derechos ARCO, puede consultar el aviso de privacidad integral en alteawellnessclub.com/privacidad en la sección aviso de privacidad.\n</p><p style=\"text-align: right\">Última modificación 19 de junio de 2020.</p></td></tr></table><div \nclass=\"contract-clauses\"><table class=\"contract-clauses-terms\" style=\"width: 100%\"><tbody><tr><td \nstyle=\"padding: 0 25%; text-align: center\"><div class=\"regulation-signature\" style=\"text-align: center\"><img \nng-src=\"{{vm.signatureSrc}}\"></div><div class=\"contract-clauses-signature\"><label>\nHE LEÍDO Y ACEPTO EL AVISO DE PRIVACIDAD<br><label>NOMBRE Y FIRMA</label></label></div></td></tr><tr><td \nstyle=\"font-size: 1.0em; padding-top: 20px\">\nAVISO DE PRIVACIDAD. ALTEA FITNESS, S.A. DE C.V., también con conocida como ALTEA WELLNESS CLUB, S.A. DE C.V. con domicilio en Boulevard Ramón G. Bonfil, número 1800, Colonia Venta Prieta, en la Ciudad de Pachuca de Soto, Estado de Hidalgo, C.P. 42084 utilizará sus datos personales recabados para: Verificar y confirmar su identidad. Estableces los datos de contacto. Comercialización de productos y servicios que ofrecemos. Datos respecto de sus características y su condición física. Elaboración y expedición de comprobantes fiscales. Dar atención al cliente. Atender y dar seguimiento a dudas, aclaraciones, quejas, sugerencias y reclamaciones. Tratándose de trabajadores o aspirantes que deseen trabajar en ALTEA WELLNESS CLUB los datos recabados se utilizarán para comprobar las cualidades manifestadas por el aspirante, para elaborar el contrato de trabajo y para conformar el expediente laboral. Para más información sobre el tratamiento y los derechos que puede ejercer puede acceder al aviso de privacidad integral en la página de internet https://alteawellnessclub.com/privacidad/\n</td></tr></tbody></table></div><div class=\"page-break\"></div><table class=\"contract-table\"><tr><td colspan=\"2\" \nstyle=\"text-align: left;  border: none\">ACUSE DE RECIBIDO DE REGLAMENTO INTERNO PARA USUARIOS</td><td colspan=\"2\" \nstyle=\"text-align: center; border: none\"></td><td colspan=\"2\" style=\"text-align: right; border: none\">\nDIR/ADM/LEG/RGI/ACUS/20.0<br><img id=\"img-logo\" ng-src=\"{{vm.logoSource}}\" class=\"imglogo\"></td></tr><tr><td \ncolspan=\"6\" style=\"border: none\"><p style=\"text-align: justify\">\nCertifico como titular de la membresía numero {{vm.data.folioMembresia}} que he recibo Reglamento Interno para Usuarios por parte de Altea Fitness S.A. de C.V. (Altea Wellness Club), aceptando términos y condiciones así como el alcances y propósitos de cada una de las pautas, procesos, reglas y normas que en el se establecen.\n</p></td></tr></table><div class=\"contract-clauses\"><table class=\"contract-clauses-terms\" style=\"width: 100%\"><tbody>\n<tr><td style=\"padding: 0 25%; text-align: center\"><div class=\"regulation-signature\" style=\"text-align: center\"><img \nng-src=\"{{vm.signatureSrc}}\"></div><div class=\"contract-clauses-signature\"><label>NOMBRE Y FIRMA DEL TITULAR</label>\n</div></td></tr><tr><td style=\"font-size: 1.0em; padding-top: 20px\">\nAVISO DE PRIVACIDAD. ALTEA FITNESS, S.A. DE C.V., también con conocida como ALTEA WELLNESS CLUB, S.A. DE C.V. con domicilio en Boulevard Ramón G. Bonfil, número 1800, Colonia Venta Prieta, en la Ciudad de Pachuca de Soto, Estado de Hidalgo, C.P. 42084 utilizará sus datos personales recabados para: Verificar y confirmar su identidad. Estableces los datos de contacto. Comercialización de productos y servicios que ofrecemos. Datos respecto de sus características y su condición física. Elaboración y expedición de comprobantes fiscales. Dar atención al cliente. Atender y dar seguimiento a dudas, aclaraciones, quejas, sugerencias y reclamaciones. Tratándose de trabajadores o aspirantes que deseen trabajar en ALTEA WELLNESS CLUB los datos recabados se utilizarán para comprobar las cualidades manifestadas por el aspirante, para elaborar el contrato de trabajo y para conformar el expediente laboral. Para más información sobre el tratamiento y los derechos que puede ejercer puede acceder al aviso de privacidad integral en la página de internet https://alteawellnessclub.com/privacidad/\n</td></tr></tbody></table></div><div class=\"page-break\"></div><table class=\"contract-table\"><tr><td colspan=\"2\" \nstyle=\"text-align: left;  border: none; width: 33.33%\">REGLAMENTO</td><td colspan=\"2\" \nstyle=\"text-align: center; border: none; width: 33.33%\"></td><td colspan=\"2\" \nstyle=\"text-align: right; border: none; width: 33.33%\">DIR/ADM/LEG/RGI/20.0<br><img id=\"img-logo\" \nng-src=\"{{vm.logoSource}}\" class=\"imglogo\"></td></tr><tr><td colspan=\"6\" style=\"border: none; text-align: justify\"><p>\n<strong>BIENVENIDA</strong></p><p>\nEn nombre del Consejo de Administración y nuestro equipo de colaboradores, le damos la más cordial Bienvenida a ALTEA WELLNESS CLUB.\n<br>Cumplir con sus expectativas de calidad y de servicio es nuestro Objetivo.<br>\nContacto: contacto@alteawellnessclub.com Blvd. Ramón G. Bonfil No. 1800. Col Venta Prieta, Pachuca de Soto, Hidalgo. C.P. 42084.\n</p><p><strong>CAPÍTULO I<br>GENERALES</strong></p><p>\nCon el objetivo de establecer reglas claras que propicien un ambiente de armonía y respeto entre nuestros usuarios, así como de regular el funcionamiento y uso de las instalaciones del Club, el Consejo de Administración de ALTEA FITNESS, S.A. DE C.V. en colaboración con las autoridades administrativas, operativas, deportivas y comités, publican el presente reglamento para el conocimiento y cumplimiento de sus usuarios.\n<br></p><ol class=\"olAlteaNumero\"><li>\nPara hacer uso de las instalaciones, es obligatorio haber adquirido los derechos mediante cualquiera de los contratos o formas establecidas por parte de ALTEA WELLNESS CLUB.\n</li><li>\nEl Comité de Aceptación se reserva el derecho de admisión, mismo que aceptará o rechazará las solicitudes que le sean presentadas, con el objetivo de mantener un ambiente sano y cordial dentro ALTEA WELLNESS CLUB.\n</li><li>\nEl Consejo de Administración se reserva el derecho de rechazar o aceptar mediante el contrato correspondiente, la realización de actividades o eventos deportivos, culturales o sociales con acceso a personas que no sean usuarios de ALTEA WELLNESS CLUB.\n</li><li>\nEl acceso a las instalaciones de ALTEA WELLNESS CLUB ya sea como usuario, invitado o contratante se entenderá como un tácito consentimiento de las disposiciones y normas contenidas en este reglamento.\n</li></ol><p><strong>CAPÍTULO II<br>DE LOS USUARIOS</strong></p><p>\nDe acuerdo con el numeral 4 del capítulo I de este reglamento, el acceso a las instalaciones de ALTEA WELLNESS CLUB, ya sea como usuario en cualquiera de sus modalidades o como invitado, le obliga a conocer y estar de acuerdo con las normas contenidas en este reglamento.\n</p><ol class=\"olAlteaNumero\"><li>\nSe llamarán usuarios a las personas que hayan adquirido una membresía mediante cualquiera de los contratos establecidos por ALTEA WELLNESS CLUB.\n</li><li>Los usuarios y tipos de membresías, tendrán las siguientes categorías:</li></ol><p><strong>MEMBRESÍA FAMILIAR\n</strong><br>\nLos integrantes que la conforman deberán ser de línea directa: papá, mamá e hijos menores de 18 años. (Los últimos integrantes tienen costo adicional sobre el precio de lista).\n<br>Es importante que en esta membresía exista un adulto responsable de los menores.</p><p><strong>MEMBRESÍA DE PAREJA\n</strong><br>\nLos integrantes que la conforman NO necesariamente deberán ser familiares, podrán ser: primos, amigos, compañeros de trabajo, etc. Caso especial: Cuando solo exista la figura de Mamá o Papá e hijo(a).\n</p><p><strong>MEMBRESÍA INDIVIDUAL</strong><br>\nComo su nombre lo indica lo conforma un solo integrante mayor de 18 años.</p><p><strong>MEMBRESÍA EMPRESARIAL</strong>\n<br>\nEl uso de esta membresía es de uso exclusivo para organizaciones con las que se tenga un convenio, al igual que sus beneficios.\n</p><p><strong>MEMBRESÍA RESIDENTES</strong><br>\nEn el caso de Altea Luxury & Living, deberá pagar una cuota de inscripción y mantenimiento con un precio preferencial, la cual será asignada por Altea Fitness S.A. de C.V. (Altea Wellness Club).\n</p><p><strong>MEMBRESÍA ARRENDATARIOS</strong><br>\nBeneficio para los arrendatarios de Altea Luxury & Living (Torre 1 y 2). El cual consta de un 50% en el pago de la membresía y la totalidad de la cuota de mantenimiento.\n</p><p><strong>INSCRIPCIONES COLABORADORES</strong><br>\nBeneficio para familiares (cónyuges e hijos) de las personas que colaboran de manera directa o indirectamente con la empresa (Altea Wellnes Club, Altea Luxury & Living).\n</p><p><strong>USUARIO ADICIONAL</strong><br></p><ol class=\"olAlteaNumero\"><li>\nEl usuario titular deberá solicitar por escrito al Consejo de Administración, el ingreso del adicional reservándose el Club el derecho de admisión.\n</li><li>Se entiende como usuario adicional únicamente a los hijos del titular y/o su conyuge.</li><li>\nNo habrá más de cuatro usuarios adicionales por membresía.</li><li>\nLa cuota por usuario adicional será la que la Administración determine en su momento.</li></ol><p><strong>\nUSUARIOS AUSENTES</strong><br>\nSe considera a los titulares y sus dependientes que por determinada circunstancia manifiesten por escrito, con treinta días de anticipación, su imposibilidad de hacer uso de los servicios de ALTEA WELLNESS CLUB. Sus cuotas de ausente correrán a partir del mes siguiente a aquél en que hayan hecho su petición por escrito, concluyendo el período solicitado, el usuario retornará a su calidad de usuario normal.\n</p><ol class=\"olAlteaNumero\"><li>\nEl status de ausencia se podrá solicitar por escrito en al área administrativa y sólo aplica para periodos de dos meses o más, cubriendo el monto de un mes de la cuota de mantenimiento vigente. Dicho monto podrá ser cubierto una vez que el usuario se reincorpore (no aplica para periodos de un mes).\n</li><li>\nEl titular y todos los integrantes de la familia que decidan realizar su pago en cuota de ausente no tendrán derecho de hacer uso de las instalaciones como usuario del Club.\n</li><li>\nEl realizar su pago en cuota ausente se refiere a mantener su membresía actualizada y no acumular algún adeudo, dicha cuota podrá respetarse en ausente por un periodo máximo de doce meses.\n</li><li>La solicitud para pago de cuota de ausente deberá hacerse por escrito treinta días antes de empezar el mes.\n</li><li>\nLos usuarios que estén en calidad de ausentes no podrán ingresar y hacer uso de las instalaciones del Club con pases de cortesía o como invitado de otros usuarios, sólo podrán hacer uso de las instalaciones, pagando su pase con la cuota correspondiente.\n</li></ol><p><strong>DE LAS MEMBRESÍAS</strong></p><ol class=\"olAltea\"><li>\nLa calidad de Residente no obliga ni da derecho al uso de las instalaciones del Club.</li><li>\nPara hacer uso de las instalaciones se requiere tener calidad de usuario, la que será otorgada por el consejo de administración a través del contrato de uso correspondiente.\n</li><li>\nEl titular de la membresía podrá transferir sus derechos previa notificación por escrito así como la firma del formato de “convenio de cesión de derechos”, obligándose el nuevo usuario a firmar un contrato de prestación de servicios y deberá cubrir la cuota de traspaso correspondiente, esta cuota será una cantidad equivalente al 30 % del valor vigente en que el Club tenga a la venta este tipo de membresías.\n</li><li>\nEn el caso de cesión de derechos de membresías, el nuevo titular será responsable de las cuotas de mantenimiento no cubiertas por el usuario original y en general de los adeudos originados por el usuario cedente.\n</li><li>\nEl Club se reserva el derecho de admitir o no a nuevos usuarios de conformidad con la resolución que tome al efecto el Consejo de Administración, el cesionario deberá estar al corriente en el pago de sus cuotas de mantenimiento.\n</li><li>El titular de la membresía no podrá y renuncia al derecho de arrendar el uso de su membresía,</li><li>\nEl interesado en ser usuario ALTEA WELLNESS CLUB, ya sea por la adquisición de una membresía nueva, por la adquisición de una membresía a través de un traspaso. Deberá cubrir los siguientes requisitos:\n<ol><li>Llenar y firmar la solicitud correspondiente.</li><li>Suscribir el contrato de uso correspondiente.</li><li>\nPagar las cuotas de admisión y mantenimiento que fije el Consejo de Administración.</li><li>\nSi el interesado o futuros usuarios pertenecieron antes a ALTEA WELLNESS CLUB, no deberán tener registros de adeudos.\n</li></ol></li></ol><p><strong>CAPÍTULO III</strong></p><p><strong>SON DERECHOS DE LOS USUARIOS</strong></p><ol \nclass=\"olAlteaNumero\"><li>\nTodos los usuarios cualquiera que sea su categoría en que hayan sido admitidos en ALTEA WELLNESS CLUB tendrán los mismos derechos y obligaciones.\n</li><li>\nEl uso y goce de los servicios e instalaciones disponibles propiedad de ALTEA WELLNESS CLUB, siempre que estén al corriente en el pago de sus cuotas, excepto los que estén cubriendo cuota de ausente.\n</li><li>\nPresentar por escrito individualmente a la Administración las sugerencias o comentarios para mejorar las instalaciones y los servicios de ALTEA WELLNES CLUB.\n</li><li>\nParticipar en torneos, actividades y eventos que se promuevan por parte de ALTEA WELLNESS CLUB, siempre y cuando reúnan las condiciones y requisitos que en su momento se solicita.\n</li></ol><p><strong>CAPÍTULO IV</strong></p><p><strong>SON OBLIGACIONES DE LOS USUARIOS</strong><br>\nLa calidad del usuario del Club sólo se comprueba con la credencial, control electrónico o biométrico que para tal efecto implemente el Consejo de Administración. El personal del Club tiene la facultad de solicitar a todas las personas que pretenden utilizar los servicios, instalaciones, establecimientos, locales y demás activos del Club que acrediten su calidad de usuarios, no teniendo derecho a utilizar los servicios que presta el Club quienes no cumplan con esta regla.\n</p><ol class=\"olAlteaNumero\"><li>\nEl cumplimiento de todas y cada una de las disposiciones tanto del contrato inicial de uso de membresía, como de los puntos establecidos en el presente reglamento.\n</li><li>\nEs obligación del titular, hacer del conocimiento de los beneficiarios de su membresía los puntos establecidos en el presente reglamento.\n</li><li>\nConservar una conducta de respeto y tolerancia dentro de ALTEA WELLNESS CLUB, tanto los usuarios como familiares e invitados en su caso.\n</li><li>\nRespetar y guardar toda consideración a los demás usuarios, personal que labora en el Club y Concesionarios del mismo.\n</li><li>\nRespetar los procedimientos de control de acceso vigentes, así como proporcionar su número de membresía y/o credencial, cuando así lo solicite cualquier Empleado del Club.\n</li><li>No introducir alimentos, bebidas y/o sustancias tóxicas al Club.</li><li>\nCumplir con los requisitos de ingreso tanto el titular como cada uno de sus integrantes: Fotografías, copia de identificación oficial, acta de nacimiento, comprobante de domicilio, certificado médico, acta de matrimonio según sea el caso.\n</li><li>\nInformar y actualizar datos generales de domicilio, teléfono, correo electrónico, cuando estos sean diferentes a los proporcionados inicialmente.\n</li><li>\nInformar por escrito del cambio de estado civil de sus hijos, dando de baja a los que pasan de solteros a casados y mayores de 18 años.\n</li><li>\nPara los usuarios mayores de 70 años, será necesaria una carta responsiva liberando a la Administración de ALTEA WELLNESS CLUB de cualquier responsabilidad por el uso de las instalaciones del Club, debiendo renovar anualmente la constancia médica donde indique que se encuentra en condiciones de salud satisfactorias para poder hacer uso de las instalaciones del club.\n</li><li>\nReconocer que el área de enfermería (primeros auxilios) es exclusiva para URGENCIAS, (revisiones físicas, dermatológicas y en su caso atención pre-hospitalaria).\n</li><li>\nSeguir las recomendaciones recibidas por parte del personal calificado del Club cuando estime que la condición física o salud no es la adecuada para practicar alguna actividad física específica.\n</li><li>\nReconocer que el Club no tiene, ni tendrá responsabilidad alguna por cualquier accidente que le pudiera ocurrir al usuario dentro de las instalaciones o por su participación en las actividades o eventos programados.\n</li><li>\nEl usuario deslinda expresamente de cualquier responsabilidad al Club, por cualquier tipo de robos, pérdidas o daños que sufra el usuario, en sus pertenencias o propiedades, así como en su persona, haciendo extensiva esta manifestación a todos y cada uno de sus familiares e invitados. En caso de perdidas mayores o “Casos Fortuitos”, el club no tiene obligación de ninguna índole.\n</li><li>\nPagar las cuotas que le correspondan dentro de los plazos previstos y cubrir de inmediato el importe de los servicios y consumos dentro de las instalaciones del Club, de lo contrario se suspenderá el uso de las instalaciones a los integrantes de la membresía.\n</li><li>\nTodos los pagos que realicen los usuarios serán definitivos y en ningún caso podrán ser reembolsados, aun cuando no se hubiera hecho uso de instalaciones por suspensión, sanción o cancelación de la membresía.\n</li><li>Cubrir los intereses moratorios en el caso de retraso en pago de mantenimiento.</li><li>\nRespetar los límites de velocidad vehicular y de los espacios destinados para los usuarios con capacidades diferentes.\n</li><li>\nNo cometer ningún acto que altere el orden y la disciplina en el Club o en las actividades y servicios que en él se prestan,\n</li><li>No realizar actos que vayan en contra a la moral y las buenas costumbres.</li><li>\nNo promover ni incitar a otros a participar en acciones, solicitudes o peticiones contrarias a los objetivos del club o que deformen sus finalidades ante terceros o autoridades.\n</li><li>\nCuidar las instalaciones, establecimientos, locales, maquinaria, equipos, muebles y demás activos del CLUB, evitando que el mal uso de ellos se haga, motive su deterioro o destrucción y obligándose a cubrir el daño ocasionado, mismo que será evaluado por el área de administración. .\n</li><li>Aceptar y acatar las sanciones que conforme al presente Reglamento se impongan.</li><li>\nPresentar credencial vigente, utilizar el medio electrónico o biométrico implementado para el control de acceso que rija en ese momento para que le sea permitido el ingreso a las instalaciones del Club.\n</li><li>\nQueda prohibido ingresar en estado de ebriedad así como consumir drogas o enervantes, dentro de las instalaciones del Club.\n</li><li>\nLas demás que les imponga el presente reglamento o que determine el Consejo de Administración y se publiquen en el Club.\n</li><li>\nEl Club tendrá la facultad de cerrar todas o parcialmente las instalaciones con el objeto de realizar acciones de mantenimiento y/o reparaciones, así como para realizar el convivio del día del colaborador ALTEA WELLNESS CLUB.\n</li></ol><p><strong>CAPÍTULO V</strong></p><p><strong>DE LAS CUOTAS</strong></p><ol class=\"olAlteaNumero\"><li>\nEl Consejo de Administración de ALTEA WELLNESS CLUB, determinará las cuotas mensuales de mantenimiento y administración, de acuerdo con los diversos tipos de usuarios. Su monto podrá ser modificado al inicio de año o cuando las condiciones económicas que prevalezcan lo requieran por el Consejo de Administración, así como los precios de los servicios adicionales que se utilicen (lockers, clases, pases de invitado, eventos, etc.)\n</li><li>\nLas cuotas de mantenimiento comprenderán periodos mensuales, su pago deberá de realizarse íntegro de la membresía dentro de los cinco primeros días del periodo a cubrir, a partir del sexto día del mes el o los usuario (s) no podrá seguir haciendo uso de los servicios de ALTEA WELLNESS CLUB.\n</li><li>\nEl pago oportuno dentro de los cinco primeros días del mes garantizan la prestación del o los servicios de ALTEA WELLNESS CLUB.\n</li><li>\nEn ningún caso el usuario podrá argumentar el no uso de instalaciones por suspensión temporal de alguno de los servicios o instalaciones de ALTEA WELLNESS CLUB, originadas por obras de mantenimiento y conservación, hechos o actos de terceros, por caso fortuito, de fuerza mayor o cualquier otra causa para liberarse de la obligación del pago de cuotas de mantenimiento, ya que la inasistencia a ALTEA WELLNESS CLUB, en todo caso se entenderá por causas imputables al usuario.\n</li><li>\nLos usuarios que dejen de cubrir sus cuotas mensuales, deberán liquidar el total de sus adeudos pendientes para hacer uso de los servicios de ALTEA WELLNESS CLUB.\n</li><li>\nLos usuarios sólo podrán cambiar de modalidad de pago de cuota de mantenimiento dos veces al año, ya sea de familiar a pareja o individual, o viceversa, cubriendo la diferencia entre el costo de membresías, si fuese el caso.\n</li><li>\nLas cuotas de invitados deberán pagarse al momento que se requiera, por parte del titular de la membresía, en caso de que se requiera fuera del servicio de caja, el titular podrá firmar el documento de aviso y aceptación de cargo a la membresía donde se indica cantidad de pases y precio unitario.\n</li></ol><p><strong>CAPÍTULO VI</strong></p><p><strong>DE LAS FORMAS DE PAGO</strong></p><ol class=\"olAlteaNumero\">\n<li>\nSe podrá pagar en la caja del club, con efectivo o tarjeta de débito o crédito, en el horario establecido, debiendo verificar las tarjetas aceptadas en el establecimiento.\n</li><li>\nTransferencia electrónica. El usuario podrá realizar el pago de su cuota de mantenimiento por transferencia electrónica o SPEI a la CLABE 030290900020810846 BANCO BanBajío a nombre de ALTEA FITNESS, S.A. DE C.V., Una vez realizada la transferencia, deberá enviar comprobante del pago a la administración del club para su aplicación y facturación correspondiente al correo caja@alteawellnessclub.com Si la transferencia se realiza después del día cinco del mes, se deberá cubrir el monto total de la cuota vigente, renunciando a cualquier descuento o beneficio adquirido.\n</li><li>\nPagos con cargo automático (domiciliación). - El usuario que desee realizar su pago con cargo automático a su tarjeta de crédito, débito o cuenta de cheques, deberá firmar una carta de autorización para el cobro de su cuota de mantenimiento.\n</li><li>\nDirectamente en el banco mediante el uso de ficha de depósito bancario (BANCO BANBAJIO) al número de cuenta 27415454.\n</li></ol><p><strong>CAPÍTULO VII</strong></p><p><strong>REGLAMENTOS PARA USO DE LAS DIVERSAS INSTALACIONES</strong>\n<br>\nEs responsabilidad y prerrogativa del personal de Deportes, Mantenimiento y Administración, apoyado por el personal de Seguridad, mantener un clima de orden, respeto y disciplina dentro de las instalaciones, para su cumplimiento, tienen facultades discrecionales de acuerdo al reglamento vigente de ALTEA WELLNESS CLUB, para hacer:\n</p><ol class=\"olAlteaNumero\"><li>\nCumplir el reglamento interno de ALTEA WELLNESS CLUB y de los reglamentos particulares de cada área y/o servicio o actividades deportivas o culturales.\n</li><li>\nQue las clases que no tengan un Quórum según el área serán suspendidas y se suplirán por actividades de mayor interés para los usuarios.\n</li><li>\nEl programa de actividades deportivas y recreativas, incluye un listado de actividades diversas en diferentes días y horarios, este es un servicio que otorga el Club a sus usuarios, mismo que puede sufrir modificaciones de acuerdo a la participación de los usuarios. Este programa de actividades se reducirá a guardias de servicio en la última semana de diciembre y primera semana de enero, mismas que serán notificadas con anticipación.\n</li><li>\nQue los usuarios disfrutarán de los servicios haciendo uso del equipo con el atuendo apropiado, conforme al reglamento particular que se expida para cada área o deporte.\n</li><li>\nQue para ejercer actividades de comercio o publicitarias de cualquier tipo dentro de las instalaciones de ALTEA WELLNESS CLUB, será necesario que la administración autorice mediante el contrato y se paguen los derechos correspondiente al ejercicio de actividades.\n</li><li>\nQue los invitados se registren en el libro correspondiente, se identifiquen con documento oficial con fotografía vigente.\n</li><li>\nQue el acceso a las instalaciones de ALTEA WELLNESS CLUB, obliga a aceptar las normas contenidas en este reglamento.\n</li></ol><p><strong>REGLAMENTO DE CARÁCTER GENERAL</strong></p><ol class=\"olAltea\"><li>\nEstá terminantemente prohibido introducir al club cualquier clase de materiales inflamables, armas de fuego, explosivos, objetos punzocortantes y cualquier otro que ponga en riesgo la integridad de los usuarios y a las instalaciones del Club.\n</li><li>Está prohibido introducir alimentos y bebidas de cualquier tipo.</li><li>No se permite el ingreso de mascotas.\n</li><li>\nNo se pueden ingresar patines, bicicletas, inflables, patinetas y cualquier otro accesorio que se indique en los reglamentos internos.\n</li><li>\nEstá prohibido el ingreso de altoparlantes, equipos de sonido, pantallas, bocinas y objetos similares que ocasionen desorden y molestias a los usuarios.\n</li><li>\nEl robo sin importar el valor, está considerado como una falta grave que se sancionará con la expulsión definitiva del Club sin amonestación previa.\n</li><li>La velocidad máxima de circulación de vehículos en el estacionamiento será de 10Km/hora.</li><li>\nSe prohíbe utilizar los cajones de estacionamiento destinados a personas con capacidades especiales designadas por la Administración de Club, las cuales tendrán la calcomanía del distintivo que los acredite como usuarios con derecho a estos cajones.\n</li><li>\nLos cajones que corresponden al Club están reservados para el uso exclusivo de los usuarios. Estos deberán respetar los señalamientos relativos a la velocidad, vialidad para peatones, espacio para cada vehículo, áreas específicas para el uso de personas con capacidades diferentes, distintivos, etc. Los choferes y guardias de los usuarios tendrán que sujetarse a estas reglas.\n</li><li>El uso de esta área se tendrá exclusivamente mientras el usuario se encuentre dentro de las instalaciones.\n</li><li>\nTodas las pertenencias de los usuarios introducidas a las instalaciones de ALTEA WELLNESS CLUB, estarán bajo la custodia y responsabilidad de su propietario, por lo que el Club no asume responsabilidad alguna en caso de pérdida de las mismas.\n</li><li>\nLa Administración está facultada para sancionar a los propietarios de los vehículos registrando los hechos o faltas con evidencias fotográficas y estas serán cuando:\n<ol><li>El vehículo esté estacionado en doble fila.</li><li>El vehículo obstruya las zonas peatonales.</li><li>\nEl vehículo obstruya la circulación.</li><li>\nEl vehículo esté ocupando las zonas destinadas para personas con capacidades especiales sin presentar el distintivo correspondiente.\n</li><li>El vehículo sea abandonado en forma permanente y sin previo aviso a la Administración.</li></ol></li><li>\nEl circuito cerrado de vigilancia y su contenido es propiedad de ALTEA FITNESS S.A. DE C.V. (ALTEA WELLNESS CLUB) para lo cual dichos contenidos no podrán ser solicitados por los usuarios en ningún momento y por ninguna situación.\n</li></ol><p><strong>REGLAMENTO DE LOS INVITADOS</strong></p><ol class=\"olAlteaNumero\"><li>\nLos usuarios podrán ser acompañados por invitados, previo pago de la cuota que en su momento fije el Consejo de Administración.\n</li><li>\nLos invitados deberán registrarse en el libro de invitados, identificarse con documento oficial vigente con fotografía.\n</li><li>Los invitados deberán respetar todos los reglamentos, así como observar normas generales de buena conducta.\n</li><li>Será responsabilidad del usuario la conducta de sus invitados durante su estancia en el club.</li><li>\nEl invitado sólo podrá ingresar acompañado del titular de la membresía. Si el titular se retira, el invitado no podrá permanecer en las instalaciones.\n</li></ol><p><strong>REGLAMENTO DE LOS CHOFERES Y NANAS</strong></p><ol class=\"olAlteaNumero\"><li>\nLos choferes y personal de seguridad que vengan acompañando a los usuarios del club, no podrán entrar a éste y deberán permanecer en el estacionamiento o en el lugar que se destine para ellos.\n</li><li>\nLas nanas y empleadas domésticas que están cuidando o atendiendo a los menores sólo podrán acompañarlos a los baños de niños o niñas, alberca y restaurante, jardines y juegos infantiles, pero queda estrictamente prohibido que hagan uso de las instalaciones del Club.\n</li><li>\nLos usuarios del club, deberán instruir a las personas a que se refiere este reglamento para que cumplan con las disposiciones que dicte el Consejo de Administración. Y se comporten debidamente con orden y respeto.\n</li></ol><p><strong>REGLAMENTO DEL RESTAURANT-BAR</strong></p><ol class=\"olAlteaNumero\"><li>\nEl servicio de bar y restaurant será limitado a las áreas destinadas para ello.</li><li>\nEstá prohibido introducir alimentos y bebidas de cualquier tipo que no hayan sido adquiridos en restaurante o barras, así como, enervantes o drogas.\n</li><li>Está prohibido que los menores de edad consuman bebidas alcohólicas.</li><li>\nDeberá sujetarse al horario que sea establecido por la Administración en conjunto con el concesionario.</li><li>\nNo está permitido el acceso en traje de baño o sin usar la ropa adecuada al restaurante bar y lugares de reunión.</li>\n<li>\nEl personal del área de restaurant y snack bar, tienen prohibida la venta de bebidas con contenido etílico a menores de edad.\n</li><li>\nEl club no se hace responsable por objetos olvidados o extraviados dentro de las instalaciones de restaurante, bar, snack y cualquier otra área.\n</li><li>El Club se reserva el derecho de admisión y servicio a cualquier usuario o invitado.</li></ol><p><strong>\nREGLAMENTO DE LAS FIESTAS Y REUNIONES</strong></p><ol class=\"olAlteaNumero\"><li>\nLos usuarios que deseen celebrar fiestas, reuniones o cualquier evento particular, deberán contratar los espacios destinados para las mismas directamente en la Administración y cubrir los costos de renta fijados por el Consejo de Administración para usuarios y externos. En el caso de que exista concesión del área de alimentos y bebidas y los eventos requieran servicios de esta área, el evento se acordará con el Concesionario.\n</li><li>\nLos usuarios que no se encuentren al corriente en el pago de sus cuotas de mantenimiento, de cualquier otra cuota especial o cargo que se le haya efectuado, no podrán contratar eventos en las instalaciones del club.\n</li><li>\nEl usuario que contrate algún evento, será responsable de los daños causados a las instalaciones, muebles y equipo usados durante el evento.\n</li></ol><p><strong>REGLAMENTO DE ACONDICIONAMIENTO FÍSICO</strong></p><p><strong>REGLAMENTO GENERAL DEL ÁREA</strong>\n</p><ol class=\"olAlteaNumero\"><li>\nEl uso del equipo de Acondicionamiento Físico (peso libre, peso integrado y cardiovascular) es exclusivo para Usuarios activos e invitados de Altea Wellness Club.\n</li><li>El uso de ropa y calzado deportivo es obligatorio.</li><li>\nEs responsabilidad de cada Usuario recoger los equipos que utilice (mancuernas, barras, discos, accesorios, materiales, etc.) y colocarlos en su lugar al término de su rutina.\n</li><li>\nLos Instructores de Acondicionamiento Físico de Altea Wellness Club son los únicos autorizados para brindar asesoramiento en el uso del equipo, orientación para establecer rutinas de entrenamiento y entrenamientos personalizados.\n</li><li>\nLa contratación de un Instructor para entrenamientos personalizados se realizará única y exclusivamente a través del área administrativa del club.\n</li><li>\nEn caso de presentar alguna lesión, cirugía o embarazo, notificar al Instructor a cargo, y es responsabilidad de cada Usuario hacer uso del equipo.\n</li><li>Actuar respetuosamente hacia el Staff y demás Usuarios.</li><li>\nAtender las indicaciones del personal encargado del área.</li><li>\nToda sugerencia con respecto a las actividades y del área, podrán ser depositadas en el buzón de sugerencias ubicado en la Administración del Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la administración de Altea Wellness Club.\n</li><li>La empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li>\n</ol><p><strong>HIGIENE</strong></p><ol class=\"olAlteaNumero\"><li>El uso de toalla es obligatorio.</li><li>\nEn atención a los demás Usuarios después de hacer uso del equipo se deberá dejar limpio y seco.</li><li>\nLos vestidores es el único lugar donde se permiten cambios de ropa.</li><li>\nSe prohíbe el acceso a Usuarios que tengan enfermedades infecciosas y/o heridas abiertas.</li></ol><p><strong>\nRESTRICCIONES</strong></p><ol class=\"olAlteaNumero\"><li>\nPor seguridad solo mayores de 15 (quince) años podrán permanecer y hacer uso del área de Acondicionamiento Físico.</li>\n<li>\nÚnicamente se pueden introducir botellas de plástico con tapa a efecto de mantenerse hidratado, se prohíbe introducir alimentos y botellas de vidrio.\n</li><li>\nLa administración de Altea Wellness Club podrá negar el uso del área de Acondicionamiento Físico en caso de incumplimiento de cualquiera de las normas señaladas.\n</li><li>\nQueda prohibido la impartición de entrenamientos personalizados por Instructores ajenos al Staff de Acondicionamiento Físico de Altea Wellness Club.\n</li><li>\nQueda prohibido hacer mal uso del equipo de Acondicionamiento Físico que pueda causar deterioro o destrucción del mismo (azotar, golpear mancuernas, barras, discos, etc.)\n</li><li>\nQueda prohibido el uso, aplicación, ingesta, compra y venta de cualquier tipo de sustancias dentro de las instalaciones de Altea Wellness Club.\n</li><li>\nQueda prohibido desplazarse o permanecer en el área de Acondicionamiento Físico en traje de baño, bata o sin playera.\n</li><li>La venta y/o promoción de cualquier producto, negocio o servicio queda estrictamente prohibida.</li><li>\nEn atención a los demás Usuarios no se permite el uso de reproductores de música sin audífonos.</li><li>\nSe prohíbe introducir maletas, mochilas y backpacks o similares al área de Acondicionamiento Físico (peso libre y peso integrado)\n</li><li>\nQueda prohibido el uso de palabras altisonantes y/o expresiones corporales obscenas, así como gritar, escupir o chiflar dentro del área de Acondicionamiento Físico.\n</li><li>\nLos Instructores en general tienen la facultad de reportar a la administración a todo aquel Usuario que presente conductas negativas y/o antideportivas, que pongan en riesgo la seguridad e integridad del Staff de Altea Wellness Club o de los Usuarios.\n</li><li>\nEl incumplimiento de este reglamento o mala conducta en el área de Acondicionamiento Físico, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li></ol><p><strong>SEGURIDAD</strong></p><ol class=\"olAlteaNumero\"><li>\nAltea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo.</li></ol><p><strong>\nREGLAMENTO DE CARDIO</strong></p><ol class=\"olAlteaNumero\"><li>\nEl uso de toalla, ropa y calzado deportivo es obligatorio.</li><li>\nEn atención a los demás Usuarios y por higiene, después de hacer uso de un equipo, deberá dejarse seco y limpio.</li>\n<li>Queda prohibido hacer mal uso del equipo de Cardio que pueda causar deterioro o destrucción del mismo.</li><li>\nPor seguridad solo mayores de 13 (trece) años podrán permanecer y hacer uso del área de Cardio.</li><li>\nLos Usuarios de 13 (trece) a 15 (quince) años deberán ser previamente valorados y autorizados por los Instructores de Acondicionamiento Físico para hacer uso del área de Cardio y deberán contar con carta responsiva firmada por Padre o Tutor.\n</li><li>\nLa administración de Altea Wellness Club podrá negar el uso del área de Acondicionamiento Físico en caso de incumplimiento de cualquiera de las normas señaladas.\n</li><li>\nQueda prohibido el uso de palabras altisonantes y/o expresiones corporales obscenas, así como gritar, escupir o chiflar dentro del área de Cardio.\n</li><li>\nÚnicamente se pueden introducir botellas de plástico con tapa a efecto de mantenerse hidratado, se prohíbe introducir alimentos, bebidas alcohólicas y botellas de vidrio al área de Cardio.\n</li><li>No se podrá permanecer en los equipos, mientras no se haga uso de los mismos.</li><li>\nEn atención a los demás Usuarios, no se permite el uso de reproductores de música sin audífonos.</li><li>\nMaletas, mochilas y chamarras no podrá estar cerca, ni sobre los aparatos de Cardio, deberán ser colocadas en el área asignada.\n</li><li>\nLos Instructores en general tienen la facultad de reportar a la administración a todo aquel Usuario que presente conductas negativas y/o antideportivas, que pongan en riesgo la seguridad e integridad del Staff de Altea Wellness Club o de los demás Usuarios.\n</li><li>\nEl incumplimiento de este reglamento o mala conducta en el área de Cardio, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la Gerencia y/o administración de Altea Wellness Club.\n</li><li>La empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li>\n</ol><p><strong>REGLAMENTO DE LOCKERS, VESTIDORES, BAÑOS, REGADERAS, VAPOR, SAUNA, BAÑO FAMILIAR Y TOALLAS.</strong>\n</p><p><strong>REGLAMENTO GENERAL DEL ÁREA</strong></p><ol class=\"olAltea\"><li>\nEl acceso y uso de los servicios de vestidores es para Usuarios e Invitados.</li><li>\nEl acceso a vestidores será de la siguiente manera:<ol><li>Vestidor de Damas<ol><li>\nUsuarios (mujeres) mayores a 12 (doce) años</li><li>\nMenores de 3 (tres) meses a 5 (cinco) años acompañados de un adulto (mujer)</li></ol></li></ol></li><li>\nVestidor de Caballeros<ol><li>Usuarios (hombres) mayores a 12 (doce) años</li><li>\nMenores de 3 (tres) meses a 5 (cinco) años acompañados de un adulto (hombre)</li></ol></li><li>Vestidor de Niñas<ol>\n<li>Menores (Niñas) de 6 (seis) a 11 (once) años.</li></ol></li><li>Vestidor Niños<ol><li>\nMenores (Niños) de 6 (seis) a 11 (once) años.</li></ol></li><li>\nQueda prohibido el acceso a Usuarios adultos a los vestidores de Menores.</li><li>\nLos Usuarios tienen derecho al uso de toallas que Altea Wellness Club proporciona en el área de vestidores, estas deben devolverse al término de su uso.\n</li><li>El uso de las secadoras es únicamente para el secado de cabello.</li><li>\nEl uso de regaderas es personal, queda estrictamente prohibido más de un adulto por regadera.</li><li>\nSe prohíbe tirar basura en todas las áreas de Vestidores.</li><li>\nSe recomienda el uso de sandalias en el área de Vestidores.</li><li>\nLos servicios (regaderas, secadoras, toallas, vapor, sauna, etc.) del área vestidores serán suspendidos 15 (quince) minutos antes del cierre.\n</li><li>Siempre dirigirse y actuar respetuosamente hacia el Staff y Usuarios.</li><li>\nLa venta y/o promoción de cualquier producto, negocio o servicio queda estrictamente prohibida.</li><li>\nQueda prohibido el uso de palabras altisonantes y/o expresiones corporales obscenas, así como gritar o chiflar dentro del área de Vestidores.\n</li><li>Queda prohibido introducir bebidas alcohólicas al área de Vestidores.</li><li>\nQueda prohibido comer en el área de Vestidores.</li><li>\nQueda prohibido introducir bocinas y utilizar reproductores de música, sin audífonos.</li><li>\nQueda prohibido permanecer y desplazarse desnudo, en el área de terraza y sala de espera de los Vestidores.</li><li>\nLa Administración de Altea Wellness Club podrá negar el uso del área de vestidores en caso de incumplimiento de cualquiera de las normas señaladas.\n</li><li>\nToda sugerencia con respecto al área de Vestidores, podrán ser depositadas en el buzón de sugerencias ubicado en la Administración del Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la Administración de Altea Wellness Club.\n</li><li>\nEl incumplimiento de este reglamento o mala conducta en el área de Vestidores, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li><li>Altea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo.</li><li>\nLa empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li></ol><p>\n<strong>VAPOR Y SAUNA</strong></p><ol class=\"olAlteaNumero\"><li>\nEl uso de toalla (para sentarse) es obligatorio antes de tomar una sesión de vapor o sauna.</li><li>\nSe recomienda ducharse antes de la sesión de vapor o sauna.</li><li>\nEl tiempo máximo de la sesión de vapor o sauna, será de 20 (veinte) minutos.</li><li>\nSe recomienda una sesión de vapor o sauna entre 2 y 3 horas después de una comida.</li><li>\nSe recomienda un descanso de 15 minutos antes de tomar una sesión de vapor o sauna, si se realizó actividad física.\n</li><li>Se recomienda una sesión de vapor o sauna al día.</li><li>\nNO se recomienda ingresar al área de vapor y sauna con joyas, relojes y accesorios de metal.</li><li>\nQueda prohibido el uso de cremas corporales y faciales, exfoliantes, tratamientos capilares, corporales o naturales dentro del área de vapor y sauna.\n</li><li>Queda prohibido depilarse, rasurarse, bañarse o cortarse las uñas en el área de vapor y sauna.</li><li>\nQueda prohibido el acceso al área de vapor y/o sauna a:</li><li>Mujeres embarazadas.</li><li>Menores de edad.</li><li>\nPersonas con diabetes.</li><li>Personas con hipertensión e hipotensión.</li><li>Personas con problemas renales</li><li>\nPersonas con problemas de corazón</li><li>Personas con fiebre.</li><li>\nLa empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li><li>\nEl uso de las instalaciones es responsabilidad del Usuario.</li></ol><p><strong>ACCESO A VESTIDORES DE ALBERCA</strong>\n</p>El acceso a vestidores de alberca será de la siguiente manera:<ol class=\"olAlteaNumero\"><li>Vestidor de Mujeres.\n</li><li>Vestidor de Hombres.</li><li>Vestidor familiar: Únicamente un adulto con más de un menor.</li><li>\nVestidor de bebés: Un adulto con un menor no mayor a 6 (seis) años (Los adultos no podrán bañarse)</li></ol><p><strong>\nDE LOS LOCKERS</strong></p><ol class=\"olAlteaNumero\"><li>\nLos usuarios pueden contar con Locker privado haciendo el pago de la renta que se encuentre vigente en ese momento.\n</li><li>\nEl club no se hace responsable por pérdida o daño de objetos propiedad de sus usuarios, invitados o visitantes.</li>\n<li>\nNingún usuario podrá permitir el uso temporal de su locker a otra persona, con excepción de las registradas para efectos de la cuota de mantenimiento dentro de la membresía respectiva.\n</li><li>\nLos usuarios están obligados a mostrar el recibo o documento que acredite el uso privado del locker, a la Administración del Club cuando esta lo requiera.\n</li><li>\nEn caso de que el Club no cuente con registro que acredite la renta de Locker, tendrá la facultad de desalojar los bienes que se encuentren en su interior, sin responsabilidad para el Club.\n</li><li>\nEl usuario debe desocupar el locker al vencimiento de la renta, cuando no realice el pago por la renovación correspondiente.\n</li><li>\nCuando algún usuario acredite el derecho de uso de un locker y requiera el desalojo de los bienes, deberá notificarlo por escrito con los datos de la persona autorizada a realizar la apertura.\n</li><li>\nLos lockers destinados para uso común no podrán ser asignados a ningún usuario, estos podrán ser usados una sola vez y desocuparlos el mismo día.\n</li><li>Queda estrictamente prohibido introducir alimentos y bebidas que no hayan sido adquiridas dentro del Club</li>\n<li>\nLa administración podrá ordenar al usuario la apertura de su locker para su inspección en caso de tener conocimiento de la existencia de bebidas alcohólicas, objetos o substancias prohibidas, si se hace caso omiso a esta orden, la administración está facultada para abrir el casillero en presencia de un testigo ó fedatario público para su inspección.\n</li><li>Está prohibido colocar cualquier tipo de anuncio, publicidad o imagen en el área de vestidores y Lockers.</li>\n</ol><p><strong>TOALLAS</strong></p><ol class=\"olAlteaNumero\"><li>\nLos Usuarios tienen derecho al uso de toallas que Altea Wellness Club proporciona en el área de vestidores, estas deben devolverse al término de su uso.\n</li><li>\nLa toalla deberá ser asignada por el personal del Club con el Control que tenga establecido al momento, debiendo el usuario acatar el mismo para poder hacer uso de este servicio.\n</li><li>\nEl uso de toallas es exclusivo para usuarios miembros del Club y sus invitados que entran con pase pagado o asignado por el titular de la membresía.\n</li><li>\nEl usuario solo podrá solicitar 2 toallas en el caso de los adultos y 1 toalla en el caso de los niños por día y estas son exclusivas para el secado corporal, en caso de solicitar toalla extra deberá cubrir el precio establecido por la administración.\n</li><li>\nEstá prohibido hacer un uso de las toallas distinto al secado corporal, quien la utilice para limpiar artículos, calzado, etc. la devuelva manchada o dañada, distinta a como la recibió deberá cubrir el precio de la toalla establecido por la administración.\n</li><li>\nEn caso de no devolver una toalla se generara un cobro de: $150 (ciento cincuenta pesos 00/100 m.n)) pesos por toalla chica y $250 (doscientos cincuenta pesos 00/100 m.n) pesos por toalla grande.\n</li></ol><p><strong>REGLAMENTO DE INSTALACIONES DEPORTIVAS</strong><br><br>\nEl uso de las canchas deportivas del Club estará sujeto a los reglamentos específicos de cada una de las siguientes disciplinas:\n</p><p><strong>REGLAMENTO DEL SQUASH</strong></p><ol class=\"olAlteaNumero\"><li>\nEs obligatorio el uso de ropa y calzado diseñado especialmente para la práctica de Squash, el calzado deberá ser de goma o el denominado “non marking”\n</li><li>Es obligatorio el uso de raqueta y pelota de squash.</li><li>\nLa asignación de canchas se realizará en Control de Canchas.</li><li>\nSe asignaran canchas de acuerdo a la disponibilidad.</li><li>\nTodos los jugadores deberán estar presentes en el momento que se asigne la cancha.</li><li>\nUna vez asignada la cancha, no podrá haber cambio de jugadores.</li><li>\nEl tiempo de tolerancia para ingresar a la cancha una vez asignada es de 10 (diez) minutos, una vez transcurrido este tiempo, Control de Canchas podrá reasignar la cancha a Usuarios en espera.\n</li><li>El tiempo de uso de la cancha es de 1 (una) hora, el cual será regulado por el Control de Canchas.</li><li>\nLas personas ajenas al juego no podrán permanecer dentro de la cancha.</li><li>\nNo se podrá hacer uso de las canchas cuando estén en mantenimiento y/o reparación.</li><li>\nLa contratación de un Instructor para entrenamientos personalizados se realizará única y exclusivamente a través del área Administrativa del Club.\n</li><li>\nClases personalizadas y clínicas se realizarán con horario reservado en Control de Canchas, no se podrá hacer reservas consecutivas.\n</li><li>\nLa asignación de canchas para clases, clínicas, academias, torneos y todo tipo de eventos especiales, será organizada por la Coordinación de Canchas y los Instructores de Squash.\n</li><li>Todos los eventos serán informados a los Usuarios con anticipación para la organización de sus actividades.\n</li><li>\nÚnicamente se pueden introducir botellas de plástico con tapa a efecto de mantenerse hidratado, se prohíbe introducir alimentos, bebidas alcohólicas, botellas de vidrio y fumar.\n</li><li>\nLos Instructores en general tienen la facultad de reportar a la administración del club a todo aquel Usuario que presente conductas negativas y/o antideportivas, que pongan en riesgo la seguridad e integridad del Staff de Altea Wellness Club o de los Usuarios.\n</li><li>\nQueda prohibido el uso de palabras altisonantes y/o expresiones corporales obscenas, así como gritar, escupir o chiflar en las canchas de Squash.\n</li><li>\nLa administración de Altea Wellness Club podrá negar el uso del área de las Canchas de Squash en caso de incumplimiento de cualquiera de las normas señaladas.\n</li><li>Altea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo.</li><li>\nEl incumplimiento de este reglamento o mala conducta en las canchas de Squash, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la administración de Altea Wellness Club.\n</li><li>La empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li>\n</ol><p><strong>REGLAMENTO DE CANCHAS DE TENIS</strong></p><ol class=\"olAlteaNumero\"><li>\nEs obligatorio el uso de ropa y calzado diseñado especialmente para la práctica de Tennis, el calzado deberá ser de goma o el denominado “non marking”\n</li><li>Es obligatorio el uso de raqueta y pelota de Tenis</li><li>\nLa asignación de canchas se realizará en Control de Canchas.</li><li>\nSe asignarán canchas de acuerdo a la disponibilidad.</li><li>\nTodos los jugadores deberán estar presentes en el momento que se asigne la cancha.</li><li>\nUna vez asignada la cancha, no podrá haber cambio de jugadores.</li><li>\nEl tiempo de tolerancia para ingresar a la cancha una vez asignada es de 10 (diez) minutos, una vez transcurrido este tiempo, Control de Canchas podrá reasignar la cancha a Usuarios en espera.\n</li><li>El tiempo de uso de la cancha es de 1 (una) hora, el cual será regulado por el Control de Canchas.</li><li>\nLas personas ajenas al juego no podrán permanecer dentro de la cancha.</li><li>\nDe lunes a domingo se jugará en modalidad de dobles en cualquier horario si se cuenta con la disponibilidad de canchas. Se podrá jugar singles mediante solicitud a Control de Canchas.\n</li><li>\nNo se podrá hacer uso de las canchas en caso de lluvia, superficie mojada o cuando estén en mantenimiento y/o reparación.\n</li><li>\nLa contratación de un Instructor para entrenamientos personalizados se realizará única y exclusivamente a través del área Administrativa del Club.\n</li><li>\nClases personalizadas y clínicas se realizarán con horario reservado en Control de Canchas, no se podrá hacer reservas consecutivas.\n</li><li>\nLa asignación de canchas para clases, clínicas, academias, torneos y todo tipo de eventos especiales, será organizada por la Coordinación de Canchas y los Instructores de Tenis.\n</li><li>Todos los eventos serán informados a los Usuarios con anticipación para la organización de sus actividades.\n</li><li>\nÚnicamente se pueden introducir botellas de plástico con tapa a efecto de mantenerse hidratado, se prohíbe introducir alimentos, bebidas alcohólicas, botellas de vidrio y fumar.\n</li><li>\nLos Instructores en general tienen la facultad de reportar a la administración del club a todo aquel Usuario que presente conductas negativas y/o antideportivas, que pongan en riesgo la seguridad e integridad del Staff de Altea Wellness Club o de los Usuarios.\n</li><li>\nQueda prohibido el uso de palabras altisonantes y/o expresiones corporales obscenas, así como gritar, escupir o chiflar en las canchas de Tenis.\n</li><li>\nLa administración de Altea Wellness Club podrá negar el uso del área de las Canchas de Tenis en caso de incumplimiento de cualquiera de las normas señaladas.\n</li><li>Altea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo.</li><li>\nEl incumplimiento de este reglamento o mala conducta en las canchas de Tennis, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la Administración de Altea Wellness Club.\n</li><li>La empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li>\n</ol><p><strong>REGLAMENTO DE CANCHAS DE PÁDEL</strong></p><ol class=\"olAlteaNumero\"><li>\nEs obligatorio el uso de ropa y calzado diseñado especialmente para la práctica de Pádel.</li><li>\nLa asignación de canchas se realizará en Control de Canchas.</li><li>\nSe asignaran canchas de acuerdo a la disponibilidad.</li><li>\nTodos los jugadores deberán estar presentes en el momento que se asigne la cancha.</li><li>\nUna vez asignada la cancha, no podrá haber cambio de jugadores.</li><li>\nEl tiempo de tolerancia para ingresar a la cancha una vez asignada es de 10 (diez) minutos, una vez transcurrido este tiempo, Control de Canchas podrá reasignar la cancha a Usuarios en espera.\n</li><li>El tiempo de uso de la cancha es de 1 (una) hora, el cual será regulado por el Control de Canchas.</li><li>\nLas personas ajenas al juego NO podrán permanecer dentro de la cancha.</li><li>\nDe lunes a domingo se jugará en modalidad de dobles en cualquier horario si se cuenta con la disponibilidad de canchas. Se podrá jugar singles mediante solicitud a Control de Canchas.\n</li><li>\nNo se podrá hacer uso de las canchas en caso de lluvia, superficie mojada o cuando estén en mantenimiento y/o reparación.\n</li><li>\nLa contratación de un Instructor para entrenamientos personalizados se realizará única y exclusivamente a través del área Administrativa del club.\n</li><li>\nClases personalizadas y clínicas se realizarán con horario reservado en Control de Canchas, no se podrá hacer reservas consecutivas.\n</li><li>\nLa asignación de canchas para clases, clínicas, academias, torneos y todo tipo de eventos especiales, será organizada por la Coordinación de Canchas.\n</li><li>Todos los eventos serán informados a los Usuarios con anticipación para la organización de sus actividades.\n</li><li>\nÚnicamente se pueden introducir botellas de plástico con tapa a efecto de mantenerse hidratado, se prohíbe introducir alimentos, bebidas alcohólicas, botellas de vidrio y fumar.\n</li><li>\nQueda estrictamente prohibido el uso y permanencia en canchas de Pádel a menores de 13 años sin la supervisión de un adulto.\n</li><li>\nLos Instructores en general tienen la facultad de reportar a la Administración del Club a todo aquel Usuario que presente conductas negativas y/o antideportivas, que pongan en riesgo la seguridad e integridad del Staff de Altea Wellness Club o de los Usuarios.\n</li><li>\nQueda prohibido el uso de palabras altisonantes y/o expresiones corporales obscenas, así como gritar o chiflar en las canchas de Pádel.\n</li><li>\nLa administración de Altea Wellness Club podrá negar el uso del área de las Canchas de Pádel en caso de incumplimiento de cualquiera de las normas señaladas.\n</li><li>La empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li>\n<li>Altea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo.</li><li>\nEl incumplimiento de este reglamento o mala conducta en el área de Canchas de Pádel, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la Administración de Altea Wellness Club.\n</li><li>La empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li>\n</ol><p><strong>REGLAMENTO DE ALBERCA</strong></p><p><strong>REGLAMENTO GENERAL DEL ÁREA</strong></p><ol \nclass=\"olAltea\"><li>El uso de la Alberca es exclusivo para Usuarios activos e Invitados.</li><li>\nEl uso de sandalias y calzado antiderrapante, es obligatorio para entrar al área de Alberca.</li><li>\nLos horarios de cada actividad estarán visibles para los Usuarios.</li><li>\nSolo se podrá hacer uso de la Alberca en los horarios establecidos que son:<ol><li>Lunes a viernes de 6:00 am a 9:30 pm\n</li><li>Sábados de 7:00 am a 4:30 pm</li><li>Domingos y días festivos de 7:00 am a 1:30 pm</li></ol></li><li>\nAtender las indicaciones del personal a cargo.</li><li>Respetar las áreas asignadas para clases y entrenamientos.</li>\n<li>\nEn horarios de alta demanda de aforo se compartirá carril, por lo que se debe respetar el nado en circuito y el tiempo máximo de nado será de 45 minutos.\n</li><li>La tolerancia para ingresar a una clase una vez iniciada, es de 10 (diez) minutos.</li><li>\nPara el préstamo de material dirigirse con el encargado en turno y devolverlo al término de su uso.</li><li>\nAl salir de la Alberca el uso de bata es obligatorio para desplazarse al área de Vestidores.</li><li>\nAltea Wellness Club se reserva el derecho para determinar el número de clases que se impartirán.</li><li>\nAltea Wellness Club se reserva el derecho de disminuir actividades de acuerdo a sus políticas de aforo.</li><li>\nSiempre dirigirse y actuar respetuosamente hacia el Staff y Usuarios.</li><li>\nEn caso de presentar alguna lesión, cirugía o embarazo se deberá notificar al Instructor a cargo y es responsabilidad del Usuario el uso de las instalaciones.\n</li><li>\nLa venta de cualquier tipo de artículo queda prohibida, al igual que la promoción de otro negocio o servicio dentro del área.\n</li><li>\nToda sugerencia con respecto a las actividades y del área, podrán ser depositadas en el buzón de sugerencias ubicado en la Administración de Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la Administración de Altea Wellness Club.\n</li><li>La empresa no se hace responsable por lesiones provocadas por el uso de los equipos y/o instalaciones.</li>\n</ol><p><strong>HIGIENE</strong></p><ol class=\"olAlteaNumero\"><li>\nLos vestidores es el único lugar donde se permiten cambios de ropa.</li><li>\nEs obligatorio ducharse antes de ingresar a la alberca, para ello se cuenta con regaderas dentro del área.</li><li>\nQueda prohibido el uso de productos corporales o faciales (crema, bronceador, bloqueador, etc.)</li><li>\nPara ingresar al área Alberca es obligatorio el uso de: bata, sandalias, gorro, goggles, traje de baño especial para natación (licra) y toalla.\n</li><li>Por ningún motivo se puede entrar, permanecer o desplazarse descalzo en el área de alberca.</li><li>\nSe prohíbe el acceso a Usuarios que tengan enfermedades infecciosas.</li><li>\nSe prohíbe el uso de la alberca a Usuarios con raspones, heridas o vendajes.</li><li>\nSe prohíbe orinar dentro de la Alberca.</li><li>Para los Bebes el uso de pañal especial para natación es obligatorio.\n</li></ol><p><strong>RESTRICCIONES</strong></p><ol class=\"olAlteaNumero\"><li>\nDentro y fuera de la alberca se prohíbe correr, gritar o empujar.</li><li>\nPara ingresar a la alberca no está permitido el uso de short, playera o cualquier otra prenda que no esté diseñada para la práctica de natación.\n</li><li>En el caso de mujeres no está permitido el uso de traje de baño de dos piezas.</li><li>\nEl uso de aretes y piercing está prohibido dentro de la alberca.</li><li>\nLa Administración de Altea Wellness Club podrá negar el uso del área de alberca en caso de incumplimiento de las normas señaladas.\n</li><li>\nÚnicamente se pueden introducir botellas de plástico con tapa a efecto de mantenerse hidratados, se prohíbe introducir alimentos, bebidas alcohólicas y envases de vidrio.\n</li><li>\nPor seguridad los menores a 15 (quince) años podrán realizar natación de manera libre, siempre y cuando estén bajo la supervisión de un adulto.\n</li><li>Queda prohibido pisar o sentarse en el área de jardineras.</li><li>\nLas maletas, bolsos, mochilas y backpacks deberán colocarse en el área asignada.</li><li>\nQueda prohibido organizar eventos o competencias sin autorización de Altea Wellness Club.</li><li>\nQueda prohibido subirse o jalar los carriles anti turbulencia.</li><li>\nLos Instructores en general tienen la facultad de reportar a la Administración del Club a todo aquel Usuario que presente conductas negativas que afecten a la moral y/o antideportivas, que pongan en riesgo la seguridad e integridad del Staff de Altea Wellness Club o de los Usuarios.\n</li><li>\nEl incumplimiento de este reglamento o mala conducta en el área de Alberca, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li></ol><p><strong>ASISTENCIA A CLASES</strong></p><ol class=\"olAlteaNumero\"><li>Llegar puntual.</li><li>\nUna vez iniciada la clase y habiendo transcurridos 10 (diez) minutos, él instructor se reserva el derecho de aceptar el ingreso del Usuario a la actividad que se esté llevando a cabo.\n</li><li>Evitar comidas en exceso mínimo 2 (dos) horas antes de la clase de natación.</li><li>\nSe recomienda ir al baño antes de ingresar a clases para evitar interrupciones.</li><li>\nEn las clases para menores, el padre o tutor no podrá dar indicaciones al menor cuando éste se encuentre en clase.</li>\n<li>Se prohíbe introducir juguetes y/u objetos ajenos dentro de la clase.</li><li>\nSe prohíbe tirar basura dentro y fuera del área de Alberca.</li></ol><p><strong>SEGURIDAD</strong></p><ol \nclass=\"olAlteaNumero\"><li>La alberca tiene un cupo limitado y bajo ninguna circunstancia podrá ser superado.</li><li>\nAltea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo.</li></ol><p><strong>\nREGLAMENTO DEL JACUZZI</strong></p><ol class=\"olAlteaNumero\"><li>\nEl uso del Jacuzzi es exclusivo para Usuarios activos e Invitados.</li><li>\nPor seguridad no se permite el ingreso a Menores de 15 (quince) años al Jacuzzi.</li><li>\nSolo se podrá hacer uso del Jacuzzi en los horarios establecidos que son:</li><li>Lunes a viernes de 6:00 am a 9:30 pm\n</li><li>Sábados de 7:00 am a 4:30 pm</li><li>Domingos y días festivos de 7:00 am a 1:30 pm</li><li>\nEl tiempo máximo dentro del Jacuzzi será de 30 minutos.</li><li>\nAl salir del Jacuzzi el uso de bata y toalla es obligatorio para desplazarse al área de Vestidores.</li><li>\nEs obligatorio ducharse antes de ingresar al Jacuzzi, para ello se cuenta con regaderas dentro del área.</li><li>\nQueda prohibido el uso de productos corporales o faciales (crema, bronceador, bloqueador, etc.)</li><li>\nPara ingresar al área Jacuzzi es obligatorio el uso de: sandalias y traje de baño.</li><li>\nSe prohíbe el acceso al Jacuzzi a Usuarios que tengan enfermedades infecciosas.</li><li>\nSe prohíbe el uso del Jacuzzi a Usuarios con raspones, heridas o vendajes.</li><li>\nSe prohíbe orinar dentro del Jacuzzi.</li><li>Se prohíben los clavados en el Jacuzzi.</li><li>\nDentro y fuera del Jacuzzi se prohíbe correr, gritar o empujar.</li><li>\nPara ingresar al Jacuzzi no está permitido el uso de short, playera o cualquier otra prenda que no esté diseñada para actividades dentro del agua.\n</li><li>En el caso de mujeres no está permitido el uso de traje de baño de dos piezas.</li><li>\nEl uso de aretes y piercings está prohibido dentro del Jacuzzi.</li><li>\nLa Administración de Altea Wellness Club podrá negar el uso del Jacuzzi en caso de incumplimiento de las normas señaladas.\n</li><li>Queda prohibido introducir alimentos, bebidas alcohólicas y envases de vidrio al Jacuzzi.</li><li>\nQueda prohibido pisar o sentarse en el área de jardineras.</li><li>\nLas maletas, bolsos, mochilas y backpacks deberán colocarse en el área asignada.</li><li>\nSe prohíbe tirar basura dentro y fuera del Jacuzzi.</li><li>\nLa empresa no se hace responsable de lesiones por el uso de los equipos y/o instalaciones.</li><li>\nAltea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo dentro y fuera del Jacuzzi.\n</li><li>\nLos Instructores en general tienen la facultad de reportar a la Administración del Club a todo aquel Usuario que presente conductas negativas que afecten a la moral y/o antideportivas, que pongan en riesgo la seguridad e integridad del Staff de Altea Wellness Club o de los Usuarios.\n</li><li>\nEl incumplimiento de este reglamento o mala conducta en el Jacuzzi, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li></ol><p><strong>REGLAMENTO DE CLASES FITNESS</strong></p><p><strong>GENERALES</strong></p><ol \nclass=\"olAlteaNumero\"><li>El acceso a las Clases Fitness es exclusivo para Usuarios activos e invitados.</li><li>\nEl uso de ropa y calzado deportivo es obligatorio en todos los salones de Clases Fitness.</li><li>\nTodas las Clases Fitness tienen una duración de 50 minutos.</li><li>\nLa tolerancia para ingresar a una Clase Fitness una vez iniciada es de 10 (diez) minutos.</li><li>\nLos horarios de cada actividad estarán visibles para los Usuarios.</li><li>\nLa Coordinación de Clases Fitness se reserva el derecho de cambiar sin previo aviso: instructor, programa, horario y salones.\n</li><li>Siempre dirigirse y actuar respetuosamente hacia el Staff y Usuarios.</li><li>\nAtender las indicaciones del personal a cargo de cada salón.</li><li>\nEn caso de presentar alguna lesión, cirugía o embarazo, notificar al instructor a cargo.</li><li>\nLa venta de cualquier tipo de artículo queda prohibida, al igual que la promoción de otro negocio o servicio dentro de los salones de Clases Fitness.\n</li><li>Altea Wellness Club se reserva el derecho para determinar el número de clases que se impartirán.</li><li>\nAltea Wellness Club se reserva el derecho de disminuir actividades en periodos vacacionales de acuerdo a sus políticas de aforo.\n</li><li>\nToda sugerencia con respecto a las actividades y del área, podrán ser depositadas en el buzón de sugerencias ubicado en la Administración del Club.\n</li></ol><p><strong>HIGIENE</strong></p><ol class=\"olAlteaNumero\"><li>\nEl uso de toalla es obligatorio en todas las Clases Fitness.</li><li>\nLos vestidores es el único lugar donde se permiten cambios de ropa.</li><li>\nSe prohíbe el acceso a Usuarios que tengan enfermedades infecciosas y/o heridas abiertas.</li></ol><p><strong>\nRESTRICCIONES</strong></p><ol class=\"olAlteaNumero\"><li>\nÚnicamente se pueden introducir botellas de plástico con tapa a efecto de mantenerse hidratados durante la clase, se prohíbe introducir alimentos y botellas de vidrio.\n</li><li>Se prohíbe introducir maletas o mochilas de gran tamaño a los salones de Clases Fitness.</li><li>\nDurante la clase se prohíbe tener bolsas o prendas de ropa (chamarras, sudaderas, etc.) en el espacio o equipo de trabajo, deberán colocarse en el área asignada.\n</li><li>\nEl instructor a cargo de la clase tiene la facultad de negar el acceso a las actividades a Usuarios que no cumplan las observaciones sobre ropa y calzado, así como aquellos que pudieran presentarse en estado inconveniente.\n</li><li>\nPor seguridad queda prohibida la permanencia de menores de 15 (quince) años en los salones cuando se imparten Clases Fitness.\n</li><li>\nLos Instructores en general tienen la facultad de reportar a la Administración del Club a todo aquel Usuario que presente conductas negativas y/o antideportivas, que pongan en riesgo la seguridad e integridad del Staff de Altea Wellness Club o de los Usuarios.\n</li><li>\nEl incumplimiento de este reglamento o mala conducta en los salones de Clases Fitness, será sancionada dentro de los estatutos y lineamientos establecidos en el reglamento general de Altea Wellness Club.\n</li></ol><p><strong>ASISTENCIA A CLASES</strong></p><ol class=\"olAlteaNumero\"><li>\nLas Clases Fitness son únicamente para mayores de 15 años.</li><li>\nLas Clases Fitness inician a la hora y 10 (diez) minutos tal como se señala en el cronograma y terminan a la hora en punto para garantizar condiciones de limpieza.\n</li><li>\nUna vez iniciada la clase y habiendo transcurridos 10 (diez) minutos, él instructor se reserva el derecho de aceptar el ingreso del Usuario a la actividad que se esté llevando a cabo.\n</li><li>\nLos Usuarios que ingresen a la clase ya iniciada NO podrán colocarse en la parte frontal del salón, excepto en la sala de “My ride”, siempre que se encuentren en esta zona maquinas libres.\n</li><li>El acceso a las clases está sujeto a cupo disponible.</li><li>Está prohibido apartar lugares dentro del salón.\n</li><li>\nLa Administración de Altea Wellness Club se reserva el derecho para determinar la capacidad máxima de cada actividad y salón.\n</li><li>\nEs responsabilidad de cada usuario recoger los equipos, accesorios y materiales que utilice durante la clase y colocarlos en los lugares asignados para su resguardo al término de la actividad.\n</li><li>\nEn aquellas clases que así lo ameriten, el instructor a cargo tendrá la facultad de solicitar el uniforme o accesorios correspondientes.\n</li><li>Únicamente se puede mantener descalzo en las actividades que lo requieran o a solicitud del instructor.</li>\n<li>\nEn atención a los demás Usuarios, se prohíbe promover que el instructor incremente el tiempo de duración de la actividad.\n</li><li>\nPara casos especiales, en el que el Usuario deba suspender su participación, se deberá dar aviso al instructor al iniciar la clase.\n</li></ol><p><strong>SEGURIDAD</strong></p><li>\nTodas las Clases Fitness tienen cupo limitado y bajo ninguna circunstancia podrá ser superado.</li><li>\nAltea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo.</li><p><strong>\nREGLAMENTO DE JUEGOS INFANTILES</strong></p><ol class=\"olAlteaNumero\"><li>\nEl horario de servicio será el estipulado por la Administración en lugar visible.</li><li>\nLos usuarios deberán respetar los avisos e indicaciones generales en el área para el buen uso de los juegos.</li><li>\nEl área de juegos está disponible para uso y recreación de los niños menores de diez años de edad y se recomienda que estén supervisados por el padre o tutor.\n</li><li>El Club no se hace responsable por accidentes y/o lesiones provocadas por el mal uso de los juegos.</li><li>\nEs responsabilidad del padre o tutor el correcto uso de los juegos así como de la seguridad del menor.</li></ol><p>\n<strong>REGLAMENTO ACADEMIA ALTEA</strong></p><p><strong>GENERALES</strong></p><ol class=\"olAltea\"><li>\nEl acceso a clases de Academia Altea es exclusivo para Usuarios activos de 3 (tres) a 15 (quince) años.</li><li>\nLa programación de clases de Academia Altea se realizara de manera cuatrimestral.</li><li>\nLos horarios de cada actividad estarán visibles para los Usuarios.</li><li>\nLos Menores podrán ser inscritos a 3 (tres) actividades por cuatrimestre, con opción a cambio de actividad al concluir este periodo.\n</li><li>\nLas inscripciones deberán realizarse en la supervisión de Academia Altea ubicada en la recepción de la Estancia Infantil.\n</li><li>\nÚnicamente las personas registradas como responsables podrán entregar a los menores al inicio de clase y recogerlos al término de la misma.\n</li><li>\nUna vez que los menores sean inscritos a sus actividades, no se podrá realizar cambio de actividad hasta concluir el periodo cuatrimestral.\n</li><li>\nLos menores podrán tomar las clases de Academia Altea que se tengan disponibles en el grupo que les corresponda de acuerdo a su edad, quedando de la siguiente manera:\n<ol><li>De 3 a 5 años 11 meses</li><li>De 6 a 9 años 11 meses</li><li>De 10 a 12 años 11 meses</li><li>De 13 a 15 años\n</li></ol></li><li>El uso de uniforme para cada actividad es obligatorio.</li><li>\nSe realizarán evaluaciones cuatrimestrales de todas las clases de Academia Altea para medir el avance de los alumnos.\n</li><li>\nLos menores podrán ingresar a las Clases de Academia Altea, solo en los horarios establecidos, siempre y cuando el padre o tutor se encuentre dentro de las instalaciones de Altea Wellness Club y deberán proporcionar datos para su localización.\n</li><li>Siempre dirigirse y actuar respetuosamente hacia el Staff y Usuarios.</li><li>\nAtender las indicaciones del personal a cargo de cada salón.</li><li>\nLa Administración de Altea Wellness Club se reserva el derecho para determinar el número de clases que se impartirán en Academia Altea.\n</li><li>\nLa Administración de Altea Wellness Club se reserva el derecho de disminuir actividades de acuerdo a sus políticas de aforo.\n</li><li>\nToda sugerencia con respecto a las actividades y del área, podrán ser depositadas en el buzón de sugerencias ubicado en la Administración del Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la Administración de Altea Wellness Club.\n</li></ol><p><strong>HIGIENE</strong></p><ol class=\"olAlteaNumero\"><li>\nLos vestidores es el único lugar donde se permiten cambios de ropa.</li><li>\nEn atención y por seguridad de los demás Usuarios de clases de Academia Altea, no se permitirá el acceso a clases a menores que presenten enfermedades infecciosas, fiebre, diarrea, tos, dolor de cabeza, náuseas, alergias y heridas abiertas, etc.\n</li></ol><p><strong>RESTRICCIONES</strong></p><ol class=\"olAlteaNumero\"><li>\nLos Instructores a cargo de cada disciplina están capacitados para el trabajo con los menores, por ello los padres, tutores o responsables NO podrán permanecer dentro de los salones durante las clases de Academia Altea.\n</li><li>\nEl personal e Instructor a cargo tienen la facultad de negar el acceso a la clase a los menores que no cumplan las observaciones sobre ropa, calzado y accesorios, así como aquellos que pudieran presentar algún padecimiento antes mencionado.\n</li><li>\nÚnicamente se pueden introducir botellas de plástico con tapa a efecto de que los menores se mantengan hidratados durante las clases de Academia Altea, se prohíbe introducir todo tipo de alimentos y botellas de vidrio.\n</li><li>Dentro y fuera de los salones de clases se prohíbe correr, gritar o empujar y tirar basura.</li></ol><p>\n<strong>ASISTENCIA A CLASES</strong></p><ol class=\"olAlteaNumero\"><li>\nTodas las clases inician a la hora en punto y tienen una duración de 50 (cincuenta) minutos, por lo que se pide puntualidad al entregar y recoger a los menores.\n</li><li>\nPor seguridad una vez iniciada la clase y habiendo transcurridos 10 (diez) minutos, él Instructor se reserva el derecho de aceptar el ingreso del menor a la clase.\n</li><li>\nLos menores deberán ser entregados a los profesores a cargo de la clase por el padre, tutor o responsable (mayor de edad) y recogerlos al finalizar.\n</li><li>Todos los menores deberán presentarse con el uniforme solicitado de acuerdo a su actividad.</li><li>\nPara los menores inscritos en las clases de Natación, el uso de bata al finalizar las clases es Obligatorio.</li><li>\nSi por algún motivo el menor se va ausentar 3 veces consecutivas de sus clases, el padre, tutor o responsable deberá notificarlo al área de Academia Altea, de lo contrario se dará de baja de la actividad.\n</li><li>\nSi un menor presentara algún malestar durante su clase, se notificará al padre, tutor o responsable y deberán acudir por él.\n</li></ol><p><strong>SEGURIDAD</strong></p><ol class=\"olAlteaNumero\"><li>\nTodas las Clases de Academia Altea tienen cupo limitado y bajo ninguna circunstancia podrá ser superado.</li><li>\nAltea Wellness Club no se hace responsable de la pérdida o extravío de cualquier artículo.</li></ol><p><strong>\nCAPÍTULO VIII</strong></p><p><strong>REGLAMENTO ESTANCIA INFANTIL</strong></p><p><strong>GENERALES</strong></p><ol \nclass=\"olAltea\"><li>El uso de la Estancia Infantil es para Usuarios activos de 3 (tres) meses a 6 (seis) años.</li><li>\nPara hacer uso de la Estancia Infantil, el padre o tutor deberá presentarse con la credencial del Club así como con la credencial del menor (ambas vigentes), para hacer los trámites correspondientes.\n</li><li>\nSe podrá hacer uso de la Estancia Infantil solo en los horarios establecidos siempre y cuando el padre o tutor se encuentre dentro de las instalaciones de Altea Wellness Club y deberán proporcionar datos para su localización.\n<ol><li>Lunes a Viernes de 8:00 am a 8:50 pm</li><li>Sábados de 8:00 am a 4:00 pm</li><li>\nDomingos y días festivos de 8:00 am a 1:00 pm</li></ol></li><li>\nÚnicamente las personas registradas como responsables podrán entregar y recoger a los menores en la Estancia Infantil.\n</li><li>Todos los menores deberán ser registrados al ingresar y salir de la Estancia Infantil.</li><li>\nLos menores podrán hacer uso de la Estancia Infantil 4 (cuatro) horas diarias, 2 (dos) por la mañana y 2 (dos) por la tarde, en caso de exceder este tiempo, el costo por hora adicional será determinado por la Administración de Altea Wellness Club.\n</li><li>\nSi los menores presentan algún malestar durante su permanencia en la Estancia Infantil, el padre, tutor o responsable deberá acudir por ellos, eximiendo a Altea Wellness Club de todo tipo de responsabilidad.\n</li><li>\nNingún miembro de Altea Wellness Club está facultado para el cuidado de menores fuera de la Estancia Infantil y del horario que se tiene establecido.\n</li><li>En caso de que el menor requiera cuidados especiales, se valorará la posibilidad de su permanencia.</li><li>\nAltea Wellness Club se deslinda de toda responsabilidad por enfermedades presuntamente contraídas dentro de la Estancia Infantil.\n</li><li>Siempre dirigirse y actuar respetuosamente hacia el Staff y Usuarios.</li><li>\nToda sugerencia con respecto a las actividades y del área, podrán ser depositadas en el buzón de sugerencias ubicado en la Administración del Club.\n</li><li>\nLos puntos no considerados o previstos en este reglamento serán atendidos en la Administración de Altea Wellness Club.\n</li></ol><p><strong>HIGIENE</strong></p><ol class=\"olAltea\"><li>\nEn atención y por seguridad de los demás Usuarios de la Estancia Infantil, no se permitirá el acceso a menores que presenten enfermedades infecciosas, fiebre, diarrea, tos, dolor de cabeza, náuseas, alergias, heridas abiertas, enfermedades virales, etc.\n</li><li>Los usuarios menores a 3 (tres) años, deberán presentarse siempre con:<ol><li>Ropa, pañal y cabello limpio.\n</li><li>Peinados</li><li>Uñas cortas de manos y pies.</li><li>\nPañales y toallitas húmedas (suficientes para su estancia)</li><li>\nMochila con: Biberón, cambio de ropa, babero y cojín para cambio de pañal, todo lo anterior marcado con su nombre.</li>\n</ol></li></ol><p><strong>RESTRICCIONES</strong></p><ol class=\"olAlteaNumero\"><li>\nLos menores podrán hacer uso de la Estancia Infantil siempre y cuando el padre o tutor se encuentre dentro de las instalaciones de ALTEA WELLNESS CLUB por la cual el padre o tutor no podrá ausentarse por ningún motivo de ALTEA WELLNESS CLUB.\n</li><li>Es obligación del padre o tutor el proporcionar datos de contacto directo y de emergencia y/o alternos.</li>\n<li>\nEl personal a cargo de la Estancia Infantil por ningún motivo puede administrar medicamento a los menores, si este lo requiere el padre o tutor deberá presentarse en la Estancia Infantil para administrarlo.\n</li><li>Queda estrictamente prohibido ingresar alimentos y golosinas a la Estancia Infantil.</li><li>\nLos menores no podrán salir solos de la Estancia Infantil, únicamente las personas registradas como responsables podrán recogerlos, para ello deberán presentar credencial o identificación.\n</li><li>Se podrá negar el acceso del menor de forma temporal, en caso de incumplimiento del reglamento.</li><li>\nEl tiempo que los menores permanezcan en la Estancia Infantil estarán a cargo y atendidos por personal capacitado para su cuidado, por lo cual los padres, tutores o nanas no podrán permanecer acompañando a los menores.\n</li><li>No se reciben ni se entregan niños dormidos.</li></ol><p><strong>ASISTENCIA A CLASES</strong></p><ol \nclass=\"olAlteaNumero\"><li>\nLos menores de 3 (tres) a 35 (treinta y cinco) meses podrán asistir a las clases diseñadas especialmente para su edad, siempre acompañados del padre, tutor o responsable.\n</li></ol><p><strong>SEGURIDAD</strong></p><ol class=\"olAlteaNumero\"><li>\nNo nos hacemos responsables por objetos olvidados.</li><li>\nPor seguridad la Estancia infantil cuenta con cupo limitado y bajo ninguna circunstancia podrá ser superado.</li></ol>\n<p><strong>REGLAMENTO DE SERVICIOS ENFERMERÍA</strong></p><ol class=\"olAlteaNumero\"><li>\nEs obligación para todos los usuarios, pasar un examen médico antes de disfrutar de los servicios que ofrece ALTEA WELLNESS CLUB en sus instalaciones deportivas. Este examen deberá hacerse anualmente con el médico de confianza del usuario y presentarse en las oficinas administrativas del Club.\n</li><li>\nSi como consecuencia del examen médico practicado, resulta necesaria la presentación de análisis u otros estudios clínicos a juicio médico, será obligación de los usuarios el efectuarlos y presentarlos en la administración del Club.\n</li><li>\nCon objeto de asegurar las condiciones de salud de los usuarios, no se permitirá el acceso a los servicios proporcionados en las instalaciones deportivas si no se entrega el certificado médico antes mencionado.\n</li><li>\nEl servicio enfermería se ofrece con el objeto de asistir a los usuarios en situaciones de accidentes o causas de fuerza mayor, por lo que de manera habitual no se da consulta, diagnostica o se receta.\n</li><li>\nSi el usuario solicita que se le aplique una inyección ó algún tratamiento invasivo será a criterio del titular de este servicio y se realiza bajo riesgo del usuario, dejando a ALTEA WELLNESS CLUB libre de cualquier responsabilidad.\n</li></ol><p><strong>CAPÍTULO IX<br>DE LAS SANCIONES</strong><br><br>\nEn general la falta a cualquiera de las disposiciones establecidas en este reglamento y cualquier otra circunstancia que a criterio del Consejo de Administración lo amerite estará sujeta a alguna de estas sanciones:\n</p><p><strong>AMONESTACIÓN</strong></p>\nEl Consejo de Administración amonestará al usuario, sin pérdida de sus derechos de utilización de las instalaciones o servicios del Club a sus familiares, invitados o visitantes mediante un comunicado por escrito, entregado personalmente, dirigido al domicilio o correo electrónico del sancionado en cualquiera de los siguientes casos:\n<ol class=\"olAlteaNumero\"><li>\nPor faltas al presente reglamento, así como a los reglamentos anexos que hacen referencia al uso de las distintas áreas del Club.\n</li><li>Una falta que no tenga señalada sanción especial conforme a este reglamento.</li><li>\nCuando el socio, sus familiares, dependientes o visitantes violen las disposiciones del presente reglamento, no otorguen a los otros socios, empleados y trabajadores del Club un trato adecuado o digno.\n</li><li>\nCualquier falta no descrita en este reglamento y que el Consejo de Administración estime procedente formular una amonestación.\n</li></ol><p><strong>SUSPENSION TEMPORAL</strong></p>\nSerá motivo para que un socio sea suspendido temporalmente de sus derechos de utilización de las instalaciones o servicios del Club cuando él o sus familiares, dependientes y visitantes incurran en:\n<ol class=\"olAlteaNumero\"><li>La acumulación de dos o más amonestaciones.</li><li>\nPor falta de pago oportuno en sus cuotas después del seis de cada mes.</li><li>\nPor faltas al presente reglamento, así como a los reglamentos anexos que hacen referencia al uso de las distintas áreas del Club y consideradas graves a criterio del Consejo de Administración.\n</li><li>\nPor faltas a la moral o a las buenas costumbres y consideradas graves a criterio del Consejo de Administración.</li>\n<li>\nSi un usuario o sus invitados son sorprendidos extrayendo o hurtando objetos, equipo, o valores propiedad del club o de cualquiera de sus usuarios.\n</li><li>\nPor falta de respeto o maltrato a los empleados de ALTEA WELLNESS CLUB, consideradas graves a criterio del Consejo de Administración.\n</li><li>Por actitud negativa del usuario, familiares o invitados del mismo hacia los intereses de ALTEA WELLNESS CLUB\n</li><li>\nPor faltas graves en contra del derecho o buen nombre de ALTEA WELLNESS CLUB o en contra del honor o dignidad de los demás usuarios.\n</li><li>Por condenación a causa de delitos o antecedentes penales.</li><li>\nPor destrucción o maltrato a las instalaciones o equipos de ALTEA WELLNESS CLUB de forma deliberada.</li><li>\nPor introducir toda clase de alimentos, frutas o bebidas, bebidas alcohólicas, armas y en general cualquier sustancia o artículo que pueda ocasionar daño o lesiones a los usuarios o a las instalaciones de ALTEA WELLNESS CLUB.\n</li><li>\nSi acontece cualquier hecho no descrito en los incisos anteriores y el Consejo de Administración considera procedente imponer una suspensión.\n</li><li>\nEl Consejo de Administración, es la instancia correspondiente para determinar y vigilar el cumplimiento de la suspensión de un usuario de ALTEA WELLNESS CLUB o de sus invitados.\n</li><li>\nLa suspensión es aplicable a todos los integrantes de la membresía, por lo tanto, ninguno de ellos podrá hacer uso de las instalaciones del Club mientras dure la sanción impuesta.\n</li><li>\nCualquier amonestación o suspensión temporal o definitiva deberá ser notificada al infractor por la vía que se considere más eficaz.\n</li><li>\nCualquier socio suspendido temporal o definitivamente NO tendrá derecho de apelación ante ninguna instancia u autoridad de ALTEA WELLNES CLUB.\n</li><li>\nLa suspensión del uso de las instalaciones del Club por faltas al reglamento ó acumulación de amonestaciones, no exime al socio del pago de las cuotas de mantenimiento y adeudos pendientes, la falta de pago de cuotas en este supuesto dará origen a una cancelación de membresía y exclusión automática del club.\n</li><li>\nSi ocurre una falta de respeto a los miembros del Consejo de Administración, empleados y servidores del Club que a juicio del Consejo de Administración o sus órganos auxiliares amerite tal suspensión.\n</li></ol><p><strong>SUSPENSION DEFINITIVA O EXPULSIÓN</strong></p>\nEl Consejo de Administración tiene la facultad de cancelar la membresía de cualquier usuario y excluirlos del club de acontecer cualquiera de los siguientes supuestos:\n<ol class=\"olAlteaNumero\"><li>\nSerá causa de suspensión definitiva y cancelación de la membresía, la falta de pago de TRES meses consecutivos de mantenimiento.\n</li><li>Si se dictan en contra de un usuario dos o más sanciones.</li><li>\nSi algún usuario o sus invitados causan perjuicios intencionales graves a las instalaciones, establecimientos, locales y demás activos de ALTEA WELLNESS CLUB, a juicio del Consejo.\n</li><li>\nSi la conducta de algún usuario de ALTEA WELLNESS CLUB es de tal manera ofensiva y grave a juicio del Consejo de Administración, que hubiese herido la dignidad de algún otro usuario, sus invitados o visitantes; o sea contraria a las buenas costumbres establecidas por la comunidad que integran los usuarios dentro de ALTEA WELLNESS CLUB.\n</li><li>\nLa suspensión definitiva y cancelación de la membresía, no exime al socio del pago de las cuotas de mantenimiento y sus adeudos pendientes.\n</li><li>\nEn los casos de suspensión o cancelación acordados por el Consejo de Administración, a que se refieren los artículos anteriores, el usuario sancionado estará impedido de entrar a las instalaciones, establecimientos, locales y demás activos de ALTEA WELLNESS CLUB y de hacer uso de los servicios que éste presta incluso en la calidad de invitado.\n</li><li>La imposición de las sanciones que previene este reglamento corresponde al Consejo de Administración.</li><li>\nEl Consejo de Administración tendrá facultad para amonestar a quienes infrinjan las disposiciones de este reglamento y las resoluciones que el propio Consejo dicte, y podrá decretar la amonestación, suspensión temporal o definitiva de sus derechos como usuario.\n</li><li>\nLos casos en que el consejo de administración tenga que aplicar una suspensión temporal o definitiva a un usuario por violaciones a las reglas ó por las causas antes señaladas, no se reembolsará cuota o pago alguno recibido por parte de los usuarios.\n</li></ol><p><strong>CAPÍTULO X<br>HORARIOS DE SERVICIO</strong></p><p>\nLa Administración de ALTEA WELLNESS CLUB determinará los horarios en que se otorgarán los diversos servicios, siendo obligación de los usuarios observar en forma estricta los horarios establecidos, así como las actividades y profesores que se asignen. LUNES A VIERNES DE 6:00 A 22:00 HRS. SÁBADOS DE 7:00 A 17:00 HRS., DOMINGOS Y DÍAS FESTIVOS DE 7:00 A 14:00 HRS. LOS DÍAS 25 DE DICIEMBRE Y EL PRIMERO DE ENERO EL CLUB PERMANECERÁ CERRADO.\n</p><p><strong>CAPÍTULO XI<br>MODIFICACIONES AL REGLAMENTO</strong></p><ol class=\"olAlteaNumero\"><li>\nEl presente reglamento podrá reformarse total o parcialmente por resolución del Consejo de Administración de ALTEA WELLNESS CLUB sin previo aviso, según las circunstancias o condiciones que así lo demanden.\n</li><li>\nEl Consejo de Administración de ALTEA WELLNESS CLUB, podrá expedir avisos o circulares con disposiciones, mismas que serán obligatorias y de aplicación general e inmediata para todos los usuarios.\n</li><li>El presente reglamento interno, entra en vigor a partir de la fecha de su publicación.</li></ol></td></tr>\n</table><div class=\"contract-clauses\"><table class=\"contract-clauses-terms\" style=\"width: 100%\"><tbody><tr><td \nstyle=\"border-bottom: 1px solid #cccccc; width: 33.33%!important\">Fecha: {{vm.data.date| date: \'dd/MM/yyyy\'}}</td><td \nstyle=\"border-bottom: 1px solid #cccccc; width: 33.33%!important\">Membresía: {{vm.data.dueName}}</td><td \nstyle=\"border-bottom: 1px solid #cccccc; width: 33.33%!important\">Nombre titular: {{vm.data.partnerName}}</td></tr><tr>\n<td colspan=\"3\" style=\"text-align: center\">Recibí reglamento interno de usuarios de Altea Wellness Club</td></tr><tr>\n<td colspan=\"3\" style=\"padding: 0 25%; text-align: center\"><div class=\"regulation-signature\" \nstyle=\"text-align: center\"><img ng-src=\"{{vm.signatureSrc}}\"></div><div class=\"contract-clauses-signature\"><label>\nNOMBRE Y FIRMA DEL TITULAR</label></div></td></tr><tr><td colspan=\"3\" style=\"font-size: 1.0em; padding-top: 20px\">\nAVISO DE PRIVACIDAD. ALTEA FITNESS, S.A. DE C.V., también con conocida como ALTEA WELLNESS CLUB, S.A. DE C.V. con domicilio en Boulevard Ramón G. Bonfil, número 1800, Colonia Venta Prieta, en la Ciudad de Pachuca de Soto, Estado de Hidalgo, C.P. 42084 utilizará sus datos personales recabados para: Verificar y confirmar su identidad. Estableces los datos de contacto. Comercialización de productos y servicios que ofrecemos. Datos respecto de sus características y su condición física. Elaboración y expedición de comprobantes fiscales. Dar atención al cliente. Atender y dar seguimiento a dudas, aclaraciones, quejas, sugerencias y reclamaciones. Tratándose de trabajadores o aspirantes que deseen trabajar en ALTEA WELLNESS CLUB los datos recabados se utilizarán para comprobar las cualidades manifestadas por el aspirante, para elaborar el contrato de trabajo y para conformar el expediente laboral. Para más información sobre el tratamiento y los derechos que puede ejercer puede acceder al aviso de privacidad integral en la página de internet https://alteawellnessclub.com/privacidad/\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/contract/contract-bylifefit.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Guardar</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.showSignature($event)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon><md-tooltip>Firmar</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.sendByEmail()\" ng-disabled=\"vm.sendingEmail\"><md-icon md-font-icon=\"icon-email\" \nng-show=\"!vm.sendingEmail\"></md-icon><md-icon md-font-icon=\"icon-dots-horizontal\" ng-show=\"vm.sendingEmail\"></md-icon>\n<md-tooltip>Enviar por email</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getLastData()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>Obtener datos nuevamente</md-tooltip></md-button></div><div \nid=\"complete-document\" class=\"card md-whiteframe-8dp\"><div class=\"titulo-centrado-normal\"><img id=\"img-logo\" \nng-src=\"{{vm.logoSource}}\" class=\"imglogo\" width=\"200\"></div><div class=\"contract-table-footer\"><h2>\nNORMAS ADMINISTRATIVAS Y CONTRATO DE SERVICIOS DEPORTIVOS.</h2></div><div class=\"contract-table-footer\"><h2>\nBY LIFE FIT GYM</h2></div><div><hr></div><br><h3>QUE CELEBRAN</h3><br><div>Por una parte, <strong>BY LIFE FIT</strong>\n, gimnasio operado por <strong>JORGE BÁRCENAS SÁNCHEZ</strong>\n, persona física con actividad empresarial, a quien en lo sucesivo se le denominará <strong>“EL GIMNASIO”</strong>\n, y por la otra, la persona cuyos datos se describen a continuación, a quien en lo sucesivo se le denominará <strong>\n“EL USUARIO”</strong>, al tenor de las siguientes declaraciones y cláusulas.</div><br><br><div><hr></div><div><h2>\nI. DATOS DE EL GIMNASIO</h2></div><div><strong>Nombre comercial:</strong> BY LIFE FIT<br><strong>Propietario:</strong>\n Jorge Bárcenas Sánchez<br><strong>RFC:</strong> BASJ760901420<br><strong>Domicilio:</strong><br>\nCalzada de los Leones número 115, Local D,<br>Ciudad de México.</div><br><div><hr></div><div><h2>\nII. DATOS DE EL USUARIO (TITULAR)</h2><div><strong>Nombre completo:</strong> {{vm.data.partnerName}}<br><strong>\nFecha de nacimiento:</strong> {{vm.data.birthdate|date:\'dd /MM / yyyy\'}}<br><strong>Edad:</strong>\n {{vm.calculateAge(vm.data.birthdate)}} años<br><strong>Domicilio particular:</strong><br>\n{{vm.data.addressStreet}} {{vm.data.addressColony}} {{vm.data.addressMunicipio}}, CP.{{vm.data.addressZipCode}}, {{vm.data.addressState}}\n<br><strong>Correo electrónico:</strong> {{vm.data.email}}<br><strong>Teléfono de contacto:</strong>\n {{vm.data.addressPhoneNumber}}</div></div><br><div><hr></div><div \nng-if=\"vm.data.familyDetails && vm.data.familyDetails.dependents.length && vm.data.familyDetails.dependents[0].due.name == \'Membresía 2x1 DEPENDIENTE\'\">\n<h2>III. DATOS DEL DEPENDIENTE</h2><strong>Nombre completo:</strong>\n {{vm.data.familyDetails.dependents[0].fatherLastname}} {{vm.data.familyDetails.dependents[0].motherLastname}} {{vm.data.familyDetails.dependents[0].name}}\n<br><strong>Fecha de nacimiento:</strong> {{vm.data.familyDetails.dependents[0].birthdate|date:\'dd / MM / yyyy\'}}<br>\n<strong>Edad:</strong> {{vm.calculateAge(vm.data.familyDetails.dependents[0].birthdate)}} años<div><hr></div><br></div>\n<div><h2>IV. DATOS DE LA MEMBRESÍA CONTRATADA</h2><br><strong>Tipo de membresía:</strong><br>{{vm.data.dueName}}<br>\n<strong>Modalidad:</strong><br>{{vm.data.periodicityName}}<br><strong>Fecha de inicio:</strong>\n {{vm.data.initPayDate|date:\'dd / MM / yyyy\'}}</div><br><div><hr></div><div><h2>V. DATOS DEL CONTRATO</h2></div><div>\n<strong>Lugar de celebración:</strong> Ciudad de México<br><strong>Fecha de celebración:</strong>\n {{vm.data.date|date:\'dd / MM / yyyy\'}}<br><strong>Versión del contrato:</strong> _____C001______________________</div>\n<br><div><hr></div><br><div style=\"font-style: italic\">\nLa firma del presente contrato implica la aceptación expresa de todas y cada una de sus cláusulas, anexos y reglamentos.\n</div><br><h2>SERVICIOS DEPORTIVOS E INSTALACIONES</h2><h3>BY LIFE FIT</h3><div><strong>QUE CELEBRAN</strong>\n, por una parte <strong>JORGE BÁRCENAS SÁNCHEZ</strong>, en su carácter de <strong>\npersona física con actividad empresarial</strong>, RFC <strong>BASJ760901420</strong>, con domicilio en <strong>\nCalzada de los Leones 115, Local D, Ciudad de México</strong>, a quien en lo sucesivo se le denominará <strong>\n“EL GIMNASIO”</strong> o <strong>“BY LIFE FIT”</strong>, y por la otra <strong>{{vm.data.partnerName}}</strong>\n, a quien en lo sucesivo se le denominará<strong> “EL TITULAR”</strong>,<strong> “EL USUARIO”</strong> y, en su caso,\n<strong> “EL DEPENDIENTE”</strong>, al tenor de las siguientes:</div><div><hr></div><div><h2>I. DECLARACIONES</h2><h3>\nI Bis. Declara EL GIMNASIO:</h3></div><div>a) Que es propietario y operador del gimnasio denominado <strong>BY LIFE FIT\n</strong>.<br>\nb) Que cuenta con instalaciones, equipo, personal y permisos necesarios para la prestación de servicios de acondicionamiento físico.\n<br>c) Que actúa como persona física con actividad empresarial, RFC <strong>BASJ760901420</strong>.</div><h3>\nI Ter. Declara EL USUARIO:</h3><div>\na) Que es mayor de edad o cuenta con autorización expresa de padre, madre o tutor legal.<br>\nb) Que la información proporcionada es veraz.<br>\nc) Que conoce, entiende y acepta el presente contrato, sus anexos y el Reglamento Interno.</div><div><hr></div><div>\n<h2>II. OBJETO DEL CONTRATO</h2></div><div>EL GIMNASIO otorga a EL USUARIO, conforme al tipo de membresía contratada, \n<strong>el derecho personal, intransferible y no exclusivo</strong>\n de uso de las instalaciones, equipo y servicios disponibles, los cuales incluyen de manera enunciativa:<br><ul><li>\nÁrea de pesas</li><li>Área de cardio</li><li>Regaderas</li><li>Lockers libres</li><li>Asesoría básica con entrenador\n</li></ul><br>El uso estará siempre sujeto a<strong>\n disponibilidad, aforo, horarios, mantenimiento, seguridad y cumplimiento del Reglamento Interno.</strong></div><br>\n<div><hr></div><div><h2>III. EDAD MÍNIMA Y RESPONSABILIDAD DE MENORES</h2><div>\nLa edad mínima para el uso de las instalaciones es de<strong> 14 años cumplidos</strong>.<br>\nLos menores deberán contar con<strong> autorización escrita</strong> de su padre, madre o tutor, quien será<strong>\n responsable solidario</strong>\n por cualquier daño, incumplimiento, sanción o consecuencia derivada de la conducta del menor dentro de las instalaciones.\n</div></div><div><br><hr></div><div><h2>IV. MEMBRESÍAS, COSTOS Y CONDICIONES</h2><h2>IV BIS. MEMBRESÍA INDIVIDUAL</h2>\n<div>La <strong>Membresía Individual</strong> otorga a EL USUARIO el derecho<strong>\n personal, intransferible y no exclusivo</strong>\n de acceso y uso de las instalaciones de BY LIFE FIT, conforme a los términos del presente contrato, el Reglamento Interno y la disponibilidad operativa del gimnasio.\n</div><div><br><strong>Modalidades y costos</strong><ul><li><strong>Mensual:</strong> $749.00 MXN</li><li><strong>\nAnual:</strong> $7,499.00 MXN</li><li><strong>Inscripción:</strong> $2,000.00 MXN</li><li><strong>\nReinscripción (cuando aplique):</strong> $1,200.00 MXN</li></ul><br><strong>Condiciones generales</strong><br><br>\na) La membresía individual podrá contratarse en modalidad mensual o anual, a elección del USUARIO.<br>\nb) La modalidad anual implica un pago anticipado por doce (12) meses consecutivos de servicio, sin que ello genere derechos adicionales distintos a los establecidos en el presente contrato.\n<br>c) La membresía es<strong> personal e intransferible</strong>\n; queda prohibido ceder, prestar o permitir el acceso a terceros.<br>\nd) La falta de pago dará lugar a la suspensión automática del servicio y, en su caso, a la aplicación de reinscripción conforme a lo establecido en este contrato.\n<br>e) La membresía individual<strong> podrá ser elegible</strong>\n, a discreción del GIMNASIO, para descuentos, ajustes o congelamientos por ausencias justificadas, únicamente en los supuestos expresamente previstos en este contrato.\n<br>f) La cancelación de la membresía individual<strong> no genera derecho a reembolso alguno</strong>\n, independientemente de la modalidad contratada o del tiempo no utilizado.</div></div><div><br><hr></div><div><h2>\nIV TER. MEMBRESÍA 2x1 (TITULAR + DEPENDIENTE)</h2><div>\nLa Membresía 2x1 es una membresía especial y preferencial, mediante la cual EL GIMNASIO otorga el derecho de uso de las instalaciones a dos personas: un TITULAR y un DEPENDIENTE, constituyendo una sola unidad contractual indivisible.\n<br><br><strong>Modalidades y costos</strong><ul><li><strong>Mensual:</strong> $1,200.00 MXN</li><li><strong>\nNo existe modalidad anual</strong></li><li>Inscripción: $2,800.00 MXN</li><li>Reinscripción: $2,000.00 MXN</li></ul>\n<br><strong>Condiciones especiales y restrictivas</strong><br><br>\na) La membresía 2x1 es exclusiva para usuarios de nuevo ingreso y no podrá ser contratada por usuarios que cuenten o hayan contado previamente con membresía individual.\n<br>b) No se permite la migración de membresía individual a membresía 2x1 bajo ninguna circunstancia.<br>\nc) Sí se permite la migración de membresía 2x1 a membresía individual, sujetándose a los costos, inscripción y condiciones vigentes al momento del cambio.\n<br>\nd) La membresía 2x1 no es elegible para descuentos, ajustes, congelamientos o compensaciones por ausencias, viajes, inasistencias o cualquier otra causa.\n<br>\ne) El DEPENDIENTE designado al momento de la contratación no podrá ser sustituido, cambiado o transferido, salvo autorización expresa y por escrito del GIMNASIO.\n<br>\nf) Cualquier incumplimiento, falta, sanción o conducta atribuible al DEPENDIENTE afectará directamente al TITULAR y a la totalidad de la membresía, conforme a lo establecido en la cláusula relativa al DEPENDIENTE.\n<br>\ng) La baja, expulsión o restricción del DEPENDIENTE no dará derecho a reducción, ajuste ni reembolso alguno del costo de la membresía 2x1.\n<br><strong>Naturaleza jurídica</strong><br>EL TITULAR reconoce expresamente que la membresía 2x1:<ul><li>\nNo constituye dos membresías independientes.</li><li>Es un beneficio tarifario condicionado.</li><li>\nEstá sujeta a reglas más restrictivas que la membresía individual.</li></ul><h3>\nIV Quarter. DEL DEPENDIENTE (MEMBRESÍA 2x1)</h3>En el caso de la membresía<strong> 2x1</strong>\n, EL DEPENDIENTE es la persona autorizada por EL TITULAR para hacer uso de las instalaciones,<strong>\n sin que ello implique una relación contractual directa con EL GIMNASIO.</strong><br><br>\nEL TITULAR reconoce y acepta que:<br>a) El DEPENDIENTE<strong> no es un usuario independiente</strong>\n, sino una extensión del derecho otorgado al TITULAR.<br>b) EL TITULAR será<strong> responsable solidario</strong>\n por cualquier daño, incumplimiento, sanción, adeudo, conducta indebida o violación al contrato o reglamento cometida por el DEPENDIENTE.\n<br>c) Cualquier falta atribuible al DEPENDIENTE<strong> podrá generar sanciones directas al TITULAR</strong>\n, incluyendo suspensión o baja definitiva de la membresía completa.<br>\nd) La baja, expulsión o restricción del DEPENDIENTE<strong> no dará derecho a reembolso, ajuste o reducción de la cuota\n</strong> de la membresía 2x1.<br>e) El GIMNASIO se reserva el derecho de revocar el acceso del<strong> DEPENDIENTE\n</strong> sin que ello implique obligación de sustitución ni compensación alguna.<br><br>\nEL TITULAR reconoce que la membresía 2x1 constituye<strong> una sola unidad contractual</strong>\n, y que cualquier incumplimiento de cualquiera de sus integrantes afecta a la totalidad de la membresía.</div></div>\n<div><br><hr></div><div><h2>V. PAGOS, MORA, SUSPENSIÓN Y REINSCRIPCIÓN</h2><div>\nEL USUARIO se obliga a cubrir puntualmente las cuotas correspondientes.<ul><li>Se otorgarán<strong>\n 5 días naturales de gracia.</strong></li><li>A partir del día 6 se aplicará<strong> 3% de interés moratorio mensual.\n</strong></li><li>El acceso será<strong> suspendido automáticamente</strong> hasta regularizar el adeudo.</li></ul><br>\nLa<strong> reinscripción solo será exigible después de 45 días naturales consecutivos sin pago</strong>\n, conforme a la membresía contratada.</div></div><div><br><hr></div><div><h2>VI. HORARIOS Y OPERACIÓN</h2><div><ul><li>\nLunes a viernes: 6:00 a 22:00</li><li>Sábados: 8:00 a 18:00</li><li>Domingos: 8:00 a 16:00</li></ul><br>Cierre total:\n<strong> 25 de diciembre y 1 de enero</strong><br>Días festivos y horarios especiales:<strong> 8:00 a 16:00</strong>\n<br>\nEl gimnasio se reserva el derecho de cerrar operaciones cualquier día por causas extraordinarias, mantenimiento o situaciones de emergencia, sin previo aviso.\n<br>Estos ajustes no generan reembolso, compensación ni extensión automática de la membresía.</div></div><div><br><hr>\n</div><div><h2>VII. AUSENCIAS Y ENFERMEDAD</h2><div>Solo aplicable a membresía individual.<br>\nLas ausencias por viaje podrán ser consideradas previa solicitud escrita.<br>En caso de enfermedad<strong>\n justificada ante el IMSS</strong>\n, podrá otorgarse congelamiento temporal o descuento total, a discreción del GIMNASIO. Solo podrá ausentarse por enfermedad por un máximo de 2 meses (60 días naturales).\n</div></div><div><br><hr></div><div><h2>VIII. LOCKERS</h2><h3>VIII Bis. Lockers libres</h3><div><br>\na) Los lockers libres son de uso temporal y exclusivo durante la estancia diaria del USUARIO.<br>\nb) Es obligatorio que el USUARIO utilice candado propio.<br>\nc) Al cierre de operaciones de cada día, todos los lockers deberán encontrarse desocupados.<br>\nd) Cualquier locker que permanezca cerrado será abierto por el personal, rompiendo el candado si es necesario, sin responsabilidad alguna para el GIMNASIO.\n<br>\ne) El GIMNASIO no se hace responsable por pérdida, robo, daño o extravío de objetos personales, aun cuando estos se encuentren dentro de lockers.\n</div><h3>VIII Ter. Lockers rentables</h3><div><br>a) Sujetos a disponibilidad.<br>\nb) El plazo de renta no podrá exceder la vigencia de la membresía activa.<br>c) El locker es personal e intransferible.\n<br>\nd) En caso de abandono, el GIMNASIO podrá abrirlo y resguardar el contenido por 7 días naturales, sin responsabilidad posterior.\n</div></div><div><br><hr></div><div><h2>IX. VISITAS EXTERNAS</h2><div>Toda visita externa deberá:<br>\na) Registrarse en recepción.<br>b) Presentar identificación oficial vigente.<br>\nc) Autorizar y permitir la obtención de copia de dicha identificación.<br>\nSin el cumplimiento de estos requisitos, no se permitirá el acceso.<br><br>\nEl TITULAR será responsable solidario por cualquier daño, sanción o incumplimiento del invitado.</div></div><div><br>\n<hr></div><div><h2>X. ACCESO, OBJETOS PROHIBIDOS Y ESTADO FÍSICO</h2><div>Queda estrictamente prohibido:<ul><li>\nIngresar o permanecer en estado de ebriedad.</li><li>\nIngresar bajo efectos de estupefacientes, narcóticos o sustancias ilegales.</li><li>\nIngresar con bebidas alcohólicas, drogas, armas u objetos peligrosos.</li></ul><br>EL GIMNASIO podrá <strong>\nnegar o retirar el acceso de forma inmediata</strong>, sin reembolso.</div></div><div><br><hr></div><div><h2>\nXI. MODIFICACIONES AL CONTRATO Y REGLAMENTO</h2><div>\nEL GIMNASIO podrá modificar en cualquier momento el contrato, reglamento, horarios, servicios y tarifas por razones operativas, administrativas, legales o de seguridad.\n<br>Las modificaciones serán notificadas por medios oficiales y <strong>\nel uso continuado del gimnasio constituirá aceptación expresa.</strong></div></div><div><br><hr></div><div><h2>\nXII. RESPONSABILIDAD, RIESGO Y CONDICIÓN FÍSICA</h2><div>\nEL USUARIO reconoce que el ejercicio implica riesgos inherentes.<br>\nDeclara encontrarse en condiciones físicas adecuadas y<strong> asume total responsabilidad</strong>\n por el uso de las instalaciones.<br>EL GIMNASIO solo responderá en caso de<strong> negligencia directa y comprobable.\n</strong></div></div><div><br><hr></div><div><h2>XIII. LIMITACIÓN DE RESPONSABILIDAD</h2><div>\nEn ningún caso la responsabilidad del GIMNASIO excederá el<strong> monto pagado por el último mes de servicio.</strong>\n</div></div><div><br><hr></div><div><h2>XIV. CASO FORTUITO Y FUERZA MAYOR</h2><div>\nNo habrá responsabilidad, reembolsos ni compensaciones por suspensiones derivadas de fuerza mayor, disposiciones de autoridad o contingencias ajenas al GIMNASIO.\n</div></div><div><br><hr></div><div><h2>XV. CÁMARAS DE SEGURIDAD E IMAGEN</h2><div>\nEL USUARIO acepta la videovigilancia y autoriza el uso de imágenes generales no individualizadas con fines informativos o promocionales.\n</div></div><div><br><hr></div><div><h2>XVI. PROPIEDAD INTELECTUAL</h2><div>La marca<strong> BY LIFE FIT</strong>\n y todo su contenido son propiedad exclusiva del GIMNASIO.</div></div><div><br><hr></div><div><h2>\nXVII. TOLERANCIA CERO A INCUMPLIMIENTOS CRÍTICOS</h2><div>EL GIMNASIO podrá rescindir<strong>\n de forma inmediata y definitiva</strong> la membresía por faltas graves,<strong>\n sin reembolso ni derecho a acceso futuro.</strong></div></div><div><br><hr></div><div><h2>\nXVIII. CANCELACIÓN Y REEMBOLSOS</h2><div>La cancelación deberá solicitarse con<strong>\n 30 días naturales de anticipación.</strong><br><strong>No existen reembolsos en ningún caso.</strong></div></div><div>\n<br><hr></div><div><h2>XIX. JURISDICCIÓN</h2><div>Las partes se someten a las leyes y tribunales de la<strong>\n Ciudad de México.</strong></div></div><div><br><hr></div><div><h3>ACEPTACIÓN Y FIRMA DEL CONTRATO</h3><div>\nLeído que fue el presente Contrato de Prestación de Servicios y Uso de Instalaciones de BY LIFE FIT, y enteradas las partes de su contenido, alcance legal y obligaciones, lo firman de conformidad, manifestando que lo hacen libre de error, dolo o mala fe.\n<br><br>\nEL USUARIO declara haber recibido copia del contrato y de sus anexos, mismos que reconoce como parte integrante del presente instrumento.\n<br><br>Manifiesto bajo protesta de decir verdad que<strong>\n he obtenido previamente y de manera clara la información relativa a los precios, planes, tipos de membresía, inscripciones, reinscripciones, servicios, horarios, reglamento interno y condiciones generales de BY LIFE FIT\n</strong>, por lo que celebro el presente contrato con pleno conocimiento de sus alcances y obligaciones.<br><br>\nDeclaro que dicha información me fue proporcionada con anterioridad a la firma del presente contrato y que no existe confusión, error o información pendiente respecto de los servicios contratados.\n</div></div><div><br><hr></div><div><h3>EL GIMNASIO</h3><div>BY LIFE FIT<br>Propietario: JORGE BÁRCENAS SÁNCHEZ<br>\nRFC: BASJ760901420<br>Fecha: {{vm.data.date|date:\'dd / MM / yyyy\'}}<br>Firma:<div style=\"width: 300px\"><img \nsrc=\"assets/images/signature_club.png\"></div></div></div><div><br><hr></div><div><h3>EL TITULAR / USUARIO</h3><div>\nNombre completo: {{vm.data.partnerName}}<br>FIRMA:<div style=\"width: 300px\"><img ng-src=\"{{vm.signatureSrc}}\"></div>\n</div></div><div><br><hr></div><h1>AVISO DE PRIVACIDAD</h1><div><strong>BY LIFE FIT</strong>, con domicilio en<strong>\n Calzada de los Leones número 115, Local D, Ciudad de México</strong>, y operado por<strong>{{partnerName}}</strong>\n, RFC <strong>{{rfc}}</strong>\n, es responsable del uso y protección de los datos personales que recabe de sus usuarios, en términos de la<strong>\n Ley Federal de Protección de Datos Personales en Posesión de los Particulares</strong>\n, por lo que se hace de su conocimiento lo siguiente:</div><div><br><hr></div><div><h2>DATOS PERSONALES QUE SE RECABAN\n</h2><div>\nLos datos personales que se recabarán de usted serán utilizados para las siguientes finalidades necesarias para la prestación del servicio que solicita:\n<ul><li>Verificar y confirmar su identidad.</li><li>Establecer y mantener datos de contacto.</li><li>\nAdministración de membresías, inscripciones, reinscripciones y pagos.</li><li>\nPrestación de servicios deportivos y uso de instalaciones.</li><li>\nElaboración y expedición de comprobantes fiscales, en su caso.</li><li>\nAtención a clientes, dudas, aclaraciones, quejas y reclamaciones.</li><li>\nControl de acceso y seguridad dentro de las instalaciones.</li></ul><br>En caso de<strong> membresías 2x1</strong>\n, se recabarán datos del dependiente únicamente para fines administrativos y de control de acceso.</div><br><h3>\nCOMERCIALIZACIÓN DE PRODUCTOS</h3><div>Los datos personales también podrán ser utilizados para la<strong>\n venta y administración de productos y servicios comercializados por BY LIFE FIT</strong>\n, así como para la atención de asuntos relacionados con dichas operaciones.</div></div><div><br><hr></div><div><h2>\nFINALIDADES SECUNDARIAS</h2><div>\nDe manera adicional, utilizaremos su información personal para las siguientes finalidades<strong> no necesarias\n</strong> para la prestación del servicio, pero que nos permiten brindarle una mejor atención:<ul><li>\nInformar sobre servicios, avisos operativos, promociones o beneficios.</li><li>\nInvitaciones a eventos o actividades organizadas por el gimnasio.</li><li>Evaluación de la calidad del servicio.</li>\n</ul><br>\nEn caso de que no desee que sus datos personales sean utilizados para estas finalidades secundarias, podrá manifestarlo a través de los medios de contacto del gimnasio. La negativa para el uso de datos personales para estas finalidades\n<strong> no será motivo para negarle los servicios</strong> que contrate.</div></div><div><br><hr></div><div><h2>\nTRANSFERENCIA DE DATOS</h2><div>\nBY LIFE FIT no transferirá sus datos personales a terceros sin su consentimiento, salvo aquellas excepciones previstas por la ley.\n</div></div><div><br><hr></div><div><h2>DERECHOS ARCO</h2><div>Usted tiene derecho a<strong>\n Acceder, Rectificar, Cancelar u Oponerse</strong>\n al tratamiento de sus datos personales (derechos ARCO), así como a revocar el consentimiento otorgado.<br>\nPara ejercer dichos derechos, deberá presentar la solicitud correspondiente por escrito a través de los medios que BY LIFE FIT tenga establecidos para tal efecto, misma que será atendida conforme a la normatividad aplicable.\n</div></div><div><br><hr></div><div><h2>VIDEOVIGILANCIA</h2><div>Le informamos que las instalaciones cuentan con\n<strong> cámaras de videovigilancia</strong>\n, utilizadas exclusivamente para fines de seguridad de las personas, bienes e instalaciones.</div></div><div><br><hr>\n</div><div><h2>CAMBIOS AL AVISO DE PRIVACIDAD</h2><div>\nEl presente Aviso de Privacidad podrá sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales o necesidades operativas del gimnasio, las cuales serán informadas por los medios oficiales de BY LIFE FIT.\n</div></div><div><br><hr></div><div><h2>CONSENTIMIENTO</h2><div><strong>\nHe leído y acepto el presente Aviso de Privacidad</strong>\n, otorgando mi consentimiento para el tratamiento de mis datos personales conforme a los términos aquí establecidos.\n</div></div><div><br><hr></div><div>Fecha: {{vm.data.date|date:\'dd / MM / yyyy\'}}<br>\nNombre del Titular: {{vm.data.partnerName}}<div>FIRMA:<div style=\"width: 300px\"><img ng-src=\"{{vm.signatureSrc}}\">\n</div></div></div><br><br><br><br><div><h2>REGLAMENTO INTERNO GENERAL</h2><h3>BY LIFE FIT</h3><div>\nEl presente Reglamento forma parte integrante del<strong>\n Contrato de Prestación de Servicios y Uso de Instalaciones de BY LIFE FIT</strong> y es de<strong>\n observancia obligatoria</strong> para todos los usuarios, dependientes, invitados y visitantes.<br>\nEl desconocimiento del reglamento<strong> no exime de su cumplimiento.</strong></div></div><div><br><hr></div><div><h2>\nI. ACCESO Y PERMANENCIA</h2><div><ul><li>1.	El acceso es<strong> personal, intransferible y condicionado</strong>\n a contar con membresía activa o autorización expresa.</li><li>2.	El ingreso podrá ser<strong> negado o retirado\n</strong> a cualquier persona que:</li><ul><li>Se encuentre en estado de ebriedad</li><li>\nSe encuentre bajo efectos de estupefacientes, narcóticos o sustancias ilegales</li><li>\nMuestre conductas agresivas, alteradas o riesgosas</li></ul><li>3.	EL GIMNASIO se reserva el derecho de<strong>\n negar el acceso sin explicación adicional</strong>, cuando exista riesgo para la seguridad o el orden.</li><li>\n4.	Queda estrictamente prohibido<strong> compartir accesos</strong>, credenciales o permitir el ingreso de terceros.\n</li><li>\n5.	Aquel usuario que haya sido dado de baja por faltas graves o cualquier otro motivo, no podrá bajo ningún motivo reincorporarse o acceder mediante algún pase o visita.\n</li></ul></div></div><div><br><hr></div><div><h2>II. VESTIMENTA E HIGIENE</h2><div><ul><li>\n1. Es obligatorio el uso de:</li><ul><li>Ropa deportiva adecuada</li><li>Calzado deportivo cerrado</li><li>\nToalla personal</li></ul><li>2.	Está prohibido:</li><ul><li>Entrenar sin playera</li><li>Entrenar descalzo</li><li>\nEntrenar con ropa no deportiva</li></ul><li>3.	El incumplimiento dará lugar a negativa inmediata de acceso.</li></ul>\n</div></div><div><br><hr></div><div><h2>III. USO DE EQUIPO E INSTALACIONES</h2><div><ul><li>1.	Todo usuario deberá:\n</li><ul><li>Utilizar el equipo correctamente y conforme a su diseño</li><li>Limpiar el equipo después de usarlo</li>\n<li>Regresar mancuernas, discos y accesorios a su lugar</li></ul><li>2.	Queda estrictamente prohibido:</li><ul><li>\nAzotar pesas</li><li>Modificar o mover equipo fijo</li><li>Utilizar equipo sin conocimiento o sin indicaciones</li><li>\nDejar mochilas, bolsas o pertenencias personales en áreas distintas a las zonas designadas para ello.</li></ul><li>\n3.	El daño al equipo por uso indebido podrá generar:</li><ul><li>Suspensión inmediata</li><li>Cobro por reparación</li>\n<li>Baja definitiva</li></ul></ul></div></div><div><br><hr></div><div><h2>IV. LOCKERS Y OBJETOS PERSONALES</h2><div>\n<h3>Lockers libres</h3><ul><li>1.	Son de uso temporal, únicamente durante la visita.</li><li>\n2.	Es obligatorio el uso de candado propio.</li><li>3.	Al cierre del gimnasio:<ul><li>\nTodo locker deberá estar desocupado</li><li>Candados no retirados serán rotos sin responsabilidad del gimnasio</li>\n</ul></li><li>4.	EL GIMNASIO no se hace responsable por:<ul><li>Robo</li><li>Extravío</li><li>Daños</li><li>\nObjetos olvidados</li></ul></li></ul><h3>Lockers rentables</h3><ul><li>1.	Uso personal e intransferible.</li><li>\n2.	El plazo no podrá exceder la vigencia de la membresía.</li><li>\n3.	En caso de abandono, el locker podrá abrirse y el contenido será resguardado por 7 días naturales, sin responsabilidad posterior.\n</li></ul></div></div><div><br><hr></div><div><h2>V. VESTIDORES Y REGADERAS</h2><div>\nEl acceso es exclusivo para usuarios activos.<ul><li>1.	Es<strong> obligatorio el uso de chanclas</strong>\n en regaderas.</li><li>2.	Está estrictamente prohibido:<ul><li>Grabar, fotografiar o realizar videollamadas</li><li>\nCorrer, empujar o realizar actos inseguros</li><li>Permanecer sin motivo razonable</li></ul></li><li>3.	Se deberá:<ul>\n<li>Respetar la privacidad de terceros</li><li>Mantener orden e higiene</li></ul></li><li>\n4.	Las regaderas son de uso individual por lo que en todo momento, no deberá de haber más de una persona por regadera.\n</li><li>5.	Cualquier conducta indebida será sancionada<strong> sin advertencia previa.</strong></li></ul></div></div>\n<div><br><hr></div><div><h2>VI. CONDUCTA, RESPETO Y CONVIVENCIA</h2><div><ul><li>1.	Se exige un trato respetuoso hacia:\n<ul><li>Otros usuarios</li><li>Personal del gimnasio</li></ul></li><li>2.	Queda prohibido:<ul><li>Acoso</li><li>\nDiscriminación</li><li>Violencia verbal o física</li><li>Lenguaje ofensivo</li><li>Agresión verbal o física;</li></ul>\n</li><li>Hacia cualquier miembro usuario o personal.</li><li>3.	Cualquier falta grave derivará en baja definitiva.</li>\n</ul></div></div><div><br><hr></div><div><h2>VI. CONDUCTA, RESPETO Y CONVIVENCIA</h2><div><ul><li>\n1.	Se exige un trato respetuoso hacia:<ul><li>Otros usuarios</li><li>Personal del gimnasio</li></ul></li><li>\n2.	Queda prohibido:<ul><li>Acoso</li><li>Discriminación</li><li>Violencia verbal o física</li><li>Lenguaje ofensivo\n</li><li>Agresión verbal o física;</li></ul></li><li>Hacia cualquier miembro usuario o personal.</li><li>\n3.	Cualquier falta grave derivará en baja definitiva.</li></ul></div></div><div><br><hr></div><div><h2>\nVII. PROHIBICIONES ESPECÍFICAS</h2><div>Queda estrictamente prohibido:<ul><li>Ingresar bebidas alcohólicas</li><li>\nIngresar sustancias ilegales</li><li>Fumar o vapear dentro de las instalaciones</li><li>\nIngresar armas u objetos peligrosos</li><li>Ofrecer o vender productos o servicios sin autorización</li></ul></div>\n</div><div><br><hr></div><div><h2>VIII. USO DE IMAGEN Y DISPOSITIVOS</h2><div><ul><li>\n1.	Está prohibido grabar a terceros sin consentimiento.</li><li>2.	El gimnasio cuenta con<strong>\n videovigilancia permanente.</strong></li><li>3.	Las imágenes se utilizan exclusivamente para:<ul><li>Seguridad</li>\n<li>Control interno</li><li>Material promocional general no individualizado</li></ul></li></ul></div></div><div><br>\n<hr></div><div><h2>IX. VISITAS E INVITADOS</h2><div><ul><li>1.	Toda visita deberá:<ul><li>Registrarse</li><li>\nPresentar identificación oficial</li><li>Autorizar copia de la misma</li></ul></li><li>2.	El titular será<strong>\n responsable total</strong> del invitado.</li><li>3.	El incumplimiento del invitado afectará directamente al titular.\n</li></ul></div></div><div><br><hr></div><div><h2>X. SANCIONES (ESCALERA OPERATIVA)</h2><div>\nLas sanciones podrán aplicarse de manera progresiva o directa, según la gravedad:<ul><li>1.	Amonestación verbal</li>\n<li>2.	Amonestación escrita</li><li>3.	Suspensión temporal</li><li>4.	Negativa de acceso</li><li>5.	<strong>\nBaja definitiva sin reembolso</strong></li></ul>EL GIMNASIO se reserva el derecho de<strong>\n aplicar la sanción que considere adecuada</strong> sin necesidad de advertencias previas en faltas graves.</div></div>\n<div><br><hr></div><div><h2>XI. DISPOSICIONES FINALES</h2><div><ul><li>1.	El presente Reglamento podrá ser<strong>\n modificado en cualquier momento</strong> conforme al contrato.</li><li>2.	La permanencia en las instalaciones implica\n<strong> aceptación total</strong> del mismo.</li><li>\n3.	Todo lo no previsto será resuelto por la administración del gimnasio.</li></ul></div></div><div><br><hr></div><br>\n<div class=\"titulo-centrado-normal\">Recibí el reglamento interno de BY LIFE FIT</div><br><div \nclass=\"titulo-centrado-normal\" style=\"margin-bottom: 100px\"><table style=\"width: 100%\"><tr><td \nstyle=\"width: 100%;\n                  text-align: center;\n                  height: 100px;\n                  vertical-align: super\">\n<img ng-src=\"{{vm.signatureSrc}}\"></td></tr><tr><td style=\"width: 50%; text-align: center\"><hr style=\"width: 60%\">\nNombre y Firma del titular</td></tr></table></div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/contract/contract-default.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Guardar</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.showSignature($event)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon><md-tooltip>Firmar</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.sendByEmail()\" ng-disabled=\"vm.sendingEmail\"><md-icon md-font-icon=\"icon-email\" \nng-show=\"!vm.sendingEmail\"></md-icon><md-icon md-font-icon=\"icon-dots-horizontal\" ng-show=\"vm.sendingEmail\"></md-icon>\n<md-tooltip>Enviar por email</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getLastData()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>Obtener datos nuevamente</md-tooltip></md-button></div><div \nid=\"complete-document\" class=\"card md-whiteframe-8dp\"><div>LAYOUT DE CONTRATO VACIO</div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/contract/contract-omada.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Guardar</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.showSignature($event)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon><md-tooltip>Firmar</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.sendByEmail()\" ng-disabled=\"vm.sendingEmail\"><md-icon md-font-icon=\"icon-email\" \nng-show=\"!vm.sendingEmail\"></md-icon><md-icon md-font-icon=\"icon-dots-horizontal\" ng-show=\"vm.sendingEmail\"></md-icon>\n<md-tooltip>Enviar por email</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getLastData()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>Obtener datos nuevamente</md-tooltip></md-button></div><div \nid=\"complete-document\" class=\"card md-whiteframe-8dp\"><div class=\"contract-wrapper\"><div fxlayout=\"row\" \nfxlayoutalign=\"center center\" style=\"width: 100%; text-align:center; margin-bottom:20px\"><img \nng-src=\"{{vm.logoSource}}\" style=\"height: 60px !important\"></div><div class=\"contract\"><div \nclass=\"contract-title text-bold text-right\">CONTRATO NÚMERO: <span style=\"text-decoration: underline\">\n{{vm.data.folioMembresia}}</span></div><br><div class=\"contract-title text-bold\">\nCONTRATO DE MEMBRESÍA Y SERVICIOS DE USO DE UN CLUB DEPORTIVO QUE CELEBRAN POR UNA PARTE DEPORTIVO ÓMADA SOCIEDAD DE RESPONSABILIDAD LIMITADA DE CAPITAL VARIABLE POR CUENTA DEL CLUB DEPORTIVO DENOMINADO “ÓMADA CLUB DEPORTIVO” (EN ADELANTE INDISTINTAMENTE COMO “OMADA CLUB DEPORTIVO” O “EL CLUB”), REPRESENTADA EN ESTE ACTO POR EL SEÑOR RAMÓN BERRA DE LA VEGA; Y POR LA OTRA PARTE EL(LA) SEÑOR(A) \n<span style=\"text-decoration: underline\">{{vm.data.razonSocial}}</span>\n - POR SU PROPIO DERECHO (EN ADELANTE EL “CLIENTE”), CONFORME A LAS SIGUIENTES DECLARACIONES Y CLÁUSULAS.</div><br><div\n class=\"text-center contract-title\"><strong>DECLARACIONES</strong></div><br><div style=\"text-decoration: underline\">\n<strong>I. DECLARA ÓMADA CLUB DEPORTIVO</strong></div><div>\na) Ser una empresa legalmente constituida conforme a las leyes mexicanas para prestar los servicios de Club Deportivo.\n</div><div>\nb)	Que el Sr. Ramón Berra de la Vega, como su representante legal, tiene plenas facultades para celebrar el presente Contrato, mismas que a la fecha no les han sido modificadas, revocadas ni restringidas en forma alguna.\n</div><div>c)	Que su nombre para identificación fiscal es DEPORTIVO ÓMADA S. DE R.L. DE C.V. y su RFC es DOM240416VB0\n</div><div>\nd)	Que va a operar un Club Deportivo al que comercialmente se le denominará ÓMADA CLUB DEPORTIVO el cual se ubicará en Av. De La Pradera #3, Lomas de Angelópolis, Municipio de Santa Clara Ocoyucan Puebla, CP 72865, Puebla; en el Lote Comercial 15 del complejo inmobiliario denominado Barrio Cascatta y que será operado, diseñado y constituido para este fin.\n</div><div>\ne)	Que la intención del presente Contrato es acordar los términos y condiciones en los cuales se otorgará al Cliente el servicio de membresía del Club Deportivo, una vez que el mismo se encuentre en operación, por lo que el presente Contrato quedará sujeto a las condiciones suspensivas que se incluyen en su clausulado.\n</div><div>\nf)	Que manifiesta su voluntad con la firma del presente Contrato, obligándose en los términos y condiciones que aparece en sus cláusulas.\n</div><div style=\"text-decoration: underline\"><strong>II.	DECLARA EL CLIENTE.</strong></div><div>\na)	Ser una persona física mayor de edad con capacidad plena para contratar y obligarse a cumplir los términos del presente Contrato y hace como suyos todos los datos personales que en este momento incorpora y se incluyen en la solicitud adjunta como Anexo “A”, cuyos datos y menciones se reproducen en este acto como si a la letra se insertase en este Contrato, ya que serán los datos que el Club Deportivo tomará en cuenta como proporcionados por el Cliente para la prestación del Servicio, en la inteligencia que cualquier cambio o actualización deberá realizarse en el Anexo “A”.\n</div><div>\nb)	Que tiene toda la intención de pagar por el derecho de uso y disfrute temporal que le otorga ser titular de la membresía del Club Deportivo así como de respetar todos y cada uno de los Reglamentos que el Club Deportivo ha expedido y expida en un futuro para regular la correcta interacción en el mismo, incluyendo obligarse y obligar a sus familiares incluidas en su membresía, así como a sus correspondientes invitados, a cumplir con los términos y condiciones señalados en el presente Contrato.\n</div><div>\nc)	Que en caso de tener una membresía familiar o de pareja, se obliga a dar a conocer a cada uno de sus familiares o personas que haya asignados como usuarios incluidos en su membresía (en adelante los usuarios) del Club Deportivo, todas y cada una de las reglas que deben de ser cumplidas por ellos durante el uso del Club Deportivo, haciéndose responsable directo el Cliente de todos los actos que estos usuarios realicen, por lo que en todos los términos del Contrato que involucren conductas o actividades u obligaciones serán entendidas que por Cliente abarca el compromiso de todos los usuarios asignados en una membresía, con lo que manifiesta su conformidad en este acto el Cliente.\n</div><div>\nd)	Que conoce y acepta que los derechos y obligaciones del presente Contrato, no pueden ser cedidos por el Cliente o los usuarios, salvo las excepciones que marca el presente Contrato, pero que en principio quedan al arbitrio exclusivo del Club Deportivo.\n</div><div>\ne)	Que es su voluntad celebrar el presente Contrato en los términos y condiciones señalados en declaraciones y cláusulas de este.\n</div><div>Una vez hechas las declaraciones anteriores, ambas Partes se otorgan las siguientes:</div><div \nclass=\"page-break\"></div><div class=\"contract-title text-center\"><strong>CLÁUSULAS</strong></div><br><div><strong \nstyle=\"text-decoration: underline\">PRIMERA.- CONTRATO – MEMBRESÍA.</strong>\n En virtud del Presente Contrato, las Partes acuerdan y pactan la forma, tiempo, modo y circunstancias en que el Club Deportivo otorgará al Cliente un derecho revocable para la prestación del servicio de uso de instalaciones del Club Deportivo denominado ÓMADA CLUB DEPORTIVO, Contrato que una vez suscrito hará las veces de membresía.\n</div><div><strong style=\"text-decoration: underline\">I.	LUGAR DE SERVICIOS Y HORARIOS DE PRESTACIÓN DE ESTOS.</strong>\n Los servicios se suministrarán exclusivamente en la dirección que se señala al rubro y en los siguientes horarios:<ul>\n<li>Lunes a viernes es: De 6:00 a 23:00 horas.</li><li>Sábado: De 7:00 a 21:00 horas.</li><li>\nDomingo: De 7:00 a 19:00 horas.</li><li>Días Festivos: Según programación anticipada del Club Deportivo.</li></ul>\n</div><div>\nII.	Toda modificación a los horarios será avisada anticipadamente por el CLUB DEPORTIVO, mediante anuncios fijados en el establecimiento, salvo causas de fuerza mayor.\n</div><div><strong style=\"text-decoration: underline\">SEGUNDA.- PAGO POR MEMBRESÍA.</strong>\n Las Partes acuerdan que en la fecha de firma del presente Contrato, el Cliente se obliga a pagar por concepto de pago de membresía la cantidad de $30,000.00 (Treinta mil pesos 00/100 Moneda Nacional) más IVA(Con las excepciones de promoción de preventa y promociones mensuales subsecuentes), lo cual le otorgará al Cliente la calidad de miembro del Club Deportivo y en un futuro a gozar del uso de las instalaciones, uso que quedará sujeto a las condiciones suspensivas que se establecen en la Cláusula Tercera siguiente. El Club Deportivo se obliga a emitir comprobante fiscal digital (CFDI) del pago que se realice por dicho concepto.\n</div><div><strong style=\"text-decoration: underline\">TERCERA.- CONDICIONES SUSPENSIVAS.</strong>\n El uso y disfrute de las instalaciones del Club Deportivo estará sujeto a las siguientes condiciones suspensivas: (i) La conclusión total de las obras del Club Deportivo; y, (ii) Que el Club Deportivo abra sus puertas y entre en Operación; en este orden e ideas, el Club Deportivo se obliga a notificarle al Cliente con 15 días de anticipación la fecha en la cual se realice la apertura que marque el inicio de operaciones del Club Deportivo para que en el siguiente mes inicie con el pago de las cuotas de mantenimiento a que se refiere la cláusula cuarta siguiente.\n</div><div><strong style=\"text-decoration: underline\">\nCUARTA.- TIPOS DE MEMBRESIAS, PAGO POR MANTENIMIENTOS E INCREMENTO AL PAGO DE MANTENIMIENTO.</strong></div><div><strong\n style=\"text-decoration: underline\">1.	TIPOS DE MEMBRESÍAS.</strong>\n El Cliente, a través del Anexo “A” realizó la solicitud de ser miembro del Club Deportivo y éste ha aceptado que el Cliente esté en la capacidad de utilizar de forma temporal y revocable las instalaciones del Club Deportivo, una vez cumplidas las Condiciones Suspensivas arriba citadas. El Cliente ya ha seleccionado su membresía tal como aparece en el propio Anexo “A”, de entre las membresías que ofrece el Club Deportivo conforme a la siguiente clasificación y conforme al tipo de ésta será el pago de las cuotas de mantenimiento mensual que el Cliente deberá realizar al Club Deportivo:\n</div><div><strong style=\"text-decoration: underline\">I.	MEMBRESÍA INDIVIDUAL.</strong>\n Esta membresía le otorga al Cliente solamente su membresía de titular.</div><div><strong \nstyle=\"text-decoration: underline\">II.	MEMBRESÍA DE PAREJA.</strong>\n Esta membresía le otorga al Cliente una membresía de titular y 1 (un) usuario adicional al Cliente.</div><div><strong \nstyle=\"text-decoration: underline\">III.	MEMBRESÍA FAMILIAR.</strong>\n Esta membresía es otorgada al Cliente que ha manifestado su deseo de inscribir a su familia en el Club Deportivo y éste le otorga al Cliente la membresía de titular y dependiendo de la modalidad(Familiar 3, Familiar 4, Familiar 5) hasta 4 (cuatro) registros de diferentes usuarios adicionales al Cliente que deberán ser: esposa y descendientes directos menores de 30 años (hijos); con la opción para que el Cliente pueda incluir a otros 2 (dos) usuarios adicionales por un costo extra en el pago de la mensualidad a ser establecido discrecionalmente por el Club Deportivo. III.I MENORES DE EDAD. Sin perjuicio a lo establecido en el Reglamento se observará lo siguiente: Para el registro e inscripción de menores de edad, estos deberán presentar petición por escrito de puño y letra de los padres o tutor, donde deslindan a la empresa y se obligan solidariamente a reparar cualquier daño ocasionado por el menor referido, asimismo el titular de la inscripción es responsable en todo momento por su seguridad y conducta.\n</div><div><strong style=\"text-decoration: underline\">IV.	MEMBRESÍA FAMILIAR EXTENDIDA.</strong>\n Será aquella membresía Familiar que incluya a un máximo de 2 (dos) ascendientes directos (abuelos paternos o maternos) por membresía familiar. En este caso el costo de la membresía sufrirá un incremento total en $5,000.00 ( Cinco mil pesos 00/100 Moneda Nacional) más IVA, adicionales al pago de la membresía señalado en la cláusula segunda anterior.\n</div><div><strong style=\"text-decoration: underline\">V.	MEMBRESÍA ESTUDIANTE.</strong>\n Esta membresía le otorga al Cliente solamente su membresía de titular. Mismo que deberá acreditar tener 15(Quince) años cumplidos y menos de 26(Veintiséis), además ser estudiante de un programa oficial con validez en la Secretaría de Educación Pública.\n</div><div><strong style=\"text-decoration: underline\">VI.	MEMBRESÍA MÁSTER.</strong>\n Esta membresía le otorga al Cliente solamente su membresía de titular. Mismo que deberá acreditar tener 60(Sesenta) Años cumplidos en la fecha de su registro.\n</div><div><strong style=\"text-decoration: underline\">2.	PAGO POR MANTENIMIENTOS.</strong>\n El Cliente se obliga a pagar al Club Deportivo de forma mensual y dentro de los primeros cinco días hábiles de cada mes, el pago de las cuotas de mantenimiento anteriormente señalado, dependiendo el tipo de membresía con la que cuente y de acuerdo a la siguiente tabla(Vigente durante 2025).\n</div><div class=\"page-break\"></div><div><table style=\"width: 100%; border-collapse: collapse;border: 1px solid\"><tr>\n<td colspan=\"3\" style=\"text-align: center; font-weight: bold;border: 1px solid\">CUOTA MENSUAL</td></tr><tr><td \nstyle=\"text-decoration: underline;text-align: center; font-weight: bold;border: 1px solid;width:35%\">TIPO</td><td \nstyle=\"text-decoration: underline;text-align: center; font-weight: bold;border: 1px solid;width:20%\">2025</td><td \nstyle=\"text-decoration: underline;text-align: center; font-weight: bold;border: 1px solid;width:45%\">OBSERVACIONES</td>\n</tr><tr><td style=\"border: 1px solid;padding-left:20px\">INDIVIDUAL</td><td \nstyle=\"border: 1px solid;padding-left:20px\">$ 2,400.00</td><td style=\"border: 1px solid;padding-left:20px\">UNA PERSONA\n</td></tr><tr><td style=\"border: 1px solid;padding-left:20px\">PAREJA</td><td \nstyle=\"border: 1px solid;padding-left:20px\">$ 3,183.00</td><td style=\"border: 1px solid;padding-left:20px\">\nDOS PERSONAS CON RELACIÓN INDISTINTA</td></tr><tr><td style=\"border: 1px solid;padding-left:20px\">FAMILIAR 3</td><td \nstyle=\"border: 1px solid;padding-left:20px\">$ 4,222.00</td><td style=\"border: 1px solid;padding-left:20px\">\nPADRE Y/O MADRE CON 1-2 HIJOS</td></tr><tr><td style=\"border: 1px solid;padding-left:20px\">FAMILIAR 4</td><td \nstyle=\"border: 1px solid;padding-left:20px\">$ 4,683.00</td><td style=\"border: 1px solid;padding-left:20px\">\nPADRE Y/O MADRE CON 2-3 HIJOS</td></tr><tr><td style=\"border: 1px solid;padding-left:20px\">FAMILIAR 5</td><td \nstyle=\"border: 1px solid;padding-left:20px\">$ 5,204.00</td><td style=\"border: 1px solid;padding-left:20px\">\nPADRE Y/O MADRE CON 3-4 HIJOS</td></tr><tr><td style=\"border: 1px solid;padding-left:20px\">FAMILIAR EXTENDIDA</td><td \nstyle=\"border: 1px solid;padding-left:20px\">$ 7,546.00</td><td style=\"border: 1px solid;padding-left:20px\">\nNÚCLEO FAMILIAR DE HASTA 5 + 2 ABUELOS</td></tr><tr><td style=\"border: 1px solid;padding-left:20px\">ADICIONAL INVITADO\n</td><td style=\"border: 1px solid;padding-left:20px\">$ 1,370.00</td><td style=\"border: 1px solid;padding-left:20px\">\n4o. HIJO O FAMILIAR INVITADO</td></tr><tr><td style=\"border: 1px solid;padding-left:20px\">UNIVERSITARIO HASTA 24 AÑOS\n</td><td style=\"border: 1px solid;padding-left:20px\">$ 1,370.00</td><td style=\"border: 1px solid;padding-left:20px\">\nINDIVIDUAL ESTUDIANDO PROGRAMA OFICIAL</td></tr><tr><td style=\"border: 1px solid;padding-left:20px\">MÁSTER 60+</td><td \nstyle=\"border: 1px solid;padding-left:20px\">$ 1,370.00</td><td style=\"border: 1px solid;padding-left:20px\">\nINDIVIDUAL CON 60 AÑOS CUMPLIDOS</td></tr></table></div><br><div><strong style=\"text-decoration: underline\">\n3.	EL PAGO POR CUOTAS DE MANTENIMIENTOS.</strong>\notorga el derecho al Cliente de usar las instalaciones del Club Deportivo, en los horarios de funcionamiento de este y adicionalmente a dichos pagos por cuotas de mantenimiento invariablemente deberán seguir las siguientes reglas:\n</div><div>\n(i)	El costo de cada uno de los pagos por mantenimiento, variarán dependiendo el tipo de membresía contratada y el costo de la cuota de mantenimiento mensual, será notificada por el Club Deportivo, en el mismo momento en que se notifique la apertura de este.\n</div><div>\n(ii)	Sólo se aceptarán transferencias electrónicas, pago con cheques o con pago de tarjeta de crédito o débito en las terminales punto de venta que en su momento se encuentren en las oficinas administrativas del Club Deportivo. Queda acordado por las Partes que sólo se aceptarán pagos en efectivo directamente depositados en ventanilla bancaria.\n</div><div>\n(iii)	Los pagos mensuales de cuotas de mantenimiento deberán pagarse a la cuenta bancaria que será proporcionada por el Club Deportivo al Cliente.\n</div><div>\n(iv)	El Cliente podrá realizar pagos anticipados anuales o mensuales, sin que exista un cargo adicional por este hecho; por su parte el Club Deportivo podrá, a su libre criterio, otorgarle un beneficio de conformidad con las políticas y presupuesto que tenga para ese año. No aplica ningún beneficio cuando el Cliente se ponga al corriente cuando haya existido un atraso en sus cuotas de mantenimiento y los pagos anticipados obedezcan también a ponerse al corriente.\n</div><br><div><strong>BENEFICIOS POR PRONTO PAGO.</strong></div><ul><li>\nPor el pago anticipado de TRES cuotas mensuales de mantenimiento el CLUB DEPORTIVO obsequia el 5% (Cinco por ciento)de descuento.\n</li><li>\nPor el pago anticipado de SEIS cuotas mensuales de mantenimiento el CLUB DEPORTIVO obsequia el 7% (Siete por ciento) de descuento.\n</li><li>\nPor el pago anticipado de DOCE cuotas mensuales de mantenimiento el CLUB DEPORTIVO obsequia el 10% (Diez por ciento) de descuento.\n</li><li>\nLos puntos 4.1, 4.2 y 4.3 aplican solo para pagos anticipados en una sola exhibición de contado, para promociones de pagos a meses sin intereses, aplica la promoción al 50%, en otros casos consultar los términos y condiciones.\n</li></ul><div>\n(v)	Ambas Partes acuerdan que los pagos por cuotas de mantenimiento solamente incluyen el uso común y cotidiano de las instalaciones del Club Deportivo, por lo que los servicios optativos tales como: clases privadas, entrenadores privados o profesores privados, consumo de bebidas y alimentos, renta de espacios y salones para eventos privados, alquiler de instalaciones del Club Deportivo para fines privados y otros que defina el Club Deportivo, serán cobrados por éste, como adicionales y con la tarifa que el Club Deportivo señale o fije para cada caso.\n</div><div>\n(vi)	Cualquier falta de pago de las cuotas de mantenimiento, dará derecho al Club Deportivo a suspender temporalmente el uso de sus instalaciones al Cliente y a sus usuarios, hasta que se confirme el pago total de las cantidades adeudadas.\n</div><div>\n(vii)	La falta de pago puntual de las cuotas de mantenimiento dará derecho al Club Deportivo de cobrar una penalización o comisión por concepto de mora equivalente al 10% mensual por cada uno de los pagos vencidos, misma que será obligatoria cubrir por el Cliente para que se reinstalen los servicios de uso.\n</div><div><strong style=\"text-decoration: underline\">4.	INCREMENTOS AL PAGO DE MANTENIMIENTO.</strong>\n. Las Partes acuerdan que el Club Deportivo se reserva el derecho de incrementar de forma anual o en su caso de tiempo en tiempo, el monto establecido como pago de cuotas de mantenimiento tomando en consideración: (i) los aumentos que llegue a presentar el salario mínimo general de la zona en que se encuentra ubicado el Centro Deportivo; (ii) el índice Nacional de Precios al Cliente (INPC); y, (iii) los incrementos a los costos de operación del propio Centro Deportivo. Todos los incrementos a las cuotas de mantenimiento deberán ser notificados por el Club Deportivo al Cliente con una anticipación de 30 (treinta) días naturales de anticipación, siendo publicados en las pantallas y pizarrones del club y enviado al correo electrónico del Cliente, proporcionado en el Anexo “A” del presente Contrato.\n</div><div><strong style=\"text-decoration: underline\">QUINTA.- VIGENCIA DEL CONTRATO Y LA MEMBRESÍA.</strong>\nEl presente Contrato como membresía, tendrá una vigencia de 5 (cinco) años contados a partir de los siguientes momentos: (i) la Fecha en que el Club Deportivo abra sus puertas y entre en Operación; o, (ii) a partir de la firma del presente Contrato, en caso de que ya se encuentre en operación el Club Deportivo.\n</div><div><strong style=\"text-decoration: underline\">SEXTA.- CASO FORTUITO Y FUERZA MAYOR.</strong>\n Ambas Partes convienen que si durante la vigencia del presente Contrato, se llegare a presentar un caso fortuito y/o fuerza mayor que sea declarado por las autoridades competentes, que haya impedido o impida la prestación del servicio de uso de las instalaciones del Club Deportivo materia del presente Contrato, las actividades del Club Deportivo deberán limitarse de conformidad con las indicaciones de las autoridades correspondientes y si es el caso, permanecer cerradas durante el tiempo en que ésta circunstancia de caso fortuito y/o fuerza mayor se presente, con lo que está de acuerdo el Cliente, por lo cual este último se abstendrá de exigir el acceso al mismo o bien, este caso fortuito y/o fuerza mayor prorrogará la apertura de la operación del Club y la vigencia del contrato se prorrogará en automático el mismo tiempo en que haya durado dicho caso fortuito y/o de fuerza mayor. Para el cumplimiento de las obligaciones de pago a cargo del Cliente, las Partes pactan que no aplicará por ningún motivo la aplicación de caso fortuito y/o fuerza mayor o cualquier otra circunstancia que el Cliente alegue como una forma para no cumplir y/o prorrogar el cumplimiento de las obligaciones de pago a su cargo contraídas a través del presente Contrato y solamente si el caso fortuito y/o fuerza mayor llegue a durar más de 90 (noventa) días naturales, el Club Deportivo notificará por correo electrónico al Cliente las medidas que se tomarán al respecto.\n</div><div><strong style=\"text-decoration: underline\">SÉPTIMA.- OBLIGACIONES DEL CLUB DEPORTIVO.</strong>\n Ambas Partes pactan que serán obligaciones del Club Deportivo las siguientes:</div><div>\na)	Mantener las instalaciones del Club Deportivo en las condiciones adecuadas para su funcionamiento y cumplir las finalidades para las cuales fueron diseñadas.\n</div><div>\nb)	Brindar el servicio de uso de las instalaciones del Club Deportivo de forma profesional, empleando gente capacitada para cada área del Club Deportivo.\n</div><div>\nc)	Llevar un expediente del Cliente y cumplir en todo momento con las estipulaciones de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, para lo cual señala la siguiente liga, en donde se encuentra el Aviso de Privacidad aplicable al Club Deportivo, por ser un Fideicomiso de Grupo Proyecta: https://www.grupoproyecta.com/privacidad.html?prefetchDate=1636469915505.\n</div><div>\nd)	Emitir al Cliente, cuando así lo solicite por los canales señalados, las facturas por el pago de la membresía y las cuotas de mantenimiento correspondientes.\n</div><div>\ne)	Mantener constante comunicación con el Cliente respecto de la reglamentación del uso, horarios y actividades del Club Deportivo.\n</div><div>\nf)	El club se compromete a brindar al usuario una oferta de actividades deportivas, recreativas y culturales que estarán incluidas en su cuota mensual, dichas actividades estarán publicadas en los pizarrones dispuestos para tal efecto y señaladas como actividades abiertas para los usuarios.\n</div><div>Dichas actividades excluyen:</div><ul><li>Clases de natación grupales.</li><li>\nActividades y clases señaladas como particulares o personalizadas.</li><li>\nEntrenamientos personalizados de toda naturaleza.</li><li>Clases especiales.</li><li>Cursos.</li><li>Talleres.</li><li>\nClínicas</li><li>Torneos</li><li>Exhibiciones.</li><li>\nClases brindadas por instructores o entrenadores externos o especializados.</li></ul><div>\ng)	Para que el cliente pueda ingresar a las clases o actividades deberá registrarse en los formatos y/o plataformas digitales establecidas para tal efecto o en el caso de infantes menores de edad ser parte del programa de entrenamiento o de la propia actividad.\n</div><div><strong style=\"text-decoration: underline\">OCTAVA.- OBLIGACIONES DEL CLIENTE.</strong></div><div>\na)	Realizar el pago de las cuotas de mantenimiento, dentro de los primeros cinco días naturales de cada mes, a partir de que sea notificada la apertura del Club Deportivo o bien, a partir de la firma del presente Contrato en caso de que éste ya se encuentre en operación para cuando se verifique la fecha de firma del presente Contrato.\n</div><div>\nb)	Una vez pagada la inscripción y la cuota mensual de mantenimiento que proceda, el CLUB DEPORTIVO dotará al CLIENTE de una clave, credencial o registrará sus datos biométricos de identificación, que deberá utilizar para lograr su acceso y permanencia en las instalaciones. El CLUB DEPORTIVO podrá inhibir el registro del CLIENTE y negar el acceso a las instalaciones, en caso de falta de pago de una o más cuotas mensuales de mantenimiento, o por suspensión temporal o definitiva de sus derechos, o por mal uso de esta.\n</div><div>\nc)	Cumplir cabalmente con cualquier obligación contenida en cualquier norma, reglamento o aviso oficial emitido por el Club Deportivo, que rija el correcto uso de las instalaciones y de las diferentes áreas específicas del Club Deportivo.\n</div><div><strong>d)	USO DE LAS INSTALACIONES, RIESGOS Y PROHIBICIONES:</strong>\n Sin perjuicio a lo establecido en el Reglamento correspondiente, el CLIENTE estará sujeto a lo siguiente.</div><div>\nI.	EL CLIENTE podrá utilizar las instalaciones y equipos dentro de los horarios establecidos.</div><div>\nII.	El CLIENTE o sus beneficiarios deslindan a la empresa y/o a sus empleados, de toda responsabilidad legal, económica o de cualquier tipo, derivada de las lesiones o muerte que pueda sufrir por el desempeño de su actividad deportiva.\n</div><div>\nIII.	Con relación a lo anterior, el CLIENTE asegura estar en óptimas condiciones de salud para el desempeño de su actividad deportiva. En caso de tener alguna condición física especial deberá presentar a la empresa el o los certificados médicos correspondientes para mantener una supervisión más cercana del personal, pero finalmente será su responsabilidad abstenerse a realizar actividades recreativas o deportivas que llegaren afectarlos o causarles la muerte.\n</div><div>\nIV.	El CLIENTE pagará todo daño parcial o total que provoque a las instalaciones o los equipos por el uso inadecuado o negligente que haga de los mismos.\n</div><div><strong>e)	PROHIBICIONES PARA EL CLIENTE DENTRO DE LAS INSTALACIONES.</strong></div><div>\nI.	No podrá circular sin zapatos, sin camisa o en general con vestimenta que sea inadecuada para el área específica en que se encuentre.\n</div><div>\nII.	No podrá entrar al club bajo el efecto de bebidas alcohólicas, psicotrópicos, drogas o en general de cualquier sustancia tóxica o nociva, o consumirlas en las instalaciones.\n</div><div>III.	Introducir vasos, botellas o cualquier otro recipiente de vidrio.</div><div>\nIV.	Fumar(Salvo en las áreas específicamente señaladas).</div><div>\nV.	Introducir armas, explosivos, objetos punzo cortantes o de cualquier forma o material que pueda causar lesiones a él mismo o a terceros.\n</div><div>VI.	Introducir animales o mascotas.</div><div>VII.	Introducir alimentos o bebidas a las instalaciones.</div>\n<div>\nVIII.	Adoptar conductas verbales o físicas, injuriosas, lascivas, o de cualquier índole que riñan contra la moral, las buenas costumbres o la seguridad física de los clientes o los empleados de la empresa.\n</div><div>\nIX.	Ofrecer, vender, comprar, suministrar o suministrarse por sí o con ayuda, cualquier tipo de sustancia en la presentación que sea, excepto tratándose de medicamentos con la prescripción médica correspondiente y para su uso personal.\n</div><div>\nf)	Los incumplimientos a dichas prohibiciones serán materia de sanción por parte del CLUB DEPORTIVO, mismas que serán:\n</div><div>I.	Llamada de atención verbal y amonestación por escrito por parte del personal facultado de la empresa.\n</div><div>II.	La suspensión temporal de acceso a las instalaciones.</div><div>\nIII.	La cancelación definitiva de acceso a las instalaciones dando por terminado el contrato.</div><div>\nIV.	Lo anterior sin perjuicio de avisar a las autoridades competentes cuando así proceda.</div><div>\ng)	El Cliente y sus usuarios, deberán conducirse dentro de las instalaciones del Club, con buena conducta, evitando poner en peligro su integridad física, así como la de otros Clientes, de sus propios familiares o invitados y de cualquier persona que se localice dentro de las instalaciones del Club Deportivo, incluyendo, desde luego, cualquier trabajador del Club Deportivo.\n</div><div><strong style=\"text-decoration: underline\">NOVENA.- TRANSFERENCIA DE DERECHOS.</strong>\n L. Las Partes pactan que los derechos y las obligaciones de la membresía que se generan en este Contrato son intransferibles para el Cliente. Por lo que respecta al Club Deportivo, los derechos y las obligaciones podrán ser cedidos, enajenados o transferidos a voluntad del Club Deportivo a cualquier persona física o moral y basta la notificación con 30 (treinta) días de anticipación al Cliente, para conocimiento de éste.\n</div><div>\nEl Club Deportivo solamente puede aceptar la transferencia de los derechos y obligaciones de esta membresía cuando el cliente lo solicite por escrito y justifique de buena voluntad la necesidad de dicha transferencia, en este caso la transferencia queda sujeta a la aprobación por parte del área Jurídica del Club Deportivo y al pago de los derechos correspondientes por un monto de $5,000.00 (Cinco mil pesos 00/, en el caso de que se presente el fallecimiento del Cliente. En este caso, el usuario asignado por el Cliente, en M.N.)primer lugar señalado en la solicitud adjunta como Anexo “A”, deberá comprobar el fallecimiento del Cliente, presentando la correspondiente acta de defunción, para que el Club haga la transferencia de derechos a dicho usuario, o bien, se lleve a cabo la baja total de la membresía, en caso de que no sea del interés de dicho usuario, continuar con la vigencia del Contrato.\n</div><div><strong style=\"text-decoration: underline\">DÉCIMA.- SUSPENSIÓN DE LA MEMBRESÍA POR AUSENCIA DECLARADA.\n</strong>\n. Las Partes acuerdan que en caso de que el Cliente tenga la necesidad imperiosa de ausentarse temporalmente, éste deberá dar aviso al Club Deportivo de la ausencia (la Ausencia Declarada), Personalmente, a través de un tercero y confirmando mediante un correo electrónico con 15 (quince) días de anticipación en el que señale la fecha de inicio y de final de la Ausencia Declarada, con el objeto de que el Club Deportivo suspenda por este tiempo la prestación de los servicios de uso al Cliente. La Ausencia Declarada solo podrá presentarse por un período mínimo de 2 (dos) meses y máximo de 1 (un) año; y será durante este período en que el Cliente sólo deberá pagar el 30% (treinta por ciento) el monto de su cuota de mantenimiento, durante la Ausencia Declarada. Dicha Ausencia declarada no podrá realizarse en los meses de diciembre, Julio, agosto y el mes que corresponda al periodo vacacional de semana santa, salvo en los casos de acreditar causa medica de fuerza mayor.\n</div><div><strong style=\"text-decoration: underline\">RESTRICCIONES A LA AUSENCIA DECLARADA:</strong></div><div>\na)	La Ausencia Declarada solo puede durar como máximo 1 (un) año, y en caso de que se prorrogue esta temporalidad el Club Deportivo cancelará definitivamente la membresía y rescindirá el presente Contrato.\n</div><div>\nb)	Durante la Ausencia Declarada, ninguno de los usuarios y/o el Cliente podrá hacer uso de las instalaciones del Club Deportivo.\n</div><div>\nc)	Si la Ausencia Declarada es igual o menor a 2 (dos) meses, el Cliente deberá pagar completamente el monto de las cuotas de mantenimiento.\n</div><div>\nd)	No podrá solicitarse otra Ausencia Declarada en el término de un año, contado a partir del regreso de la última Ausencia Declarada.\n</div><div>\ne)	Cualquier otro caso especial, será directamente tratado con la Administración del Club Deportivo y su decisión será determinante e inapelable.\n</div><div><strong style=\"text-decoration: underline\">\nDÉCIMA PRIMERA.- TERMINACIÓN DEL CONTRATO Y MEMBRESÍA; PENA CONVENCIONAL.</strong></div><div>\nI.	Las Partes pactan que son causales de rescisión del presente Contrato por responsabilidad del Cliente, las siguientes causas:\n</div><div>\na)	La falta de pago por parte del Cliente de 3 (tres) mensualidades consecutivas o de (4) cuatro mensualidades alternas sin pago.\n</div><div>\nb)	La transgresión de cualquier regla o norma que el Club Deportivo haya impuesto que haya sido cometida por el Cliente y/o sus usuarios y/o sus invitados.\n</div><div>c)	Prolongar por más de un año la Ausencia Declarada.</div><div>\nd)	Cualquier demanda judicial, jurisdiccional o administrativa presentada en contra del Club Deportivo, cualquiera que sea su causa.\n</div><div>\ne)	Realizar propaganda negativa al Club Deportivo, por cualquier medio de comunicación que, a discreción del Club Deportivo, le cause un daño reputacional.\n</div><div>\nDe presentarse los casos antes señalados, la terminación del Contrato será inmediata y dará derecho al Club Deportivo a cancelar la membresía del Cliente para disponer de ella a su libre criterio, sin que ninguna de las Partes tenga que acudir a autoridad alguna a solicitar la rescisión judicial del mismo. En este sentido el Cliente perderá su lugar como usuario y no tendrá derecho alguno a la exigencia de devolución del pago de: (i) su membresía; (ii) pagos por cuotas de mantenimiento, aún aquellos que hayan sido pagados de forma anticipada; y, (iii) cualquier otro concepto pagado al Club Deportivo de forma anticipada, así como de reclamar el pago de interés alguno, o cantidad alguna o cualquier otro concepto, con lo que desde ahora está de acuerdo el Cliente.\n</div><div><strong style=\"text-decoration: underline\">DÉCIMA SEGUNDA. - RENOVACIÓN DE LA MEMBRESÍA.</strong>\n La renovación de la membresía será un derecho que el Club Deportivo le concede al Cliente para que una vez que haya terminado la vigencia del presente Contrato, éste tenga acceso directo a renovar su membresía con los siguientes requisitos y derechos preferenciales.\n</div><div>\na)	El Cliente podrá renovar su membresía con un beneficio económico consistente en el 50% del costo de una membresía nueva.\n</div><div>b)	El Cliente deberá estar al corriente en el pago de sus cuotas de mantenimiento y nunca haberse atrasado.\n</div><div>c)	El Cliente no debió haber sido sancionado de forma alguna por el Club Deportivo.</div><div>\nd)	La renovación de la membresía será por el plazo de 5(Cinco años)a partir de la fecha de dicha renovación o que el Club Deportivo indique a su entera discreción.\n</div><div><strong style=\"text-decoration: underline\">DÉCIMA TERCERA.- PROMOCIONES Y COSTOS ADICIONALES.</strong>\n. El Club Deportivo se reserva el derecho de poner a disposición del Cliente y sus respectivos usuarios, las promociones en los términos y vigencias que considere convenientes, así como de retirarlas, incluso sin previo aviso. De igual forma el Club Deportivo se reserva el derecho a reservar para el uso exclusivo propio, las áreas e instalaciones del Club Deportivo, para llevar a cabo cualquier tipo de eventos que considere convenientes para la promoción tanto del Club Deportivo, como del Desarrollo Inmobiliario Lomas de Angelópolis.\n</div><div>\nSe considerarán como costos adicionales no incluidos en la cuota de mantenimiento, todas aquellas actividades que se desarrollen en el Club Deportivo y que tengan un costo unitario por servicios o productos que se vendan o arrenden dentro del Club Deportivo, los cuales, de forma enunciativa y no limitativa se señalan: las cuentas de los restaurantes y cafetería, los productos de las tiendas o boutiques que, en su caso, existan dentro del Club Deportivo, los servicios y/o honorarios de maestros particulares, la renta de cualquier área, salón, instalación, lockers o equipo del Club Deportivo para uso exclusivo de algún Cliente.\n</div><div><strong style=\"text-decoration: underline\">DÉCIMA CUARTA.- DOMICILIOS Y NOTIFICACIONES.</strong>\n. Las Partes convienen en que todos los avisos, notificaciones y requerimientos que deban realizarse bajo el presente Contrato, deberán hacerse por escrito con acuse de recibo, por medio de entrega personal, correo electrónico o mensajería especializada, a las direcciones que aparecen en el Anexo “A” del presente Contrato.\n</div><div>El Club Deportivo:</div><div>Av. De La Pradera #3, Barrio Cascatta.</div><div>Colonia Lomas de Angelópolis\n</div><div>Santa Clara Ocoyucan, Puebla.</div><div>Código Postal 72865</div><div>Correo electrónico: <span \nstyle=\"text-decoration: underline\">administracion@omada.city</span></div><div>\no a cualquier otro domicilio que por escrito notifiquen a la otra parte en los términos antes previstos, en la inteligencia de que cualquier cambio de domicilio que notifiquen, estará vigente al siguiente día hábil de efectuada la notificación correspondiente.\n</div><div><strong style=\"text-decoration: underline\">DÉCIMA QUINTA.- ENCABEZADOS, RECLAMACIONES Y VALORES.</strong>\n</div><div><strong>I.	DE LOS ENCABEZADOS.</strong>\nCada una de las Cláusulas del presente Contrato son empleados únicamente como mera referencia y bajo ningún concepto deberán interpretarse por sí mismos como constitutivos de obligaciones entre las partes o en cualquier forma alterar o sustituir el contenido de su clausulado o utilizarse en la interpretación de este.\n</div><div><strong>II.	RECLAMACIONES.-</strong>\n En caso de reclamaciones, el CLIENTE se dirigirá al personal asignado para dicho efecto, quién le proveerá del formulario correspondiente, que una vez llenado y firmado lo devolverá, dándose atención y respuesta en un plazo no mayor a setenta y dos horas, por el conducto que la empresa estime pertinente. No se atenderán reclamaciones vagas, ociosas o imprecisas, por lo que el CLIENTE deberá suministrar a detalle la razón de esta.\n</div><div><strong>III.	DE LOS VALORES.</strong>\n EL CLUB DEPORTIVO no se hace responsable por la perdida, extravío o robo de los bienes del CLIENTE. En caso de olvido de objetos que eventualmente sean encontrados por personal del CLUB DEPORTIVO, serán custodiados los mismos hasta por 30 días naturales y vencido este plazo, se donarán a casas de asistencia, sin mayor responsabilidad para la empresa. Para proceder a la devolución del objeto encontrado, será necesario que el CLIENTE describa correctamente al mismo y, en su caso, presente documento que acredite la propiedad, levantándose acta de entrega.\n</div><div><strong style=\"text-decoration: underline\">DÉCIMA SEXTA.– ACUERDO TOTAL E INTEGRIDAD DEL CONTRATO.</strong>\n</div><div>\nEste Contrato contiene el acuerdo total entre las Partes con respecto al objeto y clausulado del mismo y substituye cualquier pacto, convenio o entendimiento anterior existente entre ellas, ya fuere oral o escrito, salvo el Anexo “A”, el cual es integrante del presente Contrato. Todas y cada una de las declaraciones o compromisos hechos por empleados, agentes o representantes de cualquiera de las Partes que no se contengan en este Contrato, no producirán efecto legal alguno.\n</div><div><strong style=\"text-decoration: underline\">DÉCIMA SÉPTIMA.- LEGISLACIÓN APLICABLE Y JURISDICCIÓN.</strong>\n</div><div>\nEl presente Contrato se rige e interpreta de acuerdo con la legislación aplicable al Estado de Puebla y cualquier controversia en relación con el mismo será resuelta por los tribunales competentes de la ciudad de Puebla, por lo que las Partes en este acto renuncian irrevocablemente a cualquier otra jurisdicción que pudiere corresponderles en razón de sus domicilios presentes o futuros o por cualquier otra causa.\n</div><div>\nLeído que fue el presente Contrato por las Partes y estando enteradas éstas de su valor y fuerza legal, lo firman por duplicado en la Ciudad de Santa Clara Ocoyucan, Puebla, el día {{vm.data.date|date:\'dd\'}} de {{vm.data.date|date:\'MMMM\'}} de {{vm.data.date|date:\'yyyy\'}}.\n</div><div class=\"risks\" style=\"padding-top: 20px; padding-bottom: 2px text-center\"><table \nclass=\"regulation-content-terms-table\"><tr><td class=\"title w-300\" style=\"vertical-align: top; text-align: center\"><div\n class=\"regulation-signature\"><div><strong>EL CLIENTE</strong></div><div></div><div style=\"height: 40px\"></div><img \nng-src=\"{{vm.signatureSrc}}\"><br>________________________________________________<div \nclass=\"regulation-signature-data\"><p>{{vm.data.partnerName}}</p></div></div></td><td class=\"title w-300\" \nstyle=\"vertical-align: top; text-align: center\"><div class=\"regulation-signature\"><div><strong>ÓMADA CLUB DEPORTIVO\n</strong></div><div><strong>(Representado por)</strong></div><img src=\"assets/images/signature_jahs.png\" width=\"240\" \nheight=\"100\"><br>________________________________________________<div class=\"regulation-signature-data\"><p>\nRAMÓN BERRA DE LA VEGA</p></div></div></td></tr></table></div></div><div class=\"dummy-print\"></div><div \nclass=\"signatures-omada\"><div><img ng-src=\"{{vm.signatureSrc}}\"></div><div><img ng-src=\"{{vm.signatureSrc}}\"></div>\n<div><img ng-src=\"{{vm.signatureSrc}}\"></div><div><img ng-src=\"{{vm.signatureSrc}}\"></div><div><img \nng-src=\"{{vm.signatureSrc}}\"></div><div><img ng-src=\"{{vm.signatureSrc}}\"></div></div></div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/contract/contract-operactive.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Guardar</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.showSignature($event)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon><md-tooltip>Firmar</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.sendByEmail()\" ng-disabled=\"vm.sendingEmail\"><md-icon md-font-icon=\"icon-email\" \nng-show=\"!vm.sendingEmail\"></md-icon><md-icon md-font-icon=\"icon-dots-horizontal\" ng-show=\"vm.sendingEmail\"></md-icon>\n<md-tooltip>Enviar por email</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getLastData()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>Obtener datos nuevamente</md-tooltip></md-button></div><div \nid=\"complete-document\" class=\"card md-whiteframe-8dp\"><div class=\"contract-wrapper\"><div fxlayout=\"row\" \nfxlayoutalign=\"center center\" style=\"width: 100%; text-align:center; margin-bottom:20px\"><img \nng-src=\"{{vm.logoSource}}\" style=\"height: 60px !important\"></div><div class=\"contract\"><div class=\"contract-title\">\nContrato que celebran, por una parte OPERADORA ACTIVE PH, S. A. de C. V; denominado en lo sucesivo <strong>\n“EL PRESTADOR”</strong>y por la otra parte <span style=\"text-decoration: underline\">{{vm.data.razonSocial}}</span>\n quién por su propio derecho, en lo sucesivo, el “USUARIO TITULAR”, al tenor de las siguientes declaraciones y cláusulas:\n</div><br><div><strong>DECLARACIONES:</strong></div><br><div><strong>I.</strong> Declara <strong>“EL PRESTADOR”\n</strong>, por conducto de su representante legal que:</div><div><strong>(a)</strong>\n Es una sociedad anónima de capital variable, constituida de conformidad con las leyes de los Estados Unidos Mexicanos y estar legalmente facultada para la celebración del presente contrato, para otorgar el uso de las instalaciones deportivas denominadas ACTIVE CLUB ubicada en Av. Universidad 1883, Col. Oxtopulco Universidad, Alcaldía Coyoacán, C.P. 04318, mismas que en lo sucesivo se denominarán “EL CLUB”.\n</div><div><strong>(b)</strong>\n Su representante cuenta con todas las facultades necesarias para la celebración del presente contrato, mismas que no le han sido revocadas ni limitadas en forma alguna a la fecha de firma.\n</div><div><strong>II.</strong> Declara el <strong>“USUARIO TITULAR”</strong>, por su propio derecho, que:</div><div>\n<strong>(a)</strong>\n Es una persona física, con plena capacidad legal para celebrar este Contrato y que tiene su domicilio en <span \nstyle=\"text-decoration: underline\">\n{{vm.data.addressStreet}}, {{vm.data.addressColony}}, {{vm.data.addressMunicipio}}, {{vm.data.addressState}}</span>\n</div><div><strong>(b)</strong> Es su voluntad inscribirse como <strong>“USUARIO TITULAR”</strong>\n de una membresía: en las instalaciones del club Active Club ubicadas en Av. Universidad 1883, Col. Oxtopulco Universidad, Alcaldía Coyoacán, C.P. 04318, cuyos derechos y obligaciones le han sido ampliamente explicados y que manifiesta son de su entero conocimiento.\n</div><div><strong>(c)</strong>\n Toda la información establecida en este contrato, incluyendo la carátula es verdadera y correcta.</div><div><strong>\n(d)</strong>\n Que a la firma del presente contrato ha hecho el pago de la cuota de membresía (cuyo término se define más adelante) correspondiente y que elige pagar la cuota de mantenimiento en la forma establecida en el presente contrato.\n</div><div><strong>(e)</strong> Que ha recibido y leído el <strong>REGLAMENTO</strong>\n (según dicho término se define más adelante, que forma parte integral del presente contrato, mismo que se obliga a cumplir y a hacer cumplir por los \n<strong>“USUARIOS DEPENDIENTES”</strong> (según dicho término se define más adelante).</div><br><div>\nDeclaran las partes que es su voluntad celebrar el presente contrato con sujeción a las siguientes cláusulas:</div><div\n class=\"contract-title text-center\" layout=\"row\" layout-align=\"center\"><strong>CLÁUSULAS:</strong></div><div><strong>\nPRIMERA:</strong></div><div class=\"risks\" style=\"padding-top: 2px; padding-bottom: 2px\"><strong>DEFINICIONES.</strong>\n Para efectos del presente contrato, se entenderá por:</div><div><strong>1. EL CLUB.-</strong>\n Establecimiento/centro de acondicionamiento físico ubicado en Av. Universidad 1883, Col. Oxtopulco Universidad, Alcaldía Coyoacán, C.P. 04318 al cual tendrán derecho.\n</div><div><strong>2. MEMBRESÍA.-</strong> Membresía que <strong>ACTIVE CLUB</strong>, otorga al <strong>“TITULAR”\n</strong> del contrato, el derecho de hacer uso de las instalaciones de “<strong>EL MISMO</strong>\n” y a designar a sus “<strong>DEPENDIENTES</strong>” de las instalaciones de <strong>“EL CLUB”</strong>\n como contraprestación del pago de las cuotas de membresía y mantenimiento:</div><div><strong>A. TIPOS DE MEMBRESÍA.-\n</strong>\n Clasificación de las membresías con base en el número de personas que bajo el amparo de ésta, tendrán el acceso a \n<strong>“EL CLUB”</strong>\n de acuerdo a la clase de la misma definidas: familiar, pareja, individual, grupal y empresarial.</div><div><strong>\nPOBLACIÓN ESPECIAL.-</strong>\n Considerados como aquellos usuarios que padezcan alguna enfermedad crónica odegenerativa. Quedan comprendidas también en esta definición aquellas personas con discapacidad física, mental o músculo esquelético parcial o total y cuyas condiciones especiales están comprendidas en las definiciones que establecen las leyes aplicables para estas materias. Manifestando que \n<strong>“EL CLUB”</strong>\n no cuenta con el personal especializado, así como la atención personalizada para dicha población.</div><div><strong>\n4. VIGENCIA.-</strong>\n El presente contrato tendrá una vigencia indefinida a partir de su suscripción, siempre y cuando mantenga pagadas sus cuotas de mantenimiento teniendo el \n<strong>“USUARIO TITULAR”</strong> el derecho a colocar su membresía en los siguientes estatus: <strong>\nINACTIVO TEMPORAL CON AVISO Y BAJA DEFINITIVA</strong> cuando ya no les interesen los servicios ofrecidos. Cuando el \n<strong>USUARIO TITULAR</strong>\n desee reactivar su membresía pagará el porcentaje que se asienta en el formato donde solicita el respectivo estatus\n</div><div><strong>5. CUOTA DE MEMBRESÍA.-</strong> Monto que deberá pagar el <strong>“TITULAR”</strong>\n como contraprestación por la adquisición de la membresía en el tipo y/o clase que elija.</div><div><strong>\n6. CUOTA DE MANTENIMIENTO.-</strong> Monto que debe pagar para tener acceso el “TITULAR” y/o los <strong>“DEPENDIENTES”\n</strong>\n que integran la membresía en el tipo elegida, esta cuota puede ser anual, semestral y/o mensual de acuerdo a la opción de precios\n</div><div><strong>7. INVITADO.-</strong> Persona física que en compañía de un <strong>“TITULAR”</strong> o <strong>\n“DEPENDIENTE”</strong>,acude en forma esporádica y eventual a <strong>“EL CLUB”</strong>\n para hacer uso de las instalaciones del mismo, previo pago de la cuota por invitación que al efecto determine <strong>\n“EL PRESTADOR”</strong>.</div><div><strong>8. TITULAR.-</strong>\n Persona física mayor de edad (o persona moral que suscribe el contrato y a nombre de quien se recibe el pago de las cuotas de membresía y mantenimiento). En el caso de la membresía junior, el padre o tutor será el quién realice los trámites administrativos, quedando este como responsable del menor ante el “EL PRESTADO”\n</div><div><strong>9. USUARIO DEPENDIENTE.-</strong>\n Persona física mayor de 1 año en adelante que sin ser el suscriptor del contrato es registrado como usuario parte de una membresía de pareja, grupal, familiar, etc.\n</div><div><strong>10. VISITA EFECTIVA.-</strong> Ingreso del usuario a las instalaciones de <strong>“EL CLUB”</strong>\n registrado por medio de los sistemas establecidos por <strong>“EL PRESTADOR”</strong> para tales efectos.</div><div>\n<strong>11. AUSENCIA.-</strong>\n Derecho que tiene el usuario y que deberá ser solicitados por escrito con fecha máxima del día 25 de cada mes, previo al mes de su aplicación, realizando el trámite específico en la Recepción del \n<strong>“EL CLUB”</strong>.</div><div><strong>12. CUOTA DE AUSENCIA.-</strong>\n Todas la membresías que se encuentren al corriente de pago tienen el derecho de solicitar ausentarse de <strong>\n“EL CLUB”</strong> contemplandose los siguientes esquemas:</div><div><strong>12.1. DOMICILIADO:</strong></div><div>\n<strong>a.-</strong>\n Si el pago es domiciliado y el usuario solicita por escrito, de acuerdo a lo establecido en este contrato una ausencia no mayor a los 3 meses deberá de pagar lo correspondiente al 33% adicional de su cuota de mantenimiento al momento de su reactivación. En este tipo de pago si se ausenta del club sin dar aviso a la Administración se le cobrará un 66% sobre su cuota de mantenimiento al momento de su reactivación\n</div><div><strong>b.-</strong>\n Si el pago es domiciliado y el usuario solicita por escrito, de acuerdo a lo establecido en este contrato una ausencia no mayor a los 3 meses deberá de pagar lo correspondiente al 33% adicional de su cuota de mantenimiento al momento de su reactivación. En este tipo de pago si se ausenta del club sin realizar el trámite respectivo a la Administración se le cobrará un 66% sobre su cuota de mantenimiento al momento de su reactivación.\n</div><div><strong>c.-</strong>\n En el caso de que el cargo domiciliado para el cobro de su pago mensual de mantenimiento no sea aceptado por el banco respectivo dentro de los primeros 5 días naturales del mes, la administración realizará el cobro en la Recepción del club, aplicándose la tarifa de caja, negándose el acceso al(os) usuario(s) a las instalaciones a partir del 6º. día del mes.\n</div><div><strong>d.-</strong>\n En las reactivaciones el usuario esta obligado a llenar su nuevo domiciliado, ya que el club por medida de seguridad y uso de datos confidenciales destruye el formato firmado inicialmente.\n</div><div><strong>12.2. SEMESTRE:</strong></div><div><strong>a.-</strong>\n En este tipo de cuota de mantenimiento el usuario no podrá aplicar ningún periodo de AUSENCIA en el periodo de vigencia de la misma.\n</div><div><strong>b.-</strong>\n No aplicarán cancelaciones, sustituciones y/o reembolsos de pago de los meses que no se hayan utilizado, siendo requisito indispensable para este producto el firmar el cargo automático el cuál se aplicará al término de la vigencia del mismo en el caso de que no renovar en esta forma de pago.\n</div><div><strong>12.3. ANUALIDADES:</strong></div><div><strong>a.-</strong>\n El usuario tendrá el derecho de solicitar hasta 3 ausencias durante la vigencia de su periodo cubierto.</div><div>\n<strong>b.-</strong>\n Las ausencias no tendrán ninguna penalización al momento de su reactivación, abonándose dicha ausencia al final de su periodo cubierto..\n</div><div><strong>c.-</strong> No se requiere firmar el formato de cargo domiciliado.</div><div><strong>d.-</strong>\n En caso de cancelación de esta forma de pago se bonificarán los montos de los meses pagados y no disfrutados, aplicándose una penalización adicional del 20%, realizándose el reembolso a los 60 días calendario de realizado este trámite.\n<br><br>\nLos mantenimientos SEMESTRALES y ANUALES deberán de notificar a la Administación del Club con 15 días antes de la conclusión de su periodo adquirido el interés de renovar, cambiar de forma de pago o cancelar su membresía.\n</div><div><strong>13. REGLAMENTO.-</strong>\n Conjunto de normas específicas que regulan los términos y condiciones de la prestación del servicio por parte de \n<strong>“EL PRESTADOR”</strong>\n y el comportamiento de los usuarios, el cual formará parte integral del presente contrato.</div><div><strong>\n14. AMONESTACIÓN.-</strong>\n Penalización que se impone a los usuarios que incumplen con las obligaciones establecidas en el presente contrato y/o reglamento que no sean consideradas graves. La cual consistirá en la advertencia para que en caso de reincidencia se suspenda de manera provisional el uso de las instalaciones o la rescisión del contrato.\n</div><div><strong>15. SUSPENSIÓN PROVISIONAL.-</strong>\n Penalización que se impone a los usuarios que incumplen con las obligaciones establecidas en el presente contrato o en su reglamento, que no sean consideradas graves, consistente en el impedimento temporal de acceso a \n<strong>“EL CLUB”</strong>. Sin suspender los pagos de mantenimiento correspondientes.</div><div><strong>16. RESCISIÓN:\n</strong> Terminación de la vigencia del presente contrato/membresía por una causa imputable al <strong>“TITULAR”\n</strong> o alguno de sus <strong>“DEPENDIENTES”</strong>.</div><div><strong>17. TERMINACIÓN VOLUNTARIA.-</strong>\n Forma de terminación del presente contrato por parte del <strong>“TITULAR”</strong>\n, sin responsabilidad para las partes, previa solicitud por escrito que haga a <strong>“EL PRESTADOR”</strong>\n con 30 (treinta) días naturales de anticipación.</div><div><strong>18. AVISO.- </strong>Todo comunicado que \n“EL PRESTADOR”\n difunda entre la generalidad de los usuarios y que para ser válido, efectivo y aplicable, bastará con que se coloque en lugares visibles de \n<strong>“EL CLUB”</strong>.</div><div><strong>SEGUNDA:</strong></div><div><strong>OBJETO:</strong>\n En virtud de la celebración del presente contrato <strong>“EL PRESTADOR”</strong> pone a disposición del <strong>\n“TITULAR”</strong> y <strong>“USUARIOS DEPENDIENTES”</strong>\n que este designe, en los términos y condiciones que correspondan a la clase y/o tipo de membresía elegida por el \n<strong>“TITULAR”</strong>, el acceso a las instalaciones y a los servicios que se prestan en <strong>“EL CLUB”\n</strong>\n y que se encuentran incluidos en tipo de membresía especificados en el presente contrato, a cambio de la contraprestación señalada en la carátula del presente contrato.\n</div><div><strong>TERCERA: </strong></div><div><strong>OBLIGACIONES DE LOS USUARIOS:</strong> Los <strong>“TITULARES”\n</strong> y los <strong>“DEPENDIENTES”</strong> tendrán a su cargo, las siguientes obligaciones:</div><div><strong>1.\n</strong>\n A la firma del presente contrato y la carátula, deberá realizar el pago del tipo de membresía elegida, así como el pago de la cuota de mantenimiento correspondiente, pudiéndolo realizar en efectivo, transferencia, cargo a tarjeta de crédito o débito.\n</div><div>La cuota de mantenimiento puede ser anual, semestral y/o mensual.</div><div>\nEn el caso del pago de cuota domiciliada el pago deberá realizarse dentro de los 5 (cinco) primeros días del mes.</div>\n<div>En caso de que el <strong>“TITULAR”</strong>\n no haga el pago del mantenimiento dentro de los 5 (cinco) primeros días del mes <strong>“EL PRESTADOR”</strong>\n se reserva el derecho de negarle a éste o a los usuarios dependientes de su membresía el acceso a las instalaciones hasta que lleve a cabo el pago del mantenimiento correspondiente.\n</div><div>En virtud del presente contrato el <strong>“TITULAR”</strong>\n queda obligado al pago de la membresía de la forma que haya elegido aunque no haga uso de las instalaciones, de suceder esto último, gozará de los beneficios que se describen en la cláusula décima quinta del presente contrato.\n</div><div><strong>“EL PRESTADOR”</strong>\n podrá incrementar el precio de las cuotas de mantenimiento y de servicios de manera anual, para lo cual dará aviso con 30 (treinta) días de anticipación a los usuarios en las instalaciones de \n<strong>“EL CLUB”</strong>\n, por lo que en caso de aceptación de los usuarios, se obligarán a pagar los incrementos que se registren en las cuotas de mantenimiento y servicios a partir del momento que para tal efecto determine \n<strong>“EL PRESTADOR”</strong>\n. Los usuarios gozarán de un plazo de 30 (treinta) días naturales para manifestar su consentimiento con las nuevas cuotas o para dar por terminado el contrato sin ninguna responsabilidad.\n</div><div>\nEl uso de las instalaciones es bajo la responsabilidad de cada usuario, los usuarios se comprometen y obligan a usar y hacer que sus invitados usen las instalaciones, equipos y demás bienes propiedad de \n<strong>“EL PRESTADOR”</strong>\n de acuerdo a su naturaleza, siguiendo en todo momento las instrucciones de uso que consten en los mismos o que les sean señaladas por el personal de \n<strong>“EL CLUB”</strong>\n, por lo tanto, el uso de todas las instalaciones, equipos y demás bienes lo realizarán bajo su única y exclusiva responsabilidad, asumiendo la responsabilidad por los daños y perjuicios que sufran en sus personas o bienes o que causen a terceros en sus personas y bienes derivados del mal uso que le den a los mismos, liberando a \n<strong>“EL PRESTADOR”</strong> de cualquier responsabilidad por los daños y perjuicios causados.</div><div>\nEn caso de reclamación presentada por algún usuario, invitado o cualquier tercero, derivada de daños y perjuicios sufridos por el mal uso de las instalaciones y equipos, por parte el \n<strong>“TITULAR”</strong> o alguno de sus <strong>“DEPENDIENTES”</strong>\n o invitados, la responsabilidad es asumida por el <strong>“TITULAR”</strong> de la membresía.</div><div><strong>2.\n</strong> El <strong>“TITULAR”</strong>, los <strong>“DEPENDIENTES”</strong>\n y los invitados de estos, tendrán la obligación de respetar y hacer respetar en todo momento las disposiciones del reglamento de \n<strong>“EL CLUB”</strong>.</div><div><strong>3.</strong>\n Los usuarios deberán registrar su entrada y salida para tener acceso a las instalaciones de <strong>“EL CLUB”</strong>\n a través del sistema de reconocimiento facial o cualquier otro sistema puesto en funcionamiento por <strong>\n“EL PRESTADOR”</strong>, por lo que se comprometen y obligan a otorgar todas las facilidades que al efecto requiera \n<strong>“EL PRESTADOR”</strong>\n para el registro y captura de sus datos y huellas digitales, ya que la finalidad de este sistema es la seguridad de todos los usuarios.\n</div><div>El hecho de que el <strong>“TITULAR”</strong> o <strong>“DEPENDIENTE”</strong>\n no otorgue las facilidades para cumplir con los requisitos del sistema de ingreso a <strong>“EL CLUB”</strong>\n será causa justificada suficiente para negarle el acceso, hasta que cumpla con dichos requisitos.</div><div><strong>\n\"EL PRESTADOR”</strong>\n se reserva el derecho de poner en funcionamiento en forma adicional o en sustitución del sistema actual, cualquier procedimiento o sistema de regulación y registro de la entrada y salida de usuarios a las instalaciones.\n</div><div>\nLos usuarios deberán facilitar al personal de ventas de membresías sus datos completos, estos son: nombre, dirección, teléfonos y correo electrónico. Para efectos de lo anterior, \n<strong>“EL PRESTADOR”</strong>, el <strong>“TITULAR”</strong> y los <strong>“DEPENDIENTES”</strong>\n observarán en todo momento lo dispuesto en la Ley Federal de Datos Personales en posesión de los Particulares, dando su consentimiento en este acto para el tratamiento de sus datos personales conforme al aviso de privacidad que se encuentra en el domicilio de \n<strong>“EL CLUB”</strong>, así como en los demás documentos que sean puestos a su vista para su suscripción.</div>\n<div><strong>CUARTA:</strong></div><div><strong>CESIÓN DE MEMBRESÍAS:</strong></div><div><strong>a.-</strong> El \n<strong>“TITULAR”</strong>\n no podrá ceder o transmitir los derechos derivados de su membresía a ningún tercero; por lo que cualquier cesión de derechos llevada a cabo en contra de esta práctica, no será reconocida, negándose el acceso a las instalaciones a los supuestos cesionarios.\n</div><div><strong>b.-</strong>\n Solo se encuentran autorizadas las cesiones entre consanguíneos o afines en línea recta y en línea colateral en primer grado (cónyuges, padres, hijos y hermanos), previo pago de la cuota que determine \n<strong>“EL PRESTADOR”</strong>.</div><div>Acuerdan las partes que <strong>“EL PRESTADOR”</strong>\n puede ceder o transmitir en todo momento los derechos y obligaciones derivados del presente contrato.</div><div>\n<strong>QUINTA:</strong></div><div><strong>CAMBIO DE MEMBRESÍA:</strong></div><div>\nLa clase y/o tipo de la membresía elegida al suscribir el presente contrato podrá ser motivo de cambio a solicitud expresa del \n<strong>“TITULAR”</strong>\n, siendo necesario para la procedencia del cambio requerido, que además de hacer el pago correspondiente, ya sea un incremento o una reducción dependiendo del tipo y clase de membresía que se elija, se cumplan con los requisitos señalados en el reglamento.\n</div><div><strong>SEXTA:</strong></div><div><strong>DEL TITULAR:</strong>\n Será el único facultado para llevar a cabo la tramitación de cambios de clase y/o tipo de membresía, ausencias temporales, terminaciones voluntarias y cualquier otro tramite relativo a la membresía contratada.\n</div><div><strong>SÉPTIMA:</strong></div><div><strong>DE LOS INVITADOS:</strong></div><div>\nEn beneficio de los demás usuarios y para evitar la saturación en el uso de las instalaciones, <strong>“EL PRESTADOR”\n</strong>\n se reserva el derecho de limitar el número de invitados por día o en horarios determinados. En todos los casos el invitado deberá estar en compañía del \n<strong>“TITULAR”</strong> o <strong>“DEPENDIENTE”</strong> que le haya invitado.</div><div><strong>OCTAVA:</strong>\n</div><div><strong>SEGURO DE RESPONSABILIDAD CIVIL:</strong></div><div><strong>\"EL PRESTADOR”</strong>\n tiene contratado y en todo momento mantendrá vigente, un seguro de responsabilidad civil.</div><div><strong>NOVENA:\n</strong></div><div><strong>MANIFESTACIÓN DE ESTADO DE SALUD:</strong></div><div>A la firma del presente contrato el \n<strong>“TITULAR”</strong> manifiesta bajo protesta de decir verdad, que tanto el mismo como los <strong>“DEPENDIENTES”\n</strong> por él designados, gozan de buen estado de salud, por lo que libera a <strong>“EL PRESTADOR”</strong>\n de cualquier responsabilidad derivada de la afectación a su salud por el uso de las instalaciones y equipo, así como por las afecciones de cualquier índole que los \n<strong>“TITULARES”</strong> o <strong>“DEPENDIENTES”</strong>\n pudieran tener antes, al momento o con posterioridad a la suscripción del presente contrato; asimismo, acepta que por razones de higiene y siempre que las actividades de \n<strong>“EL CLUB”</strong> lo requieran, <strong>“EL PRESTADOR”</strong>\n podrá solicitarle, en caso de no contar con personal acreditado para tal efecto en sus instalaciones, un certificado médico para el acceso a la alberca o en caso de que \n<strong>“EL PRESTADOR”</strong>\n cuente con dicho personal, permita una revisión de su estado de salud e higiene y el de sus usuarios dependientes e invitados.\n</div><div>Asimismo, el <strong>“TITULAR”</strong> acepta que, para el caso de que alguno de los <strong>\"DEPENDIENTES”\n</strong>\n por él designados, o bien, alguno de sus invitados padezca de alguna discapacidad física, será el único y directamente responsable de las consecuencias que pudieran llegar a presentarse en virtud del uso de las instalaciones por parte de las personas mencionadas.\n</div><div><strong>DÉCIMA:</strong></div><div><strong>EVENTOS:</strong></div><div><strong>\nESPECIALES, ORGANIZACIÓN Y MANTENIMIENTO:</strong></div><div>Los usuarios e invitados expresamente aceptan que <strong>\n“EL PRESTADOR”</strong> lleve a cabo, dando aviso para tal efecto a los usuarios en las instalaciones de <strong>\n“EL CLUB”</strong>\n con 7 (siete) días naturales de anticipación, la organización de torneos y eventos dentro de las instalaciones de \n<strong>“EL CLUB”</strong>\n y que en virtud de ello se podrá restringir en forma parcial y temporal el acceso a algunas áreas y equipos de \n<strong>“EL CLUB”</strong>.</div><div>Del mismo modo, expresamente aceptan que <strong>“EL PRESTADOR”</strong>\n se reserva el derecho de establecer métodos y procedimientos para la utilización de las áreas que por su naturaleza tienen capacidad para un número limitado de usuarios sin generar responsabilidad alguna para \n<strong>“EL PRESTADOR”</strong>\n por el hecho de que algún usuario no pueda hacer uso de la instalación o equipo, precisamente en el momento en que así lo requiera.\n</div><div>\nLas restricciones en el uso de áreas y equipos sujetos a mantenimiento, eventos y/o cualquier mejora o remodelación que determine \n<strong>“EL PRESTADOR”</strong>\n, no otorga derecho alguno de reducción, reembolso o bonificación de cuotas de membresía o mantenimiento.</div><div>\n<strong>DÉCIMO PRIMERA:</strong></div><div><strong>DAÑOS Y PÉRDIDAS DE BIENES:</strong></div><div>\nPor ningún motivo y bajo ninguna condición <strong>“EL PRESTADOR”</strong>\n se hace responsable de daños o pérdidas de bienes y valores propiedad de los usuarios o de sus invitados.</div><div>\n<strong>DÉCIMO SEGUNDA:</strong></div><div><strong>DÍAS Y HORAS DE SERVICIO:</strong></div><div><strong>“EL CLUB”\n</strong>\n y sus instalaciones estarán abiertas en los días y en el horario establecidos de acuerdo al calendario que disponga \n<strong>“EL PRESTADOR”</strong> y que previo aviso se hará de conocimiento en las instalaciones de <strong>“EL CLUB”\n</strong>\n con 24 (veinticuatro) horas de anticipación; en cuanto a los horarios de apertura y cierre de las instalaciones, siendo señalados en el acceso del mismo.\n</div><div><strong>\"EL PRESTADOR”</strong>\n podrá cerrar las instalaciones generales o áreas específicas o restringir los horarios en días festivos y en los días que el mantenimiento de instalaciones lo requiera, para lo cual deberá dar aviso con por lo menos 24 (veinticuatro) horas de anticipación, mediante avisos que se coloquen en lugares visibles de \n<strong>“EL CLUB”</strong>.</div><div>En los casos en que <strong>“EL PRESTADOR”</strong>\n deba suspender los servicios y clases por causa de fuerza mayor o caso fortuito, no se reembolsará cuota o pago alguno recibido por parte de los usuarios.\n</div><div><strong>DÉCIMA TERCERA:</strong></div><div><strong>PROFESORES, ENTRENADORES Y CLASES:</strong></div><div>\n<strong>\"EL PRESTADOR”</strong>\n se reserva el derecho de contratar y designar a los profesores y entrenadores que impartirán las clases y proporcionarán entrenamiento personal a los usuarios, pudiendo estos elegir entre aquellos disponibles en \n<strong>“EL CLUB”</strong>\n, con la única limitante del espacio en las áreas y el tiempo de los profesores y entrenadores; por lo tanto, los usuarios no tendrán derecho a indemnización o reclamación alguna para el caso de que estos profesores o entrenadores sean sustituidos.\n</div><div><strong>\"EL PRESTADOR”</strong>\n se reserva el derecho de señalar los horarios y duración de las clases de grupo impartidas en <strong>“EL CLUB”\n</strong>\n; por lo tanto, los usuarios no tendrán derecho a indemnización o reclamación alguna para el caso de que estos profesores o entrenadores o las clases que estos impartan sean sustituidos.\n</div><div><strong>DÉCIMO CUARTA:</strong></div><div><strong>TERMINACIÓN VOLUNTARIA:</strong></div><div>El <strong>\n“TITULAR”</strong>\n es el único facultado para realizar el trámite de terminación voluntaria en cualquier momento, para lo cual deberá dar aviso por escrito a \n<strong>“EL PRESTADOR”</strong>\n con por lo menos 30 (treinta) días naturales de anticipación, haciendo devolución y entrega de los bienes que son propiedad de \n<strong>“EL PRESTADOR”</strong>\n y que le fueran entregados para que los usuarios de la membresía tuvieran acceso e hicieran uso de las instalaciones y equipos.\n</div><div><strong>DÉCIMO QUINTA:</strong></div><div><strong>AMONESTACIÓN:</strong>\n En caso de que algún usuario incurra en una violación del contrato o su reglamento que sea considerada una falta leve, se le hará una amonestación escrita en la cual conste la violación cometida, apercibiéndole para que en caso de reincidencia, pueda ser suspendido temporalmente o podrá rescindirse su contrato.\n</div><div>En forma enunciativa, se enumeran las siguientes causas de amonestación:</div><div>\nA. Incumplir con cualquier obligación asumida en el contrato o en el reglamento.</div><div>\nB. Omitir el pago oportuno de cualquier cuota o cargo a la membresía</div><div>\nC. No dar las facilidades requeridas para su registro como usuario de <strong>“EL CLUB”</strong>.</div><div>\nD. Evadir en forma alguna los sistemas de registro de ingreso y egreso de las instalaciones de <strong>“EL CLUB”\n</strong>.</div><div>E. Introducir a <strong>“EL CLUB”</strong>\n comida, vasos u objetos de vidrio, así como armas de fuego o armas blancas.</div><div>\nF. Violar los horarios de salida o estancia en <strong>“EL CLUB”</strong>.</div><div>En caso de amonestación, <strong>\n“EL PRESTADOR”</strong>\n deberá dar aviso escrito en el cual se especifique la causa. El aviso escrito se hará mediante entrega al usuario amonestado en las instalaciones de \n<strong>“EL CLUB”</strong>, también podrá hacerse vía correo electrónico.</div><div><strong>DÉCIMO SÉXTA:</strong>\n</div><div><strong>SUSPENSIÓN TEMPORAL:</strong></div><div>\nEn caso de que algún usuario incurra en una violación del contrato o su reglamento que sea considerada no grave, se le comunicará su suspensión temporal de las instalaciones de \n<strong>“EL CLUB”</strong>\n de manera escrita en la cual conste la violación cometida, apercibiéndolo en caso de reincidencia, podrá rescindirse su contrato.\n</div><div>En forma enunciativa, más no limitativa se enumeran las siguientes causas de suspensión temporal:</div><div>\nA. Reincida por mas de una ocasión en las causas de amonestación antes referidas;</div><div>\nB. Otorgar o recibir entrenamientos personales entre usuarios, es decir, con independencia de los entrenadores reconocidos por el \n<strong>“EL PRESTADOR”</strong>.</div><div>C. Comercializar cualquier tipo de productos en el interior de <strong>\n“EL CLUB”</strong>, o en el área de estacionamiento, cuando sea propiedad de <strong>“EL PRESTADOR”</strong>.</div>\n<div>D. Violar las reglas de uso y acceso a cada una de las diferentes instalaciones de <strong>“EL CLUB”</strong>.\n</div><div>E. Fumar dentro de las instalaciones del <strong>“EL CLUB”</strong>.</div><div>\nF. Circular en áreas generales de <strong>“EL CLUB”</strong>\n sin zapatos, sin camiseta o en forma inapropiada para llevar a cabo la actividad a la que están destinadas las áreas de \n<strong>“EL CLUB”</strong>.</div><div>G. Violar la reglamentación relativa al ingreso.</div><div>\nEn caso de suspensión temporal del contrato <strong>“EL PRESTADOR”</strong>\n deberá dar aviso escrito en el cual se especifique la causa de la suspensión y el periodo de la misma; tratándose de membresías de pareja o familiares, dicha sanción afectará exclusivamente al usuario responsable de la violación, permitiendo el acceso a los otros usuarios de dicha membresía.\n</div><div>\nEl aviso escrito, ya sea de manera impresa o digital, se hará mediante entrega al usuario suspendido en las instalaciones de \n<strong>“EL CLUB”</strong>.</div><div>En caso de suspensión temporal, <strong>“EL PRESTADOR”</strong>\n no hará reembolso alguno por concepto de cuotas de membresía o mantenimiento.</div><div><strong>DÉCIMO SEPTIMA. \n</strong></div><div><strong>RESCISIÓN DEL CONTRATO:</strong></div><div><strong>“EL PRESTADOR”</strong>\n podrá rescindir el presente contrato a cualquier usuario que incumpla las obligaciones asumidas en el contrato o que viole lo establecido en el reglamento de \n<strong>“EL CLUB”</strong>.</div><div>\nEn caso de que la falta sea considerada grave se rescindirá el contrato sin necesidad de amonestación o suspensión temporal previa a dicha rescisión, considerando graves las causas siguientes:\n</div><div>A. La reincidencia por más de una ocasión en las causas de suspensión temporal;</div><div>\nB. Agredir física o verbalmente a otro usuario o al personal de <strong>“EL PRESTADOR”</strong>;</div><div>\nC. Participar como sujeto provocador o no, en una riña en el interior de las instalaciones de <strong>“EL CLUB”\n</strong>;</div><div>D. Cometer alguna conducta que pudiera ser considerada como delito dentro de las instalaciones de \n<strong>“EL CLUB”</strong>;</div><div>\nE. Realizar actos contrarios a la moral, a las buenas costumbres o inapropiados al interior de <strong>“EL CLUB”\n</strong>.</div><div>F. Portar armas de cualquier tipo dentro de <strong>“EL CLUB”</strong>.</div><div>\nG. Asistir bajo el efecto o usar dentro de <strong>“EL CLUB”</strong>\n bebidas alcohólicas, toxicas, enervantes o drogas.</div><div>H. Introducir a las instalaciones de <strong>“EL CLUB”\n</strong> bebidas alcohólicas, toxicas, enervantes o drogas de cualquier tipo.</div><div>\nI. Proporcionar datos falsos o inexactos al realizar cualquier trámite en <strong>“EL CLUB”</strong>.</div><div>\nJ. Adquirir una membresía o cualquier otro servicio de los que ofrece <strong>“EL PRESTADOR”</strong>\n a personas no autorizadas, y/o ajenas a <strong>“EL CLUB”</strong>\n, y pretender hacer uso de las instalaciones o servicios con base en documentos apócrifos u obtenidos con dolo, engaño o mala fe. Se presumirá que existe lo anterior, cuando el \n<strong>“USUARIO TITULAR”</strong>\n no ingrese el pago o los pagos realizados por dichos conceptos en las cajas instaladas en <strong>“EL CLUB”</strong>\n para la recepción de cualquier tipo de pago.</div><div>\nK. Omitir el pago del mantenimiento de más de 6 (seis) meses que corresponda a la membresía contratada.</div><div>\nEn caso de rescisión del contrato <strong>“EL PRESTADOR”</strong>\n deberá dar aviso escrito en el cual se especifique la causa de la misma. En caso de tratarse de membresías de pareja o familiares, dicha sanción afectará exclusivamente al usuario responsable de la violación, permitiéndose el acceso a los demás usuarios de dicha membresía. En caso de que la rescisión del contrato sea hecha al \n<strong>“USUARIO TITULAR”</strong>, la membresía podrá quedar a nombre de quien éste designe.</div><div>\nEl aviso escrito, ya sea de manera impresa o digital, se hará mediante entrega al usuario suspendido definitivamente en las instalaciones de \n<strong>“EL CLUB”</strong>.</div><div><strong>“EL PRESTADOR”</strong>\n no hará reembolso alguno por concepto de cuotas de membresía o mantenimiento.</div><div><strong>“EL USUARIO”</strong>\n podrá rescindir el presente contrato a <strong>“EL PRESTADOR”</strong>\n sin responsabilidad alguna, cuando se den las siguientes causas de incumplimiento:</div><div>\n1. En caso de que el usuario no acepte el cambio de concepto a que se refiere la cláusula vigésima tercera del presente contrato.\n</div><div>2. En caso de cierre de <strong>“EL CLUB”</strong> por causas imputables a <strong>“EL PRESTADOR”</strong>\n que no deriven de una causa de fuerza mayor o de una orden de carácter judicial que determine dicha situación.</div>\n<div>3. En caso de que el mantenimiento de algún área de <strong>“EL CLUB”</strong>\n se extienda por más de 3 (tres) meses.</div><div>\n4. Que el usuario haya presentado más de 3 (tres) inconformidades debidamente sustentadas por la misma causa.</div>\n<div>En este caso <strong>“EL PRESTADOR”</strong>\n hará las devoluciones del pago de mantenimientos no devengados y pagados anticipadamente conforme a Ley Federal de Protección al Consumidor, consistente en el 20% (veinte por ciento) de dichos conceptos.\n</div><div><strong>DÉCIMO OCTAVA:</strong></div><div><strong>TARIFAS VIGENTES DE MANTENIMIENTO:</strong></div><div>\n<strong>“EL PRESTADOR”</strong>\n podrá incrementar el precio de las cuotas de mantenimiento y servicios de manera anual y/o al término del periodo correspondiente al mantenimiento anual pagado y devengado por los usuarios, para lo cual dará aviso con 30 (treinta) días naturales de anticipación a los usuarios en las instalaciones de \n<strong>“EL CLUB”</strong>\n que corresponda de dicho incremento, por lo que en caso de aceptación tácita de los usuarios se obligarán a pagar los incrementos que se registren en las cuotas de mantenimiento a partir del momento que para tal efecto determine \n<strong>“EL PRESTADOR”</strong></div><div>\nLos usuarios gozarán de un plazo de 30 (treinta) días naturales para manifestar su consentimiento con las nuevas cuotas o para dar por terminado el contrato sin ninguna responsabilidad.\n</div><div><strong>DECIMA NOVENA</strong></div><div><strong>FIRMA ELECTRÓNICA:</strong></div><div>El <strong>“TITULAR”\n</strong> manifiesta que es su deseo hacer uso de la firma electrónica elegida por <strong>“EL PRESTADOR”</strong>\n para generar derechos y obligaciones en su carácter de <strong>“TITULAR”</strong>\n, indicando a su vez que aprueba y reconoce el contenido del presente</div><div>\ninstrumento y los mensajes de datos generados con la herramienta mencionada, para que produzcan todos los efectos legales a que haya lugar, con los mismos efectos que las leyes otorgan a la firma autógrafa física en términos de lo dispuesto por los artículos 96 al 99 del Código de Comercio.\n</div><div>El <strong>“TITULAR”</strong>\n reconoce y acepta que el presente instrumento legal firmado por él, mediante el uso de Firma Electrónica, así como los mensajes de datos, podrán ser conservados de manera digital por las partes, junto con sus certificados o mecanismos digitales, como prueba en cualquier procedimiento legal derivado de la relación entre ellas. No obstante, cada parte será responsable del tratamiento y destino que se les dé a dichos documentos y/o mensajes de datos una vez descargados.)\n</div><div><strong>VIGÉSIMA. </strong></div><div><strong>SOLIDARIDAD:</strong></div><div>\nPara todos los efectos derivados del presente contrato y su reglamento, los usuarios dependientes designados por el \n<strong>“USUARIO TITULAR”</strong>, se constituyen en obligados solidarios ante <strong>“EL PRESTADOR”</strong>\n, respecto del pago de las cuotas de membresía y mantenimiento, así como de la responsabilidad derivada del mal uso de las instalaciones y equipos propiedad de \n<strong>“EL PRESTADOR”</strong>.</div><div><strong>VIGÉSIMA PRIMERA. </strong></div><div><strong>\nAUTORIZACIÓN DE USO DE DATOS PARA FINES COMERCIALES: </strong></div><div>Por medio del presente <strong>“EL PRESTADOR”\n</strong>\n pone a su consideración el consentimiento para usar los datos personales hechos de su conocimiento para efectos del envío de sus promociones comerciales o las de sus empresas filiales y/o subsidiarias.\n</div><div><strong>VIGÉSIMA SEGUNDA. </strong></div><div><strong>JURISDICCIÓN Y COMPETENCIA:</strong></div><div>\nEn caso de conflicto entre las partes acuerdan irrevocablemente someterse a la jurisdicción de la procuraduría federal del consumidor y renuncian en forma expresa a cualquier otro fuero que por razón de domicilio, presente o futuro, o que por cualquier otra causa pudiere corresponderles, dejando a salvo sus derechos para el caso de no poder dirimir la controversia respectiva ante esta instancia, se ejerza ante los tribunales competentes a la entidad federativa que corresponda al lugar de prestación de los servicios contratados.\n</div><div><strong>VIGÉSIMA TERCERA. </strong></div><div><strong>ATENCIÓN A QUEJAS O SUGERENCIAS:</strong></div><div>\nPara el caso de quejas o sugerencias, <strong>“EL PRESTADOR”</strong>\n pone a su disposición el teléfono 55 68 13 67 36en un horario de lunes a viernes de 8:00 a 18:00 horas y sábado y domingo de 8:00 a 14:00 horas. \n<strong>“EL PRESTADOR”</strong>\n dará respuesta a las quejas o sugerencias de los usuarios en un lapso de hasta 5 (cinco) días hábiles contados a partir de la fecha de su recepción.\n</div><div class=\"risks\" style=\"padding-top: 2px; padding-bottom: 2px text-center\"><table \nclass=\"regulation-content-terms-table\"><tr><td class=\"title w-300\" style=\"vertical-align: top; text-align: center\"><div\n class=\"regulation-signature\"><img src=\"assets/images/signature_jahs.png\" width=\"100\" height=\"100\"><br>\n________________________________________________<div class=\"regulation-signature-data\"><p>\nGERENTE GENERAL ANTONIO HERNANDEZ</p><p>EL PRESTADOR</p></div></div></td><td class=\"title w-300\" \nstyle=\"vertical-align: top; text-align: center\"><div class=\"regulation-signature\"><div style=\"height: 40px\"></div><img \nng-src=\"{{vm.signatureSrc}}\"><br>________________________________________________<div \nclass=\"regulation-signature-data\"><p>{{vm.data.partnerName}}</p><p>TITULAR</p></div></div></td></tr></table></div>\n</div><div class=\"signatures\"><div><img ng-src=\"{{vm.signatureSrc}}\"></div><div><img ng-src=\"{{vm.signatureSrc}}\">\n</div><div><img ng-src=\"{{vm.signatureSrc}}\"></div><div><img ng-src=\"{{vm.signatureSrc}}\"></div><div><img \nng-src=\"{{vm.signatureSrc}}\"></div></div></div><div class=\"page-break\"></div><div><div \nclass=\"contract-title text-center\" layout=\"row\" layout-align=\"center\"><br><br>AVISO DE PRIVACIDAD</div><div><br><div>\nEn cumplimiento a lo previsto en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (en lo sucesivo “la Ley”), nos permitimos informarle lo siguiente:\n</div><br><div>\n1.- RESPONSABLE DE LOS DATOS PERSONALES OPERADORA ACTIVE PH S.A. de C.V., (en lo sucesivo “ACTIVE CLUB\"), señalando para efectos del presente Aviso de Privacidad el domicilio ubicado en Avenida Universidad 1883, Colonia Oxtopulco Universidad, Delegación Coyoacán, C.P. 04318 CDMX, será el responsable de los datos personales que le sean proporcionados por las personas físicas a quienes correspondan los mismos (en lo sucesivo el “Titular” o los “Titulares”)\n</div><br><div>\n2.- DATOS PERSONALES QUE SE SOLICITAN DEL TITULAR Para las finalidades señaladas en el presente Aviso de Privacidad, ACTIVE CLUB podrá recabar los datos personales del Titular interesado en contratar alguno de los servicios de ACTIVE CLUB como son: nombre (identificación oficial así como la imagen del Titular al ingresa a las instalaciones de ACTIVE CLUB a través de las cámaras de videovigilancia y seguridad), domicilio, teléfono fijo, teléfono celular, nacionalidad, fecha de nacimiento, estado civil, información general de aptitudes físicas, padecimientos o enfermedades, Registro Federal de Contribuyentes (RFC), Clave Única de Registro de Población (CURP), número de cuenta bancaria y ocupación o actividad profesional. Por otra parte, para aquellas personas que tengan el carácter de Avales u Obligados Solidarios de un Titular interesado en contratar alguno de los servicios de ACTIVE CLUB se les informa que éste último únicamente requiere sus Datos Personales correspondientes a: nombre (identificación oficial así como la imagen del Titular al ingresar a las instalaciones de ACTIVE CLUB a través de las cámaras de videovigilancia y seguridad), domicilio, estado civil, información general de aptitudes físicas, padecimientos o enfermedades, Registro Federal de Contribuyentes (RFC) e información patrimonial (relación de bienes). Datos Personales de los que los Avales u Obligados Solidarios son Titulares en términos del presente Aviso de Privacidad. Los Datos Personales de los Titulares se podrán recabar de las siguientes formas: i) cuando el Titular los proporcione personal o directamente, ii) cuando ACTIVE CLUB los obtenga de forma indirecta, iii) cuando el Titular utilice el sitio de internet o los servicios en línea de ACTIVE CLUB y/o iv) cuando se obtengan por ACTIVE CLUB a través de las fuentes permitidas por la legislación. Es responsabilidad del Titular de los Datos Personales, el garantizar que los datos que facilite personal o directamente a ACTIVE CLUB sean veraces y completos, así como de notificar a ACTIVE CLUB cualquier modificación a los mismos para dar cumplimiento a la obligación de mantener la información actualizada.\n</div><br><div>\n3.- FINALIDADES PARA LAS QUE SE RECABAN LOS DATOS PERSONALES La información de Datos Personales, que es recolectada por ACTIVE CLUB del Titular interesado en contratar alguno de los servicios de ACTIVE CLUB tendrá el uso que se describe a continuación: i) para la relación correspondiente a la prestación de los servicios ofrecidos por ACTIVE CLUB (en adelante y en su conjunto los Servicios), ii) para el cumplimiento de los contratos que celebre ACTIVE CLUB con el Titular, iii) para la identificación del Titular, iv) para la administración de los Servicios, v) para el análisis de los Servicios, vi) para la actualización de datos del Titular, vii) proporcionar seguridad a las instalaciones de ACTIVE CLUB y a los Titulares que ingresen a éstas últimas, finalidades que son necesarias para cumplir las obligaciones derivadas de la relación jurídica que tenga ACTIVE CLUB con el Titular. Asimismo, dentro del uso que ACTIVE CLUB dará a la información del Titular interesado en contratar alguno de los servicios está: i) el ofrecimiento y promoción de bienes, productos y servicios y/o prospección comercial así como ii) evaluar la calidad de los Servicios, finalidades que no necesariamente se requieren para cumplir con las obligaciones derivadas de la relación jurídica que tenga ACTIVE CLUB con el Titular, por lo que, en caso de que el Titular no esté de acuerdo en que ACTIVE CLUB utilice sus Datos Personales para dichas finalidades deberá manifestar su oposición de acuerdo a lo dispuesto en la sección cinco (5) del presente Aviso de Privacidad, ya que, en caso de que el Titular no manifieste su oposición se entenderá que otorga su consentimiento a ACTIVE CLUB. En relación a los Datos Personales que recaba ACTIVE CLUB de aquellos Titulares que tienen el carácter de Avales u Obligados Solidarios de los Titulares interesado en contratar alguno de los servicios de ACTIVE CLUB se les informa que las finalidades para las que este último utiliza sus Datos Personales son únicamente las contenidas en los puntos (i) a () del primer párrafo de la presente sección finalidades que son necesarias para cumplir las obligaciones derivadas de la relación jurídica que tenga ACTIVE CLUB con dichos Titulares derivadas de su designación como Avales u Obligados Solidarios. En relación a los Datos Personales de aquellos Titulares que en el pasado otorgaron sus datos a ACTIVE CLUB y que actualmente ya no tienen una relación con éste último así como de los Avales y/o Obligados Solidarios, se les informa que ACTIVE CLUB únicamente conserva sus Datos Personales de conformidad a lo dispuesto por el artículo 25 de la Ley, es decir, durante el periodo de bloqueo1 establecido en dicho ordenamiento legal, por lo que, una vez transcurrido dicho periodo de bloqueo sus Datos Personales serán suprimidos.\n</div><br><div>\n4.- TEMPORALIDAD, REMISIONES Y TRANSFERENCIAS La temporalidad del manejo de los Datos Personales de los Titulares, dependerá de la relación jurídica que se tenga celebrada con ACTIVE CLUB, así como de las obligaciones exigidas por la legislación vigente las autoridades competentes y las políticas internas de ACTIVE CLUB, sin embargo, en relación a los Datos Personales correspondientes a la imagen de los Titulares que es captada por las cámaras de videovigilancia, dicha información es conservada por ACTIVE CLUB únicamente por un plazo de 30 (treinta) a 60 (sesenta) días hábiles posteriores a la fecha en la que se obtiene. La información que sea entregada a ACTIVE CLUB, será resguardada, conservada y protegida, por éste último de acuerdo a lo dispuesto por la legislación vigente y las políticas internas de ACTIVE CLUB para efecto de mantener la confidencialidad de dicha información. De acuerdo a lo dispuesto por la Ley, ACTIVE CLUB dará acceso a los Datos Personales de los Titulares (a través de remisiones) a aquellas personas que tengan el carácter de Encargados2 como pueden ser prestadores de servicios, socios de negocios o terceros, que tengan una relación jurídica con ACTIVE CLUB, que derivado de dicha relación jurídica necesiten conocer la información y asuman el compromiso de mantenerla bajo un estricto orden de confidencialidad y seguridad reconociendo además conocer los términos y condiciones del presente Aviso de Privacidad y comprometiéndose a dar cumplimiento a los mismos. En caso de que los Datos Personales resguardados sean requeridos por una autoridad de cualquier índole o deban ser entregados a ésta última de acuerdo a la legislación vigente, estos datos se pondrán a su disposición dentro del estricto cumplimiento a la Ley, transferencia que no requiere del consentimiento de los Titulares de acuerdo a lo dispuesto en el artículo 37 de dicho ordenamiento legal.\n</div><br><div>\n5.- DERECHOS DE ACCESO, RECTIFICACIÓN, CANCELACIÓN, OPOSICIÓN, REVOCACIÓN Y LIMITACIÓN DE LOS DATOS PERSONALES. Los Titulares de la información tendrán derecho a solicitar el acceso, rectificación, revocación, cancelación u oposición así como limitar el uso o divulgación de sus datos, mediante: a.- Solicitud escrita dirigida al Departamento de Datos Personales de ACTIVE CLUB al siguiente domicilio: Avenida Universidad 1883, Colonia Oxtopulco Universidad, Alcaldía Coyoacán, C.P. 04318 en CDMX, de las 10:00 a las 17:00 horas, en días hábiles, o b.- Solicitud formulada al correo electrónico contacto@active-club.mx ACTIVE CLUB, dará respuesta a las solicitudes del Titular de la información, siempre y cuando no se actualice alguna de las excepciones contenidas en la Ley, y el solicitante cumpla con lo dispuesto en el artículo 29 de dicho ordenamiento legal que establece los requisitos que debe contener las solicitudes presentadas por los Titulares. Para que ACTIVE CLUB de trámite a la solicitud de un Titular referente al acceso, rectificación, revocación, cancelación, oposición y/o limitación del uso o divulgación de sus datos, éste último deberá adjuntar a su solicitud la siguiente información y documentación: i. Nombre del Titular y domicilio u otro medio para que ACTIVE CLUB le comunique la respuesta a su solicitud. ii. Los documentos con los que acredite su identidad o su personalidad en caso de la representación legal del Titular (identificación oficial del titular o del representante legal y poder de éste último). iii. La descripción clara y precisa de los Datos Personales respecto de los que se busca ejercer el derecho de acceso, rectificación, revocación, cancelación, oposición, limitación del uso o divulgación, así como cualquier otro dato o documento que pueda facilitar la localización de los Datos Personales. ACTIVE CLUB dará respuesta a la solicitud de un Titular referente al acceso, rectificación, revocación, cancelación, oposición y/o limitación del uso o divulgación de sus datos dentro de los plazos establecidos en la Ley, es decir, dentro de los veinte (20) días siguientes contados a partir de que reciba la solicitud del Titular, plazo que podrá ser ampliado por ACTIVE CLUB de acuerdo a lo dispuesto por el artículo 32 de la Ley. La obligación de acceso a la información se dará por cumplida por ACTIVE CLUB cuando, en caso de que sea solicitado por el Titular, se ponga a disposición de éste último sus Datos Personales en el domicilio de ACTIVE CLUB durante el plazo de 15 (quince) días hábiles siguientes a que se le comunique al Titular la respuesta a su solicitud o bien a través de alguna de las formas establecidas en el artículo 33 de la Ley, mismas que en la respuesta a su solicitud se le notificarán al Titular.\n</div><br><div>\n6.- MODIFICACIONES AL AVISO DE PRIVACIDAD En el supuesto, de que ACTIVE CLUB, requiera usar sus Datos Personales con fines distintos a los pactados o convenidos al tenor de la relación jurídica que se tiene con el Titular y/o en el presente Aviso de Privacidad o bien requiera del Titular Datos Personales distintos a los señalados en el presente Aviso de Privacidad, se notificará al Titular en forma escrita, telefónica, electrónica, o por cualquier medio óptico, sonoro, visual u otro que la tecnología permita ahora o en lo futuro explicando los nuevos usos que pretenda darle a dicha información a fin de obtener su consentimiento en términos de la Ley. Con el presente Aviso de Privacidad, los Titulares de la información quedan debidamente informados de los datos que se recabaron de ellos y con qué fines así como del hecho de que el Aviso de Privacidad podrá en todo momento ser consultado en el domicilio de ACTIVE CLUB arriba señalado. ACTIVE CLUB, se reserva el derecho a modificar el presente Aviso de Privacidad para adaptarlo a novedades legislativas o jurisprudenciales así como a prácticas comerciales. En dichos supuestos, se anunciarán en el domicilio de ACTIVE CLUB, arriba señalado, los cambios de referencia. El presente Aviso de Privacidad, así como el manejo en general de la Ley que haga ACTIVE CLUB, se rige por la legislación vigente y aplicable en los Estados Unidos Mexicanos, cualquier controversia que se suscite con motivo de su aplicación deberá ventilarse ante el Instituto Federal de Acceso a la Información y Protección de Datos (IFAI) o ante los Órganos Jurisdiccionales competentes en la Ciudad de México, Distrito Federal.\n</div></div><div class=\"risks\" style=\"padding-top: 2px; padding-bottom: 2px text-center\"><table \nclass=\"regulation-content-terms-table\"><tr><td class=\"title w-300\" style=\"vertical-align: top; text-align: center\"><div\n class=\"regulation-signature\"><img src=\"assets/images/signature_jahs.png\" width=\"100\" height=\"100\"><br>\n________________________________________________<div class=\"regulation-signature-data\"><p>\nGERENTE GENERAL ANTONIO HERNANDEZ</p><p>EL PRESTADOR</p></div></div></td><td class=\"title w-300\" \nstyle=\"vertical-align: top; text-align: center\"><div class=\"regulation-signature\"><div style=\"height: 40px\"></div><img \nng-src=\"{{vm.signatureSrc}}\"><br>________________________________________________<div \nclass=\"regulation-signature-data\"><p>{{vm.data.partnerName}}</p><p>TITULAR</p></div></div></td></tr></table></div>\n</div><div class=\"page-break\"></div><div><div class=\"contract-title text-center\" layout=\"row\" layout-align=\"center\">\n<br><br>\nPara efectos del presente Reglamento “Active Club” significa la persona moral encargada de operar las instalaciones.\n</div><div><br><div><strong>SOCIOS Y MEMBRESÍAS:</strong></div><div>\n1) El presente Reglamento es de aplicación para todos los usuarios de Active Club, así mismo todos los usuarios e invitados estarán obligados a cumplir con los reglamentos internos o de área, así como cualquier disposición operativa o administrativa y las políticas que en su momento se pudieran emitir.\n</div><div>2) Los tipos de membresías que se pueden contratar son las siguientes:</div><div><strong \nstyle=\"font-style: italic\">Membresía Individual:</strong></div><div>\nPermite el uso de la membresía para una sola persona mayor a 18 años. Conformada por un usuario titular.</div><div>\n<strong style=\"font-style: italic\">Membresía de Pareja:</strong></div><div>\nIntegrada por dos personas sin necesidad de justificar parentesco. Compuesta por un usuario titular y un agregado.\n</div><div><strong style=\"font-style: italic\">Membresía Familiar:</strong></div><div>\nEstá integrada como base por una pareja, los hijos o familiares directo de éstos. Este tipo de membresía tiene derecho a máximo 6 integrantes.\n</div><div><strong style=\"font-style: italic\">Membresía Individual 60 años y más:</strong></div><div>\nEstá integrada por una persona que debe de comprobar una edad de 60 años en adelante teniendo una cuota mensual de mantenimiento preferencial, este tipo de membresía no tiene derecho a agregado familiar, debiendo de presentar credencial de INE, INAPAM y/o pasaporte.\n</div><div><strong style=\"font-style: italic\">Membresía de Pareja 60 años y más:</strong></div><div>\nEstá integrada por una pareja que puede estar conformada por dos personas sin importar parentesco, debiendo de comprobar una edad de 60 años en adelante teniendo una cuota mensual de mantenimiento preferencial, debiendo de presentar credencial de INE, INAPAM y/o pasaporte.\n</div><div><strong style=\"font-style: italic\">Grupal:</strong></div><div>\nConformada por un usuario titular y 3 agregados, no necesitan comprobar parentesco.</div><div><strong \nstyle=\"font-style: italic\">Junior:</strong></div><div>\nMembresías para niños y adolescentes sin la presencia de padre o tutor en la misma a partir de los 6 años y hasta 14 años y 11 meses. Entre 6 y 10 años solo podrán ingresar al club con nana u otro personal de servicio.\n</div><div>\n•	Para los casos en los que el usuario titular se encuentre entre los 15 y 18 años, será necesaria una carta responsiva por parte del padre o tutor, así como la firma del contrato de este mismo. Este tipo de usuario ingresa en modalidad individual y con cargo\n</div><div>\n3) El titular de la membresía tendrá que ser mayor de 18 años y tendrá la obligación de proporcionar la información verídica solicitada al momento de realizar la compra de la misma.\n</div><div>\n4) El usuario podrá hacer uso de las instalaciones a partir del momento que ha realizado su pago, es decir, asista o no, el pago cubre a partir del mes corriente. En caso que el usuario eligiera hacer uso posteriormente de las instalaciones deberá tener autorización por parte de la Gerencia y esta no podrá exceder más de 2 meses después de realizada la compra.\n</div><div>\n5) Para cambiar el tipo de membresía y poder admitir un mayor número de usuarios, el titular de ésta deberá cubrir una cuota que será determinada por la Gerencia. En caso contrario, es decir, disminuir el número de usuarios, sólo se realizará el trámite de baja de los que lo soliciten. Este trámite se deberá hacer antes del día 25 de cada mes, siendo necesario tener como comprobante la copia del formato que se le entrega al momento de realizar el mismo.\n</div><div>\n6) Para traspasar una membresía el titular de ésta deberá de conseguir un tercero al cual se le traspasará, así mismo deberá cubrir una cuota que será determinada por la Gerencia y no presentar ningún tipo de adeudo. Este traspaso solo contará con la membresía como tal y no con los beneficios que ésta pudo haber adquirido por motivos de preventa y/o algún caso similar. En el caso de una inscripción activa con mantenimiento anual, la cuota de traspaso se descontará del total del pago de la anualidad y el saldo restante se aplicara al nuevo titular. Este trámite se deberá hacer antes del día 25 de cada mes.\n</div><div>7) Active Club se reserva el derecho de rechazar cualquier solicitud de membresía.</div><div>\n8) Para poder adquirir una membresía de cualquier tipo es requisito ser mayor de edad y cubrir la cuota de inscripción que esté vigente a la fecha de la transacción.\n</div><div>\n9) La documentación que todos los usuarios de las nuevas inscripciones deben proporcionar al comprar será la siguiente:\n</div><div><strong style=\"text-decoration: underline\">Membresía individual. -</strong>\n Copia fotostática de identificación oficial (acta de nacimiento o credencial del INE o Pasaporte o Cédula profesional o Licencia de manejo).\n</div><div><strong style=\"text-decoration: underline\">Membresía de pareja.-</strong>\n Copia fotostática de identificación oficial de cada socio (acta de nacimiento o credencial del INE o Pasaporte o Cédula profesional o Licencia de manejo).\n</div><div><strong style=\"text-decoration: underline\">Membresía familiar.-</strong>\n Copia fotostática de identificación oficial de cada socio incluyendo niños (acta de nacimiento o credencial del INE o Pasaporte o Cédula profesional o Licencia de manejo).\n</div><div><strong style=\"text-decoration: underline\">Menores.-</strong>\n Copia fotostática de identificación (Cartilla de vacunación o Acta de nacimiento o credenciales escolares o Permiso de conducir o acta tutorial o de adopción).\n</div><div><strong style=\"text-decoration: underline\">Membresía grupal. -</strong>\n Adicional a los documentos de la inscripción es necesario agregar copia de la credencial del corporativo o empresa a la que pertenece.\n</div><div><strong>Nota</strong>\n: En caso de no entregar estos documentos en un lapso de 10 días, la Gerencia quedará facultada para restringir al acceso de todos los integrantes de la membresía.\n</div><br><div><strong>CUOTAS:</strong></div><div>\n10) Todos los usuarios antes descritos pagarán una cuota que deberá realizarse de manera mensual o anual en las diferentes formas de pago que designe la Gerencia, esta cuota se define como cuota de mantenimiento.\n</div><div>\n11) En el caso de los usuarios que al aumentar de edad cambie la cuota de mantenimiento, ésta se ajustará, según sea el caso, al mes siguiente de haber cambiado a la edad de la nueva categoría de tipo de usuario.\n</div><div>12) Las formas para realizar los pagos de las cuotas de mantenimiento de manera mensual son:</div><div>\n</div><div><strong style=\"font-style: italic\">Cargo Mensual Direccionado y/o Domiciliado.</strong>\n Es la cuota vigente que se cobra de manera automática por Active Club y puede ser cargada a una tarjeta de crédito o débito. El usuario reconoce que el cargo mensual direccionado tiene cuotas preferenciales sobre las cuotas convencionales o de caja. En caso de que el usuario desee cancelar su membresía o desee transformar la forma de pago de su cuota a cargo convencional, éste deberá acudir a la recepción del Club para realizar los trámites correspondientes. El usuario acepta que la modalidad de cargo direccionado podrá ser cancelada en cualquier momento por Active Club.\n</div><div><strong style=\"font-style: italic\">Cargo Mensual Convencional.</strong>\n Es la cuota vigente que se cobra mediante el pago del usuario directamente en caja y puede ser con cheque, efectivo, tarjeta de crédito o débito. En caso de que el usuario desee cancelar su membresía, éste deberá acudir a la recepción del Club para realizar los trámites correspondientes.\n</div><div>13) El cargo direccionado tendrá cuotas preferenciales sobre el pago convencional o caja.</div><div>\n14) En caso de que el usuario, haya elegido el pago de la cuota de mantenimiento mediante cargo direccionado, expresamente autoriza a Active Club para que, automáticamente y sin necesidad de algún otro proceso, cargue mensualmente la cuota vigente a cuenta de la tarjeta de crédito y/o débito mencionado en el formato específico.\n</div><div>\nEl usuario autoriza que Active Club realice el cargo de la cuota de mantenimiento direccionado a partir del primer (1) día hábil de cada mes. Si por insuficiencia de fondos o crédito imputables al usuario no se puede realizar el cargo en dicho plazo, el usuario deberá de realizar el pago en la caja del Club con precio convencional.\n</div><div>\n15) Para direccionar los cargos de mantenimiento es necesario realizar el trámite por escrito en el área de Recepción proporcionando la información que contiene el formato específico.\n</div><div>\n16) Las membresías pueden realizar el pago de mantenimiento anual. Es la cuota anual vigente que se cobra en una exhibición y puede ser pagada en tarjeta de crédito o débito. En este caso no se podrá solicitar la devolución sobre la cantidad pagada, descontándose los meses disfrutados y al monto restante se le aplicará una penalización del 20%.\n</div><div>\n17) Durante los últimos meses del año la Gerencia publicará las nuevas cuotas que estarán vigentes a partir del primer día del mes de enero, dándolas a conocer en las pantallas informativas del club, así como por nuestras redes sociales (Facebook e Instagram)\n</div><div>\n18) El pago de las cuotas de mantenimiento de una membresía deberán de realizarse en una sola exhibición, quedando prohibido los pagos parciales.\n</div><div>\n19) Para solicitar un comprobante fiscal o factura de servicios distintos al pago de mantenimiento y membresía</div>\n<div>\n(invitados, entre otros), el usuario deberá de solicitar su comprobante fiscal al momento de realizar su pago, de no hacerlo la empresa estará imposibilitada para emitirlo con posterioridad.\n</div><div>\n20) Para solicitar un cambio de factura o comprobante fiscal del pago de mantenimiento o membresía, esta deberá de ser dentro del mismo mes en que la misma fue expedida.\n</div><div>\n21) En caso de devolución de un cheque por parte del banco, el usuario estará obligado a cubrir el cargo que el banco le genere a Active Club, en caso de que la causa sea por falta de fondos se cobrará el 20 % del monto del cheque.\n</div><div>\n22) Todos los pagos de cualquier servicio que ofrece Active Club deberán ser realizados en la caja ubicada en la recepción del Club.\n</div><div>\n23) En caso de una membresía nueva, ésta deberá de cubrir la cuota de mantenimiento proporcional según el día en que se realice la misma: durante los primeros 6 días del mes deberá cubrir la cuota de mantenimiento completa, a partir del día 7 pagará la proporción que resulte de dividir el monto total de la cuota de mantenimiento entre el número de días del mes en cuestión, por el número de días vigentes o a correr del mes. Si la membresía es adquirida después del día 24, es decir a partir del día 25 del mes, el monto de pago de estos últimos días será de cortesía. El usuario tiene la opción de realizar este cargo con cuota direccionada, siempre y cuando haya realizado ya el trámite para direccionar sus futuros pagos de mantenimiento.\n</div><div>\n24) La Gerencia está facultada para negar el acceso a todos los integrantes de la membresía en caso de que presente un adeudo de la cuota de mantenimiento o algún otro adeudo, tomándose esta medida según la opción de pago que haya elegido:\n</div><div><strong>Pago de mantenimiento mensual direccionado.</strong>\n Se negará el acceso a partir del día 6 del mes corriente que no se haya pagado. Es decir; si hoy es 6 de marzo y no ha sido cubierta la cuota de mantenimiento del mes de marzo, la Gerencia estará facultada para negar el acceso hasta recibir el pago de dicho mes.\n</div><div><strong>Pago de mantenimiento mensual convencional.</strong>\n Se negará el acceso a partir del día 6 del mes corriente, es decir, si hoy es día 6 de febrero y no ha sido cubierta la cuota de mantenimiento del mes de febrero, la Gerencia estará facultada para negar el acceso hasta recibir el pago correspondiente.\n</div><div><strong>Pago de mantenimiento semestral y anual.</strong>\n Se negará el acceso a partir del primer día del mes siguiente al que se haya vencido la anualidad y/o semestre.</div>\n<div>\n25) En caso de que todos los integrantes de la membresía requieran ausentarse por un lapso mínimo de tres meses, se podrá solicitar la cuota de ausencia. Esta cuota corresponde a un porcentaje del mantenimiento individual. Si el pago de mantenimiento es direccionado y/o convencional será del 33% del monto que paga la persona o integrante. El trámite debe realizarlo el titular de la membresía en la Recepción del Club llenando el formato pertinente. La membresía deberá estar al corriente en sus cuotas de mantenimiento, debiendo de entregar las credenciales de los integrantes de la membresía. Esta cuota aplicará al mes siguiente de haber realizado el trámite, aplicando la cuota de ausencia vigente.\n</div><div>\n26) La Gerencia no se hace responsable por situaciones o acontecimientos sociales, desastres naturales, contingencia ambiental, sanitaria o cualquier otro incidente fuera de nuestra responsabilidad, que afecte la operación regular de nuestra unidad, y nos impida ofrecer nuestros servicios, parcial o totalmente, deslindándonos de cualquier tipo de devolución, compensación, reposición o bonificación en pagos de mantenimiento, inscripción y servicios. En caso de cierre por pandemia los pagos anticipados que estén pendientes por devengar (anualidades, semestres) se congelarán, reactivándose al momento de la reapertura.\n</div><br><div><strong>USO DE LAS INSTALACIONES:</strong></div><div>\n27) El horario de servicio de Active Club estará colocado en el reglamento del área de recepción, página de internet y en caso de surgir alguna duda o de requerir mayor información del mismo, podrá consultar esta información con el personal del Club.\n</div><div>\n28) La Gerencia está facultada para hacer cambios en el horario de operación de Active Club con previo aviso a los usuarios mediante comunicados que serán colocados en las pantallas informativas que se encuentran en diversas áreas del Club, así como en las redes sociales oficiales de Active Club (Facebook e Instagram).\n</div><div>\n29) Para efectos de días festivos o días especiales, Active Club notificará de forma anticipada a los usuarios el horario del Club por medio de comunicados en las pantallas informativas, así como en las redes sociales oficiales de Active Club (Facebook e Instagram).\n</div><div>30) Los días <strong>1º de Enero y 25 de diciembre</strong>\n Active Club no dará servicio permaneciendo sus instalaciones cerradas.</div><div>\n31) Los servicios de vapor y sauna permanecerán abiertos desde la apertura del Club hasta 30 minutos antes del cierre del mismo, el servicio de regaderas se suspenderá a partir de las 22:45 hrs; las luces serán apagadas de lunes a viernes a las 23:00 hrs, sábado y domingo a las 17:00 hrs. y días festivos a las 15:00 hrs. El área de alberca permanecerá abierta desde la apertura del Club hasta las 22:00 hrs; de lunes a viernes, sábados y domingos hasta las 16:00 hrs; y días festivos desde la apertura hasta las 14:00 hrs.\n</div><div>\n32) Para poder acceder a las instalaciones de Active Club es obligatorio estar registrado y deberá portar la credencial en caso de requerirla para situaciones extraordinarias.\n</div><div>\n33) El uso de la credencial y gafetes de acceso es personal e intransferible, el mal uso de éstos será sancionado por la Gerencia pudiendo llegar hasta la expulsión definitiva de Active Club.\n</div><div>34) La reposición de credencial tendrá el costo determinado por la Gerencia.</div><div>\n35) Los niños menores de 11 años 11 meses, deberán acceder, permanecer y salir del Club con algún acompañante responsable mayor de edad.\n</div><div>\n36) La Gerencia podrá disponer de las diversas instalaciones y/o servicios que Active Club brinda, en el momento y tiempo necesario para mantenimiento u otros eventos relacionados con la operación del club.\n</div><div>\n37) Todos los integrantes de las inscripciones y que sean mayores 4 años tendrán derecho a la realización de la valoración de la aptitud física sin costo alguno, para obtener dicho beneficio los usuarios nuevos deberán tramitar su cita en Sistema Deportivo Trainingym, así como para las revaloraciones.\n</div><div>\n38) Para cancelar la membresía definitivamente es necesario realizar el trámite el mes anterior en el área de Recepción, siendo requisito indispensable no presentar ningún tipo de adeudo, así como entregar las credenciales de todos los integrantes. Este trámite se puede realizar hasta el día 25 del mes anterior a la cancelación de la membresía (citando como ejemplo que si la cancelación se solicita sea efectiva para el mes de Octubre el trámite se debe de realizar durante el mes de Septiembre).\n</div><div>\n39) Para realizar el alta de un usuario se debe llenar el formato respectivo en el área de Recepción por parte del titular de la membresía. Este trámite puede realizarse cualquier día del mes siempre y cuando la membresía esté al corriente en sus cuotas de mantenimiento y deberá cubrir la parte proporcional de la cuota de mantenimiento del nuevo integrante, los siguientes pagos de mantenimiento se realizarán en una sola exhibición. Dentro de los siguientes 10 días hábiles el nuevo usuario deberá de entregar su documentación completa, además de realizarse la valoración de la aptitud física.\n</div><div>\n40) Para realizar la baja de un usuario es necesario llenar el formato respectivo en el área de Recepción por parte del titular de la membresía, La baja se realizará al mes siguiente de que fue recibido el formato, es decir si la carta fue recibida en el mes de septiembre, la baja se registrará en el mes de octubre (durante este mes ya no se pagará la cuota del integrante dado de baja). Para poder realizar este trámite la inscripción debe de estar al corriente de sus cuotas de mantenimiento y entregar la credencial (es) de (l) la(s) persona(s) dada(s) de baja. Todo movimiento relacionado con este punto deberá realizarse antes del día 25 del mes previo a la aplicación de la baja.\n</div><div>\n41) Los usuarios podrán tener invitados que hagan uso de las instalaciones de Active Club siempre y cuando paguen la cuota que determine la Gerencia y estén acompañados en todo momento por algún integrante de la membresía en la cual se registra el invitado. El titular de la membresía se hace responsable por el buen comportamiento de su(s) invitado(s), así como cubrir los daños y consumos que hagan. Active Club se reserva el derecho de negar el acceso a cualquier invitado.\n</div><div>\n42) El familiar o persona que acompañen al menor que está inscrito al club Active Club deberá de reportarse en la recepción para entregar una identificación oficial, donde recepción le entregara un gafete que debe portar en todo momento estando en el club.\n</div><div>\nEs necesario agregar al expediente los datos de las personas que estarán autorizadas para acompañar al menor para mayor seguridad de los socios y control interno, estos documentos son:\n</div><div class=\"text-center\">a) Copia de Identificación oficial</div><div class=\"text-center\">\nb) Formato de carta responsiva.</div><div>\n43) Active Club se reserva el derecho de negar el acceso al usuario que se presente en estado de ebriedad, con aliento alcohólico o bajo la influencia de cualquier estupefaciente o psicotrópico, también se le negará el acceso a cualquier persona que represente algún riesgo para el resto de los usuarios o empleados.\n</div><div>\n44) Toda credencial no entregada por el usuario al realizar movimientos de membresía que así lo requieren (baja, ausencia, cancelación) tendrá que ser sustituida por el pago de la cuota de reposición de credencial, de lo contrario no se podrá realizar el movimiento solicitado.\n</div><div>\n45) Ninguna persona ajena al staff puede ejercer la función como instructor, el usuario que sea sorprendido realizando cualquier instrucción o asesoría será sancionado, de reincidir será expulsado.\n</div><div>\n46) Todas las quejas y sugerencias deberán hacerse por escrito dirigidas a la Gerencia de Active Club y se depositarán en un buzón que estaré colocado cerca de la recepción, así como en las redes sociales oficiales de Active (Facebook e Instagram)\n</div><br><div><strong>SANCIONES:</strong></div><div>\n47) Cualquier falta al reglamento o comportamiento que altere el orden de Active Club será sancionada con una amonestación por escrito la cual se integrará al expediente de la Membresía.\n</div><div>\n48) El usuario que acumule un total de 3 amonestaciones causará baja definitiva de Active Club. Si la falta lo amerita, el usuario podrá ser suspendido temporalmente de Active Club, sin que esto interfiera con los pagos del mantenimiento mensual.\n</div><div>\n49) La Gerencia tiene la facultad de cancelar definitivamente una membresía si a su juicio el usuario incurre en alguna falta grave que así lo amerite: destrucción de las instalaciones o equipos, falta de respeto a cualquier integrante de Active Club, ya sea usuario o empleado, repetidas faltas al reglamento, robo, etc. En dicho caso Active Club no estará obligado a realizar reembolso alguno. En estos casos intervendrá el Comité de Honor y Justicia quién documentará los elementos para la expulsión de los usuarios.\n</div><div>\n50) Cualquier daño que se ocasione a las instalaciones o equipos de Active Club por parte de cualquier integrante de la membresía o invitado será cubierto por el titular de la misma.\n</div><br><div><strong>GENERALES:</strong></div><div>\n51) Queda prohibida la venta o promoción de cualquier tipo(s) de artículo(s), evento(s) o rifa(s).</div><div>\n52) Se prohíbe convocar a asambleas, realizar mítines, organizar juntas, reunir firmas, volantear información o complots en contra de Active Club y su personal.\n</div><div>\n53) Queda prohibido introducir cualquier tipo de alimentos y bebidas, excepto agua y bebidas hidratantes en envases de plástico.\n</div><div>\n54) Active Club no se hace responsable por la pérdida total o parcial de cualquier objeto o valor, tales como celulares, documentos, joyas, dinero, entre otros, estando a su disposición las cajas de seguridad ubicadas en el acceso de vestidor de damas y caballeros. El servicio de estas cajas de seguridad es sin ningún costo adicional, pudiendo consultar el reglamento específico de las mismas.\n</div><div>\n55) Queda prohibido portar e introducir a Active Club: bebidas alcohólicas, estupefacientes o cualquier clase de arma o materiales peligrosos que pudieran perjudicar o dañar a los usuarios y personal de Active Club, así como a las instalaciones del mismo.\n</div><div>56) Queda prohibido el acceso a las instalaciones de Active Club con cualquier clase de animal o mascota.\n</div><div>\n57) Queda prohibido el uso de aparatos de sonido, bocinas, televisores portátiles o aparatos electrónicos y/o de entretenimiento sin el uso de audífonos personales.\n</div><div>\n58) No está permitido el introducir a las instalaciones bicicletas, triciclos, patines u objetos similares excepto en eventos organizados por Active Club.\n</div><div>\n59) Los usuarios no podrán reprender o llamar la atención a ningún empleado de Active Club, para cualquier queja, ésta deberá de formularse por escrito a la Gerencia General.\n</div><div>60) Queda prohibido fumar en todas las áreas del Club.</div><div>\n61) No se permite la toma de fotos a instalaciones, usuario o cualquier persona dentro de las instalaciones, salvo en los eventos previamente programados por la Gerencia.\n</div><br><br><div class=\"text-center\"><strong>REGLAMENTO CAJA:</strong></div><br><br><div class=\"text-center\" \nstyle=\"text-decoration: underline\">Horario de servicio:</div><div class=\"text-center\">\nDe lunes a viernes: de 6:00 a 22:00 hrs.</div><div class=\"text-center\">\nSábado y domingo 9:00 a 16:30 y días festivos de: 7:00 a 14:30 hrs.</div><br><br><div>\n1. La fecha límite para efectuar el pago oportuno de su cuota mensual es el día cinco de cada mes.</div><div>\n2. El personal de caja no está autorizado para recibir pagos parciales de su adeudo, tampoco podrá autoriza la entrada a las instalaciones, si su estado de cuenta manifiesta que no está al corriente de pago. Si tiene alguna duda sobre el saldo de su cuenta, favor de pasar a la Gerencia del Club quien atenderá su caso.\n</div><div>\n3. Los cambios de status en su membresía (bajas, ausencias y demás), deberán notificarse por escrito a la gerencia del club a más tardar el día 25 del mes anterior a su vigencia.\n</div><div><strong>FORMAS DE PAGO:</strong></div><div><strong>1.- DOMICILIADO</strong></div><div>a) Tarjeta de crédito\n</div><div>b) Tarjeta de débito</div><div><strong>2.- CONVENCIONAL O CAJA</strong></div><div>a) Transferencias</div>\n<div>b) Efectivo</div><div>c) Tarjeta de débito o crédito</div><div>b) Cheque</div><br><div class=\"text-center\">\n<strong>REGLAMENTO DE ACCESO:</strong></div><div class=\"text-center\" style=\"text-decoration: underline\">\nHorario de acceso:</div><div class=\"text-center\">Lunes a viernes: de 5:00 a 22:30 hrs.</div><div class=\"text-center\">\nSábado y domingo de 7:00 a 16:30 y días festivos: de 7:00 a 14:30 hrs.</div><div>\n1. Por la seguridad de todos nuestros usuarios, todas las personas que tengan acceso y salida a las instalaciones del Club es por medio de su reconocimiento facial y/o credencial, En caso de olvido de la credencial tendrá derecho a tres pases de olvido de credencial al mes, siendo responsabilidad del área de Recepción validar que la membresía se encuentre al corriente de pago. En caso de un cuarto olvido de credencial se cobrará el monto establecido por la Gerencia del Club.\n</div><div>\n2. Todos los usuarios de Active Club contarán con su con su reconocimiento facial y/o credencial siéndoles útil para el rentado de toallas.\n</div><div>\n3. Si por algún motivo no le es permitido el acceso, favor de pasar a la oficina de la Gerencia y/o Gerencia en turno, para aclarar el motivo. El personal de Recepción y vigilancia no está autorizado para hacer excepciones en ningún caso; evite discutir con ellos.\n</div><div>\n4. Se prohíbe la introducción de alimentos, bebidas de cualquier índole, así como mascotas (animales), juguetes con ruedas como bicicletas, triciclos, patines o patinetas, ni otros que puedan causar molestias o accidentes a los demás usuarios.\n</div><div>\n5. La Gerencia está facultada para negar el acceso a todos los integrantes de la inscripción en caso de que presente un adeudo de la cuota de mantenimiento o algún otro adeudo.\n</div><div>\n6. La Gerencia no se hace responsable por situaciones o acontecimientos sociales, desastres naturales, contingencia ambiental, sanitaria o cualquier otro incidente fuera de nuestra responsabilidad, que afecte la operación regular de nuestra unidad, y nos impida ofrecer nuestros servicios, parcial o totalmente.\n</div><div>\n7. La Gerencia está facultada para hacer cambios en el horario de operación de Active Club con previo aviso a los usuarios mediante comunicados que serán colocados en las pantallas informativas del Club, así como por las redes sociales oficiales (Facebook e Instagram).\n</div><div>\n8. Para efectos de días festivos o días especiales, Active Club notificará de forma anticipada a los usuarios el horario del Club por medio de comunicados en las pantallas informativas.\n</div><div>\n9. Los servicios de baño y regaderas permanecerán abiertos desde la apertura del Club hasta 15 minutos antes del cierre del mismo. Los servicios de vapor y sauna permanecerán abiertos desde la apertura hasta 30 minutos antes del cierre. El área de alberca permanecerá abierta desde la apertura hasta 60 minutos antes del cierre del Club.\n</div><div>10. La reposición de credencial tendrá el costo determinado por la Gerencia.</div><div>\n11. Active Club se reserva el derecho de negar el acceso al usuario que se presente en estado de ebriedad, con aliento alcohólico o bajo la influencia de cualquier estupefaciente o psicotrópico, también se le negará el acceso a cualquier persona que represente algún riesgo para el resto de los usuarios o empleados.\n</div><div>12. Queda prohibido fumar en todas las áreas del Club.</div><div>\n13. Todas las quejas y sugerencias deberán hacerse por escrito dirigidas a Active Club y se depositarán en los buzones de sugerencias ubicado en las diferentes áreas del Club, así como en las redes sociales.\n</div><div>\n14. Los socios no podrán reprender o llamar la atención a ningún empleado de Active Club, para cualquier queja, ésta deberá de formularse por escrito a la Gerencia.\n</div><div class=\"text-center\"><strong>REGLAMENTO DE ACCESO:</strong></div><div class=\"text-center\" \nstyle=\"text-decoration: underline\">Horario de servicio de regaderas:</div><div class=\"text-center\">\nDe lunes a viernes: de 5:00 a 22:45 hrs.</div><div class=\"text-center\">\nSábados y domingos de 7:00 a 16:45 hrs. y días festivos de: 7:00 a 14:45 hrs.</div><div class=\"text-center\" \nstyle=\"text-decoration: underline\">Horario de servicio de vapor y sauna:</div><div class=\"text-center\">\nDe lunes a viernes: de 5:00 a 22:30 hrs.</div><div class=\"text-center\">\nSábados y domingos 7:00 a 16:30 hrs. y días festivos de: 7:00 a 14:30 hrs.</div><div>\n1. El área de vestidores forma parte del club por lo que su uso es destinado exclusivamente para las actividades de aseo personal, resguardo de artículos deportivos y/o implementos de higiene, cualquier otro tipo de actividad diferente a éstas quedan prohibidas.\n</div><div>\n2. Queda estrictamente prohibido introducir cualquier tipo de bebidas en envases de cristal y metálicos. Así como también guardar comida, snacks, latas y/o contenedores de alimentos, en cualquiera de los lockers.\n</div><div>\n3. El uso de chanclas o sandalias en buenas condiciones es obligatorio en todas las áreas de vestidores y alberca. Active Club no se hace responsable por algún accidente provocado por la falta de las mismas.\n</div><div>\n4. Se prohíbe realizar cualquier tipo de compra-venta de artículos tales como: ropa, zapatos, joyería, substancias anabólicas, complementos dietéticos, lociones y demás.\n</div><div>\n5. Existen a disposición de los socios lockers de uso diario y sólo podrán ser usados durante el tiempo que permanezca el usuario en Active Club y sin costo alguno, de lo contrario la Gerencia podrá desalojar las pertenencias del locker. En ambos casos la Gerencia no asume ninguna responsabilidad sobre los objetos de valor (teléfonos celulares, carteras, tarjetas bancarias o comerciales, dinero en efectivo, joyas, relojes, dispositivos de música, juegos electrónicos, agendas o asistentes digitales, etc.) depositados en el locker.\n</div><div>\n6. Los lockers que se ofrecen están destinados exclusivamente para resguardar artículos de aseo personal y accesorios deportivos.\n</div><div>\n7. Los usuarios podrán hacer uso de los casilleros debiendo de traer su candado. En caso de dejar el candado en el locker al final del día, se romperá el mismo, retirando las pertenencias las cuáles serán colocadas en una bolsa de nylon, relacionando todo el contenido. En caso del olvido de la combinación del locker, se deberá de reportar a la Gerencia en turno quién aplicará el procedimiento correspondiente.\n</div><div>\n8. Los objetos desalojados, olvidados, así como los extraviados serán resguardados por Active Club por un lapso de 7 días, después de este tiempo se donarán dichos artículos a una institución de Beneficencia.\n</div><div>\n9. Para obtener el servicio de toallas en el área de recepción, es necesario realizar el pago correspondiente previamente en el área de caja y dejar en custodia la credencial del usuario que hará uso de la(s) toalla(s). En el caso de pérdida o que se manchen de grasa de zapato, tinte de cabello, etc.; se tendrá que pagar la cuota determinada por la Gerencia y deberá ser cubierta de inmediato, de lo contrario la Gerencia quedará facultada para interrumpir el acceso a las instalaciones a todos los miembros de la membresía.\n</div><div>\n10. En caso de no entregar la toalla el día correspondiente a su uso, será considerado como extravío y el usuario deberá cubrir la cuota determinada para tal situación por la Gerencia General.\n</div><div>\n11. Queda prohibido realizar cualquier tipo de comercio, rifas, tandas y vendimia dentro de las instalaciones de Active Club.\n</div><div>\n12. Los tickets para el uso de toallas tendrán una vigencia de 45 días naturales a partir de la fecha de compra.</div>\n<div>\n13. La secadora centrífuga será de uso exclusivo para trajes de baño, en caso de usarla para otro tipo de ropa el usuario será acreedor a una sanción administrativa y de reincidir será dado de baja. En caso de dañarla, el usuario deberá cubrir el costo de reparación y la sanción administrativa correspondiente.\n</div><div>14. Las secadoras únicamente podrán ser utilizadas para el secado del cabello.</div><div>\n15. No se permite el apartado de regaderas ni vestidores.</div><div>\n16. La plancha de vapor será para el uso exclusivo de planchado ropa (para el uso inmediato), siendo el usuario el responsable de realizar la acción. El staff del Club no podrá realizar éstas labor.\n</div><div>17. Queda prohibido enjabonarse fuera de las regaderas.</div><div>\n18. Las regaderas podrán ser ocupadas, solamente por una persona a la vez, exceptuando la situación de los adultos\n</div><div>responsables con sus niños.</div><div>\n19. Por beneficio de TODOS, el uso del agua deberá ser de forma racional y moderada.</div><div>\n20. Con el fin de brindarle mayor seguridad y mantener los pasillos secos, queda prohibido usar las regaderas con la puerta abierta.\n</div><div>\n21. Cualquier situación imprevista o no contemplada en este reglamento se sujeta a las resoluciones adoptadas por la Gerencia y deberá ser acatada por todos los usuarios sin excepción.\n</div><div><strong>Las edades permitidas para el uso de los vestidores son las siguientes:</strong></div><div>\nEn el caso de niñas y niños menores de 5 años podrán utilizar los vestidores del género de su mamá o de su papá según sea el caso.\n</div><div class=\"text-center\"><strong>REGLAMENTO PARA EL USO DEL VAPOR Y SAUNA (damas y caballeros):</strong></div>\n<div class=\"text-center\" style=\"text-decoration: underline\">Horario de servicio:</div><div class=\"text-center\">\nDe lunes a viernes: de 5:30 a 22:00 hrs.</div><div class=\"text-center\">\nSábados y domingos 7:30 a 16:00 hrs. y días festivos: de 7:30 a 14:00 hrs.</div><div>\n1. Queda estrictamente prohibido introducir bebidas alcohólicas, gaseosas, energizantes, así como envases de cristal y/o metálicos al vapor y sauna.\n</div><div>2. Se prohíbe hacer uso del vapor en estado etílico o de deshidratación.</div><div>\n3. Se prohíbe el uso de cremas, tratamientos cutáneos, lociones, tintes, esencias aromáticas, etc. dentro del vapor y/o sauna.\n</div><div>\n4. Prohibida la entrada al vapor y sauna a menores de 15 años de edad por aspectos fisiológicos (deshidratación)</div>\n<div>\n5. La regulación de la válvula de vapor, es responsabilidad del personal del área de vestidores, quedando prohibido a los usuarios la manipulación del equipo.\n</div><div>6. Por seguridad de todos, queda estrictamente prohibido enjabonarse, en esta área.</div><div>\n7. Queda prohibido la colocación de substancias aromáticas en la estufa del sauna, así como el colocar encima de la misma ropa mojada y/o verter cualquier tipo de líquido.\n</div><div>\n8. Por higiene y seguridad se prohíbe bañarse y/o aplicarse cualquier tipo de tratamiento facial o corporal (jabón, mascarillas, shampoo, aromatizantes, productos naturales, etc.) dentro del área de vapor o sauna.\n</div><div>\n9. Queda prohibido introducir al sauna periódicos o revistas para la lectura de los socios, siendo esta una medida preventiva para evitar algún conato de incendio.\n</div><div>\n10. Se prohíbe depilarse, rasurarse, cortarse las uñas, exfoliarse, etc. dentro del área de lockers, sauna y vapor.\n</div><div>\n11. El uso de chanclas o sandalias en buenas condiciones es obligatorio en todas las áreas de vestidores y alberca. Active Club no se hace responsable por algún accidente provocado por la falta de las mismas.\n</div><div>\n12. Queda estrictamente prohibido introducir cualquier tipo de prenda de vestir al sauna con la finalidad del secado de la misma.\n</div><div>\n13. Para el uso de sauna y vapor se recomienda una exposición máxima de 15 min, el exceder estos tiempos es responsabilidad del usuario e implicaría un riesgo elevado para su salud.\n</div><div>\n14. Queda estrictamente prohibido el uso del celular dentro del sauna y vapor así como también bocinas o cualquier tipo de artículo electrónico.\n</div><div>15. Por su propia seguridad, se prohíbe colocar papel mojado en el bulbo del cuarto de sauna.</div><div>\n16. Queda prohibido arrojar agua al sensor de temperatura del vapor y/o sauna.</div><div class=\"text-center\"><strong>\nREGLAMENTO DE ALBERCA:</strong></div><div class=\"text-center\" style=\"text-decoration: underline\">Horario de servicio:\n</div><div class=\"text-center\">Lunes a viernes de: 5:00 a 22:00hrs.</div><div class=\"text-center\">\nSábados y domingos 7:00 a 16:00 hrs. días festivos de: 7:00 a 14:00 hrs</div><div><strong>Vestimenta y/o uniforme:\n</strong></div><div>• Hombres:</div><div>\n- Es obligatorio el uso de traje de baño (sin ropa interior) y que este sea de licra o Polibutireno teleftalano (PBT). No se podrá ingresar con traje de baño de playa u otra índole.\n</div><div>• Mujeres:</div><div>\n- Es obligatorio que el traje sea de una sola pieza y que este sea de licra o Polibutireno teleftalano (PBT).</div>\n<div>• General:</div><div>\n1. El uso de gorra de natación es obligatorio para poder hacer uso de la alberca y deberá portarse en todo momento.\n</div><div>2. Se recomienda tener 2 horas de haber ingerido alimentos</div><div>\n3. Es obligatorio el uso de googles de natación y sandalias.</div><div>\n4. No se podrá hacer uso de playeras para nadar, su uso tendrá que ser respaldado por un justificante médico y ésta deberá ser una playera especializada tipo RASH GUARD de licra, PBT o poliéster de manga larga, con protector UV.\n</div><div>\n5. Ninguna persona ajena al staff puede ejercer la función como instructor, el usuario que sea sorprendido realizando cualquier instrucción o asesoría será sancionado, de reincidir podrá ser expulsado.\n</div><br><div><strong>Medidas de higiene para el uso de la alberca:</strong></div><div>\n1. Se deberá tomar una ducha en las regaderas de la alberca sin excepción alguna antes de entrar a la alberca.</div>\n<div>\n2. Queda estrictamente prohibido orinar en las duchas de alberca y dentro de la misma, en caso de que el usuario sea sorprendido, será causa de baja definitiva.\n</div><div>3. Queda estrictamente prohibido el uso de cremas corporales y bronceadores.</div><div>\n4. En el caso de las mujeres, queda estrictamente prohibido el uso de maquillaje para entrar a la alberca.</div><div>\n5. El usuario de la alberca deberá asegurarse que antes de entrar al agua, sus fosas nasales estén completamente libres de mucosidad.\n</div><div><strong>Consideraciones generales:</strong></div><div>\n1. La alberca forma parte de las instalaciones del club por lo que su uso es para la práctica de la natación en sus diferentes modalidades, otra actividad distinta a ésta, queda prohibida.\n</div><div>\n2. Todo usuario que se encuentre en la zona de la alberca deberá comportarse con orden y respeto, queda prohibido expresarse con palabras altisonantes, y/o vocabulario vulgar y prosaico, así como juegos bruscos que impliquen un contacto físico exagerado (luchas, hundirse uno al otro, golpes, “caballitos”, etc.), también quedan prohibidas las muestras efusivas de afecto que pudieran incomodar a otros socios.\n</div><div>\n3. El usuario que cuente con alguna lesión física, discapacidad, enfermedad deberá notificarlo al staff de la alberca.\n</div><div>4. Se recomienda comer 2 horas antes de realizar cualquier actividad dentro de la alberca.</div><div>\n5. No se podrá hacer uso de la alberca si se ingirió bebidas alcohólicas.</div><div>\n6. Ninguna persona deberá estar en el perímetro de la alberca, con vestimenta diferente a la propia para el uso de la alberca.\n</div><div>\n7. Es obligatorio acudir con el guardavida antes de ingresar a la alberca para que éste le indique en qué carril puede hacer uso de la misma, ya que el uso de carriles y su asignación dependerá de la operación del día y hora. La operación de la alberca queda bajo estricto control de Active Club y el staff del área.\n</div><div>\n8. El uso de los carriles es compartido, por lo que el nado es en circuito, circulando siempre del lado derecho del mismo.\n</div><div>9. Queda prohibido recargar el peso y/o subirse a los carriles.</div><div>\n10. Se prestará el material didáctico a todo usuario, mismo que deberá ser colocado en su lugar después de su uso.\n</div><div>11. Se deberá cuidar el material de la alberca; en caso de daño o desperfecto el usuario deberá pagarlo.\n</div><div>\n12. Queda prohibido introducir alimentos al área de la alberca; solo se permite el uso de agua y bebidas deportivas en recipiente de platico transparente.\n</div><div>\n13. No se permite introducir al área de la alberca maletas, mochilas, bolsas, etc. Solo podrán traer red de natación.\n</div><div>14. Queda prohibido introducir mascotas dentro del área de la alberca.</div><div>\n15. Las toallas como las batas de baño deberán ser colocadas en los percheros de la alberca.</div><div>\n16. Active Club no se hará responsable por el uso indebido de las instalaciones de la alberca sin tomar las precauciones necesarias.\n</div><div>\n17. La edad mínima para que un niño pueda permanecer solo en la alberca es de 12 años, el niño tiene que saber flotar.\n</div><div>\n18. Los niños de 1 año a 11 años 11 meses deben entrar a la alberca acompañados de un adulto miembro de la membresía que se haga responsable de su seguridad y de su comportamiento, un adulto podrá hacerse cargo de máximo dos menores.\n</div><div>19. Niños menores de tres años deben de usar pañal para alberca.</div><div>\n20. El staff de alberca está facultado para sancionar a los usuarios que incurran en conductas incorrectas en el área de la alberca, asentando por escrito la falta cometida y esta será entregada a la Gerencia del Club.\n</div><br><div><strong>Uso recreativo de la alberca:</strong></div><div>\n1. El horario recreativo será de 12:00 hasta las 17:00 horas de lunes a viernes. Sábados, domingos y días festivos será de 7:00 a 16:00 horas.\n</div><div>2. El staff de la alberca indicará cual será el carril para esta actividad.</div><div>\n3. Queda prohibido brincar a la alberca y/o toda clase de clavados.</div><div>\n4. Queda prohibido el uso de pelotas y balones.</div><div>\n5. El uso de juguetes será a consideración y autorización del staff de alberca.</div><br><div><strong>\nREGLAMENTO PARA ACADEMIA DE NATACIÓN:</strong></div><div>\n1. Es obligatorio acudir con el staff de alberca para registrarse en la academia de natación Active Club y agendar la evaluación técnica pertinente para que le sea asignado un grupo y nivel adecuado. De no llevar a cabo el registro y evaluación antes citados el usuario no podrá ingresar a una clase programada. El usuario tendrá la opción de hacer uso del carril asignados para nado libre.\n</div><div>\n2. Los menores que asistan a la academia de natación deberán llegar acompañados sin excepción alguna de un adulto responsable.\n</div><div>\n3. El staff de la academia de natación se reserva el derecho de asignar y cambiar instructores en función de la disponibilidad de éstos.\n</div><div>\n4. El staff de la academia de natación están facultados para fusionar, reasignar o eliminar grupos de acuerdo a la asistencia de los usuarios.\n</div><div>\n5. Los cambios de horarios se solicitarán con el guardavida, la aceptación de este se hará con base a la capacidad en los grupos.\n</div><div>\n6. Para todas las clases impartidas en el área de alberca existirá un tiempo de tolerancia de 5 minutos una vez iniciada la clase (según el reloj interno de la alberca de Active Club).\n</div><div>7. Todos los alumnos de la academia de natación deberán respetar el reglamento de la Alberca.</div><div>\n8. Se deberá asistir regularmente a la clase de la academia de natación, a partir de la tercera falta en un mes o bien, en caso de acumular más de 8 faltas en el cuatrimestre se dará de baja del grupo, reasignándole otro horario según la disponibilidad.\n</div><div>10. Se prohíbe permanecer en las instalaciones de la alberca con ropa y calzado de vestir.</div><div>\n11. Los padres de los niños deberán permanecer dentro de las instalaciones del club durante el tiempo de duración de la clase.\n</div><div>\n13. Cualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia y deberá de ser acatada por todos los socios sin excepción.\n</div><br><div><strong>SERVICIO DE NUTRICION:</strong></div><div>\n1. Los Nutriólogos e instructores de piso están capacitados para atender cualquier lesión o eventualidad que pudiera sufrir algún usuario dentro de las instalaciones. El personal tiene prohibido recetar o suministrar cualquier tipo de medicamento, emitir diagnóstico o tratamiento alguno a los usuarios de Active Club.\n</div><div>\n2. En el área de Nutrición, se realizará la valoración de la aptitud física, siendo necesario que el usuario de nuevo ingreso se realice la misma, posteriormente quedará a discreción del usuario realizar el seguimiento para conocer los avances obtenidos, siendo este un beneficio para todos.\n</div><div>3. Las citas para la valoración de la aptitud física se deberán agendar en el Sistema Deportivo Trainingym.\n</div><div>\n4. La cita de la valoración de la aptitud física tendrá un tiempo de tolerancia de 5 minutos, transcurrido ese tiempo, el usuario tendrá que agendar otra cita.\n</div><div>\n5. La valoración de la aptitud física se realizará a todos los usuarios que así lo deseen, esta tendrá un periodo de vigencia de 2 meses, al final del cual deberá de haber cubierto un 80% de cumplimiento del plan de acondicionamiento físico, agendando una nueva cita en la aplicación Sistema Deportivo Trainingym del gimnasio para continuar con su siguiente valoración. En caso de no cumplir el porcentaje requerido perderá el seguimiento de esta valoración, teniendo 2 opciones a) Retomar la valoración próxima pasada hasta cumplir el 80% de asistencia y la opción b) Que consiste en agendar una cita de valoración de la aptitud física con el costo marcado por la Gerencia del club. Al cumplir el porcentaje marcado su siguiente valoración no tendrá costo.\n</div><div>\n6. La valoración nutricional se agendará en el Sistema Trainingym y estará condicionada al cumplimiento del 80% del plan de acondicionamiento físico.\n</div><br><div class=\"text-center\"><strong>REGLAMENTO DE USO DEL AREA DE ACONDICIONAMIENTO FÍSICO:</strong></div><br>\n<div class=\"text-center\" style=\"text-decoration: underline\">Horario de servicio:</div><div class=\"text-center\">\nLunes a viernes: de 5:00 a 22:45 hrs.</div><div class=\"text-center\">\nSábados y domingo 7:00 a 16:45 y días festivos de: 07:00 a 14:45hrs.</div><div><strong>Vestimenta o uniforme:</strong>\n</div><div>\n1. Se permite el acceso con ropa deportiva (pants, playera, sudadera, licras, leotardo, shorts, mallas, zapatos tenis, calcetas deportivas).\n</div><div>\n2. Es obligatorio utilizar toalla limpia personal para el uso del gimnasio, siendo este implemento parte del uniforme, utilizándose para secar la transpiración del cuerpo y el sudor dejado en aparatos e implementos utilizados.\n</div><div>3. El gimnasio brindara el servicio de renta de toalla el cual tendrá un costo.</div><div><strong>Reglas:\n</strong></div><div>\n1. Los instructores asignados están facultados para suspender o restringir el acceso al gimnasio a toda persona que falte al presente reglamento (por desaseo personal, lenguaje ofensivo, etc.).\n</div><div>2. Está prohibido colgar prendas u objetos en los aparatos y/o cualquier implemento del gimnasio.</div><div>\n3. El acceso al gimnasio es exclusivo para el de acondicionamiento físico, el usuario deberá de registrar su actividad realizada y validarla con los instructores para darle seguimiento a su programa en base al sistema Active Club.\n</div><div>4. Está prohibido apartar cualquier aparato, implemento o accesorio del gimnasio.</div><div>\n5. Queda prohibido el uso de mancuernas o pesas mientras se usa cualquier aparato para ejercicio cardiovascular (elíptica, caminadora, escalera sin fin, bicicleta, etc.)\n</div><div>6. El uso de los aparatos cardiovasculares será de 30 minutos máximo por persona sin excepción alguna.</div>\n<div>\n7. Está prohibido el uso de todo tipo de sustancias para el cuerpo (cremas, lociones, lubricantes colorantes, hot stof) así como fajas térmicas y/o chalecos para sudar, etc.\n</div><div>\n8. Queda prohibido por parte de los entrenadores y profesores de clases dirigidas ofrecer entrenos personales a los usuarios o visitantes del Active Club.\n</div><div>9. Por seguridad del desarrollo físico se restringe el acceso a menores de 13 años.</div><div>\n10. Se prohíbe el acceso al gimnasio con maletas, equipos de sonido, etc.</div><div>\n11. Esta estrictamente prohibido fumar, ingerir alimentos y bebidas de cualquier índole (a excepción de bebidas hidratantes y agua natural en envases de plástico y/o cilindros).\n</div><div>\n12. Se sancionará al usuario que retire o desplace algún equipo de esta área, así como hacer mal uso o dañarlo. Para lograr un mejor servicio e imagen del gimnasio se deberá de colocar en su lugar el equipo que se utilice (barras, mancuernas, etc.).\n</div><div>13. Se prohíbe utilizar los aparatos para una función que no sea estipulada en el instructivo del mismo.\n</div><div><br></div><div><strong>Por seguridad:</strong></div><div>\n1. Se recomienda realizar una consulta a su médico particular antes de iniciar cualquier programa de ejercicios. Es de importancia recordar que el club no asume responsabilidad alguna por lesiones o problemas de orden médico.\n</div><div>\n2. Los instructores tienen prohibido vender o recomendar medicamentos, sustancias anabólicas y complementos dietéticos.\n</div><div>3. Si desconoce el uso de los aparatos pida asesoría a los instructores encargados.</div><div>\n4. La selección de audio y video del área del gimnasio queda estrictamente a cargo de la gerencia, no pudiendo hacer ningún cambio a petición de los usuarios.\n</div><div>\n5. Todos los usuarios que realicen su entrenamiento en el gimnasio; deberán de contar con el formato de entrenamiento en el cual se incluirán los datos más relevantes de su valoración de la aptitud física (realizada previamente). Cualquier situación especial de salud o lesión deberá de ser reportada al personal del área.\n</div><div>\n6. Será obligatorio el uso de una toalla facial personal, en caso contrario no se permitirá el acceso al área.</div>\n<div>\n7. Después de usar cualquier aparato es obligatorio limpiarlo con las toallas húmedas desinfectantes que se encuentran en diversos puntos del gimnasio.\n</div><div>\n8. Es obligatorio que los usuarios regresen a su lugar el equipo (barras, mancuernas y equipo en general) que empleen en la ejecución de su rutina de entrenamiento.\n</div><div>9. Queda estrictamente prohibido el acceso al área con carriolas.</div><div>\n10. Ninguna persona ajena al staff puede ejercer la función como instructor, el usuario que sea sorprendido realizando cualquier instrucción o asesoría será sancionado, de reincidir podrá ser expulsado.\n</div><div>\n11. No podrán permanecer en el gimnasio las personas o usuarios que no estén realizando alguna actividad de acondicionamiento físico.\n</div><div>\n12. El staff de Active Club queda facultado para hacer cumplir el reglamento a los usuarios que incurran en conductas incorrectas, reportando a la Gerencia por escrito la falta cometida, anexándose al expediente de la membresía.\n</div><div>\n13. Active Club se reserva el derecho de cambiar los instructores y los horarios de los mismos cuando así lo requiera el servicio.\n</div><div>\n14. Todos los usuarios deberán alternar y compartir al hacer uso de los aparatos y equipos. Queda prohibido apartar los mismos.\n</div><div>\n15. Active Club no se hace responsable por objetos olvidados y/o extraviados dentro del área de acondicionamiento físico.\n</div><div>\n16. Todos los socios deberán de presentarse en el área con las condiciones de aseo personal mínimas (uso de antitranspirante y/o desodorante, ropa limpia). Esto con el objetivo de generar un entorno limpio, higiénico y agradable para todos.\n</div><div>\n17. Cualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia y deberá de ser acatada por todos los socios sin excepción.\n</div><div><br></div><div><strong>REGLAMENTO DE SPINNING:</strong></div><div>\n1.Se deberá utilizar ropa adecuada para la práctica de esta actividad.</div><div>\n2. Para asistir a la clase deberá el usuario reservar su lugar en la aplicación del Sistema Deportivo Trainingym</div>\n<div>\n3. Todos los usuarios deberán de presentarse en el área con las condiciones de aseo personal mínimas (uso de antitranspirante y/o desodorante, ropa limpia). Esto con el objetivo de generar un entorno limpio, higiénico y agradable para todos.\n</div><div>4. Queda estrictamente prohibido introducir alimentos en el área de Spinning.</div><div>\n5. Sólo se podrán introducir agua y bebidas hidratantes en envase de plástico con tapa.</div><div>\n6. No se podrán introducir maletas y/o bolsas voluminosas al área de trabajo.</div><div>\n7. El tiempo de tolerancia para entrar a las clases una vez iniciadas será de 10 minutos, transcurrido ese tiempo no se permitirá el acceso.\n</div><div>8. No está permitido apartar bicicletas.</div><div>\n9. El acceso a las clases de Spinning se permitirá a partir de los 12 años de edad.</div><div>\n10. Cualquier desperfecto por maltrato a las bicicletas será responsabilidad del usuario debiendo cubrir el monto del daño ocasionado.\n</div><div>\n11. Active Club se reserva el derecho de cambiar sin previo aviso, por causas de fuerza mayor, el instructor, el horario y el tipo de clase.\n</div><div>\n12. Cualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia General y deberá ser acatada por todos los socios sin excepción\n</div><div><br></div><div><strong>REGLAMENTO DE BOX:</strong></div><div>\n1. Se deberá utilizar la ropa adecuada para la práctica de esta actividad, queda prohibido el acceso con zapatos de calle.\n</div><div>\n2. Todos los usuarios deberán de presentarse en el área con las condiciones de aseo personal mínimas (uso de antitranspirante y/o desodorante, ropa limpia). Esto con el objetivo de generar un entorno limpio, higiénico y agradable para todos.\n</div><div>\n3. Queda estrictamente prohibido introducir alimentos, permitiéndose el acceso con agua y/o bebidas hidratantes en envase de plástico con tapa, queda prohibido el acceso de cualquier accesorio que ponga en riesgo la integridad de los usuarios.\n</div><div>\n4. Para la práctica de este deporte es necesario el uso de vendajes las cuales deben ser adquiridas por el usuario.\n</div><div>\n5. Está prohibido el uso de todo tipo de sustancias para el cuerpo (cremas, lociones, lubricantes colorantes, hot stof) así como fajas térmicas y/o chalecos para sudar, etc.\n</div><div>\n6. Ninguna persona ajena al staff puede ejercer la función como instructor, el usuario que sea sorprendido realizando cualquier instrucción o asesoría será sancionado, de reincidir será expulsado.\n</div><div>\n7. El tiempo de tolerancia para que los usuarios puedan entrar a las clases será de 10 minutos, transcurrido ese tiempo el profesor no permitirá el acceso, esto como medida de seguridad para los participantes.\n</div><div>\n8. La práctica de esta actividad es exclusivamente deportiva (sin contacto), no podrá ser utilizada para otro fin</div>\n<div>\n9. El uso irresponsable del equipo que tenga como consecuencia el deterioro de los mismos será responsabilidad del usuario, quien deberá de cubrir el daño respectivo.\n</div><div>\n10. Active Club queda facultado para amonestar por escrito a los usuarios que incurran en conductas incorrectas en el área donde se imparta esta actividad.\n</div><div>11. Active Club se reserva el derecho de cambiar horarios e instructor cuando así se requiera.</div><div>\n12. Los accesorios para llevar a cabo la práctica de esta disciplina deberán ser adquiridos por el usuario.</div><div>\n13. Cualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia y deberá de ser acatada por todos los socios sin excepción.\n</div><div><br></div><div><strong>REGLAMENTO DE USO DE LOS SALONES PARA ACTIVIDADES GRUPALES:</strong></div><div>\n1.	Se deberá utilizar la ropa adecuada para la práctica de la actividad impartida, queda prohibido el acceso con zapatos de calle.\n</div><div>\n2.	Es obligatorio utilizar toalla limpia personal para el uso de los salones para actividades grupales, utilizándose para secar la transpiración del cuerpo y el sudor dejado en éstos. Queda prohibido limpiarse el sudor en las paredes, cristales y/o implementos de los mismos, debiendo utilizar las toallas húmedas sanitizantes colocadas en el salón.\n</div><div>\n3.	Todos los usuarios deberán de presentarse en el área con las condiciones de aseo personal mínimas (uso de antitranspirante y/o desodorante, ropa limpia). Esto con el objetivo de generar un entorno limpio, higiénico y agradable para todos.\n</div><div>4.	Queda estrictamente prohibido introducir alimentos a los salones.</div><div>\n5.	Sólo se podrán introducir bebidas hidratantes en envase plástico con tapa.</div><div>\n6.	No se podrán introducir maletas y/o bolsas voluminosas al salón.</div><div>\n7.	El tiempo de tolerancia para entrar a las clases será de 10 minutos, transcurrido ese tiempo no se permitirá el acceso.\n</div><div>8.	No está permitido apartar lugares o espacios en cualquiera de las clases impartidas.</div><div>\n9.	Al término de cada clase los usuarios deberán abandonar el salón para permitir el acceso del personal de limpieza.\n</div><div>\n10.	En clases que requieran el uso de equipo, cada persona se hará responsable del uso del mismo y de colocar el equipo en el lugar asignado al término de la clase.\n</div><div>\n11.	La Gerencia determinará el cupo de cada clase y no podrá haber más participantes que los designados para cada actividad.\n</div><div>12.	El acceso a las clases dirigidas se permitirá a partir de los 12 años.</div><div>\n13.	Las clases dirigidas tendrán una duración de 50 minutos.</div><div>\n14.	No se permitirá permanecer dentro del salón si no hay clase o instructor.</div><div>\n15.	Active Club no se hace responsable por objetos olvidados y/o extraviados dentro de los salones.</div><div>\n16.	Queda estrictamente prohibido el acceso a niños menores de 12 años, aun cuando estén acompañados por un adulto.\n</div><div>\n17.	Active Club se reserva el derecho de cambiar sin previo aviso, por causas de fuerza mayor, el instructor, horario y tipo de clase.\n</div><div>\n18.	Cualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia y deberá de ser acatada por todos los socios sin excepción.\n</div><div><br></div><div><strong>REGLAMENTO DE ENTRENAMIENTO FUNCIONAL:</strong></div><div>\n1. Después de usar cualquier implemento es obligatorio colocarlo en su lugar.</div><div>\n2. Por su seguridad e higiene es obligatorio utilizar la ropa adecuada (conjuntos deportivos de algodón, licra y/o telas sintéticas deportivas), queda estrictamente prohibido hacer ejercicio con ropa de mezclilla, gabardina, zapatos de calle, sandalias y/o cualquier calzado que no sea el adecuado.\n</div><div>\n3. Todos los usuarios deberán de presentarse en el área con las condiciones de aseo personal mínimas (uso de antitranspirante y/o desodorante, ropa limpia). Esto con el objetivo de generar un entorno limpio, higiénico y agradable para todos.\n</div><div>\n4. Está prohibido el uso de todo tipo de sustancias para el cuerpo (cremas, lociones, lubricantes colorantes, hot stof) así como fajas térmicas y/o chalecos para sudar, etc.\n</div><div>\n5. Queda estrictamente prohibido introducir todo tipo de alimentos y envases de vidrio, bebidas calientes, en lata o en envases sin tapa para evitar derrames en el área.\n</div><div>6. No se podrán introducir maletas, back packs y/o bolsas voluminosas al área.</div><div>\n7. Se prohíbe el uso indebido del equipo o instalaciones del área; que motiven el deterioro y/o destrucción del mismo.\n</div><div>8. Queda estrictamente prohibido el acceso al área con carriolas.</div><div>\n9. Ninguna persona ajena al staff de instructores puede ejercer la función como tal, el usuario que sea sorprendido realizando cualquier instrucción o asesoría será sancionado.\n</div><div>10. La edad mínima para ingresar a clases de entrenamiento funcional, de manera general, será de 12 años.\n</div><div>\n11. El staff de Active Club queda facultado para hacer cumplir el reglamento a los socios que incurran en conductas incorrectas, reportando a la Gerencia por escrito la falta cometida, anexándose al expediente de la membresía.\n</div><div>\n12. Active Club se reserva el derecho de cambiar los instructores y los horarios de los mismos cuando así lo requiera el servicio.\n</div><div>13. Queda prohibido apartar los implementos y/o accesorios.</div><div>\n14. Active Club no se hace responsable por objetos olvidados y/o extraviados dentro del área de entrenamiento funcional.\n</div><div>\n15. Cualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia de Active Club y deberá de ser acatada por todos los socios sin excepción.\n</div><div><br></div><div><strong>GENERALIDADES:</strong></div><div>\n1. La Gerencia establecerá las normas técnicas o deportivas para el mejor aprovechamiento de todas las instalaciones de Active Club por parte de los usuarios y de sus invitados.\n</div><div>\n2. Todos los reglamentos son susceptibles de modificaciones o adiciones por parte de la Gerencia cuando se juzgue que estas reformas resulten convenientes para la mejor operación de Active Club.\n</div><div>\n3. Active Club queda facultada para expedir circulares y normas internas que deben ser acatadas por los usuarios e invitados.\n</div><div>\n4. La facultad de interpretación de los reglamentos y aplicación de sanciones pertenece exclusivamente a la Gerencia de Active Club.\n</div><div>\n5. Las modificaciones o adiciones que se hagan a las disposiciones reglamentarias serán comunicadas a los usuarios.\n</div><div>\n6. Cualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia y deberá de ser acatada por todos los usuarios sin excepción.\n</div></div><div class=\"risks\" style=\"padding-top: 2px; padding-bottom: 2px text-center\"><table \nclass=\"regulation-content-terms-table\"><tr><td class=\"title w-300\" style=\"vertical-align: top; text-align: center\"><div\n class=\"regulation-signature\"><img src=\"assets/images/signature_jahs.png\" width=\"100\" height=\"100\"><br>\n________________________________________________<div class=\"regulation-signature-data\"><p>\nGERENTE GENERAL ANTONIO HERNANDEZ</p><p>EL PRESTADOR</p></div></div></td><td class=\"title w-300\" \nstyle=\"vertical-align: top; text-align: center\"><div class=\"regulation-signature\"><div style=\"height: 40px\"></div><img \nng-src=\"{{vm.signatureSrc}}\"><br>________________________________________________<div \nclass=\"regulation-signature-data\"><p>{{vm.data.partnerName}}</p><p>TITULAR</p></div></div></td></tr></table></div>\n</div><div class=\"dummy-print\"></div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/contract/contract-urban.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button><md-button class=\"md-icon-button\" \nflex ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Guardar</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.showSignature($event)\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon><md-tooltip>Firmar</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.sendByEmail()\" ng-disabled=\"vm.sendingEmail\"><md-icon md-font-icon=\"icon-email\" \nng-show=\"!vm.sendingEmail\"></md-icon><md-icon md-font-icon=\"icon-dots-horizontal\" ng-show=\"vm.sendingEmail\"></md-icon>\n<md-tooltip>Enviar por email</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.getLastData()\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon><md-tooltip>Obtener datos nuevamente</md-tooltip></md-button></div><div \nid=\"complete-document\" class=\"card md-whiteframe-8dp\"><div class=\"titulo-centrado-normal\"><img id=\"img-logo\" \nng-src=\"{{vm.logoSource}}\" class=\"imglogo\"></div><div class=\"contract-table-footer\"><strong>\nCONTRATO DE PRESTACIÓN DE SERVICIOS QUE CELEBRAN, POR UNA PARTE, {{vm.data.partnerName}}, POR SU PROPIO DERECHO (EN LO SUCESIVO, EL \"USUARIO\"), Y POR LA OTRA PARTE GABRIELA MARQUEZ SABAG.,] REPRESENTADA EN ESTE ACTO POR GABRIELA MARQUEZ SABAG (EN LO SUCESIVO, \"URBAN FITNESS\"), AL TENOR DE LAS SIGUIENTES DECLARACIONES Y CLAUSULAS:\n</strong></div><br><div class=\"titulo-centrado-normal\">DECLARACIONES</div><br><div>\nI. Declara el Usuario, por su propio derecho, que:</div><br><div>\n(a) Es una persona física, con plena capacidad legal para celebrar este Contrato y cumplir con las obligaciones derivadas del mismo de conformidad con sus términos.\n</div><br><div>\n(b) Es su voluntad contratar los servicios de Urban Fitness sujeto a los términos y condiciones de este Contrato.</div>\n<br><div>(c) Toda la información establecida en este Contrato, incluyendo la carátula es verdadera y correcta.</div>\n<br><div>II. Declara Urban Fitness, a través de su representante, que:</div><br><div>\n(a) Es una persona física con actividad empresarial, creada de conformidad con las leyes de los Estados Unidos Mexicanos y que cuenta con la capacidad suficiente para contratar en los términos del presente Contrato.\n</div><br><div>\n(b) Su representante cuenta con todas las facultades necesarias para la celebración del presente Contrato, mismas que no le han sido revocadas ni limitadas en forma alguna a la fecha de firma del presente Contrato.\n</div><br><div><strong>VIRTUD DE LO ANTERIOR</strong>\n y en consideración de los acuerdos mutuos contenidos en el presente Contrato, las partes acuerdan y convienen conforme a las siguientes:\n</div><br><div class=\"titulo-centrado-normal\">CLÁUSULAS:</div><br><div>\nPRIMERA. OBJETO. Urban Fitness prestará al Usuario (en lo sucesivo cualquier referencia al \"Usuario\" de la inscripción, en su caso) los servicios descritos en la Cláusula Segunda, durante la vigencia de este Contrato. El Usuario se obliga a pagar a Urban Fitness en términos de la Cláusula Tercera de este Contrato una cuota de inscripción y una cuota de mantenimiento mensual o, en su caso, anual por la prestación de dichos servicios.\n</div><br><div>\nSEGUNDA. SERVICIOS. Urban Fitness prestará al Usuario en las instalaciones del gimnasio operado bajo la marca Urban Fitness según datos de carátula, los servicios deportivos que ofrece actualmente a sus usuarios en general, los cuales podrán ser modificados o adicionados de tiempo en tiempo (los \"Servicios Deportivos\"). Lo anterior, de conformidad con los términos y condiciones previstos en el presente Contrato\n</div><br><div>\nTERCERA. CUOTAS. Como contraprestación por los Servicios Deportivos, el Usuario se obliga a pagar a Urban Fitness las siguientes cuotas:\n</div><br><div>\n1. Cuota de inscripción, cuyo monto, condiciones y forma de pago se establecen en la carátula del presente Contrato.\n</div><br><div>\n2. Cuota de mantenimiento, que deberá pagarse de manera anual o mensual, de conformidad con lo siguiente:</div><br>\n<div><strong>Cargo/Cuota Anual.</strong> Es la cuota anual vigente que se cobra en una sola exhibición. <u>\nEn esta cuota/forma de pago no existirá reembolso o devolución de cantidad alguna pagada, toda vez que se está adquiriendo/pagando una cuota preferencial, y por ende tiene dicha restricción.\n</u>\n El pago de esta cuota puede realizarse mediante cheque, transferencia, depósito a cuenta de Urban Fitness (en dicho caso deberá solicitarse de forma previa datos para pago), efectivo, tarjeta de crédito o débito, o cualquier otro medio/forma \n<u>siempre y cuando, así se indique por Urban Fitness para efectos de pago.</u>\n Lo anterior, atendiendo a las opciones de medios registrados de cobro- y que así se señale en la que el pago diga Urban Fitness y el numero de usuario.\n</div><br><div><strong>Cargo/Cuota Mensual Direccionado.</strong>\n Es la cuota vigente que se cobra de manera automática por Urban Fitness y es cargada a una tarjeta de crédito. El Usuario reconoce que el cargo mensual direccionado tiene cuotas preferenciales sobre las cuotas/cargos convencionales. En caso de que el Usuario desee cancelar su inscripción o desee cambiar la forma de pago de su cuota mensual direccionado a cargo/cuota mensual convencional, éste deberá acudir a la recepción (área de front) del gimnasio en cuestión para realizar los trámites correspondientes. El Usuario acepta que la modalidad de cargo mensual direccionado podrá ser cancelada en cualquier momento por Urban Fitness.\n</div><br><div><strong>Cargo/Cuota Mensual Convencional.</strong>\n Es la cuota vigente que tiene lugar mediante el pago por parte del Usuario en caja (área de front). El pago de esta cuota puede realizarse mediante cheque, transferencia, depósito a cuenta de Urban Fitness (en dicho caso deberá solicitarse de forma previa datos para pago), efectivo, tarjeta de crédito o débito, o cualquier otro medio/forma \n<u>siempre y cuando, así se indique por Urban Fitness para efectos de pago.</u>\n Lo anterior, atendiendo a las opciones de medios registrados de cobro- y que diga Urban Fitness y el numero de usuario.\n</div><br><div>\nEn caso de que el Usuario desee realizar cualquier cambio con respecto a su inscripción o medio de pago, ya sea cancelar su inscripción o desee autorizar el cargo mensual direccionado, éste deberá acudir a la recepción (área de front) de Urban Fitness y el número de usuario para realizar los trámites correspondientes.\n</div><br><div>\nPara el caso de cargos/cuotas mensuales-el Usuario deberá pagar dichas las cuotas de mantenimiento mensual, dentro de los primeros 3 (TRES) días naturales de cada mes calendario, pudiendo gozar además, de una tarifa preferencial.- para el caso que exista y así aplique.- con respecto a la tarifa regular/ordinaria de cuota de mantenimiento vigente al momento del cobro. En caso de que el pago no se realice dentro de los primeros 3 (TRES) días del mes, Urban Fitness cobrará la cuota de mantenimiento regular/ordinaria vigente (atendiendo a precio de lista). Durante los últimos meses del año, Urban Fitness dará a conocer al Usuario, mediante comunicados que serán colocados en los pizarrones de avisos que se encuentran en diversas áreas del Gimnasio, las nuevas cuotas de mantenimiento que estarán vigentes a partir del mes de diciembre de ese mismo año. En casos extraordinarios Urban Fitness podrá determinar aumentos de cuotas de mantenimiento en otros periodos del año. Así mismo, cualquier otro ajuste de precio/tarifa con respecto a otros servicios proporcionados por Urban Fitness, serán notificados al Usuario mediante dichos comunicados.\n</div><br><div>\nCUARTA. CARGOS A TARJETA DE CRÉDITO. En caso de que el Usuario, de conformidad con la opción seleccionada en la carátula de este Contrato, haya elegido el pago de la cuota de mantenimiento mediante cargo direccionado, en este acto el Usuario expresamente autoriza a Urban Fitness para que, automáticamente y sin necesidad de alguna otra autorización, cargue mensualmente la cuota mensual vigente a cuenta de la tarjeta de crédito mencionada en dicha carátula. El Usuario autoriza que Urban Fitness realice el cargo de la cuota de mantenimiento direccionado durante los primeros 3 (TRES) días naturales de cada mes. Si por insuficiencia de fondos o crédito, imputables al Usuario, Urban Fitness no puede realizar el cargo en dicho plazo, el Usuario autoriza a Urban Fitness a realizar el cargo de dicha cuota de mantenimiento sin beneficio alguno relativo a cuota de mantenimiento preferencial. En adición y para el caso de que Urban Fitness no pueda realizar dicho cargo en repetidas ocasiones, por causas ajenas a Urban Fitness, no se le respetará al Usuario la cuota de mantenimiento direccionada y se le cobrará la cuota de mantenimiento convencional que esté vigente al momento del cobro. El Usuario reconoce que Urban Fitness está facultado para cargar los ajustes a las cuotas de mantenimiento que sean notificadas al Usuario de conformidad con la Cláusula Tercera.\n</div><br><div>\nQUINTA. FALTA DE PAGO. La administración de Urban Fitness está facultada para negar el acceso en caso de que presente un adeudo de la cuota de mantenimiento o algún otro adeudo, tomándose esta medida según la opción de pago que se haya elegido: Pago de mantenimiento/cuota mensual: Se negará el acceso a partir del día 4 (CUATRO) del mes corriente/calendario que no se haya pagado. Es decir; si hoy es 4 de marzo y no ha sido cubierta la cuota de mantenimiento del mes de marzo, la administración estará facultada para negar el acceso del gimnasio en cuestión, hasta recibir el pago de dicho mes.\n</div><br><div>\nRecargos: En caso de que el usuario no realice el pago correspondiente de su mantenimiento después del día 3 de cada mes se genera un interés mensual del 5% acumulable por mes.\n</div><br><div>\nSEXTA. REGLAMENTO Y NORMAS INTERNAS. El Usuario declara a Urban Fitness que conoce, entiende y acepta, el Reglamento \" Urban Fitness \" (en lo sucesivo, el \"Reglamento\") en su totalidad, mismo que le(s) es entregado en esta misma fecha por Urban Fitness (de forma física o digital) y cuya recepción se confirma mediante la firma del presente. El Usuario se obliga en todo momento a cumplir con las disposiciones del Reglamento, así como a cumplir con todos los términos y condiciones de circulares, políticas y normas internas que de tiempo en tiempo Urban Fitness determine para el uso de sus instalaciones y del equipo deportivo ubicado en dichas instalaciones. El Usuario reconoce y acepta que en caso de que, ocurra algún incumplimiento por parte del Usuario a las disposiciones del Reglamento, circulares, políticas y normas internas, Urban Fitness tiene el derecho de cancelar inmediatamente la inscripción y el acceso del Usuario, sin responsabilidad alguna Urban Fitness y sin que éste tenga que reembolsar cantidad alguna al Usuario.\n</div><br><div>SÉPTIMA. RESPONSABILIDAD.</div><br><div>\n(a) Urban Fitness no se hace responsable por la pérdida total o parcial de cualquier objeto o valor ocurrida dentro de sus instalaciones.\n</div><br><div>\n(b) El Usuario reconoce y declara que se encuentra en buen estado de salud y asume cualquier riesgo derivado de enfermedades o problemas de salud presentes o futuros.\n</div><br><div>\n(c) El Usuario reconoce y acepta que las instalaciones del gimnasio en cuestión y el equipo deportivo ubicado en dichas instalaciones son peligrosos por sí mismos (por su naturaleza) y, por lo tanto, existen riesgos inherentes a la participación del Usuario en actividades deportivas. El Usuario acepta, bajo su propia y exclusiva responsabilidad, su participación en dichas instalaciones.\n</div><br><div>\n(d) El Usuario se obliga a responder del daño que éste provoque a cualquier tercero, obligándose, a su propio costo, a sacar en paz y a salvo a Urban Fitness, sus afiliadas, subsidiarias, accionistas, consejeros, directores, empleados y/o asesores, de cualquier demanda y/o reclamación presentada en su contra, liberándolos en este acto de toda responsabilidad por dicho daño.\n</div><br><div>\n(e) Asimismo, el Usuario asume el riesgo total (incluyendo riesgos previsibles y no previsibles) y la responsabilidad derivada de su participación, así como el daño, lesión o enfermedad causados a los mismos por participar en eventos deportivos organizados por Urban Fitness, así como por sus afiliadas o subsidiarias fuera de las instalaciones de Urban Fitness, liberando en este acto de toda responsabilidad de cualquier naturaleza a Urban Fitness, así como a sus afiliadas, subsidiarias, accionistas, consejeros, directores, empleados y/o asesores por dicho daño, derivada de dicho daño, lesión o enfermedad.\n</div><br><div>\nOCTAVA. SEGUROS. Seguro de Responsabilidad Civil. Urban Fitness cuenta con un seguro de responsabilidad civil por daños y perjuicios ocasionados a terceros, dentro de las instalaciones del gimnasio en cuestión, conforme a la legislación aplicable en materia de responsabilidad civil vigente en los Estados Unidos Mexicanos. Lo anterior, de conformidad con la cobertura, monto asegurado, alcances y demás términos y condiciones establecidos en la póliza de seguro que para tales efectos tenga contratada Urban Fitness con una compañía de seguros.\n</div><br><div>\nNOVENA. DURACIÓN. El Usuario podrá hacer uso de las instalaciones y de los Servicios Deportivos proporcionados por Urban Fitness mientras se encuentre al corriente en el pago de las cuotas de mantenimiento correspondientes y cualesquier otras cantidades adeudadas a favor de Urban Fitness, de conformidad con lo establecido en este Contrato.\n</div><br><div>\nDÉCIMA. AUSENCIA. En caso de que el Usuario requiera ausentarse por un lapso de al menos UN mes, éste podrá solicitar la aplicación para pago de la \n<u>cuota de ausencia.</u>\n Lo anterior de conformidad con lo establecido para tales efectos en el Reglamento. La solicitud en cuestión deberá realizarse en la recepción (área de front) del gimnasio a más tardar el día 25 de cada mes calendario, en la inteligencia de que, la cuota de ausencia aplicará/será efectiva, en el mes calendario inmediato siguiente.\n</div><br><div>\nDÉCIMA PRIMERA. RELACIÓN ENTRE LAS PARTES. El presente Contrato es un contrato de prestación de servicios y de ninguna manera deberá considerarse que el mismo crea o constituye una relación laboral, coinversión, asociación, sociedad o acuerdo similar entre las partes, por lo que cada parte es y deberá ser independiente y únicamente responsable por sus obligaciones frente a terceros (incluyendo a sus respectivos empleados), así como por cualquier obligación de carácter civil, laboral, administrativo o fiscal.\n</div><br><div>\nDÉCIMA SEGUNDA. NOTIFICACIONES Y AVISOS. Toda notificación u otra comunicación requerida o permitida conforme al presente Contrato se realizará por escrito. En caso de que la notificación sea dirigida a Urban Fitness, ésta se entregará personalmente por el Usuario en la recepción (área de front) del gimnasio, a la atención de Urban Fitness como lo indica en la carátula de este Contrato.\n</div><br><div>\nDÉCIMA TERCERA. CESIÓN. Urban Fitness tiene el derecho de ceder en cualquier momento todos sus derechos y obligaciones bajo el presente Contrato. El Usuario no podrá ceder sus derechos y obligaciones bajo el presente Contrato, salvo en el caso de fallecimiento del Usuario titular, en cuyo caso sus derechos bajo el presente Contrato podrán cederse al cónyuge o alguno de los hijos integrantes de la inscripción, requiriendo realizar los trámites indicados por la administración de Urban Fitnes.\n</div><br><div>\nDÉCIMA CUARTA. REVOCACIÓN DE CONSENTIMIENTO. Durante un lapso de 5 (cinco) días hábiles contados a partir de la fecha de celebración de este Contrato, el Usuario tendrá el derecho de revocar su consentimiento mediante un aviso por escrito entregado personalmente en el área de recepción/front del gimnasio en cuestión de Urban Fitness. Lo anterior, aplicará \n<u><em>siempre y cuando</em></u>\n, el pago de cuotas de mantenimiento mensuales pactada en el contrato sea convencional o direccionado. En ese caso, se le reembolsará al Usuario hasta el 80% (ochenta por ciento) del importe pagado como cuota de inscripción. \n<u>No se hará devolución alguna sobre cuotas de mantenimiento pagadas.</u></div><br><div>\nNo obstante lo anterior, en el evento en que la celebración del presente contrato sea resultado de un proceso de reactivación, para el caso de que exista una cancelación por parte del Usuario a la inscripción en un lapso menor a 3 (TRES) meses contados a partir de la reactivación, existiendo a esa fecha, algún incumplimiento de pago por parte del Usuario con respecto a Urban Fitness, el Usuario perderá su derecho a cualquier cuota promocional aunado a que, el Usuario: (a) deberá cubrir en esa fecha o en la que así sea requerido, cualquier adeudo que exista a favor de Urban Fitness. En caso contrario, se generarán los recargos que en su caso correspondan hasta la fecha del pago total del adeudo; y (b) el Usuario no será acreedor para efectos de recibir reembolso o devolución de pago alguno que en su momento haya realizado a favor de Urban Fitness. Lo anterior, sin importar la fecha en que se haya celebrado el contrato correspondiente a la inscripción en cuestión.\n</div><br><div>\nDÉCIMA QUINTA. CIERRE DE INSTALACIONES. El Usuario reconoce que los días 1° de enero 24, 25 y 31 de diciembre, Urban Fitness no dará servicio permaneciendo sus instalaciones cerradas. Así mismo, el Usuario reconoce y acepta que Urban Fitness puede modificar sus horarios de operación o cerrar sus instalaciones, por \n<u>causas de fuerza mayor</u>\n o, en su caso, por eventos organizados a favor de los usuarios o del staff de Urban Fitness. Dichos cierres de instalaciones serán informados a los Usuarios atendiendo a los medios físicos o tecnológicos disponibles; en la inteligencia de que, los cierres de instalaciones por causas de fuerza mayor no generan responsabilidad alguna a cargo de Urban Fitness.\n</div><br><div>\nDÉCIMA SEXTA. ANEXOS. La carátula y cualesquier documentos adjuntos al presente Contrato son parte integral del presente Contrato, tal y como si estuviesen aquí reproducidos, y se considerará que toda referencia que se haga al presente Contrato incluye dichos documentos.\n</div><br><div>\nDÉCIMA SÉPTIMA. MODIFICACIONES. Salvo por los ajustes a las cuotas de mantenimiento y otros ajustes de precios que Urban Fitness notifique al Usuario mediante comunicados que serán colocados en los pizarrones de avisos que se encuentran en diversas áreas del gimnasio, este Contrato únicamente podrá ser modificado o reformado por medio de un acuerdo por escrito firmado por las partes de este.\n</div><br><div>\nDÉCIMA OCTAVA. EFECTO OBLIGATORIO. El presente Contrato y los documentos e instrumentos que sean celebrados conforme al mismo, constituyen el acuerdo total de las partes, y deroga cualesquier negociaciones, convenios, acuerdos y compromisos anteriores (orales o escritos) en relación con la materia del presente.\n</div><br><div>\nDÉCIMA NOVENA. LEGISLACIÓN APLICABLE Y JURISDICCIÓN. El presente Contrato será regido e interpretado de acuerdo con las leyes \n<u>federales</u>\n de los Estados Unidos Mexicanos. Para todo lo relacionado con la interpretación, cumplimiento y exigibilidad del presente Contrato, las partes convienen en someterse a la jurisdicción de los tribunales de Ciudad Obregón, Sonora y renuncian expresamente a cualquier otro fuero que pudiere corresponderles debido a sus actuales o futuros domicilios, por la ubicación de sus activos o por cualquier otra causa.\n</div><br><div>\nVIGÉSIMA. PROTECCIÓN DE DATOS PERSONALES. Con motivo del objeto del presente Contrato, Urban Fitness recabará diversos datos personales del USUARIO, los cuales serán tratados de conformidad con lo dispuesto en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, su Reglamento y demás disposiciones aplicables. Por su parte, el titular de la inscripción reconoce que previamente a proporcionarle sus datos personales a Urban Fitness, este último le puso a su disposición el correspondiente aviso de privacidad de forma personal, habiéndolo leído, comprendido y consentido, mismo que puede consultarse en la página de FACEBOOK: urban fitness obregón e INSTAGRAM: urbanfitness.mx; ratificando en este acto su consentimiento expreso y por escrito al referido aviso de privacidad, En caso de que el titular de la membresía registre un menor de edad estará obligado que el aviso de privacidad haya sido previamente consentido por quien ejerza sobre el menor la patria potestad o tutela. El incumplimiento de la presente cláusula por parte del titular de la inscripción, será motivo de rescisión de Contrato sin responsabilidad para Urban Fitness, independientemente de la obligación del titular de la inscripción de sacar en paz y a salvo a Urban Fitness de cualquier demanda, denuncia, reclamación o procedimiento, interpuesto en su contra por cualquier tercero ante el Instituto Nacional de Transparencia, Acceso a la Información y Protección de Datos Personales y/o cualquier otra autoridad, obligándose asimismo a indemnizar a Urban Fitness por los daños y perjuicios que le llegare a ocasionar por este concepto.\n</div><br><div>\nEste Contrato es celebrado en dos ejemplares, quedando uno en poder de cada parte y cada uno de los cuales se considera como un original, pero juntos constituyen uno y el mismo contrato. En vista de lo estipulado anteriormente, las partes celebran el presente Contrato el {{vm.data.initPayDate | date: \'dd\'}} de {{vm.data.initPayDate | date: \'MMMM\'}} {{vm.data.initPayDate | date: \'yyyy\'}}.\n</div><br><div><table style=\"width: 100%\"><tr><td \nstyle=\"width: 50%;\n                  text-align: center;\n                  height: 100px;\n                  vertical-align: super\">\nUrban Fitness</td><td \nstyle=\"width: 50%;\n                  text-align: center;\n                  height: 100px;\n                  vertical-align: super\">\nEl USUARIO<br><img ng-src=\"{{vm.signatureSrc}}\"></td></tr><tr><td \nstyle=\"width: 50%; text-align: center; vertical-align: super\"><hr style=\"width: 60%\">Por: Gabriela Marquez Sabag</td>\n<td style=\"width: 50%; text-align: center\"><hr style=\"width: 60%\"><md-button \nclass=\"md-icon-button md-primary sign-button\" flex ng-click=\"vm.showSignature()\"><md-icon \nmd-font-icon=\"icon-pencil-box-outline\"></md-icon><md-tooltip>Firmar</md-tooltip></md-button>{{vm.data.partnerName}}\n</td></tr></table></div><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>\n<br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br>\n<div class=\"page-break\"></div><div class=\"titulo-centrado\">Reglamento</div><br><div class=\"titulo-centrado-normal\">\n<strong>URBAN FITNESS</strong></div><br><div><strong>USUARIOS E INSCRIPCIONES:</strong></div><br><div><strong>1)\n</strong>\n El presente reglamento es de aplicación para todo el usuario del Gimnasio, así mismo todos los usuarios e invitados estarán obligados a cumplir con los reglamentos internos o de área, así como cualquier disposición operativa o administrativa y las políticas que en su momento se pudieran emitir.\n</div><br><div><strong>2)</strong> Los tipos de inscripciones que se pueden contratar son las siguientes:</div><br>\n<div><strong>Inscripción Individual:</strong>\n Integrada exclusivamente por un integrante que deberá ser mayor de edad. En caso que este sea menor de edad, es necesario que la inscripción esté direccionada a tarjeta de crédito o débito de un mayor. (Padre, madre o tutor) y deberá firmar una carta responsiva.\n</div><br><div><strong>3)</strong>\n El dueño de la inscripción tendrá que ser mayor de 18 años y tendrá la obligación de proporcionar la información verídica solicitada al momento de realizar la compra de la misma.\n</div><br><div><strong>4)</strong>\n El usuario podrá hacer uso de las instalaciones a partir del momento que ha realizado su pago, es decir, asista o no, el pago cubre a partir del mes corriente. En caso que el usuario eligiera hacer uso posteriormente de las instalaciones deberá tener autorización por parte de la gerencia general, y esta no podrá exceder más de 2 meses después de realizada la compra.\n</div><br><div><strong>5)</strong> El gimnasio se reserva el derecho de rechazar cualquier solicitud de inscripción.\n</div><br><div><strong>6)</strong>\n La documentación que todos los usuarios de las nuevas inscripciones deberán proporcionar al adquirir su inscripción será la siguiente:\n</div><br><div><strong>Inscripción individual, tercera edad, all incluisve.-</strong>\n Copia fotostática de identificación oficial (acta de nacimiento, credencial del INE, pasaporte, cédula profesional o licencia de manejo)\n</div><br><div><strong>Inscripción Empresarial.-</strong>\n Identificación Oficial y Gafete que lo identifique como empleado de la empresa con la que se tiene el convenio.</div>\n<br><div><strong>Inscripción Escuela.-</strong>\n Identificación Oficial y Credencial vigente de la escuela, tira de materias o un comprobante que acredite ser estudiante de la escuela que se realizó dicho convenio\n</div><br><div><strong>Nota:</strong>\n En caso de no entregar estos documentos en un lapso de 10 días, la Gerencia General quedará facultada para restringir al acceso de todos los usuarios de la inscripción.\n</div><br><div><strong>CUOTAS.</strong></div><br><div><strong>7)</strong>\n Todos los usuarios antes descritos pagarán una cuota que deberá realizarse conforme se estipulo en la caratula del contrato misma que deberá ser en una sola exhibición y que se define como cuota de mantenimiento.\n</div><br><div><strong>8)</strong>\n Las formas para realizar los pagos de las cuotas de mantenimiento de manera mensual son:</div><br><div><strong>\nCargo Mensual Direccionado.</strong>\n Es la cuota vigente que se cobra de manera automática por el gimnasio y puede ser cargada a una tarjeta de crédito o débito o bien a una cuenta a través de la CLABE interbancaria. El usuario reconoce que el cargo mensual direccionado a tarjeta de crédito, tiene cuotas preferenciales sobre la tarjeta de débito, cuenta bancaria a través de la CLABE y convencional. En caso de que el usuario desee cancelar su inscripción o desee transformar la forma de pago de su cuota a cargo convencional, deberá acudir a la recepción del gimnasio para realizar los trámites correspondientes antes del día 25 de cada mes.\n</div><br><div><strong>Cargo Mensual Convencional.</strong>\n Es la cuota vigente que se cobra mediante el pago del Usuario en caja y puede ser efectivo o tarjeta de crédito o débito. En caso de que el Usuario desee cancelar su inscripción o desee autorizar el cargo mensual direccionado, éste deberá acudir a la recepción del gimnasio para realizar los trámites correspondientes antes del día 25 de cada mes.\n</div><br><div><strong>9)</strong>\n En caso de que el Usuario, haya elegido el pago de la cuota de mantenimiento mediante cargo direccionado, expresamente autoriza al gimnasio para que automáticamente y sin necesidad de alguna otra autorización, cargue mensualmente la cuota vigente a cuenta de la tarjeta de crédito mencionada en dicha carátula.\n</div><br><div>\nEl Usuario autoriza que el gimnasio realice el cargo de la cuota de mantenimiento direccionado a partir del primer (1) día hábil de cada mes. Si por insuficiencia de fondos o crédito imputables al Usuario no se puede realizar el cargo en dicho plazo, el Usuario autoriza a gimnasio a realizar el cargo de dicha cuota de mantenimiento más los intereses moratorios en los días que restan del mes corriente.\n</div><br><div>\nEn caso de que gimnasio no pueda realizar dicho cargo en repetidas ocasiones, por causas ajenas a gimnasio, no se le respetará al Usuario la cuota de mantenimiento direccionada y se le cobrará la cuota de mantenimiento convencional.\n</div><br><div><strong>10)</strong>\n Para direccionar los cargos de mantenimiento es necesario realizar el trámite por escrito en el área de recepción por el titular de la tarjeta, proporcionando la información que resulte necesaria. El usuario no podrá determinar la fecha en que se realice su cargo a la tarjeta de crédito o débito; debido a que se realizan envíos previamente determinados.\n</div><br><div><strong>11)</strong>\n Las inscripciones pueden realizar el pago de mantenimiento trimestre, semestre y anual. En este caso no se podrá solicitar la devolución sobre la cantidad pagada, ni total o parcial, toda vez que está adquiriendo una cuota preferencial que tiene dicha restricción, El Gimnasio podrá recorrer hasta un 50% del tiempo que reste por utilizar de dicho pago; siempre y cuando, el Usuario lo notifique con anticipación y dentro de los días del 1 al 25 de cada mes, para que se aplique para el siguiente mes. Este trámite se realiza en la recepción del gimnasio y de forma presencial.\n</div><br><div><strong>12)</strong>\n Durante el mes de diciembre la Administración publicará las nuevas cuotas que estarán vigentes a partir del mes de diciembre.\n</div><br><div><strong>13)</strong>\n La Administración cuenta con facultades para realizar los incrementos que considere pertinentes para el buen funcionamiento de Gimnasio.\n</div><br><div><strong>14)</strong>\n El Usuario deberá pagar las cuotas de mantenimiento con base a la forma elegida, en caso contrario se cobrará un interés moratorio que será del 5% mensual, siendo facultad de la Administración el modificar este porcentaje en cualquier momento.\n</div><br><div><strong>15)</strong>\n El pago de las cuotas de mantenimiento de una inscripción deberán de realizarse en una exhibición, quedando prohibido los pagos parciales así como el pago de la cuota de mantenimiento de la misma inscripción en dos o más tarjetas de crédito.\n</div><br><div><strong>16)</strong>\n Para solicitar un comprobante fiscal o factura de servicios distintos al pago de mantenimiento e inscripción, entre otros, el usuario deberá de solicitar su comprobante fiscal al momento de realizar su pago, de no hacerlo la empresa estará imposibilitada para emitirlo con posterioridad.\n</div><br><div><strong>17)</strong>\n Para solicitar un cambio de factura o comprobante fiscal del pago de mantenimiento o inscripción, esta deberá de ser dentro del mismo mes en que la misma fue expedida.\n</div><br><div><strong>18)</strong>\n Todos los pagos de cualquier servicio que ofrece el gimnasio deberán ser realizados en la caja del gimnasio.</div><br>\n<div><strong>19)</strong>\n En caso de una inscripción nueva, ésta deberá de cubrir la cuota de mantenimiento proporcional según el día en que se realice la misma: durante los primeros 6 días del mes deberá cubrir la cuota de mantenimiento completa, a partir del día 7 pagará la proporción que resulte de dividir el monto total de la cuota de mantenimiento entre el número de días del mes en cuestión, por el número de días vigentes o a correr del mes. Si la inscripción es adquirida después del día 24, es decir a partir del día 25 del mes, el mantenimiento correspondiente a estos últimos días será de cortesía. El usuario tiene la opción de realizar este cargo con cuota direccionada, siempre y cuando haya realizado ya el trámite para direccionar sus futuros pagos de mantenimiento.\n</div><br><div><strong>20)</strong>\n La Administración está facultada para negar el acceso al usuario de la inscripción en caso de que presente un adeudo de la cuota de mantenimiento o algún otro adeudo, tomándose esta medida según la opción de pago que haya elegido:\n</div><br><div><strong>Pago de mantenimiento mensual direccionado.</strong>\n Se negará el acceso a partir del día 4 del mes corriente que no se haya pagado. Es decir; si hoy es 4 de marzo y no ha sido cubierta la cuota de mantenimiento del mes de marzo, la Administración estará facultada para negar el acceso hasta recibir el pago de dicho mes.\n</div><br><div><strong>Pago de mantenimiento mensual convencional.</strong>\n Se negará el acceso a partir del día del mes corriente, es decir, si hoy es día 1 de febrero y no ha sido cubierta la cuota de mantenimiento del mes de febrero, la administración estará facultada para negar el acceso hasta recibir el pago correspondiente.\n</div><br><div><strong>CARTA DE AUSENCIA</strong></div><br><div>\nEn caso de que todos los integrantes de la inscripción requieran ausentarse por un lapso mínimo de 1 mes, se podrá solicitar la cuota de ausencia. El trámite debe realizarlo el titular de la inscripción en la Recepción del gimnasio llenando el formato pertinente. La inscripción deberá estar al corriente en sus cuotas de mantenimiento, debiendo. Esta cuota aplicará al mes siguiente de haber realizado el trámite, aplicando la cuota de ausencia vigente. Este trámite se deberá hacer antes del día 25 de cada mes.\n</div><br><div><strong>21)</strong>\n La administración no se hace responsable por situaciones o acontecimientos sociales, desastres naturales, contingencia ambiental, sanitaria o cualquier otro incidente fuera de nuestra responsabilidad, que afecte la operación regular de nuestro gimnasio, y nos impida ofrecer nuestros servicios, parcial o totalmente, deslindándonos de cualquier tipo de devolución, compensación, reposición o bonificación en pagos de mantenimiento, inscripción y servicios.\n</div><br><div><strong>USO DE LAS INSTALACIONES.</strong></div><br><div><strong>22)</strong>\n La Administración está facultada para hacer cambios en el horario de operación del Gimnasio con previo aviso a los usuarios mediante comunicados que serán colocados en los pizarrones informativos que se encuentran en diversas áreas del gimnasio.\n</div><br><div><strong>23)</strong>\n Para efectos de días festivos o días especiales, El gimnasio notificará de forma anticipada a los usuarios el horario del gimnasio por medio de comunicados en los pizarrones de avisos.\n</div><br><div><strong>24)</strong> Los días <strong>1ro de enero, 24, 25, 30 y 31 de diciembre</strong>\n el gimnasio no dará servicio permaneciendo sus instalaciones cerradas.</div><br><div><strong>25)</strong>\n Los servicios de regaderas permanecerán abiertos desde la apertura del gimnasio hasta 15 minutos antes del cierre del mismo.\n</div><br><div><strong>26)</strong>\n El uso de la huella y contraseña es personal, el mal uso de éstos será sancionado por la Administración hasta con la expulsión definitiva del gimnasio.\n</div><br><div><strong>27)</strong>\n La Administración podrá disponer de las diversas instalaciones y/o servicios del gimnasio brinda, en el momento y tiempo necesario para mantenimiento u otros eventos relacionados con la operación del gimnasio.\n</div><br><div><strong>28)</strong>\n Todos los integrantes de las inscripciones y que sean mayores de 13 años de edad tendrán derecho a la realización de la valoración física sin costo alguno, para obtener dicho beneficio los usuarios nuevos deberán tramitar su cita en el área de recepción de AF, así como para las revaloraciones En caso de que un usuario no asista o cancele su cita en dos ocasiones, dicho servicio tendrá un costo, el cual será determinado por la Administración.\n</div><br><div><strong>29)</strong>\n Para cancelar la inscripción definitivamente, es necesario realizar el trámite como fecha límite hasta el día 25 de cada mes en el área de recepción por el titular de la inscripción, siendo requisito indispensable no presentar ningún tipo de adeudo, en caso de contar con mantenimiento direccionado traer la tarjeta a la cual se realizan los cargos para realizar la cancelación de los mismos. Dicho movimiento aplicará al mes siguiente, este trámite se debe realizar antes del día 25 del mes anterior a la cancelación de la Inscripción (citando como ejemplo que si la cancelación se solicita sea efectiva para el mes de octubre el trámite se debe de realizar durante el mes de septiembre).\n</div><br><div><strong>30)</strong>\n Para realizar el alta de un usuario se debe llenar el formato respectivo en el área de Recepción por parte del titular de la inscripción. Este trámite puede realizarse cualquier día del mes siempre y cuando la inscripción esté al corriente en sus cuotas de mantenimiento e inscripción y deberá cubrir la parte proporcional de la cuota de mantenimiento del nuevo integrante, los siguientes pagos de mantenimiento se realizarán en una sola exhibición.\n</div><br><div>\nDentro de los siguientes 10 días hábiles el nuevo usuario deberá de entregar su documentación completa, además de realizarse la valoración física en caso de ser mayor de 13 años. En caso de mantenimiento direccionado, se deberá traer la tarjeta a la cual se realiza el cargo direccionado mensual.\n</div><br><div><strong>31)</strong>\n Los usuarios podrán tener invitados que hagan uso de las instalaciones de todo el gimnasio siempre y cuando paguen la cuota que determine la Administración y estén acompañados en todo momento por la cual se registra el invitado. El titular de la inscripción se hace responsable por el buen comportamiento de su(s) invitado(s), así como cubrir los daños y consumos que hagan. El gimnasio se reserva el derecho de negar el acceso a cualquier invitado.\n</div><br><div>\nEn el caso de acompañantes deberán de dejar una identificación oficial en la recepción donde le entregara una credencial para su control. A su salida entregara la credencial y no deberá tener daños ya que de presentarlos cubrirá el importe de pase de invitado determinado por la Administración.\n</div><br><div><strong>32)</strong>\n El gimnasio se reserva el derecho de negar el acceso al usuario que se presente en estado de ebriedad, con aliento alcohólico o bajo la influencia de cualquier estupefaciente o psicotrópico, también se le negará el acceso a cualquier persona que represente algún riesgo para el resto de los usuarios o empleados.\n</div><br><div><strong>33)</strong>\n Todas las quejas y sugerencias deberán hacerse por escrito dirigidas al gimnasio y se depositarán en el buzón de sugerencias ubicado en la recepción.\n</div><br><div><strong>SANCIONES</strong></div><br><div><strong>34)</strong>\n Cualquier falta al reglamento o comportamiento que altere el orden del gimnasio será sancionada con una amonestación por escrito la cual se integrará al expediente de la Inscripción. Es considerada falta administrativa, a todo lo que ofenda a alguien con algún acto.\n</div><br><div>Con base en el reglamento de orden jurídico del Estado de Sonora es considerada <strong>\nfalta que atenta contra las buenas costumbres:</strong></div><br><div><ul><li>Fumar en lugares prohibidos.</li><li>\nIngerir bebidas embriagantes.</li><li>Proferir palabras altisonantes, procaces o cualquier forma de expresión obscena.\n</li><li>Ejecutar actos indecorosos o notificantes.</li><li>\nPracticar cualquier acto sexual dentro de las instalaciones del gimnasio.</li></ul></div><br><div><strong>35)</strong>\n El usuario que acumule un total de 3 amonestaciones causará baja definitiva del gimnasio. Si la falta lo amerita, el usuario podrá ser suspendido temporalmente del gimnasio, sin que esto interfiera con los pagos del mantenimiento mensual.\n</div><br><div><strong>36)</strong>\n La Administración tiene la facultad de cancelar definitivamente una inscripción si a su juicio el usuario incurre en alguna falta grave que así lo amerite: destrucción de las instalaciones o equipos, falta de respeto a cualquier integrante del gimnasio, ya sea usuario o empleado, repetidas faltas al reglamento, robo, etc. En dicho caso gimnasio no estará obligado a realizar devolución alguna. En estos casos intervendrá el Comité de Honor y Justicia quién documentará los elementos para la expulsión de los usuarios.\n</div><br><div><strong>37)</strong>\n Cualquier daño que se ocasione a las instalaciones o equipos del gimnasio por parte del usuario de la inscripción o invitado será cubierto por el titular de la inscripción.\n</div><br><div><strong>38)</strong> El no conocer el reglamento, no lo exime de su cumplimiento y acato de este.</div>\n<br><div><strong>GENERALES.</strong></div><br><div><strong>39)</strong>\n Queda prohibida la venta o promoción de cualquier tipo(s) de artículo(s), evento(s) o rifa(s) sin previa autorización escrita por parte de la Administración.\n</div><br><div><strong>40)</strong>\n Se prohíbe convocar a asambleas, realizar mítines, organizar juntas, reunir firmas, volantear información o complots en contra del gimnasio y su personal.\n</div><br><div><strong>41)</strong>\n Queda prohibido introducir cualquier tipo de alimentos y bebidas, excepto agua y bebidas hidratantes en envases de plástico.\n</div><br><div><strong>42)</strong>\n El Gimnasio no se hace responsable por la pérdida total o parcial de cualquier objeto o valor, tales como celulares, documentos, joyas, dinero, entre otros.\n</div><br><div><strong>43)</strong>\n Queda prohibido portar e introducir al gimnasio: bebidas alcohólicas, estupefacientes o cualquier clase de arma o materiales peligrosos que pudieran perjudicar o dañar a los usuarios y personal del gimnasio, así como a las instalaciones del mismo.\n</div><br><div><strong>44)</strong>\n Queda prohibido el acceso a las instalaciones de Gimnasio con cualquier clase de animal o mascota.</div><br><div>\n<strong>45)</strong> Queda prohibido el uso de radios o televisores portátiles que no tengan audífonos personales.\n</div><br><div><strong>46)</strong>\n Los usuarios no podrán reprender o llamar la atención a ningún empleado del gimnasio, para cualquier queja, ésta deberá de formularse por escrito a la Administración.\n</div><br><div><strong>47)</strong>\n No se permite la toma de fotos a instalaciones, usuarios o cualquier persona dentro de las instalaciones, salvo en los eventos previamente programados por la Administración.\n</div><br><div><strong>REGLAMENTO DE VESTIDORES.</strong></div><br><div>\nAdministración no asume ninguna responsabilidad sobre los objetos de valor (teléfonos celulares, carteras, tarjetas bancarias o comerciales, dinero en efectivo, joyas, relojes, dispositivos de música, juegos electrónicos, agendas, tablets) depositados en los casilleros.\n</div><br><div><strong>48)</strong> El uso de sandalias es obligatorio en todas las áreas de vestidores.</div><br><div>\n<strong>49)</strong> No se permite el apartado de regaderas.</div><br><div><strong>50)</strong>\n Las regaderas podrán ser ocupadas, solamente por una persona a la vez.</div><br><div><strong>51)</strong>\n Por beneficio de TODOS, el uso del agua deberá ser de forma racional.</div><br><div><strong>52)</strong>\n Cualquier situación imprevista o no contemplada en este reglamento se sujeta a las resoluciones adoptadas por la Gerencia General del gimnasio y deberá ser acatada por todos los usuarios sin excepción.\n</div><br><div><strong>REGLAMENTOS DE ÁREA.</strong></div><br><div>\nLos reglamentos de área que se señalan a continuación serán aplicables únicamente cuando el gimnasio cuente con las áreas mencionadas.\n</div><br><div><strong>REGLAMENTO DE ESTACIONAMIENTO</strong></div><br><div>\nEl servicio de estacionamiento, El gimnasio no se hace responsable de ningún tipo de robo, choque o descompostura. Todos los usuarios que deseen utilizar este servicio deberán de respetar los siguientes puntos:\n</div><br><div>\nEl gimnasio no se hace responsable por siniestros ocasionados por terremotos, inundaciones, incendios, robo con violencia, etc.\n</div><br><div><ul><li>\nQueda prohibido el estacionarse en los lugares asignados para usuarios con capacidades diferentes.</li><li>\nCualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia General del gimnasio y deberá ser acatada por todos.\n</li></ul></div><br><div><strong>GENERALIDADES.</strong></div><br><div><ul><li>\nLa Administración establecerá las normas técnicas o deportivas para el mejor aprovechamiento de todas las instalaciones del gimnasio por parte de los usuarios y de sus invitados.\n</li><li>\nTodos los reglamentos son susceptibles de modificaciones o adiciones por parte de la Administración cuando se juzgue que estas reformas resulten convenientes para la mejor operación del gimnasio.\n</li><li>\nEl gimnasio queda facultado para expedir circulares y normas internas que deben ser acatadas por los usuarios e invitados.\n</li><li>\nLa facultad de interpretación de los reglamentos y aplicación de sanciones pertenece exclusivamente a la Administración del gimnasio.\n</li><li>\nLas modificaciones o adiciones que se hagan a las disposiciones reglamentarias serán comunicadas a los usuarios.</li>\n</ul></div><br><div><strong>VALORACIÓN FISICA</strong></div><br><div><strong>\nSe realizará la valoración física por los asesores deportivos, es necesario que el usuario de primera vez se realice la misma o bien firme la carta de deslinde de responsabilidades, posteriormente quedará a discreción del usuario realizar el seguimiento para conocer los avances obtenidos, siendo este un beneficio para todos nuestros usuarios.\n</strong></div><br><div><ul><li>\nLas Citas para valoraciones físicas se deberán agendar en la Recepción de AF. Se podrán cancelar valoraciones vía telefónica, pero no se podrán reagendar por este medio. Será necesario reagendarla en la recepción de AF.\n</li><li>\nLa cita de valoración física tendrá un tiempo de tolerancia de 5 minutos, transcurrido ese tiempo, el usuario tendrá que agendar otra cita.\n</li></ul></div><br><div><strong>REGLAMENTO DE GIMNASIO.</strong></div><br><div><ul><li>\nTodos los usuarios que realicen su entrenamiento en el gimnasio; deberán de contar con el programa de entrenamiento (rutina). Cualquier situación especial de salud o lesión deberá de ser reportada al personal del área.\n</li><li>Será obligatorio el uso de una toalla facial personal, en caso contrario no se permitirá el acceso al área.\n</li><li>Después de usar cualquier aparato es obligatorio limpiarlo.</li><li>\nPor su seguridad e higiene es obligatorio utilizar la ropa adecuada (conjuntos deportivos de algodón, licra y/o telas sintéticas deportivas), queda estrictamente prohibido hacer ejercicio con ropa de mezclilla, gabardina, etc., zapatos de calle, sandalias y/o cualquier calzado que no sea el adecuado.\n</li><li>\nQueda prohibido introducir todo tipo de alimentos y envases de vidrio, bebidas calientes, en lata o en envases sin tapa para evitar derrames en el área.\n</li><li>\nNo se podrán introducir maletas, back packs y/o bolsas voluminosas al área, que excedan las medidas de 50 x 30 cm.</li>\n<li>\nSe prohíbe el uso indebido del equipo o instalaciones del gimnasio; que causen el deterioro destrucción del mismo. En caso de requerir ayuda para el uso de algún aparato o equipo, es obligación de los instructores atenderlo.\n</li><li>\nEs obligatorio que los usuarios regresen a su lugar el equipo (barras, mancuernas y equipo en general) que empleen en la ejecución de su rutina de entrenamiento.\n</li><li>Se prohíbe introducir pesas o accesorios de peso libre al área cardiovascular y/o peso integrado.</li><li>\nNinguna persona ajena al staff puede ejercer la función como asesor deportivo, el usuario que sea sorprendido realizando cualquier instrucción o asesoría será sancionado.\n</li><li>\nLa edad mínima para ingresar al gimnasio, será de 13 años a Cardiovascular y 15 años al área de peso integrado y libre.\n</li><li>No podrán permanecer en el gimnasio las personas o usuarios que no realicen alguna rutina de entrenamiento.\n</li><li>\nEl staff del gimnasio queda facultado para hacer cumplir el reglamento a los usuarios que incurran en conductas incorrectas, reportando a la Gerencia por escrito la falta cometida, anexándose al expediente de la inscripción.\n</li><li>\nEl Gimnasio se reserva el derecho de cambiar los asesores deportivos y los horarios de los mismos cuando así lo requiera el servicio.\n</li><li>Todos los usuarios deberán alternar y compartir al hacer uso de los aparatos y equipos.</li><li>\nQueda prohibido apartar los aparatos.</li><li>\nEn todos los horarios el uso de los equipos cardiovasculares (caminadoras, elípticas, bicicletas y demás) será de 30 minutos máximo.\n</li><li>El gimnasio no se hace responsable por objetos olvidados y/o extraviados dentro del área de A.F.</li><li>\nLos asesores deportivos del gimnasio tienen prohibido sugerir el uso, compra, venta o aplicación de cualquier tipo de sustancia o complemento alimenticio. En caso de detectar este tipo de anomalía, favor de reportarla a la Gerencia General del GIMNASIO.\n</li><li>\nCualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia General del Gimnasio, y deberá de ser acatada por todos los usuarios sin excepción.\n</li></ul></div><br><div class=\"titulo-centrado\">REGLAMENTO</div><br><div class=\"titulo-centrado\">\nENTRENAMIENTOS PERSONALIZADOS.</div><br><div><ul><li>\nEl entrenamiento personalizado tienen un costo adicional, el cuál será fijado por la el entrenador personal. El pago se realiza directamente con los Entrenadores personales.\n</li><li>URBAN FITNESS se deslinda de cualquier responsabilidad del servicio de Entrenamiento Personal.</li><li>\nCualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia General del gimnasio y deberán de ser acatadas por todos los usuarios.\n</li></ul></div><br><div><strong>REGLAMENTO DE USO DE LOS SALONES PARA CLASES</strong></div><br><div><ul><li>\nSe deberá utilizar la ropa adecuada para la práctica de esta actividad. Queda prohibido el acceso con zapatos que no sean deportivos.\n</li><li>Queda estrictamente prohibido introducir alimentos a los salones.</li><li>\nSólo se podrán introducir bebidas en envase plástico con tapa.</li><li>\nEl tiempo de tolerancia para entrar a las clases será de 10 minutos, transcurrido ese tiempo no se permitirá el acceso.\n</li><li>No está permitido apartar lugares o espacios en cualquiera de las clases impartidas.</li><li>\nDespués de cada clase los usuarios deberán abandonar el salón para permitir el acceso del personal de limpieza.</li>\n<li>\nEn clases que requieran el uso de equipo, cada persona se hará responsable del uso del mismo y de colocar el equipo en el lugar asignado al término de la clase.\n</li><li>\nLa Administración determinará el cupo de cada clase y no podrá haber más participantes que los designados para cada actividad. El gimnasio se reserva el derecho de cambiar sin previo aviso al profesor, horarios y tipos de clase.\n</li><li>El acceso a las clases dirigidas se permitirá a partir de los 13 años de edad.</li><li>\nLas Clases dirigidas tendrán una duración de 50 minutos.</li><li>\nNo se permitirá permanecer dentro del salón si no hay clase o instructor, (no aplica en el área de bike).</li><li>\nEl Gimnasio no se hace responsable por objetos olvidados y/o extraviados dentro de los salones.</li><li>\nEl profesor respetará el cupo máximo de cada clase y no podrá haber más participantes que los designados para cada actividad.\n</li><li>El Gimnasio se reserva el derecho de cambiar sin previo aviso, al profesor, horario y tipo de clase.</li><li>\nCualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia General del gimnasio y deberá de ser acatada por todos los usuarios sin excepción.\n</li></ul></div><br><div class=\"titulo-centrado\">REGLAMENTO DE STUDIO INDOOR CYCLING.</div><br><div>\nPara poder tomar clase de INDOOR CYCLING el usuario deberá de registrarse previa cita y cumplir los siguientes puntos.\n</div><br><div><ul><li>\nEl usuario en caso de no pueda asistir a su clase tendrá que cancelar su asistencia con un mínimo de 2 horas antes vía telefónica o presencial.\n</li><li>\nEn caso de que el usuario no cancele su inasistencia y acumule 3 inasistencias sin notificarlo dentro del mismo mes será acreedor a una multa de $100 pesos, que será cobrada en su siguiente mensualidad.\n</li><li>El usuario solo tendrá derecho de tomar una clase al día</li><li>\nUrban fitness prestara los tenis de indoor cycling bajo disponibilidad de talla y al término de la actividad el usuario entregara los mismos.\n</li><li>\nEn caso de que el usuario haga mal uso de los tenis de indoor cycling tendrá que pagar el valor comercial del mismo.\n</li><li>Para generar la reserva de una clase se podrá realizar antes de una hora que inicie la actividad.</li><li>\nSe deberá utilizar ropa adecuada para la práctica de esta actividad.</li><li>\nQueda estrictamente prohibido introducir alimentos en el STUDIO INDOOR CYCLING.</li><li>\nSólo se podrán introducir agua y bebidas hidratantes en envase de plástico con tapa.</li><li>\nNo se podrán introducir maletas y/o bolsas voluminosas al salón.</li><li>\nEl tiempo de tolerancia para entrar a las clases una vez iniciadas será de 5 minutos, transcurrido ese tiempo no se permitirá el acceso.\n</li><li>\nDespués de cada clase los usuarios deberán abandonar el salón para permitir el acceso del personal de limpieza.</li>\n<li>El acceso a las clases de STUDIO INDOOR CYCLING se permitirá a partir de los 13 años de edad.</li><li>\nCualquier desperfecto o maltrato a las bicicletas será responsabilidad del usuario debiendo cubrir el monto del daño ocasionado.\n</li><li>\nCualquier situación imprevista o no contemplada en este reglamento se sujetará a las resoluciones adoptadas por la Gerencia General del gimnasio, y deberá ser acatada por todos los usuarios sin excepción.\n</li></ul></div><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><div \nclass=\"page-break\"></div><div><strong>CARTA COVID-19</strong></div><br><div class=\"titulo-derecha\">\n{{vm.data.initPayDate | date: \'dd/MM/yyyy\'}}</div><br><div class=\"titulo-derecha\">\nNo. De inscripción {{vm.data.folioMembresia}}</div><br><div>\nEl suscrito, en calidad de usuario del Urban Fitness ubicado en calle Hidalgo 920 Col. Centro, Ciudad Obregón Sonora hago constar que entiendo y comprendo que en el gimnasio se cumplen con las medidas de seguridad establecidas por la Secretaría de Salud con motivo del SARS-CoV-2 que provoca Covid-19 y reinicio de actividades.\n</div><br><div>\nEn virtud de lo anterior, entre otras medidas, entiendo y autorizo que antes de ingresar a las instalaciones del gimnasio se realicen monitoreos del estado de salud de mi persona así como de todos y cada uno de los usuarios que están dentro de la inscripción de referencia, incluyendo menores de edad, invitados y/o acompañantes; por lo que con la firma de la presente.\n</div><br><div>\nLo anterior, en el entendido de que, el resultado del monitoreo de salud en cuestión será dado a conocer a la persona objeto del monitoreo, salvo en casos de menores de edad cuyo resultado podrá ser revelado al mayor de edad que lo acompañe. Asimismo, estoy de acuerdo en adoptar, las medidas de seguridad e higiene que así se soliciten al interior del atendiendo para ello a lo así previsto en el reglamento interior del gimnasio y los respectivos comunicados/avisos que eventualmente se coloquen en las instalaciones.\n</div><br><div>\nAunado a lo antes mencionado, hago constar que entiendo y estoy de acuerdo en que, en virtud de la forma en la cual evoluciona la sintomatología y el propio virus que provoca COVID-19, Urban Fitness y/o la entidad operadora del gimnasio; no será ni podrá hacerse responsable de cualquier posible contagio (presumiendo que el mismo no ocurrió dentro del gimnasio, atento a las medidas expuestas).\n</div><br><div>\nAsí mismo, hago constar mi aprobación, para que en caso de presentarse cualquier síntoma que presuma el contagio de COVID-19, será indispensable que la persona en cuestión se abstenga de atender al gimnasio durante el periodo que así indique el médico tratante.\n</div><br><div>\nFinalmente, otorgo mi consentimiento libre, informado, específico y de manera inequívoca, para que mis datos personales, incluyendo mis datos personales sensibles, sean tratados de conformidad con los términos del aviso de privacidad integral anexo al presente documento. Dicho aviso de privacidad se encuentra también disponible en las redes sociales de Facebook: Urban Fitness Obregón e Instagram: urbanfitness.mx. De igual forma. Con relación a los menores de edad, me obligo a que dicho consentimiento sea otorgado por quien ejerce la patria potestad o tutela sobre el menor. En caso de incumplir lo anterior, estoy de acuerdo en responder ilimitadamente por los daños y perjuicios que mi incumplimiento ocasione a Urban Fitness.\n</div><br><div class=\"titulo-centrado-normal\">Atentamente</div><br><div class=\"titulo-centrado-normal\"><table \nstyle=\"width: 100%\"><tr><td \nstyle=\"width: 100%;\n                  text-align: center;\n                  height: 100px;\n                  vertical-align: super\">\n<img ng-src=\"{{vm.signatureSrc}}\"></td></tr><tr><td style=\"width: 50%; text-align: center\"><hr style=\"width: 60%\">\n{{vm.data.partnerName}}</td></tr></table></div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/info/printable-pass/printable-pass.html","<div id=\"pass\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"pass-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex ng-if=\"vm.item.isPrintable\" \nonclick=\"window.print()\"><md-icon md-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" flex ng-if=\"vm.item.isSendByEmail\" ng-disabled=\"vm.imageSaving || vm.emailSending\" \nng-click=\"vm.sendMail()\"><md-icon ng-show=\"!vm.emailSending\" md-font-icon=\"icon-email\"></md-icon><md-icon \nng-show=\"vm.emailSending\" md-font-icon=\"icon-dots-horizontal\"></md-icon><md-tooltip>Enviar por Email</md-tooltip>\n</md-button></div><div id=\"pass-card\" class=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" \nlayout-align=\"center center\"><div layout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"center center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img id=\"img-logo\" ng-src=\"{{vm.logoSource}}\"></div></div></div>\n</div><div class=\"content\"><div class=\"pass-type\">{{vm.item.pass.passType.name}}</div><div class=\"barcode\"><svg \nid=\"barcode\"></svg></div><div class=\"pass-valid\">VIGENCIA (<strong>{{vm.item.validFrom | date: \'dd/MM/yyyy\'}}</strong>\n - <strong>{{vm.item.validTo | date: \'dd/MM/yyyy\'}}</strong>)</div><div class=\"assigned-to\">ASIGNADO A (<strong>\n{{vm.item.name}}</strong>)</div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/partners/views/prospects/dialogs/dialog-prospect/dialog-prospect.html","<md-dialog id=\"partners-dialog-prospect\" class=\"\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall h-50\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.close()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div></md-toolbar><form \nname=\"detailForm\"><md-dialog-content class=\"no-padding\"><div class=\"page-layout carded fullwidth\" layout=\"column\"><div \nlayout=\"column\" class=\"p-0 pl-15 pr-15 pt-10 m-0\"><div layout=\"row\"><md-input-container flex><label>Nombre(s)</label>\n<input type=\"text\" name=\"name\" ng-model=\"vm.prospect.name\" required ng-disabled=\"vm.prospect.isSignedUp\"><div \nng-messages=\"detailForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dato obligatorio.</span></div></div>\n</md-input-container><md-input-container flex><label>Apellido Paterno</label><input type=\"text\" name=\"fatherLastname\" \nng-model=\"vm.prospect.fatherLastname\" required ng-disabled=\"vm.prospect.isSignedUp\"><div \nng-messages=\"detailForm.fatherLastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Dato obligatorio.</span>\n</div></div></md-input-container><md-input-container flex><label>Apellido Materno</label><input type=\"text\" \nname=\"motherLastname\" ng-model=\"vm.prospect.motherLastname\" ng-disabled=\"vm.prospect.isSignedUp\"></md-input-container>\n</div><div layout=\"row\"><md-input-container flex><label>Teléfono 1</label><input type=\"text\" name=\"phone\" \nng-model=\"vm.prospect.phone\" required ng-disabled=\"vm.prospect.isSignedUp\"><div ng-messages=\"detailForm.phone.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Dato obligatorio.</span></div></div></md-input-container>\n<md-input-container flex><label>Teléfono 2</label><input type=\"text\" name=\"phone2\" ng-model=\"vm.prospect.phone2\" \nng-disabled=\"vm.prospect.isSignedUp\"></md-input-container><md-input-container flex><label>Email</label><input \ntype=\"text\" name=\"email\" ng-model=\"vm.prospect.email\" ng-disabled=\"vm.prospect.isSignedUp\"></md-input-container></div>\n<div layout=\"row\"><md-input-container flex><label>Estado</label><input type=\"text\" name=\"state\" \nng-model=\"vm.prospect.state\" ng-disabled=\"vm.prospect.isSignedUp\"></md-input-container><md-input-container flex><label>\nColonia</label><input type=\"text\" name=\"colonia\" ng-model=\"vm.prospect.colonia\" ng-disabled=\"vm.prospect.isSignedUp\">\n</md-input-container><md-input-container flex><label>Vendedor</label><md-select ng-model=\"vm.prospect.sellerId\" \nname=\"sellerId\" required ng-disabled=\"vm.prospect.isSignedUp\"><md-option \nng-repeat=\"item in vm.sellers | filter: { active: true }\" ng-value=\"item.id\">\n{{item.name}} {{item.fatherLastname}} {{item.motherLastname}}</md-option></md-select><div \nng-messages=\"detailForm.sellerId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Vendedor.</span>\n</div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label>Medio por el que se enteró\n</label><md-select ng-model=\"vm.prospect.mediaId\" name=\"mediaId\" required ng-disabled=\"vm.prospect.isSignedUp\">\n<md-option ng-repeat=\"item in vm.media | filter: {active: true}\" ng-value=\"item.id\">{{item.name}}</md-option>\n</md-select><div ng-messages=\"detailForm.mediaId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Medio.</span></div></div></md-input-container><md-input-container flex><label>Referencia 1</label><input \ntype=\"text\" name=\"reference\" ng-model=\"vm.prospect.reference\" ng-disabled=\"vm.prospect.isSignedUp\">\n</md-input-container><md-input-container flex><label>Referencia 2</label><input type=\"text\" name=\"reference2\" \nng-model=\"vm.prospect.reference2\" ng-disabled=\"vm.prospect.isSignedUp\"></md-input-container></div></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-if=\"!vm.prospect.isSignedUp\">\n<md-button type=\"submit\" ng-click=\"vm.accept()\" class=\"send-button md-accent md-raised w-150\" \nng-disabled=\"detailForm.$invalid || vm.sending\" aria-label=\"ACEPTAR\"><span ng-hide=\"vm.sending\">Guardar </span><span \nng-show=\"vm.sending\">Guardando...</span></md-button><md-button ng-click=\"vm.close()\" aria-label=\"Cancelar\">Cancelar\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/kardex/kardex.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"buttons\" layout=\"column\"><md-button class=\"md-icon-button\" flex onclick=\"window.print()\"><md-icon \nmd-font-icon=\"icon-printer\"></md-icon><md-tooltip>Imprimir</md-tooltip></md-button></div><div id=\"complete-document\" \nclass=\"card md-whiteframe-8dp\"><div flex-1 layout=\"row\" layout-align=\"center start\" class=\"familiar-actions\"><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\" style=\"float:left\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\" class=\"partner-image\"></div></div><div style=\"float:right\"><h3>\n{{vm.appData.branch.name}}</h3>{{vm.appData.settings.address}}<br></div></div><div><hr class=\"styleTitle\"><h4>\nSOLICITUD UNICA DE CONTRATO DE SERVICIOS</h4><hr class=\"styleTitle\"><table class=\"simple socio-table\"><tr><td \nstyle=\"text-align: left!important\"><h4 style=\"text-align: left!important\">{{vm.partner.completeName}}</h4></td><td \nstyle=\"text-align: right\">Fecha: {{vm.date | date:\'yyyy-MM-dd\'}}</td></tr><tr><td>Tipo de socio:</td><td>\n{{vm.partner.due.name}} ({{vm.partner.duePrice.price | currency : \'$ \' : 2}})</td></tr><tr><td>Fecha de nacimiento:\n</td><td>{{vm.partner.birthdate | date: \'dd/MM/yyyy\'}}</td></tr><tr><td>IdMember:</td><td>\n{{vm.partner.sequentialNumber}}</td></tr><tr><td>Num Familia:</td><td>{{vm.partner.sequentialNumber}}</td></tr><tr><td>\nClave Anterior:</td><td>0</td></tr><tr><td>Fecha de Ingreso:</td><td>\n{{vm.partner.inscriptionDate | date: \'dd/MM/yyyy\'}}</td></tr><tr><td>Fecha del Próximo Pago:</td><td>\n{{vm.partner.payedDate | date: \'dd/MM/yyyy\'}}</td></tr><tr ng-repeat=\"itemRentable in vm.partner.rentables\"><td>\nRentable:</td><td>{{itemRentable.rentable.name}}</td></tr><tr><td>E-mail:</td><td>{{vm.partner.email}}</td></tr><tr>\n<td>Ocupación:</td><td>{{vm.partner.profession.name}}</td></tr><tr ng-repeat=\"itemAgreements in vm.partner.agreements\">\n<td>Convenio:</td><td>{{itemAgreements.name}}</td></tr><tr><td>Teléfono:</td><td>{{vm.partner.phone}}</td></tr><tr \nng-show=\"vm.partner.phone2 != null\"><td>Teléfono 2:</td><td>{{vm.partner.phone2}}</td></tr><tr><td>Dirección:</td><td>\n{{vm.partner.addresses[0].street}} {{vm.partner.addresses[0].number}} {{vm.partner.addresses[0].interiorNumber}}, {{vm.partner.addresses[0].colony}}, {{vm.partner.addresses[0].city}}, {{vm.partner.addresses[0].state}}, {{vm.partner.addresses[0].zipCode}}\n</td></tr><tr><td>Domiciliado:</td><td>{{vm.partner.domiciliado}}</td></tr><tr \nng-show=\"vm.partner.partnerAutomaticPayment != null\"><td>Monto Domiciliado:</td><td>\n{{vm.partner.MontoDomiciliado | currency: \'$\' : 2}}</td></tr><tr ng-show=\"vm.partner.partnerAutomaticPayment != null\">\n<td>Vigencia Domiciliado:</td><td>{{vm.partner.FechaExpiracion | date: \'dd/MM/yyyy\'}}</td></tr><tr \nng-show=\"vm.partner.partnerAutomaticPayment != null\"><td>Periodicidad:</td><td>{{vm.partner.duePeriodicity.name}}</td>\n</tr></table></div><div class=\"page-break-inside\"></div><hr class=\"styleTitle\"><h4>(DEPENDIENTES)</h4><table \nclass=\"simple socio-table socio-dependiente-table\" ng-repeat=\"group in vm.partner.familyDetails.dependents\"><tr><td>\nNombre</td><td>{{group.completeName}}</td></tr><tr><td>Fecha de nacimiento</td><td>\n{{group.birthdate | date: \'dd/MM/yyyy\'}}</td></tr><tr><td>Tipo de socio</td><td>\n{{group.due.name}} ({{group.duePrice.price | currency : \'$ \' : 2}})</td></tr><tr><td>IDMember</td><td>\n{{group.sequentialNumber}}</td></tr><tr><td>E-mail</td><td>{{group.email}}</td></tr><tr><td>Fecha de inscripción</td>\n<td>{{group.inscriptionDate | date: \'dd/MM/yyyy\'}}</td></tr><tr><td>Teléfono</td><td>{{group.phone}}</td></tr><tr \nng-show=\"group.phone2 != null\"><td>Teléfono2</td><td>{{group.phone2}}</td></tr></table></div></div></div>");
$templateCache.put("app/main/partners/views/prospectCalendar/dialogs/dialog-event/dialog-event.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-block\"><label>Vendedor</label><input type=\"text\" \nng-model=\"vm.selectedSeller.completeName\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\"><label>Prospecto</label><md-select ng-model=\"vm.calendarEvent.prospect\" name=\"prospect\" md-autofocus \nrequired aria-label=\"prospectSelect\"><md-option ng-repeat=\"item in vm.prospects\" ng-value=\"item\">\n{{ item.completeName }}</md-option></md-select><div ng-messages=\"eventForm.prospect.$error\" \nng-show=\"eventForm.prospect.$invalid\" role=\"alert\"><div ng-message=\"required\">Seleccione prospecto.</div></div>\n</md-input-container><div layout=\"row\" class=\"date-row\"><md-datepicker \nng-init=\"vm.start = (vm.calendarEvent.start | toDate)\" ng-change=\"vm.calendarEvent.start = vm.start\" \nng-model=\"vm.start\" md-placeholder=\"Fecha inicio\" ng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker>\n<md-input-container class=\"no-errors-spacer\" flex md-no-float><cd-input-time ng-model=\"vm.calendarEvent.startTime\">\n</cd-input-time></md-input-container></div><div layout=\"row\" class=\"date-row\"><md-datepicker \nng-init=\"vm.end = (vm.calendarEvent.end | toDate)\" ng-change=\"vm.calendarEvent.end = vm.end\" ng-model=\"vm.end\" \nmd-placeholder=\"Fecha de término\" ng-model-options=\"{ timezone: \'UTC\' }\"></md-datepicker><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float required><cd-input-time ng-model=\"vm.calendarEvent.endTime\"></cd-input-time>\n</md-input-container></div><md-input-container flex class=\"md-block textarea-container\"><label>Notas</label><textarea \nng-model=\"vm.calendarEvent.notes\" md-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"eventForm.$invalid=true;vm.saveEvent();\" class=\"save-button md-accent md-raised\" aria-label=\"Guardars\" \nng-disabled=\"eventForm.$invalid\">GUARDAR</md-button><md-button class=\"md-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Cancelar\">CANCELAR</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-cobranza/layout-consolidado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE DE CAJA (CONSOLIDADO)</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\" ng-if=\"vm.reportData.report.parameters[0].value.type == 1\">\nPor fecha del {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}} \n</span><span class=\"title\" ng-if=\"vm.reportData.report.parameters[0].value.type == 2\">\nPor folio del {{vm.reportData.report.parameters[0].value.from}} al {{vm.reportData.report.parameters[0].value.to}}\n</span></div><div class=\"info\"><div class=\"title\">Turno: <span>{{vm.reportData.report.parameters[1].value}}</span><br>\nSucursal(es): <span ng-repeat=\"item in vm.reportData.report.parameters[2].value\">{{item.name}},</span><br>Usuario(s): \n<span ng-repeat=\"item in vm.reportData.report.parameters[3].value\">{{item.name}} {{item.fatherLastname}},</span></div>\n</div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><table \nclass=\"simple report-table\"><tbody><tr ng-repeat=\"group in vm.group\"><td><h4 class=\"report-group-1\">{{group.key}}</h4>\n<table class=\"pl-50 simple report-table w-500 mt-0\"><thead><tr><th class=\"text-center\">Fecha</th><th \nclass=\"text-right\">Factura/Recibo</th><th class=\"text-right\">Nota de crédito</th><th class=\"text-right\">Total</th><th>\n% Representa del total</th></tr></thead><tbody><tr ng-repeat=\"fecha in group.fecha\"><td class=\"text-center\">\n{{fecha.key | date: \'dd/MM/yyyy\'}}</td><td class=\"text-right pr-20\">{{fecha.totalFR | currency: \'$\' : 2}}</td><td \nclass=\"text-right pr-20 text-notaCredito\">{{fecha.totalNC | currency: \'$\' : 2}}</td><td class=\"text-right pr-20\">\n{{(vm.reportData.report.parameters[6].value.id == 1 ? fecha.totalFR - fecha.totalNC : fecha.totalFR) | currency: \'$\' : 2}}\n</td><td class=\"text-right pr-20\">{{fecha.branchPercentage | number : 2 }}</td></tr><tr><td></td><td \nclass=\"text-right pr-20\"><span class=\"report-subtotals\">{{group.totalFR | currency: \'$\': 2 }}</span></td><td \nclass=\"text-right pr-20\"><span class=\"report-subtotals\">{{group.totalNC | currency: \'$\': 2 }}</span></td><td \nclass=\"text-right pr-20\"><span class=\"report-subtotals\">\n{{(vm.reportData.report.parameters[6].value.id == 1 ? group.totalFR - group.totalNC : group.totalFR) | currency: \'$\': 2 }}\n</span></td><td></td></tr></tbody></table></td></tr></tbody></table><div class=\"text-right w-500\"><span \nclass=\"report-totals\">Total: {{vm.group | sum: \'totalGroup\' | currency: \'$ \': 2 }}</span></div></div></div><div \nclass=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-cobranza/layout-desglosado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE DE CAJA (DESGLOSADO)</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\" ng-if=\"vm.reportData.report.parameters[0].value.type == 1\">\nPor fecha del {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}} \n</span><span class=\"title\" ng-if=\"vm.reportData.report.parameters[0].value.type == 2\">\nPor folio del {{vm.reportData.report.parameters[0].value.from}} al {{vm.reportData.report.parameters[0].value.to}}\n</span></div><div class=\"info\"><div class=\"title\">Turno: <span>{{vm.reportData.report.parameters[1].value}}</span><br>\nSucursal(es): <span ng-repeat=\"item in vm.reportData.report.parameters[2].value\">{{item.name}},</span><br>Usuario(s): \n<span ng-repeat=\"item in vm.reportData.report.parameters[3].value\">{{item.name}} {{item.fatherLastname}},</span></div>\n</div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"group in vm.group\"><h3 class=\"report-group-1\">{{group.key}}</h3><div \nng-repeat=\"groupType in group.groupType\" class=\"ml-20\"><h3 class=\"report-group-2\">{{groupType.key}}</h3><div \nng-repeat=\"subgroup in groupType.groupDate\" class=\"ml-20\"><h3 class=\"report-group-3\">\n{{subgroup.key | date: \'dd/MM/yyyy\'}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\">No</th><th class=\"text-center\">Folio</th><th class=\"text-center\">Hora</th><th class=\"text-center\">\nNo Familia</th><th class=\"text-center\">A quien se facturo</th><th class=\"text-center\">Socio</th><th \nclass=\"text-center\">Subtotal</th><th class=\"text-center\">Descuento</th><th class=\"text-center\">IVA</th><th>Total</th>\n<th class=\"text-center\">Responsable</th></tr></thead><tbody><tr ng-repeat=\"item in subgroup.items\"><td \nclass=\"text-center\">{{item.number}}</td><td class=\"text-center\">{{item.folio}}</td><td class=\"text-center\">\n{{item.hora | date: \'HH:mm\' }}</td><td class=\"text-center\">{{item.sequentialNumber}}</td><td>{{item.razonSocial}}</td>\n<td>{{item.partnerName}}</td><td class=\"text-right\">{{item.subtotal | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{item.discountAmmount | currency: \'$\': 2 }}</td><td class=\"text-right\">{{item.iva | currency: \'$\': 2 }}</td><td \nclass=\"text-right\">{{item.total | currency: \'$\': 2 }}</td><td>{{item.sellerName}}</td></tr><tr class=\"subtotals\"><td \ncolspan=\"6\">Subtotales</td><td class=\"text-right\">{{subgroup.items | sum: \'subtotal\' | currency: \'$\': 2 }}</td><td \nclass=\"text-right\">{{subgroup.items | sum: \'discountAmmount\' | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{subgroup.items | sum: \'iva\' | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{subgroup.items | sum: \'total\' | currency: \'$\': 2 }}</td><td></td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Subtotal por metodo</span><div><span>\nSubtotal: {{groupType.items | sum: \'subtotal\' | currency: \'$\': 2 }}</span> <span class=\"ml-20\">\nDescuento: {{groupType.items | sum: \'discountAmmount\' | currency: \'$\': 2 }}</span> <span class=\"ml-20\">\nIVA: {{groupType.items | sum: \'iva\' | currency: \'$\': 2 }}</span> <span class=\"ml-20\">\nTotal: {{groupType.items | sum: \'total\' | currency: \'$\': 2 }}</span></div></div></div></div><hr><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\"><span>Total general</span><div><span>\nSubtotal: {{ vm.subtotal | currency: \'$\' : 2}}</span> <span class=\"ml-20\">\nDescuento: {{ vm.discountAmmount | currency: \'$\' : 2}}</span> <span class=\"ml-20\">IVA: {{ vm.iva | currency: \'$\' : 2}}\n</span> <span class=\"ml-20\">Total: {{ vm.total | currency: \'$\' : 2}}</span></div></div><div layout=\"row\" \nlayout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"70\"><thead><tr><th \nclass=\"text-center\">Sucursal</th><th class=\"text-center\">Recibos</th><th class=\"text-center\">Facturas</th><th \nclass=\"text-center\">Notas de crédito</th><th class=\"text-center\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.summary\"><td class=\"text-left\">{{item.branch}}</td><td class=\"text-right\">\n{{item.receiptTotal | currency: \'$\': 2}}</td><td class=\"text-right\">{{item.invoiceTotal | currency: \'$\': 2}}</td><td \nclass=\"text-right ng-class: vm.reportData.report.parameters[6].value.id == 1 ? \'text-include\' : \'text-exclude\'\">\n{{item.ncTotal | currency: \'$\': 2}}</td><td class=\"text-right\">\n{{(item.receiptTotal + item.invoiceTotal - (vm.reportData.report.parameters[6].value.id == 1 ? item.ncTotal : 0)) | currency: \'$\': 2}}\n</td></tr></tbody></table></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button>\n</cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-TPV/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCorte de Caja por TPV</span></div><div class=\"info\"><div class=\"report-subtitle\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\">\nPor fecha del {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}</h3><div \nng-repeat=\"tpv in group.TPVS\" class=\"ml-20\"><h3 class=\"report-group-2\">TPV: {{tpv.key}}</h3><table \nclass=\"simple report-table font-small\"><thead><tr><th class=\"w-50 text-center\">Factura</th><th \nclass=\"w-50 text-center\">Familia</th><th class=\"w-50 text-center\">Fecha</th><th class=\"w-100 text-center\">\nA quien se le cobro</th><th class=\"w-50 text-center\">Importe</th><th class=\"w-50 text-center\">Cancelada</th><th \nclass=\"w-50 text-center\">Forma Pago</th><th class=\"w-50 text-center\">Referencia</th></tr></thead><tbody><tr \nng-repeat=\"item in tpv.items\"><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">{{item.invoiceFolio}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">{{item.id}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\'? \'text-notaCredito\' : \'\'\">\n{{item.fecha | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">{{item.namePartner}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">\n{{item.ammount | currency: \'$\' : 2}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">{{item.cancelado}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">{{item.paymentMethod}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">{{item.reference}}</td></tr>\n</tbody></table><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total</span>\n<div><span>{{tpv.total | currency: \'$\' : 2}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total Sucursal</span><div><span>\n{{group.total | currency: \'$\' : 2}}</span></div></div></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><span>TOTAL INGRESOA CON TPV:</span><div><span>{{vm.total | currency: \'$\' : 2}}</span>\n</div></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-cuenta-contable/layout-desglosado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE DE CAJA POR CUENTA CONTABLE</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\">\n<span class=\"title\" ng-if=\"vm.reportData.report.parameters[0].value.type == 1\">\nPor fecha del {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}} \n</span><span class=\"title\" ng-if=\"vm.reportData.report.parameters[0].value.type == 2\">\nPor folio del {{vm.reportData.report.parameters[0].value.from}} al {{vm.reportData.report.parameters[0].value.to}}\n</span></div><div class=\"info\"><div class=\"title\">Turno: <span>{{vm.reportData.report.parameters[1].value}}</span><br>\nSucursal(es): <span ng-repeat=\"item in vm.reportData.report.parameters[2].value\">{{item.name}},</span><br>Usuario(s): \n<span ng-repeat=\"item in vm.reportData.report.parameters[3].value\">{{item.name}} {{item.fatherLastname}},</span></div>\n</div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"group in vm.group\"><h3 class=\"report-group-1\">{{group.key}}</h3><div \nng-repeat=\"groupType in group.groupType\" class=\"ml-20\"><h3 class=\"report-group-2\">{{groupType.key}}</h3><div \nng-repeat=\"groupAccount in groupType.groupAccount\" class=\"ml-20\"><h3 class=\"report-group-2b\" \nng-if=\"groupAccount.key !== \'\'\">Cuenta contable: {{groupAccount.key}}</h3><div \nng-repeat=\"subgroup in groupAccount.groupDate\" class=\"ml-20\"><h3 class=\"report-group-3\">\n{{subgroup.key | date: \'dd/MM/yyyy\'}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\">No</th><th class=\"text-center\">Folio</th><th class=\"text-center\">Hora</th><th class=\"text-center\">\nNo Familia</th><th class=\"text-center\">A quien se facturo</th><th class=\"text-center\">Socio</th><th \nclass=\"text-center\">Subtotal</th><th class=\"text-center\">Descuento</th><th class=\"text-center\">IVA</th><th>Total</th>\n</tr></thead><tbody><tr ng-repeat=\"item in subgroup.items\"><td class=\"text-center\">{{item.number}}</td><td \nclass=\"text-center\">{{item.folio}}</td><td class=\"text-center\">{{item.hora | date: \'HH:mm\' }}</td><td \nclass=\"text-center\">{{item.sequentialNumber}}</td><td>{{item.razonSocial}}</td><td>{{item.partnerName}}</td><td \nclass=\"text-right\">{{item.subtotal | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{item.discountAmmount | currency: \'$\': 2 }}</td><td class=\"text-right\">{{item.iva | currency: \'$\': 2 }}</td><td \nclass=\"text-right\">{{item.total | currency: \'$\': 2 }}</td></tr><tr class=\"subtotals\"><td colspan=\"6\">Subtotales</td><td\n class=\"text-right\">{{subgroup.items | sum: \'subtotal\' | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{subgroup.items | sum: \'discountAmmount\' | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{subgroup.items | sum: \'iva\' | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{subgroup.items | sum: \'total\' | currency: \'$\': 2 }}</td></tr></tbody></table></div></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Subtotal por metodo</span><div><span>\nSubtotal: {{groupType.items | sum: \'subtotal\' | currency: \'$\': 2 }}</span> <span class=\"ml-20\">\nDescuento: {{groupType.items | sum: \'discountAmmount\' | currency: \'$\': 2 }}</span> <span class=\"ml-20\">\nIVA: {{groupType.items | sum: \'iva\' | currency: \'$\': 2 }}</span> <span class=\"ml-20\">\nTotal: {{groupType.items | sum: \'total\' | currency: \'$\': 2 }}</span></div></div></div></div><hr><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\"><span>Total general</span><div><span>\nSubtotal: {{ vm.subtotal | currency: \'$\' : 2}}</span> <span class=\"ml-20\">\nDescuento: {{ vm.discountAmmount | currency: \'$\' : 2}}</span> <span class=\"ml-20\">IVA: {{ vm.iva | currency: \'$\' : 2}}\n</span> <span class=\"ml-20\">Total: {{ vm.total | currency: \'$\' : 2}}</span></div></div><div layout=\"row\" \nlayout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"70\"><thead><tr><th \nclass=\"text-center\">Sucursal</th><th class=\"text-center\">Recibos</th><th class=\"text-center\">Facturas</th><th \nclass=\"text-center\">Notas de crédito</th><th class=\"text-center\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.summary\"><td class=\"text-left\">{{item.branch}}</td><td class=\"text-right\">\n{{item.receiptTotal | currency: \'$\': 2}}</td><td class=\"text-right\">{{item.invoiceTotal | currency: \'$\': 2}}</td><td \nclass=\"text-right ng-class: vm.reportData.report.parameters[5].value.id == 1 ? \'text-include\' : \'text-exclude\'\">\n{{item.ncTotal | currency: \'$\': 2}}</td><td class=\"text-right\">\n{{(item.receiptTotal + item.invoiceTotal - (vm.reportData.report.parameters[5].value.id == 1 ? item.ncTotal : 0)) | currency: \'$\': 2}}\n</td></tr></tbody></table></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button>\n</cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-due/layout-consolidado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE POR CUOTA (CONSOLIDADO)</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Producto(s): <span \nng-repeat=\"item in vm.reportData.report.parameters[3].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><table class=\"simple report-table\">\n<tbody><tr ng-repeat=\"group in vm.group\"><td><h4 class=\"report-group-1\">{{group.key}}</h4><table \nclass=\"pl-50 simple report-table w-600 mt-0\"><thead><tr><th class=\"text-center\">Cuota</th><th \nclass=\"w-150 text-center\">Cantidad</th><th class=\"w-200 text-center\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in group.items\"><td>{{item.dueName}}</td><td class=\"text-center\">{{item.quantity}}</td><td \nclass=\"text-right pr-20\">{{item.total | currency: \'$\' : 2}}</td></tr><tr><td colspan=\"2\"><strong>Subtotal por Sucursal\n</strong></td><td class=\"text-right pr-20\"><span class=\"report-subtotals\">\n{{group.items | sum:\'total\' | currency: \'$\': 2 }}</span></td></tr></tbody></table></td></tr></tbody></table><div \nclass=\"text-right pr-20\"><span class=\"report-totals\">Total: {{vm.reportData.data | sum: \'total\' | currency: \'$ \': 2 }}\n</span></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-due/layout-desglosado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE POR CUOTA (DESGLOSADO)</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Cuota(s): <span \nng-repeat=\"item in vm.reportData.report.parameters[3].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div ng-repeat=\"group in vm.group\"><h3 \nclass=\"report-group-1\">{{group.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\" ng-if=\"group.items[0].date\">Fecha</th><th class=\"text-center\">No Familia</th><th \nclass=\"text-center\">Nombre</th><th class=\"text-center\">Tipo</th><th class=\"text-center\">Monto</th><th \nclass=\"text-center\">Responsable</th></tr></thead><tbody><tr ng-repeat=\"item in group.items\"><td class=\"text-center\" \nng-if=\"item.date\">{{item.date|date:\'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.sequentialNumber}}</td><td>\n{{item.partnerName}}</td><td class=\"text-center\">{{item.partnerType}}</td><td class=\"text-right\">\n{{item.total | currency: \'$\': 2 }}</td><td>{{item.sellerName}}</td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Subtotal por cuota</span><div><span>\n{{group.items | sum: \'total\' | currency: \'$\' : 2}}</span></div></div></div><hr><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\"><span>Total general</span><div><span>\n{{ vm.reportData.data | sum: \'total\' | currency: \'$\' : 2}}</span></div></div></div></div><div class=\"page-break\"></div>\n</div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-facturas/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nDATOS RECIBOS / FACTURAS</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><table \nclass=\"simple report-table font-small\"><thead><tr><th class=\"text-center\">O.Fecha</th><th class=\"text-center\">O.No</th>\n<th class=\"text-center\">O.Importe</th><th class=\"text-center\">O.Interes</th><th class=\"text-center\">O.Descuento</th><th\n class=\"text-center\">O.Total</th><th class=\"text-center\">F.Fecha</th><th class=\"text-center\">F.No</th><th \nclass=\"text-center\">F.Importe</th><th class=\"text-center\">F.Descuento</th><th class=\"text-center\">F.Iva</th><th \nclass=\"text-center\">F.Total</th><th class=\"text-center\">F.Estado</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.reportData.data\"><td class=\"text-center\">{{item.orderDate | date: \'dd/MM/yyyy HH:mm\'}}</td><td \nclass=\"text-center\">{{item.orderFolio}}</td><td class=\"text-right\">{{item.orderSubtotal | currency: \'$\': 2 }}</td><td \nclass=\"text-right\">{{item.orderInterest | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{item.orderDiscount | currency: \'$\': 2 }}</td><td class=\"text-right\">{{item.orderTotal | currency: \'$\': 2 }}</td><td \nclass=\"text-center\">{{item.invoiceDate | date: \'dd/MM/yyyy HH:mm\'}}</td><td class=\"text-center\">{{item.invoiceFolio}}\n</td><td class=\"text-right\">{{item.invoiceSubtotal | currency: \'$\': 2 }}</td><td class=\"text-right\">\n{{item.invoiceDiscount | currency: \'$\': 2 }}</td><td class=\"text-right\">{{item.invoiceIva | currency: \'$\': 2 }}</td><td\n class=\"text-right\">{{item.invoiceTotal | currency: \'$\': 2 }}</td><td class=\"text-center\">{{item.invoiceState}}</td>\n</tr></tbody></table><hr></div></div><div class=\"page-break\"></div></div><cd-export-excel-button>\n</cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-forma-pago/layout-consolidado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE POR FORMA DE PAGO (CONSOLIDADO)</span></div><div class=\"report-subtitle\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><table class=\"simple report-table\">\n<tbody><tr ng-repeat=\"group in vm.group\"><td><h4 class=\"report-group-1\">{{group.key}}</h4><table \nclass=\"pl-50 simple report-table w-500 mt-0\"><thead><tr><th class=\"text-center\">Forma de pago</th><th \nclass=\"w-150 text-center\">Total</th><th>% Representa de la sucursal</th><th>% Representa del total</th></tr></thead>\n<tbody><tr ng-repeat=\"item in group.items\"><td class=\"text-center\">{{item.paymentMethod | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-right pr-20\">{{item.total | currency: \'$\' : 2}}</td><td class=\"text-center\">\n{{item.branchPercentage | number: 2}}</td><td class=\"text-center\">{{item.totalPercentage | number: 2}}</td></tr><tr>\n<td></td><td class=\"text-right pr-20\"><span class=\"report-subtotals\">{{group.items | sum:\'total\' | currency: \'$\': 2 }}\n</span></td><td></td></tr></tbody></table></td></tr></tbody></table><div class=\"text-right w-500\"><span \nclass=\"report-totals\">Total: {{vm.reportData.data | sum: \'total\' | currency: \'$ \': 2 }}</span></div></div></div><div \nclass=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-forma-pago/layout-desglosado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE POR FORMA DE PAGO (DESGLOSADO)</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\">\n<span class=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div ng-repeat=\"group in vm.group\"><h3 \nclass=\"report-group-1\">{{group.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\">No Recibo</th><th class=\"text-center\">No Factura</th><th class=\"text-center\">No Familia</th><th \nclass=\"text-center\">Socio</th><th class=\"text-center\">A quien se facturo</th><th class=\"text-center\">Forma de pago</th>\n<th class=\"text-center\">Banco</th><th class=\"text-center\">Importe</th><th class=\"text-center\">Referencia</th><th \nclass=\"text-center\">Usuario</th></tr></thead><tbody><tr ng-repeat=\"item in group.items\"><td class=\"text-center\">\n{{item.orderFolio}}</td><td class=\"text-center\">{{item.invoiceFolio}}</td><td class=\"text-center\">\n{{item.sequentialNumber}}</td><td class=\"text-center\">{{item.partnerName}}</td><td>{{item.InvoiceRazonSocial}}</td><td \nclass=\"text-center\">{{item.paymentMethod}}</td><td class=\"text-center\">{{item.paymentMethodOption}}</td><td \nclass=\"text-right\">{{item.ammount | currency: \'$\': 2 }}</td><td class=\"text-center\">{{item.reference}}</td><td>\n{{item.sellerName}}</td></tr></tbody></table><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><span>Subtotal por sucursal</span><div><span>\nSubtotal: {{group.items | sum: \'ammount\' | currency: \'$\' : 2}}</span></div></div></div><hr><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\"><span>Total general</span><div><span>\nTotal: {{ vm.reportData.data | sum: \'ammount\' | currency: \'$\' : 2}}</span></div></div></div></div><div \nclass=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-notas-credito/layout.html","<div class=\"report-horizontal page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nNOTAS DE CREDITO</span></div><div class=\"info\"><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\">\n<span class=\"title\">\nPor fecha del {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}</h3><table \nclass=\"simple report-table font-small\"><thead><tr><th class=\"w-50 text-center\">Fecha</th><th class=\"w-150 text-center\">\nFolio De La Nota De Crédito</th><th class=\"w-150 text-center\">Folio De La Factura De La Que Proviene</th><th \nclass=\"w-150 text-center\">Fecha De La Factura Origen</th><th class=\"w-100 text-center\">Es Por El Total</th><th \nclass=\"w-150 text-center\">Total Monto De Factura Origen</th><th class=\"w-50 text-center\">Nombre</th><th \nclass=\"w-50 text-center\">Concepto</th><th class=\"w-50 text-center\">Totales</th></tr></thead><tbody><tr \nng-repeat=\"item in group.items\"><td class=\"text-center\">{{item.fechaNC | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-center\">{{item.folioNC}}</td><td class=\"text-center\">{{item.folioFactura}}</td><td class=\"text-center\">\n{{item.fechaFac | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.esTotal}}</td><td class=\"text-center\">\n{{item.total | currency: \'$\' : 2}}</td><td class=\"text-center\">{{item.namePartner}}</td><td class=\"text-center\">\n{{item.notes}}</td><td class=\"text-center\">{{item.ncTotal | currency: \'$\' : 2}}</td></tr><tr><td class=\"text-center\">\n</td><td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\">\n</td><td class=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"><b>Total</b></td><td \nclass=\"text-center\">{{group.total | currency: \'$\' : 2}}</td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\"><tbody><tr><td>\nNo. de notas de credito en el periodo sucrusal</td><td>{{group.totalItems}}</td><td></td></tr><tr><td></td><td></td>\n<td>Total</td></tr><tr><td>Notas de crédito aplicadas en su totalidad sucursal</td><td>{{group.totalItemsNoParciales}}\n</td><td>{{group.noParciales | currency: \'$\' : 2}}</td></tr><tr><td>Notas de crédito parciales sucursal</td><td>\n{{group.totalItemsParciales}}</td><td>{{group.parciales | currency: \'$\' : 2}}</td></tr></tbody></table></div><br><hr \nwidth=\"100%\" noshade=\"noshade\"><br></div><div layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\">\n<table class=\"totales simple report-table\" flex=\"50\"><tbody><tr><td>No. de notas de credito en el periodo</td><td>\n{{vm.totalItems}}</td><td>{{vm.total | currency: \'$\' : 2}}</td></tr><tr><td>Notas de crédito aplicadas en su totalidad\n</td><td>{{vm.totalItemsNoParciales}}</td><td>{{vm.noParciales | currency: \'$\' : 2}}</td></tr><tr><td>\nNotas de crédito parciales</td><td>{{vm.totalItemsParciales}}</td><td>{{vm.parciales | currency: \'$\' : 2}}</td></tr>\n</tbody></table></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button>\n</div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-products/layout-consolidado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE POR PRODUCTO (CONSOLIDADO)</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\">\n<span class=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Producto(s): <span \nng-repeat=\"item in vm.reportData.report.parameters[3].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><table class=\"simple report-table\">\n<tbody><tr ng-repeat=\"group in vm.group\"><td><h4 class=\"report-group-1\">{{group.key}}</h4><table \nclass=\"pl-50 simple report-table w-600 mt-0\"><thead><tr><th class=\"text-center\">Producto</th><th \nclass=\"w-150 text-center\">Cantidad</th><th class=\"w-200 text-center\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in group.items\"><td>{{item.productName}}</td><td class=\"text-center\">{{item.quantity}}</td><td \nclass=\"text-right pr-20\">{{item.total | currency: \'$\' : 2}}</td></tr><tr><td colspan=\"2\"><strong>Subtotal por Sucursal\n</strong></td><td class=\"text-right pr-20\"><span class=\"report-subtotals\">\n{{group.items | sum:\'total\' | currency: \'$\': 2 }}</span></td></tr></tbody></table></td></tr></tbody></table><div \nclass=\"text-right pr-20\"><span class=\"report-totals\">Total: {{vm.reportData.data | sum: \'total\' | currency: \'$ \': 2 }}\n</span></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/corte-products/layout-desglosado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nCORTE POR PRODUCTO (DESGLOSADO)</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span\n class=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Producto(s): <span \nng-repeat=\"item in vm.reportData.report.parameters[3].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div ng-repeat=\"group in vm.group\"><h3 \nclass=\"report-group-1\">{{group.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\" ng-if=\"group.items[0].date\">Fecha</th><th class=\"text-center\">No Familia</th><th \nclass=\"text-center\">Nombre</th><th class=\"text-center\">Tipo</th><th class=\"text-center\">Monto</th><th \nclass=\"text-center\">Responsable</th></tr></thead><tbody><tr ng-repeat=\"item in group.items\"><td class=\"text-center\" \nng-if=\"item.date\">{{item.date|date:\'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.sequentialNumber}}</td><td>\n{{item.partnerName}}</td><td class=\"text-center\">{{item.partnerType}}</td><td class=\"text-right\">\n{{item.total | currency: \'$\': 2 }}</td><td>{{item.sellerName}}</td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Subtotal por producto</span><div><span>\n{{group.items | sum: \'total\' | currency: \'$\' : 2}}</span></div></div></div><hr><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\"><span>Total general</span><div><span>\n{{ vm.reportData.data | sum: \'total\' | currency: \'$\' : 2}}</span></div></div></div></div><div class=\"page-break\"></div>\n</div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/cortes-caja/document-cancel/layout.html","<div class=\"report-horizontal page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nDocumentos Cancelados</span></div><div class=\"info\"><div class=\"report-subtitle\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\">\nPor fecha del {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}</h3><div \nng-repeat=\"orderType in group.orderTypes\" class=\"ml-20\"><h3 class=\"report-group-2\">{{orderType.key}}S</h3><table \nclass=\"simple report-table font-small\"><thead><tr><th class=\"w-50 text-center\">{{orderType.key}}</th><th \nclass=\"w-50 text-center\">Fecha Docto</th><th class=\"w-50 text-center\">Fecha Cancelación</th><th \nclass=\"w-50 text-center\">Familia</th><th class=\"w-100 text-center\">Razón Social</th><th class=\"w-50 text-center\">\nImporte</th><th class=\"w-50 text-center\">Iva</th><th class=\"w-50 text-center\">Total</th><th \nng-show=\"orderType.key == \'FACTURA\'\" class=\"w-50 text-center\">NO FACTURA ORIGEN</th><th \nng-show=\"orderType.key == \'FACTURA\'\" class=\"w-50 text-center\">UUID</th><th ng-show=\"orderType.key == \'FACTURA\'\" \nclass=\"w-50 text-center\">GLOBAL</th><th ng-show=\"orderType.key == \'FACTURA\'\" class=\"w-50 text-center\">MONTO FACT GLOBAL\n</th></tr></thead><tbody><tr ng-repeat=\"item in orderType.items\"><td class=\"text-center\">{{item.folio}}</td><td \nclass=\"text-center\">{{item.fecha | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">\n{{item.insertDate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.sequentialNumber}}</td><td \nclass=\"text-center\">{{item.partnerName}}</td><td class=\"text-center\">{{item.importe | currency: \'$\' : 2}}</td><td \nclass=\"text-center\">{{item.iva | currency: \'$\' : 2}}</td><td class=\"text-center\">{{item.total | currency: \'$\' : 2}}\n</td><td ng-show=\"orderType.key == \'FACTURA\'\" class=\"text-center\">{{item.facturaOrigen}}</td><td \nng-show=\"orderType.key == \'FACTURA\'\" class=\"text-center\">{{item.uuids}}</td><td ng-show=\"orderType.key == \'FACTURA\'\" \nclass=\"text-center\">{{item.global}}</td><td ng-show=\"orderType.key == \'FACTURA\'\" class=\"text-center\">\n{{item.montoGlobal | currency: \'$\' : 2}}</td></tr><tr><td class=\"text-center\"></td><td class=\"text-center\"></td><td \nclass=\"text-center\"></td><td class=\"text-center\"></td><td class=\"text-center\"><b>TOTALES</b></td><td \nclass=\"text-center\"><b>{{orderType.ImporteTotal | currency: \'$\' : 2}}</b></td><td class=\"text-center\"><b>\n{{orderType.IvaTotal | currency: \'$\' : 2}}</b></td><td class=\"text-center\"><b>\n{{orderType.TotalTotal | currency: \'$\' : 2}}</b></td><td ng-show=\"orderType.key == \'FACTURA\'\" class=\"text-center\"></td>\n<td ng-show=\"orderType.key == \'FACTURA\'\" class=\"text-center\"></td><td ng-show=\"orderType.key == \'FACTURA\'\" \nclass=\"text-center\"></td><td ng-show=\"orderType.key == \'FACTURA\'\" class=\"text-center\"></td></tr></tbody></table></div>\n<div layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\">\n<tbody><tr><td>TOTALES SUCURSAL</td><td></td></tr><tr ng-repeat=\"orderType in group.orderTypes\"><td>\n{{orderType.key}}S Cancelados</td><td>{{orderType.TotalTotal | currency: \'$\' : 2}}</td></tr><tr><td>TOTAL SUCURSAL</td>\n<td>{{group.TotalTotal | currency: \'$\' : 2}}</td></tr></tbody></table></div></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>TOTAL:</span><div><span>\n{{vm.TotalTotal | currency: \'$\' : 2}}</span></div></div></div></div><div class=\"page-break\"></div></div>\n<cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/exports/general/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE EXPORTACION GENERAL</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content\" layout=\"column\" layout-align=\"center center excel-exportable\"><a href=\"{{vm.report}}\">Descargar</a>\n</div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/reports/views/reports/exports/generalIntelisis/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE EXPORTACION GENERAL INTELISIS</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\">\n<div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content\" layout=\"column\" layout-align=\"center center excel-exportable\"><a href=\"{{vm.report}}\">Descargar</a>\n</div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/reports/views/reports/exports/generalIntelisisRecip/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE EXPORTACION GENERAL INTELISIS RECIBOS</span></div></div><div class=\"issuer\" layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div>\n</div></div><div class=\"content\" layout=\"column\" layout-align=\"center center excel-exportable\"><a href=\"{{vm.report}}\">\nDescargar</a></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/reports/views/reports/ingresos/otros/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE OTROS INGRESOS</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><table class=\"simple report-table font-small\"><thead><tr><th class=\"text-center\">Fecha\n</th><th class=\"text-center\">Cantidad</th><th class=\"text-center\">Producto</th><th class=\"text-center\">Precio</th><th \nclass=\"text-center\">Importe</th></tr></thead><tbody><tr ng-repeat=\"item in vm.reportData.data\" \nng-class=\"{\'canceled\': item.isCanceled }\"><td class=\"text-center\">{{item.insertDate | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-center\">{{item.quantity}}</td><td class=\"text-center\">{{item.productName}}</td><td class=\"text-center\">\n{{item.price | currency: \'$\' : 2}}</td><td class=\"text-center\">{{item.total | currency: \'$\' : 2}}</td></tr></tbody>\n</table></div></div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/ingresos/general/layout-consolidado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nINGRESOS GENERALES (CONSOLIDADO)</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\">\n<span class=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 \nclass=\"report-group-1\">Sucursal: {{group.key}}</h3><div ng-repeat=\"sellerGroup in group.sellerGroup\" class=\"ml-20\"><h3 \nclass=\"report-group-2\">Vendedor: {{sellerGroup.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"w-150 text-center\">Tipo de Ingreso</th><th class=\"aling-right\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in sellerGroup.items\"><td class=\"text-center\">{{item.tipoIngreso}}</td><td class=\"text-right pr-20\">\n{{item.total | currency: \'$\' : 2}}</td></tr><tr class=\"subtotals\"><td colspan=\"5\">Total por Vendedor</td><td \nclass=\"text-right\">{{sellerGroup.total | currency: \'$\' : 2}}</td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total por Sucursal</span><div><span>\n{{group.total | currency: \'$\' : 2}}</span></div></div></div><div class=\"text-right w-500\"><span class=\"report-totals\">\nTotal: {{vm.reportData.data | sum: \'total\' | currency: \'$ \': 2 }}</span></div></div></div><div class=\"page-break\">\n</div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/ingresos/general/layout-desglosado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nINGRESOS GENERALES</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 \nclass=\"report-group-1\">Sucursal: {{group.key}}</h3><div ng-repeat=\"sellerGroup in group.sellerGroup\" class=\"ml-20\"><h3 \nclass=\"report-group-2\">Vendedor: {{sellerGroup.key}}</h3><div \nng-repeat=\"typeIncomeGroup in sellerGroup.typeIncomeGroup\" class=\"ml-20\"><h3 class=\"report-group-3\">\nTipo ingreso: {{typeIncomeGroup.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"w-100 text-center\">Fecha</th><th class=\"w-150 text-center\">Descripción</th><th class=\"w-150 text-center\">Socio\n</th><th class=\"w-100 text-center\">No. Familia</th><th class=\"w-100 text-center\">No. Documento</th><th \nclass=\"w-150 text-center\">Forma de pago</th><th class=\"aling-right\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in typeIncomeGroup.items\"><td class=\"text-center\">{{item.insertDate | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-center\">{{item.descriptionItem}}</td><td class=\"text-center\">{{item.partnerName}}</td><td \nclass=\"text-center\">{{item.familyId}}</td><td class=\"text-center\">{{item.folio}}</td><td class=\"text-center\">\n{{item.namePaymentMethods}}<span ng-if=\"item.countMethodPayment != 1\">*</span></td><td class=\"text-right pr-20\">\n{{item.total | currency: \'$\' : 2}}</td></tr><tr class=\"subtotals\"><td colspan=\"5\">Total por tipo de ingreso</td><td \nclass=\"text-right\">{{typeIncomeGroup.total | currency: \'$\' : 2}}</td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total por Vendedor</span><div><span>\n{{sellerGroup.total | currency: \'$\' : 2}}</span></div></div></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><span>Total por Sucursal</span><div><span>{{group.total | currency: \'$\' : 2}}</span>\n</div></div></div><div class=\"text-right w-500\"><span class=\"report-totals\">\nTotal: {{vm.reportData.data | sum: \'total\' | currency: \'$ \': 2 }}</span></div></div></div><div class=\"page-break\">\n</div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/servicios/rentables/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">RENTABLES\n</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}</h3><div \nng-repeat=\"tipoCasillero in group.tipoCasillero\" class=\"ml-20\"><h3 class=\"report-group-2\">\nTipo de Casillero: {{tipoCasillero.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"w-50 text-center\">Casillero</th><th class=\"w-150 text-center\">Usuario</th><th class=\"w-150 text-center\">\nPagado Hasta</th><th class=\"w-150 text-center\">Vencido</th><th class=\"w-100 text-center\">Periodicidad</th></tr></thead>\n<tbody><tr ng-repeat=\"item in tipoCasillero.items\"><td class=\"text-center\">{{item.casillero}}</td><td \nclass=\"text-center\">{{item.namePartner}}</td><td class=\"text-center\">{{item.payedDate | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-center\">{{item.vencido}}</td><td class=\"text-center\">{{item.periodicidad}}</td></tr></tbody></table><br><hr\n width=\"100%\" noshade=\"noshade\"><br><div layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table \nclass=\"simple report-table\" flex=\"50\"><tbody><tr><td class=\"text-center\"><b>TOTAL OCUPADOS</b></td><td \nclass=\"text-center\">{{tipoCasillero.ocupados}}</td></tr><tr><td class=\"text-center\"><b>TOTAL DISPONIBLES</b></td><td \nclass=\"text-center\">{{tipoCasillero.disponibles}}</td></tr><tr><td class=\"text-center\"><b>TOTAL</b></td><td \nclass=\"text-center\">{{tipoCasillero.total}}</td></tr><tr><td class=\"text-center\"><b>TOTAL VENCIDOS</b></td><td \nclass=\"text-center\"><b>{{tipoCasillero.vencidos}}</b></td></tr><tr><td class=\"text-center\"><b>TOTAL VIGENTES</b></td>\n<td class=\"text-center\"><b>{{tipoCasillero.vigentes}}</b></td></tr></tbody></table></div></div><br><hr width=\"100%\" \nnoshade=\"noshade\"><br><span><b>TOTALES</b></span><br><br><div layout=\"row\" layout-align=\"center start\" \nclass=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"80\"><tbody><tr \nng-repeat=\"tipoCasilleros in group.tipoCasillero\"><td class=\"text-center\">{{tipoCasilleros.key}}</td><td \nclass=\"text-center\">{{tipoCasilleros.ocupados}}</td></tr><tr><td class=\"text-center\">CASILLEROS DISPONIBLES</td><td \nclass=\"text-center\"><b>{{group.disponibles}}</b></td></tr><tr><td class=\"text-center\"><b>TOTAL</b></td><td \nclass=\"text-center\"><b>{{group.total}}</b></td></tr><tr><td class=\"text-center\"><b>TOTAL VENCIDOS</b></td><td \nclass=\"text-center\"><b>{{group.vencidos}}</b></td></tr><tr><td class=\"text-center\"><b>TOTAL VIGENTES</b></td><td \nclass=\"text-center\"><b>{{group.vigentes}}</b></td></tr></tbody></table></div></div></div></div><div class=\"page-break\">\n</div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/prospectos/general/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">PROSPECTOS\n</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nDel {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[1].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 \nclass=\"report-group-1\">Sucursal: {{group.key}}</h3><div ng-repeat=\"sellerGroup in group.sellerGroup\" class=\"ml-20\"><h3 \nclass=\"report-group-2\">Vendedor: {{sellerGroup.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"w-100 text-center\">Fecha</th><th class=\"w-130 text-center\">Nombre prospecto</th><th class=\"w-100 text-center\">\nTeléfono</th><th class=\"w-130 text-center\">Medio por el que se entero</th><th class=\"w-130 text-center\">E-mail</th><th \nclass=\"w-50 text-center\">Inscrito</th><th class=\"w-50 text-center\">Hizo cita</th></tr></thead><tbody><tr \nng-repeat=\"item in sellerGroup.items\"><td class=\"text-center\">{{item.insertDate | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-center\">{{item.nombreProspecto}}</td><td class=\"text-center\">{{item.phone}}</td><td class=\"text-center\">\n{{item.medio}}</td><td class=\"text-center\">{{item.email}}</td><td class=\"text-center\">{{item.inscrito}}</td><td \nclass=\"text-center\">{{item.cita}}</td></tr></tbody></table></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><table class=\"simple report-table\"><thead><tr><th class=\"w-200 text-center\">Vendedor</th>\n<th class=\"w-200 text-center\">Inscritos</th><th class=\"w-100 text-center\">No inscritos</th><th \nclass=\"w-100 text-center\">Total</th></tr></thead><tbody><tr ng-repeat=\"sellerGroup in group.sellerGroup\"><td \nclass=\"text-center\">{{sellerGroup.key}}</td><td class=\"text-center\">{{sellerGroup.totalInscritos}}</td><td \nclass=\"text-center\">{{sellerGroup.totalNoInscritos}}</td><td class=\"text-center\">{{sellerGroup.items.length}}</td></tr>\n<tr><td class=\"text-center\"><b>Total sucursal</b></td><td class=\"text-center\">\n{{group.sellerGroup | sum: \'totalInscritos\'}}</td><td class=\"text-center\">\n{{group.sellerGroup | sum: \'totalNoInscritos\'}}</td><td class=\"text-center\">{{group.items.length}}</td></tr></tbody>\n</table></div></div><div layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table \nclass=\"simple report-table\"><thead><tr><th class=\"w-200 text-center\">Sucursal</th><th class=\"w-200 text-center\">\nInscritos</th><th class=\"w-100 text-center\">No inscritos</th><th class=\"w-100 text-center\">Total</th></tr></thead>\n<tbody><tr ng-repeat=\"group in vm.groups\"><td class=\"text-center\">{{group.key}}</td><td class=\"text-center\">\n{{group.totalInscritos}}</td><td class=\"text-center\">{{group.totalNoInscritos}}</td><td class=\"text-center\">\n{{group.items.length}}</td></tr><tr><td class=\"text-center\"><b>Totales</b></td><td class=\"text-center\"><b>\n{{vm.groups | sum: \'totalInscritos\'}}</b></td><td class=\"text-center\"><b>{{vm.groups | sum: \'totalNoInscritos\'}}</b>\n</td><td class=\"text-center\"><b>{{vm.reportData.data.length}}</b></td></tr></tbody></table></div></div></div><div \nclass=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/activos/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS ACTIVOS</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><table class=\"simple report-table font-small\"><thead><tr><th class=\"text-center\">Número de membresia</th><th \nclass=\"text-center\">Nombre de Socio</th><th class=\"text-center\">Tipo de membresia</th><th class=\"text-center\">\nRecurrente</th><th class=\"text-center\">Periodicidad</th><th class=\"text-center\">Fecha de vigencia</th></tr></thead>\n<tbody><tr ng-repeat=\"item in group.items\" ng-class=\"{\'canceled\': item.isCanceled }\"><td class=\"text-center\">\n{{item.id}}</td><td class=\"text-center\">{{item.namePartner}}</td><td class=\"text-center\">{{item.membershipType}}</td>\n<td class=\"text-center\">{{item.recurrente}}</td><td class=\"text-center\">{{item.periodo}}</td><td class=\"text-center\">\n{{item.fechaVigencia | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table><hr width=\"70%\" noshade=\"noshade\"></div></div>\n</div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/agesRange/layout-consolidado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS POR EDAD (CONSOLIDADO)</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Rango(s) de edad: <span \nng-repeat=\"item in vm.reportData.report.parameters[1].value\">{{item.from}}-{{item.to}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\" layout=\"column\" \nlayout-align=\"center center\"><div ng-repeat=\"branchGroup in vm.branchGroups\" class=\"w-400\" flex><h3 \nclass=\"report-group-1\">Sucursal: {{branchGroup.key}}</h3><table \nclass=\"simple report-table font-medium ml-20 w-350 border\"><thead><tr><th class=\"text-center\">Grupo</th><th \nclass=\"text-center\">No Socios</th></tr></thead><tbody><tr ng-repeat=\"item in branchGroup.items\"><td \nclass=\"text-center\">{{item.ageRange}}</td><td class=\"text-center\">{{item.total}}</td></tr></tbody></table><div \nlayout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total por Sucursal</span><div>\n<span>{{branchGroup.items | sum: \'total\'}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10 w-400\" flex><span>Total</span><div><span>\n{{vm.reportData.data | sum: \'total\'}}</span></div></div></div></div><div class=\"page-break\"></div></div>\n<cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/agesRange/layout-desglosado.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS POR EDAD (DESGLOSADO)</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Rango(s) de edad: <span \nng-repeat=\"item in vm.reportData.report.parameters[1].value\">{{item.from}}-{{item.to}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"branchGroup in vm.branchGroups\"><h3 class=\"report-group-1\">Sucursal: {{branchGroup.key}}</h3><div \nng-repeat=\"rangeGroup in branchGroup.rangeGroups\" class=\"ml-20\"><h3 class=\"report-group-2\">Socios {{rangeGroup.key}}\n</h3><table class=\"simple report-table font-small\"><thead><tr><th class=\"text-center\">No Familia</th><th \nclass=\"text-left\">Nombre de Socio</th><th class=\"text-center\">Fecha Nacimiento</th><th class=\"text-center\">\nCuota-Periodicidad</th><th class=\"text-center\">Edad</th></tr></thead><tbody><tr ng-repeat=\"item in rangeGroup.items\">\n<td class=\"text-center\">{{item.sequentialNumber}}</td><td class=\"text-left\">{{item.partnerName}}</td><td \nclass=\"text-center\">{{item.birthdate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">\n{{item.dueName}}-{{item.periodicityName}}</td><td class=\"text-center\">{{item.age}}</td></tr><tr class=\"subtotals\"><td \ncolspan=\"5\">Total por Rango de Edad</td><td class=\"text-right\">{{rangeGroup.items.length}}</td></tr></tbody></table>\n</div><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total por Sucursal\n</span><div><span>{{branchGroup.items.length}}</span></div></div></div><hr><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\"><span>Total</span><div><span>\n{{ vm.reportData.data.length}}</span></div></div><div layout=\"row\" layout-align=\"center start\" \nclass=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\"><thead><tr><th>Sucursal</th><th>Rango de Edad\n</th><th class=\"text-center\">No de Socios</th></tr></thead><tbody><tr ng-repeat=\"item in vm.summary\"><td>\n{{item.branch}}</td><td>{{item.ageRange}}</td><td class=\"text-center\">{{item.count}}</td></tr></tbody></table></div>\n</div></div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/ausencia/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nSocios por Ausencia</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><table class=\"simple report-table font-small\"><thead><tr><th class=\"w-100 text-center\">Id</th><th \nclass=\"w-250 text-center\">Nombre Completo</th><th class=\"w-100 text-center\">Descuento</th><th \nclass=\"w-100 text-center\">Inicio ausencia</th><th class=\"w-100 text-center\">Fin ausencia</th></tr></thead><tbody><tr \nng-repeat=\"item in group.items\"><td class=\"text-center\">{{item.id}}</td><td class=\"text-center\">{{item.namePartner}}\n</td><td class=\"text-center\">{{item.discountPercentage}}%</td><td class=\"text-center\">\n{{item.dateFrom | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.dateTo | date: \'dd/MM/yyyy\'}}</td></tr>\n</tbody></table><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total Sucursal\n</span><div><span>{{group.items.length}}</span></div></div></div></div></div><div class=\"page-break\"></div></div>\n<cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/altas/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS POR FECHA DE ALTA</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><div ng-repeat=\"membershipType in group.membershipType\" class=\"ml-20\"><h3 class=\"report-group-2\">\nTipo Membresia: {{membershipType.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\">No. membresia</th><th class=\"text-center\">Nombre de Socio</th><th class=\"text-center\">\nTipo de membresia</th><th class=\"text-center\">Domiciliado</th><th class=\"text-center\">Periodicidad</th><th \nclass=\"text-center\">Fecha de inscripción</th></tr></thead><tbody><tr ng-repeat=\"item in membershipType.items\" \nng-class=\"{\'canceled\': item.isCanceled }\"><td class=\"text-center\">{{item.id}}</td><td class=\"text-center\">\n{{item.namePartner}}</td><td class=\"text-center\">{{item.membershipType}}</td><td class=\"text-center\">\n{{item.domiciliado}}</td><td class=\"text-center\">{{item.periodo}}</td><td class=\"text-center\">\n{{item.inscriptionDate | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table><div layout=\"row\" layout-align=\"center start\" \nclass=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\"><thead><tr><th>Nombre periodo</th><th>Total\n</th></tr></thead><tbody><tr ng-repeat=\"periodo in membershipType.periodo\"><td>{{periodo.key}}</td><td>\n{{periodo.total}}</td></tr><tr><td><b>Total por tipo membresia</b></td><td><b>{{membershipType.total}}</b></td></tr>\n</tbody></table></div></div><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>\nTotal domiciliado en sucursal</span><div><span>{{group.totalDomicialiado}}</span></div><span>\nTotal No domiciliado en sucursal</span><div><span>{{group.totalNoDomicialiado}}</span></div><span>Total en sucursal\n</span><div><span>{{group.total}}</span></div></div><hr width=\"70%\" noshade=\"noshade\"></div><hr width=\"100%\" \nnoshade=\"noshade\"><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>\nTotal Domicialidiados</span><div><span>{{vm.totalDomicialiado}}</span></div><span>Total No domiciliados</span><div>\n<span>{{vm.totalNoDomicialiado}}</span></div><span>Total</span><div><span>{{vm.total}}</span></div></div><hr \nwidth=\"70%\" noshade=\"noshade\"><div ng-repeat=\"group in vm.groups\"><div layout=\"row\" layout-align=\"center start\" \nclass=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\"><thead><tr><th>Nombre periodo</th><th>Total\n</th></tr></thead><tbody><tr ng-repeat=\"periodo in group.periodo\"><td>{{periodo.key}}</td><td>{{periodo.total}}</td>\n</tr></tbody></table></div><hr width=\"70%\" noshade=\"noshade\"><div layout=\"row\" layout-align=\"center start\" \nclass=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\"><thead><tr><th>Nombre membresia</th><th>Total\n</th></tr></thead><tbody><tr ng-repeat=\"membershipType in group.membershipType\"><td>{{membershipType.key}}</td><td>\n{{membershipType.total}}</td></tr></tbody></table></div></div></div></div><div class=\"page-break\"></div></div>\n<cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/between-dates/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\">\nENTRE RANGO DE FECHAS</div><div class=\"info\"><div class=\"title\">Rango: <span class=\"title\">\nDel {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}}\n</span><br>Sucursal(es): <span ng-repeat=\"item in vm.reportData.report.parameters[1].value\">{{item.name}},</span></div>\n</div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"dueGroup in vm.dueGroups\"><h3 class=\"report-group-1\" layout=\"row\" layout-align=\"space-between start\"><span>\n{{dueGroup.key}}</span> <span class=\"pr-15\">{{dueGroup.items.length | number}}</span></h3><div \nng-repeat=\"periodicityGroup in dueGroup.periodicityGroups\"><h3 class=\"report-group-2\" layout=\"row\" \nlayout-align=\"space-between start\"><span>{{periodicityGroup.key | date: \'dd/MM/yyyy\'}}</span> <span class=\"pr-20\">\n{{ periodicityGroup.items.length | number}}</span></h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center w-80\">No Familia</th><th class=\"text-center w-200\">Cuota-Periodicidad</th><th class=\"text-center\">\nNombre</th><th class=\"text-center w-110\">Fecha de pago</th><th class=\"text-center w-80\">No Inscripción</th></tr>\n</thead><tbody><tr ng-repeat=\"item in periodicityGroup.items\"><td class=\"text-center\">{{item.sequentialNumber}}</td><td\n class=\"text-center\">{{item.duePeriodicityName}}</td><td>{{item.partnerName}}</td><td class=\"text-center\">\n{{item.payedDate | date: \'dd/MM/yyyy\'}}</td><td>{{item.inscriptionNumber}}</td></tr></tbody></table></div></div><hr>\n<div layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\">\n<thead><tr><th>Cuota</th><th>Periodicidad</th><th class=\"text-center\">Conteo</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.summary\"><td>{{item.due}}</td><td>{{item.periodicity}}</td><td class=\"text-center\">{{item.count}}\n</td></tr></tbody></table></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button>\n</cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/birthdate/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE CUMPLEAÑOS</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"g in vm.group\"><h3 class=\"report-group-1\">\n{{g.key}} - {{g.items[0].dueName}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\">No. Socio</th><th class=\"text-center\">Nombre</th><th class=\"text-center\">Tipo socio</th><th \nclass=\"text-center\">Fecha de nacimiento</th><th class=\"text-center\">Correo</th><th class=\"text-center\">Telefono</th><th\n class=\"text-center\">Años</th><th class=\"text-center\">Status</th></tr></thead><tbody><tr ng-repeat=\"item in g.items\" \nng-class=\"{\'canceled\': item.isCanceled }\"><td class=\"text-center\">{{item.id }}</td><td class=\"text-center\">\n{{item.nammePartner}}</td><td class=\"text-center\">{{item.membershipType}}</td><td class=\"text-center\">\n{{item.birthdate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.email}}</td><td class=\"text-center\">\n{{item.phone}}</td><td class=\"text-center\">{{item.age}}</td><td class=\"text-center\">{{item.partnerType}}</td></tr>\n</tbody></table><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>\nTotal de registros</span><div><span>{{g.items.length}}</span></div></div></div><hr></div></div><div class=\"page-break\">\n</div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/cargoautomatico/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS POR CARGO AUTOMATICO</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Rango de fechas: <span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"branchGroup in vm.branchGroups\"><h3 class=\"report-group-1\">Sucursal: {{branchGroup.key}}</h3><div \nng-repeat=\"pmg in branchGroup.paymentMethodGroups\" class=\"ml-20\"><h3 class=\"report-group-2\">Forma de pago: {{pmg.key}}\n</h3><div ng-repeat=\"pmog in pmg.paymentMethodOptionsGroups\" class=\"ml-20\"><h3 class=\"report-group-2\">\nOpción de Forma de pago: {{pmog.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-left\">Nombre de Socio</th><th class=\"text-center\">Número de tarjeta</th><th class=\"text-center\">\nValido Hasta</th><th class=\"text-center\">Monto</th><th class=\"text-center\">Contrato</th></tr></thead><tbody><tr \nng-repeat=\"item in pmog.items\"><td class=\"text-left\">{{item.partnerName}}</td><td class=\"text-center\">\n{{item.cardNumber}}</td><td class=\"text-center\">{{item.expirationDate | date : \'dd/MM/yyyy\'}}</td><td \nclass=\"text-right\">{{item.amount | currency: \'$\': 2}}</td><td class=\"text-right\">{{item.contractNumber}}</td></tr><tr \nclass=\"subtotals\"><td colspan=\"5\">Total por Opcion de Metodo de Pago</td><td class=\"text-right\">{{pmog.items.length}}\n</td></tr></tbody></table></div><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\">\n<span>Total por Metodo de Pago</span><div><span>{{pmg.items.length}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total por Sucursal</span><div><span>\n{{branchGroup.items.length}}</span></div></div></div><hr><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-totals p-10\"><span>Total</span><div><span>{{ vm.reportData.data.length}}</span></div></div><div \nlayout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"75\">\n<thead><tr><th>Sucursal</th><th>Metodo de pago</th><th>Opcion</th><th class=\"text-center\">No de Socios</th><th \nclass=\"text-center\">Total</th></tr></thead><tbody><tr ng-repeat=\"item in vm.summary\"><td>{{item.branch}}</td><td>\n{{item.pmName}}</td><td>{{item.pmoName}}</td><td class=\"text-center\">{{item.count}}</td><td class=\"text-right\">\n{{item.total | currency: \'$\': 2}}</td></tr></tbody></table></div></div></div><div class=\"page-break\"></div></div>\n<cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/byincscription-date/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nSOCIOS POR FECHA DE INSCRIPCIÓN</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span\n class=\"title\">\nDel {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}}\n</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[1].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 \nclass=\"report-group-1\">Sucursal: {{group.key}}</h3><div ng-repeat=\"mediaGroup in group.mediaGroup\" class=\"ml-20\"><h3 \nclass=\"report-group-2\">Medio: {{mediaGroup.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"w-100 text-center\">Fecha Inscripción</th><th class=\"w-130 text-center\">Nombre Socio</th><th \nclass=\"w-100 text-center\">Teléfono</th><th class=\"w-130 text-center\">E-mail</th></tr></thead><tbody><tr \nng-repeat=\"item in mediaGroup.items\"><td class=\"text-center\">{{item.inscriptionDate | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-center\">{{item.nombreProspecto}}</td><td class=\"text-center\">{{item.phone}}</td><td class=\"text-center\">\n{{item.email}}</td></tr></tbody></table></div><br><br><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-summary p-20\"><table class=\"simple report-table\"><thead><tr><th class=\"w-200 text-center\">Medio</th><th \nclass=\"w-100 text-center\">Total</th></tr></thead><tbody><tr ng-repeat=\"mediaGroup in group.mediaGroup\"><td \nclass=\"text-center\">{{mediaGroup.key}}</td><td class=\"text-center\">{{mediaGroup.items.length}}</td></tr><tr><td \nclass=\"text-center\"><b>Total de sucursal</b></td><td class=\"text-center\">{{group.items.length}}</td></tr></tbody>\n</table></div></div><div layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table \nclass=\"simple report-table\"><thead><tr><th class=\"w-200 text-center\">Sucursal</th><th class=\"w-100 text-center\">Total\n</th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td class=\"text-center\">{{group.key}}</td><td \nclass=\"text-center\">{{group.items.length}}</td></tr><tr><td class=\"text-center\"><b>Totales</b></td><td \nclass=\"text-center\"><b>{{vm.reportData.data.length}}</b></td></tr></tbody></table></div></div></div><div \nclass=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/cargoautomaticobanco/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS POR CARGO AUTOMATICO (BANCO)</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Rango de fechas: <span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content\"><table \nclass=\"excel-exportable simple report-table font-small\"><thead><tr><th class=\"text-left\"># Socio</th><th \nclass=\"text-center\">Número de tarjeta</th><th class=\"text-center\">Monto</th><th class=\"text-center\">Email</th><th \nclass=\"text-center\">Contrato</th></tr></thead><tbody><tr ng-repeat=\"item in vm.reportData.data\"><td class=\"text-left\">\n{{item.id}}</td><td class=\"text-center\">{{item.cardNumber}}</td><td class=\"text-center\">\n{{item.amount | currency: \'$\': 2}}</td><td class=\"text-center\">{{item.email}}</td><td class=\"text-center\">\n{{item.contractNumber}}</td></tr></tbody></table></div></div><div class=\"page-break\"></div></div>\n<cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/convenio/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nSocios por Convenio</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><div ng-repeat=\"agreement in group.agreements\" class=\"ml-20\"><h3 class=\"report-group-2\">\nConvenio: {{agreement.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th class=\"w-100 text-center\">\nContador</th><th class=\"w-300 text-center\">Número de familia</th><th class=\"w-600 text-center\">Nombre completo</th>\n</tr></thead><tbody><tr ng-repeat=\"item in agreement.items\"><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">{{$index + 1}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\' ? \'text-notaCredito\' : \'\'\">{{item.familyId}}</td><td \nclass=\"text-center ng-class: item.cancelado == \'Verdadero\'? \'text-notaCredito\' : \'\'\">{{item.partnerName}}</td></tr>\n</tbody></table><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total</span>\n<div><span>{{agreement.items.length}}</span></div></div></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><span>Total Sucursal</span><div><span>{{group.items.length}}</span></div></div></div><div\n layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\">\n<thead><tr><th>Nombre convenio</th><th>Total</th></tr></thead><tbody><tr ng-repeat=\"agreement in vm.agreements\"><td>\n{{agreement.key}}</td><td>{{agreement.items.length}}</td></tr><tr><td><b>TOTAL</b></td><td><b>\n{{vm.reportData.data.length}}</b></td></tr></tbody></table></div></div></div><div class=\"page-break\"></div></div>\n<cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/cupo/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE CUPO DE SOCIOS</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"branchGroup in vm.branchGroups\"><h3 class=\"report-group-1\">Sucursal: {{branchGroup.key}}</h3><div \nng-repeat=\"activityGroup in branchGroup.activityGroups\" class=\"ml-20\"><h3 class=\"report-group-2\">\nActividad: {{activityGroup.key}} - Cupo ({{activityGroup.items[0].quota}})</h3><table \nclass=\"simple report-table font-small\"><thead><tr><th class=\"text-center\">Socio</th><th class=\"text-center\">\nCuota-Periodicidad</th><th class=\"text-center\">Fecha de pago</th><th class=\"text-center\">No de Titular</th></tr>\n</thead><tbody><tr ng-repeat=\"item in activityGroup.items\"><td class=\"text-left\">{{item.partnerName}}</td><td \nclass=\"text-center\">{{item.dueName}}-{{item.periodicityName}}</td><td class=\"text-center\">\n{{item.payedDate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.sequentialNumber}}</td></tr><tr \nclass=\"subtotals\" ng-if=\"vm.reportData.report.parameters[1].value.id != 1\"><td colspan=\"5\">Total por Actividad</td><td \nclass=\"text-right\">{{activityGroup.items.length}}</td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total por Sucursal</span><div><span>\n{{branchGroup.items.length}}</span></div></div></div><hr><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-totals p-10\"><span>Total</span><div><span>{{ vm.reportData.data.length}}</span></div></div><div \nlayout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\">\n<thead><tr><th>Sucursal</th><th>Actividad</th><th class=\"text-center\">Cupo</th><th class=\"text-center\">Inscritos</th>\n</tr></thead><tbody><tr ng-repeat=\"item in vm.summary\"><td>{{item.branch}}</td><td>{{item.activity}}</td><td \nclass=\"text-center\">{{item.quota}}</td><td class=\"text-center\">{{item.count}}</td></tr></tbody></table></div></div>\n</div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/general/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE GENERAL DE SOCIOS</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.group\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><div ng-repeat=\"orderTypeGroup in group.orderTypeGroups\" class=\"ml-20\"><h3 class=\"report-group-2\">\nTipo Membresia-Periodo: {{orderTypeGroup.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\">Id</th><th class=\"text-center\">Nombre de Socio</th><th class=\"text-center\">Domiciliado</th><th \nclass=\"text-center\">Estatus</th><th class=\"text-center\">Inicio de memebresia</th><th class=\"text-center\">\nUltima fecha de pago</th><th class=\"text-center\">Fehca de baja</th><th class=\"text-center\">Nombre de vendedor</th></tr>\n</thead><tbody><tr ng-repeat=\"item in orderTypeGroup.items\" ng-class=\"{\'canceled\': item.isCanceled }\"><td \nclass=\"text-center\">{{item.id}}</td><td class=\"text-center\">{{item.namePartner}}</td><td class=\"text-center\">\n{{item.domiciliado}}</td><td class=\"text-center\">{{item.estatus}}</td><td class=\"text-center\">\n{{item.inscriptionDate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.fechaUltimoPago | date: \'dd/MM/yyyy\'}}\n</td><td class=\"text-center\">{{item.lowDate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.nombreFronDesk}}\n</td></tr></tbody></table><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>\nSub total activo</span><div><span>{{orderTypeGroup.totalActive}}</span></div><span>Sub total inactivo</span><div><span>\n{{orderTypeGroup.totalInactive}}</span></div><span>Total por tipo de mantenimiento / Cuotao</span><div><span>\n{{orderTypeGroup.total}}</span></div></div></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><span>Sub total activo sucursal</span><div><span>{{group.totalActive}}</span></div><span>\nSub total inactivo sucursal</span><div><span>{{group.totalInactive}}</span></div><span>Total por sucursal</span><div>\n<span>{{group.total}}</span></div></div><hr width=\"70%\" noshade=\"noshade\"></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Activo</span><div><span>{{vm.totalActive}}\n</span></div><span>Inactivo</span><div><span>{{vm.totalInactive}}</span></div><span>Total</span><div><span>{{vm.total}}\n</span></div></div><hr width=\"70%\" noshade=\"noshade\"></div></div><div class=\"page-break\"></div></div>\n<cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/generalPago/layout.html","<div class=\"report-horizontal page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE GENERAL DE SOCIOS ULTIMO PAGO</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\">\n<div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.group\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><div ng-repeat=\"dueName in group.dueName\" class=\"ml-20\"><h3 class=\"report-group-2\">Tipo Membresia: {{dueName.key}}\n</h3><table class=\"simple report-table font-small\"><thead><tr><th class=\"w-50 text-center\">Número</th><th \nclass=\"w-150 text-center\">Nombre</th><th class=\"w-60 text-center\">Tipo de<br>Pago</th><th class=\"w-60 text-center\">\nTipo de<br>Membresia</th><th class=\"w-100 text-center\">Fecha de Ingreso</th><th class=\"w-100 text-center\">\nFecha Siguiente<br>Pago</th><th class=\"w-60 text-center\">Estatus de<br>Pago</th><th class=\"w-60 text-center\">Fecha de\n<br>Baja</th><th class=\"w-50 text-center\">Teléfono</th></tr></thead><tbody><tr ng-repeat=\"item in dueName.items\"><td \nclass=\"text-center\">{{item.id}}</td><td class=\"text-center\">{{item.namePartner}}</td><td class=\"text-center\">\n{{item.periodicitiName}}</td><td class=\"text-center\">{{dueName.key}}</td><td class=\"text-center\">\n{{item.inscriptionDate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.payedDate | date: \'dd/MM/yyyy\'}}</td>\n<td class=\"text-center\">{{item.statusPartners}}</td><td class=\"text-center\">{{item.dischargeDate | date: \'dd/MM/yyyy\'}}\n</td><td class=\"text-center\">{{item.phone}}</td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total vigentes</span><div><span>\n{{dueName.vigentes}}</span></div><span>Total vencidos</span><div><span>{{dueName.vencidos}}</span></div><span>\nTotal por tipo de membresia</span><div><span>{{dueName.total}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\"><span>Total vigentes en sucursal</span><div><span>\n{{group.vigentes}}</span></div><span>Total vencidos en sucursal</span><div><span>{{group.vencidos}}</span></div><span>\nTotal por sucursal</span><div><span>{{group.total}}</span></div></div><br><hr width=\"100%\" noshade=\"noshade\"><br></div>\n<div layout=\"row\" layout-align=\"space-between start\" class=\"report-totals-final p-10\"><span>Vigentes</span><div><span>\n{{vm.vigentes}}</span></div><span>Vencidos</span><div><span>{{vm.vencidos}}</span></div><span>Total</span><div><span>\n{{vm.total}}</span></div></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button>\n</cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/inactivos/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS INACTIVOS</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><table class=\"simple report-table font-small\"><thead><tr><th class=\"text-center\">\nNúmero de membresia</th><th class=\"text-center\">Nombre de Socio</th><th class=\"text-center\">Tipo de membresia</th><th \nclass=\"text-center\">Recurrente</th><th class=\"text-center\">Periodicidad</th><th class=\"text-center\">Fecha de vigencia\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.reportData.data\" ng-class=\"{\'canceled\': item.isCanceled }\"><td \nclass=\"text-center\">{{item.id}}</td><td class=\"text-center\">{{item.namePartner}}</td><td class=\"text-center\">\n{{item.membershipType}}</td><td class=\"text-center\">{{item.recurrente}}</td><td class=\"text-center\">{{item.periodo}}\n</td><td class=\"text-center\">{{item.fechaVigencia | date: \'dd/MM/yyyy\'}}</td></tr></tbody></table></div></div><div \nclass=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/invoicesorders/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE FACTURAS Y RECIBOS POR SOCIO</span></div><div class=\"info\"><div class=\"title\"><br>Rango de fechas: <span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"g in vm.group\"><h3 class=\"report-group-1\">{{g.key}} - {{g.items[0].dueName}}</h3><div \nng-repeat=\"otg in g.orderTypeGroups\" class=\"ml-20\"><h3 class=\"report-group-2\">Tipo de documento: {{otg.key}}</h3><div \nng-repeat=\"folio in otg.InvoiceGroup\" class=\"ml-20\"><h3 class=\"report-group-3\">Folio: {{folio.key}}</h3><table \nclass=\"simple report-table font-small\"><thead><tr><th class=\"text-center\">Fecha</th><th class=\"text-center\">Folio</th>\n<th class=\"text-center\">Concepto</th><th class=\"text-center\">Importe</th></tr></thead><tbody><tr \nng-repeat=\"item in folio.items\" ng-class=\"{\'canceled\': item.isCanceled }\"><td class=\"text-center\">\n{{item.expeditionDate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.folio}}</td><td class=\"text-left\">\n{{item.description}}</td><td class=\"text-center\">{{item.total | currency: \'$\': 2}}</td></tr></tbody></table></div><div \nlayout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total</span><div><span>\n{{otg.items.length}}</span></div></div></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><span>Total</span><div><span>{{g.items.length}}</span></div></div></div><hr><div \nlayout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\">\n<thead><tr><th>Tipo</th><th class=\"text-center\">Número</th><th class=\"text-center\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.summary\"><td>{{item.orderType}}</td><td class=\"text-center\">{{item.count}}</td><td \nclass=\"text-right\">{{item.total | currency: \'$\': 2}}</td></tr></tbody></table></div></div></div><div \nclass=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/invoicesordersall/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE FACTURAS Y RECIBOS</span></div><div class=\"info\"><div class=\"title\"><br>Rango de fechas: <span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"g in vm.group\"><h3 class=\"report-group-1\">{{g.key}} - {{g.items[0].dueName}}</h3><div \nng-repeat=\"otg in g.orderTypeGroups\" class=\"ml-20\"><h3 class=\"report-group-2\">Tipo de documento: {{otg.key}}</h3><div \nng-repeat=\"folio in otg.InvoiceGroup\" class=\"ml-20\"><h3 class=\"report-group-3\" layout=\"row\" \nlayout-align=\"space-between start\"><div>Folio: {{folio.key}}</div><div class=\"text-right\">\nPago: {{folio.items[0].payments}}</div></h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\">Fecha</th><th class=\"text-center\">Folio</th><th class=\"text-center\">Concepto</th><th \nclass=\"text-center\">Importe</th></tr></thead><tbody><tr ng-repeat=\"item in folio.items\" \nng-class=\"{\'canceled\': item.isCanceled }\"><td class=\"text-center\">{{item.expeditionDate | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-center\">{{item.folio}}</td><td class=\"text-left\">{{item.description}}</td><td class=\"text-center\">\n{{item.total | currency: \'$\': 2}}</td></tr></tbody></table></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><span>Total</span><div><span>{{otg.items| sum:\'total\' | currency: \'$\': 2}}</span></div>\n</div></div><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total</span><div>\n<span>{{g.items | sum:\'total\' | currency: \'$\': 2}}</span></div></div></div><hr><div layout=\"row\" \nlayout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\"><thead><tr><th>\nTipo</th><th class=\"text-center\">Número</th><th class=\"text-center\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.summary\"><td>{{item.orderType}}</td><td class=\"text-center\">{{item.count}}</td><td \nclass=\"text-right\">{{item.total | currency: \'$\': 2}}</td></tr></tbody></table></div></div></div><div \nclass=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/status/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nSOCIOS POR ESTATUS DE VIGENCIA</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\">Fecha de Validación {{vm.reportData.report.parameters[0].value | date: \'dd/MM/yyyy\'}}</span></div><div \nclass=\"info\"><div class=\"title\">Sucursal(es): <span ng-repeat=\"item in vm.reportData.report.parameters[2].value\">\n{{item.name}},</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><div ng-repeat=\"membershipType in group.membershipType\" class=\"ml-20\"><h3 class=\"report-group-2\">\nTipo Membresia: {{membershipType.key}}</h3><div ng-repeat=\"period in membershipType.period\" class=\"ml-20\"><h3 \nclass=\"report-group-3\">Periodo de cobro: {{period.key}}</h3><table class=\"simple report-table font-small\"><thead><tr>\n<th class=\"w-50 text-center\">Id</th><th class=\"w-200 text-center\">Socio</th><th class=\"w-150 text-center\">Tipo</th><th \nclass=\"w-200 text-center\">Dependencia</th><th class=\"w-50 text-center\">Recurrente</th><th class=\"w-150 text-center\">\nFecha de vigencia</th></tr></thead><tbody><tr ng-repeat=\"item in period.items\"><td class=\"text-center\">{{item.id}}</td>\n<td class=\"text-center\">{{item.nammePartner}}</td><td class=\"text-center\">{{item.partnerType}}</td><td \nclass=\"text-center\">{{item.parentPartner}}</td><td class=\"text-center\"><span ng-if=\"item.isRecurrent == 1\">Si</span> \n<span ng-if=\"item.isRecurrent != 1\">No</span></td><td class=\"text-center\">{{item.fechaVigencia | date: \'dd/MM/yyyy\'}}\n</td></tr><tr class=\"subtotals\"><td colspan=\"5\">Total de socios por tipo de membresia y periodo de pago</td><td \nclass=\"text-right\">{{period.items.length}}</td></tr></tbody></table></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total de socios por tipo de membresia</span>\n<div><span>{{membershipType.items.length}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total por Sucursal</span><div><span>\n{{group.total}}</span></div></div></div><div layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\">\n<table class=\"simple report-table\" flex=\"50\"><thead><tr><th class=\"w-200 text-center\">Sucursal</th><th \nclass=\"w-200 text-center\">Membresia</th><th class=\"w-100 text-center\">Periodo</th><th class=\"w-100 text-center\">\nNo. de Socios</th></tr></thead><tbody><tr ng-repeat=\"item in vm.summary\"><td class=\"text-center\">{{item.branch}}</td>\n<td class=\"text-center\">{{item.membershipType}}</td><td class=\"text-center\">{{item.period}}</td><td \nclass=\"text-center\">{{item.totalPeriod}}</td></tr></tbody></table></div><div ng-repeat=\"group in vm.groups\"><div \nng-repeat=\"periodType in group.periodType\"><div ng-repeat=\"item in periodType.recurrent\"><div \nclass=\"text-center w-1020\"><span class=\"report-totals\">Socios pago {{periodType.key}} </span><span \nng-if=\"item.key == \'No\'\" class=\"report-totals\">{{item.key}}</span> <span class=\"report-totals\">: {{item.total}}</span>\n</div></div></div></div><div class=\"text-center w-1020\"><span class=\"report-totals-final\">\nTotal de Socios Recurrentes: {{vm.groups | sum: \'totalRecurrente\'}}</span></div><div class=\"text-center w-1020\"><span \nclass=\"report-totals-final\">Total de Socios No recurrentes: {{vm.groups | sum: \'totalNoRecurrente\'}}</span></div><div \nclass=\"text-center w-1020\"><span class=\"report-totals-final\">Total de Socios: {{vm.groups | sum: \'total\'}}</span></div>\n</div></div><div class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/tipo/layout.html","<div class=\"report-horizontal page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE CONSOLIDADO POR TIPO DE CUOTA</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\">\n<div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.groups\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><table class=\"simple report-table font-small\"><thead><tr><th class=\"w-100 text-center\">Descripción</th><th \nclass=\"w-70 text-center\">Hombres</th><th class=\"w-70 text-center\">Mujeres</th><th class=\"w-70 text-center\">Total tipo\n</th><th class=\"w-60 text-center\">MEN.VEN</th><th class=\"w-60 text-center\">MEN.VIG</th><th class=\"w-60 text-center\">\nBI.VEN</th><th class=\"w-60 text-center\">BI.VIG</th><th class=\"w-60 text-center\">TRI.VEN</th><th \nclass=\"w-60 text-center\">TRI.VIG</th><th class=\"w-60 text-center\">CUA.VEN</th><th class=\"w-60 text-center\">CUA.VIG</th>\n<th class=\"w-60 text-center\">SEM.VEN</th><th class=\"w-60 text-center\">SEM.VIG</th><th class=\"w-60 text-center\">ANU.VEN\n</th><th class=\"w-60 text-center\">ANU.VIG</th><th class=\"w-60 text-center\">SEMA.VEN</th><th class=\"w-60 text-center\">\nSEMA.VIG.</th><th class=\"w-60 text-center\">VENC</th><th class=\"w-60 text-center\">VIGE</th></tr></thead><tbody><tr \nng-repeat=\"item in group.tipoCuota\"><td class=\"text-center\">{{item.key}}</td><td class=\"text-center\">{{item.masculino}}\n</td><td class=\"text-center\">{{item.femenino}}</td><td class=\"text-center\">{{item.masculino + item.femenino}}</td><td \nclass=\"text-center\">{{item.menVencido}}</td><td class=\"text-center\">{{item.menVigente}}</td><td class=\"text-center\">\n{{item.biVencido}}</td><td class=\"text-center\">{{item.biVigente}}</td><td class=\"text-center\">{{item.triVencido}}</td>\n<td class=\"text-center\">{{item.triVigente}}</td><td class=\"text-center\">{{item.cuaVencido}}</td><td \nclass=\"text-center\">{{item.cuaVigente}}</td><td class=\"text-center\">{{item.semVencido}}</td><td class=\"text-center\">\n{{item.semVigente}}</td><td class=\"text-center\">{{item.anuVencido}}</td><td class=\"text-center\">{{item.anuVigente}}\n</td><td class=\"text-center\">{{item.semanalVencido}}</td><td class=\"text-center\">{{item.semanalVigente}}</td><td \nclass=\"text-center\">{{item.vencido}}</td><td class=\"text-center\">{{item.vigente}}</td></tr><tr><td class=\"text-rigth\">\nTOTALES</td><td class=\"text-center\">{{group.masculino}}</td><td class=\"text-center\">{{group.femenino}}</td><td \nclass=\"text-center\">{{group.masculino + group.femenino}}</td><td class=\"text-center\">{{group.menVencido}}</td><td \nclass=\"text-center\">{{group.menVigente}}</td><td class=\"text-center\">{{group.biVencido}}</td><td class=\"text-center\">\n{{group.biVigente}}</td><td class=\"text-center\">{{group.triVencido}}</td><td class=\"text-center\">{{group.triVigente}}\n</td><td class=\"text-center\">{{group.cuaVencido}}</td><td class=\"text-center\">{{group.cuaVigente}}</td><td \nclass=\"text-center\">{{group.semVencido}}</td><td class=\"text-center\">{{group.semVigente}}</td><td class=\"text-center\">\n{{group.anuVencido}}</td><td class=\"text-center\">{{group.anuVigente}}</td><td class=\"text-center\">\n{{group.semanalVencido}}</td><td class=\"text-center\">{{group.semanalVigente}}</td><td class=\"text-center\">\n{{group.vencido}}</td><td class=\"text-center\">{{group.vigente}}</td></tr></tbody></table><br><hr width=\"100%\" \nnoshade=\"noshade\"><br></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button>\n</cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/typeDue/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE POR TIPO DE CUOTA</span></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div \nclass=\"content excel-exportable\"><div ng-repeat=\"group in vm.group\"><h3 class=\"report-group-1\">Sucursal: {{group.key}}\n</h3><div ng-repeat=\"due in group.due\" class=\"ml-20\"><h3 class=\"report-group-2\">Tipo Periodo: {{due.key}}</h3><table \nclass=\"simple report-table font-small\"><thead><tr><th class=\"text-center\">No. Socio</th><th class=\"text-center\">\nNombre Completo</th><th class=\"text-center\">Status</th><th class=\"text-center\">Periodicidad</th></tr></thead><tbody><tr\n ng-repeat=\"item in due.items\" class=\"ng-class: item.active == 1 ? \'text-include\' : \'text-exclude\'\"><td \nclass=\"text-center\">{{item.id }}</td><td class=\"text-center\">{{item.partnerName}}</td><td class=\"text-center\">\n{{item.estatus}}</td><td class=\"text-center\">{{item.typePeriodo}}</td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>Total de registros</span><div><span>\n{{due.items.length}}</span></div></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"report-subtotals p-10\"><table class=\"simple report-table\"><tbody><tr ng-repeat=\"typePeriodo in due.typePeriodo\">\n<td class=\"text-center\">{{typePeriodo.key}}</td><td class=\"text-center\">{{typePeriodo.items.length}}</td></tr></tbody>\n</table></div><hr></div></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button>\n</cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/vigentes/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS VIGENTES</span></div><div class=\"report-subtitle\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"title\" ng-if=\"vm.reportData.report.parameters[0].value.type == 1\">\nPor fecha del {{vm.reportData.report.parameters[0].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[0].value.to | date: \'dd/MM/yyyy\'}} \n</span><span class=\"title\" ng-if=\"vm.reportData.report.parameters[0].value.type == 2\">\nNo periodos: {{vm.reportData.report.parameters[0].value.periods}}</span></div><div class=\"info\"><div class=\"title\">\nStatus: {{vm.reportData.report.parameters[1].value.name}}<br>Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[2].value\">{{item.name}},</span></div></div></div><div \nclass=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" layout-align=\"center center\"><img\n ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"dueGroup in vm.dueGroups\"><h3 class=\"report-group-1\">{{dueGroup.key}}</h3><div \nng-repeat=\"periodicityGroup in dueGroup.periodicityGroups\"><h3 class=\"report-group-2\">\n{{periodicityGroup.key | date: \'dd/MM/yyyy\'}}</h3><table class=\"simple report-table font-small\"><thead><tr><th \nclass=\"text-center\">No Familia</th><th class=\"text-center\">Cuota-Periodicidad</th><th class=\"text-center\">Nombre</th>\n<th class=\"text-center\">Fecha de pago</th><th class=\"text-center\">No Inscripción</th><th class=\"text-center\" \nng-if=\"vm.reportData.report.parameters[0].value.type == 2\">Periodos</th><th class=\"text-center\" \nng-if=\"vm.reportData.report.parameters[1].value.id != 1\">Adeudo</th></tr></thead><tbody><tr \nng-repeat=\"item in periodicityGroup.items\"><td class=\"text-center\">{{item.sequentialNumber}}</td><td \nclass=\"text-center\">{{item.duePeriodicityName}}</td><td>{{item.partnerName}}</td><td class=\"text-center\">\n{{item.payedDate | date: \'dd/MM/yyyy\'}}</td><td>{{item.inscriptionNumber}}</td><td class=\"text-center\" \nng-if=\"vm.reportData.report.parameters[0].value.type == 2\">{{item.periodsNumber}}</td><td class=\"text-right\" \nng-if=\"vm.reportData.report.parameters[1].value.id != 1\">{{item.debitAmount | currency: \'$ \': 2 }}</td></tr><tr \nclass=\"subtotals\" ng-if=\"vm.reportData.report.parameters[1].value.id != 1\"><td colspan=\"5\">Adeudo por periodicidad</td>\n<td class=\"text-right\">{{periodicityGroup.items | sum: \'debitAmount\' | currency: \'$ \': 2 }}</td></tr></tbody></table>\n</div><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\" \nng-if=\"vm.reportData.report.parameters[1].value.id != 1\"><span>Adeudo por cuota</span><div><span>\n{{dueGroup.items | sum: \'debitAmount\' | currency: \'$ \' : 2}}</span></div></div></div><hr><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\" ng-if=\"vm.reportData.report.parameters[1].value.id != 1\">\n<span>Adeudo Total</span><div><span>{{ vm.reportData.data | sum: \'debitAmount\' | currency: \'$ \' : 2}}</span></div>\n</div><div layout=\"row\" layout-align=\"center start\" class=\"report-summary p-20\"><table class=\"simple report-table\" \nflex=\"50\"><thead><tr><th>Cuota</th><th>Periodicidad</th><th class=\"text-center\">Conteo</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.summary\"><td>{{item.due}}</td><td>{{item.periodicity}}</td><td class=\"text-center\">{{item.count}}\n</td></tr></tbody></table></div></div></div><div class=\"page-break\"></div></div><cd-export-excel-button>\n</cd-export-excel-button></div>");
$templateCache.put("app/main/reports/views/reports/socios/vendedor/layout.html","<div class=\"report page-layout blank\" layout=\"row\" ms-scroll><div class=\"report-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"header-title\"><div class=\"report-title\" layout=\"row\" layout-align=\"start center\"><span class=\"title\">\nREPORTE DE SOCIOS POR VENDEDOR</span></div><div class=\"info\"><div class=\"title\">Sucursal(es): <span \nng-repeat=\"item in vm.reportData.report.parameters[0].value\">{{item.name}},</span><br>Rango de fechas: <span \nclass=\"title\">\nDel {{vm.reportData.report.parameters[1].value.from | date: \'dd/MM/yyyy\'}} al {{vm.reportData.report.parameters[1].value.to | date: \'dd/MM/yyyy\'}}\n</span></div></div></div><div class=\"issuer\" layout=\"row\" layout-align=\"start start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\"></div></div></div><div class=\"content excel-exportable\"><div \nng-repeat=\"branchGroup in vm.branchGroups\"><h3 class=\"report-group-1\">Sucursal: {{branchGroup.key}}</h3><div \nng-repeat=\"sellerGroup in branchGroup.sellerGroup\" class=\"ml-20\"><h3 class=\"report-group-2\">\nVendedor: {{sellerGroup.key}}</h3><table class=\"simple report-table font-small\"><thead><tr><th class=\"text-left\">\nNombre de Socio</th><th class=\"text-center\">Tipo de Socio (Cuota)</th><th class=\"text-center\">Monto Cuota</th><th \nclass=\"text-center\">Fecha de Inscripción</th></tr></thead><tbody><tr ng-repeat=\"item in sellerGroup.items\"><td \nclass=\"text-left\">{{item.partnerName}}</td><td class=\"text-center\">{{item.dueName}}</td><td class=\"text-center\">\n{{item.price | currency: \'$\': 2}}</td><td class=\"text-center\">{{item.inscriptionDate | date: \'dd/MM/yyyy\'}}</td></tr>\n<tr class=\"subtotals\"><td colspan=\"5\">Total por Vendedor</td><td class=\"text-right\">{{sellerGroup.items.length}}</td>\n</tr></tbody></table></div><div layout=\"row\" layout-align=\"space-between start\" class=\"report-subtotals p-10\"><span>\nTotal por Sucursal</span><div><span>{{branchGroup.items.length}}</span></div></div></div><hr><div layout=\"row\" \nlayout-align=\"space-between start\" class=\"report-totals p-10\"><span>Total</span><div><span>\n{{ vm.reportData.data.length}}</span></div></div><div layout=\"row\" layout-align=\"center start\" \nclass=\"report-summary p-20\"><table class=\"simple report-table\" flex=\"50\"><thead><tr><th>Sucursal</th><th>Vendedor</th>\n<th class=\"text-center\">No de Socios</th></tr></thead><tbody><tr ng-repeat=\"item in vm.summary\"><td>{{item.branch}}\n</td><td>{{item.sellerName}}</td><td class=\"text-center\">{{item.count}}</td></tr></tbody></table></div></div></div><div\n class=\"page-break\"></div></div><cd-export-excel-button></cd-export-excel-button></div>");
$templateCache.put("app/main/catalogs/views/dues/due/dialogs/dialog-prices/dialog-prices.html","<md-dialog id=\"rentable-zone-dialog-price\" class=\"catalogs-dialog-detail\"><form name=\"detailForm\" id=\"detailForm\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nPRECIOS DE CUOTAS</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-sm=\"row\" class=\"mb-0\"><md-input-container class=\"md-block mb-0\" flex><label>Vigencia desde</label>\n<md-datepicker ng-init=\"vm.validFrom = (vm.priceHeader.validFrom | toDate)\" \nng-change=\"vm.priceHeader.validFrom = vm.validFrom\" ng-model=\"vm.validFrom\" name=\"validFrom\" required \nmd-placeholder=\"Seleccione fecha\" md-hide-icons=\"calendar\" md-current-view=\"year\"></md-datepicker><div \nng-messages=\"priceForm.validFrom.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione fecha de inicio validez.</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex><label>Interes</label><input type=\"text\" name=\"interes\" ng-model=\"vm.priceHeader.interes\"><div \nng-messages=\"priceForm.interes.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese interes.</span></div>\n</div></md-input-container><md-input-container class=\"md-block mb-0\" flex><label>Días de gracia</label><input \ntype=\"text\" name=\"daysOfGrace\" ng-model=\"vm.priceHeader.daysOfGrace\"><div ng-messages=\"priceForm.daysOfGrace.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ingrese días de gracia.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"row\" class=\"mb-0\"><table class=\"dataTable border\"><thead><tr><th>Periodicidades</th><th class=\"w-120\">\nMontos</th><th class=\"w-120\">X Clase</th></tr></thead><tbody><tr ng-repeat=\"item in vm.newPrices\"><td><span>\n{{item.periodicity.name}}</span></td><td><input type=\"number\" class=\"p-5 w-100\" ng-model=\"item.price\" required min=\"0\">\n</td><td><input type=\"number\" class=\"p-5 w-100\" ng-model=\"item.pricePerClass\" required min=\"0\"></td></tr></tbody>\n</table></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" flex><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"detailForm.$invalid\" aria-label=\"GUARDAR\">GUARDAR</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/catalogs/views/rentable-zones/rentable-zone/dialogs/dialog-prices/dialog-prices.html","<md-dialog id=\"rentable-zone-dialog-price\" class=\"catalogs-dialog-detail\"><form name=\"detailForm\" id=\"detailForm\" \nclass=\"md-inline-form\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nPRECIOS DE RENTABLES</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-sm=\"row\" class=\"mb-0\"><md-input-container class=\"md-block mb-0\" flex><label>Vigencia desde</label>\n<md-datepicker ng-init=\"vm.validFrom = (vm.priceHeader.validFrom | toDate)\" \nng-change=\"vm.priceHeader.validFrom = vm.validFrom\" ng-model=\"vm.validFrom\" name=\"validFrom\" required \nmd-placeholder=\"Seleccione fecha\" md-hide-icons=\"calendar\" md-current-view=\"year\"></md-datepicker><div \nng-messages=\"priceForm.validFrom.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione fecha de inicio validez.</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex><label>Interes</label><input type=\"text\" name=\"interes\" ng-model=\"vm.priceHeader.interes\"><div \nng-messages=\"priceForm.interes.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese interes.</span></div>\n</div></md-input-container><md-input-container class=\"md-block mb-0\" flex><label>Días de gracia</label><input \ntype=\"text\" name=\"daysOfGrace\" ng-model=\"vm.priceHeader.daysOfGrace\"><div ng-messages=\"priceForm.daysOfGrace.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Ingrese días de gracia.</span></div></div></md-input-container></div><div\n layout-gt-sm=\"row\" class=\"mb-0\"><table class=\"dataTable border\"><thead><tr><th>Periodicidades</th><th class=\"w-120\">\nMontos</th><th class=\"w-120\">Precio X día</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.newPrices | orderBy: \'periodicityId\'\"><td><span>{{item.periodicity.name}}</span></td><td><input \ntype=\"number\" class=\"p-5 w-100\" ng-model=\"item.price\" required></td><td><input type=\"number\" class=\"p-5 w-100\" \nng-model=\"item.pricePerDay\" required></td></tr></tbody></table></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\" flex><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"detailForm.$invalid\" aria-label=\"GUARDAR\">\nGUARDAR</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/inventory/views/inventories/inventories/dialogs/dialog-inventory/dialog-inventory.html","<md-dialog class=\"discount-dialog\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nNUEVO INVENTARIO</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.close()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div></md-toolbar><form \nname=\"inventoryForm\"><md-dialog-content ms-scroll><div class=\"page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Producto</label><md-select name=\"product\" ng-model=\"vm.inventory.productId\"><md-option \nng-repeat=\"option in vm.products | filter: { active: true }\" ng-value=\"option.id\">{{option.name}}</md-option>\n</md-select><div ng-messages=\"inventoryForm.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione producto.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Almacen</label><md-select name=\"warehouse\" ng-model=\"vm.inventory.warehouseId\"><md-option \nng-repeat=\"option in vm.warehouses | filter: {active: true}\" ng-value=\"option.id\">{{option.name}}</md-option>\n</md-select><div ng-messages=\"inventoryForm.product.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione almacen.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex-1><label>Cantidad</label><input ng-model=\"vm.inventory.quantity\" type=\"number\" name=\"quantity\" \nrequired min=\"0\"><div ng-messages=\"inventoryForm.quantity.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIngrese Interés.</span></div><div ng-message=\"number\"><span>El campo debe ser numérico.</span></div><div \nng-message=\"min\"><span>Valor incorrecto.</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex><label>Precio</label><input ng-model=\"vm.inventory.price\" type=\"number\" name=\"price\" required min=\"0\"><div \nng-messages=\"inventoryForm.price.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese Precio.</span></div><div\n ng-message=\"number\"><span>El campo debe ser numérico.</span></div><div ng-message=\"min\"><span>Valor incorrecto</span>\n</div></div></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.accept()\" class=\"send-button md-accent md-raised\" ng-disabled=\"inventoryForm.$invalid\" \naria-label=\"ACEPTAR\">Aceptar</md-button></div><div layout=\"row\"><md-button ng-click=\"vm.close()\" aria-label=\"Cancelar\">\nCancelar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/views/notasCredito/notasCredito/dialogs/dialog-nota-credito/dialog-nota-credito.html","<md-dialog id=\"dialog-order\" class=\"catalogs-dialog-detail\" aria-label=\"dialog-order\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">NOTA DE CREDITO</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll class=\"no-padding\"><form name=\"ncForm\"><div layout=\"row\" class=\"p-10\" \nlayout-align=\"start start\"><div flex layout=\"row\"><md-input-container class=\"md-block\" flex-1><label>Serie</label>\n<input type=\"text\" ng-model=\"vm.invoiceSerie\" cd-enter=\"vm.searchInvoice()\" required></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Número de factura</label><input type=\"number\" \nng-model=\"vm.invoiceNumber\" cd-enter=\"vm.searchInvoice()\" md-autofocus required></md-input-container><md-button \nclass=\"md-button md-accent md-raised w-50 h-50\" ng-click=\"vm.searchInvoice()\" ng-disabled=\"vm.searchInvoiceLoading\">\n<md-icon ng-if=\"vm.searchInvoiceLoading\" md-font-icon=\"icon-dots-horizontal\"></md-icon><md-icon \nng-if=\"!vm.searchInvoiceLoading\" md-font-icon=\"icon-magnify\"></md-icon><md-tooltip>Buscar</md-tooltip></md-button>\n<md-input-container class=\"md-block w-200\" flex \nng-if=\"vm.invoice && vm.invoice.ncOrders && vm.invoice.ncOrders.length > 0\"><label>Recibos</label><md-select \nng-model=\"vm.selectedOrder\" ng-change=\"vm.orderSelectedChange(vm.selectedOrder)\"><md-option \nng-repeat=\"opt in vm.invoice.ncOrders | orderBy : \'folio\' | filter: { isShowed : true } \" ng-value=\"opt\">{{opt.folio}}\n</md-option></md-select></md-input-container><div flex><md-input-container class=\"md-block\" flex><label>Monto</label>\n<input type=\"text\" ng-model=\"vm.item.total\"></md-input-container></div></div></div><div layout=\"row\" class=\"m-10 mt-0\" \nflex><div layout=\"column\" flex=\"50\"><div layout=\"row\"><table><tr><td colspan=\"2\"><h3 class=\"mt-0\">Datos de factura</h3>\n</td></tr><tr><td>Fecha:</td><td>{{vm.item.expeditionDate | date: \'dd/MM/yyyy HH:mm\'}}</td></tr><tr><td>Uso del CFDI:\n</td><td>{{vm.item.satCfdiUse.name}}</td></tr><tr><td>Cond. de pago:</td><td>{{vm.item.satPaymentMethod.name}}</td>\n</tr><tr><td>Forma de pago:</td><td>{{vm.item.satPayment.name}}</td></tr></table></div></div><div layout=\"column\" \nflex=\"50\"><div layout=\"row\"><table><tr><td colspan=\"2\"><h3 class=\"mt-0\">Datos de socio</h3></td></tr><tr><td>\nNo Familia:</td><td>{{vm.item.partner.sequentialNumber}}</td></tr><tr><td>Nombre:</td><td>{{vm.item.targetRazonSocial}}\n</td></tr><tr><td>RFC:</td><td>{{vm.item.targetRfc}}</td></tr><tr><td>Teléfono:</td><td>{{vm.item.partner.phone}}</td>\n</tr></table></div></div></div><div layout=\"row\" layout-align=\"start center\" class=\"m-10\"><div layout=\"column\" flex>\n<div layout=\"row\"><h3>Datos de la Nota de Crédito</h3></div><div layout=\"row\"><md-input-container \nclass=\"md-block w-100\" flex><label>Importe</label><input type=\"text\" ng-model=\"vm.item.total\" required>\n</md-input-container><md-input-container class=\"md-block w-270\" flex><label>Concepto</label><md-select \nng-model=\"vm.conceptoNotaCredito\" required><md-option ng-repeat=\"opt in vm.conceptos | filter : { active: true }\" \nng-value=\"opt\">{{opt.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block w-270\" \nflex><label>Tipo Relación:</label><md-select ng-model=\"vm.cfdiRelacionado\" required><md-option \nng-repeat=\"opt in vm.cfdiRelacionado | filter : { active: true }\" ng-value=\"opt\">{{opt.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-1><md-checkbox ng-model=\"vm.item.reactiveReceipt\">\nReactivar recibo(s)</md-checkbox></md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex><label>Observaciones</label><input type=\"text\" ng-model=\"vm.item.notes\"></md-input-container></div></div></div>\n<div layout=\"row\" layout-align=\"end center\" class=\"m-10\"><md-button class=\"md-button md-accent md-raised w-200\" \nng-click=\"vm.save()\" ng-disabled=\"ncForm.$invalid || vm.saving\"><span ng-if=\"vm.saving\">Generando...</span> <span \nng-if=\"!vm.saving\">Generar NC</span></md-button><md-button class=\"md-button md-warn md-raised\" ng-click=\"vm.close()\">\nCancelar</md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/order/dialogs/dialog-discount/dialog-discount.html","<md-dialog class=\"discount-dialog\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAPLICAR DESCUENTO</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div></md-toolbar><form \nname=\"discountForm\"><md-dialog-content ms-scroll><div class=\"page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><div class=\"address-form\"><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Tipo de descuento</label><md-select ng-model=\"vm.discount.type\" \nrequired><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.discountTypes | orderBy: \'id\' : true\">{{item.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Monto <span \nng-show=\"vm.discount.type == 2\">(%)</span></label><input ng-model=\"vm.discount.ammount\" type=\"number\" name=\"ammount\" \nrequired min=\"0.01\" ng-max=\"vm.discount.type == 2 ? 100 : 999999999\" md-autofocus><div \nng-messages=\"discountForm.ammount.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese Monto.</span></div><div\n ng-message=\"number\"><span>El campo debe ser numérico.</span></div><div ng-message=\"min\"><span>\nEl valor no puede ser menor a 0.1</span></div><div ng-message=\"max\"><span>El monto máximo es incorrecto.</span></div>\n</div></md-input-container></div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.discountAccept()\" class=\"send-button md-accent md-raised\" ng-disabled=\"discountForm.$invalid\" \naria-label=\"ACEPTAR\">Aceptar</md-button></div><div layout=\"row\"><md-button ng-click=\"vm.cancel()\" \naria-label=\"Cancelar\">Cancelar</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/order/dialogs/dialog-incompletePeriods/dialog-incompletePeriods.html","<md-dialog class=\"invoice-dialogs dialog-incomplete-periods\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">INGRESA LOS DATOS FALTANTES</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div>\n</md-toolbar><form name=\"editDetailForm\"><md-dialog-content ms-scroll><div class=\"page-layout carded fullwidth\" \nlayout=\"row\"><div class=\"content fullpage-datatable no-padding\" layout=\"column\" flex><table class=\"dataTable\"><thead>\n<tr><th>Socio</th><th>Periodo</th><th class=\"w-80\"># Clases Restantes</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.periods\"><td>{{item.partnerName}} [{{item.due.name}}]</td><td>\n{{item.partnerPayedDate | date : \'dd/MM/yyyy\'}} - {{item.currentPeriod.endDate | date : \'dd/MM/yyyy\'}} ({{item.remainDays}} dias)\n</td><td><input type=\"number\" name=\"remainClass\" ng-model=\"item.remainClass\" min=\"1\" required \nclass=\"w-70 text-align-center\" select-on-focus md-autofocus></td></tr></tbody></table></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><div flex layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.accept()\" class=\"send-button md-accent md-raised\" ng-disabled=\"editDetailForm.$invalid\" \naria-label=\"ACEPTAR\">Aceptar</md-button><md-button ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">Cancelar</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/order/dialogs/dialog-messages/dialog-messages.html","<md-dialog id=\"order-dialog-messages\" class=\"catalogs-dialog-detail\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Mensajes</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><ul class=\"messages\">\n<li ng-repeat=\"partner in vm.partners\">{{partner.completeName}} <span ng-show=\"!partner.isFamily\">(TITULAR)</span><ul \nclass=\"partner-messages\"><li ng-repeat=\"item in vm.messages | filter: { partnerId: partner.id }\"><h2>{{item.message}}\n</h2></li></ul></li></ul></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"end center\"><md-button type=\"submit\" ng-click=\"vm.close()\" class=\"send-button md-accent md-raised\" \naria-label=\"save\">Aceptar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/order/dialogs/dialog-turns/dialog-turns.html","<md-dialog id=\"invoice-dialog-turns\" class=\"invoice-dialogs\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Turnos</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.closeDialog()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"no-padding pt-5\"><div class=\"page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><div class=\"dates-filters\" layout=\"row\" \nlayout-align=\"start start\"><md-input-container class=\"md-block mb-0 h-40\" flex-1><label>Desde</label><md-datepicker \nng-init=\"vm.dummy.from = (vm.from | toDate)\" ng-change=\"vm.from = vm.dummy.from; vm.getTurns();\" \nng-model=\"vm.dummy.from\" name=\"from\" md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block mb-0 h-40\" flex-1><label>Hasta</label>\n<md-datepicker ng-init=\"vm.dummy.to = (vm.to | toDate)\" ng-change=\"vm.to = vm.dummy.to; vm.getTurns();\" \nng-model=\"vm.dummy.to\" name=\"to\" md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker></md-input-container><md-input-container class=\"mb-0\"><label>Mostrar:</label><md-select \nng-model=\"vm.isOpen\"><md-option ng-repeat=\"item in vm.filterOpenOptions\" ng-value=\"item.value\">{{item.text}}\n</md-option></md-select></md-input-container></div><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text w-150\"><div class=\"table-header\"><span class=\"column-title\">FechaApertura</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Turno</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">UsuarioApertura</span></div></th><th \nclass=\"secondary-text w-150\"><div class=\"table-header\"><span class=\"column-title\">FechaCierre</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">UsuarioCierre</span></div></th><th \nclass=\"secondary-text w-90\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr \ncd-custom-grid=\"item in vm.turns | filter: { isOpen: vm.isOpen } | orderBy: \'id\': true | itemsPerPage: (8)\"><td>\n{{item.id}}</td><td>{{item.openDate | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{item.turnNumber}}</td><td>\n{{item.user.name}}</td><td>{{item.closeDate | date : \'dd/MM/yyyy HH:mm\' }}</td><td>{{item.closeUser.name}}</td><td>\n<md-button class=\"md-icon-button\" ng-if=\"item.isOpen\" ng-click=\"vm.closeTurn(item)\"><md-icon \nmd-font-icon=\"icon-alarm-off\"></md-icon><md-tooltip>Cerrar turno</md-tooltip></md-button></td></tr></tbody><tr><td \ncolspan=\"7\"><dir-pagination-controls></dir-pagination-controls></td></tr></table></div></div></md-dialog-content>\n<md-dialog-actions><div layout-gt-sm=\"row\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-click=\"vm.openTurn()\" class=\"send-button md-accent md-raised\" aria-label=\"Aceptar\">Abrir turno</md-button><md-button\n class=\"md-button md-raised md-warn\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\">Cancelar</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/partners/views/partners/info/dialogs/dialog-credential/dialog-credential.html","<md-dialog id=\"partner-dialog-credential\" class=\"catalogs-dialog-detail\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">CREDENCIAL</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nlayout=\"column\" class=\"no-padding\"><div layout=\"row\" flex><div layout=\"column\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex-1 class=\"p-15\"></div><div layout=\"row\" layout-align=\"space-between center\" \nflex-1 class=\"p-15\"><div flex><md-input-container flex-1 class=\"w-300 mr-15\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><img ng-src=\"{{vm.logo}}\" class=\"partner-image\"></div></md-input-container>\n<md-input-container flex-1 class=\"w-300 mr-15\"><label style=\"text-align: center\">{{vm.partner.sequentialNumber}}\n</label></md-input-container></div></div><div layout=\"row\" layout-align=\"space-between center\" flex-1 class=\"p-15\"><div\n flex><md-input-container flex-1 class=\"w-300 mr-15\"><label style=\"text-align: center\">\n{{vm.partner.name}} {{vm.partner.fatherLastname}} {{vm.partner.motherLastname}}</label></md-input-container>\n<md-input-container flex-1 class=\"w-300 mr-15\"><div class=\"text-align-center\"><img \nng-if=\"vm.partner && vm.partner.picturePathName && vm.partner.picturePathName && vm.partner.picturePathName != \'\'\" \nclass=\"partner-image\" ng-src=\"{{vm.picturesUrl}}{{vm.partner.picturePathName}}\"> <img \nng-if=\"!vm.partner || !vm.partner.picturePathName || vm.partner.picturePathName == \'\'\" class=\"partner-image\" \nsrc=\"assets/images/avatars/profile.jpg\"></div></md-input-container></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex-1 class=\"p-15\"><div flex><md-input-container flex-1 class=\"w-300 mr-15\"><div \nid=\"qrcode\"></div></md-input-container><md-input-container flex-1 class=\"w-300 mr-15\"><label \nstyle=\"text-align: center\">{{vm.partner.due.name}}</label></md-input-container></div></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/partners/views/partners/info/dialogs/dialog-messages/dialog-messages.html","<md-dialog id=\"partner-dialog-messages\" class=\"catalogs-dialog-detail\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Mensajes de: {{vm.partner.completeName}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll layout=\"column\" class=\"no-padding\"><div layout=\"row\" flex ng-if=\"vm.message\" class=\"p-15\">\n<form name=\"messageForm\" layout=\"column\" flex><md-input-container flex class=\"md-block textarea-container\" flex><label>\nMensaje</label><textarea ng-model=\"vm.message.message\" md-maxlength=\"500\" required md-autofocus></textarea>\n</md-input-container><div layout=\"row\"><md-input-container flex-1 class=\"md-block textarea-container\" flex><md-checkbox\n ng-model=\"vm.message.IsVisibleInOrder\">Mostrar en facturación</md-checkbox></md-input-container><md-input-container \nflex-1 class=\"md-block textarea-container\" flex><md-checkbox ng-model=\"vm.message.IsVisibleInAccessPoint\">\nMostrar en caseta</md-checkbox></md-input-container></div><div layout=\"row\" layout-align=\"end center\" flex><md-button \nclass=\"md-button md-raised md-accent\" flex-1 ng-click=\"vm.save()\" ng-disabled=\"messageForm.$invalid\">Guardar\n</md-button><md-button class=\"md-button md-raised md-warn\" flex-1 ng-click=\"vm.cancel()\">Cancelar</md-button></div>\n</form></div><div layout=\"row\" flex ng-hide=\"vm.message\"><div layout=\"column\" flex><div layout=\"row\" \nlayout-align=\"end center\" flex-1 class=\"p-15\"><md-input-container flex-1 class=\"w-200 mr-15\"><label>Mostar</label>\n<md-select ng-model=\"vm.filterIsView\"><md-option ng-value=\"{{false}}\">NO Leidos</md-option><md-option \nng-value=\"{{true}}\">Leidos</md-option><md-option ng-value=\"{{null}}\">Todos</md-option></md-select></md-input-container>\n<md-button class=\"md-icon-button md-raised md-accent\" flex-1 ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip>Agregar</md-tooltip></md-button><md-button class=\"md-icon-button md-green-bg white-fg\" flex-1 \nng-click=\"vm.read()\" ng-disabled=\"!vm.selectedMessage || vm.selectedMessage.isViewed\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip>Marcar como Leido</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-raised md-warn\" flex-1 ng-click=\"vm.unread()\" \nng-disabled=\"!vm.selectedMessage || !vm.selectedMessage.isViewed\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<md-tooltip>Marcar como NO leido</md-tooltip></md-button></div><div layout=\"row\" flex><hr><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"w-110\">Fecha/Hora</th><th>Mensaje</th><th class=\"w-30\">Fact.\n</th><th class=\"w-30\">Caseta</th></tr></thead><tbody><tr ng-if=\"vm.messages.length == 0\"><td colspan=\"2\" \nclass=\"empty-rows\">No hay mensajes registrados</td></tr><tr \ncd-custom-grid=\"item in vm.messages | filter: { isViewed: vm.filterIsView } | itemsPerPage: (5)\" \nng-click=\"vm.selectedMessage = item\" class=\"selectable\" ng-class=\"{\'selected\': vm.selectedMessage.id == item.id}\" \npagination-id=\"messagesPaginator\"><td class=\"text-align-center\">{{item.insertDate | date : \'dd/MM/yyyy HH:mm\'}}</td>\n<td>{{item.message}}</td><td><span ng-show=\"item.isVisibleInOrder\">SI</span> <span ng-hide=\"item.isVisibleInOrder\">NO\n</span></td><td><span ng-show=\"item.isVisibleInAccessPoint\">SI</span> <span ng-hide=\"item.isVisibleInAccessPoint\">NO\n</span></td></tr></tbody><tr><td colspan=\"2\"><dir-pagination-controls pagination-id=\"messagesPaginator\">\n</dir-pagination-controls></td></tr></table></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/order/dialogs/dialog-products/dialog-products.html","<md-dialog id=\"invoice-dialog-products\" class=\"invoice-dialogs\" aria-label=\"Dialog\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" flex>Seleccionar producto</span><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon>\n<input ng-model=\"vm.keyword\" class=\"search-input\" type=\"text\" placeholder=\"Buscar\" flex></div><md-button flex-1 \nclass=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll class=\"no-padding\"><div \nclass=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"content fullpage-datatable no-padding\" layout=\"column\" \nflex><table class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text w-80\"><div class=\"table-header\">\n<span class=\"column-title\">Código</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nombre</span></div></th><th class=\"secondary-text w-90\"><div class=\"table-header\"><span \nclass=\"column-title\">Precio</span></div></th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.inventory | filter: vm.keyword  | itemsPerPage: (10)\" ng-click=\"vm.setSelected(item)\" \nng-dblclick=\"vm.select(item)\" ng-class=\"{ \'selected\': item === vm.selected }\"><td>{{item.product.code}}</td><td>\n{{item.product.name}}</td><td class=\"price\">{{item.price | currency: \'$ \': 2}}</td></tr></tbody><tr><td colspan=\"3\">\n<dir-pagination-controls></dir-pagination-controls></td></tr></table></div></div></md-dialog-content>\n<md-dialog-actions><div layout-gt-sm=\"row\" layout=\"row\" layout-align=\"end center\" flex><md-button \nng-click=\"vm.accept()\" class=\"send-button md-accent md-raised\" aria-label=\"Aceptar\">ACEPTAR</md-button><md-button \nclass=\"md-button md-raised md-warn\" ng-click=\"vm.closeDialog()\" aria-label=\"Cancelar\">Cancelar</md-button></div>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/order/dialogs/dialog-edit/dialog-edit.html","<md-dialog class=\"discount-dialog\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nEDITAR DETALLE</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div></md-toolbar><form \nname=\"editDetailForm\"><md-dialog-content ms-scroll><div class=\"page-layout carded fullwidth\" layout=\"row\"><div \nclass=\"content fullpage-datatable no-padding\" layout=\"column\" flex><div class=\"address-form\"><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Descripción</label><input type=\"text\" name=\"description\" \nng-model=\"vm.detail.description\"><div ng-messages=\"editDetailForm.description.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Descripción.</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Precio (Subtotal)</label><input ng-model=\"vm.detail.price\" \ntype=\"number\" name=\"price\" required min=\"0\"><div ng-messages=\"editDetailForm.price.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Precio.</span></div><div ng-message=\"number\"><span>El campo debe ser numérico.\n</span></div><div ng-message=\"min\"><span>Valor incorrecto</span></div><div ng-message=\"max\"><span>Valor incorrecto.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Interés</label><input \nng-model=\"vm.detail.interest\" type=\"number\" name=\"interest\" required min=\"0\"><div \nng-messages=\"editDetailForm.interest.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese Interés.</span>\n</div><div ng-message=\"number\"><span>El campo debe ser numérico.</span></div><div ng-message=\"min\"><span>\nValor incorrecto.</span></div><div ng-message=\"max\"><span>Valor incorrecto.</span></div></div></md-input-container>\n</div></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.accept()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"editDetailForm.$invalid\" aria-label=\"ACEPTAR\">Aceptar</md-button>\n</div><div layout=\"row\"><md-button ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">Cancelar</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partners/dialogs/dialog-changePayedDates/dialog-changePayedDates.html","<md-dialog id=\"dialog-change-payed-dates\" class=\"catalogs-dialog-detail\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">CAMBIO DE FECHAS</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\">\n<md-tabs class=\"no-padding\"><md-tab><md-tab-label><span>Cuotas</span></md-tab-label><md-tab-body class=\"p-15\" \nms-scroll><div layout=\"row\"><div layout=\"column\" flex=\"80\"><table class=\"dataTable hover selectable border\"><thead><tr>\n<th class=\"w-30\">#</th><th>Socio</th><th class=\"w-80\">Pagado hasta</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.partners\" class=\"selectable\" ng-click=\"vm.selectPartner(item)\" \nng-class=\"{\'selected\': vm.partner == item }\"><td>{{item.id}}</td><td>{{item.completeName}}</td><td>\n{{item.payedDate | date : \'dd/MM/yyyy\'}}</td></tr></tbody></table></div><div layout=\"column\" flex=\"30\" class=\"pl-15\">\n<form name=\"formDues\"><md-input-container><label>Nueva fecha</label><md-datepicker ng-model=\"vm.newPayedDate\" \nname=\"payedDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"year\" \nng-disabled=\"!vm.partner\"></md-datepicker><div ng-messages=\"formDues.payedDate.$error\" role=\"alert\"><div \nng-message=\"required\">Seleccione fecha</div></div></md-input-container><div flex><md-checkbox \nng-model=\"vm.applyAllPartners\" ng-disabled=\"!vm.partner\">Aplicar a toda la familia</md-checkbox></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.saveDues()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"!formDues.$valid\" aria-label=\"GUARDAR\">GUARDAR</md-button></div>\n</form></div></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Rentables</span></md-tab-label><md-tab-body \nclass=\"p-15\" ms-scroll><div layout=\"row\"><div layout=\"column\" flex=\"80\"><table \nclass=\"dataTable hover selectable border\"><thead><tr><th class=\"w-30\">#</th><th>Rentable</th><th>Socio</th><th \nclass=\"w-80\">Pagado hasta</th></tr></thead><tbody><tr ng-repeat=\"item in vm.rentables\" class=\"selectable\" \nng-click=\"vm.selectRentable(item)\" ng-class=\"{\'selected\': vm.rentable == item }\"><td>{{item.id}}</td><td>\n{{item.rentable.name}} - {{item.rentable.rentableZone.name}}</td><td>{{item.partner.completeName}}</td><td>\n{{item.payedDate | date : \'dd/MM/yyyy\'}}</td></tr></tbody></table></div><div layout=\"column\" flex=\"30\" class=\"pl-15\">\n<form name=\"formRentables\"><md-input-container><label>Nueva fecha</label><md-datepicker \nng-model=\"vm.newPayedDateRentable\" name=\"payedDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"year\" ng-disabled=\"!vm.rentable\"></md-datepicker><div ng-messages=\"formRentables.payedDate.$error\" \nrole=\"alert\"><div ng-message=\"required\">Seleccione fecha</div></div></md-input-container><div flex><md-checkbox \nng-model=\"vm.applyAllRentables\" ng-disabled=\"!vm.rentable\">Aplicar a todos los rentables</md-checkbox></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.saveRentables()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"!formRentables.$valid\" aria-label=\"GUARDAR\">GUARDAR</md-button>\n</div></form></div></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/partners/views/partners/info/dialogs/dialog-passes/dialog-passes.html","<md-dialog id=\"partner-dialog-passes\" class=\"catalogs-dialog-detail\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">PASES Y CREDENCIALES</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll layout=\"column\" class=\"no-padding\"><div layout=\"row\" flex><div layout=\"column\" flex><div layout=\"row\" \nlayout-align=\"space-between center\" flex-1 class=\"p-15\"><div flex><md-input-container flex-1 class=\"w-200 mr-15\">\n<label>Socio</label><md-select ng-model=\"vm.partner\"><md-option ng-repeat=\"item in vm.partners\" ng-value=\"item\">\n{{item.completeName}}</md-option></md-select></md-input-container><md-input-container flex-1 class=\"w-200 mr-15\">\n<label>Tipo de pase</label><md-select ng-model=\"vm.filterPassTypeId\"><md-option ng-value=\"{{null}}\">TODOS</md-option>\n<md-option ng-repeat=\"item in vm.passTypes\" ng-value=\"item.id\">{{item.name}}</md-option></md-select>\n</md-input-container></div><md-input-container class=\"md-block mb-0\" flex-1><label>Desde</label><md-datepicker \nng-model=\"vm.from\" md-placeholder=\"Seleccione\" md-hide-icons=\"calendar\" md-current-view=\"month\" \nng-change=\"vm.getPasses()\"></md-datepicker></md-input-container><md-input-container class=\"md-block mb-0 mr-15\" flex-1>\n<label>Hasta</label><md-datepicker ng-model=\"vm.to\" md-placeholder=\"Seleccione\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\" ng-change=\"vm.getPasses()\"></md-datepicker></md-input-container><md-button \nclass=\"md-icon-button md-raised md-accent\" flex-1 ng-click=\"vm.add()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip>Agregar pase</md-tooltip></md-button><md-button class=\"md-icon-button md-raised md-warn\" flex-1 \nng-click=\"vm.remove()\" ng-disabled=\"!vm.selectedPass\"><md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>\nBorrar pase seleccionado</md-tooltip></md-button></div><div layout=\"row\" flex class=\"border\"><table \nclass=\"dataTable row-border\" flex><thead><tr><th class=\"w-50\">Pase</th><th class=\"w-80\">Fecha alta</th><th \nclass=\"w-80\">Inicia vigencia</th><th class=\"w-80\">Termina vigencia</th><th>Nombre</th><th>Socio</th><th class=\"w-40\">\n</th></tr></thead><tbody><tr ng-if=\"vm.passes.length == 0\"><td colspan=\"6\" class=\"empty-rows\">No hay pases registrados.\n</td></tr><tr \ncd-custom-grid=\"item in vm.passes | filter: { passTypeId : vm.filterPassTypeId, partnerId: vm.partner.id } | itemsPerPage: (4)\" \nng-click=\"vm.selectedPass = item\" class=\"selectable\" ng-class=\"{\'selected\': vm.selectedPass.id == item.id}\" \npagination-id=\"passesPaginator\"><td>{{item.pass.number}}</td><td class=\"text-align-center\">\n{{item.insertDate | date : \'dd/MM/yyyy\'}}</td><td class=\"text-align-center\">{{item.validFrom | date : \'dd/MM/yyyy\'}}\n</td><td class=\"text-align-center\">{{item.validTo | date : \'dd/MM/yyyy\'}}</td><td>{{item.name}}</td><td>\n{{item.partner.completeName}}</td><td><md-button class=\"md-icon-button show-gt-xs\" \nng-click=\"vm.showPrintable(item.id)\" aria-label=\"Mostrar Pase\" ng-if=\"item.isPrintable || item.isSendByEmail\"><md-icon \nmd-font-icon=\"icon-file-document\"></md-icon><md-tooltip>Mostrar pase</md-tooltip></md-button></td></tr></tbody><tr><td \ncolspan=\"6\"><dir-pagination-controls pagination-id=\"passesPaginator\"></dir-pagination-controls></td></tr></table></div>\n</div></div><div layout=\"row\" flex ng-if=\"vm.pass\" class=\"p-15 border m-15\"><form name=\"passForm\" layout=\"column\" flex>\n<input type=\"hidden\" name=\"dummyhdnProduct\" value=\"1\" required><div layout=\"row\" flex><md-input-container flex \nclass=\"md-block w-100\" flex><label>No. Pase</label><input type=\"number\" ng-model=\"vm.passNumber\" name=\"number\" \nrequired ng-model-options=\"{ debounce: 1000 }\" ng-change=\"vm.checkPassNumber()\"><div \nng-messages=\"passForm.number.$error\" role=\"alert\"><div ng-message=\"required\">Dato obligatorio</div></div>\n</md-input-container><div flex-1 layout=\"row\" layout-align=\"center start\" class=\"pl-10 pt-20\"><div \nclass=\"md-icon-button\"><md-icon ng-show=\"vm.checkPassNumberOk\" md-font-icon=\"icon-check\" class=\"green-fg\"></md-icon>\n</div><div class=\"md-icon-button\"><md-icon ng-show=\"!vm.checkPassNumberOk\" md-font-icon=\"icon-close\" class=\"red-fg\">\n</md-icon></div></div><md-input-container flex class=\"md-block w-120\" flex><label>Tipo de pase</label><input \ntype=\"text\" ng-model=\"vm.pass.pass.passType.name\" ng-disabled=\"true\"></md-input-container><md-input-container flex \nclass=\"md-block w-130\" flex><label>Vigente desde</label><md-datepicker ng-model=\"vm.validFrom\" \nng-change=\"vm.pass.validFrom = vm.validFrom\" name=\"validFrom\" required md-hide-icons=\"calendar\" \nmd-current-view=\"month\"><div ng-messages=\"passForm.validFrom.$error\" role=\"alert\"><div ng-message=\"required\">\nSeleccione fecha</div></div></md-datepicker></md-input-container><md-input-container flex class=\"md-block w-130\" flex>\n<label>Vigente desde</label><md-datepicker ng-model=\"vm.validTo\" ng-change=\"vm.pass.validTo = vm.validTo\" \nname=\"validTo\" required md-hide-icons=\"calendar\" md-current-view=\"month\"><div ng-messages=\"passForm.validTo.$error\" \nrole=\"alert\"><div ng-message=\"required\">Seleccione fecha</div></div></md-datepicker></md-input-container>\n<md-input-container flex class=\"md-block\" flex><label>Nombre</label><input type=\"text\" ng-model=\"vm.pass.name\" \nname=\"name\" required><div ng-messages=\"passForm.name.$error\" role=\"alert\"><div ng-message=\"required\">Dato obligatorio\n</div></div></md-input-container></div><div flex layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.pass && vm.pass.pass && vm.pass.pass.passType && vm.pass.pass.passType.isSendByEmail == true\"><div flex \nclass=\"mr-10\"><md-input-container flex class=\"md-block\" flex><label>Email</label><input type=\"email\" \nng-model=\"vm.pass.email\" name=\"email\"><div ng-messages=\"passForm.email.$error\" role=\"alert\"><div ng-message=\"email\">\nFormato de email incorrecto</div></div></md-input-container></div><div flex class=\"w-260 mr-10\"><md-checkbox \nng-model=\"vm.pass.isSendByEmail\">Enviar por correo electrónico?</md-checkbox></div><div flex class=\"w-100\"><md-checkbox\n ng-model=\"vm.pass.isPrintable\">Imprimir?</md-checkbox></div></div><div flex-1 layout=\"row\" \nlayout-align=\"start center\"><div flex-1 class=\"w-150\"><md-checkbox ng-model=\"vm.pass.generatePlannedProduct\">\nGenera cargo</md-checkbox></div><input type=\"hidden\" name=\"dummyhdn\" ng-model=\"vm.pass.productId\" \nng-required=\"vm.pass.generatePlannedProduct\" ng-show=\"vm.pass.generatePlannedProduct\"><md-autocomplete flex \nmd-selected-item=\"vm.plannedProduct\" \nmd-selected-item-change=\"vm.pass.productPrice = vm.plannedProduct.price; vm.pass.productId = vm.plannedProduct.productId;\" \nmd-search-text=\"vm.plannedSearchTextclient\" md-items=\"item in vm.inventory | filter: vm.plannedSearchTextclient\" \nmd-item-text=\"item.product.name\" md-min-length=\"0\" md-floating-label=\"Producto\" ng-if=\"vm.pass.generatePlannedProduct\">\n<md-item-template><span md-highlight-text=\"vm.plannedSearchTextclient\" md-highlight-flags=\"^i\">\n{{item.product.name}} ({{item.price | currency: \'$\': 2}})</span></md-item-template><md-not-found>No se hay resultados.\n</md-not-found></md-autocomplete><div flex-1 class=\"w-100 ml-15\" ng-if=\"vm.pass.generatePlannedProduct\"><span>\n{{vm.pass.productPrice | currency: \'$\': 2}}</span></div></div><div layout=\"row\" layout-align=\"end center\" flex-1>\n<md-button class=\"md-button md-raised md-accent\" type=\"submit\" flex-1 ng-click=\"vm.save()\" \nng-disabled=\"passForm.$invalid\">Guardar</md-button><md-button class=\"md-button md-raised md-warn\" flex-1 \nng-click=\"vm.cancel()\">Cancelar</md-button></div></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/orders/dialogs/dialog-cancel/dialog-cancel.html","<md-dialog id=\"orders-dialog-invoice\" class=\"\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall h-50\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.close()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div></md-toolbar><form \nname=\"detailForm\"><md-dialog-content class=\"no-padding\"><div class=\"page-layout carded fullwidth\" layout=\"column\"><div \nlayout=\"row\" class=\"p-0 pl-15 pr-15 pt-10 m-0\"><div layout=\"column\" flex=\"50\"><div layout=\"row\"><md-input-container \nflex><label>Motivo de cancelación</label><md-select ng-model=\"vm.catInvoiceCancellationReason\" \nname=\"catInvoiceCancellationReason\" required ng-disabled=\"vm.viewMode\"><md-option \nng-repeat=\"item in vm.catInvoiceCancellationReasons\" ng-value=\"item\">{{item.description}}</md-option></md-select><div \nng-messages=\"detailForm.catInvoiceCancellationReasonId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Motivo</span></div></div></md-input-container></div></div></div><div layout=\"row\" \nclass=\"p-0 pl-15 pr-15 m-0\"><md-input-container class=\"md-block\" flex \nng-if=\"vm.catInvoiceCancellationReason.code == \'01\'\"><label>Folio fiscal</label><input type=\"text\" \nng-model=\"vm.paymentConditions\" name=\"paymentConditions\" ng-disabled=\"vm.viewMode\" required><div \nng-messages=\"detailForm.paymentConditions.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIngrese el folio fiscal de la nueva factura</span></div></div></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.accept()\" \nclass=\"send-button md-accent md-raised w-150\" ng-disabled=\"!detailForm.$valid\" aria-label=\"ACEPTAR\"><span \nng-hide=\"vm.sending\">GENERAR </span><span ng-show=\"vm.sending\">GENERANDO...</span></md-button><md-button \nng-click=\"vm.close()\" aria-label=\"Cancelar\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/orders/dialogs/dialog-invoice/dialog-invoice.html","<md-dialog id=\"orders-dialog-invoice\" class=\"\" aria-label=\"Dialog\"><md-toolbar class=\"md-accent md-tall h-50\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" aria-label=\"Cerrar\" ng-click=\"vm.close()\">\n<md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Cerrar</md-tooltip></md-button></div></md-toolbar><form \nname=\"detailForm\"><md-dialog-content class=\"no-padding\"><div class=\"page-layout carded fullwidth\" layout=\"column\"><div \nlayout=\"row\" class=\"p-0 pl-15 pr-15 pt-10 m-0\"><div layout=\"column\" flex=\"50\"><h2>Datos de emisor<hr></h2><div \nlayout=\"row\"><md-input-container flex-1><label>RFC</label><input type=\"text\" ng-model=\"vm.invoice.rfc\" required \ndisabled=\"disabled\"></md-input-container><md-input-container flex><label>Razon Social</label><input type=\"text\" \nng-model=\"vm.invoice.razonSocial\" required disabled=\"disabled\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label>Regimen fiscal</label><input type=\"text\" ng-model=\"vm.invoice.satRegimenFiscal.name\" \ndisabled=\"disabled\"></md-input-container></div></div><div layout=\"column\" flex=\"50\"><h2>Datos de receptor<hr></h2><div \nlayout=\"row\"><md-input-container flex-1><label>RFC</label><input type=\"text\" ng-model=\"vm.invoice.targetRfc\" required \nng-disabled=\"vm.viewMode\"></md-input-container><md-input-container flex><label>Razon Social</label><input type=\"text\" \nng-model=\"vm.invoice.targetRazonSocial\" required ng-disabled=\"vm.viewMode\"></md-input-container></div><div \nlayout=\"row\"><md-input-container flex><label>Regimen Fiscal</label><md-select \nng-model=\"vm.invoice.targetSatRegimenFiscalCode\" name=\"satRegimenFiscalId\" \nng-change=\"vm.usesCFDI(vm.invoice.targetSatRegimenFiscalCode)\" required><md-option \nng-repeat=\"item in vm.satRegimenFiscales\" ng-value=\"item.code\">{{item.name}}</md-option></md-select><div \nng-messages=\"settingsForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container flex><label><span \nng-show=\"vm.validatingTargetZipCode\">... </span><span \nng-show=\"!vm.validatingTargetZipCode && vm.invoice.targetSatZipcodeId\"><md-icon md-font-icon=\"icon-check\" \nclass=\"green-fg\"></md-icon></span><span ng-show=\"!vm.validatingTargetZipCode && !vm.invoice.targetSatZipcodeId\">\n<md-icon md-font-icon=\"icon-close\" class=\"red-fg\"></md-icon><md-tooltip>Codigo Postal Inválido</md-tooltip></span>\nCodigo Postal</label><input ng-model=\"vm.targetSatZipcode\" ng-change=\"vm.targetZipCodeChange()\" \nng-model-options=\"{ debounce: 500 }\" required ng-disabled=\"vm.viewMode\"></md-input-container></div><div layout=\"row\">\n<md-input-container flex><label>Uso de CFDI</label><md-select ng-model=\"vm.invoice.satCfdiUseId\" name=\"satCfdiUseId\" \nrequired ng-disabled=\"vm.viewMode\"><md-option ng-repeat=\"item in vm.satCfdiUses\" ng-value=\"item.id\">{{item.name}}\n</md-option></md-select><div ng-messages=\"detailForm.satCfdiUseId.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Seleccione Unidad del SAT.</span></div></div></md-input-container></div></div></div><h2 class=\"pl-15 pr-15\">\nDatos de Factura<hr></h2><div layout=\"row\" class=\"p-0 pl-15 pr-15 m-0\"><md-input-container class=\"md-block\" flex>\n<label>Tipo de factura</label><md-select ng-model=\"vm.invoice.satInvoiceTypeId\" name=\"satInvoiceTypeId\" required \nng-disabled=\"vm.viewMode\"><md-option ng-repeat=\"item in vm.satInvoiceTypes\" ng-value=\"item.id\">\n[{{item.code}}] {{item.description}}</md-option></md-select><div ng-messages=\"detailForm.satInvoiceTypeId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Seleccione Unidad del SAT.</span></div></div></md-input-container>\n<md-input-container><label>Fecha de Expedicion</label><input type=\"text\" ng-model=\"vm.invoice.expeditionDate\" required \ndisabled=\"disabled\"></md-input-container><md-input-container><label><span ng-show=\"vm.validatingZipCode\">... </span>\n<span ng-show=\"!vm.validatingZipCode && vm.invoice.satZipcode\"><md-icon md-font-icon=\"icon-check\" class=\"green-fg\">\n</md-icon></span><span ng-show=\"!vm.validatingZipCode && !vm.invoice.satZipcode\"><md-icon md-font-icon=\"icon-close\" \nclass=\"red-fg\"></md-icon><md-tooltip>Codigo Postal Inválido</md-tooltip></span>Codigo Postal</label><input \nng-model=\"vm.zipCode\" ng-change=\"vm.zipCodeChange()\" ng-model-options=\"{ debounce: 500 }\" required \nng-disabled=\"vm.viewMode\"></md-input-container></div><div layout=\"row\" class=\"p-0 pl-15 pr-15 m-0\"><md-input-container \nclass=\"md-block\" flex><label>Moneda</label><md-select ng-model=\"vm.invoice.satCoinId\" name=\"satCoinId\" required \nng-disabled=\"vm.viewMode\"><md-option ng-repeat=\"item in vm.satCoins\" ng-value=\"item.id\">\n[{{item.code}}] {{item.description}}</md-option></md-select><div ng-messages=\"detailForm.satCoinId.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Seleccione Modena del SAT.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Pago</label><md-select ng-model=\"vm.invoice.satPaymentId\" \nname=\"satPaymentId\" required ng-disabled=\"vm.viewMode\"><md-option ng-repeat=\"item in vm.satPayments\" \nng-value=\"item.id\">[{{item.code}}] {{item.description}}</md-option></md-select><div \nng-messages=\"detailForm.satPaymentId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Pago del SAT.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Metodo de Pago</label>\n<md-select ng-model=\"vm.invoice.satPaymentMethodId\" name=\"satPaymentMethodId\" required ng-disabled=\"vm.viewMode\">\n<md-option ng-repeat=\"item in vm.satPaymentMethods\" ng-value=\"item.id\">[{{item.code}}] {{item.description}}</md-option>\n</md-select><div ng-messages=\"detailForm.satPaymentMethodId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Metodo de Pago del SAT.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Condiciones de Pago</label><input type=\"text\" ng-model=\"vm.invoice.paymentConditions\" name=\"paymentConditions\" \nng-disabled=\"vm.viewMode\"><div ng-messages=\"detailForm.paymentConditions.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese descripción de pago.</span></div></div></md-input-container></div><h2 \nclass=\"pl-15 pr-15\">Conceptos<hr></h2><div layout=\"row\"><table id=\"details\" class=\"dataTable row-border hover\"><thead>\n<tr><th>Descripción</th><th class=\"w-80 text-align-center\">Unidad</th><th class=\"w-45 text-align-center\">Cantidad</th>\n<th class=\"w-100 text-align-right\">P. Unitario</th><th class=\"w-100 text-align-right\">Importe</th><th \nclass=\"w-70 text-align-right\">Descuento</th><th class=\"w-100 text-align-right\">Subtotal</th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.invoice.details | itemsPerPage: (4)\"><td class=\"description\">\n({{item.satProduct.code}}) {{item.satProduct.description}}<br><span>{{item.description}}</span></td><td \nclass=\"text-align-center\">{{item.satUnit.code}}-{{item.satUnit.description}}</td><td class=\"text-align-center\">\n{{item.quantity}}</td><td class=\"text-align-right\">{{item.unityValue | currency: \'$\': 2}}</td><td \nclass=\"text-align-right\">{{item.amount | currency: \'$\': 2}}</td><td class=\"text-align-right\">\n{{item.discount | currency: \'$\': 2}}</td><td class=\"text-align-right\">\n{{item.amount - item.discount | currency: \'$\': 2}}</td></tr></tbody><tr><td colspan=\"6\"><dir-pagination-controls>\n</dir-pagination-controls></td></tr></table></div><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"p-10\"><span>{{vm.invoice.xml}}</span></div><md-card id=\"totals\" class=\"md-card md-side-nav-right\">\n<md-card-content class=\"no-padding\"><table class=\"dataTable row-border\"><tbody><tr><td><strong>Subtotal</strong></td>\n<td><div>{{ vm.invoice.subtotal | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Descuento</strong></td><td><div>\n{{ vm.invoice.discount | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Impuestos</strong></td><td><div>\n+ {{ vm.invoice.transferedTaxesTotal | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Total</strong></td><td><div>\n{{ vm.invoice.total | currency : \'$\' : 2}}</div></td></tr></tbody></table></md-card-content></md-card></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\" ng-hide=\"vm.invoice.id != 0\"><md-button \ntype=\"submit\" ng-click=\"vm.accept()\" class=\"send-button md-accent md-raised w-150\" \nng-disabled=\"detailForm.$invalid || !vm.invoice.satZipcode || vm.sending\" aria-label=\"ACEPTAR\"><span \nng-hide=\"vm.sending\">GENERAR </span><span ng-show=\"vm.sending\">GENERANDO...</span></md-button><md-button \nng-click=\"vm.close()\" aria-label=\"Cancelar\">Cancelar</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/invoices/views/orders/orders/dialogs/dialog-order/dialog-order.html","<md-dialog id=\"dialog-order\" class=\"catalogs-dialog-detail\" aria-label=\"dialog-order\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">ORDEN DE VENTA</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll class=\"no-padding\"><div layout=\"row\" class=\"p-10\" layout-align=\"space-between center\"><h2>\nSocio: <strong>({{vm.order.partnerId}}) {{vm.order.partner.completeName}}</strong></h2><h4>\nFecha de creación: {{vm.order.insertDate | date : \'dd/MM/yyyy HH:mm\'}}</h4></div><div layout=\"row\"><table \nclass=\"dataTable\"><thead><tr><th>Descripción</th><th>Socio</th><th>Periodo</th><th class=\"text-align-center\">P.Unitario\n</th><th class=\"text-align-center w-30\">Cantidad</th><th class=\"text-align-center\">Subtotal</th><th \nclass=\"text-align-center\">Descuento</th><th class=\"text-align-center\">Interes</th><th class=\"text-align-center\">Total\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.order.details\" class=\"selectable\"><td>{{item.description}}</td><td>\n{{item.partner.completeName}}</td><td>{{item.endPeriodDate | date: \'dd/MM/yyyy\'}}</td><td \nclass=\"text-align-right pr-15\">{{item.price | currency: \'$ \': 2}}</td><td class=\"text-align-center\">{{item.quantity}}\n</td><td class=\"text-align-right pr-15\">{{item.subtotal | currency: \'$ \': 2}}</td><td class=\"text-align-right pr-15\">\n{{item.discountAmmount | currency: \'$ \': 2}}</td><td class=\"text-align-right pr-15\">\n{{item.interest | currency: \'$ \': 2}}</td><td class=\"text-align-right pr-15\">{{item.total | currency: \'$ \': 2}}</td>\n</tr></tbody></table></div><div layout=\"row\" layout-align=\"end center\" class=\"m-10\"><div layout=\"column\" class=\"w-200\">\n<table class=\"dataTable row-border border\"><tbody><tr><td><strong>Subtotal</strong></td><td class=\"text-align-right\">\n<div>{{ vm.order.subtotal | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Intereses</strong></td><td \nclass=\"text-align-right\"><div>{{ vm.order.interests | currency : \'$\' : 2}}</div></td></tr><tr><td><strong>Descuento\n</strong></td><td class=\"text-align-right\"><div>{{ vm.order.discountAmmount | currency : \'$\' : 2}}</div></td></tr><tr>\n<td><strong>Total</strong></td><td class=\"text-align-right\"><div>{{ vm.order.total | currency : \'$\' : 2}}</div></td>\n</tr></tbody></table></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/dialogs/dialog-acciones/dialog-acciones.html","<md-dialog id=\"partner-dialog-acciones\" class=\"catalogs-dialog-detail\" aria-label=\"partner-dialog-club-access\"><form \nname=\"accessForm\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nBuscar Accion</span><md-input-container class=\"md-block h-50 pb-5 mb-0\"><label>Buscar...</label><input type=\"text\" \nng-model=\"vm.keyword\"></md-input-container><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nlayout=\"column\" class=\"no-padding\"><div layout=\"row\" flex><table class=\"dataTable row-border\"><thead><tr><th \nclass=\"w-60\">Acción</th><th>Dueño de la acción</th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.acciones | filter: vm.keyword | itemsPerPage: (6)\" pagination-id=\"accionesPaginator\" \nclass=\"selectable\" ng-class=\"{\'selected\': item.id == vm.selectedAccion.id }\" ng-click=\"vm.selectedAccion = item\" \nng-dblclick=\"vm.accept()\"><td>{{item.number}}-{{item.serie}}</td><td>{{item.accionista.completeName}}</td></tr></tbody>\n<tr><td colspan=\"2\"><dir-pagination-controls pagination-id=\"accionesPaginator\"></dir-pagination-controls></td></tr>\n</table></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\">\n<md-button type=\"submit\" ng-click=\"vm.accept()\" class=\"send-button md-accent md-raised\" aria-label=\"save\">Aceptar\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/dialogs/dialog-dues/dialog-dues.html","<md-dialog id=\"partner-dialog-dues\" class=\"catalogs-dialog-detail\"><form name=\"formDues\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Cuotas : {{vm.partner.completeName}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\"></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"!formDues.$valid\" \nng-show=\"vm.automaticPayment.isEnabled\" aria-label=\"GUARDAR\">GUARDAR</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/dialogs/dialog-automaticPayment/dialog-automaticPayment.html","<md-dialog id=\"dialog-automatic-payment\" class=\"catalogs-dialog-detail\"><form name=\"formAutomaticPayment\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Cargo Automático : {{vm.partner.completeName}}</span><md-button\n class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex><md-button class=\"md-raised md-accent\" \nng-if=\"!vm.automaticPayment.isEnabled\" ng-click=\"vm.enable()\">Habilitar Cargo Automático</md-button><md-button \nclass=\"md-raised md-warn\" ng-if=\"vm.automaticPayment.isEnabled\" ng-click=\"vm.disable()\">Deshabilitar Cargo Automático\n</md-button><md-button class=\"md-raised md-green-bg white-fg\" ng-if=\"vm.partner.isFamily\" \nng-click=\"vm.getDataFromTitular()\">Obtener datos de titular</md-button></div><div \nng-if=\"vm.automaticPayment.isEnabled\"><div class=\"md-block h-70\" layout=\"row\"><md-input-container class=\"md-block\" \nflex><label>Monto CA</label><input type=\"number\" min=\"0\" name=\"ammount\" ng-model=\"vm.automaticPayment.ammount\" \nrequired md-autofocus><div ng-messages=\"formAutomaticPayment.ammount.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\">Campo obligatorio.</div><div ng-message=\"min\">Cantidad incorrecta.</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-1><label>Valido hasta</label><md-datepicker \nng-init=\"vm.expirationDate = (vm.automaticPayment.expirationDate | toDate)\" \nng-change=\"vm.automaticPayment.expirationDate = vm.expirationDate\" ng-model=\"vm.expirationDate\" name=\"expirationDate\" \nrequired md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker><div \nng-messages=\"formAutomaticPayment.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\">Campo obligatorio.\n</div></div></md-input-container></div><md-input-container class=\"md-block\" flex><label>RFC</label><input type=\"text\" \nname=\"fatherLastname\" ng-model=\"vm.automaticPayment.rfc\" required><div \nng-messages=\"formAutomaticPayment.fatherLastname.$error\" role=\"alert\"><div ng-message=\"required\">Campo obligatorio.\n</div></div></md-input-container><md-input-container class=\"md-block mb-0\" flex><label>Nombre que aparece en la tarjeta\n</label><input type=\"text\" name=\"fatherLastname\" ng-model=\"vm.automaticPayment.cardName\" required><div \nng-messages=\"formAutomaticPayment.fatherLastname.$error\" role=\"alert\"><div ng-message=\"required\">Campo obligatorio.\n</div></div></md-input-container><div class=\"md-block h-70 mb-20\" layout=\"row\"><md-input-container class=\"md-block\" \nflex><label>Forma de pago</label><md-select type=\"text\" name=\"paymentMethod\" \nng-model=\"vm.automaticPayment.paymentMethodId\" required><md-option \nng-repeat=\"item in vm.paymentMethods | filter: { active: true, isAutomaticPayment : true }\" ng-value=\"item.id\">\n{{item.name}}</md-option></md-select><div ng-messages=\"formAutomaticPayment.paymentMethod.$error\" role=\"alert\"><div \nng-message=\"required\">Campo obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Banco</label><md-select type=\"text\" name=\"paymentMethodOptions\" \nng-model=\"vm.automaticPayment.paymentMethodOptionId\" ng-disabled=\"!vm.automaticPayment.paymentMethodId\" required>\n<md-option \nng-repeat=\"item in vm.paymentMethodOptions | filter: { active: true, paymentMethodId: vm.automaticPayment.paymentMethodId, isAutomaticPayment : true }\" \nng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"formAutomaticPayment.paymentMethod.$error\" \nrole=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div></div></md-input-container></div><div \nclass=\"md-block h-70\" layout=\"row\"><md-input-container class=\"md-block\" flex><label>Numero de tarjeta</label><input \ntype=\"password\" name=\"cardNumber\" ng-model=\"vm.automaticPayment.cardNumber\" required><div \nng-messages=\"formAutomaticPayment.cardNumber.$error\" role=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Confirmación No de tarjeta</label><input \ntype=\"password\" name=\"cardNumberConfirm\" ng-model=\"vm.automaticPayment.cardNumberConfirm\" \ncompare-to=\"vm.automaticPayment.cardNumber\" required><div ng-messages=\"formAutomaticPayment.cardNumber.$error\" \nrole=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div><div ng-message=\"compareTo\"><span>\nEl número de tarjeta no coincide</span></div></div></md-input-container><md-input-container class=\"md-block w-100\" \nflex-1><label>Vencimiento</label><input type=\"text\" name=\"cardExpiration\" \nng-model=\"vm.automaticPayment.cardExpiration\" ui-mask=\"99/99\" required></md-input-container><md-input-container \nclass=\"md-block w-140\" flex><label>No Contrato</label><input type=\"text\" name=\"contractNumber\" \nng-model=\"vm.automaticPayment.contractNumber\"></md-input-container></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"!formAutomaticPayment.$valid\" \nng-show=\"vm.automaticPayment.isEnabled\" aria-label=\"GUARDAR\">GUARDAR</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/dialogs/dialog-signature/dialog-signature.html","<md-dialog id=\"partner-dialog-signature\" class=\"catalogs-dialog-detail\" aria-label=\"partner-dialog-signature\">\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Firma</span><md-button class=\"md-icon-button\" \nng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content layout=\"column\" class=\"no-padding\"><input type=\"hidden\" id=\"hdn-base64sign\"><canvas id=\"cnv\" \nname=\"cnv\" width=\"700\" height=\"180\" class=\"sign-canvas\"></canvas></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"space-between center\"><md-button class=\"md-raised md-warn\" \nng-click=\"vm.onClear()\" aria-label=\"clear\">Limpiar</md-button><md-button type=\"submit\" ng-click=\"vm.onDone()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"save\">Aceptar</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/dialogs/dialog-clubAccess/dialog-clubAccess.html","<md-dialog id=\"partner-dialog-club-access\" class=\"catalogs-dialog-detail\" aria-label=\"partner-dialog-club-access\"><form\n name=\"accessForm\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nAccesos de: {{vm.partner.completeName}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" \naria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll layout=\"column\" class=\"no-padding\"><div layout=\"column\" flex><div ng-repeat=\"g in vm.groups\" flex><h2 \nclass=\"pl-20\">{{g.items[0].branch.name}}</h2><table class=\"dataTable row-border\"><tbody><tr \nng-repeat=\"access in g.items | filter: { active: true }\"><td><md-checkbox ng-model=\"access.selected\" \nng-change=\"vm.accessChecked(access)\">{{access.name}}</md-checkbox></td><td><ul class=\"time-zones\"><li \nng-repeat=\"timeZone in access.timeZones | filter: { active: true }\"><md-checkbox ng-model=\"timeZone.selected\" \nng-disabled=\"!access.selected\">{{timeZone.name}}</md-checkbox></li></ul></td></tr></tbody></table></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"!accessForm.$valid\" \naria-label=\"save\">GUARDAR</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/dialogs/dialog-signature-mouse/dialog-signature-mouse.html","<md-dialog id=\"partner-dialog-signature-mouse\" class=\"catalogs-dialog-detail\" \naria-label=\"partner-dialog-signature-mouse\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\nFirma</span><md-button class=\"md-icon-button\" ng-click=\"vm.close()\" aria-label=\"Cerrar\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content layout=\"column\" \nclass=\"no-padding\"><input type=\"hidden\" id=\"hdn-base64sign\"><signature-pad signature=\"vm.signature\"></signature-pad>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between center\">\n<md-button class=\"md-raised md-warn\" ng-click=\"vm.onClear()\" aria-label=\"clear\">Limpiar</md-button><md-button \ntype=\"submit\" ng-click=\"vm.onDone()\" class=\"send-button md-accent md-raised\" aria-label=\"save\">Aceptar</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-absences/tab-absences.html","<div class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><strong class=\"pl-15\">{{vm.absences.length}} ausencia(s)</strong><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.detail($event)\">Agregar ausencia</md-button></div><table \nclass=\"dataTable row-border hover bordered\"><thead><tr><th class=\"secondary-text w-50\"><div class=\"table-header\"><span \nclass=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Inicia</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Termina</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">% Descuento</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Socio</span></div></th><th class=\"secondary-text w-120\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.absences\"><td>{{item.id}}\n</td><td>{{item.dateFrom | date: \'dd/MM/yyyy\'}}</td><td>{{item.dateTo | date : \'dd/MM/yyyy\' }}</td><td>\n{{item.discountPercentage}}</td><td>\n{{item.partner.name}} {{item.partner.fatherLastname}} {{item.partner.motherLastname}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.detail($event, item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"vm.remove(item)\" aria-label=\"Borrar\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-activities/tab-activities.html","<div class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><strong class=\"pl-15\">{{vm.partnerActivities.length}} Actividades(es)</strong>\n<md-button class=\"md-button md-raised md-accent\" ng-click=\"vm.detail($event)\">Agregar actividad</md-button></div><table\n class=\"dataTable row-border hover bordered\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Socio/Familiar</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Actividad</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Horario</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Ubicación</span></div></th><th class=\"secondary-text w-120\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.partnerActivities\"><td>\n{{item.partner.completeName}}</td><td>{{item.activityScheduleZone.activitySchedule.activity.name}}</td><td>\n{{item.activityScheduleZone.activitySchedule.name}}</td><td>{{item.activityScheduleZone.zone.name}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.detail($event, item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"vm.remove(item)\" aria-label=\"Borrar\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-becas/tab-becas.html","<div class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><strong class=\"pl-15\">{{vm.becas.length}} beca(s)</strong><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.detail($event)\">Agregar Beca</md-button></div><table \nclass=\"dataTable row-border hover bordered\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Socio</span></div></th><th class=\"secondary-text w-80\"><div class=\"table-header\"><span \nclass=\"column-title\">% Descuento</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Inicia</span></div></th><th class=\"secondary-text w-100\"><div class=\"table-header\"><span \nclass=\"column-title\">Termina</span></div></th><th class=\"secondary-text w-120\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.becas\"><td>\n{{item.partner.name}} {{item.partner.fatherLastname}} {{item.partner.motherLastname}}</td><td>\n{{item.beca.discountPercentage}} %</td><td>{{item.dateFrom | date: \'dd/MM/yyyy\'}}</td><td>\n{{item.dateTo | date : \'dd/MM/yyyy\' }}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.detail($event, item)\" aria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar\n</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"vm.remove(item)\" aria-label=\"Borrar\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table>\n</div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-address/tab-address.html","<div id=\"tabAddress\" class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div \nlayout-gt-sm=\"row\" layout-align=\"space-between center\"><strong class=\"pl-15\">{{vm.addresses.length}} direccion(es)\n</strong><md-button class=\"md-button md-raised md-accent\" ng-click=\"vm.detail($event)\">Agregar dirección</md-button>\n</div><table class=\"dataTable row-border hover bordered\"><thead><tr><th class=\"secondary-text w-50\"><div \nclass=\"table-header\"><span class=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Dirección</span></div></th><th class=\"secondary-text w-100\"><div \nclass=\"table-header\"><span class=\"column-title\">Tipo</span></div></th><th class=\"secondary-text w-70\"><div \nclass=\"table-header\"><span class=\"column-title\">Predet.</span></div></th><th class=\"secondary-text w-70\"><div \nclass=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th class=\"secondary-text w-120\"><div \nclass=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.addresses\"><td>{{item.id}}</td><td>{{item.street}}</td><td>{{item.addressType.name}}</td>\n<td><i ng-if=\"item.isDefault\" class=\"icon-star yellow-700-fg\"></i></td><td><i ng-if=\"item.active\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-if=\"!item.active\" class=\"icon-cancel red-500-fg\"></i></td>\n<td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.detail($event, item)\" aria-label=\"Editar direccion\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"vm.deleteAddress(item)\" aria-label=\"Borrar direccion\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr><tr><td colspan=\"6\">\n<dir-pagination-controls></dir-pagination-controls></td></tr></tbody></table></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-invoices/tab-invoices.html","<div class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\" layout=\"row\"><div \nlayout=\"column\" flex=\"50\" class=\"p-5\"><div layout-gt-sm=\"row\" layout-align=\"space-between center\" class=\"h-70\"><div \nflex class=\"ml-15\"><h4><strong>No de recibos: {{vm.orders.length}}</strong></h4></div><div flex class=\"w-300\" \nlayout=\"row\"><md-input-container class=\"md-block mb-0\" flex><label>Desde</label><md-datepicker \nng-init=\"vm.dummy.from = (vm.from | toDate)\" ng-change=\"vm.from = vm.dummy.from; vm.getInvoices();\" \nng-model=\"vm.dummy.from\" name=\"from\" md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block mb-0\" flex><label>Hasta</label><md-datepicker \nng-init=\"vm.dummy.to = (vm.to | toDate)\" ng-change=\"vm.to = vm.dummy.to; vm.getInvoices();\" ng-model=\"vm.dummy.to\" \nname=\"to\" md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker>\n</md-input-container></div></div><div layout-gt-sm=\"row\"><table class=\"dataTable row-border hover border\"><thead><tr>\n<th class=\"secondary-text w-50\"><div class=\"table-header\"><span class=\"column-title\">ID</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Fecha</span></div></th><th \nclass=\"secondary-text w-150\"><div class=\"table-header\"><span class=\"column-title\">Total</span></div></th><th \nclass=\"secondary-text w-110\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr cd-custom-grid=\"item in vm.orders | itemsPerPage: (5)\" ng-click=\"vm.select(item)\" \nng-class=\"{\'selected\': item.selected == true }\" class=\"selectable\" pagination-id=\"ordersPaginator\"><td><md-checkbox \nng-model=\"item.selected\" class=\"m-0\">{{item.id}}</md-checkbox></td><td>{{item.insertDate | date: \'dd/MM/yyyy HH:mm\'}}\n</td><td>{{item.total | currency: \'$ \' : 2}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.receipt(item.id)\" aria-label=\"Receipt\"><md-icon md-font-icon=\"icon-file-document\"></md-icon><md-tooltip>\nImprimir recibo</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.showOrderDetail($event, item.id)\" aria-label=\"showOrderDetail\"><md-icon md-font-icon=\"icon-comment\">\n</md-icon><md-tooltip>Mostrar</md-tooltip></md-button></td></tr><tr><td colspan=\"6\"><dir-pagination-controls \npagination-id=\"ordersPaginator\"></dir-pagination-controls></td></tr></tbody></table></div></div><div layout=\"column\" \nflex=\"50\" class=\"p-5\"><div layout-gt-sm=\"row\" layout-align=\"space-between center\" class=\"h-70\"><div flex class=\"ml-15\">\n<h4><strong>Seleccionados: {{vm.selected.length}}</strong></h4></div><div flex class=\"w-300\" layout=\"row\"><md-button \nclass=\"md-button md-raised md-accent\" ng-disabled=\"!vm.selected || vm.selected.length == 0\" \nng-click=\"vm.generateInvoice()\">Generar Factura</md-button></div></div><div layout-gt-sm=\"row\"><table \nclass=\"dataTable row-border hover border\"><thead><tr><th class=\"secondary-text w-50\"><div class=\"table-header\"><span \nclass=\"column-title\">ID</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Fecha</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">RFC</span></div></th><th class=\"secondary-text w-150\"><div class=\"table-header\"><span \nclass=\"column-title\">Total</span></div></th><th class=\"secondary-text w-70\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr \ncd-custom-grid=\"item in vm.invoices | itemsPerPage: (5)\" ng-click=\"vm.invoice = item\" \nng-class=\"{\'selected\' : vm.invoice.id == item.id }\" class=\"selectable\" pagination-id=\"invoicesPaginator\"><td>\n{{item.id}}</td><td>{{item.insertDate | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{item.rfc}}</td><td>\n{{item.total | currency: \'$ \' : 2}}</td><td><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.invoice(item.id)\" aria-label=\"Invoice\"><md-icon md-font-icon=\"icon-file-document\"></md-icon><md-tooltip>\nRe-Imprimir factura</md-tooltip></md-button></td></tr><tr><td colspan=\"5\"><dir-pagination-controls \npagination-id=\"invoicesPaginator\"></dir-pagination-controls></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-family/tab-family.html","<div class=\"tab-family no-padding transparent-bg\" layout=\"row\"><md-card class=\"familiar no-padding mr-10\" \nlayout=\"column\" flex=\"80\"><md-card-content class=\"no-padding\" ng-if=\"!vm.showDetail\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><strong class=\"pl-15\">{{vm.family.length}} familiar(es)</strong><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.detail($event)\" ng-disabled=\"vm.partnerDue.familiarMaxNumber == 0\">\nAgregar familiar</md-button></div><table class=\"dataTable row-border hover bordered\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Nombre</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Activo</span></div></th><th \nclass=\"secondary-text w-170\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.family\" ng-click=\"vm.familiarSelected = item\" \nng-class=\"{\'selected\' : vm.familiarSelected.id == item.id }\"><td>\n{{item.name}} {{item.fatherLastname}} {{item.motherLastname}}</td><td><i ng-if=\"item.active\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"></i> <i ng-if=\"!item.active\" class=\"icon-cancel red-500-fg\"></i></td>\n<td><md-button class=\"edit-button md-icon-button btnEditFamiliar\" ng-click=\"vm.detail($event, item, isLocked)\" \naria-label=\"Editar\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button\n class=\"edit-button md-icon-button\" ng-click=\"vm.showClubAccess($event, item)\" aria-label=\"access\"><md-icon \nmd-font-icon=\"icon-clock\"></md-icon><md-tooltip>Accesos y Horarios</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn btnDeleteFamiliar\" ng-click=\"vm.remove(item)\" aria-label=\"Borrar\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table>\n</md-card-content><form name=\"familyForm\" ng-if=\"vm.showDetail\"><md-card-content ms-scroll><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Tipo de familiar</label><md-select name=\"partnerType\" \nng-model=\"vm.familiar.partnerTypeId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.partnerTypes | filter: { isFamiliar: true, active: true }\">{{ item.name }}</md-option>\n</md-select><div ng-messages=\"detailForm.partnerType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Tipo de socio.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nNombre(s)</label><input type=\"text\" name=\"name\" ng-model=\"vm.familiar.name\" required md-autofocus \nng-disabled=\"isLocked && vm.familiar.id != 0\"><div ng-messages=\"familyForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese nombre(s).</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Paterno</label><input type=\"text\" name=\"fatherLastname\" \nng-model=\"vm.familiar.fatherLastname\" required ng-disabled=\"isLocked && vm.familiar.id != 0\"><div \nng-messages=\"familyForm.fatherLastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIngrese Apellido paterno(s).</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nApellido Materno</label><input type=\"text\" name=\"motherLastname\" ng-model=\"vm.familiar.motherLastname\" \nng-disabled=\"isLocked && vm.familiar.id != 0\"></md-input-container><div flex-1><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.showAutomaticPayment($event)\" ng-if=\"vm.familiar.id != 0\">\nCargo automatico</md-button></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>País\n</label><md-select name=\"country\" ng-model=\"vm.familiar.countryId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.countries | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"familyForm.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione País.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Sexo</label><md-select name=\"gender\" \nng-model=\"vm.familiar.genderId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.genders | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"familyForm.gender.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Sexo</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Profesión</label><md-select name=\"profession\" \nng-model=\"vm.familiar.professionId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.professions | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"familyForm.profession.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Profesión.</span>\n</div></div></md-input-container><md-input-container class=\"md-block w-140\" flex-1><label>Fecha nacimiento</label>\n<md-datepicker ng-init=\"vm.birthdate = (vm.familiar.birthdate | toDate)\" ng-change=\"vm.birthdateChange()\" \nng-model=\"vm.birthdate\" name=\"birthdate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"year\" md-min-date=\"vm.minBirthdate\" md-max-date=\"vm.maxBirthdate\"></md-datepicker><div \nng-messages=\"familyForm.birthdate.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Seleccione fecha\n</div><div ng-message=\"maxdate\">Fecha incorrecta</div></div></md-input-container><div flex-1 class=\"w-120 p-15 pt-25\">\n<span>({{vm.familiar.age}} años)</span></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Telefono</label><input type=\"text\" name=\"phone\" ng-model=\"vm.familiar.phone\" required><div \nng-messages=\"familyForm.phone.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese teléfono.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Telefono 2</label><input type=\"text\" \nname=\"phone2\" ng-model=\"vm.familiar.phone2\"></md-input-container><md-input-container class=\"md-block\" flex><label>Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vm.familiar.email\" required><div \nng-messages=\"familyForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Ingrese Email.</div>\n<div ng-message=\"email\"><span>Formato de Email incorrecto.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Código de credencial</label><input type=\"text\" name=\"credentialCode\" \nng-model=\"vm.familiar.credentialCode\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Cuotas</label><md-select name=\"due\" ng-disabled=\"vm.isLocked && vm.familiar.id != 0\" \nng-model=\"vm.familiar.dueId\" ng-change=\"vm.dueChange()\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.dues | filter: { active: true, isFamiliar: true }\">{{ item.name }}</md-option>\n</md-select><div ng-messages=\"familyForm.due.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccine cuota.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Periodicidad</label><input \ntype=\"text\" ng-model=\"vm.duePeriodicityText\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Convenios</label><md-select name=\"agreement\" \nng-disabled=\"vm.isLocked && vm.familiar.id != 0\" ng-model=\"vm.familiar.agreements\" multiple=\"multiple\"><md-option \nng-value=\"item\" ng-repeat=\"item in vm.catalogs.agreements | filter: { active: true }\">{{ item.name }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Tipo de facturacion</label><md-select\n name=\"agreement\" ng-model=\"vm.familiar.calculationModeId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.calculationModes | filter: { active: true }\">{{ item.name }}</md-option></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\" layout.align=\"start center\"><md-input-container class=\"md-block\" \nflex><label>Fecha de inscripción</label><md-datepicker ng-change=\"vm.familiar.inscriptionDate = vm.inscriptionDate\" \nng-model=\"vm.inscriptionDate\" name=\"inscriptionDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex><label>\nInicio de pago</label><md-datepicker ng-change=\"vm.familiar.initPayDate = vm.initPayDate\" ng-model=\"vm.initPayDate\" \nname=\"initPayDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block\" flex><label>MultiClub</label><md-select \nname=\"multiclub\" ng-model=\"vm.familiar.branches\" multiple=\"multiple\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.catalogs.branches | filter: { active: true }\">{{ item.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block mr-10\" flex-1><md-checkbox ng-model=\"vm.familiar.active\">\nActivo</md-checkbox></md-input-container><md-input-container class=\"md-block mr-10\" flex-1><md-checkbox \nng-model=\"vm.familiar.isBlocked\">Bloqueado</md-checkbox></md-input-container><md-input-container \nclass=\"md-block mr-10\" flex-1><md-checkbox ng-model=\"vm.familiar.isFingerAuthentication\">Autenticación por huella\n</md-checkbox></md-input-container></div></md-card-content><md-card-actions layout=\"row\" layout-gt-sm=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"!familyForm.$valid\" aria-label=\"GUARDAR\">GUARDAR</md-button><md-button \nclass=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">CANCELAR</md-button></md-card-actions>\n</form></md-card><md-card class=\"familiar-details no-padding mr-10\" flex=\"20\" \nng-if=\"vm.familiar.id != 0 || !vm.showDetail\"><md-card-content class=\"no-padding\"><div ng-if=\"vm.familiarSelected\"><div\n class=\"text-align-center\"><img \nng-if=\"vm.familiarSelected && vm.familiarSelected.picturePathName && vm.familiarSelected.picturePathName && vm.familiarSelected.picturePathName != \'\'\" \nclass=\"partner-image\" ng-src=\"{{vm.picturesUrl}}{{vm.familiarSelected.picturePathName}}\"> <img \nng-if=\"!vm.familiarSelected || !vm.familiarSelected.picturePathName || vm.familiarSelected.picturePathName == \'\'\" \nclass=\"partner-image\" src=\"assets/images/avatars/profile.jpg\"></div><div layou=\"row\" class=\"pr-20\"><div layout=\"row\">\n<md-input-container class=\"mb-0\" flex><label>Tipo de Socio:</label><input type=\"text\" \nng-model=\"vm.familiarSelected.partnerType.name\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"mb-0 w-40\" flex><label>ID:</label><input type=\"text\" ng-model=\"vm.familiarSelected.id\" disabled=\"disabled\">\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"mb-0\" flex><label>Cuota:</label><input \ntype=\"text\" ng-model=\"vm.familiarSelected.due.name\" disabled=\"disabled\"></md-input-container></div><div layout=\"row\">\n<md-input-container class=\"mb-0\" flex><label>Tipo de facturación:</label><input type=\"text\" \nng-model=\"vm.familiarSelected.calculationMode.name\" disabled=\"disabled\"></md-input-container></div></div></div>\n</md-card-content></md-card></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-levels/tab-levels.html","<div class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><strong class=\"pl-15\">{{vm.levels.length}} nivel(es)</strong><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.detail($event)\">Agregar avance</md-button></div><table \nclass=\"dataTable row-border hover bordered\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Socio/Familiar</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Actividad</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Instructor</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Nivel</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">No. Evaluación</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Calificación</span></div></th><th class=\"secondary-text w-120\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.levels\"><td>\n{{item.partner.name}} {{item.partner.fatherLastname}} {{item.partner.motherLastname}}</td><td>{{item.activity.name}}\n</td><td>{{item.employee.name}} {{item.employee.fatherLastname}} {{item.employee.motherLastname}}</td><td>\n{{item.level.name}}</td><td>{{item.evaluationYear}} - {{item.evaluation.name}}</td><td>{{item.levelScore.name}}</td>\n<td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.detail($event, item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"vm.remove(item)\" aria-label=\"Borrar\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-otherCharges/tab-otherCharges.html","<div id=\"tab-other-charges\" class=\"detail-form-container no-padding m-0\" layout=\"column\"><md-card layout=\"row\" \nclass=\"partner h-70\"><md-card-content layout=\"column\" flex><div layout=\"row\" flex><h2 flex-1 class=\"m-0 pt-5\">Socio:\n</h2><md-select ng-model=\"vm.partner\" flex class=\"m-0 ml-15\" ng-change=\"vm.partnerChange()\" \naria-label=\"partner-select\"><md-option ng-repeat=\"partner in vm.family\" ng-value=\"partner\">{{partner.completeName}}\n</md-option></md-select></div></md-card-content></md-card><div layout=\"row\" ms-scroll><md-card \nclass=\"planned-products no-padding mr-10\" layout=\"column\" flex=\"50\"><md-card-content class=\"no-padding\" \nlayout=\"column\"><md-toolbar layout=\"row\" class=\"border pl-15\" layout-align=\"space-between center\"><h2 flex-1>\nCargos Planificados</h2><div layout=\"row\" flex layout-align=\"end center\"><div class=\"search\" layout=\"row\" \nlayout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" class=\"white-text icon search-icon\"></md-icon>\n<input ng-model=\"vm.plannedKeyword\" class=\"search-input\" type=\"text\" placeholder=\"Buscar\" flex></div><md-button \nclass=\"md-button md-raised\" ng-click=\"vm.addPlanned()\" flex-1 ng-disabled=\"vm.plannedNew\">Agregar</md-button></div>\n</md-toolbar><div class=\"content\" layout=\"row\" flex><div layout=\"column\" flex><div layout=\"row\" class=\"detail\" \nng-if=\"vm.plannedNew\"><form name=\"plannedForm\" flex layout=\"column\"><div layout=\"row\"><input type=\"hidden\" \nname=\"dummyhdn\" ng-model=\"vm.plannedNew.productId\" required><md-autocomplete flex \nmd-selected-item=\"vm.plannedNew.inventory\" \nmd-selected-item-change=\"vm.plannedNew.price = vm.plannedNew.inventory.price; vm.plannedNew.productId = vm.plannedNew.inventory.productId;\" \nmd-search-text=\"vm.plannedSearchTextclient\" md-items=\"item in vm.inventory | filter: vm.plannedSearchTextclient\" \nmd-item-text=\"item.product.name\" md-min-length=\"0\" md-floating-label=\"Producto\"><md-item-template><span \nmd-highlight-text=\"vm.plannedSearchTextclient\" md-highlight-flags=\"^i\">\n{{item.product.name}} ({{item.price | currency: \'$\': 2}})</span></md-item-template><md-not-found>No se hay resultados.\n</md-not-found></md-autocomplete><md-input-container class=\"md-block w-100\" flex-1><label>Monto</label><input \ntype=\"number\" min=\"0\" name=\"plannedPrice\" ng-model=\"vm.plannedNew.price\" required></md-input-container>\n<md-input-container class=\"md-block\" flex-1><label>Vencimiento</label><md-datepicker \nng-init=\"vm.expirationDate = (vm.plannedNew.expirationDate | toDate)\" \nng-change=\"vm.plannedNew.expirationDate = vm.expirationDate\" ng-model=\"vm.expirationDate\" name=\"expirationDate\" \nrequired md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker><div \nng-messages=\"plannedForm.expirationDate.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nSeleccione fecha</div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-button md-raised md-accent\" ng-disabled=\"plannedForm.$invalid\" type=\"submit\" ng-click=\"vm.plannedAccept()\">\nAceptar</md-button><md-button class=\"md-button md-raised md-warn\" ng-click=\"vm.plannedNew = null\">Cancelar</md-button>\n</div></form></div><div layout=\"row\" ng-hide=\"vm.plannedNew\"><table class=\"dataTable row-border hover bordered mb-10\">\n<thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Producto</span></div></th>\n<th class=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Monto</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Vencimiento</span></div></th><th \nclass=\"secondary-text w-40\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr \ncd-custom-grid=\"item in vm.plannedProducts | filter: vm.plannedKeyword | filter: { isPayed: false } | orderBy: \'id\': true | itemsPerPage: (4)\" \npagination-id=\"plannedPaginator\"><td><span ng-show=\"!item.product.description\">{{item.product.name}}</span> <span \nng-show=\"item.product.description\">{{item.description}}</span></td><td class=\"text-align-right\">\n{{item.price | currency: \'$ \': 2}}</td><td>{{item.expirationDate | date: \'dd/MM/yyyy\'}}</td><td><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"vm.plannedRemove(item)\" aria-label=\"Borrar\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar cargo</md-tooltip></md-button></td></tr></tbody><tr><td \ncolspan=\"4\"><dir-pagination-controls pagination-id=\"plannedPaginator\"></dir-pagination-controls></td></tr></table>\n</div></div></div></md-card-content></md-card><md-card class=\"periodical-products no-padding ml-10\" layout=\"column\" \nflex=\"50\"><md-card-content class=\"no-padding\" layout=\"column\"><md-toolbar layout=\"row\" class=\"border pl-15\" \nlayout-align=\"space-between center\"><h2 flex-1>Cargos Periodicos</h2><div layout=\"row\" flex layout-align=\"end center\">\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input ng-model=\"vm.periodicalKeyword\" class=\"search-input\" type=\"text\" \nplaceholder=\"Buscar\" flex></div><md-button class=\"md-button md-raised\" ng-click=\"vm.addPeriodicity()\" flex-1 \nng-disabled=\"vm.periodicalProductNew\">Agregar</md-button></div></md-toolbar><div class=\"content\" layout=\"row\" flex><div\n layout=\"column\" flex><div layout=\"row\" class=\"detail\" ng-if=\"vm.periodicalProductNew\"><form name=\"periodicalForm\" \nflex layout=\"column\"><div layout=\"row\" class=\"pt-10\"><md-radio-group ng-model=\"vm.periodicalProductNew.isDue\" \nlayout=\"row\"><md-radio-button ng-value=\"{{true}}\" aria-label=\"periodicalDueOption\">Cuota</md-radio-button>\n<md-radio-button ng-value=\"{{false}}\" aria-label=\"periodicalProductOption\">Producto</md-radio-button></md-radio-group>\n</div><div layout=\"row\"><input type=\"hidden\" name=\"dummyhdnperiodicalDue\" ng-model=\"vm.periodicalProductNew.dueId\" \nng-required=\"vm.periodicalProductNew.isDue\"><md-autocomplete flex ng-if=\"vm.periodicalProductNew.isDue\" \nmd-selected-item=\"vm.periodicalProductNew.due\" \nmd-selected-item-change=\"vm.periodicalProductNew.dueId = vm.periodicalProductNew.due.id; vm.periodicalDueChange();\" \nmd-search-text=\"vm.periodicalProductNew.periodicalSearchTextDue\" \nmd-items=\"item in vm.dues | filter: vm.periodicalProductNew.periodicalSearchTextDue\" md-item-text=\"item.name\" \nmd-min-length=\"0\" md-floating-label=\"Cuota\"><md-item-template><span \nmd-highlight-text=\"vm.periodicalProductNew.periodicalSearchTextDue\" md-highlight-flags=\"^i\">{{item.name}}</span>\n</md-item-template><md-not-found>No se hay resultados.</md-not-found></md-autocomplete><input type=\"hidden\" \nname=\"dummyhdnperiodical\" ng-model=\"vm.periodicalProductNew.productId\" ng-required=\"!vm.periodicalProductNew.isDue\">\n<md-autocomplete flex ng-if=\"!vm.periodicalProductNew.isDue\" md-selected-item=\"vm.periodicalProductNew.inventory\" \nmd-selected-item-change=\"vm.periodicalProductNew.productId = vm.periodicalProductNew.inventory.productId;\" \nmd-search-text=\"vm.periodicalProductNew.periodicalSearchTextProduct\" \nmd-items=\"item in vm.inventory | filter: vm.periodicalProductNew.periodicalSearchTextProduct\" \nmd-item-text=\"item.product.name\" md-min-length=\"0\" md-floating-label=\"Producto\"><md-item-template><span \nmd-highlight-text=\"vm.periodicalProductNew.periodicalSearchTextProduct\" md-highlight-flags=\"^i\">\n{{item.product.name}} ({{item.price | currency: \'$\': 2}})</span></md-item-template><md-not-found>No se hay resultados.\n</md-not-found></md-autocomplete></div><div layout=\"row\"><md-input-container class=\"md-block\" flex \nng-if=\"vm.periodicalProductNew.isDue\"><label>Periodicidad</label><md-select \nng-model=\"vm.periodicalProductNew.periodicityId\" name=\"duePrice\" ng-disabled=\"!vm.periodicalProductNew.dueId\" required>\n<md-option ng-repeat=\"opt in vm.duePrices\" ng-value=\"opt.periodicityId\">\n{{ opt.periodicity.name }} ({{opt.price | currency : \'$ \' : 2}})</md-option></md-select><div \nng-messages=\"periodicalForm.duePrice.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nSeleccione periodicidad</div></div></md-input-container><md-input-container class=\"md-block\" flex \nng-if=\"!vm.periodicalProductNew.isDue\"><label>Periodicidad</label><md-select \nng-model=\"vm.periodicalProductNew.periodicityId\" name=\"periodicalPeriodicity\" \nng-disabled=\"vm.periodicalProductNew.isDue && !vm.periodicalProductNew.dueId\" required><md-option \nng-repeat=\"opt in vm.periodicities\" ng-value=\"opt.id\">{{ opt.name }}</md-option></md-select><div \nng-messages=\"periodicalForm.periodicalPeriodicity.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nSeleccione periodicidad</div></div></md-input-container><md-input-container class=\"md-block\" flex-1><label>\nInicio de pago</label><md-datepicker \nng-init=\"vm.periodicalInitPayDate = (vm.periodicalProductNew.initPayDate | toDate)\" \nng-change=\"vm.periodicalProductNew.initPayDate = vm.periodicalInitPayDate\" ng-model=\"vm.periodicalInitPayDate\" \nname=\"periodicalInitPayDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker><div ng-messages=\"periodicalForm.periodicalInitPayDate.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\">Seleccione fecha</div></div></md-input-container><md-input-container class=\"md-block\" flex-1 \nng-if=\"vm.periodicalProductNew.id != 0\"><label>Pagado hasta</label><md-datepicker \nng-init=\"vm.periodicalPayedDate = (vm.periodicalProductNew.payedDate | toDate)\" \nng-change=\"vm.periodicalProductNew.payedDate = vm.periodicalPayedDate\" ng-model=\"vm.periodicalPayedDate\" \nname=\"periodicalPayedDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker><div ng-messages=\"periodicalForm.periodicalPayedDate.$error\" role=\"alert\"><div ng-message=\"required\">\nSeleccione fecha</div></div></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-button md-raised md-accent\" ng-disabled=\"periodicalForm.$invalid\" type=\"submit\" \nng-click=\"vm.periodicalAccept()\">Aceptar</md-button><md-button class=\"md-button md-raised md-warn\" \nng-click=\"vm.periodicalProductNew = null\">Cancelar</md-button></div></form></div><div layout=\"row\" \nng-hide=\"vm.periodicalProductNew\"><table class=\"dataTable row-border hover bordered mb-10\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Producto / Cuota</span></div></th><th \nclass=\"secondary-text w-80\"><div class=\"table-header\"><span class=\"column-title\">Periodicidad</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Inicio</span></div></th><th \nclass=\"secondary-text w-70\"><div class=\"table-header\"><span class=\"column-title\">Pagado</span></div></th><th \nclass=\"secondary-text w-90\"><div class=\"table-header\"><span class=\"column-title\">Acciones</span></div></th></tr>\n</thead><tbody><tr \ncd-custom-grid=\"item in vm.periodicalProducts | filter: vm.periodicalKeyword | orderBy: \'id\': true  | itemsPerPage: (4)\" \npagination-id=\"periodicalPaginator\"><td><span ng-if=\"item.product\">Producto: {{item.product.name}}</span> <span \nng-if=\"item.due\">Cuota: {{item.due.name}}</span></td><td>{{item.periodicity.name}}</td><td>\n{{item.initPayDate | date: \'dd/MM/yyyy\'}}</td><td>{{item.payedDate | date: \'dd/MM/yyyy\'}}</td><td><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.periodicalEdit(item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"vm.periodicalRemove(item)\" aria-label=\"Borrar\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody><tr><td colspan=\"5\">\n<dir-pagination-controls pagination-id=\"periodicalPaginator\"></dir-pagination-controls></td></tr></table></div></div>\n</div></md-card-content></md-card></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-pagos/tab-pagos.html","<div id=\"tab-pictures\" class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div \nclass=\"tab-pagos page-layout blank\" layout=\"row\" ms-scroll><div class=\"tab-pagos-container\"><div class=\"card content\">\n<div ng-repeat=\"g in vm.group\"><h3 class=\"tab-pagos-group-1\">{{g.key}} - {{g.items[0].dueName}}</h3><div \nng-repeat=\"otg in g.orderTypeGroups\" class=\"ml-20\"><h3 class=\"tab-pagos-group-2\">Tipo de documento: {{otg.key}}</h3>\n<div ng-repeat=\"folio in otg.InvoiceGroup\" class=\"ml-20\"><h3 class=\"tab-pagos-group-3\">Folio: {{folio.key}}</h3><table \nclass=\"simple tab-pagos-table font-small\"><thead><tr><th class=\"text-center\">Fecha</th><th class=\"text-center\">Folio\n</th><th class=\"text-center\">Concepto</th><th class=\"text-center\">Formas Pago</th><th class=\"text-center\">Importe</th>\n</tr></thead><tbody><tr ng-repeat=\"item in folio.items\" ng-class=\"{\'canceled\': item.isCanceled }\"><td \nclass=\"text-center\">{{item.expeditionDate | date: \'dd/MM/yyyy\'}}</td><td class=\"text-center\">{{item.folio}}</td><td \nclass=\"text-center\">{{item.description}}</td><td class=\"text-center\">{{item.payments}}</td><td class=\"text-center\">\n{{item.total | currency: \'$\': 2}}</td></tr></tbody></table></div><div layout=\"row\" layout-align=\"space-between start\" \nclass=\"tab-pagos-subtotals p-10\"><span>Total</span><div><span>{{otg.InvoiceGroup.totalFolios}}</span></div></div></div>\n<div layout=\"row\" layout-align=\"space-between start\" class=\"tab-pagos-subtotals p-10\"><span>Total</span><div><span>\n{{g.totalFolios}}</span></div></div></div><hr><div layout=\"row\" layout-align=\"center start\" \nclass=\"tab-pagos-summary p-20\"><table class=\"simple tab-pagos-table\" flex=\"50\"><thead><tr><th>Tipo</th><th \nclass=\"text-center\">Número</th><th class=\"text-center\">Total</th></tr></thead><tbody><tr \nng-repeat=\"item in vm.summary\"><td>{{item.orderType}}</td><td class=\"text-center\">{{item.count}}</td><td \nclass=\"text-right\">{{item.total | currency: \'$\': 2}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-rentables/tab-rentables.html","<div class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><strong class=\"pl-15\">{{vm.rentables.length}} rentable(s)</strong><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.detail($event)\">Asignar Rentable</md-button></div><table \nclass=\"dataTable row-border hover bordered\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Socio/Familiar</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Rentable</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Periodicidad</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tipo de Facturación</span></div></th><th class=\"secondary-text w-160\"><div class=\"table-header\">\n<span class=\"column-title\">Periodo</span></div></th><th class=\"secondary-text w-60\"><div class=\"table-header\"><span \nclass=\"column-title\">Descuento</span></div></th><th class=\"secondary-text w-110\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.rentables\"><td>\n{{item.partner.name}} {{item.partner.fatherLastname}} {{item.partner.motherLastname}}</td><td>\n{{item.rentable.rentableZone.name}} - {{item.rentable.name}}</td><td>{{item.periodicity.name}}</td><td>\n{{item.calculationMode.name}}</td><td>{{item.dateFrom | date: \'dd/MM/yyyy\'}} - {{item.dateTo | date: \'dd/MM/yyyy\'}}\n</td><td class=\"text-align-center\"><span ng-show=\"item.discountPercentage == 0\">- </span><span \nng-hide=\"item.discountPercentage == 0\">{{item.discountPercentage}} %</span></td><td><md-button class=\"md-icon-button\" \nng-click=\"vm.show($event, item)\" aria-label=\"Show\"><md-icon md-font-icon=\"icon-eye\"></md-icon><md-tooltip>Mostrar\n</md-tooltip></md-button><md-button class=\"md-icon-button md-warn\" ng-click=\"vm.remove(item)\" aria-label=\"Borrar\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table>\n</div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-pictures/tab-pictures.html","<div id=\"tab-pictures\" class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div \nlayout-gt-sm=\"row\"><div layout-gt-sm=\"column\" flex=\"50\" class=\"p-10\"><table class=\"dataTable row-border hover border\" \nid=\"table-family\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">FAMILIARES\n</span></div></th><th class=\"secondary-text w-50\"><div class=\"table-header\"><span class=\"column-title\"></span></div>\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.family\" ng-click=\"vm.partner = item\" class=\"selectable\" \nng-class=\"{\'selected\' : item.id == vm.partner.id }\"><td>{{item.name}} {{item.fatherLastname}} {{item.motherLastname}}\n</td><td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.parner = item\" aria-label=\"Mostrar\"><md-icon \nmd-font-icon=\"icon-picture\"></md-icon><md-tooltip>Mostrar</md-tooltip></md-button></td></tr></tbody></table></div><div \nlayout-gt-sm=\"column\" flex=\"50\" class=\"p-10\" ng-show=\"vm.partner\"><div class=\"content\"><h2>\nFotografia de: {{vm.partner.completeName}}</h2><div layout=\"row\" layout-align=\"start center\"><input type=\"file\" \nid=\"inputFile\" flex><md-button class=\"md-button md-raised md-accent\" ng-click=\"vm.save()\" flex-1>Subir</md-button>\n</div><div layout=\"row\" layout-align=\"center start\"><img \nng-if=\"vm.partner.picturePathName && vm.partner.picturePathName != \'\'\" class=\"partner-image\" \nng-src=\"{{vm.picturesUrl}}{{vm.partner.picturePathName}}\"> <img \nng-if=\"!vm.partner.picturePathName || vm.partner.picturePathName == \'\'\" class=\"partner-image\" \nsrc=\"assets/images/avatars/profile.jpg\"></div></div></div></div></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-tags/tab-tags.html","<div class=\"detail-form-container md-background-bg md-whiteframe-1dp no-padding border\"><div layout-gt-sm=\"row\" \nlayout-align=\"space-between center\"><strong class=\"pl-15\">{{vm.tags.length}} Tags(s)</strong><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.detail($event)\">Agregar Tag</md-button></div><table \nclass=\"dataTable row-border hover bordered\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Tag</span></div></th><th class=\"secondary-text w-120\"><div class=\"table-header\"><span \nclass=\"column-title\">Acciones</span></div></th></tr></thead><tbody><tr ng-repeat=\"item in vm.tags\"><td>{{item.tag}}\n</td><td><md-button class=\"edit-button md-icon-button\" ng-click=\"vm.detail($event, item)\" aria-label=\"Editar\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Editar</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"vm.remove(item)\" aria-label=\"Borrar\"><md-icon md-font-icon=\"icon-trash\">\n</md-icon><md-tooltip>Borrar</md-tooltip></md-button></td></tr></tbody></table></div>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-absences/dialogs/dialog-absence.html","<md-dialog id=\"dialog-absence\" class=\"catalogs-dialog-detail\"><form name=\"absenceForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Socio</label>\n<md-select name=\"partner\" ng-model=\"vm.absence.partnerId\" required md-autofocus><md-option \nng-repeat=\"p in vm.partners\" ng-value=\"p.id\">{{p.name}} {{p.fatherLastname}} {{p.motherLastname}}</md-option>\n</md-select><div ng-messages=\"absenceForm.partner.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione socio</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block w-140\" flex-1><label>Fecha de inicio</label><md-datepicker \nng-init=\"vm.dateFrom = (vm.absence.dateFrom | toDate)\" ng-change=\"vm.absence.dateFrom = vm.dateFrom\" \nng-model=\"vm.dateFrom\" name=\"dateFrom\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\" md-min-date=\"vm.minBirthdate\" md-max-date=\"vm.maxBirthdate\"></md-datepicker><div \nng-messages=\"absenceForm.dateFrom.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Seleccione fecha\n</div><div ng-message=\"maxdate\">Fecha incorrecta</div></div></md-input-container><md-input-container \nclass=\"md-block w-140\" flex-1><label>Fecha fin</label><md-datepicker \nng-init=\"vm.dateTo = (vm.absence.dateTo | toDate)\" ng-change=\"vm.absence.dateTo = vm.dateTo\" ng-model=\"vm.dateTo\" \nname=\"dateTo\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker>\n<div ng-messages=\"absenceForm.dateTo.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">\nSeleccione fecha</div><div ng-message=\"maxdate\">Fecha incorrecta</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Porcentaje de descuento</label><input type=\"number\" min=\"0\" max=\"100\" \nname=\"discountPercentage\" ng-model=\"vm.absence.discountPercentage\"><div \nng-messages=\"absenceForm.discountPercentage.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"min\">\nValor incorrecto</div><div ng-message=\"max\">Valor incorrecto</div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"!absenceForm.$valid\" aria-label=\"GUARDAR\">\nGUARDAR</md-button><md-button class=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">CANCELAR\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-becas/dialogs/dialog-beca.html","<md-dialog id=\"dialog-beca\" class=\"catalogs-dialog-detail\"><form name=\"becaForm\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Cerrar\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Socio</label><md-select name=\"partner\" \nng-model=\"vm.beca.partnerId\" required md-autofocus><md-option ng-repeat=\"p in vm.partners\" ng-value=\"p.id\">\n{{p.name}} {{p.fatherLastname}} {{p.motherLastname}}</md-option></md-select><div ng-messages=\"becaForm.partner.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Seleccione socio</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Becas</label><md-select name=\"beca\" \nng-model=\"vm.beca.becaId\" required><md-option ng-repeat=\"b in vm.becas | filter: {active: true}\" ng-value=\"b.id\">\n{{b.name}} - {{b.discountPercentage}} %</md-option></md-select><div ng-messages=\"becaForm.beca.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>Seleccione beca</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block w-140\" flex-1><label>Fecha de inicio</label><md-datepicker \nng-init=\"vm.dateFrom = (vm.beca.dateFrom | toDate)\" ng-change=\"vm.beca.dateFrom = vm.dateFrom\" ng-model=\"vm.dateFrom\" \nname=\"dateFrom\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\" \nmd-min-date=\"vm.minBirthdate\" md-max-date=\"vm.maxBirthdate\"></md-datepicker><div \nng-messages=\"becaForm.dateFrom.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Seleccione fecha\n</div><div ng-message=\"maxdate\">Fecha incorrecta</div></div></md-input-container><md-input-container \nclass=\"md-block w-140\" flex-1><label>Fecha fin</label><md-datepicker ng-init=\"vm.dateTo = (vm.beca.dateTo | toDate)\" \nng-change=\"vm.beca.dateTo = vm.dateTo\" ng-model=\"vm.dateTo\" name=\"dateTo\" required md-placeholder=\"Ingrese fecha\" \nmd-hide-icons=\"calendar\" md-current-view=\"month\"></md-datepicker><div ng-messages=\"becaForm.dateTo.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Seleccione fecha</div><div ng-message=\"maxdate\">\nFecha incorrecta</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-gt-sm=\"row\" layout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"!becaForm.$valid\" aria-label=\"GUARDAR\">GUARDAR</md-button>\n<md-button class=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">CANCELAR</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-family/dialogs/dialog-family.html","<md-dialog id=\"dialog-family\" class=\"catalogs-dialog-detail\"><form name=\"familyForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Tipo de familiar\n</label><md-select name=\"partnerType\" ng-model=\"vm.familiar.partnerTypeId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.partnerTypes | filter: { isFamiliar: true, active: true }\">{{ item.name }}</md-option>\n</md-select><div ng-messages=\"detailForm.partnerType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Tipo de socio.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nNombre(s)</label><input type=\"text\" name=\"name\" ng-model=\"vm.familiar.name\" required md-autofocus \nclass=\"ctrlEditFamiliarData\"><div ng-messages=\"familyForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nIngrese nombre(s).</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nApellido Paterno</label><input type=\"text\" name=\"fatherLastname\" ng-model=\"vm.familiar.fatherLastname\" required \nclass=\"ctrlEditFamiliarData\"><div ng-messages=\"familyForm.fatherLastname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Ingrese Apellido paterno(s).</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Apellido Materno</label><input type=\"text\" name=\"motherLastname\" \nng-model=\"vm.familiar.motherLastname\" class=\"ctrlEditFamiliarData\"></md-input-container><div flex-1><md-button \nclass=\"md-button md-raised md-accent\" ng-click=\"vm.showAutomaticPayment($event)\" ng-if=\"vm.familiar.id != 0\">\nCargo automatico</md-button></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>País\n</label><md-select name=\"country\" ng-model=\"vm.familiar.countryId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.countries | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"familyForm.country.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione País.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Sexo</label><md-select name=\"gender\" \nng-model=\"vm.familiar.genderId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.genders | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"familyForm.gender.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Sexo</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Profesión</label><md-select name=\"profession\" \nng-model=\"vm.familiar.professionId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.professions | filter: { active: true }\">{{ item.name }}</md-option></md-select><div \nng-messages=\"familyForm.profession.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Profesión.</span>\n</div></div></md-input-container><md-input-container class=\"md-block w-140\" flex-1><label>Fecha nacimiento</label>\n<md-datepicker ng-init=\"vm.birthdate = (vm.familiar.birthdate | toDate)\" ng-change=\"vm.birthdateChange()\" \nng-model=\"vm.birthdate\" name=\"birthdate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"year\" md-min-date=\"vm.minBirthdate\" md-max-date=\"vm.maxBirthdate\"></md-datepicker><div \nng-messages=\"familyForm.birthdate.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Seleccione fecha\n</div><div ng-message=\"maxdate\">Fecha incorrecta</div></div></md-input-container><div flex-1 class=\"w-120 p-15 pt-25\">\n<span>({{vm.familiar.age}} años)</span></div></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex>\n<label>Telefono</label><input type=\"text\" name=\"phone\" ng-model=\"vm.familiar.phone\" required><div \nng-messages=\"familyForm.phone.$error\" role=\"alert\"><div ng-message=\"required\"><span>Ingrese teléfono.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Telefono 2</label><input type=\"text\" \nname=\"phone2\" ng-model=\"vm.familiar.phone2\"></md-input-container><md-input-container class=\"md-block\" flex><label>Email\n</label><input type=\"email\" name=\"email\" ng-model=\"vm.familiar.email\" required><div \nng-messages=\"familyForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\">Ingrese Email.</div>\n<div ng-message=\"email\"><span>Formato de Email incorrecto.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Código de credencial</label><input type=\"text\" name=\"credentialCode\" \nng-model=\"vm.familiar.credentialCode\"></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Cuotas</label><md-select name=\"due\" ng-disabled=\"vm.isLocked && vm.familiar.id != 0\" \nng-model=\"vm.familiar.dueId\" ng-change=\"vm.dueChange()\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.dues | filter: { active: true, isFamiliar: true }\">{{ item.name }}</md-option>\n</md-select><div ng-messages=\"familyForm.due.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccine cuota.\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>Periodicidad</label><input \ntype=\"text\" ng-model=\"vm.duePeriodicityText\" ng-disabled=\"true\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Convenios</label><md-select name=\"agreement\" \nng-disabled=\"vm.isLocked && vm.familiar.id != 0\" ng-model=\"vm.familiar.agreements\" multiple=\"multiple\"><md-option \nng-value=\"item\" ng-repeat=\"item in vm.catalogs.agreements | filter: { active: true }\">{{ item.name }}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex><label>Tipo de facturacion</label><md-select\n name=\"agreement\" ng-model=\"vm.familiar.calculationModeId\" required><md-option ng-value=\"item.id\" \nng-repeat=\"item in vm.catalogs.calculationModes | filter: { active: true }\">{{ item.name }}</md-option></md-select>\n</md-input-container></div><div layout-gt-sm=\"row\" layout.align=\"start center\"><md-input-container class=\"md-block\" \nflex><label>Fecha de inscripción</label><md-datepicker ng-change=\"vm.familiar.inscriptionDate = vm.inscriptionDate\" \nng-model=\"vm.inscriptionDate\" name=\"inscriptionDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex><label>\nInicio de pago</label><md-datepicker ng-change=\"vm.familiar.initPayDate = vm.initPayDate\" ng-model=\"vm.initPayDate\" \nname=\"initPayDate\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" md-current-view=\"month\">\n</md-datepicker></md-input-container><md-input-container class=\"md-block\" flex><label>MultiClub</label><md-select \nname=\"multiclub\" ng-model=\"vm.familiar.branches\" multiple=\"multiple\"><md-option ng-value=\"item\" \nng-repeat=\"item in vm.catalogs.branches | filter: { active: true }\">{{ item.name }}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block mr-10\" flex-1><md-checkbox ng-model=\"vm.familiar.active\">\nActivo</md-checkbox></md-input-container><md-input-container class=\"md-block mr-10\" flex-1><md-checkbox \nng-model=\"vm.familiar.isBlocked\">Bloqueado</md-checkbox></md-input-container><md-input-container \nclass=\"md-block mr-10\" flex-1><md-checkbox ng-model=\"vm.familiar.isFingerAuthentication\">Autenticación por huella\n</md-checkbox></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"!familyForm.$valid\" aria-label=\"GUARDAR\">GUARDAR</md-button><md-button \nclass=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">CANCELAR</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-activities/dialogs/dialog-activity.html","<md-dialog id=\"dialog-level\" class=\"catalogs-dialog-detail\"><form name=\"activityForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Socio</label>\n<md-select name=\"partner\" ng-model=\"vm.partnerActivity.partnerId\" required md-autofocus><md-option \nng-repeat=\"p in vm.partners\" ng-value=\"p.id\">{{p.name}} {{p.fatherLastname}} {{p.motherLastname}}</md-option>\n</md-select><div ng-messages=\"activityForm.partner.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione socio</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Actividad</label><md-select name=\"activity\" ng-model=\"vm.activity\" required \nng-change=\"vm.activityChange()\"><md-option ng-repeat=\"item in vm.activities\" ng-value=\"item\">{{item.name}}</md-option>\n</md-select><div ng-messages=\"activityForm.activity.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione Actividad</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" layout-align=\"start center\">\n<md-input-container class=\"md-block\" flex><label>Horario</label><md-select name=\"schedule\" ng-model=\"vm.schedule\" \nrequired ng-disabled=\"!vm.activity\" ng-change=\"vm.scheduleChange()\"><md-option ng-repeat=\"item in vm.schedules\" \nng-value=\"item\">{{item.name}}</md-option></md-select><div ng-messages=\"activityForm.schedule.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Seleccione horario</span></div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Ubicación</label><md-select name=\"zone\" \nng-model=\"vm.partnerActivity.activityScheduleZoneId\" required ng-disabled=\"!vm.schedule\" ng-change=\"vm.zoneChange()\">\n<md-option ng-repeat=\"item in vm.activityZones\" ng-value=\"item.id\">{{item.zone.name}} ({{item.quota}})</md-option>\n</md-select><div ng-messages=\"activityForm.zone.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione ubicación</span></div></div></md-input-container><div flex-1 class=\"mt-20\"><input type=\"hidden\" \nng-model=\"vm.quotaOk\" ng-required=\"!vm.quotaOk\"> <span ng-show=\"vm.validatingQuota\"><md-icon \nmd-font-icon=\"icon-dots-horizontal\" class=\"accept-fg\"></md-icon></span><span \nng-show=\"!vm.validatingQuota && vm.quotaOk\"><md-icon md-font-icon=\"icon-check\" class=\"green-fg\"></md-icon></span><span \nng-show=\"!vm.validatingQuota && !vm.quotaOk\"><md-icon md-font-icon=\"icon-close\" class=\"red-fg\"></md-icon><md-tooltip>\nNO HAY CUPO!!!</md-tooltip></span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" \nlayout-align=\"end center\"><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"!activityForm.$valid || !vm.quotaOk\" aria-label=\"GUARDAR\">GUARDAR</md-button><md-button \nclass=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">CANCELAR</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-levels/dialogs/dialog-level.html","<md-dialog id=\"dialog-level\" class=\"catalogs-dialog-detail\"><form name=\"levelForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Socio</label>\n<md-select name=\"partner\" ng-model=\"vm.level.partnerId\" required md-autofocus><md-option \nng-repeat=\"p in vm.partners | filter: { active: true }\" ng-value=\"p.id\">\n{{p.name}} {{p.fatherLastname}} {{p.motherLastname}}</md-option></md-select><div \nng-messages=\"levelForm.partner.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione socio</span></div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Actividad\n</label><md-select name=\"activity\" ng-model=\"vm.level.activityId\" required><md-option \nng-repeat=\"item in vm.activities | filter: { active: true }\" ng-value=\"item.id\">{{item.name}}</md-option></md-select>\n<div ng-messages=\"levelForm.activity.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione actividad</span>\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>\nInstructor</label><md-select name=\"employee\" ng-model=\"vm.level.employeeId\" required><md-option \nng-repeat=\"item in vm.employees\" ng-value=\"item.id\">{{item.name}} {{item.fatherLastname}} {{item.motherLastname}}\n</md-option></md-select><div ng-messages=\"levelForm.employee.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSeleccione empleado</span></div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Clases del periodo</label><input type=\"number\" min=\"1\" name=\"classNumber\" \nng-model=\"vm.level.periodClassNumber\" required><div ng-messages=\"levelForm.classNumber.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Dato obligatorio.</span></div><div ng-message=\"min\"><span>\nEl minimo es 1.</span></div></div></md-input-container><md-input-container class=\"md-block\" flex><label>\nClases asistidas</label><input type=\"number\" min=\"0\" name=\"classAttendance\" ng-model=\"vm.level.classAttendance\" \nrequired><div ng-messages=\"levelForm.classAttendance.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Dato obligatorio.</span></div><div ng-message=\"min\"><span>Valor incorrecto.</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Nivel de avance</label><md-select \nname=\"level\" ng-model=\"vm.level.levelId\" required><md-option ng-repeat=\"item in vm.levels | filter: { active: true }\" \nng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"levelForm.level.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Seleccione nivel.</span></div></div></md-input-container></div>\n<div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Año de Evaluación</label><md-select \nname=\"evaluationYear\" ng-model=\"vm.level.evaluationYear\" required><md-option ng-repeat=\"item in vm.years\" \nng-value=\"item.year\">{{item.year}}</md-option></md-select><div ng-messages=\"levelForm.evaluationYear.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Obligatiorio.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>No. Evaluación</label><md-select name=\"evaluationNumber\" \nng-model=\"vm.level.evaluationId\" required><md-option ng-repeat=\"item in vm.evaluations | filter :{ active: true }\" \nng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"levelForm.evaluationNumber.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>Obligatiorio.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex><label>Calificación</label><md-select name=\"score\" \nng-model=\"vm.level.levelScoreId\" required><md-option ng-repeat=\"item in vm.levelScores | filter:  { active: true }\" \nng-value=\"item.id\">{{item.name}}</md-option></md-select><div ng-messages=\"levelForm.score.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Seleccione calificación.</span></div></div></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"!levelForm.$valid\" \naria-label=\"GUARDAR\">GUARDAR</md-button><md-button class=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" \naria-label=\"Cancelar\">CANCELAR</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-address/dialogs/dialog-address.html","<md-dialog id=\"dialog-address\" class=\"catalogs-dialog-detail\"><form name=\"addressForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Calle</label>\n<input type=\"text\" name=\"street\" ng-model=\"vm.address.street\" required><div ng-messages=\"addressForm.street.$error\" \nrole=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"20\"><label>Número</label><input type=\"text\" name=\"number\" ng-model=\"vm.address.number\" required>\n<div ng-messages=\"addressForm.number.$error\" role=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"20\"><label>Interior</label><input type=\"text\" \nname=\"interiorNumber\" ng-model=\"vm.address.interiorNumber\"></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container class=\"md-block\" flex><label>Estado</label><input type=\"text\" name=\"state\" \nng-model=\"vm.address.state\" required><div ng-messages=\"addressForm.state.$error\" role=\"alert\"><div \nng-message=\"required\">Campo obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\" flex>\n<label>Ciudad</label><input type=\"text\" name=\"city\" ng-model=\"vm.address.city\" required><div \nng-messages=\"addressForm.city.$error\" role=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Municipio</label>\n<input type=\"text\" name=\"municipio\" ng-model=\"vm.address.municipio\" required><div \nng-messages=\"addressForm.municipio.$error\" role=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex><label>Colonia</label><input type=\"text\" name=\"colony\" \nng-model=\"vm.address.colony\"></md-input-container><md-input-container class=\"md-block\" flex><label>C.P.</label><input \ntype=\"text\" name=\"zipcode\" ng-model=\"vm.address.zipCode\" required><div ng-messages=\"addressForm.zipcode.$error\" \nrole=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>Teléfono 1</label><input type=\"text\" name=\"phone1\" \nng-model=\"vm.address.phone\"></md-input-container><md-input-container class=\"md-block\" flex><label>Teléfono 2</label>\n<input type=\"text\" name=\"phone2\" ng-model=\"vm.address.phone2\"></md-input-container><md-input-container \nclass=\"md-block\" flex><label>Fax</label><input type=\"text\" name=\"fax\" ng-model=\"vm.address.fax\"></md-input-container>\n</div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex><label>RFC</label><input type=\"text\" \nname=\"rfc\" ng-model=\"vm.address.rfc\"></md-input-container><md-input-container class=\"md-block\" flex><label>\nRazon Social o persona física</label><input type=\"text\" name=\"name\" ng-model=\"vm.address.razonSocial\">\n</md-input-container></div><div layout-gt-sm=\"row\" layout=\"row\"><md-input-container class=\"md-block\" flex><label>\nRegimen Fiscal</label><md-select ng-model=\"vm.address.satRegimenFiscalId\" name=\"satRegimenFiscalId\" required><md-option\n ng-repeat=\"item in vm.satRegimenFiscales\" ng-value=\"item.id\">{{item.name}}</md-option></md-select><div \nng-messages=\"settingsForm.satTaxId.$error\" role=\"alert\"><div ng-message=\"required\"><span>Seleccione Impuesto del SAT.\n</span></div></div></md-input-container></div><div layout-gt-sm=\"row\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex><label>Tipo de dirección</label><md-select name=\"addressType\" \nng-model=\"vm.address.addressTypeId\" required><md-option ng-repeat=\"item in vm.addressTypes\" ng-value=\"item.id\">\n{{item.name}}</md-option></md-select><div ng-messages=\"addressForm.addressType.$error\" role=\"alert\"><div \nng-message=\"required\">Campo obligatorio.</div></div></md-input-container><md-input-container class=\"md-block\" flex-1>\n<md-checkbox ng-model=\"vm.address.isDefault\">Predeterminada</md-checkbox></md-input-container><md-input-container \nclass=\"md-block\" flex-1><md-checkbox ng-model=\"vm.address.active\">Activo</md-checkbox></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><md-button \ntype=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"!addressForm.$valid\" \naria-label=\"GUARDAR\">GUARDAR</md-button><md-button class=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" \naria-label=\"Cancelar\">CANCELAR</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-tags/dialogs/dialog-tag.html","<md-dialog id=\"dialog-beca\" class=\"catalogs-dialog-detail\"><form name=\"tagForm\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Cerrar\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block\" flex=\"100\"><label>TAG</label><input type=\"text\" name=\"tag\" ng-model=\"vm.tag.tag\" \nrequired><div ng-messages=\"tagForm.tag.$error\" role=\"alert\"><div ng-message=\"required\">Campo obligatorio.</div></div>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"!tagForm.$valid\" \naria-label=\"GUARDAR\">GUARDAR</md-button><md-button class=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" \naria-label=\"Cancelar\">CANCELAR</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-rentables/dialogs/dialog-showRentable/dialog-showRentable.html","<md-dialog id=\"dialog-show-rentable\" class=\"catalogs-dialog-detail\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Mostrar casillero</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" \naria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout-gt-sm=\"row\"><div layout-gt-sm=\"column\" flex><cd-rentable-selection ng-model=\"vm.dummy\" \nzone-id=\"vm.zoneId\"></cd-rentable-selection></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/partners/views/partners/partner/tabs/tab-rentables/dialogs/dialog-rentable/dialog-rentable.html","<md-dialog id=\"dialog-rentable\" class=\"catalogs-dialog-detail\"><form name=\"rentableForm\"><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">\nSELECCIONAR CASILLERO: {{vm.partner.name}} {{vm.partner.fatherLastname}} {{vm.partner.motherLastname}}</span><md-button\n class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Cerrar\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout-gt-sm=\"row\"><form name=\"rentableForm\"><div \nlayout-gt-sm=\"column\" flex=\"25\"><md-input-container class=\"md-block\"><label>Socio</label><md-select \nng-model=\"vm.partner\" required ng-change=\"vm.rentable.partnerId = vm.partner.id\"><md-option \nng-repeat=\"item in vm.family\" ng-value=\"item\">{{item.name}} {{item.fatherLastname}} {{item.motherLastname}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>Periodicidad de pago</label><md-select \nng-model=\"vm.rentable.periodicityId\" required><md-option ng-repeat=\"item in vm.periodicities\" ng-value=\"item.id\">\n{{item.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nTipo de facturación</label><md-select ng-model=\"vm.rentable.calculationModeId\" required><md-option \nng-repeat=\"item in vm.calculationModes\" ng-value=\"item.id\">{{item.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>Desde</label><md-datepicker \nng-init=\"vm.dateFrom = (vm.rentable.dateFrom | toDate)\" ng-change=\"vm.rentable.dateFrom = vm.dateFrom\" \nng-model=\"vm.dateFrom\" name=\"dateFrom\" required md-placeholder=\"Ingrese fecha\" md-hide-icons=\"calendar\" \nmd-current-view=\"month\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.applyDiscount\"><label>% de Descuento</label><input type=\"number\" min=\"0\" max=\"100\" \nng-model=\"vm.rentable.discountPercentage\" required name=\"discountPercentage\"><div \nng-messages=\"rentableForm.discountPercentage.$error\" role=\"alert\"><div ng-message=\"min\">Valor de descuento incorrecto\n</div><div ng-message=\"max\">Valor de descuento incorrecto</div></div></md-input-container><div layout=\"row\" \nlayout-gt-sm=\"row\"><md-button id=\"btnAplicarDescuento\" class=\"md-button md-raised md-accent w-200 md-warn\" \nng-if=\"!vm.applyDiscount\" ng-click=\"vm.applyDiscount = true\">Aplicar descuento</md-button><md-button \nclass=\"md-button md-raised md-warn w-200\" ng-if=\"vm.applyDiscount\" \nng-click=\"vm.rentable.discontPercentage = null; vm.applyDiscount = false;\">Cancelar descuento</md-button></div></div>\n<div layout-gt-sm=\"column\" flex=\"75\"><cd-rentable-selection ng-model=\"vm.rentable.rentableId\"></cd-rentable-selection>\n</div></form></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-gt-sm=\"row\" layout-align=\"end center\">\n<md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"!rentableForm.$valid\" aria-label=\"GUARDAR\">GUARDAR</md-button><md-button \nclass=\"md-button md-raised md-warn\" ng-click=\"vm.cancel()\" aria-label=\"Cancelar\">CANCELAR</md-button>\n</md-dialog-actions></form></md-dialog>");}]);